const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Фон Тсукуеми",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Не удалось опубликовать из-за избыточных ресурсов сцены. Пожалуйста, удалите некоторые ресурсы и попробуйте снова",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "В настоящее время нет разрешения на доступ к функциям, связанным с членством",
  T_12_I_GIFT_SENDER_BELL: "Колокольчик",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Сейчас ты его видишь, а теперь нет. [FFB300](Скрывает Шлем)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Маска Старика",
  T_12_L_COS_PINKMAN: "Розовая Дино",
  T_12_L_COS_POLAR: "Северный Мишка",
  T_12_L_COS_RENDER: "Радужный Динозавр",
  T_12_L_COS_TIGER: "Дино-тигр",
  T_12_L_MALE_BOTTOM_COS_ELF: "Зимний Эльф (Низ)",
  T_12_L_MALE_COS_SANTA: "Сердитый Старик",
  T_12_L_MALE_HAIR_COS_ELF: "Зимний Эльф (Голова)",
  T_12_L_MALE_SHOE_COS_ELF: "Зимний Эльф (Обувь)",
  T_12_L_MALE_TOP_COS_ELF: "Зимний Эльф (Верх)",
  T_12_O_CAT_NAME: "Котёнок",
  T_12_O_M1014_CHRISTMAS_NAME: "Северный M1014",
  T_12_O_MACHETE_GOLD_NAME: "Золотое Лезвие",
  T_12_O_PET_TITLE: "ПИТОМЕЦ",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Прыжковые Ботинки",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Обувь созданная с применением современных технологий. Позволяет совершать двойной прыжок.",
  T_12_Q_ITEM_FLYSHOE: "Реактивные Ботинки",
  T_12_Q_ITEM_FLYSHOE_DESC: "Ботинки, которые позволяют летать. Постарайтесь не израсходовать все топливо в воздухе.",
  T_12_Q_ITEM_STOCK1: "Приклад Ур 1",
  T_12_Q_ITEM_STOCK2: "Приклад Ур 2",
  T_12_Q_ITEM_STOCK3: "Приклад Ур 3",
  T_12_Q_ITEM_TREATMENTGUN: "Леч. Пистолет",
  T_12_Q_ITEM_VEST4: "Бронежилет Ур.4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Антонио",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Вуконг",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Танцуй!",
  T_12_R_EMOTE_WAVE_NAME: "Волна",
  T_12_R_SKILL_NAME_GANGLEADER: "Дух Гангстера",
  T_12_R_SKILL_NAME_MONKEYGOD: "Иллюзия",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Амфибия",
  T_13_I_COLLECTION_V_JEEP: "Джип",
  T_13_I_COLLECTION_V_MONSTER: "Монстр Трак",
  T_13_I_COLLECTION_V_MOTOBIKE: "Байк",
  T_13_I_COLLECTION_V_ROADSTER: "Спорткар",
  T_13_I_COLLECTION_V_SUV: "Пикап",
  T_13_I_COLLECTION_V_TUTU: "Тук Тук",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Арктически-Синий (Маска)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Вездесущая Любовь (Низ)",
  T_13_L_MALE_HAIR_COS_BJD: "Арктически-Синий (Голова)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Вездесущая Любовь (Верх)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Оружие",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Скин Питомца: Котёнок Детектив",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Купидон",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Моко",
  T_13_R_EMOTE_BABYSHARK_NAME: "Маленькая Акула",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Отжиматься",
  T_13_R_EMOTE_EGYPT_NAME: "Танец Мумии",
  T_13_R_PVE_WEAPON_SLOT: "Слот оружия",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Эффективная Дальность",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Скорострельность",
  T_13_R_SKILL_DESC_HACKERGIRL: "Помечает противников на [FFB300]{0}сек[-], товарищи по команде также могут видеть отметку",
  T_13_R_SKILL_NAME_HACKERGIRL: "Глаз Хакера",
  T_13_Z_KICKOFF_BAN: "БАН",
  T_13_Z_ROOM_MORNING: "День",
  T_13_Z_ROOM_NIGHT: "Ночь",
  T_14_G_ITEM_KATANA: "Катана",
  T_14_I_HEADPIC_SONGKRAN_NAME: "БРЫЗГ!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Кролик в кубе",
  T_14_L_COS_EASTER: "Наблюдатель 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Леди Огня (Обувь)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Кролик-Воин (Маска)",
  T_14_O_AK_WATERSPLASHING_NAME: "Водяной AK47",
  T_14_O_DOG_NAME: "Механический Щенок",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Скин Питомца: Стальной Щенок",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Скин Питомца: Электрический Щенок",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Скин Питомца: Магнетический Щенок",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Скин Питомца: Ночной Котёнок",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Кровавая Луна",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Нападение Акул",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Хаято",
  T_14_R_SKILL_DESC_SAMURAI: "Каждые [FFB300]{0}%[-] потери ХП увеличивают пробитие брони на [FFB300]{1}%[-].",
  T_14_R_SKILL_NAME_SAMURAI: "Бусидо",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Голодовка (Маска)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Ядовитое Касание (Маска)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Голодовка (Низ)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Ядовитое Касание (Низ)",
  T_15_L_MALE_SHOE_COS_FAIM: "Голодовка (Обувь)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Ядовитое Касание (Обувь)",
  T_15_L_MALE_TOP_COS_FAIM: "Голодовка (Верх)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Ядовитое Касание (Верх)",
  T_15_L_TOP_COS_MOTHERSDAY: "Лучшая Мама",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Катаклизм",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Викинг",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Катаклизм",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Катаклизм",
  T_15_O_PANTHER_NAME: "Ночная Пантера",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Скин Питомца: Капитан",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Скин Питомца: Золотой Леопард",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Скин Питомца: Лиловая Угроза",
  T_15_O_SKS_DEATH_NAME: "СКС - Завещание",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Катаклизм",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "МИНИГАН",
  T_15_R_CHARACTER_AGENT_NAME: "Лаура",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Повторяй За Мной",
  T_15_R_SKILL_DESC_AGENT: "Точность во время прицеливания увеличена на [FFB300]{0}%[-]",
  T_15_R_SKILL_NAME_AGENT: "Меткий Стрелок",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Пурпурные Крылья",
  T_16_B_ITEM_GRAPPLINGHOOK: "Крюк-Кошка",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Крюковая Пушка",
  T_16_L_MALE_COS_LEGO: "Безумный Человечек",
  T_16_L_MALE_SHOE_COS_SUMMER: "Летние Каникулы (Обувь)",
  T_16_P_MANUAL_MONSTER: "Монстр Трак",
  T_16_P_MANUAL_MUSHROOM1: "Гриб Ур.1",
  T_16_P_MANUAL_MUSHROOM2: "Гриб Ур.2",
  T_16_P_MANUAL_MUSHROOM3: "Гриб Ур.3",
  T_16_P_MANUAL_MUSHROOM4: "Гриб Ур.4",
  T_16_P_MANUAL_ROADSTER_DESC: "Стильный спорткар. Мало ХП, но высокая скорость. Вмещает 2 игроков.",
  T_16_P_MANUAL_STROP: "Канатка",
  T_16_P_MANUAL_SUV: "Пикап",
  T_16_P_MANUAL_SUV_DESC: "Транспорт-визитная карточка Free Fire. Средний запас ХП, но максимальная скорость. Вмещает 2 игроков.",
  T_16_P_MANUAL_TUTU_DESC: "Мало ХП и медленная скорость. Вмещает 3 игроков.",
  T_16_P_MANUAL_WEAPON_AR: "Автомат",
  T_16_P_MANUAL_WEAPON_BOMB: "Метательное",
  T_16_P_MANUAL_WEAPON_PISTOL: "Пистолет",
  T_16_P_MANUAL_WEAPON_SG: "Дробовик",
  T_16_P_MANUAL_WEAPON_SMG: "Пистолет- Пулемёт",
  T_16_P_MANUAL_WEAPON_SR: "Снайперская Винтовка",
  T_16_Q_MINISENTRY: "Мини Турель",
  T_16_Q_MINISENTRY_DESC: "Автоматическая турель, которая проводит сканирование и атакует ближайших противников.",
  T_16_R_EMOTE_DESERT_NAME: "Яростный Удар",
  T_16_R_EMOTE_EPHUNTER_NAME: "Боевой Танец",
  T_16_R_EMOTE_EPHUNTER2_NAME: "Дай Пять",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Лунный Удар",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Шаткая Походка",
  T_16_W_AK_FIRE_NAME: "AK47 Огненный Красный",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Розовый Дьявол",
  T_16_W_SCAR_WATER_NAME: "SCAR - Элемент Воды",
  T_16_Y_CHARACTER_HITMAN_NAME: "Рафаэль",
  T_16_Y_PANDA_NAME: "Детектив Панда",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Скин Питомца: Дикая Панда",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Скин Питомца: Опасный Панда",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Скин Питомца: Панда-Молния",
  T_17_B_CS_MODE_NAME: "Битва Отрядов",
  T_17_C_SKILL_NAME_PLAYBOY: "Молниеносность",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Королевский Шут (Маска)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Кровавая Госпожа (Маска)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Кровавая Госпожа (Низ)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Волшебная Лиса (Голова)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Кровавая Госпожа (Обувь)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Кровавая Госпожа (Верх)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Месть Вампира (Маска)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Уличный Головорез (Низ)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Месть Вампира (Низ)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Королевский Фиолетовый (Голова)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "Джентльмен (Обувь)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Месть Вампира (Обувь)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Месть Вампира (Верх)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Сияющий Золотой (Верх)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Скин Питомца: Принцесса Мяу",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Скин Питомца: Золотая Сказка",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Скин Питомца: Тёмно-синий",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Скин Питомца: Удачный Зелёный",
  T_17_O_SHIBA_NAME: "Сиба Ину",
  T_17_Q_FOLDWINGS: "Планер",
  T_17_Q_FOLDWINGS_DESC: "Позволяет скользить по воздуху",
  T_17_Q_SUPERHEAT: "ПЛАЗМА",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Дискотека",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS Вампир",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR Призрачный Убийца",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR Винтаж",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Джозеф",
  T_17_Z_CS_NAME: "Название",
  T_17_Z_ROOM_JUMP_SWITCH: "Высота Прыжка",
  T_17_Z_ROOM_SPEED_SWITCH: "Скорость Передвижения",
  T_18_B_THROWINGKNIFE_NAME: "Нож FF",
  T_18_C_DUMMY_NAME: "Граната-Приманка",
  T_18_C_SKILL_DESC_DJMALE: "Создает [FFB300]{1}м[-] ауру, которая увеличивает скорость на [FFB300]{3}%[-], и восст. [FFB300]{2} ХП/с[-] в течение [FFB300]{0}с[-]. Эффекты не складываются. Восст. [FFB300]{4}с[-].",
  T_18_C_SKILL_NAME_DJMALE: "Лови Ритм",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Восстановление Брони",
  T_18_L_COS_INDIANEWYEAR: "Лазурный Дракон",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Хмурое Лицо",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Огненный Красный (Маска)",
  T_18_O_FOX_NAME: "Призрачная Лиса",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Скин Питомца: Боевая Лиса",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Скин Питомца: Синяя Лиса",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Скин Питомца: Лавовая Тыква",
  T_18_O_PETSKIN_PINKFOX_NAME: "Скин Питомца: Красная Лиса",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Скин Питомца: Дух",
  T_18_U_WEAPON_M1887_NAME: "М1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 Пылающий Череп",
  T_18_W_UMP_GEISHA_N: "UMP Искусство Войны",
  T_18_Y_CHARACTER_DJMALE_N: "Алок",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Шани",
  T_19_B_HB_NAME: "Электродоска",
  T_19_C_ICE_GUN_NAME: "Ледяной Пистолет",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Урон от взрывного оружия увеличивается на [FFB300]{0}%[-], дальность урона увеличивается на [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "Во время вождения восстанавливает [FFB300]{1} ХП[-] каждые [FFB300]{0}с[-] для всех в транспортном средстве. Максимум до [FFB300]{2}[-] ХП",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Искусство Подрывника",
  T_19_C_SKILL_NAME_TOMBOY: "Благословение гонщика",
  T_19_I_EVENT_INFI_ITEM: "Безлимитный",
  T_19_L_A_ICEFESTIVAL19_B: "Последний Смех",
  T_19_L_F_S_ICEFESTIVAL: "Снежная Служанка (Обувь)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Диско Фиаско (Низ)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Диско Фиаско (Голова)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Диско Фиаско (Верх)",
  T_19_O_PETSKIN_NAME: "Скин Питомца: по умолчанию",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Скин Питомца: Хип-Хоп Панда",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Скин Питомца: Полярная Панда",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Скин Питомца: Робо Фараон",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Скин Питомца: Весенний Робо",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Скин Питомца: Снежный Робо",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Скин Питомца: Хип-Хоп Сиба",
  T_19_O_ROBOT_NAME: "Робо",
  T_19_O_TDM_NAME: "Ком. Бой Насмерть",
  T_19_R_EMOTE_MIGUEL_NAME: "Брейк Данс",
  T_19_S_SECOND_WEAPON_TITLE: "Вспомогательное оружие",
  T_19_S_VEST_TITLE: "Пуленепробиваемый Жилет",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Двойной Магазин",
  T_19_W_GROZA_TAGGERCREW_N: "ГРОЗА Восстание Тэггеров",
  T_19_W_M60_ICEFESTIVAL_N: "M60 Выбор Санты",
  T_19_W_MP40_PARK_N: "MP40 Карнавальная Резня",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR Золотой Дракон",
  T_19_X_PVE_SAMURAINAME: "Хранитель Самурай",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Альваро",
  T_19_Y_CHARACTER_TOMBOY_N: "Нотора",
  T_20_C_INHALER_NAME: "Противогаз",
  T_20_C_SKILL_DESC_PARKOURGUY: "Восстанавливает Здоровье при попадании во врага из огнестрельного оружия. Укладывание врага в нокдаун восстанавливает [FFB300]{0}%[-] ХП.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Яркое Убежище",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Смертельная Скорость",
  T_20_C_SKILL_NAME_PARKOURGUY: "Долгий Рейд",
  T_20_L_A_APRILFOOL2020: "Пёсель",
  T_20_L_F_A_METALHEAD_RED: "Шлем Рока (Маска)",
  T_20_L_F_B_THAIGIRL: "Царство Феникса (Низ)",
  T_20_L_F_H_KILLERCUPID: "Милый Амурчик (Голова)",
  T_20_L_F_H_THAIGIRL: "Царство Феникса (Голова)",
  T_20_L_F_S_THAIGIRL: "Царство Феникса (Обувь)",
  T_20_L_F_T_METALHEAD_RED: "Шлем Рока  (Верх)",
  T_20_L_F_T_THAIGIRL: "Царство Феникса (Верх)",
  T_20_L_JEANDINO: "Джинсовый динозавр",
  T_20_L_M_A_METALHEAD_RED: "Шлем Ярости (Маска)",
  T_20_L_M_T_METALHEAD_RED: "Шлем Ярости (Верх)",
  T_20_L_M_T_STOCKING: "Дворянин (Верх)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Скин Питомца: Влюблённый Лисёнок",
  T_20_P_CHANNEL_G: "Гильдия",
  T_20_P_WORLD_SSPEAKER: "Громкоговоритель",
  T_20_S_CSROOM_COIN: "Монеты по умолчанию",
  T_20_U_SHIELD_GUN_NAME: "Щитовая Пушка",
  T_20_W_AN94_METALHEAD_N: "Морковинатор AN94",
  T_20_W_P90_EVILBONE_N: "P90 Каратели",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Стеффи",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: "Келли Стриж",
  T_20_Y_CHARACTER_PARKOURGUY_N: "Итан",
  T_21_B_SMOKEGRENADE_DESC: "Пускает дым. Подойдёт, чтобы скрыть своё местоположение или для отвлекающего маневра",
  T_21_B_SMOKEGRENADE_NAME: "Дымовая Граната",
  T_21_C_AUTOPICKUP_AVERAGE: "По умолчанию",
  T_21_C_SKILL_DESC_KPOPSINGER: "Во время помощи напарнику, дает этому напарнику [FFB300]{0} ХП[-] щит и [FFB300]{1}%[-] увелич. скорости передвиж. В течение [FFB300]{2}с[-] уменьш. эффекты усил. после успешной помощи. Уменьшает потерю ХП во время нокдауна на [FFB300]{3}%[-] для напарников. Эффекты не складываются.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Каждый килл увеличивает макс. ХП на [FFB300]{0}[-]. Макс: [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Песня Жизни",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Хет-трик",
  T_21_L_ANGELICAL: "Кигуруми с крыльями",
  T_21_L_S_VNSLIPPER: "Вьетнамки",
  T_21_O_OTTER_NAME: "Выдра",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Скин Питомца: Токсичная Выдра",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Скин Питомца: Выдра в сакуре",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Скин Питомца: Неоновая Выдра",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Скин Питомца: Повелитель Смерти",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Скин Питомца: вспышка молнии",
  T_21_R_EMOTE_SORROW_NAME: "За что?!",
  T_21_U_WEAPON_THOMPSON_NAME: "Томпсон",
  T_21_W_BACKPACK_SPINE_N: "Киберпанк Рюкзак",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Контрольный Удар",
  T_21_W_M79_RABBITKILLER_N: "M79 Ушастый Хипстер",
  T_21_W_PAN_VOLCANO_N: "Гнев Вулкана",
  T_21_W_XM8_RAINBOW_N: "XM8 - День Нептуна",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Капелла",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Лусио",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Показывает противников в радиусе [FFB300]{0}м[-], если они не присели или не легли. Эффект длится [FFB300]{1}с[-]. Твоя команда тоже будет видеть противников. Восст. [FFB300]{2}с[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Выслеживание",
  T_22_C_SKILL_NAME_STREAMERGUY: "Прямой эфир",
  T_22_L_F_H_COLLEGE: "Огненная отличница (Голова)",
  T_22_L_F_S_SUMMER20: "Жара (Обувь)",
  T_22_L_M_A_GREENCOAT: "Блеск клуба (Маска)",
  T_22_L_M_A_PINKFUR: "Цвет клуба (Маска)",
  T_22_L_M_A_PLAGUE2: "Моровое Поветрие (Маска)",
  T_22_L_M_B_FAIM2: "Голодное Пламя (Низ)",
  T_22_L_M_B_GREENCOAT: "Блеск клуба (Низ)",
  T_22_L_M_B_PINKFUR: "Цвет клуба (Низ)",
  T_22_L_M_B_PLAGUE2: "Моровое Поветрие (Низ)",
  T_22_L_M_B_REDPANTS: "Клубный модник (Низ)",
  T_22_L_M_B_TIGERSTRIPE: "Клубный тигр (Низ)",
  T_22_L_M_H_COLLEGE: "Огненный отличник (Голова)",
  T_22_L_M_H_FAIM2: "Голодное Пламя (Голова)",
  T_22_L_M_H_GREENCOAT: "Блеск клуба (Голова)",
  T_22_L_M_H_PINKFUR: "Цвет клуба (Голова)",
  T_22_L_M_H_PLAGUE2: "Моровое Поветрие (Голова)",
  T_22_L_M_H_REDPANTS: "Клубный модник (Голова)",
  T_22_L_M_H_TIGERSTRIPE: "Клубный тигр (Голова)",
  T_22_L_M_S_FAIM2: "Голодное Пламя (Обувь)",
  T_22_L_M_S_PLAGUE2: "Моровое Поветрие (Обувь)",
  T_22_L_M_T_FAIM2: "Голодное Пламя (Верх)",
  T_22_L_M_T_GREENCOAT: "Блеск клуба (Верх)",
  T_22_L_M_T_PINKFUR: "Цвет клуба (Верх)",
  T_22_L_M_T_PLAGUE2: "Моровое Поветрие (Верх)",
  T_22_L_M_T_REDPANTS: "Клубный модник (Верх)",
  T_22_L_M_T_TIGERSTRIPE: "Клубный тигр (Верх)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K - Академия Бунтарей",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Арбузный тигр",
  T_22_LC_SCAR_HERMIT_N: "SCAR Искателей Тайн",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Лечащий Пистолет - Луч Жизни",
  T_22_O_HAWK_NAME: "Сокол",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Скин Питомца: Лиса в конце мира",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Скин Питомца: Сокол-Феникс",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Скин Питомца: Летний Сокол",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Скин Питомца: Солнечный Сиба Ину",
  T_22_Q_BOMB_PLIERS: "Кусачки",
  T_22_R_EMOTE_SHIMMY_NAME: "Шимми",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Бронебойность",
  T_22_U_WPNSKN_SPEED_RUN: "Скорость",
  T_22_Y_CHARACTER_DETECTIVE_N: "Эврика",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Волчара",
  T_23_B_CARDIAC_NAME: "Горизалин",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Мастер Клинка",
  T_23_C_SKILL_NAME_SWATGUY: "Перезарядка Ярости",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: "Хаято Всполох",
  T_23_D_CHARACTER_SWATGUY_N: "Джей",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Состоятельная Вокалистка (Низ)",
  T_23_L_F_B_MIKOGIRL: "Жрица Полудня (Низ)",
  T_23_L_F_B_NAVYGIRL: "Морячка (Низ)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Состоятельная Вокалистка (Голова)",
  T_23_L_F_H_MIKOGIRL: "Жрица Полудня (Голова)",
  T_23_L_F_H_NAVYGIRL: "Морячка (Голова)",
  T_23_L_F_S_MIKOGIRL: "Жрица Полудня (Обувь)",
  T_23_L_F_S_ORDERCHALLENGER: "Гениальная взломщица  (Обувь)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Состоятельная Вокалистка (Верх)",
  T_23_L_F_T_MIKOGIRL: "Жрица Полудня (Верх)",
  T_23_L_F_T_NAVYGIRL: "Морячка (Верх)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Состоятельный Резидент (Маска)",
  T_23_L_M_B_FOXGUY: "Жрец Полудня (Низ)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Состоятельный Резидент (Низ)",
  T_23_L_M_H_FOXGUY: "Жрец Полудня (Голова)",
  T_23_LC_SKS_GEMINI_N: "СКС - Истерика",
  T_23_O_PENGUIN_NAME: "Мистер Пинг-Вин",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Скин Питомца: Пинг-Вин Тусовщик",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Скин Питомца: Кибер-Вин",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Скин Питомца: Золотой Пинг",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Битва Отрядов",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Персонаж",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "ВНИМАНИЕ",
  T_24_C_FLAMETHROWER_NAME: "Огнемёт",
  T_24_C_SKILL_DESC_PROFESSOR: "Максимум Энергии (EP) увеличен на [FFB300]{0}[-]. Режим Джиу-джитсу: союзники в пределах [FFB300]{2}м[-] получают бонус [FFB300]{1}%[-] к переводу EP в Здоровье. Психологический режим: Восстанавливает [FFB300]{5} EP[-] каждые [FFB300]{4}с[-], до максимума [FFB300]{6} EP[-]. Можно переключать режим раз в [FFB300]{3}с[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "В отрыв",
  T_24_C_SKILL_NAME_PROFESSOR: "Энергия Вселенной",
  T_24_D_CHARACTER_PARTYGIRL_N: "Даша",
  T_24_D_CHARACTER_PROFESSOR_N: "Камиль",
  T_24_L_B_MAXPANTS: "Штаны MAX",
  T_24_L_H_PUMPKIN2020_A: "Бешеная тыковка (голова)",
  T_24_L_T_TSHIRT_COMEDIAN: "Он смеётся последним",
  T_24_LC_MP5_RICHBOXER_N: "MP5 Король Бокса",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR Приколистка с Динамо",
  T_24_LC_SVD_WARRINGSTATES_N: "СВД Легенда о Мечниках",
  T_24_U_M21A5: "Ястреб",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Общий Счёт",
  T_24_V_TRAINING_BOX_ATTACH: "Обвесы",
  T_24_V_TRAINING_BOX_WEAPON: "Оружие",
  T_24_W_ARMORY: "Оружие",
  T_24_W_ARMOTY_MELEE: "Ближний бой",
  T_24_W_ARMOTY_PISTOL: "Пистолеты",
  T_24_W_ARMOTY_RIFLE: "Автоматы",
  T_24_W_ARMOTY_SHOTGUN: "Дробовики",
  T_24_W_ARMOTY_SNIPER: "Снайперки",
  T_24_W_ARMOTY_SPECIAL: "Другое",
  T_24_W_ARMOTY_SUBMACHINE: "ПП",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Скин Питомца: Панда Booyah",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Скин Питомца: Роки Скелет",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Скин Питомца: Тусовочный Роки",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Скин Питомца: Зомби-Рок",
  T_24_W_RACCOON_N: "Роки",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Повелитель Времени",
  T_25_D_CHARACTER_BOUNTY_N: "Кронос",
  T_25_E_HUD_01: "Схема 1",
  T_25_E_HUD_02: "Схема 2",
  T_25_L_F_B_DEMONKILLER: "Юная Искра (Низ)",
  T_25_L_F_H_DEMONKILLER: "Юная Искра (Голова)",
  T_25_L_F_S_DEMONKILLER: "Юная Искра (Обувь)",
  T_25_L_F_T_DEMONKILLER: "Юная Искра (Верх)",
  T_25_L_HA_FP_EVIL: "Зло (Грим)",
  T_25_L_M_H_ANIMEHAIR: "Ветер (Голова)",
  T_25_L_S_MAXSNEAKERS: "Кроссовки MAX",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Кибер-Удар",
  T_25_LC_GLOO_WINTERFEST2020_N: "Стена Север 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "Северный M1887 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Кибер-Клинок",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 Звуковая Атака из укрытия",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 Звуковая Атака на закате",
  T_25_LC_PAN_BOUNTY_N: "Сковородка Кибер-Охотник за Наградой",
  T_25_R_LEGEND_REMIND: "Напоминание",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Коса",
  T_25_U_VECTOR: "Вектор",
  T_25_W_BABOON_N: "Павиан",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Скин Питомца: Ледниковый Павиан",
  T_25_W_PETSKIN_BABOON_HELL_N: "Скин Питомца: Пылающий Павиан",
  T_25_W_PETSKIN_BABOON_PURE_N: "Скин Питомца: Великий Белый Павиан",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Скин Питомца: Снежная Пантера",
  T_25_Z_R_SIMULATOR_OFF: "Нельзя",
  T_26_C_SKILL_DESC_SUPERSTAR: "Создаёт перед собой звуковую волну на [FFB300]{0}м[-]. Волна взрывается и наносит урон Стенам в радиусе [FFB300]{1}м[-] в течение [FFB300]{2}с[-]. Восстановление: [FFB300]{3}с[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Бешеный ритм",
  T_26_D_CHARACTER_DELIVERY_N: "Широ",
  T_26_D_CHARACTER_SUPERSTAR_N: "Скайлер",
  T_26_ET_CELLPHONE_NAME: "Лёгкий дрон",
  T_26_L_A_FLAMING_PREM: "Огненный Солдат (Маска)",
  T_26_L_A_SANTAMODE: "Снеговик Боб (Маска)",
  T_26_L_B_SANTAMODE: "Снеговик Боб (Низ)",
  T_26_L_F_B_WATERFEST21_A: "Летний Бриз (Низ)",
  T_26_L_F_H_WATERFEST21_A: "Летний Бриз (Голова)",
  T_26_L_F_S_WATERFEST21_A: "Летний Бриз (Обувь)",
  T_26_L_F_T_WATERFEST21_A: "Летний Бриз (Верх)",
  T_26_L_M_A_EGGDAY2021: "Кибер-Зайчик (Маска)",
  T_26_L_M_B_EGGDAY2021: "Кибер-Зайчик (Низ)",
  T_26_L_M_B_PAIRING: "Не разлей вода -  муж. (Низ)",
  T_26_L_M_B_WATERFEST21_A: "Летний Пляж (Низ)",
  T_26_L_M_H_EGGDAY2021: "Кибер-Зайчик (Голова)",
  T_26_L_M_H_PAIRING: "Не разлей вода -  муж. (Голова)",
  T_26_L_M_H_WATERFEST21_A: "Летний Пляж (Голова)",
  T_26_L_M_S_EGGDAY2021: "Кибер-Зайчик (Обувь)",
  T_26_L_M_S_PAIRING: "Не разлей вода -  муж. (Обувь)",
  T_26_L_M_S_WATERFEST21_A: "Летний Пляж (Обувь)",
  T_26_L_M_T_EGGDAY2021: "Кибер-Зайчик (Верх)",
  T_26_L_M_T_PAIRING: "Не разлей вода -  муж. (Верх)",
  T_26_L_M_T_WATERFEST21_A: "Летний Пляж (Верх)",
  T_26_L_S_SANTAMODE: "Снеговик Боб (Обувь)",
  T_26_L_T_SANTAMODE: "Снеговик Боб (Верх)",
  T_26_LC_AWM_KOICARP_N: "AWM Карп Кои",
  T_26_LC_KATANA_VALENTINE2021_N: "Катана - Розовый Сезон",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Спорткар Sayonara Boy",
  T_26_P_SKILL_NAME_DELIVERY: "Урон с доставкой",
  T_26_V_TRAINING_BHH: "Клёвый Молоток",
  T_26_V_TRAINING_DICE: "Мега-Кубик",
  T_26_W_DRAGON_N: "Дрейк",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Скин Питомца: Мистический Дрейк",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Скин Питомца: Электрический Дрейк",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Скин Питомца: Галактический Дрейк",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Скин Питомца: Влюблённый Пинг-Вин",
  T_26_XL_SETTING_TEAMMATE_INFO: "Инфо о члене команды",
  T_26_YP_HISTORY_WIN: "Победа",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Жен.",
  T_26_YP_SOCIAL_GENDER_MALE: "Муж.",
  T_26_YP_SOCIAL_NAME: "Никнейм",
  T_27_C_SKILL_DESC__RACERGIRL: "Скорость вождения увеличена на [FFB300]{0}%[-]. Когда персонаж в транспорте, в него труднее прицелиться, и получаемый урон уменьшен на [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Создаёт непробиваемое силовое поле, блокирующее [FFB300]{0} урона[-]. Изнутри поля нельзя атаковать противников, находящихся снаружи. Эффекты длятся [FFB300]{1}с[-]. Восст. [FFB300]{2}с[-].",
  T_27_C_SKILL_DESC_FALCONER: "Урон увеличивается вместе с расстоянием, до [FFB300]{0}%[-]. Урон по отмеченным противникам увеличен на [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Пробуждение: Уменьшает урон, полученный спереди на [FFB300]{1}%[-] за каждые [FFB300]{0}%[-] потерянного ХП",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Пробуждённый: Для активации беги [FFB300]{0}с[-]. Первые [FFB300]{2}[-] выстрел(а) по цели наносят повышенный на [FFB300]{1}%[-] урон. Длит. [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "Соколиная охота",
  T_27_C_SKILL_NAME_XTREME: "Адреналин",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "Эндрю Неистовый",
  T_27_D_CHARACTER_FALCONER_N: "Мадияр",
  T_27_D_CHARACTER_XTREME_N: "Ксандра",
  T_27_F_EAP_PKG3_D: "Играй на Стиле!",
  T_27_HYL_SKILLBOARD_HP: "Здоровье",
  T_27_L_A_CARDBOARD_MID2: "Бумажный Тигр-р-р (Маска)",
  T_27_L_B_CARDBOARD_REG: "Бумажный МедведЪ (Низ)",
  T_27_L_M_S_KAZAKHSTAN: "Батыр (Обувь)",
  T_27_L_S_CARDBOARD_REG: "Бумажный МедведЪ (Обувь)",
  T_27_L_T_CARDBOARD_REG: "Бумажный МедведЪ (Верх)",
  T_27_LC_VECTOR_FFWS2021_N: "Вектор FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Монстр Трак FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Байк K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Спорткар Буйная Зелень",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Пикап Призрачный Дракон",
  T_27_P_SKILL_NAME_HITMAN_RE: "Мёртвая Тишина",
  T_27_R_EMOTE_GREETING_NAME: "Приветствие",
  T_27_R_VEHICLE_ACCELERATION: "Ускорение",
  T_27_R_VEHICLE_HP: "Прочность",
  T_27_R_VEHICLE_SPEED: "Макс. скорость",
  T_27_U_KORD: "Корд",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Пробуждённый: Снижение урона бронёй улучшено на [FFB300]{0}%[-]. Урон снижается ещё на  [FFB300]{1}%[-] за каждого члена команды с этим навыком",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Сила Стаи",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Марси",
  T_27_W_ARMOTY_DMR: "Винтовки",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Скин Питомца: Цветочный Марси",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Скин Питомца: Марси-геймер",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Скин Питомца: Марси-хипстер",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Скин Питомца: Щенок на FFWS 2021",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Скин Питомца: Панда на FFWS 2021",
  T_27_XC_REPLAY_DIE: "Смерть",
  T_27_XC_REPLAY_KILL: "Килл",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Ремонт",
  T_28_C_G_ICE_NAME: "Крио-Граната",
  T_28_C_SKILL_DESC_STREETBEAT: "Во время стрельбы в движении скорость передвижения увеличивается на [FFB300]{0}%[-], точность увеличивается на [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "В такт",
  T_28_D_CHARACTER_STREETBEAT_N: "Флай",
  T_28_HI_UZI: "Мини-Узи",
  T_28_L_B_BRJERSEY_A: "Футбольная форма 23 (Низ)",
  T_28_L_B_BRJERSEY_B: "Футбольная форма 10 (Низ)",
  T_28_L_B_BRJERSEY_C: "Футбольная форма 24 (Низ)",
  T_28_L_B_BRJERSEY_D: "Футбольная форма 30 (Низ)",
  T_28_L_B_BRJERSEY_E: "Футбольная форма 1 (Низ)",
  T_28_L_B_BRJERSEY_F: "Футбольная форма 20 (Низ)",
  T_28_L_F_B_FOURSYMBOLS_C: "Алая Сирокко (Низ)",
  T_28_L_F_H_FOURSYMBOLS_C: "Алая Сирокко (Голова)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Алая Сирокко (Грим)",
  T_28_L_F_S_FOURSYMBOLS_C: "Алая Сирокко (Обувь)",
  T_28_L_F_T_FOURSYMBOLS_C: "Алая Сирокко (Верх)",
  T_28_L_HA_THUNDER: "Молнии из глаз (Грим)",
  T_28_L_M_A_SPORTSUIT: "Резкий Скейтер (Маска)",
  T_28_L_M_B_FOURSYMBOLS_D: "Песочный Самум (Низ)",
  T_28_L_M_B_SPORTSUIT: "Резкий Скейтер (Низ)",
  T_28_L_M_H_FOURSYMBOLS_D: "Песочный Самум (Голова)",
  T_28_L_M_H_SPORTSUIT: "Резкий Скейтер (Голова)",
  T_28_L_M_S_FOURSYMBOLS_D: "Песочный Самум (Обувь)",
  T_28_L_M_S_SPORTSUIT: "Резкий Скейтер (Обувь)",
  T_28_L_M_T_FALLWINTER: "Чёткий Статус (Верх)",
  T_28_L_M_T_FOURSYMBOLS_D: "Песочный Самум (Верх)",
  T_28_L_M_T_SPORTSUIT: "Резкий Скейтер (Верх)",
  T_28_L_T_BRJERSEY_A: "Футбольная форма 23 (Верх)",
  T_28_L_T_BRJERSEY_B: "Футбольная форма 10 (Верх)",
  T_28_L_T_BRJERSEY_C: "Футбольная форма 24 (Верх)",
  T_28_L_T_BRJERSEY_D: "Футбольная форма 30 (Верх)",
  T_28_L_T_BRJERSEY_E: "Футбольная форма 1 (Верх)",
  T_28_L_T_BRJERSEY_F: "Футбольная форма 20 (Верх)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 Для Невесты",
  T_28_LC_GLOO_FALLWINTER_N: "Чёткая Стена",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Стена Тайфун",
  T_28_LC_KORD_SHINOBI_N: "Корд Разряд",
  T_28_LC_M21A5_FANTASYEYE_N: "Ястреб Безжалостный Некромант",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 Смертоносная Акула",
  T_28_LC_PAN_FOURSYMBOLS_N: "Сковородка Песчаная Буря",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Джип Тайфун",
  T_28_T_WS_ITEM1: "Кубический Ящик",
  T_28_T_WS_ITEM10: "Хижина",
  T_28_T_WS_ITEM11: "Вышка",
  T_28_T_WS_ITEM12: "Будка",
  T_28_T_WS_ITEM13: "Дом А",
  T_28_T_WS_ITEM14: "Дом В",
  T_28_T_WS_ITEM15: "Дом С",
  T_28_T_WS_ITEM16: "Скульптура из песка",
  T_28_T_WS_ITEM17: "Фонтан",
  T_28_T_WS_ITEM18: "Сакура",
  T_28_T_WS_ITEM19: "Дерево",
  T_28_T_WS_ITEM2: "Длинный Ящик",
  T_28_T_WS_ITEM20: "Унитаз",
  T_28_T_WS_ITEM21: "Забор",
  T_28_T_WS_ITEM3: "Куст",
  T_28_T_WS_ITEM4: "Стог сена",
  T_28_T_WS_ITEM5: "Машина",
  T_28_T_WS_ITEM6: "Автобус",
  T_28_T_WS_ITEM7: "Контейнер А",
  T_28_T_WS_ITEM8: "Контейнер В",
  T_28_T_WS_ITEM9: "Контейнер С",
  T_28_T_WS_TYPE1: "Объекты",
  T_28_T_WS_TYPE4: "Украшения",
  T_28_W_DUCK_N: "Доктор Кряккер",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Скин Питомца: Дрейк-Химера",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Скин Питомца: Сержант Кряккер",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Скин Питомца: Гангста-Кряккер",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Скин Питомца: DJ Кряккер",
  T_28_YF_AR15: "Зимородок",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Пробуждённый: Метка на враге, в которого попали, длится дольше, когда враг движется, до [FFB300]{0}с[-].",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Взгляд Сфинкса",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Воодушевление",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Сердечный Ритм",
  T_29_D_CHARACTER_AMOCO_N: "Моко Энигма",
  T_29_D_CHARACTER_MUSICBRO1_N: "Димитрий",
  T_29_D_CHARACTER_MUSICBRO2_N: "Тива",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Полосатая футбольная форма (Низ)",
  T_29_L_M_A_FALCONER_C: "Капризный Миллионер (Маска)",
  T_29_L_M_A_JUNGLE_GREEN: "Боевая Черепаха (Маска)",
  T_29_L_M_B_FALCONER_C: "Капризный Миллионер (Низ)",
  T_29_L_M_B_JUNGLE_GREEN: "Боевая Черепаха (Низ)",
  T_29_L_M_H_FALCONER_C: "Капризный Миллионер (Голова)",
  T_29_L_M_H_JUNGLE_GREEN: "Боевая Черепаха (Голова)",
  T_29_L_M_S_FALCONER_C: "Капризный Миллионер (Обувь)",
  T_29_L_M_S_JUNGLE_GREEN: "Боевая Черепаха (Обувь)",
  T_29_L_M_T_FALCONER_C: "Капризный Миллионер (Верх)",
  T_29_L_M_T_JUNGLE_GREEN: "Боевая Черепаха (Верх)",
  T_29_L_T_TRJERSEY: "Полосатая футбольная форма (Верх)",
  T_29_M_WS_ITEM22: "Обшарпанный контейнер",
  T_29_M_WS_ITEM23: "Обшарпанный забор",
  T_29_M_WS_ITEM24: "Точка Появления А",
  T_29_M_WS_ITEM25: "Точка Появления Б",
  T_29_M_WS_TYPE5: "Интерактивные объекты",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Скин Питомца: Сенсей Тиго в Дороге",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Скин Питомца: Огненный Сенсей Тиго",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Скин Питомца: Кибер-Сокол",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Скин Питомца: Панда на Ве4еринке",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Скин Питомца: Ледяной Сенсей Тиго",
  T_29_W_TIGER_NINJA_N: "Сенсей Тиго",
  T_29_YF_MACHETE_MUSICFEST_N: "Резкий Звук",
  T_29_YF_MAGEZINE_CHAIN_N: "Авт. Магазин",
  T_29_YF_MUZZLE_CRASH_N: "Дуло для ПП",
  T_29_YF_MUZZLE_WIDE_N: "Дуло для Дробовика",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 Ионная Буря",
  T_29_YF_UZI_GOLDENWING_N: "Мини-Узи Она-Дроид",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Монстр Трак Угрызения Совести",
  T_30_AD_RP_ROUNDEND: "РАУНД ЗАВЕРШЁН",
  T_30_AD_TRAINING_SNOWBALL: "Снежки",
  T_30_AD_TRAINING_SNOWBALL_DES: "Сыграем в снежки!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}с[-] после атаки восстанавливайте [FFB300]{1}ХП[-]/с в течение [FFB300]{2}с[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Бросок с Сиреной",
  T_30_C_SKILL_NAME_MUERTOGUY: "Дымка Воспоминаний",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Леон",
  T_30_D_CHARACTER_MUERTOGUY_N: "Отзо",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Микрочип Джея",
  T_30_L_A_BRMASCOT_ADULT: "Злобная Канарейка",
  T_30_L_A_BRMASCOT_KIDS: "Милая Канарейка",
  T_30_L_A_SUGARSKULL21_BANDANA: "Маска Смертельный Укус",
  T_30_L_B_BRFOOTBALL_BLACK: "Чёрная футбольная форма CBF (Низ)",
  T_30_L_B_BRFOOTBALL_GREEN: "Зелёная футбольная форма CBF (Низ)",
  T_30_L_B_BRFOOTBALL_GREY: "Серая футбольная форма CBF (Низ)",
  T_30_L_B_BRUNIFORM: "Канарейка (Низ)",
  T_30_L_F_A_SUGARSKULL21: "Золотая Вышивка (Маска)",
  T_30_L_F_B_SUGARSKULL21: "Золотая Вышивка (Низ)",
  T_30_L_F_B_THASIAN: "Коралловая Хулиганка (Низ)",
  T_30_L_F_H_CATEARS: "Кавайные Ушки",
  T_30_L_F_H_SUGARSKULL21: "Золотая Вышивка (Голова)",
  T_30_L_F_H_THASIAN: "Коралловая Хулиганка (Голова)",
  T_30_L_F_S_SUGARSKULL21: "Золотая Вышивка (Обувь)",
  T_30_L_F_S_THASIAN: "Коралловая Хулиганка (Обувь)",
  T_30_L_F_T_SUGARSKULL21: "Золотая Вышивка (Верх)",
  T_30_L_F_T_THASIAN: "Коралловая Хулиганка (Верх)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Шапочка с Дельфином",
  T_30_L_H_CHILDRENSDAY_RED: "Шапочка со Слоном",
  T_30_L_H_CLOWNHAT: "Жёлтый Шутовской Колпак",
  T_30_L_H_ZASCARF: "Модный Золотой Шарф",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Лёгкий Вид (Маска)",
  T_30_L_M_A_SUGARSKULL21: "Золотой Узор (Маска)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Лёгкий Вид (Низ)",
  T_30_L_M_B_PKCRICKET: "Чемпион в Зелёном (Низ)",
  T_30_L_M_B_SUGARSKULL21: "Золотой Узор (Низ)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Наездник Ветра (Низ)",
  T_30_L_M_B_THASIAN: "Коралловый Бунтарь (Низ)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Лёгкий Вид (Голова)",
  T_30_L_M_H_SUGARSKULL21: "Золотой Узор (Голова)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Наездник Ветра (Голова)",
  T_30_L_M_H_THASIAN: "Коралловый Бунтарь (Голова)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Костяной Доспех Альфа (Грим)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Лёгкий Вид (Обувь)",
  T_30_L_M_S_PKCRICKET: "Чемпион в Зелёном (Обувь)",
  T_30_L_M_S_SUGARSKULL21: "Золотой Узор (Обувь)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Наездник Ветра (Обувь)",
  T_30_L_M_S_THASIAN: "Коралловый Бунтарь (Обувь)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Лёгкий Вид (Верх)",
  T_30_L_M_T_PKCRICKET: "Чемпион в Зелёном (Верх)",
  T_30_L_M_T_SUGARSKULL21: "Золотой Узор (Верх)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Наездник Ветра (Верх)",
  T_30_L_M_T_THASIAN: "Коралловый Бунтарь (Верх)",
  T_30_L_S_BRUNIFORM: "Канарейка (Обувь)",
  T_30_L_T_BRFOOTBALL_BLACK: "Чёрная футбольная форма CBF (Верх)",
  T_30_L_T_BRFOOTBALL_GREEN: "Зелёная футбольная форма CBF (Верх)",
  T_30_L_T_BRFOOTBALL_GREY: "Серая футбольная форма CBF (Верх)",
  T_30_L_T_BRUNIFORM: "Канарейка (Верх)",
  T_30_M_WS_PARTY_MODE: "Спортплощадка",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Вызов",
  T_30_R_EMOTE_MAX_NAME: "Чёткий Движ",
  T_30_R_LEGEND_HALO_NAME: "Горячая Аура",
  T_30_T_WS_DEFAULTDESCRIPTION: "Крутая карта на Личном Острове Free Fire",
  T_30_T_WS_ITEM26: "Шины",
  T_30_T_WS_ITEM27: "Куча Шин А",
  T_30_T_WS_ITEM28: "Куча Шин В",
  T_30_T_WS_ITEM29: "Куча Шин С",
  T_30_T_WS_ITEM30: "Машинка с Автодрома",
  T_30_T_WS_ITEM31: "Амфибия",
  T_30_T_WS_ITEM32: "Джип",
  T_30_T_WS_ITEM33: "Мусорный контейнер",
  T_30_T_WS_ITEM34: "Навес",
  T_30_T_WS_ITEM35: "Полевой Госпиталь",
  T_30_T_WS_ITEM36: "Гараж",
  T_30_T_WS_ITEM37: "Разрисованные Стены",
  T_30_T_WS_ITEM38: "Тории",
  T_30_T_WS_ITEM39: "Стальная Платформа",
  T_30_T_WS_ITEM40: "Домик-вагон",
  T_30_T_WS_ITEM41: "Трейлер",
  T_30_T_WS_ITEM42: "Стена A",
  T_30_T_WS_ITEM43: "Стена B",
  T_30_T_WS_ITEM44: "Стена C",
  T_30_T_WS_ITEM45: "Стена D",
  T_30_T_WS_ITEM46: "Стена E",
  T_30_T_WS_ITEM47: "Стена F",
  T_30_U_ATTACHMENT_1: "Усилитель Щита",
  T_30_U_ATTACHMENT_4: "Удлинитель Броника",
  T_30_U_ATTACHMENT_5: "Накладка на Шлем",
  T_30_U_ATTACHMENT_6: "Накладка на Броник",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Скин Питомца: Павиан-Череп",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Скин Питомца: Пинг-Вин-Панк",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Скин Питомца: Снайпер Агент Скок",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Скин Питомца: Цирковой Агент Скок",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Скин Питомца: Кибер-Агент Скок",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Скин Питомца: Робо-Амулет",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Скин Питомца: Робо с газировкой",
  T_30_W_RABBIT_N: "Агент Скок",
  T_30_XH_PCMAP_P17: "Фабрика",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Стена ДЕНЬ BOOYAH 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Граната ДЕНЬ BOOYAH 2021",
  T_30_YF_Healinggun_Sniper_N: "Леч. Снайперка",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 Светлый Защитник",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL Алый Наследник",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR Светлый Защитник",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Томпсон Золотое Посвящение",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Спорткар Опасный Панк",
  T_31_C_SKILL_NAME_WINTERGUY: "Ледник",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Зимний Замес",
  T_31_HQ_GLOO_EAGLE_N: "Стена Ветер Дюн",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Леч. Снайперка Ледяные Кости",
  T_31_HQ_KATANA_WINTERFEST21_N: "Катана Жгучая Зима",
  T_31_HQ_PAN_WINTERFEST21_N: "Сковородка Жгучая Зима",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Скин Питомца: Снежная Выдра",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Скин Питомца: Пинг-Вин на Льду",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Скин Питомца: Йети-Шаман",
  T_31_HQ_PETSKIN_YETI_RED_N: "Скин Питомца: Огненный Йети",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Коса Жгучая Зима",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Байк Зимние Цветы",
  T_31_HQ_YETI_N: "Йети",
  T_31_KK_WINTER_BUJIX: "Припасы",
  T_31_KK_WINTER_SANJITOU: "Шлем",
  T_31_L_A_BDCRICKET: "Чемпион по Крикету (Маска)",
  T_31_L_A_WINTERFEST21: "Оленье Покрывало",
  T_31_L_B_BDCRICKET: "Чемпион по Крикету (Низ)",
  T_31_L_B_MEJERSEY_10: "Форма № 10 (Низ)",
  T_31_L_B_MEJERSEY_11: "Форма № 11 (Низ)",
  T_31_L_B_MEJERSEY_13: "Форма № 13 (Низ)",
  T_31_L_B_MEJERSEY_18G: "Зелёная Форма № 18 (Низ)",
  T_31_L_B_MEJERSEY_18R: "Красная Форма № 18 (Низ)",
  T_31_L_B_MEJERSEY_7: "Форма № 7 (Низ)",
  T_31_L_F_B_RUMUSICIAN: "Fire Squad: Другая (Низ)",
  T_31_L_F_B_THAGENT: "Заговорщица (Низ)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Варёная Панама (женская)",
  T_31_L_F_H_RUMUSICIAN: "Fire Squad: Другая (Голова)",
  T_31_L_F_H_THAGENT: "Заговорщица (Голова)",
  T_31_L_F_HA_RUMUSICIAN: "Fire Squad: Другая (Грим)",
  T_31_L_F_S_RUMUSICIAN: "Fire Squad: Другая (Обувь)",
  T_31_L_F_S_THAGENT: "Заговорщица (Обувь)",
  T_31_L_F_T_RUMUSICIAN: "Fire Squad: Другая (Верх)",
  T_31_L_F_T_THAGENT: "Заговорщица (Верх)",
  T_31_L_HA_RUMUSICIAN_MU: "Fire Squad: Другой (Грим)",
  T_31_L_HA_WINTERFEST21_BLUE: "Грим Морозное Веселье",
  T_31_L_HA_WINTERFEST21_PINK: "Грим Фейерверк",
  T_31_L_M_A_REGGAETON_B: "Неоновый Реггетон (Маска)",
  T_31_L_M_A_REGGAETON_P: "Амбициозный Цвет (Маска)",
  T_31_L_M_A_RUMUSICIAN: "Fire Squad: Другой (Маска)",
  T_31_L_M_A_THAGENT: "Конспиратор (Маска)",
  T_31_L_M_B_PKCOSTUME: "Утончённый Зелёный (Низ)",
  T_31_L_M_B_REGGAETON_B: "Неоновый Реггетон (Низ)",
  T_31_L_M_B_REGGAETON_P: "Амбициозный Цвет (Низ)",
  T_31_L_M_B_RUMUSICIAN: "Fire Squad: Другой (Низ)",
  T_31_L_M_B_THAGENT: "Конспиратор (Низ)",
  T_31_L_M_H_GREENCAP: "Кепка Победителя",
  T_31_L_M_H_PKCOSTUME: "Утончённый Зелёный (Голова)",
  T_31_L_M_H_REGGAETON_B: "Неоновый Реггетон (Голова)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Варёная Панама (мужская)",
  T_31_L_M_H_REGGAETON_P: "Амбициозный Цвет (Голова)",
  T_31_L_M_H_RUMUSICIAN: "Fire Squad: Другой (Голова)",
  T_31_L_M_H_THAGENT: "Конспиратор (Голова)",
  T_31_L_M_S_PKCOSTUME: "Утончённый Зелёный (Обувь)",
  T_31_L_M_S_REGGAETON_B: "Неоновый Реггетон (Обувь)",
  T_31_L_M_S_REGGAETON_P: "Амбициозный Цвет (Обувь)",
  T_31_L_M_S_RUMUSICIAN: "Fire Squad: Другой (Обувь)",
  T_31_L_M_S_THAGENT: "Конспиратор (Обувь)",
  T_31_L_M_T_PKCOSTUME: "Утончённый Зелёный (Верх)",
  T_31_L_M_T_REGGAETON_B: "Неоновый Реггетон (Верх)",
  T_31_L_M_T_REGGAETON_P: "Амбициозный Цвет (Верх)",
  T_31_L_M_T_REGGAETON_TATOO: "Familia",
  T_31_L_M_T_RUMUSICIAN: "Fire Squad: Другой (Верх)",
  T_31_L_M_T_THAGENT: "Конспиратор (Верх)",
  T_31_L_S_BDCRICKET: "Чемпион по Крикету (Обувь)",
  T_31_L_T_BDCRICKET: "Чемпион по Крикету (Верх)",
  T_31_L_T_BRBANK: "Красный Бомбер",
  T_31_L_T_MEJERSEY_10: "Форма № 10 (Верх)",
  T_31_L_T_MEJERSEY_11: "Форма № 11 (Верх)",
  T_31_L_T_MEJERSEY_13: "Форма № 13 (Верх)",
  T_31_L_T_MEJERSEY_18G: "Зелёная Форма № 18 (Верх)",
  T_31_L_T_MEJERSEY_18R: "Красная Форма № 18 (Верх)",
  T_31_L_T_MEJERSEY_7: "Форма № 7 (Верх)",
  T_31_L_T_PKMOBILE: "Футболка Infinix",
  T_31_L_T_REGGAETON_HOOD: "Худи со смайликом",
  T_31_MF_CHARACTER_WINTERGUY_N: "Найр",
  T_31_R_EMOTE_FALCONER_NAME: "Номер 1",
  T_31_RW_COMBINEMACHINE_2: "Активатор стрельбы с двух рук (Продвинутый)",
  T_31_RW_VIBRATION_EXPLOSION: "Взрывы",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Оружие Ближнего боя",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Прочее оружие",
  T_31_T_WS_1PLAYERTEAM: "Соло",
  T_31_T_WS_2PLAYERTEAM: "Дуо",
  T_31_T_WS_3PLAYERTEAM: "Трио",
  T_31_T_WS_4PLAYERTEAM: "Отряд",
  T_31_T_WS_5PLAYERTEAM: "5 игроков",
  T_31_T_WS_6PLAYERTEAM: "6 игроков",
  T_31_T_WS_BUFFTIME_TITLE: "Время Обновления (с)",
  T_31_T_WS_BUFFTYPE_AMMO: "Патроны",
  T_31_T_WS_BUFFTYPE_ARMOR: "Броня",
  T_31_T_WS_BUFFTYPE_HP: "Здоровье",
  T_31_T_WS_BUFFTYPE_RANDOM: "Случайно",
  T_31_T_WS_BUFFTYPE_TITLE: "Тип Бонуса",
  T_31_T_WS_DESC48: "За миллисекунды унесёт тебя в другое место",
  T_31_T_WS_DESC49: "Создаёт звук пианино",
  T_31_T_WS_DESC51: "Создаёт звук барабана",
  T_31_T_WS_DESC53: "Создаёт звук синтезатора",
  T_31_T_WS_DESC59: "Устройство, которое иногда генерирует бонус. Подбери, чтобы получить соответствующее улучшение",
  T_31_T_WS_DRUMTYPE_CLAPS: "Трещотка",
  T_31_T_WS_DRUMTYPE_HIHATS: "Тарелка",
  T_31_T_WS_DRUMTYPE_KICK: "Бас-бочка",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Тарелка 2",
  T_31_T_WS_DRUMTYPE_RIDES: "Подвесная тарелка",
  T_31_T_WS_DRUMTYPE_SNARES: "Малый барабан",
  T_31_T_WS_EARLYSHRINK: "Быстрое сужение",
  T_31_T_WS_ITEM48: "Портал",
  T_31_T_WS_ITEM49: "Кнопка Пианино",
  T_31_T_WS_ITEM51: "Кнопка Барабанов",
  T_31_T_WS_ITEM53: "Комбо-Кнопка А",
  T_31_T_WS_ITEM55: "Комбо-Кнопка B",
  T_31_T_WS_ITEM57: "Комбо-Кнопка C",
  T_31_T_WS_ITEM59: "Генератор Бонусов",
  T_31_T_WS_LATESHRINK: "Позднее сужение",
  T_31_T_WS_ME_DAMAGE: "Нанесённый урон",
  T_31_T_WS_ME_DAMAGED: "Полученный урон",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Начальное соотношение Энергии",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Радиус Первой Безопасной Зоны",
  T_31_T_WS_ME_EPQUICKRESTORE: "Быстрый перевод Энергии",
  T_31_T_WS_ME_FLOW: "Режим",
  T_31_T_WS_ME_GENERALSETTING: "Общее",
  T_31_T_WS_ME_INRANDOMSPAWN: "Случайная точка появления",
  T_31_T_WS_ME_KILLSCORE: "Бонус за Киллы",
  T_31_T_WS_ME_MAXEP: "Макс. Энергия",
  T_31_T_WS_ME_MAXHP: "Макс. Здоровье",
  T_31_T_WS_ME_NEARTEAM: "Союзники поблизости",
  T_31_T_WS_ME_REBIRTH: "Время Ожидания Возрождения",
  T_31_T_WS_ME_REBIRTHLOCATION: "Локация Возрождения",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Время Начала Сужения Зоны",
  T_31_T_WS_ME_WINSCORE: "Победный Счёт",
  T_31_T_WS_MINIZONE: "Мини-Зона",
  T_31_T_WS_MUSICTYPE_TITLE: "Тип музыки",
  T_31_T_WS_UNLIMITEDAMMO: "Бесконечные Патроны",
  T_31_WT_WS_DESC1: "Квадратный деревянный ящик, их можно складывать друг на друга",
  T_31_WT_WS_DESC10: "Домик с деревянной лестницей, по которой можно подниматься наверх",
  T_31_WT_WS_DESC11: "Множество окон полезны для стрелка",
  T_31_WT_WS_DESC12: "Сделана из металла, есть входы и окна",
  T_31_WT_WS_DESC13: "Есть входы и окна",
  T_31_WT_WS_DESC14: "Двухэтажный дом с верандой",
  T_31_WT_WS_DESC15: "Двухэтажный дом с герметичной крышей",
  T_31_WT_WS_DESC16: "Декор - Песчаная скульптура в форме сердца",
  T_31_WT_WS_DESC17: "Декор - фонтан с чистейшей водой",
  T_31_WT_WS_DESC18: "Декор - дерево с розовыми цветами",
  T_31_WT_WS_DESC19: "Декор - маленькое банановое дерево без плодов",
  T_31_WT_WS_DESC2: "Прямоугольный деревянный ящик, их можно складывать друг на друга",
  T_31_WT_WS_DESC20: "Часть обстановки ванной комнаты, можно выносить наружу",
  T_31_WT_WS_DESC21: "Небольшая ограда, которой можно разграничивать пространство",
  T_31_WT_WS_DESC22: "Деревянную стенку этого контейнера можно разбить грубой силой",
  T_31_WT_WS_DESC23: "Эту небольшую ограду можно разбить грубой силой",
  T_31_WT_WS_DESC24: "Стартовая точка Команды А (Доступно только в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_31_WT_WS_DESC25: "Стартовая точка Команды Б (Доступно только в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_31_WT_WS_DESC26: "Отбрасывает игроков на небольшое расстояние в направлении, в котором они лицом",
  T_31_WT_WS_DESC27: "Отбрасывает игроков на небольшое расстояние в заданном направлении",
  T_31_WT_WS_DESC28: "Отбрасывает игроков на среднее расстояние в заданном направлении",
  T_31_WT_WS_DESC29: "Отбрасывает игроков на большое расстояние в заданном направлении",
  T_31_WT_WS_DESC3: "Цветёт красными и жёлтыми цветами, добавляет лёгкости полю боя",
  T_31_WT_WS_DESC30: "Машинка с автодрома, которую можно водить",
  T_31_WT_WS_DESC31: "Амфибия, которую можно водить",
  T_31_WT_WS_DESC32: "Джип, который можно водить",
  T_31_WT_WS_DESC33: "Внутри мусор. Ниже человеческого роста, но какое-никакое укрытие",
  T_31_WT_WS_DESC34: "Металлическое укрытие на открытом воздухе",
  T_31_WT_WS_DESC35: "Палатка средних размеров. Есть два входа, но нет окон",
  T_31_WT_WS_DESC36: "Большой кирпичный гараж",
  T_31_WT_WS_DESC37: "Большая кирпичная стена, которой можно разграничивать пространство",
  T_31_WT_WS_DESC38: "Полезный ориентир",
  T_31_WT_WS_DESC39: "Большая металлическая платформа, которую можно использовать как главное поле сражения",
  T_31_WT_WS_DESC4: "Выше человеческого роста. Можно использовать как укрытие",
  T_31_WT_WS_DESC40: "Выглядит как жилой транспорт. Есть много входов и окон",
  T_31_WT_WS_DESC41: "Выглядит как жилой транспорт. Есть один вход и много окон",
  T_31_WT_WS_DESC42: "Стена со входом",
  T_31_WT_WS_DESC43: "Обычная стена",
  T_31_WT_WS_DESC44: "Угол из стен",
  T_31_WT_WS_DESC45: "Асимметричный угол из стен",
  T_31_WT_WS_DESC46: "Асимметричный угол из стен",
  T_31_WT_WS_DESC47: "Угол из стен с окнами",
  T_31_WT_WS_DESC5: "Брошенная машина. Ниже человеческого роста, но какое-никакое укрытие",
  T_31_WT_WS_DESC6: "Выше человеческого роста. Можно использовать как укрытие",
  T_31_WT_WS_DESC7: "Открыт с двух сторон. Может разделять пространство или формировать проход",
  T_31_WT_WS_DESC8: "Открыт с одной стороны. Может разделять пространство",
  T_31_WT_WS_DESC9: "Закрыт с двух сторон. Может разделять пространство",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Транспорт",
  T_31_Z_OB_UAV: "Дрон",
  T_32_C_SKILL_DESC_YAKUZA: "Резко бежит вперёд на большой скорости [FFB300]{0}с[-]. Навык можно накапливать и использовать до [FFB300]{2} раз[-] подряд с перерывом в [FFB300]{3}с[-] между использованиями. Восст. [FFB300]{1}с[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Погоня",
  T_32_HQ_AUG_VNSTREET_N: "AUG Непокорная Натура",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Рюкзак Карминовый Рассвет",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B Вампирский Гипноз",
  T_32_HQ_GLOO_DUNHUANG_N: "Стена Холодный Свет",
  T_32_HQ_GLOO_HURRICANE_2_N: "Стена Сердце Зари",
  T_32_HQ_GRENADE_HURRICANE_N: "Сценическая Граната",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 Холодный Свет",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Скин Питомца: Красный Кряккер",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Скин Питомца: Кибер-Флэш",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Скин Питомца: Флэш-Геймер",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Скин Питомца: Праздничный Флэш",
  T_32_HQ_TORTOISE_N: "Флэш",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Спорткар Кладбищенский Туман",
  T_32_L_F_A_PHARAOH: "Царственная Мумия (Маска)",
  T_32_L_F_B_PHARAOH: "Царственная Мумия (Низ)",
  T_32_L_F_H_PHARAOH: "Царственная Мумия (Голова)",
  T_32_L_F_HA_PHARAOH: "Царственная Мумия (Грим)",
  T_32_L_F_S_PHARAOH: "Царственная Мумия (Обувь)",
  T_32_L_F_T_PHARAOH: "Царственная Мумия (Верх)",
  T_32_L_M_A_JUNKFOOD: "Бургер (Маска)",
  T_32_L_M_A_PHARAOH: "Восставший Фараон (Маска)",
  T_32_L_M_B_JUNKFOOD: "Бургер (Низ)",
  T_32_L_M_B_PHARAOH: "Восставший Фараон (Низ)",
  T_32_L_M_H_JUNKFOOD: "Бургер (Голова)",
  T_32_L_M_H_PHARAOH: "Восставший Фараон (Голова)",
  T_32_L_M_S_JUNKFOOD: "Бургер (Обувь)",
  T_32_L_M_S_PHARAOH: "Восставший Фараон (Обувь)",
  T_32_L_M_T_JUNKFOOD: "Бургер (Верх)",
  T_32_L_M_T_PHARAOH: "Восставший Фараон (Верх)",
  T_32_L_T_WHITESWEATER: "Белая Водолазка",
  T_32_LC_NEWVAULT_EMOTE: "Эмоция",
  T_32_LO_WS_IMMORTAL: "Зона Бессмертия",
  T_32_LO_WS_ITEM60: "Труба",
  T_32_LO_WS_ITEM60_DESC: "Туннель, по которому можно ходить",
  T_32_LO_WS_ITEM61: "Т-образная Труба",
  T_32_LO_WS_ITEM61_DESC: "Т-образный туннель, по которому можно ходить",
  T_32_LO_WS_ITEM62: "Соединение труб",
  T_32_LO_WS_ITEM62_DESC: "Пересечение туннелей",
  T_32_LO_WS_ITEM63: "Труба-уголок",
  T_32_LO_WS_ITEM63_DESC: "Туннель под углом, по которому можно ходить",
  T_32_LO_WS_ITEM64: "Автолавка",
  T_32_LO_WS_ITEM64_DESC: "Зайдёшь перекусить?",
  T_32_LO_WS_ITEM65: "Гриб-навес",
  T_32_LO_WS_ITEM65_DESC: "Огромный гриб, который выдержит человека",
  T_32_LO_WS_ITEM66: "Сушилка",
  T_32_LO_WS_ITEM66_DESC: "Частый элемент дизайна в жилых районах",
  T_32_LO_WS_ITEM67: "Деревянная Доска",
  T_32_LO_WS_ITEM67_DESC: "Можно сделать мостик или гать",
  T_32_LO_WS_ITEM68: "Садовая Решётка",
  T_32_LO_WS_ITEM68_DESC: "Немного восточной атмосферы",
  T_32_LO_WS_ITEM69: "Свая",
  T_32_LO_WS_ITEM69_DESC: "На любой стройке таких полно",
  T_32_LO_WS_ITEM70: "Кактус",
  T_32_LO_WS_ITEM70_DESC: "Не колется, кстати",
  T_32_LO_WS_ITEM71: "Сухое Дерево",
  T_32_LO_WS_ITEM71_DESC: "Давно тут стоит",
  T_32_LO_WS_ITEM72: "Каменный Фонарь",
  T_32_LO_WS_ITEM72_DESC: "Затейливое украшение имперских садов",
  T_32_LO_WS_ITEM73: "Уличный Фонарь",
  T_32_LO_WS_ITEM73_DESC: "Обычный уличный фонарь",
  T_32_LO_WS_ITEM74: "Солнечная Панель",
  T_32_LO_WS_ITEM74_DESC: "Экологичный источник энергии",
  T_32_LO_WS_ITEM75: "Кондиционер А",
  T_32_LO_WS_ITEM75_DESC: "Жарко? Охладись",
  T_32_LO_WS_ITEM76: "Пропеллер",
  T_32_LO_WS_ITEM77: "Летающая Сковорода",
  T_32_LO_WS_ITEM78: "Куб",
  T_32_LO_WS_ITEM79: "Колесо",
  T_32_LO_WS_ITEM80: "Молоток",
  T_32_LO_WS_ITEM81: "Доска",
  T_32_LO_WS_ITEM82: "Мишень",
  T_32_LO_WS_ITEM83: "Гибкая Стена",
  T_32_LO_WS_ITEM84AMMO: "Точка появления Патронов",
  T_32_LO_WS_ITEM84AMMO_DESC: "Здесь будут появляться выбранные типы патронов",
  T_32_LO_WS_ITEM84AR: "Точка появления Брони",
  T_32_LO_WS_ITEM84AR_DESC: "Здесь будут появляться выбранные типы брони",
  T_32_LO_WS_ITEM84ARLV1: "Броня Ур.1",
  T_32_LO_WS_ITEM84ARLV2: "Броня Ур.2",
  T_32_LO_WS_ITEM84ARLV3: "Броня Ур.3",
  T_32_LO_WS_ITEM84CO: "Точка появления Расходников",
  T_32_LO_WS_ITEM84CO_DESC: "Здесь будут появляться выбранные типы расходных материалов",
  T_32_LO_WS_ITEM84JA: "Точка появления Метательных снарядов",
  T_32_LO_WS_ITEM84JA_DESC: "Здесь будут появляться выбранные типы метательных снарядов",
  T_32_LO_WS_ITEM84TE: "Точка появления Прицелов",
  T_32_LO_WS_ITEM84TE_DESC: "Здесь будут появляться выбранные типы Прицелов",
  T_32_LO_WS_ITEM84W: "Точка появления Оружия",
  T_32_LO_WS_ITEM84W_DESC: "Здесь будут появляться выбранные типы оружия",
  T_32_LO_WS_ITEM85: "Опасная/Безопасная Зона",
  T_32_LO_WS_ITEM85_DESC: "Игрок, который входит в зону активатора, испытает особый эффект, получит бессмертие или умрёт. (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_32_LO_WS_ITEM85CP: "Контрольная Точка",
  T_32_LO_WS_ITEM85CP_DESC: "Обязательный предмет в режиме Паркур. Игроки должны по очереди проходить Контрольные Точки. Умирая, игрок может выбрать возрождение на последней пройденной Контрольной Точке.  (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_32_LO_WS_ITEM85TM: "Финишная Точка",
  T_32_LO_WS_ITEM85TM_DESC: "Обязательный предмет в режиме Паркур. Игроки должны оказаться внутри линии финиша, чтобы завершить свой матч (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_32_LO_WS_ITEM86: "Точка Появления",
  T_32_LO_WS_ITEM86_DESC: "Не закреплена за командой. Здесь появится случайная команда. (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_32_LO_WS_ITEM86L: "Общая Точка Появления",
  T_32_LO_WS_ITEM86L_DESC: "Крупная Точка Появления, рекомендована для режима Паркур. На ней появятся все игроки в ряд (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_32_LO_WS_ITEM87: "Блок",
  T_32_LO_WS_ITEM87_DESC: "Можно менять его размер",
  T_32_LO_WS_ITEM88: "Кубоид или наклон",
  T_32_LO_WS_ITEM88_DESC: "Кубоид или наклон, размер которого можно регулировать.",
  T_32_LO_WS_ITEMLINE: "Поменять местами",
  T_32_LO_WS_ITEMMOVE: "Настройки Активатора",
  T_32_LO_WS_ITEMROT: "Изменить",
  T_32_LO_WS_ITEMSCALE: "Изменить размер",
  T_32_LO_WS_KILLZONE: "Гибельная Зона",
  T_32_LO_WS_LOOT_AMMOTYPE: "Патроны",
  T_32_LO_WS_LOOT_ARTYPE: "Броня",
  T_32_LO_WS_LOOT_COTYPE: "Расходники",
  T_32_LO_WS_LOOT_JATYPE: "Метательное",
  T_32_LO_WS_LOOT_RANDOM: "Случайное",
  T_32_LO_WS_LOOT_TETYPE: "Прицел",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Оружие",
  T_32_LO_WS_SCALEX: "Длина",
  T_32_LO_WS_SCALEY: "Высота",
  T_32_LO_WS_SCALEZ: "Ширина",
  T_32_LO_WS_TRIGGERH: "Скрыть",
  T_32_LO_WS_TRIGGERHORP: "Показать / Скрыть Активаторы",
  T_32_LO_WS_TRIGGERP: "Показать",
  T_32_LO_WS_TRIGGERTYPE: "Тип Активатора",
  T_32_M_WS_MODE_ANNIHILATE: "Уничтожение",
  T_32_M_WS_MODE_SCORE: "Набор Очков",
  T_32_M_WS_MODE_SPEED: "Паркур",
  T_32_M_WS_MULTIPLETEAMS: "Множество Команд",
  T_32_M_WS_ROUNDS: "Раунды",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Дискотека",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Опасная Зона",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Урон",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Опасная Зона",
  T_32_T_WS_ME_CUSTOM: "Настроить",
  T_32_T_WS_ME_ENDTYPE1: "Уничтожение",
  T_32_T_WS_ME_ENDTYPE2: "Набор Очков",
  T_32_T_WS_ME_ENDTYPE3: "Паркур",
  T_32_T_WS_ME_ENDTYPEDESC1: "Останьтесь последней выжившей командой",
  T_32_T_WS_ME_ENDTYPEDESC2: `Режим начисления очков, в котором побеждает команда, первой набравшая необходимое количество очков.
Вы можете устанавливать правила игрового процесса и редактировать параметры игрового процесса по своему усмотрению, включая настройку очков, присуждаемых за выбывание.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `Режим паркура, в котором побеждает команда, все участники которой первой достигнут финишной точки.
Вы можете устанавливать правила игрового процесса, а также объекты на дорожках и финишной черте по своему усмотрению.`,
  T_32_T_WS_ME_MATCHTIME: "Время Матча",
  T_32_T_WS_ME_MECHANIC: "Механика",
  T_32_T_WS_ME_NEARCHECKPOINT: "У отметки",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Всего должно быть не более 12 игроков",
  T_32_T_WS_ME_PREGAMETIME: "Время подготовки",
  T_32_T_WS_ME_RESPAWN: "Возрождения",
  T_32_T_WS_ME_RESPAWNSETTING: "Возрождения",
  T_32_T_WS_ME_ROUNDNUM: "Кол-во раундов",
  T_32_T_WS_ME_ROUNDOPEN: "Разрешить разные раунды",
  T_32_T_WS_ME_ROUNDRESET: "Обнулять всё в новом раунде",
  T_32_T_WS_ME_ROUNDSETTING: "Раунды",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Длительность Сужения Зоны",
  T_32_T_WS_ME_SCORESETTING: "Счёт",
  T_32_T_WS_ME_TEAMMATENUM: "Игроков в команде",
  T_32_T_WS_ME_TEAMNUM: "Кол-во команд",
  T_32_T_WS_ME_TEAMSETTING: "Команда",
  T_32_U_ATTACHMENT_8: "Навесной Карман",
  "T_32_U_GOLD_FAMAS-I": "FAMAS-I",
  "T_32_U_GOLD_FAMAS-II": "FAMAS-II",
  "T_32_U_GOLD_FAMAS-III": "FAMAS-III",
  T_32_U_GOLD_HEATGUN_I: "ПЛАЗМА-I",
  T_32_U_GOLD_HEATGUN_II: "ПЛАЗМА-II",
  T_32_U_GOLD_HEATGUN_III: "ПЛАЗМА-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Чип Улучшения",
  T_32_WT_WS_BARRIER: "Препятствия",
  T_32_WT_WS_BDS: "Постройки",
  T_32_WT_WS_MMINVALIDERROR: "Неверный код карты",
  T_32_WT_WS_TRGS: "Активаторы",
  T_32_YF_CHARGESHOT_N: "Кинетический Дробовик",
  T_32_YF_GOLD_GROZA_N: "ГРОЗА-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "СВД-Y",
  T_32_YS_WEAPON_TAG_18: "Дополн. урон",
  T_32_YS_WEAPON_TAG_3: "Скорострельность",
  T_32_YS_WEAPON_TAG_36: "Пробитие Брони",
  T_32_YS_WEAPON_TAG_39: "Стрельба с Двух Рук",
  T_32_YS_WEAPON_TAG_42: "Ледяная Стена",
  T_33_C_SKILL_DESC_GRAFFITIST: "Создаёт площадь [FFB300]{0}м[-], в которой не действуют метательные снаряды. Союзники в радиусе действия восстанавливают [FFB300]{1}%[-] прочности брони каждую секунду, а урон от пуль уменьшается на [FFB300]{2}%[-]. Длит. [FFB300]{3}с[-]. Эффекты не складываются. Восст. [FFB300]{4}с[-].",
  T_33_C_SKILL_DESC_HITMAN: "При стрельбе из снайперок и винтовок звук выстрела заглушён. Противники, отправленные в нокдаун, теряют здоровье быстрее на [FFB300]{0}%[-]",
  T_33_C_SKILL_DESC_KENTA: "Создаёт щит шириной [FFB300]{0}м[-], уменьшающий урон от оружия спереди на [FFB300]{1}%[-]. Длит. [FFB300]{3}с[-]. При стрельбе, уменьшает урон на [FFB300]{2}%[-]. Восст. [FFB300]{4}с[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Выпускает электромагнитную волну диаметром [FFB300]{0}м[-], которая препятствует активации навыков врага, наносит [FFB300]{3} урона[-] и прерывает время взаимодействия с предметом. Длит. [FFB300]{1}сек[-]. Восст: [FFB300]{2}с[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Оружейный Эксперт",
  T_33_C_SKILL_NAME_KENTA: "Гнев Мечника",
  T_33_C_SKILL_NAME_MADEMANA: "Жажда Жизни",
  T_33_DY_AXOLOTL_N: "Аксель",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Скин Питомца: Фруктовый Аксель",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Скин Питомца: Кряккер на FFWS",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Скин Питомца: Сокол в Цветах",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Свежий Хлебушек",
  T_33_HQ_EMOTE_SONGKRAN_N: "Выходи Танцевать",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 Циан Ультра",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Граната Циан Ультра",
  T_33_HQ_M14_SPIDERLILY_N: "M14 Горящая Лилия",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 Утраченный Секрет",
  T_33_HQ_MP40_FFWS03_N: "MP40 Безмятежный Воин",
  T_33_HQ_SCAR_FFWS03_N: "SCAR Безмятежный Воин",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Изумрудная Коса",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Клинок Безмятежного Воина",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Вектор Циан Ультра",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Изумрудный Джип",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Монстр Трак Резкий Ожог",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Пикап Безмятежная Защитница",
  T_33_LO_WS_BHPARA_A: "Атака",
  T_33_LO_WS_BHPARA_ATKMODE: "Тип атаки",
  T_33_LO_WS_BHPARA_GROUP: "Команда",
  T_33_LO_WS_BHPARA_NA: "Без атаки",
  T_33_LO_WS_BHPARA_P: "Пассивная",
  T_33_LO_WS_DICE_DESC: "Кубик для более крутых прыжков. Можно использовать в разных сценариях",
  T_33_LO_WS_DICEVXZ: "Горизонтальная Скорость",
  T_33_LO_WS_DICEVY: "Вертикальная Скорость",
  T_33_LO_WS_DTOWER: "Башня",
  T_33_LO_WS_DTOWER_DESC: "Автоматически атакует врагов на определённом расстоянии от защитного сооружения. Если Здоровье достигает 0, разрушается (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_33_LO_WS_FORT: "Крепость",
  T_33_LO_WS_FORT_DESC: "Автоматически атакует врагов на определённом расстоянии от сооружения. Если Здоровье достигает 0, разрушается (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_33_LO_WS_ITEM89: "Резервуар",
  T_33_LO_WS_ITEM89_DESC: "Бак для хранения воды",
  T_33_LO_WS_ITEM90: "Собачья будка",
  T_33_LO_WS_ITEM90_DESC: "Домик для пёселей",
  T_33_LO_WS_ITEM91: "Остановка",
  T_33_LO_WS_ITEM91_DESC: "Обычная автобусная остановка",
  T_33_LO_WS_ITEM92: "Стена с Граффити",
  T_33_LO_WS_ITEM92_DESC: "Сколько тут краски потрачено...",
  T_33_LO_WS_ITEM93: "Конюшня",
  T_33_LO_WS_ITEM93_DESC: "Простая постройка из соломы",
  T_33_LO_WS_ITEM94: "Скамейка",
  T_33_LO_WS_ITEM94_DESC: "Как обычно в парке",
  T_33_LO_WS_ITEM95: "Каменный Мост",
  T_33_LO_WS_ITEM95_DESC: "Мост, построенный из камня",
  T_33_LO_WS_ITEM96: "Навес от солнца",
  T_33_LO_WS_ITEM96_DESC: "Защищает хотя бы от солнечных ожогов",
  T_33_LO_WS_ITEM97: "Финишная Арка",
  T_33_LO_WS_ITEM97_DESC: "Отмечает линию финиша",
  T_33_LO_WS_ITEM98: "Рекламный Щит",
  T_33_LO_WS_ITEM98_DESC: "Обычный щит для рекламы",
  T_33_LO_WS_PARA_DM: "Урон",
  T_33_LO_WS_PARA_HP: "ХП",
  T_33_LO_WS_PARA_RANGE: "Расстояние сканирования врагов",
  T_33_LO_WS_PARA_SP: "Скорость",
  T_33_LO_WS_ZBPARA_AMOUNT: "Сколько зомби в волне",
  T_33_LO_WS_ZBPARA_INTERVAL: "Интервал между волнами (с)",
  T_33_LO_WS_ZBPARA_ROUND: "Количество волн",
  T_33_LO_WS_ZBSPAWNER: "Точка Выхода Зомби",
  T_33_LO_WS_ZBSPAWNER_DESC: "На ней автоматически появляются зомби. Их поведение можно настраивать с помощью выпадающего меню (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Кента",
  T_33_PD_ZOMBIE_LEVELUP: "Прокачаться",
  T_33_RW_SKILL_DESC_GANGGIRL: "Скорострельность увеличена на [FFB300]{0}%[-]. Если игрок попадает во врага, максимум [FFB300]{1}%[-] показателя скорострельности переводится в скорость передвижения. Навык обнуляется, когда игрок выживает после схватки",
  T_33_RW_SKILL_NAME_GANGGIRL: "Бей или Беги",
  T_33_WT_WS_BASICSET1: "Основное",
  T_33_WT_WS_QCEPRTIP: "Переводи Энергию в Здоровье быстрее",
  T_33_WT_WS_SKILLSET_TAG: "Бесконечный Навык",
  T_33_WT_WS_SKILLSET1: "Настройки Навыков",
  T_33_WT_WS_SKILLSET10: "Повелитель Времени (Кронос)",
  T_33_WT_WS_SKILLSET11: "Бешеный ритм (Скайлер)",
  T_33_WT_WS_SKILLSET12: "Адреналин (Ксандра)",
  T_33_WT_WS_SKILLSET13: "Сердечный Ритм (Димитрий)",
  T_33_WT_WS_SKILLSET2: "Пассивные Навыки",
  T_33_WT_WS_SKILLSET2_TIP: "Вкл/выкл Пассивные Навыки",
  T_33_WT_WS_SKILLSET3: "Активные Навыки (включи, чтобы настроить время восстановления ниже)",
  T_33_WT_WS_SKILLSET3_TIP: "Вкл/выкл Активные Навыки. При включении можно настроить время восстановления ниже",
  T_33_WT_WS_SKILLSET4: "Иллюзия (Вуконг)",
  T_33_WT_WS_SKILLSET5: "Жажда Жизни (А124)",
  T_33_WT_WS_SKILLSET6: "Лови Ритм (Алок)",
  T_33_WT_WS_SKILLSET7: "Яркое Убежище (Стеффи)",
  T_33_WT_WS_SKILLSET8: "Выслеживание (Эврика)",
  T_33_WT_WS_SKILLSET9: "Энергия Вселенной (Камиль)",
  T_33_WT_WS_UNIT_HPSECOND: "ХП/с",
  T_33_WT_WS_UNIT_METER: "м",
  T_33_WT_WS_UNIT_SECOND: "сек.",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Ливень (Низ)",
  T_33_YS_H_ONIGIRI: "Онигири",
  T_33_YS_H_RAINCOAT: "Ливень (Голова)",
  T_33_YS_HA_CRYINGFACE: "Плач (Грим)",
  T_33_YS_M_H_FROGKING: "Кепка Король Лягушек",
  T_33_YS_S_RAINCOAT: "Ливень (Обувь)",
  T_33_YS_T_BLACKHOLE: "Худи Эффект Доплера",
  T_33_YS_T_RAINCOAT: "Ливень (Верх)",
  T_33_YS_T_SOCCER_GREEN: "Электризованный Пас (Верх)",
  T_33_YS_T_SOCCER_YELLOW: "Энергичный Пас (Верх)",
  T_33_YS_T_WIFI: "Футболка Wi-Fi",
  T_34_C_SKILL_DESC_STREAMERGUY: "Каждое устранение или наблюдение дает один заряд эффекта. Каждый заряд уменьшает урон от хэдшотов на [FFB300]{0}%[-] (макс. [FFB300]{1}%[-] в сумме) и увеличивает урон от хэдшотов противникам на [FFB300]{2}%[-] (макс. [FFB300]{3}%[-] в сумме).",
  T_34_C_SKILL_DESC_TRACKER: "Отправляет дрон в сторону ближайшего противника впереди в пределах [FFB300]100м[-]. Создаёт импульсный взрыв радиусом [FFB300]{5}м[-], который уменьшает скорость передвижения на [FFB300]{0}%[-], скорострельность на [FFB300]{1}%[-]. Длит. [FFB300]{3}с[-]. Наносит [FFB300]{2} урона[-]. Восст. [FFB300]{4}с[-].",
  T_34_C_SKILL_NAME_TRACKER: "Сенсорная Перегрузка",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Скин Питомца: Катран-Сёрфер",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Скин Питомца: Глубоководный Катран",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Скин Питомца: Громовой Катран",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Скин Питомца: Цифровой Тиго",
  T_34_DY_SURFSHARK_N: "Катран",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Великий Дирижёр",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Поток Энергии",
  T_34_HQ_EMOTE_RIDICULE_N: "Насмешка",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Пикап Тёмный Изобретатель",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Тук Тук Хаски",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle Гибридный Взрыв",
  T_34_JL_G36_MADBIONIC_N: "G36 Огненная Бионика",
  T_34_JL_GRENADE_BIS_N: "Граната Битый Пиксель",
  T_34_JL_MACHETE_RAMPAGE4_N: "Тёмный Клинок",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Нож-Банан",
  T_34_JL_UMP45_BIS_N: "UMP Фастерский Манёвр",
  T_34_LY_WS_ABS_DESC: "Взять абсолютное значение этого числа",
  T_34_LY_WS_ADD_DESC: "Добавить новый элемент в конец списка",
  T_34_LY_WS_AUTO_A: "Авто-скан",
  T_34_LY_WS_BOT: "Обычный",
  T_34_LY_WS_BOT_PATH: "Путь",
  T_34_LY_WS_BOT_TYPE: "Тип",
  T_34_LY_WS_BOT4: "Рубака",
  T_34_LY_WS_BOT5: "Метатель",
  T_34_LY_WS_BOT6: "Взрывной",
  T_34_LY_WS_BOT8: "Неуязвимый",
  T_34_LY_WS_COL_DESC: "Выбери цвет",
  T_34_LY_WS_DEL_DESC: "Удалить соответствующий элемент под указанным индексом в списке",
  T_34_LY_WS_DF_PER: "Защита, %",
  T_34_LY_WS_FORT_INTERVAL: "Интервал между атаками (с)",
  T_34_LY_WS_GET: "Взять",
  T_34_LY_WS_GET_DESC: "Взять соответствующий элемент под указанным индексом в списке",
  T_34_LY_WS_GLEN_ARR_DESC: "Получить количество элементов в текущем списке",
  T_34_LY_WS_GLEN_DESC: "Взять длину этой строки текста",
  T_34_LY_WS_GVX: "Взять компонент вектора x",
  T_34_LY_WS_GVX_DESC: "Взять первый компонент вектора",
  T_34_LY_WS_GVY: "Взять компонент вектора y",
  T_34_LY_WS_GVY_DESC: "Взять второй компонент вектора",
  T_34_LY_WS_GVZ: "Взять компонент вектора z",
  T_34_LY_WS_GVZ_DESC: "Взять третий компонент вектора",
  T_34_LY_WS_INDEX: "Индекс",
  T_34_LY_WS_JOIN: "Соединить",
  T_34_LY_WS_NEG_DESC: "Взять отрицательное значение этого числа",
  T_34_LY_WS_PATH: "Курс",
  T_34_LY_WS_PATH_DESC: "Для создания / удаления пути особых живых объектов (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_34_LY_WS_POINT: "Маркер",
  T_34_LY_WS_POINT_DESC: "Отмечай локацию на текущей позиции (Недоступно в режимах Битва Отрядов, Командный Бой Насмерть и Спортплощадка)",
  T_34_LY_WS_RANGE_F: "Далеко",
  T_34_LY_WS_RANGE_M: "Средне",
  T_34_LY_WS_RANGE_N: "Рядом",
  T_34_LY_WS_RNDF_DESC: "Сгенерировать случайную десятичную дробь из интервала",
  T_34_LY_WS_RNDI_DESC: "Сгенерировать случайное целое число из интервала",
  T_34_LY_WS_SET: "Назначить",
  T_34_LY_WS_SET_DESC: "Назначить соответствующий элемент под указанным индексом в списке",
  T_34_LY_WS_SQRT_DESC: "Взять квадратный корень из этого числа",
  T_34_LY_WS_STRC_DESC: "Соединить две строки текста",
  T_34_LY_WS_SVX: "Назначить компонент x вектора",
  T_34_LY_WS_SVX_DESC: "Назначить первый компонент вектора",
  T_34_LY_WS_SVY: "Назначить компонент y вектора",
  T_34_LY_WS_SVY_DESC: "Назначить второй компонент вектора",
  T_34_LY_WS_SVZ: "Назначить компонент z вектора",
  T_34_LY_WS_SVZ_DESC: "Назначить третий компонент вектора",
  T_34_LY_WS_VADD: "Добавить вектор",
  T_34_LY_WS_VADD_DESC: "Добавить два вектора",
  T_34_LY_WS_VAL_DESC: "Ввести целое или десятичную дробь согласно сценарию",
  T_34_LY_WS_VANG_DESC: "Рассчитать угол между двумя векторами",
  T_34_LY_WS_VCP: "Векторное произведение",
  T_34_LY_WS_VCP_DESC: "Рассчитать векторное произведение двух векторов",
  T_34_LY_WS_VDIS_DESC: "Рассчитать расстояние между двумя векторами",
  T_34_LY_WS_VDP: "Скалярное произведение",
  T_34_LY_WS_VDP_DESC: "Рассчитать скалярное произведение двух векторов",
  T_34_LY_WS_VFX1: "Сфера",
  T_34_LY_WS_VFX2: "Цилиндр",
  T_34_LY_WS_VFX3: "Кольцо",
  T_34_LY_WS_VFX4: "Бум",
  T_34_LY_WS_VFX5: "Пиксели",
  T_34_LY_WS_VFX6: "Искры",
  T_34_LY_WS_VMOD_DESC: "Рассчитать величину вектора",
  T_34_LY_WS_VMUL: "Умножение векторов",
  T_34_LY_WS_VMUL_DESC: "Перемножить два вектора",
  T_34_LY_WS_VNOR_DESC: "Нормализовать вектор",
  T_34_LY_WS_VSUB: "Вычитание векторов",
  T_34_LY_WS_VSUB_DESC: "Вычесть один вектор из другого",
  T_34_M_WS_ANGLE: "Угол вращения",
  T_34_M_WS_ARRAY: "Список",
  T_34_M_WS_ATT: "Свойство",
  T_34_M_WS_BOOL: "Булево",
  T_34_M_WS_COLORARRAY: "Массив цветов",
  T_34_M_WS_COLOUR: "Цвет",
  T_34_M_WS_CONFRONBANNER: "Фон сражения",
  T_34_M_WS_COORDINATE: "Координаты",
  T_34_M_WS_CUSTOMINF: "Собственный HUD",
  T_34_M_WS_CUSTOMMODEDESC: `Пустой и полностью настраиваемый режим без предустановленного игрового процесса, в котором вы можете создавать и играть по своим собственным правилам.
Немного сложновато для начинающих создателей карт.`,
  T_34_M_WS_DAMAGETYPE: "Тип урона",
  T_34_M_WS_DAMAGETYPEDESC: "Тип урона, установленный сейчас системой",
  T_34_M_WS_DESCTEXT: "Описательный текст",
  T_34_M_WS_DURACTION: "Длительность",
  T_34_M_WS_ECAMODE: "Режим Тонкой Настройки",
  T_34_M_WS_ENDPHASEDESC: "Немедленно закончить текущий этап и перейти к следующему",
  T_34_M_WS_ENTITY: "Сущность",
  T_34_M_WS_FLOAT: "Десятичная дробь",
  T_34_M_WS_GAME: "Игра",
  T_34_M_WS_GAMERESULTS: "Результат матча",
  T_34_M_WS_GETCONTROL2: "Получить контрольную сущность из интерфейса игрока, чтобы редактировать свойства сущности (в том числе дизайн, цвет, содержимое и т.д.)",
  T_34_M_WS_HEIGHT: "Высота",
  T_34_M_WS_HUDBUTTONWIDGET: "Управление кнопками",
  T_34_M_WS_HUDEMPTYWIDGET: "Пустой поворот",
  T_34_M_WS_HUDIMAGEWIDGET: "Управление изображением",
  T_34_M_WS_HUDINPUTWIDGET: "Управление текстовым окном",
  T_34_M_WS_HUDLABELWIDGET: "Управление текстом",
  T_34_M_WS_ICON: "Иконка",
  T_34_M_WS_ICON_AIM: "Прицел",
  T_34_M_WS_ICON_ARROW: "Стрела",
  T_34_M_WS_ICON_BLAST: "Взрыв",
  T_34_M_WS_ICON_CIRCULAR: "Круг",
  T_34_M_WS_ICON_CLOTH: "Ладонь",
  T_34_M_WS_ICON_COLLIMATION: "Перекрестье",
  T_34_M_WS_ICON_CORPSE: "Зомби",
  T_34_M_WS_ICON_CROSS: "Крест",
  T_34_M_WS_ICON_DAY: "Солнце",
  T_34_M_WS_ICON_DEFENSE: "Щит",
  T_34_M_WS_ICON_DIALOGUE: "Диалог",
  T_34_M_WS_ICON_DIAMONDS: "Алмаз",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Восклицательный знак",
  T_34_M_WS_ICON_FLAG: "Флаг",
  T_34_M_WS_ICON_FOLDER: "Папка",
  T_34_M_WS_ICON_GLASSES: "Глаз",
  T_34_M_WS_ICON_GUN: "Пушка",
  T_34_M_WS_ICON_HEART: "Сердце",
  T_34_M_WS_ICON_HEXAGON: "Шестиугольник",
  T_34_M_WS_ICON_HOURGLASS: "Песочные часы",
  T_34_M_WS_ICON_HOUSE: "Дом",
  T_34_M_WS_ICON_KEY: "Ключ",
  T_34_M_WS_ICON_LIGHTNING: "Молния",
  T_34_M_WS_ICON_LOCK: "Замок",
  T_34_M_WS_ICON_LOOP: "Цикл",
  T_34_M_WS_ICON_MAGNIFIER: "Лупа",
  T_34_M_WS_ICON_MONEY: "Деньги",
  T_34_M_WS_ICON_MONTH: "Луна",
  T_34_M_WS_ICON_OPENFOLDER: "Открытая папка",
  T_34_M_WS_ICON_PLUS: "Плюс",
  T_34_M_WS_ICON_QUADRI: "Четырёхугольник",
  T_34_M_WS_ICON_QUESTIONMARK: "Вопросительный знак",
  T_34_M_WS_ICON_RECYCLING: "Переработка",
  T_34_M_WS_ICON_REFRESH: "Обновление",
  T_34_M_WS_ICON_REST: "Отдых",
  T_34_M_WS_ICON_RETURN: "Назад",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Косая трапеция",
  T_34_M_WS_ICON_SCISSORS: "Ножницы",
  T_34_M_WS_ICON_SETUP: "Настройки",
  T_34_M_WS_ICON_SIGN: "Маркер",
  T_34_M_WS_ICON_SIGNOUT: "Выход",
  T_34_M_WS_ICON_SQUARE: "Квадрат",
  T_34_M_WS_ICON_STAR: "Звезда",
  T_34_M_WS_ICON_STONE: "Камень",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Спасательный круг",
  T_34_M_WS_ICON_TAGGING: "Метка",
  T_34_M_WS_ICON_THESWORD: "Меч",
  T_34_M_WS_ICON_TRAPEZOID: "Трапеция",
  T_34_M_WS_ICON_TRASHCAN: "Мусорка",
  T_34_M_WS_ICON_TRIANGLE: "Треугольник",
  T_34_M_WS_ICON_TROPHY: "Кубок",
  T_34_M_WS_ICON_UP: "Палец вверх",
  T_34_M_WS_ICON_WRONG: "Нет",
  T_34_M_WS_ICON_YES: "Да",
  T_34_M_WS_ICONNAME: "Название иконки",
  T_34_M_WS_INT: "Целое",
  T_34_M_WS_KILLZONE: "Гибельная Зона",
  T_34_M_WS_LEFTCOLOR: "Цвет слева",
  T_34_M_WS_LEFTTEAMINDEX: "Индекс команды справа",
  T_34_M_WS_LEFTTEAMSCORE: "Счёт команды справа",
  T_34_M_WS_LOCSWITCH: "Включить перевод",
  T_34_M_WS_MAX: "Максимум",
  T_34_M_WS_MIN: "Минимум",
  T_34_M_WS_NUMBER: "Число",
  T_34_M_WS_OBJECT: "Сущность",
  T_34_M_WS_OPEN: "Вкл",
  T_34_M_WS_OPENSATUS: "Вкл. статус",
  T_34_M_WS_PICTURE: "Графика",
  T_34_M_WS_RANKARRAY: "Массив рангов",
  T_34_M_WS_RESULTS: "Результаты",
  T_34_M_WS_RIGHTCOLOR: "Цвет справа",
  T_34_M_WS_RIGHTTEAMINDEX: "Индекс команды слева",
  T_34_M_WS_RIGHTTEAMSCORE: "Счёт команды справа",
  T_34_M_WS_ROUNDBANNER: "Фон раунда",
  T_34_M_WS_ROUNDDESC: "Описание раунда",
  T_34_M_WS_ROUNDHUD: "Номер раунда",
  T_34_M_WS_ROUNDPARAMS: "Массив номеров раунда",
  T_34_M_WS_SAME_NAME: "Название повторяется. Попробуй другое",
  T_34_M_WS_SCOREARRAY: "Массив счёта",
  T_34_M_WS_SCORINGTYPE: "Тип счёта",
  T_34_M_WS_SCORINGTYPEDECS: "Тип счёта, который может получить игрок. Поддерживает настройку счёта",
  T_34_M_WS_SCUFFLESCORING: "Счёт множества команд",
  T_34_M_WS_SETATTRIBUTES: "Настройки свойств",
  T_34_M_WS_SHUT: "Выкл",
  T_34_M_WS_SOUND: "Звуковые эффекты",
  T_34_M_WS_SOUNDCLICK: "Щелчки",
  T_34_M_WS_SOUNDDD: "Обратный отсчёт",
  T_34_M_WS_SOUNDFEMALEA: "Ранен (Жен. голос)",
  T_34_M_WS_SOUNDM: "Стрельба",
  T_34_M_WS_SOUNDMALEA: "Ранен (Муж. голос)",
  T_34_M_WS_SOUNDUAV: "Взрыв",
  T_34_M_WS_ST_ASSISTCOUNT: "Помощь",
  T_34_M_WS_ST_CHECKPROGRESS: "Прогресс по контрольным точкам",
  T_34_M_WS_ST_DAMAGESUM: "Урон",
  T_34_M_WS_ST_FINISHCOUNT: "Количество достигнутых целей",
  T_34_M_WS_ST_FINISHORDER: "Порядок достижения целей",
  T_34_M_WS_ST_FINISHTIME: "Время достижения цели",
  T_34_M_WS_ST_KILLCOUNT: "Киллы",
  T_34_M_WS_ST_MAINSCORE: "Целевой счёт",
  T_34_M_WS_ST_RANKSCORE: "Счёт ранга",
  T_34_M_WS_ST_SURVIVALDURACTION: "Время выживания",
  T_34_M_WS_ST_UNKOWN: "Неизвестно",
  T_34_M_WS_STARTBANNER: "Стартовый фон",
  T_34_M_WS_STARTTIME: "Время старта",
  T_34_M_WS_STRING: "Текст",
  T_34_M_WS_STUDIO: "СТУДИЯ",
  T_34_M_WS_TEAMARRAY: "Массив команд",
  T_34_M_WS_TEXTCONTENT: "Содержимое",
  T_34_M_WS_THEMECOLOR: "Цвет темы",
  T_34_M_WS_TIME: "Обратный отсчёт",
  T_34_M_WS_TITLETEXT: "Заголовок текста",
  T_34_M_WS_TYPE: "Тип",
  T_34_M_WS_UODATETYPE: "Обновить тип",
  T_34_M_WS_VARNAME: "Название переменной",
  T_34_M_WS_VECTOR: "Вектор",
  T_34_M_WS_VFX: "Визуальные эффекты",
  T_34_M_WS_WIDTH: "Ширина",
  T_34_MF_CHARACTER_TRACKER_N: "Гомер",
  T_34_PD_FlagBattle_HYPE_1: "Огонь",
  T_34_SP_WS_BLOCK1_NAME: "Переключение этапа",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Переключение этапа матча на желаемый этап (или раунд). У раундов также есть индексы этапа, и они являются особым типом этапа",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "Индекс указанного этапа",
  T_34_SP_WS_BLOCK10_NAME: "Создать визуальные эффекты",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Создать иконку с помощью указанных визуальных эффектов. Свойства визуального эффекта можно настроить, поменяв свойства сущности визуального эффекта",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Визуальный эффект",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Типы визуальных эффектов, которые можно применить",
  T_34_SP_WS_BLOCK12_NAME: "Удалить визуальные эффекты",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Удалить указанные визуальные эффекты",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Сущность визуальных эффектов",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "Сущность визуальных эффектов, которую нужно удалить",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Скомандовать клиенту воспроизвести визуальный эффект",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Список игроков",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Игроки, которые получат сообщение",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Путь к ресурсу",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Путь к ресурсам системы - in:path. Путь к индивидуальным ресурсам - out:path. По умолчанию пустое значение",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Канал RGBA. Каждый канал содержит значение от 0 до 255 в формате int32. Цвет по умолчанию - белый (255,255,255,255)",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Приближение",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Масштаб приближения. По умолчанию 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Положение на экране, выраженное в глобальных координатах. По умолчанию Vector3(0)",
  T_34_SP_WS_BLOCK14_NAME: "Воспроизвести звуковой эффект",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Скомандовать клиенту воспроизвести звуковой эффект",
  T_34_SP_WS_BLOCK15_NAME: "Выходной журнал",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Выводит содержимое в интерфейс журнала",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Включи, чтобы сделать возможным урон игрокам вне Безопасной Зоны",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Центральная точка Безопасной Зоны",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Радиус",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "Радиус Безопасной Зоны",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Обратный отсчёт перед сужением Безопасной Зоны",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "Длительность сужения Безопасной Зоны",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "Сколько урона наносит пребывание вне Безопасной Зоны",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Если Опасная Зона отключена, игроки вне Безопасной Зоны не будут получать урон",
  T_34_SP_WS_BLOCK4_NAMEDESC: "С помощью этой опции можно задержать последующее действие на указанное время",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "Время ожидания, измеряется в миллисекундах",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Задержать последующее действие до следующего кадра (фрейма)",
  T_34_SP_WS_BLOCK6_NAME: "Создать свою версию HUD",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Создание собственной версии HUD",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "Название, которое используется для создания сущности HUD. Локальная переменная, с которой оно связано - это сущность создаваемого HUD",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Игрок",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Сущность конкретного игрока. Видима только этому игроку",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Уникальный индекс HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Создание HUD по умолчанию, который виден только указанным игрокам",
  T_34_SP_WS_BLOCK8_NAMEDESC: "При удалении HUD по умолчанию не будет отображаться в клиенте (скрыт или удалён)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "Сущность HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "Сущность HUD, которую нужно удалить",
  T_34_SP_WS_BLOCK9_NAMEDESC: "При удалении настроенный HUD не будет отображаться в клиенте (скрыт или удалён)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Событие случается, когда начинается матч",
  T_34_T_WS_BLOCK10_NAMEDESC: "Событие случается, когда устранён игрок",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "Устранённый игрок, запускающий событие",
  T_34_T_WS_BLOCK13_NAMEDESC: "Событие случается, когда игрок помогает другому игроку",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "Игрок, которого устранили",
  T_34_T_WS_BLOCK14_NAMEDESC: "Событие случается, когда игрок наносит урон",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "Игрок, получающий урон",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "Тип нанесённого урона",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "Количество нанесённого урона",
  T_34_T_WS_BLOCK15_NAMEDESC: "Событие случается, когда игрок устраняет другого игрока",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "Игрок, которого устранили",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "Тип урона, который привёл к устранению",
  T_34_T_WS_BLOCK16_NAMEDESC: "Событие случается, когда игрок присоединяется к матчу",
  T_34_T_WS_BLOCK17_NAMEDESC: "Событие случается, когда игрока оживляют",
  T_34_T_WS_BLOCK18_NAMEDESC: "Событие случается, когда команда удалена",
  T_34_T_WS_BLOCK19_NAMEDESC: "Событие случается, когда команда добавлена",
  T_34_T_WS_BLOCK2_NAMEDESC: "Событие случается, когда матч заканчивается",
  T_34_T_WS_BLOCK20_NAMEDESC: "Событие случается, когда команда уничтожена",
  T_34_T_WS_BLOCK3_NAMEDESC: "Событие случается в начале каждого раунда",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "Номер раунда начинается с 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Индекс раунда",
  T_34_T_WS_BLOCK4_NAMEDESC: "Событие случается, когда заканчивается каждый раунд",
  T_34_T_WS_BLOCK5_NAMEDESC: "Событие случается, когда начинается этап",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "Номер этапа начинается с 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Сущность этапа",
  T_34_T_WS_BLOCK6_NAMEDESC: "Событие случается, когда заканчивается этап",
  T_34_T_WS_BLOCK7_NAMEDESC: "Событие случается, когда игрок выходит из матча",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "Игрок, запускающий событие",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Игрок-инициатор",
  T_34_T_WS_BLOCK8_NAMEDESC: "Событие случается, когда счёт игрока изменяется",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "Тип изменённого счёта",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "Значение счёта после изменения",
  T_34_T_WS_BLOCK9_NAMEDESC: "Событие случается, когда счёт команды изменяется",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "Команда, запускающая событие",
  T_34_WT_WS_BORNENTITY_PARAM1: "Точка Появления",
  T_34_WT_WS_BORNENTITY_PARAM2: "Доступные координаты",
  T_34_WT_WS_BORNENTITY_PARAM3: "Назначить точкой появления по умолчанию",
  T_34_WT_WS_BORNENTITY_PARAM4: "Светящиеся границы",
  T_34_WT_WS_BORNENTITY_PARAM5: "Используется или нет",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Управление контрольными точками",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Статус открытия",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Активатор Статуса",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Активатор Устранения или нет",
  T_34_WT_WS_ENTITY_PARAM1: "Игровая сущность",
  T_34_WT_WS_ENTITY_PARAM10: "Сколько команд",
  T_34_WT_WS_ENTITY_PARAM11: "Сколько членов команды",
  T_34_WT_WS_ENTITY_PARAM12: "Снаряжение обнуляется каждый раунд",
  T_34_WT_WS_ENTITY_PARAM13: "Включить урон вне зоны",
  T_34_WT_WS_ENTITY_PARAM14: "Размер зоны",
  T_34_WT_WS_ENTITY_PARAM15: "Время начала сужения зоны",
  T_34_WT_WS_ENTITY_PARAM16: "Продолжительность сужения зоны",
  T_34_WT_WS_ENTITY_PARAM17: "Урон вне зоны",
  T_34_WT_WS_ENTITY_PARAM18: "Целевой счёт",
  T_34_WT_WS_ENTITY_PARAM19: "Счёт устранения",
  T_34_WT_WS_ENTITY_PARAM2: "Некорректный статус",
  T_34_WT_WS_ENTITY_PARAM20: "Тип оживления",
  T_34_WT_WS_ENTITY_PARAM21: "Критерии ранжирования счёта в раунде (игрок)",
  T_34_WT_WS_ENTITY_PARAM22: "Важность критерия (игрок)",
  T_34_WT_WS_ENTITY_PARAM23: "Критерии ранжирования счёта в раунде (команда)",
  T_34_WT_WS_ENTITY_PARAM24: "Важность критерия (команда)",
  T_34_WT_WS_ENTITY_PARAM25: "Ранжирование счёта в раунде (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Важность критерия (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Ранжирование по счёту в раунде",
  T_34_WT_WS_ENTITY_PARAM28: "Показывать критерии на странице результатов",
  T_34_WT_WS_ENTITY_PARAM29: "Сколько всего раундов",
  T_34_WT_WS_ENTITY_PARAM3: "Время игры",
  T_34_WT_WS_ENTITY_PARAM4: "Индекс текущего раунда",
  T_34_WT_WS_ENTITY_PARAM5: "Индекс текущего этапа",
  T_34_WT_WS_ENTITY_PARAM6: "ID шаблона режима",
  T_34_WT_WS_ENTITY_PARAM7: "Вкл. оживление игроков",
  T_34_WT_WS_ENTITY_PARAM8: "Вкл. оживление ботов",
  T_34_WT_WS_ENTITY_PARAM9: "Время оживления",
  T_34_WT_WS_ENTITY1_NAME: "Текущая сущность",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Возврат к текущей сущности",
  T_34_WT_WS_ENTITY10_NAME: "Убрать иконку",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Убрать указанную иконку",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Выбери иконку, которую хочешь убрать",
  T_34_WT_WS_ENTITY11_NAME: "Убрать текст",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Убрать текстовую сущность",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Выбери текст, который хочешь убрать",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Добавить предмет указанным игрокам",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Игрок(-и), который(-е) получат предмет",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "ID конкретного предмета, который будет выдан",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Сколько предметов выдать",
  T_34_WT_WS_ENTITY12_PARAM3: "Количество",
  T_34_WT_WS_ENTITY13_PARAM1: "Тип",
  T_34_WT_WS_ENTITY13_PARAM2: "Место",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Координаты места, где появится объект",
  T_34_WT_WS_ENTITY13_PARAM4: "Объект",
  T_34_WT_WS_ENTITY14_NAME: "Убрать объект",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Убрать указанный объект",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Удалить объект",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Получить все сущности игроков",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Получить все сущности команд",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Восполнить указанный объём Здоровья для указанных игроков. Если объём Здоровья для восполнения превышает максимум ХП, Здоровье будет восполнено до максимума",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Игрок(-и), для которых настраивается колебание Здоровья",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "Указанное количество Здоровья, которое будет восстановлено",
  T_34_WT_WS_ENTITY18_NAME: "Взять координаты случайного появления",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Настроить локацию, в которой будут появляться и куда будут возвращаться указанные игроки",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Игрок(-и), который(-е) будут случайно появляться из этой локации",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Координаты места, в которое будет назначен игрок",
  T_34_WT_WS_ENTITY19_NAME: "Взять счёт игрока",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Получить определённый счёт указанных игроков",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Получить сущность счёта указанного(-ых) игрока(-ов)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Получить тип счёта",
  T_34_WT_WS_ENTITY19_RETURNDESC: "Определённое значение счёта, которое нужно получить",
  T_34_WT_WS_ENTITY2_NAME: "Настроить свойства",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Задать значение свойств, когда тип свойства уже выбран",
  T_34_WT_WS_ENTITY2_PARAM1: "Сущность",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "Значение свойства игровой сущности",
  T_34_WT_WS_ENTITY2_PARAM3: "Свойство",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Конкретное свойство игровой сущности",
  T_34_WT_WS_ENTITY2_PARAM4: "Значение",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "Конкретное значение свойства. Тип свойства должен подходить к уже выбранным и совпадать с типом, настроенным в связанных блоках",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Настроить определённый счёт указанных игроков",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Настроить сущность счёта для этого(-их) игрока(-ов)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Настроить тип счёта",
  T_34_WT_WS_ENTITY20_PARAM3: "Счёт",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "Установка конкретного значения счёта",
  T_34_WT_WS_ENTITY21_NAME: "Взять общий счёт команды",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Получить определённый тип общего счёта указанных команд",
  T_34_WT_WS_ENTITY21_PARAM1: "Команда",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Взять сущность счёта этой(-их) команд(-ы)",
  T_34_WT_WS_ENTITY22_NAME: "Настроить счёт команды в текущем раунде",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Настроить определённый тип счёта в текущем раунде для указанных команд",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Настроить счёт(-а) этой(-их) команд(-ы)",
  T_34_WT_WS_ENTITY23_NAME: "Взять счёт игрока в этом раунде",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Получить определённый счёт указанных игроков в определённом раунде",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Получить счёт(-а) этого игрока(-ов)",
  T_34_WT_WS_ENTITY23_PARAM2: "Раунд",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Взять счёт в этом раунде",
  T_34_WT_WS_ENTITY24_NAME: "Взять счёт команды в раунде",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Получить определённый счёт указанных команд в определённом раунде",
  T_34_WT_WS_ENTITY25_NAME: "Телепорт",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Телепортировать указанных игроков в назначенную локацию",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Игрок(-и), которому(-ым) назначен телепорт",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Координаты, на которые телепорт переносит игрока(-ов)",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Разрешить указанным игрокам наносить урон по указанным целям. Если атакующие игроки не заданы, указанные цели будут получать урон от системы",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Сущности, которые будут получать урон",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Количество наносимого урона",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Оживление назначенных игроков",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Сущности игроков, которых можно оживить",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Настроить тип блока",
  T_34_WT_WS_ENTITY3_PARAM1: "как",
  T_34_WT_WS_ENTITY4_NAME: "Взять свойство",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Взять конкретное свойство сущности",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Получить определённую игровую сущность со значением свойства",
  T_34_WT_WS_ENTITY4_RETURNDESC: "Определённое значение свойства, которое нужно получить",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Настроить возможность передвижения для всех игроков",
  T_34_WT_WS_ENTITY6_NAME: "Создать иконку",
  T_34_WT_WS_ENTITY6_PARAM1: "Иконка",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "Картинка, которая показывается в HUD. Можно выбрать из нескольких видов",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Выбери иконку, на которой будет применён дизайн",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Создать иконку в HUD для указанных игроков. Если ни одна сущность игрока не выбрана, HUD будет создан для всех игроков",
  T_34_WT_WS_ENTITY7_PARAM1: "Игрок",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Создать иконку в HUD для выбранного(-ых) игрока(-ов)",
  T_34_WT_WS_ENTITY8_NAME: "Создать текст",
  T_34_WT_WS_ENTITY8_PARAM1: "Текст",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "Конкретный текст, который создаётся с помощью этой команды",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Текстовая сущность, которая сейчас создаётся",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Добавить строку текста в HUD для указанных игроков. Если ни одна сущность игрока не выбрана, текст в HUD будет создан для всех игроков",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Добавить текст в HUD для выбранного(-ых) игрока(-ов)",
  T_34_WT_WS_ICONENTITY_PARAM1: "Сущность иконки",
  T_34_WT_WS_ICONENTITY_PARAM2: "Дизайн",
  T_34_WT_WS_ICONENTITY_PARAM3: "Цвет",
  T_34_WT_WS_ICONENTITY_PARAM4: "Масштаб",
  T_34_WT_WS_ICONENTITY_PARAM5: "Положение на экране",
  T_34_WT_WS_ICONENTITY_PARAM6: "Следовать за целью",
  T_34_WT_WS_ICONENTITY_PARAM7: "Видно сквозь стены",
  T_34_WT_WS_ICONENTITY_PARAM8: "Всегда показывать",
  T_34_WT_WS_ONETEAM_TAG: "Одна Команда",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Сущность этапа",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Индекс этапа",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Время начала",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Время окончания",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Длительность",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Сущность игрока",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Точка оживления",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Коэффициент урона",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "3D модель персонажа",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Принадлежность",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "Текущее Здоровье",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Максимум Здоровья",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "ИИ",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Статус игрока",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Время Выживания",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Неуязвимость",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Команда",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ID целевой контрольной точки",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Точка Появления",
  T_34_WT_WS_PROCIRCLE_ICON: "Иконка",
  T_34_WT_WS_PVEDESC1: "Если хотя бы один игрок достигнет финиша, прежде чем закончится время, команда победит. Если одновременно устранены все игроки, игра заканчивается",
  T_34_WT_WS_PVEDESC2: "Чтобы победить, оставайся в живых в течение определённого времени. Если одновременно устранены все игроки, игра заканчивается",
  T_34_WT_WS_PVENAME1: "Гонка",
  T_34_WT_WS_PVENAME2: "Выносливость",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "ID текущей контрольной точки",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Номер контрольной точки в паркуре",
  T_34_WT_WS_SKILLSET14: "Гнев Мечника (Кента)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Сущность команды",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Отряд уничтожен",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Все члены",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Обычный Активатор",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Типа внешности",
  T_34_WT_WS_TXTENTITY_PARAM1: "Текстовая сущность",
  T_34_WT_WS_TXTENTITY_PARAM2: "Содержимое",
  T_34_WT_WS_VFXENTITY_PARAM1: "Сущность визуальных эффектов",
  T_34_WZ_WS_LOGIC10_NAME: "К следующему",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Пропустить текущую итерацию цикла и выполнить следующую",
  T_34_WZ_WS_LOGIC11_NAME: "Return",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Прекращает текущий процесс и возвращается в основную программу. Позволяет обратную отправку данных при возвращении",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Return value",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Данные, которые отправляются в главную программу",
  T_34_WZ_WS_LOGIC2_NAME: "Сравнить",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Сравнить 2 значения с помощью указанного оператора",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Левое значение",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "Значение слева, используемое в сравнении",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Функция сравнения",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Выбери, как сравнивать значения. Поддерживаемые операторы:  >, ≥, ==, ≠, ≤, &lt, AND (только булев), OR (только булев)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Правое значение",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "Значение справа, используемое в сравнении",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Результат сравнения",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Даёт обратное логическое значение",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "Значение, на котором нужно использовать оператор NOT",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Результат операции NOT",
  T_34_WZ_WS_LOGIC4_NAME: "Проверить пустое",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Проверить, является ли сущность пустой/null",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Сущность",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "Сущность, у которой проверяется, пустое ли значение",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Пустая ли сущность",
  T_34_WZ_WS_LOGIC5_NAME: "если",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Запускаются, если выполнены определённые условия. Подпроцессы те же, что и последующие логические ветви",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Значение (Value)",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "Количество условий и количество подпроцессов (логических ветвей) должно быть одинаковым",
  T_34_WZ_WS_LOGIC6_NAME: "Цикл диапазона целого",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Цикл от x до y по шагу z. Подпроцесс - это сам цикл",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "Название индекса цикла, который можно использовать для извлечения значения индекса цикла локальной переменной",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Начальное значение",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "Значение, с которого начинается цикл",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Конечное значение",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "Значение, на котором заканчивается цикл",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Шаг",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "Шаг каждого цикла. Когда начальное значение меньше, чем конечное значение, шаг должен быть больше 0. Когда стартовое значение больше, чем конечное значение, шаг должен быть меньше 0",
  T_34_WZ_WS_LOGIC7_NAME: "Зациклить каждый элемент",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Позволяет обход контейнера данных для извлечения каждого подэлемента. Подпроцесс - сам цикл",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Элемент",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Переход к этому названию извлечёт значение подэлемента локальной переменной",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Контейнер данных",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "Контейнер данных для перехода. Поддерживает типы списков",
  T_34_WZ_WS_LOGIC8_NAME: "Условный цикл",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Условный цикл повторяется до выполнения условия. Цикл прекращается, когда условие становится Ложным (False)",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Условие",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Повторяет цикл до тех пор, пока условие является Истинным (True). Прекращает цикл, когда становится Ложным (False)",
  T_34_WZ_WS_LOGIC9_NAME: "Прерывание цикла",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Останавливает текущий процесс цикла и выходит из цикла",
  T_34_Y_B_DINOSAURS: "Иллюзия Дино (Низ)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Невинный Ангел (Ж)",
  T_34_YS_F_B_PANDACATTLE: "Уютная Пижамка (Низ)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Бушующая Гроза (Низ)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Бушующая Гроза (Голова)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Бушующая Гроза (Грим)",
  T_34_YS_F_S_PANDACATTLE: "Уютная Пижамка (Обувь)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Бушующая Гроза (Обувь)",
  T_34_YS_F_T_PANDACATTLE: "Уютная Пижамка (Верх)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Бушующая Гроза (Верх)",
  T_34_YS_M_B_ANGEL_BW: "Невинный Ангел (М)",
  T_34_YS_M_B_PANDACATTLE: "Панда Дома (Низ)",
  T_34_YS_M_H_PANDACATTLE: "Панда Дома (Голова)",
  T_34_YS_M_S_PANDACATTLE: "Панда Дома (Обувь)",
  T_34_YS_M_T_PANDACATTLE: "Панда Дома (Верх)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "Донна А",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Получи  [FFB300]{0} Энергии[-], отправив противника в нокдаун",
  T_35_DY_PET_OWL_N: "Соверен",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Скин Питомца: Космический Марси",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Скин Питомца: Клубный Аксель",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Скин Питомца: Орёл-талисман",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Скин Питомца: Соверен-Феникс",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Скин Питомца: Соверен в Ночи",
  T_35_DY_PETSKIN_OWL_STORM_N: "Скин Питомца: Морозный Соверен",
  T_35_JL_KNOCKEDDOWN: "в нокдауне",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "В течение [FFB300]{1}с[-] успешный выстрел в Стену отмечает противников в радиусе [FFB300]{3}м[-] от неё, и пробивает Стену с возможностью нанести этим противникам урон (урон будет ниже обычного). Работает максимум на [FFB300]{0}[-] Стен(ы). Восст. [FFB300]{2}с[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Стеклянные Стены",
  T_35_KY_INFECTION_MAPNAME: "Пустошь",
  T_35_M_WS_BUTTONCLICKDESC: "Запускает этот инцидент при нажатии соответствующей кнопки. Игрока-триггера можно получить с помощью параметров.",
  T_35_M_WS_GETTEAMMATEPOS: "Получить местоположение союзников поблизости",
  T_35_M_WS_ROUND2: "Текущая волна",
  T_35_PD_Infection_HUMANSELECT: "Выбери оружие",
  T_35_PD_INFECTION_MODENAME: "Робогеддон",
  T_35_QX_WS_ICONTYPE_ITEM: "Объект",
  T_35_QX_WS_ICONTYPE_NATURE: "Природные Формы",
  T_35_QX_WS_ICONTYPE_SHAPE: "Геометрический",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Символ",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Оружие",
  T_35_R_EMOTE_TAG_MUSIC_N: "Музыка",
  T_35_RW_SKILL_DESC_Singers: "Пользователь навыка и союзники в радиусе [FFB300]{0}м[-] могут блокировать [FFB300]{1}%[-] урона с помощью Энергии. В этом случае количество Энергии, снятое у союзников, добавится к Энергии пользователя",
  T_35_RW_SKILL_NAME_Singers: "Защита Души",
  T_35_SP_WS_COMMENTKEY_01: "Подходящая сложность",
  T_35_SP_WS_COMMENTKEY_02: "Креативная",
  T_35_SP_WS_COMMENTKEY_03: "Интересный игровой процесс",
  T_35_SP_WS_COMMENTKEY_04: "Можно играть несколько раз",
  T_35_SP_WS_COMMENTKEY_05: "Интересный сюжет",
  T_35_SP_WS_COMMENTKEY_06: "Хорошо сбалансирована",
  T_35_SP_WS_COMMENTKEY_07: "Приятный опыт",
  T_35_SP_WS_COMMENTKEY_08: "Гибкая",
  T_35_SP_WS_COMMENTKEY_09: "Эстетически приятная",
  T_35_SP_WS_COMMENTKEY_10: "Слишком сложная",
  T_35_SP_WS_COMMENTKEY_11: "Слишком простая",
  T_35_SP_WS_COMMENTKEY_12: "Скучная",
  T_35_SP_WS_COMMENTKEY_13: "Слишком долгая",
  T_35_SP_WS_COMMENTKEY_14: "Несбалансированная",
  T_35_SP_WS_COMMENTKEY_15: "Неприятный опыт",
  T_35_SP_WS_IMAGE03: "Текстура",
  T_35_SP_WS_IMAGE04: "Рамка",
  T_35_SY_CHARGESHOT_TEARS_N: "Кинетический Дробовик - Блеск Лавы",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Граната Кристальное Сияние",
  T_35_SY_GRENADE_PIRATES_N: "Граната Морской Волк",
  T_35_SY_GRENADE_RIDERS_N: "Граната Экстремальный Заезд",
  T_35_SY_M24_KUN_N: "M24 Речной Поток",
  T_35_SY_SCAR_PARKOUR_N: "SCAR Беспечный Трейсер",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Джип Монохроный Паззл",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Празднуем!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Байк Симметрия Кристалла",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Сооружения и Декор",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Сооружения",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Прочее",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Строения",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Большие Дома",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Средние Дома",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Игровые Объекты",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Главное в Режиме",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Музыка",
  T_35_WT_WS_PVEMODE_TAG: "Режим Выживания",
  T_35_WZY_WS_BECRE_NAMEDESC: "Активируется, когда указанная сущность создана",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Активируется, когда сущность устранена. Источник атаки можно определить с помощью команды "Активирующая сущность", тип атаки можно определить с помощью команды "Тип Урона"',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "Сущность, которая активирует событие",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Создай тип или набор предметов в указанной локации. При создании одного типа предмета количество будет его номером. При создании набора предметов количество будет количественным списком, соответствующим списку предметов. Создаваемые предметы зависят от предметов на карте",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Список, содержащий все предметы, которые будут созданы. В нём также может быть 1 предмет",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Количественный список, соответствующий списку предметов. В нём может быть только 1 тип предметов",
  T_35_WZY_WS_DAMTYPE_CAR: "Транспорт",
  T_35_WZY_WS_DAMTYPE_FALL: "Падение",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Огнестрельное",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Граната",
  T_35_WZY_WS_DAMTYPE_MELEE: "Ближний Бой",
  T_35_WZY_WS_DAMTYPE_ZONE: "Вне зоны",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Удалить указанное количество предметов у указанных игроков",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Вход в зону активации",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Активируется, когда "Активирующая сущность" входит в зону активации',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Игрок, который должен получить сущность. После привязки к игроку информация о сущности будет обновляться только для указанного игрока. Если нет привязанного игрока, информацию о сущности будут получать все игроки",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Сущность в бою",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Получить все объекты указанного типа. Возвращаемый результат - список",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Тип объекта",
  T_35_WZY_WS_HUDWIDGET_NAME: "Управление Интерфейсом",
  T_35_WZY_WS_HURT_NAMEDESC: 'Активируется, когда эта сущность получает урон. Источник атаки можно определить с помощью команды "Активирующая сущность"',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Тип предмета",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Объект для Этапа",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Активируется, когда эта сущность устраняет другую сущность. Тип устранённой сущности можно определить с помощью команды "Устранённая сущность"',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "Сущность, которую кто-то устранил",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Активируется, когда сущность наносит урон",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Сущность, наносящая урон",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Целевая сущность",
  T_35_WZY_WS_PREFABID_NAME: "ID Шаблона",
  T_35_WZY_WS_PROPERTY_EPNOW: "Текущая Энергия",
  T_35_WZY_WS_PROPERTY_JUMP: "Высота прыжка",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Выход из зоны активации",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Активируется, когда "Активирующая сущность" покидает зону активации',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Убрать указанный элемент из списка. [Список] - список, в котором находится элемент. [Элемент] - элемент, который нужно убрать",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Значение элемента",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "Значение элемента, который нужно убрать",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Сущность раунда",
  T_35_WZY_WS_TOWER_PARAM1: "Башня и Крепость",
  T_35_WZY_WS_TOWER_PARAM2: "ID Команды",
  T_35_WZY_WS_TOWER_PARAM3: "Текущее Здоровье",
  T_35_WZY_WS_TOWER_PARAM4: "Макс. Здоровье",
  T_35_WZY_WS_TOWER_PARAM5: "Урон",
  T_35_WZY_WS_TOWER_PARAM6: "Интервал Атак",
  T_35_WZY_WS_TOWER_PARAM7: "Дальность Атак",
  T_35_WZY_WS_TOWER_PARAM8: "% Защиты",
  T_35_XYL_PDM_REVENGE: "Отмщение!",
  T_35_XYL_WS_BISPARTERRE: "Клумба с Граффити",
  T_35_XYL_WS_BISPARTERRE_DESC: "Клумба в тематике Играй на Стиле",
  T_35_XYL_WS_BISWALL: "Стена с Граффити",
  T_35_XYL_WS_BISWALL_DESC: "Стена в тематике Играй на Стиле. Можно комбинировать",
  T_35_XYL_WS_BOTDROP: "Вкл/Выкл выпадение лута",
  T_35_XYL_WS_CUSTOMTRIGGER: "Настраиваемый активатор",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Размести объект, который активирует определённый настроенный спецэффект, когда игрок активирует его. Эффект нужно прописать в скрипте. (Только в режиме Тонкой Настройки)",
  T_35_XYL_WS_DOUBLEDOOR: "Ворота",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Открытые ворота",
  T_35_XYL_WS_RESET: "Обнуляется каждый раунд",
  T_35_XYL_WS_RESETN: "Нет",
  T_35_XYL_WS_RESETY: "Да",
  T_35_XYL_WS_ROADBLOCK: "Дорожное Заграждение",
  T_35_XYL_WS_ROADBLOCK_DESC: "Ты не проедешь",
  T_35_XYL_WS_STAIRS: "Лестница",
  T_35_XYL_WS_STAIRS_DESC: "Лестница, которую можно совмещать с площадками",
  T_35_XYL_WS_STAIRSL: "Площадка B",
  T_35_XYL_WS_STAIRSL_DESC: "Платформа, которую можно совмещать с лестницей",
  T_35_XYL_WS_STAIRSZ: "Площадка A",
  T_35_XYL_WS_STAIRSZ_DESC: "Платформа, которую можно совмещать с лестницей",
  T_35_XYL_WS_TBOOTH: "Телефонная Будка",
  T_35_XYL_WS_TBOOTH_DESC: "Такие стоят на каждом углу",
  T_35_YF_PP19_N: "Бизон",
  T_35_YS_A_CATEAM_HW: "Орёл-талисман",
  T_35_YS_A_CUBBY: "Бандана-Мишка",
  T_35_YS_F_A_PANTOMIME: "Монохромная Тревога (Маска)",
  T_35_YS_F_A_RIDERS: "Экстремальная Гонка (Маска)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Идеальная Гармония (Низ)",
  T_35_YS_F_B_GOLDCHAIN: "Убедительная Роскошь (Низ)",
  T_35_YS_F_B_PANTOMIME: "Монохромная Тревога (Низ)",
  T_35_YS_F_B_RIDERS: "Экстремальная Гонка (Низ)",
  T_35_YS_F_H_BEAR_HW: "Шапка-Мишка (жен.)",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Идеальная Гармония (Голова)",
  T_35_YS_F_H_GOLDCHAIN: "Убедительная Роскошь (Голова)",
  T_35_YS_F_H_PANTOMIME: "Монохромная Тревога (Голова)",
  T_35_YS_F_H_RIDERS: "Экстремальная Гонка (Голова)",
  T_35_YS_F_HA_GOLDCHAIN: "Убедительная Роскошь (Грим)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Идеальная Гармония (Обувь)",
  T_35_YS_F_S_GOLDCHAIN: "Убедительная Роскошь (Обувь)",
  T_35_YS_F_S_PANTOMIME: "Монохромная Тревога (Обувь)",
  T_35_YS_F_S_RIDERS: "Экстремальная Гонка (Обувь)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Идеальная Гармония (Верх)",
  T_35_YS_F_T_GOLDCHAIN: "Убедительная Роскошь (Верх)",
  T_35_YS_F_T_PANTOMIME: "Монохромная Тревога (Верх)",
  T_35_YS_F_T_RIDERS: "Экстремальная Гонка (Верх)",
  T_35_YS_ITEM_SUPERFAK: "Супер-Аптечка",
  T_35_YS_M_A_GOLDCHAIN: "Тяжёлый Люкс (Маска)",
  T_35_YS_M_A_RIDERS: "Экстремальный Заезд (Маска)",
  T_35_YS_M_B_GOLDCHAIN: "Тяжёлый Люкс (Низ)",
  T_35_YS_M_B_RIDERS: "Экстремальный Заезд (Низ)",
  T_35_YS_M_H_BEAR_HW: "Шапка-Мишка (муж.)",
  T_35_YS_M_H_GOLDCHAIN: "Тяжёлый Люкс (Голова)",
  T_35_YS_M_H_RIDERS: "Экстремальный Заезд (Голова)",
  T_35_YS_M_S_GOLDCHAIN: "Тяжёлый Люкс (Обувь)",
  T_35_YS_M_S_RIDERS: "Экстремальный Заезд (Обувь)",
  T_35_YS_M_T_GOLDCHAIN: "Тяжёлый Люкс (Верх)",
  T_35_YS_M_T_RIDERS: "Экстремальный Заезд (Верх)",
  T_35_YS_T_CHAMPION: "Футболка Чемпионов",
  T_35_YS_T_PAINTING: "Поймал!",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Айрис",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Получить монеты в начале матча",
  T_36_JH_WS_CESAYCLOSE: "Отключить ручное закрытие или нет",
  T_36_JH_WS_CHOOSEEDITSHOP: "Выбрать магазин для редактирования",
  T_36_JH_WS_CHOOSESHOP: "Выбрать магазин",
  T_36_JH_WS_COINCOUNT: "Количество валюты",
  T_36_JH_WS_COINHUD: "Показать кол-во монет или нет",
  T_36_JH_WS_CRAFTSHOP: "Редактировать магазин",
  T_36_JH_WS_CREATEGOLD: "Генератор Монет",
  T_36_JH_WS_CSHOPENTITY: "Привязать сущность магазина",
  T_36_JH_WS_CSHOPHUD: "Интерфейс магазина",
  T_36_JH_WS_CURRENTLIMIT: "Оставшийся лимит покупок",
  T_36_JH_WS_ECONOMIC: "Экономика",
  T_36_JH_WS_INGAMEECONOMI: "Экономика игры",
  T_36_JH_WS_ITEMINDEXID: "Номер товара",
  T_36_JH_WS_KILLMONEY: "Получить монеты за киллы",
  T_36_JH_WS_KILLMONEYTIP: "Количество монет, которое можно заработать за устранение зомби в режимах Гонка или Выносливость",
  T_36_JH_WS_LISTINDEX: "Список типов товаров",
  T_36_JH_WS_NULL: "Null",
  T_36_JH_WS_NUMBER: "Количество",
  T_36_JH_WS_OPTIONNAME: "Эксклюзив для режима Робогеддон",
  T_36_JH_WS_REALSHOPENTITY: "Сущность магазина",
  T_36_JH_WS_SEEORHIDE: "Показать торговый автомат",
  T_36_JH_WS_SHOPFRONT: "Магазин",
  T_36_JH_WS_SHOPITEMLIST: "Тип товара",
  T_36_JH_WS_SHOPOPENCON: "Статус",
  T_36_JH_WS_SSHOPNAME: "Название магазина",
  T_36_JH_WS_TOTALLIMIT: "Лимит покупок",
  T_36_JH_WS_TRIGGERWIDE: "Радиус активации",
  T_36_JH_WS_VENDMACHINE: "Торговый Автомат",
  T_36_JH_WS_WINMONEY: "Монеты за победу",
  T_36_JH_WS_WORTH: "Стоимость",
  T_36_JL_FOREGRIP_MR_N: "Рукоятка Винтовки",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Приклад для Дробовика",
  T_36_JL_STOCK_SR_N: "Приклад для Снайперки",
  T_36_KK_WS_MONTSTERDES: "4-местный прочный грузовик с высокой проходимостью",
  T_36_M_WS_SETTEMPVAR: "Задать временную переменную",
  T_36_M_WS_TEMPVAR: "Временная Переменная",
  T_36_SY_AK47_MAMBAS_N: "AK47 Укус Мамбы",
  T_36_SY_AN94_MAMBAS_N: "AN94 Укус Мамбы",
  T_36_SY_AR15_MAMBAS_N: "Зимородок Укус Мамбы",
  T_36_SY_AUG_MAMBAS_N: "AUG Укус Мамбы",
  T_36_SY_AWM_MAMBAS_N: "AWM Укус Мамбы",
  T_36_SY_BLT_MAMBAS_N: "M82B Укус Мамбы",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Кинетический Дробовик Укус Мамбы",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle Укус Мамбы",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS Укус Мамбы",
  T_36_SY_G18_MAMBAS_N: "G18 Укус Мамбы",
  T_36_SY_G36_MAMBAS_N: "G36 Укус Мамбы",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Граната Морской Праздник",
  T_36_SY_GROZA_MAMBAS_N: "ГРОЗА Укус Мамбы",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Ручная Пушка Укус Мамбы",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Леч. Снайперка Укус Мамбы",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ледяной Пистолет Укус Мамбы",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k Укус Мамбы",
  T_36_SY_KORD_MAMBAS_N: "Корд Укус Мамбы",
  T_36_SY_M1014_MAMBAS_N: "M1014 Укус Мамбы",
  T_36_SY_M14_MAMBAS_N: "M14 Укус Мамбы",
  T_36_SY_M1873_MAMBAS_N: "M1873 Укус Мамбы",
  T_36_SY_M1887_MAMBAS_N: "M1887 Укус Мамбы",
  T_36_SY_M1917_MAMBAS_N: "M1917 Укус Мамбы",
  T_36_SY_M21A5_MAMBAS_N: "Ястреб Укус Мамбы",
  T_36_SY_M24_MAMBAS_N: "M24 Укус Мамбы",
  T_36_SY_M249_MAMBAS_N: "M249 Укус Мамбы",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 Укус Мамбы",
  T_36_SY_M500_MAMBAS_N: "M500 Укус Мамбы",
  T_36_SY_M60_MAMBAS_N: "M60 Укус Мамбы",
  T_36_SY_M79_MAMBAS_N: "M79 Укус Мамбы",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 Укус Мамбы",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 Укус Мамбы",
  T_36_SY_MINI_MAMBAS_N: "AC80 Укус Мамбы",
  T_36_SY_MP40_MAMBAS_N: "MP40 Укус Мамбы",
  T_36_SY_MP5_MAMBAS_N: "MP5 Укус Мамбы",
  T_36_SY_P90_MAMBAS_N: "P90 Укус Мамбы",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL Укус Мамбы",
  T_36_SY_PP19_MAMBAS_N: "Бизон Укус Мамбы",
  T_36_SY_PP19_POLICEMAN_N: "Бизон Призрачный Дозорный",
  T_36_SY_SCAR_MAMBAS_N: "SCAR Укус Мамбы",
  T_36_SY_SKS_MAMBAS_N: "СКС Укус Мамбы",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 Укус Мамбы",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "ПЛАЗМА Укус Мамбы",
  T_36_SY_SVD_MAMBAS_N: "СВД Укус Мамбы",
  T_36_SY_THOMPSON_MAMBAS_N: "Томпсон Укус Мамбы",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Клинок для Мамбы",
  T_36_SY_THROWINGKNIFE_MENA_N: "Бохо-нож",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Леч. Пистолет Укус Мамбы",
  T_36_SY_UMP45_MAMBAS_N: "UMP Укус Мамбы",
  T_36_SY_USP45_MAMBAS_N: "USP Укус Мамбы",
  T_36_SY_UZI_MAMBAS_N: "Мини-Узи Укус Мамбы",
  T_36_SY_VECTOR_MAMBAS_N: "Вектор Укус Мамбы",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Монстр Трак - Ослепительное Золото",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Байк Путешествие за Завесу",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Спорткар Скорость Жизни",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Тук Тук Покатушки на Ту Сторону",
  T_36_SY_VSS_MAMBAS_N: "VSS Укус Мамбы",
  T_36_SY_XM8_MAMBAS_N: "XM8 Укус Мамбы",
  T_36_WZY_AFTERACCUMULATOR: "Конечный аккумулятор",
  T_36_WZY_AVAILAB: "Включено",
  T_36_WZY_BACKANDFORTH: "Туда-обратно",
  T_36_WZY_BASEMULTIPLIER: "Базовый множитель",
  T_36_WZY_BASIC: "Базовый тип",
  T_36_WZY_BEFORACCUMULATOR: "Начальный аккумулятор",
  T_36_WZY_CYLIC: "Возвращение",
  T_36_WZY_GUNPRO_PARAM1: "Базовый урон",
  T_36_WZY_GUNPRO_PARAM10: "Начало разлёта пуль",
  T_36_WZY_GUNPRO_PARAM11: "Макс. разлёт",
  T_36_WZY_GUNPRO_PARAM12: "Импульс",
  T_36_WZY_GUNPRO_PARAM2: "Пуль в магазине",
  T_36_WZY_GUNPRO_PARAM3: "Начальный размер магазина",
  T_36_WZY_GUNPRO_PARAM4: "Интервал стрельбы",
  T_36_WZY_GUNPRO_PARAM7: "Расстояние для макс. урона",
  T_36_WZY_GUNPRO_PARAM8: "Расстояние для мин. урона",
  T_36_WZY_GUNPRO_PARAM9: "Минимальный урон",
  T_36_WZY_MULTIPLIR: "Множитель",
  T_36_WZY_PRICE: "Цена",
  T_36_WZY_SUMMULTIPLIER: "Аккумулятор множителя",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "Результат абсолютного значения",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Добавить все элементы из [Исходного списка] в низ [Целевого списка]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "Список, в который нужно добавить элементы",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "Список, который содержит элементы для добавления",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Добавить определённое количество указанной валюты в указанный кошелёк",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Кошелёк",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "Кошелёк, в который нужно добавить валюту",
  T_36_WZY_WS_ADDSUB: "Добавить или вычесть значения",
  T_36_WZY_WS_AIENTITY: "Сущность ИИ",
  T_36_WZY_WS_ALLSHOP_DESC: "Список, состоящий из сущностей магазинов",
  T_36_WZY_WS_ANGLE_DESC: "Значение угла",
  T_36_WZY_WS_ANYTYPE: "Любой тип",
  T_36_WZY_WS_ARILEFT: "Левое значение в операции",
  T_36_WZY_WS_ARIRES: "Результат операции",
  T_36_WZY_WS_ARIRIGHT: "Правое значение в операции",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 арифметических операции",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Базовые операции над целыми числами поддерживают сложение, вычитание, умножение, деление и остаток. Операции над дробями поддерживают сложение, вычитание, умножение и деление",
  T_36_WZY_WS_ARRAY_DESC: "Целевой список",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Проверяет, содержит ли список указанный элемент. Возвращаемое значение - Булево",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "Назначенный список",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "Элемент, который нужно найти в списке",
  T_36_WZY_WS_ARRCONELERES: "Результат проверки, есть ли указанный элемент в списке. Значение - Булево",
  T_36_WZY_WS_ATTACK: "Патрулировать и атаковать",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Активируется, когда игрок падает в нокдаун",
  T_36_WZY_WS_BIGFLOAT: "Большая дробь",
  T_36_WZY_WS_BIGTOYBALL: "Кубик",
  T_36_WZY_WS_BOOLLIST: "Список Булевых",
  T_36_WZY_WS_CEIL_NAME_DESC: "Округлить указанное значение вверх",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "Значение для округления вверх",
  T_36_WZY_WS_CEILRES: "Результат округления",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "Выбранный ИИ будет преследовать эту сущность вне зависимости от расстояния между ними. [Преследуемая сущность] может быть любой. Когда [Преследуемая сущность] не имеет свойства Здоровья, сущность ИИ не будет наносить повреждений",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "Сущность, которая преследует",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "Целевая сущность, которую преследуют. Может быть любая сущность",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Шаблон для клонирования объектов. Выбирайте при помощи курсора. Свойства и скрипт клона будут такими же, как у выбранного объекта",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "Сущность клонируемого объекта",
  T_36_WZY_WS_CONDITION: "Условие",
  T_36_WZY_WS_CONDITIONLIST: "Список условий",
  T_36_WZY_WS_CONOFHUD: "Сущность HUD, в которой есть контрольное",
  T_36_WZY_WS_CONTROL_DESC: "Единственный индекс контрольного",
  T_36_WZY_WS_COS_NAMEDESC: "Найти косинус угла",
  T_36_WZY_WS_COSRES: "Косинус угла",
  T_36_WZY_WS_CREABLEOB: "Создаваемый объект",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Создать сущность объекта в назначенной локации (Тестовая версия)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Координаты создаваемого объекта",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "Тип создаваемого объекта",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "Сущность создаваемого объекта",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Валюта",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Сущность товара",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Создать сущность товара",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Создать сущность кошелька. [Привязанный игрок] - игрок, который может видеть этот кошелёк. [Владелец] - игрок, которому принадлежит кошелёк. Не работает, если кошелёк уже существует",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Привязанный игрок",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "Игрок, которому виден кошелёк. Если никакие настройки не заданы, кошелёк будет виден всем",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Владелец кошелька",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Сущность кошелька",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "Созданная сущность кошелька",
  T_36_WZY_WS_CURRAMT: "Количество валюты",
  T_36_WZY_WS_DATA_TYPE1: "Добавленный параметр",
  T_36_WZY_WS_DATA_TYPE2: "Базовые и логические вычисления",
  T_36_WZY_WS_DATA_TYPE3: "Операции со списками",
  T_36_WZY_WS_DATA_TYPE4: "Векторные вычисления",
  T_36_WZY_WS_DESTITEM_NAME: "Уничтожить предмет игрока",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Уничтожить указанный тип предмета для указанного игрока",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Можно уничтожать оружие, бронежилеты и шлемы",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "Ячейка индекса типа выбранного предмета. Индекс оружия [1,3], а Бронежилет и Шлем по умолчанию 1",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Терять снаряжение при устранении",
  T_36_WZY_WS_DESTOBJ: "Уничтожаемые объекты",
  T_36_WZY_WS_DIRPOINT: "Направляющая точка",
  T_36_WZY_WS_DIRPOINTDESC: "Создаваемая направляющая точка",
  T_36_WZY_WS_ELEFINDRES: "Индекс первого положения элемента",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Взять индекс первого положения элемента в списке. Если целевого элемента нет в списке, результат будет "-1"',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "Элемент, который нужно искать в списке",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Взять индекс последнего положения элемента в списке. Если целевого элемента нет в списке, результат будет "-1"',
  T_36_WZY_WS_ELELINDRES: "Индекс последнего положения элемента",
  T_36_WZY_WS_ELEMENTSNUM: "Кол-во элементов в списке",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Запускается, когда [Активирующая сущность] сталкивается с этим активатором",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "Сущность, которая сталкивается с активатором",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Запускается, когда [Активирующая сущность] ведёт транспорт",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "Сущность, которая ведёт транспорт",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Запускается, когда игрок входит в активатор",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Активатор, в который нужно войти",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Запускается, когда [Активирующая сущность] покидает транспорт",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "Сущность, покидающая транспорт",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Запускается, когда [Активирующая сущность] входит в транспорт",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "Сущность, которая садится в транспорт",
  T_36_WZY_WS_ENTITY_TYPE1: "Часто используемые",
  T_36_WZY_WS_ENTITY_TYPE2: "Свойства",
  T_36_WZY_WS_ENTITY_TYPE3: "Объекты и предметы",
  T_36_WZY_WS_ENTITY_TYPE4: "ИИ",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "Значение элемента, которое будет изменено",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Целевой игрок",
  T_36_WZY_WS_ENTITYLIST: "Список сущностей",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Запускается, когда [Активирующая сущность] отскакивает от шины",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "Сущность, отскакивающая от шины",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Запускается, когда [Активирующая сущность] входит в портал и телепортируется",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "Телепортированная сущность",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "Тип экипированной брони, включая бронежилет, шлем и рюкзак",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Запускается, когда игрок успешно экипирует оружие. [Игрок-инициатор] - игрок, успешно экипировавший оружие. [Сущность оружия] - оружие, которое экипировал игрок",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "Сущность экипированного оружия",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Тип оружия",
  T_36_WZY_WS_EULERANGLE: "Углы Эйлера",
  T_36_WZY_WS_FACECAMERA: "Всегда перед камерой",
  T_36_WZY_WS_FLOATLIST: "Список десятичных дробей",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Округлить указанное значение вниз",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "Значение для округления вниз",
  T_36_WZY_WS_FLOORRES: "Результат округления вниз",
  T_36_WZY_WS_FORMUENT: "Свойства Сущности, для которой  доступны формулы",
  T_36_WZY_WS_FORMUFACT: "Тип фактора формулы свойств",
  T_36_WZY_WS_GAME_TYPE2: "Игровой процесс",
  T_36_WZY_WS_GAME_TYPE3: "Спецэффекты",
  T_36_WZY_WS_GENENT_NAMEDESC: "Запускается, когда генератор создаёт созданий. [Список сущностей созданий] - список созданий, созданных генератором. [Количество волн] - количество волн, создаваемых генератором",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Сущность создания",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Список, состоящий из сущностей создания, созданных генератором",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "Кол-во волн, создаваемых генератором",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Взять все магазины в матче. Возвращаемое значение - список, состоящий из сущностей магазинов",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Использовать RGB, чтобы взять цвет",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Взять количество определённой валюты в определённом кошельке",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "Кошелёк, из которого берётся кол-во валюты",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "Тип валюты, которую нужно взять",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Взять тип целевой сущности",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "Сущность, тип которой нужно взять",
  T_36_WZY_WS_GETENTTYPERES: "Тип целевой сущности",
  T_36_WZY_WS_GETFOR_NAME: "Получить координаты направления",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Получить вектор указанной направляющей точки",
  T_36_WZY_WS_GETFORRES: "Вектор направляющей точки",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Взять сущность валюты определённого типа валюты в кошельке",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "Кошелёк, в котором находится сущность валюты",
  T_36_WZY_WS_GETPOS_NAME: "Взять координаты",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Взять координаты указанной направляющей точки",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "Указанная направляющая точка",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Тип снаряжения",
  T_36_WZY_WS_GETWALLET_NAME: "Взять кошелёк",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Взять кошелёк выбранного владельца",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Существует ли привязанный кошелёк",
  T_36_WZY_WS_GETWALLETRES: "Сущность кошелька владельца",
  T_36_WZY_WS_HUDCONTROL_DESC: "Контрольная сущность HUD",
  T_36_WZY_WS_HUDTYPE: "Тип HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Событие для всего матча",
  T_36_WZY_WS_INCIDENT_TYPE2: "Событие сущности",
  T_36_WZY_WS_INDEX_DESC: "Значение индекса списка. Начинается с 0",
  T_36_WZY_WS_INTLIST: "Список целых чисел",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Проверить, принадлежит ли тип сущности к определённой подкатегории. Возвращаемый результат - Булево значение",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "Родительская категория, к которой проверяется принадлежность сущности",
  T_36_WZY_WS_JENTSUBCLRES: "Результат проверки родительской категории",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Проверить, принадлежит ли сущность к определённому типу сущностей. Возвращаемый результат - Булево значение",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "Сущность для проверки",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Означает, что совпадает с типом сущности",
  T_36_WZY_WS_JENTTYPERES: "Результат проверки сущности",
  T_36_WZY_WS_JUSTPATROL: "Только патрулировать",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Активируется, когда игрок выходит из активатора",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Активатор для выхода",
  T_36_WZY_WS_LEVELOBLIST: "Список Объектов",
  T_36_WZY_WS_LEVOBJSLIST: "Список объектов на карте в этом матче",
  T_36_WZY_WS_LEVOBTYPE: "Тип объекта",
  T_36_WZY_WS_LISTT: "Шаблон списка",
  T_36_WZY_WS_LOGCONTEXT_DESC: "Выводимое содержимое",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "Левая строка для соединения",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "Правая строка для соединения",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "Добавляемое значение элемента",
  T_36_WZY_WS_LOGOPER: "При выполнении логических операций (and & or): При использовании операции and, если из двух Булевых значений оба TRUE (истинные), результат будет TRUE. При использовании операции or, если из двух Булевых значений НЕ оба FALSE (ложные), результат будет TRUE",
  T_36_WZY_WS_LOOTPOINT: "Точка сбора лута",
  T_36_WZY_WS_MAINWEAP: "Текущее оружие",
  T_36_WZY_WS_MAX_DESC: "Верхний диапазон сгенерированного целого числа (открытый интервал)",
  T_36_WZY_WS_MIN_DESC: "Нижний диапазон сгенерированного целого числа (замкнутый интервал)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Сущность оружия",
  T_36_WZY_WS_MONENT: "Сущность валюты",
  T_36_WZY_WS_MONTYPE: "Тип валюты",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Даёт ИИ команду двигаться к целевой точке. Чтобы задать, будет ли ИИ возвращаться на исходную точку, используйте блок [Возвращаться или нет]. Чтобы задать, будет ли ИИ искать врагов по пути, используйте [Атаковать или нет]",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "Сущность ИИ, которая перемещается",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "Точка назначения",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Используйте, чтобы задать, нужно ли ИИ возвращаться в точку отправления после прибытия на точку назначения. TRUE = возвращаться. FALSE = не возвращаться",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Атаковать или нет",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Используйте, чтобы задать, будет ИИ атаковать встреченных врагов по пути. TRUE = искать врагов. FALSE = не искать врагов",
  T_36_WZY_WS_MULVALUE: "Скалярное",
  T_36_WZY_WS_MULVEC: "Вектор для скалярного умножения",
  T_36_WZY_WS_NEGRES: "Отрицательное значение в результате",
  T_36_WZY_WS_NEUTRAL: "Нейтрально",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Принуждает назначенный генератор создать следующую волну. Генераторы включают Точки Появления Зомби и точки появления предметов",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Сущность генератора",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "Сущность указанного генератора, например, Точки Появления Зомби или точки появления предметов",
  T_36_WZY_WS_OBJENT: "Сущность объекта",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Запускается, когда получен предмет. [Тип предмета] - тип полученного предмета",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Запускается, когда оружие получено. [Сущность оружия] - полученное оружие",
  T_36_WZY_WS_ONEWAY: "В один конец",
  T_36_WZY_WS_OPENSTATE: "Статус",
  T_36_WZY_WS_OPERMETHOD_NAME: "Операция",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Базовые арифметические операции. Сейчас операции над целым числом поддерживают сложение, вычитание, умножение, деление и остаток. Операции над дробями поддерживают сложение, вычитание, умножение и деление",
  T_36_WZY_WS_OWNERENT_DESC: "Сущность для отъёма кошелька",
  T_36_WZY_WS_PERCENTAGE: "Корректировка процентов",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Когда игрок сталкивается с активатором",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Запускается, когда [Игрок-инициатор] сталкивается с активатором",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "Игрок, который сталкивается с активатором",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "Сущность объекта, с которым сталкивается игрок",
  T_36_WZY_WS_PLADRIVEH_NAME: "Когда игрок ведёт транспорт",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Запускается, когда [Игрок-инициатор] ведёт транспорт",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "Игрок, который ведёт транспорт",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "Сущность транспорта, который ведёт игрок",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Когда игрок покидает транспорт",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Запускается, когда [Игрок-инициатор] покидает транспорт",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "Игрок, покидающий транспорт",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "Сущность транспорта, который покидает игрок",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Когда игрок садится в транспорт",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Запускается, когда [Игрок-инициатор] входит в портал",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Сущность транспорта, в который садится игрок",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Когда игрок отскакивает от шины",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Запускается, когда [Игрок-инициатор] отскакивает от шины",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "Игрок, отскакивающий от шины",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Сущность объекта, от которого отскакивает игрок",
  T_36_WZY_WS_PLATP_NAME: "После телепортации игрока",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "Игрок, использующий портал",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "Сущность портала, который использовал игрок",
  T_36_WZY_WS_PLAYERLIST_DESC: "Список всех игроков в этом матче",
  T_36_WZY_WS_POINTPICKER: "Поворот на пути",
  T_36_WZY_WS_PORTALENT: "Сущность портала",
  T_36_WZY_WS_PREFAB: "Шаблон",
  T_36_WZY_WS_PRODLIST: "Список товаров",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Порядок сортировки",
  T_36_WZY_WS_PROPMOD: "Способ изменения свойств",
  T_36_WZY_WS_RANKABLEE: "Сущность с доступным рангом",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Потратить определённое количество указанной валюты в указанном кошельке",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "Кошелёк, в котором тратится валюта",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "Тип потраченной валюты",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "Количество потраченной валюты",
  T_36_WZY_WS_RNDFRES: "Сгенерированная случ. дробь",
  T_36_WZY_WS_RNDIRES: "Сгенерированное случ. целое",
  T_36_WZY_WS_ROUND_NAME_DESC: "Округлить значение до ближайшего целого числа",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "Значение для округления",
  T_36_WZY_WS_ROUNDRES: "Результат округления",
  T_36_WZY_WS_RUNAI_NAMEDESC: "Дерево поведения, которое будет исполнять ИИ",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "Сущность создания, которая исполняет / останавливает дерево поведения по умолчанию",
  T_36_WZY_WS_SCOREABLEE: "Сущность с доступным счётом",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Запускается, когда изменяется счёт. [Тип счёта] - тип счёта, который изменяется. [Счёт] - новый счёт",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Создать направляющую точку",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Берёт вновь созданную направляющую точку. Используйте блок [Место], чтобы задать координаты точки, и блок [Направление], чтобы задать вектор направления",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Координаты направляющей точки",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Направление",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "Вектор направляющей точки",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Сущности ИИ будут перемещаться по заданному здесь порядку. Доступные типы перемещения - возвращение, в один конец и туда-обратно. Также можно выбрать, будет ли ИИ искать врагов по пути",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Список, состоящий из точек, к которым должен перемещаться ИИ",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Тип перемещения",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Это типы перемещения. В один конец - ИИ перестаёт перемещаться, достигнув точки назначения. Возвращение - ИИ ищет путь назад, достигнув точки назначения. Туда-обратно - ИИ возвращается в исходную локацию согласно плану возвращения в путевом листе",
  T_36_WZY_WS_SHOPECON: "Магазин и экономика",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Используйте для показа всплывающих уведомлений на экране. Текст можно настроить при помощи блока [Текст], цвет текста при помощи блока [Цвет], а длительность показа при помощи блока [Длительность] (измеряется в миллисекундах)",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "Содержимое всплывающего уведомления",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "Цвет всплывающего уведомления",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "Длительность показа всплывающего уведомления, в миллисекундах",
  T_36_WZY_WS_SIN_NAMEDESC: "Найти синус угла",
  T_36_WZY_WS_SINRES: "Синус угла",
  T_36_WZY_WS_SKIPKNODOWN: "Устранять ли при нокдауне",
  T_36_WZY_WS_SQRTRES: "Результат извлечения квадратного корня",
  T_36_WZY_WS_STRCONRES: "Результат соединения строк",
  T_36_WZY_WS_STRINGLIST: "Список строк",
  T_36_WZY_WS_STRLEN: "Длина строки",
  T_36_WZY_WS_STRVAL: "Результат строки",
  T_36_WZY_WS_TAN_NAMEDESC: "Найти тангенс угла",
  T_36_WZY_WS_TANRES: "Тангенс угла",
  T_36_WZY_WS_TEAMLIST: "Список команд",
  T_36_WZY_WS_TEAMLIST_DESC: "Список всех команд в этом матче",
  T_36_WZY_WS_TIMETWEENTIPS: "Сущность уведомления об обратном отсчёте",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Перевести целевое значение в строку",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "Целевое значение для перевода в строку",
  T_36_WZY_WS_TOSTRINGRES: "Результат перевода в строку",
  T_36_WZY_WS_TOWERCAMP_DESC: "Кол-во сторон и кол-во команд одинаковое. Нейтральные вышки и укрепления будут атаковать всех игроков и ИИ в радиусе",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Перевести определённое количество указанной валюты из одного кошелька в другой",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "Кошелёк, из которого нужно перевести валюту",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "Тип валюты для перевода",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "Количество валюты для перевода",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "Кошелёк, в который нужно перевести валюту",
  T_36_WZY_WS_TWEENTIPS: "Сущность всплывающего уведомления",
  T_36_WZY_WS_TYPEENUM: "Тип перечисления (enum)",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Запускается, когда игрок использует предмет. [Игрок-инициатор] - игрок, использующий предмет. [Тип предмета] - предмет, использованный игроком",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "Тип предмета, используемого игроком",
  T_36_WZY_WS_VECADDLEFT: "Левое значение сложения векторов",
  T_36_WZY_WS_VECADDRES: "Результат сложения векторов",
  T_36_WZY_WS_VECADDRIGHT: "Правое значение сложения векторов",
  T_36_WZY_WS_VECANGLEFT: "Левое значение векторного угла",
  T_36_WZY_WS_VECANGRES: "Угол между 2 векторами",
  T_36_WZY_WS_VECANGRIGHT: "Правое значение векторного угла",
  T_36_WZY_WS_VECCROLEFT: "Левое значение векторного произведения",
  T_36_WZY_WS_VECCRORES: "Результат векторного произведения",
  T_36_WZY_WS_VECCRORIGHT: "Правое значение векторного произведения",
  T_36_WZY_WS_VECDISLEFT: "Левое значение векторного расстояния",
  T_36_WZY_WS_VECDISRES: "Расстояние между 2 векторами",
  T_36_WZY_WS_VECDISRIGHT: "Правое значение векторного расстояния",
  T_36_WZY_WS_VECDOCLEFT: "Левое значение скалярного произведения",
  T_36_WZY_WS_VECDOCRES: "Результат скалярного произведения",
  T_36_WZY_WS_VECDOCRIGHT: "Правое значение скалярного произведения",
  T_36_WZY_WS_VECMULRES: "Результат скалярного умножения",
  T_36_WZY_WS_VECNORRES: "Нормализованный вектор",
  T_36_WZY_WS_VECSIZERES: "Величина вектора",
  T_36_WZY_WS_VECSUBLEFT: "Левое значение вычитания векторов",
  T_36_WZY_WS_VECSUBRES: "Результат вычитания векторов",
  T_36_WZY_WS_VECSUBRIGHT: "Правое значение вычитания векторов",
  T_36_WZY_WS_VECTORLIST: "Список векторов",
  T_36_WZY_WS_VECX: "Компонент x",
  T_36_WZY_WS_VECY: "Компонент y",
  T_36_WZY_WS_VECZ: "Компонент z",
  T_36_WZY_WS_VEHENT: "Сущность транспорта",
  T_36_WZY_WS_WALLCONT: "Содержимое кошелька",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Непрерывно",
  T_36_XYL_WS_AIBOT: "Создание",
  T_36_XYL_WS_AIGENERATOR: "Генератор Созданий",
  T_36_XYL_WS_AIGENERATOR_DESC: "Генератор, который постоянно выпускает созданий (например, зомби)",
  T_36_XYL_WS_AIWAVE: "Кол-во созданий в волне",
  T_36_XYL_WS_ARROW: "Указатель Направления",
  T_36_XYL_WS_ARROW_DESC: "Знак, который указывает направление",
  T_36_XYL_WS_BREAKBOX: "Хрупкий Ящик",
  T_36_XYL_WS_BREAKBOX_DESC: "Деревянный ящик, который можно сломать при атаке",
  T_36_XYL_WS_FENCE: "Железный Забор",
  T_36_XYL_WS_FENCE_DESC: "Сквозь этот забор могут пролетать пули",
  T_36_XYL_WS_STAIRI: "Площадка C",
  T_36_XYL_WS_STAIRI_DESC: "Платформа, которую можно совмещать с лестницей",
  T_36_XYL_WS_ZOMBIEAI: "Зомби",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Зомби, которых можно настраивать. Могут быть получаемым и копируемым объектом в Генераторе Созданий",
  T_36_YF_CORRODE_GRENADE_N: "Стеноплавитель",
  T_36_YF_SETTING_TYPE3: "Схема 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "Лазурная футбольная форма CBF (Низ)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "Лимонная футбольная форма CBF (Низ)",
  T_36_YS_F_A_GHOSTHUNTER: "Городская Лисица (Маска)",
  T_36_YS_F_B_GHOSTHUNTER: "Городская Лисица (Низ)",
  T_36_YS_F_H_GHOSTHUNTER: "Городская Лисица (Голова)",
  T_36_YS_F_S_GHOSTHUNTER: "Городская Лисица (Обувь)",
  T_36_YS_SETTING_GRENADE: "Метательные",
  T_36_YS_SETTING_MOVE: "Передвижение",
  T_36_YS_T_BRFOOTBALL_BLUE01: "Лазурная футбольная форма CBF (Верх)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "Лимонная футбольная форма CBF (Верх)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Луна",
  T_36_YZY_CHARACTER_YAKUZA_N: "Тацуя",
  T_36_YZY_PET_WOLF_N: "Клык",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Скин Питомца: Лиловый Аксель",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Скин Питомца: Грозовой Сокол",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Скин Питомца: Вулканический Клык",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Скин Питомца: Дух-Проводник",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Скин Питомца: Арктический Клык",
  T_37_B_WS_HIDE: "Прятки",
  T_37_HZ_WS_CATMODEDESC1: "Прятки",
  T_37_JH_WS_CREATEGOLD_DESC: "Торговый Автомат, где игроки могут приобретать предметы. (Недоступен в режимах БО, КБН, Спортплощадка, Робогеддон)",
  T_37_JH_WS_NAME1: "FF Нож Робогеддон",
  T_37_JH_WS_NAME10: "M1887-X Робогеддон",
  T_37_JH_WS_NAME11: "SPAS12 Робогеддон",
  T_37_JH_WS_NAME12: "M1014 Робогеддон",
  T_37_JH_WS_NAME13: "MP40 Робогеддон",
  T_37_JH_WS_NAME14: "MP5-III Робогеддон",
  T_37_JH_WS_NAME15: "P90 Робогеддон",
  T_37_JH_WS_NAME16: "M60-III Робогеддон",
  T_37_JH_WS_NAME17: "Томпсон Робогеддон",
  T_37_JH_WS_NAME18: "UMP Робогеддон",
  T_37_JH_WS_NAME19: "СВД Робогеддон",
  T_37_JH_WS_NAME2: "ГРОЗА Робогеддон",
  T_37_JH_WS_NAME20: "AWM Робогеддон",
  T_37_JH_WS_NAME21: "M82B Робогеддон",
  T_37_JH_WS_NAME22: "M249-X Робогеддон",
  T_37_JH_WS_NAME23: "Kar98k-III Робогеддон",
  T_37_JH_WS_NAME3: "AK47 Робогеддон",
  T_37_JH_WS_NAME4: "M4A1-III Робогеддон",
  T_37_JH_WS_NAME5: "SCAR Робогеддон",
  T_37_JH_WS_NAME6: "M14-III Робогеддон",
  T_37_JH_WS_NAME7: "PARAFAL Робогеддон",
  T_37_JH_WS_NAME8: "XM8 Робогеддон",
  T_37_JH_WS_NAME9: "MAG-7 Робогеддон",
  T_37_JH_WS_VENDMACHINE_DESC: "Золото, которое можно подобрать на карте. (Нельзя использовать в режимах БО, КБН, Спортплощадка, Робогеддон)",
  T_37_JH_WS_X: "Ось X",
  T_37_JH_WS_Y: "Ось Y",
  T_37_JH_WS_Z: "Ось Z",
  T_37_JL_FOOTBALL_TIE: "Ничья",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "M1216",
  T_37_KK_WS_SNOWMAN: "Северный Пингвин",
  T_37_LC_BP_ENTRANCE_GIFT: "Подарок!",
  T_37_M_WS_MISSING: "Нет Источника",
  T_37_M_WS_NAMEERROR: "Содержит недопустимые символы. Пожалуйста, измени.",
  T_37_PD_HuntingGround_BOSSTITLE: "Мясник",
  T_37_QL_JUMPPAD_DES: "Создаёт на земле площадку с трамплином. Можно использовать для прыжка высоко в воздух, позволяет стрелять в прыжке.",
  T_37_QL_JUMPPAD_NAME: "Трамплин",
  T_37_R_TAILOR_LIMIT: "Лимит Времени",
  T_37_RW_LOADOUT_BORNFIRETAG: "Получите 2 костра в начале матча. Костер [FFBA00]восстанавливает 5 ХП и 20 Энергии в секунду[-] (до 10 секунд) для вас и ваших напарников в зоне действия. Эффекты костра не суммируются.",
  T_37_RW_PROPCATAPULT_DESC: "В надутом состоянии Пусковая Площадка может быть использована для запуска в воздух. Главное, оставаться в Безопасной Зоне!",
  T_37_RW_PROPCATAPULT_NAME: "Пусковая Площадка",
  T_37_SP_WS_COLOR_02: "Цвет",
  T_37_SP_WS_COLOR_03: "Внешний Вид",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "Сущность равна нулю при получении или настройке свойств",
  T_37_SP_WS_LOG_PHASE_END: "Уровень {0} завершён.",
  T_37_SP_WS_LOG_PHASE_START: "Уровень {0} начинается",
  T_37_SP_WS_LOG_ROUND_END: "Раунд {0} завершён.",
  T_37_SP_WS_LOG_ROUND_START: "Раунд {0} начался.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Несоответствие типа при указании значения переменной. Требуемый тип: {0}. Текущий тип: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Неопределённая или выходящая за пределы видимости локальная переменная {0}",
  T_37_SP_WS_MAPACCESS_08: "Редактировать",
  T_37_SP_WS_RACEMODE_01: "Обратный Отсчёт",
  T_37_SP_WS_RACEMODE_02: "Время Обратного Отсчёта",
  T_37_SP_WS_RACEMODE_04: "При достижении финишной точки всеми членами команды начинается обратный отсчёт. Игра заканчивается с окончанием обратного отсчёта.",
  T_37_SY_AR15_KABUKI_N: "Зимородок - Нингё-химэ",
  T_37_SY_BACKPACK_STRAW_N: "Рюкзак - Соломенная Шляпа",
  T_37_SY_GRENADE_FFWS2022_01_N: "Граната - Яркое Созвездие",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Чёрная Дыра",
  T_37_SY_M1216_MAMBAS_N: "M1216 - Укус Мамбы",
  T_37_SY_PET_FLYINGCREATURE_N: "Эрвин",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Скин Питомца: Звезда Гламура",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Скин Питомца: Пепельный Эрвин",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Скин Питомца: Космический Эрвин",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Скин Питомца: Эрвин, Легендарное Пламя",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Скин Питомца: Бегун Флэш",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Скин Питомца: Зимующий Йети",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Джип - Рок-Фестиваль",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Пикап Хозяин Звёзд",
  T_37_WT_WS_PVE2DESC: `Режим выживания среди зомби, в котором игроки должны уничтожить определенное количество зомби за отведенное время или выжить до конца игры.
Вы можете установить правила игрового процесса и настроить параметры зомби по своему усмотрению, включая количество зомби, которых необходимо уничтожить.`,
  T_37_WT_WS_RULEDESC: "Устрани необходимое число зомби для победы.",
  T_37_WT_WS_RULETITLE: "Цель",
  T_37_WT_WS_TXT1: "Устранение зомби",
  T_37_WT_WS_TXT1DESC: "Когда активно, игроки побеждают, устраняя определённое число зомби. Когда неактивно, игроки побеждают, если доживают до конца матча.",
  T_37_WT_WS_TXT2: "Число киллов",
  T_37_WZY_FRIDPLA: "Союзник",
  T_37_WZY_FRIDSIDE: "Союзная фракция",
  T_37_WZY_FRIDTEAM: "Союзная команда",
  T_37_WZY_HOSTPLA: "Противник",
  T_37_WZY_HOSTSIDE: "Фракция противника",
  T_37_WZY_WS_ACCFRAMES: "Накопленные Кадры",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Добавить предмет к товарам. Можно добавить один предмет или группу. Количество может быть как числом отдельных предметов, так и списком из предметов равного количества.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "Сущность товара, к которой будут добавлены предметы",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Предметы на добавление. Можно добавить один предмет или группу.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "Количество отдельных предметов на добавление или список, в котором содержатся  предметы в этом количестве.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Добавить тэг для выбранной сущности",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "Сущность для добавления тэга",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "Добавить текст",
  T_37_WZY_WS_AIMABLEENT: "Сущность доступна для прицела",
  T_37_WZY_WS_AIMASSISTTYPE: "Тип автоприцела",
  T_37_WZY_WS_ALLOWDROP_NAME: "Включить/отключить выпадание предметов",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Возможность выпадания предметов у игрока",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "Управление возможностью выпадания предметов у этой сущности игрока",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Возможность выпадания предметов у игрока. Булев тип",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Включить/отключить подбор предметов",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Возможность подбора предметов игроком",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "Управление возможностью подбора предметов у этой сущности игрока",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Возможность подбора предметов игроком. Булев тип",
  T_37_WZY_WS_AMBIENTCOLOR: "Светлый оттенок окружения",
  T_37_WZY_WS_AMRORTOOL: "Ремонт брони",
  T_37_WZY_WS_ATTACK: "Атака",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Отменить маскировку игроков, возврат к обычному внешнему виду",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "Отменить маскировку этой сущности игрока",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Увеличить скорость мяча",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "Мяч для увеличения скорости",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "Вектор скорости",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Проявляется, когда в мяч попадают из Мяч-Пушки. [Сущность Игрок] - игрок, у которого Мяч-Пушка. [Ускорение] - это добавленная скорость мяча после столкновения.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "Игрок, у которого Мяч-Пушка",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "Вектор скорости мяча после удара",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "При столкновении мяча с сущностью, скорость мяча вырастает. [Препятствие] - это сущность, с которой сталкивается мяч. [Ускорение] - это добавленная скорость мяча после столкновения.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "Сущность, с которой сталкивается мяч",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "Добавленная скорость мяча после столкновения.",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Проявляется, когда сущность становится обьектом прицеливания игрока",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "Прицеливающийся в сущность Игрок",
  T_37_WZY_WS_BEHAVIORSTAT: "Статус возможностей игрока",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "Оружие, которое нанесло попадание по сущности",
  T_37_WZY_WS_BLOODBARENT: "Сущность Шкала Здоровья",
  T_37_WZY_WS_BOMBEND: "Перед взрывом",
  T_37_WZY_WS_BOMBSTART: "Индикатор бомбы",
  T_37_WZY_WS_CHANENT: "Сущность Канал",
  T_37_WZY_WS_CHEER: "Поддержка",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Проверить, содержит ли выбранная сущность определённые тэги",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "Проверить наличие тэгов у сущности",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "Тэг для проверки",
  T_37_WZY_WS_CHELABELRES: "Результат проверки тэга. Булев тип",
  T_37_WZY_WS_CJERSEY_NAME: "Изменить форму",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "Игрок, чья форма будет изменена",
  T_37_WZY_WS_CJERSEY_PARAM2: "Дизайн Формы",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "Изменить дизайн на",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "Цвет 1-й части формы",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "Цвет 2-й части формы",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "Цвет 3-й части формы",
  T_37_WZY_WS_CJERSEYTYPE1: "Дизайн 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Дизайн 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Дизайн 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Стереть все элементы списка",
  T_37_WZY_WS_CREABLEOB_DESC: "Тип объекта, который можно собрать из блоков",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Создать изменяемый товар и вернуть сущность товара. Характеристики товара можно поменять в Настройках Свойств.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Создать изменяемый список товаров и вернуть сущность списка товаров. Характеристики списка можно поменять в Настройках Свойств.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "Сущность списка товаров, который нужно создать",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Создать сущность фракции",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "Сущность фракции, который нужно создать",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Создать изменяемый магазин и вернуть сущность магазина. Характеристики магазина можно поменять в Настройках Свойств.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "Созданная сущность магазина",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Изменение времени суток в игре. Можно выбрать день, сумерки или ночь.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "Желаемое время суток. Можно выбрать день, сумерки или ночь.",
  T_37_WZY_WS_DARKNESS: "Общее затемнение",
  T_37_WZY_WS_DELENT_NAMEDESC: "Удалить определённую сущность. Поддерживает следующие сущности: иконки, текст, HUD, оружие и другие.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "Сущность к удалению",
  T_37_WZY_WS_DROP: "Ошибка",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Запускается, когда у игрока выпадает предмет. [Тип предмета] это ID типа предмета, который выпал.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "ID типа предмета, который выпал",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Запускается, когда у игрока выпадает оружие. [Сущность оружия] это оружие, которое выпало у игрока.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "Оружие, которое выпало у игрока",
  T_37_WZY_WS_DUMMYLEOBJ: "Объект обычного уровня",
  T_37_WZY_WS_DUST: "Сумерки",
  T_37_WZY_WS_EMPTYCH: "Пустой канал по умолчанию",
  T_37_WZY_WS_EMPTYCH1: "Пустой канал 1",
  T_37_WZY_WS_EMPTYCH2: "Пустой канал 2",
  T_37_WZY_WS_EMPTYCH3: "Пустой канал 3",
  T_37_WZY_WS_EMPTYCH4: "Пустой канал 4",
  T_37_WZY_WS_EMPTYCH5: "Пустой канал 5",
  T_37_WZY_WS_EMPTYCH6: "Пустой канал 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Получи список, включающий все сущности, удовлетворяющие 3-м условиям. Содержание, вставленное в "Включает всё", "Исключает" и "Включает" - это один тип компонента или список типов компонента. Вернувшийся результат - это список сущностей, которые удовлетворяют условиям.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "Отфильтрованные сущности должны содержать все компоненты из этого массива",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "Отфильтрованные сущности не должны содержать компонентов из этого массива",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "Отфильтрованные сущности должны содержать хотя бы один компонент из этого массива",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "Тип свойств сущности для изменения",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "Значение свойства для изменения",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Позволяет игроку покинуть этот канал, оставляя его вне всех каналов",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "Игрок, который должен покинуть канал",
  T_37_WZY_WS_FAKEENT: "Сущность маскировка",
  T_37_WZY_WS_FIND_STR_DESC: "Поиск местоположения определённого текста в строке",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "Персонаж для поиска",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Найти строку стартовой локации, которая начинается с 0.",
  T_37_WZY_WS_FINDSTRRES: "Первая локация, где найдена искомая строка. Начинается с 0.",
  T_37_WZY_WS_FOGCOLOR: "Цвет тумана",
  T_37_WZY_WS_FRICTIONCON: "Стандартный множитель силы трения",
  T_37_WZY_WS_FRICTIONIMP: "Множитель силы трения для столкновения",
  T_37_WZY_WS_FROMDEATH: "Возрождение",
  T_37_WZY_WS_FROMKNODOWN: "Подъём",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Получить канал, в котором находится определённый игрок",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "Сущность Игрок, чей канал нужно получить",
  T_37_WZY_WS_GETCHANRES: "Канал, в котором находится игрок",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "В соответствии с ID канала с 1 по 8, получи пустой канал, созданный по умолчанию в начале игры",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID пустого канала по умолчанию",
  T_37_WZY_WS_GETEMPTYCH_RES: "Полученная сущность канала",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Получить сущность маскировки",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "Получить объект сущности маскировки",
  T_37_WZY_WS_GETGAMEENT_NAME: "Получить глобальные",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Получить сущность игры этого матча",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Получить доступного для атаки игрока",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Сущность фракции",
  T_37_WZY_WS_GOAL_NAMEDESC: "Запускается, когда мяч попадает в ворота. [Ворота] - те ворота, в которые попадает мяч. [Бомбардир] - это игрок, который последним взаимодействовал с мячом. [Поддержка] это игрок, который предпоследним взаимодействовал с мячом.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "Ворота, куда входит мяч",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "Игрок, который последним контактировал с мячом",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "Игрок, который предпоследним контактировал с мячом",
  T_37_WZY_WS_HEARTBEAT: "Сердцебиение",
  T_37_WZY_WS_HEAVYWEAPON: "Тяжёлое Оружие",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Наименьший воздушный угол",
  T_37_WZY_WS_HOSTPLA: "Список игроков для атаки",
  T_37_WZY_WS_HOSTSIDE: "Список фракций для атаки",
  T_37_WZY_WS_HOSTTEAM: "Список команд для атаки",
  T_37_WZY_WS_ICON_CLOCK: "Отсчёт",
  T_37_WZY_WS_ICON_CLOTHES: "Одежда",
  T_37_WZY_WS_ICON_QUIT: "Выход",
  T_37_WZY_WS_INSERT_ARR_DESC: "Добавление нового элемента в определённое место в списке",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Извлечение строки определённой длины, начиная с расположения индекса. Если извлекаемая длина превышает длину строки, произойдёт извлечение контента до конца строки.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Длина извлечения",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "Строка, которая была извлечена",
  T_37_WZY_WS_INTORINTL: "Целое число или список целых чисел",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Позволить игроку присоединиться к определённой фракции",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "Фракция для присоединения",
  T_37_WZY_WS_JUMP: "Прыжок",
  T_37_WZY_WS_LABEL: "Тэг",
  T_37_WZY_WS_LENSFLARE: "Блик объектива",
  T_37_WZY_WS_LENTH: "Длина",
  T_37_WZY_WS_LIGHTATTACK: "Успешное попадание",
  T_37_WZY_WS_LIGHTCOLOR: "Цвет источника света",
  T_37_WZY_WS_LIGHTINTENSITY: "Яркость источника света",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Загрузить новое окружение",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "Название окружения для загрузки",
  T_37_WZY_WS_MOROBJECT: "Маскировка объекта",
  T_37_WZY_WS_MOVEAXISX: "Движение вдоль оси x",
  T_37_WZY_WS_MOVEAXISY: "Движение вдоль оси y",
  T_37_WZY_WS_MOVEAXISZ: "Движение вдоль оси z",
  T_37_WZY_WS_MOVEDISTITLE: "Дистанция движения",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Вкл. или Выкл. сообщений",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Вкл./Выкл. сообщений. Когда отключено, интерфейс сообщений недоступен, и игроки не могут отправлять и получать сообщения",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "Игрок для включения или отключения сообщений",
  T_37_WZY_WS_MUTEVOICE_NAME: "Включить или отключить голосовой чат",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Вкл./Выкл. голосового чата. Когда отключено, интерфейс голосового чата недоступен, и игроки не могут отправлять и получать голосовые сообщения.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "Игрок для включения или отключения голосового чата",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Булев тип. TRUE = выкл., FALSE = вкл.",
  T_37_WZY_WS_NIGHTMODE: "Ночной режим",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Запускается, когда игрок прицеливается в доступную для прицела сущность. [Целевая Сущность] - это сущность, в которую прицеливаются. Если ни одна сущность не является объектом прицеливания, возвращаемый результат равен нулю.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Сущность под прицелом",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "Сущность, в которую произошло попадание из оружия",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Запускается, когда окружение успешно загружается",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "Название окружения для загрузки. Это строка.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Запускается, когда окружение успешно меняется",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "Название нового окружения. Это строка.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Вернуть одежду игрока к дефолтному виду",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "Игрок, для которого нужно восстановить одежду по умолчанию",
  T_37_WZY_WS_PETSET: "Настройки Питомца",
  T_37_WZY_WS_PETSKILL: "Навыки Питомца",
  T_37_WZY_WS_PETSWITCH2: "Возможность использовать навык",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Включение или отключение движения игрока. Булев тип",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Тип возможностей игрока",
  T_37_WZY_WS_PRESS: "Лёгкий клик",
  T_37_WZY_WS_PROGRESS: "Текущий прогресс",
  T_37_WZY_WS_PROGRESSBAR: "Сущность шкалы HUD",
  T_37_WZY_WS_RANKDOWN: "Понижение ранга",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Убрать тэг с выбранной сущности",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "Текстовый контент к удалению",
  T_37_WZY_WS_REPLACE_STR_DESC: "Заменить контент строки на определённый контент",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "Персонаж для замены",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "Новый персонаж на замену",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Обратить все элементы списка",
  T_37_WZY_WS_REVIVEHERE: "Игрок, возрождающий членов команды на точке возрождения",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Запускается, когда игрок возрождает членов команды на этой точке возрождения",
  T_37_WZY_WS_REVIVEWAYDESC: "Способ, которым игрок был возрождён или поднят из нокдауна",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Конфигурация статуса возможностей для игроков. В отключенном состоянии соответствующие кнопки интерфейса будут недоступны, ручные и автодействия будут отключены. В скрытом состоянии соответствующие кнопки интерфейса не будут отображаться, и только автодействия останутся доступны. Во включенном состоянии соответствующие кнопки будут отображаться в интерфейсе, и все типы действий будут доступны.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "Игрок для установки статуса возможностей",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "Возможности игрока, влючая движение, атаку, прыжки, бег",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Статус показывает отключенные, скрытые и включенные возможности. В скрытом состоянии соответствующие кнопки интерфейса не будут отображаться, и только автодействия останутся доступны. Во включенном состоянии соответствующие кнопки будут отображаться в интерфейсе, и все типы действий будут доступны",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "Координаты мяча",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Должен ли футбольный мяч поддерживать свою скорость до настройки. Это значение Boolean.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Настройки атаки игрока",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Конфигурация возможности  [Настраиваемого игрока] атаковать [Целевого игрока]. Настройки по умолчанию основаны на том, принадлежит ли целевой игрок к команде и фракции, доступной для атаки. Эта настройка имеет более высокий приоритет, чем настройка команды/фракции.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "Игрок для конфигурации противников",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "Игрок, который является противником",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Доступно или нет для атаки",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"ДА" означает доступно для атаки, "НЕТ" означает недоступно. Настройки по умолчанию основаны на том, принадлежит ли целевой игрок к команде и фракции, доступной для атаки.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"ДА" означает доступно для атаки, "НЕТ" означает недоступно.',
  T_37_WZY_WS_SHADOWSTRENGTH: "Тени",
  T_37_WZY_WS_SHOOTANGLE: "Наименьший угол стрельбы",
  T_37_WZY_WS_SKYBOX: "Небо",
  T_37_WZY_WS_SKYBOXENT: "Сущность Небо",
  T_37_WZY_WS_SKYBOXTYPE: "Базовые типы неба",
  T_37_WZY_WS_STEPPED: "Триггер",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Сменить канал голосового чата для игрока",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "Игрок, для которого производится смена канала",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "Канал, на который производится смена",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Заменить на определённое окружение",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "Название окружения для замены",
  T_37_WZY_WS_TARGETSTR_DESC: "Целевая строка",
  T_37_WZY_WS_TEAMASIDE: "Команда и Фракция",
  T_37_WZY_WS_TELEPORTN_AUTO: "Авто",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Телепортируемо или нет",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Вручную",
  T_37_WZY_WS_TELEPORTN_NO: "Нет",
  T_37_WZY_WS_TELEPORTN_TITLE: "Способ телепорта",
  T_37_WZY_WS_TELEPORTN_YES: "Да",
  T_37_WZY_WS_TERRAINWET: "Влажность почвы",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Заменить внешний вид [Сущности игрока] на внешний вид [Объекта окружения]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "Сущность игрока для смены внешности",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "Игрок для получения маскировочной сущности",
  T_37_WZY_WS_TRANSP: "Прозрачность",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Удалить определённое окружение",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "Название окружения для удаления",
  T_37_WZY_WS_VFX1: "Символика",
  T_37_WZY_WS_VFX2: "Дымка",
  T_37_WZY_WS_VFX3: "Проклятие",
  T_37_WZY_WS_VFX5: "Лёд",
  T_37_WZY_WS_VFX6: "Софиты",
  T_37_WZY_WS_VFX7: "Восходящая Турбулентность",
  T_37_WZY_WS_VFX8: "Взрыв Атмосферы",
  T_37_WZY_WS_VISABLE: "Видимость",
  T_37_WZY_WS_WEAOPEN: "Показать или нет",
  T_37_WZY_WS_WEAPONENT: "Сущность Оружие",
  T_37_WZY_WS_WEATARGETED: "Может ли являться целью автоприцела",
  T_37_XYL_CUSTOMJERSEY: "Формашина",
  T_37_XYL_CUSTOMJERSEY_DESC: "Используй Формашину, чтобы создать свою идеальную форму",
  T_37_XYL_FOOTGUN: "Мяч-Пушка",
  T_37_XYL_SOCCER: "Мяч",
  "T_37_XYL_SOCCER_ RADIUS": "Радиус",
  T_37_XYL_SOCCER_DESC: "Мяч с настраиваемыми характеристиками",
  T_37_XYL_SOCCER_HIGHT1: "Стандартный угол",
  T_37_XYL_SOCCER_HIGHT2: "Удар в воздухе",
  T_37_XYL_SOCCER_RESET: "Перезапуск времени после гола (с)",
  T_37_XYL_SOCCER_RESIST1: "Сила Трения (Удар Ногой)",
  T_37_XYL_SOCCER_RESIST2: "Сила Трения (Режим Пушки)",
  T_37_XYL_SOCCERGOAL: "Гол",
  T_37_XYL_SOCCERGOAL_DESC: "Это гол. Shoot the football into the goal to score. (Only valid in Points Grab.)",
  T_37_XYL_SOCCERITEM: "Появление Предмета",
  T_37_XYL_SOCCERITEM_DESC: "После установки сгенерирует выбранный предмет",
  T_37_XYL_SPAWN_PEOPLE: "# игроков",
  T_37_XYL_WS_AIRCONDITIONER001: "Кондиционер В",
  T_37_XYL_WS_AMMUCHEST: "Боевой Лутбокс А",
  T_37_XYL_WS_BAFFLE001: "Барьер А",
  T_37_XYL_WS_BARREL001: "Бочки",
  T_37_XYL_WS_BARREL001_DES: "Деревянные бочки, которые можно встретить где угодно",
  T_37_XYL_WS_BOARD001: "Доска Объявлений А",
  T_37_XYL_WS_BOOK001: "Стопка Книг А",
  T_37_XYL_WS_BOOK002: "Настольная Игра A",
  T_37_XYL_WS_BOUGAINVILLEA: "Бугенвиллея",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Декор - украшает это место!",
  T_37_XYL_WS_BOX001: "Ящики А",
  T_37_XYL_WS_BOX002: "Небольшая Коробочка",
  T_37_XYL_WS_BUSHCOVER: "Заросли",
  T_37_XYL_WS_BUSHCOVER_DES: "Заросли, в которых можно прятаться",
  T_37_XYL_WS_CABINET001: "Шкаф А",
  T_37_XYL_WS_CHAIR001: "Кресло А",
  T_37_XYL_WS_COCONUTTREE: "Кокосовая Пальма",
  T_37_XYL_WS_COCONUTTREE_DES: "Декор - для пляжного настроения!",
  T_37_XYL_WS_COMPUTER001: "Компьютер А",
  T_37_XYL_WS_DAMAGERATIO: "Коэффициент урона",
  T_37_XYL_WS_FIREEX: "Огнетушитель",
  T_37_XYL_WS_GUIDEPOSE: "Указатель",
  T_37_XYL_WS_HUGEHOUSE001: "Трёхэтажный Дом Б",
  T_37_XYL_WS_HUGEHOUSE002: "Двухэтажный Дом Б",
  T_37_XYL_WS_JACKSTRAW: "Пугало",
  T_37_XYL_WS_LADDER001: "Лестница А",
  T_37_XYL_WS_OILDRUM: "Небольшая Ёмкость",
  T_37_XYL_WS_ORNAMENT001: "Ваза А",
  T_37_XYL_WS_PACKBOX: "Контейнер Снабжения",
  T_37_XYL_WS_PILLA001: "Бетонный Столб",
  T_37_XYL_WS_PRESENT: "Подарочный Лутбокс",
  T_37_XYL_WS_PRESENT_DES: "Внутри новогодние подарки",
  T_37_XYL_WS_PUMPKIN: "Тыква в квадрате",
  T_37_XYL_WS_PUMPKINCUT: "Фонарь Джека",
  T_37_XYL_WS_PUMPKINCUT_DES: "Традиционное украшение Самого Страшного Праздника",
  T_37_XYL_WS_ROADBLOCK001: "Блокпост В",
  T_37_XYL_WS_SHELF001: "Книжная Полка А",
  T_37_XYL_WS_SOFA001: "Диван А",
  T_37_XYL_WS_SPAWNTEAM: "Все команды",
  T_37_XYL_WS_SUPPLYBOX: "Лутбокс Запасов",
  T_37_XYL_WS_TABLE001: "Стол А",
  T_37_XYL_WS_TABLE002: "Стол Б",
  T_37_XYL_WS_TARGET001: "Цель",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Выход из Портала",
  T_37_XYL_WS_TELEPORTNEW: "Портал А",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Портал, который отправит игрока в конечную точку портала",
  T_37_XYL_WS_TIRES001: "Шина А",
  T_37_XYL_WS_TOOLRACK: "Полка Для Инструментов",
  T_37_XYL_WS_WALL001: "Стена",
  T_37_XYL_WS_WOOD001: "Дрова",
  T_37_XYL_WS_YELLOWDUCK001: "Резиновая Утка",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Спасательный круг в форме утки",
  T_37_YM_BOMBSQUAD_DEFUSER: "Обезвреживатель",
  T_37_YS_B_BRFOOTBALL_WHITE: "Форма CBF",
  T_37_YS_F_B_VN_STREET: "Красный Хошимин (Низ)",
  T_37_YS_F_H_VN_STREET: "Красный Хошимин (Голова)",
  T_37_YS_F_S_VN_STREET: "Красный Хошимин (Обувь)",
  T_37_YS_F_T_VN_STREET: "Красный Хошимин (Верх)",
  T_37_YS_M_A_CRICKET_BLACK: "Чёрно-желтая Бита (Маска)",
  T_37_YS_M_A_THKOL: "Больше Огня (Маска)",
  T_37_YS_M_B_CRICKET_BLACK: "Чёрно-желтая Бита (Низ)",
  T_37_YS_M_B_SILVERERA: "Серебряная Пуля (Низ)",
  T_37_YS_M_B_THKOL: "Больше Огня (Низ)",
  T_37_YS_M_H_SILVERERA: "Серебряная Пуля (Голова)",
  T_37_YS_M_H_THKOL: "Больше Огня (Голова)",
  T_37_YS_M_S_CRICKET_BLACK: "Чёрно-желтая Бита (Обувь)",
  T_37_YS_M_S_SILVERERA: "Серебряная Пуля (Обувь)",
  T_37_YS_M_S_THKOL: "Больше Огня (Обувь)",
  T_37_YS_M_T_CRICKET_BLACK: "Чёрно-желтая Бита (Верх)",
  T_37_YS_M_T_SILVERERA: "Серебряная Пуля (Верх)",
  T_37_YS_M_T_THKOL: "Больше Огня (Верх)",
  T_37_YS_T_BRFOOTBALL_WHITE: "Форма CBF",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Минимум игроков",
  T_38_BQ_SKILL_NAME_DUMMY1: "Каскадёр",
  T_38_BQ_SKILL_NAME_DUMMY2: "Сплит",
  T_38_CJ_F_B_STREAMER_MUSIC: "Стримерша (Низ)",
  T_38_CJ_F_H_STREAMER_MUSIC: "Стримерша (Голова)",
  T_38_CJ_F_S_STREAMER_MUSIC: "Стримерша (Обувь)",
  T_38_CJ_F_T_STREAMER_MUSIC: "Стримерша (Верх)",
  T_38_JH_WS_CM1: "Понятные правила",
  T_38_JH_WS_CM2: "Неясные правила",
  T_38_JH_WS_CM3: "Частые выходы",
  T_38_JL_M79_AMMO_N: "Патроны для M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "Микрочип J.Biebs",
  T_38_M_WS_VECTOR2: "2D Вектор",
  T_38_R_TACTICS_N: "Пресет",
  T_38_RW_NIW_NIWNAME: "Создатель Стен",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Слишком много слоев блоков. Текущий: {0}. Максимальный: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Количество созданных элементов ({0}) превысило лимит ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Количество инцидентов, полученных в одном кадре ({0}), превысило предел ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Достигнут лимит создания динамических сущностей за кадр ({0}); {1} попыток создания отклонены.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Длина инициализированного списка ({0}) превысила предел ({1}). Автоматическое создание списка макс. вместимости.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Количество циклов ({0}) превысило предел ({1}). Цикл прерван",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "Количество параллельных программ ({0}) в области видимости программы превысило предел ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Не удалось добавить элемент в список. Список {0} пуст",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Несовпадение типов значений при выполнении базовой арифметической операции. Левый тип значения - {0}, а правый тип значения - {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Повторяющееся значение временной переменной. Имя переменной: {0}.",
  T_38_SP_WS_REVIEW_01: "Токсично",
  T_38_SP_WS_REVIEW_02: "Вульгарно",
  T_38_SP_WS_REVIEW_03: "Оскорбительно",
  T_38_SP_WS_REVIEW_04: "Супер-токсично",
  T_38_SP_WS_REVIEW_05: "Угроза",
  T_38_SP_WS_REVIEW_06: "Неуважительное",
  T_38_SP_WS_REVIEW_07: "Рассмотрение",
  T_38_SP_WS_REVIEW_08: "{0} имя {1} не соответствует правилам. {2}.",
  T_38_SP_WS_REVIEW_09: "Строка",
  T_38_SP_WS_REVIEW_10: "Магазин",
  T_38_SP_WS_REVIEW_11: "Переменная",
  T_38_SP_WS_REVIEW_12: "Функция",
  T_38_SP_WS_REVIEW_13: "Объект",
  T_38_SP_WS_REVIEW_14: "Перейти в Определение",
  T_38_SP_WS_REVIEW_15: "Перейти в Управление Объектами",
  T_38_SP_WS_REVIEW_16: "Нет направления",
  T_38_SP_WS_REVIEW_17: "Название карты",
  T_38_SP_WS_REVIEW_18: "Описание",
  T_38_SP_WS_REVIEW_19: "Изображение обложки",
  T_38_SP_WS_REVIEW_20: "В тексте есть недопустимые слова",
  T_38_SP_WS_REVIEW_21: "Сохранить не удалось. Отзыв невозможен",
  T_38_SP_WS_REVIEW_22: "Отзыв в режиме ожидания",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Поварёшка",
  T_38_SY_CHARACTER_DESIGNER_N: "Сантино",
  T_38_SY_PET_CACTUS_N: "Кактус",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Скин Питомца: Запретный Кактус",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Скин Питомца: Кактус Мечты",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Скин Питомца: Жаркий Кактус",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Скин Питомца: Стиляга Эрвин",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Скин Питомца: Фестивальный Роки",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Ронин Огня",
  T_38_SY_SICKLE_ES_N: "Серп - Манга",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Грузовичок - Доставка Суши",
  T_38_WT_WS_MUITLEVEL: "Мульти-Уровень",
  T_38_WT_WS_SKILLSET15: "Жажда Жизни (A124)",
  T_38_WT_WS_SKILLSET16: "Сенсорная Перегрузка (Гомер)",
  T_38_WT_WS_SKILLSET17: "Стеклянные Стены (Айрис)",
  T_38_WT_WS_SKILLSET18: "Погоня (Тацуя)",
  T_38_WZY_WS_ACTIVEA: "Можно использовать в  декорациях или нет",
  T_38_WZY_WS_ACTIVEB: "Включить обновление логики или нет",
  T_38_WZY_WS_ACTIVEVALUE: "Статус активности",
  T_38_WZY_WS_AIR: "Воздух",
  T_38_WZY_WS_ALLOWMOVE: "Перемещаемый или нет",
  T_38_WZY_WS_AMMOAMOUNT: "Количество боеприпасов",
  T_38_WZY_WS_AMMONAME: "Сущность боеприпасов",
  T_38_WZY_WS_ARMOR_DAMRED: "Множитель снижения урона",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Множитель снижения урона от взрыва",
  T_38_WZY_WS_ARMOR_DURABILITY: "Текущая прочность",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Макс. прочность",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Повреждаемый или нет",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Разрушаемый или нет",
  T_38_WZY_WS_ARMOR_LEVEL: "Уровень",
  T_38_WZY_WS_ASSCONZOM: "Помощь в устранении зомби",
  T_38_WZY_WS_BAGNAME: "Сущность рюкзака",
  T_38_WZY_WS_BAGSPACEEX: "Дополнительное место в рюкзаке",
  T_38_WZY_WS_BRIDGING: "Компонент рендеринга моста",
  T_38_WZY_WS_BUBBLE: "Пузырь",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Очистить все предметы [player entity's] в рюкзаке",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Убрать ненужные предметы, лежащие по всей карте, такие как лут, остатки метательных предметов и лутбоксы",
  T_38_WZY_WS_CLEARPRO: "Очистить один фактор свойства",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Клонировать [объект окружения] сущность в локации [сущность игрока] и возврат [сущность маскировки]",
  T_38_WZY_WS_COMPONENT: "Компонент",
  T_38_WZY_WS_COSTAMMO: "Потратить боеприпасы",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Создать камеру и вернуть [сущность камеры], свойства которого могут быть изменены с помощью настроек свойств",
  T_38_WZY_WS_CYCLES: "Количество сыгранных игр",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Проверить, находится ли [объект] в пределах кругового полюса. [центр] - центр полюса, [радиус] - радиус круговой поверхности, [высота] - высота полюса, [углы Эйлера] - углы трехмерной ориентации полюса.",
  T_38_WZY_WS_CYLINDERJUD_RES: "Результат проверки охвата кругового полюса. Это булево значение.",
  T_38_WZY_WS_DAMSUMZOM: "Урон по зомби",
  T_38_WZY_WS_DARKNESS: "Тьма",
  T_38_WZY_WS_DIFCOLOR: "Цвет поверхности",
  T_38_WZY_WS_DIFTEXTURE: "Текстура поверхности",
  T_38_WZY_WS_DRUMMUSIC: "Тип компонента: барабаны",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "Игрок, который был отключен",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "Игрок, который переподключается",
  T_38_WZY_WS_EUIANCHOR: "Перечисление типов якорей HUD",
  T_38_WZY_WS_FEATHER: "Перо",
  T_38_WZY_WS_FLAMEAMMO: "Боеприпасы для огнемета",
  T_38_WZY_WS_FLOWER: "Цветок",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Установить [сущность], чтобы она всегда следовала за [преследуемая сущность]. [Координаты смещения] - это расстояние между двумя сущностями.",
  T_38_WZY_WS_FOLLOWENT: "Преследуемая сущность",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Получить сущность камеры, которая в настоящее время используется [сущность игрока]",
  T_38_WZY_WS_GETCURCAMDESC: "Камера, которая в настоящее время используется игроком",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Получить количество предмета [указанный тип предмета], которым владеет [игрок]",
  T_38_WZY_WS_GETITEMNUM_RES: "Количество обозначенного предмета, которым владеет игрок",
  T_38_WZY_WS_GETVEC_NAME: "Получить вектор",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Получить вектор с помощью компонентов x, y и z набора координат",
  T_38_WZY_WS_GETVECRES: "Вектор, полученный из компонентов x, y и z",
  T_38_WZY_WS_GHOST: "Привидение",
  T_38_WZY_WS_GRENADEFROZENNAME: "Сущность крио-гранаты",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Радиус зоны заморозки",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Продолжительность заморозки",
  T_38_WZY_WS_GRENADENAME: "Сущность Граната",
  T_38_WZY_WS_GRENADEPARAM1: "Мин. урон",
  T_38_WZY_WS_GRENADEPARAM2: "Макс. урон",
  T_38_WZY_WS_GRENADEPARAM4: "Дальность взрыва",
  T_38_WZY_WS_GRENADEPARAM5: "Скорость броска",
  T_38_WZY_WS_GRENADEPARAM6: "Задержка взрыва",
  T_38_WZY_WS_GRENADEPARAM7: "Множитель урона по себе",
  T_38_WZY_WS_GRENADEPARAM8: "Множитель урона союзника",
  T_38_WZY_WS_GRENADEPARAM9: "Множитель урона транспорта",
  T_38_WZY_WS_GUNFIRE: "Стрельба",
  T_38_WZY_WS_GUNPRO_PARAM2: "Скорость перезарядки",
  T_38_WZY_WS_GUNPRO_PARAM3: "Соотношение урона выстрелов по телу",
  T_38_WZY_WS_GUNPRO_PARAM4: "Соотношение урона хэдшотов",
  T_38_WZY_WS_GUNPRO_PARAM5: "Соотношение урона выстрелов по конечностям",
  T_38_WZY_WS_GUNPRO_PARAM7: "Дополнительный урон",
  T_38_WZY_WS_HELMET_NAME: "Сущность шлема",
  T_38_WZY_WS_ICON1: "Корона",
  T_38_WZY_WS_ICON2: "Дуэль",
  T_38_WZY_WS_INITPOS: "Исходная Локация",
  T_38_WZY_WS_ISRESET: "Возвратно-поступательное движение",
  T_38_WZY_WS_KILLCONZOM: "Количество устраненных зомби",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Устранить выбранную [сущность], которая должна быть боевым типом сущности. Игнорирует статус неуязвимости.",
  T_38_WZY_WS_LABELPARAM: "Список параметров текстового содержимого",
  T_38_WZY_WS_LEADMUSICA: "Тип компонента: фортепиано (высокие частоты)",
  T_38_WZY_WS_LEADMUSICB: "Тип компонента: фортепиано (альт)",
  T_38_WZY_WS_LEADMUSICC: "Тип компонента: фортепиано (бас)",
  T_38_WZY_WS_LINE: "Линия",
  T_38_WZY_WS_LIQUID: "Жидкость",
  T_38_WZY_WS_LOCALKEY: "Локализованный контент",
  T_38_WZY_WS_LOCALPOS: "Относительная Локация",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Установить [сущность] в направлении от [Сущность под прицелом]. [Координаты смещения] - это разница в координатах точки прицеливания и позиции объекта.",
  T_38_WZY_WS_MAINWEAPONA: "Основное оружие 1",
  T_38_WZY_WS_MAINWEAPONB: "Основное оружие 2",
  T_38_WZY_WS_MOTIONTIME: "Продолжительность движения",
  T_38_WZY_WS_MOTIONTYPE: "Метод движения",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Модифицированная Энергия",
  T_38_WZY_WS_MUSHROOMNAME: "Сущность гриба",
  T_38_WZY_WS_OBFACTION: "Наблюдать за фракцией",
  T_38_WZY_WS_OBGLOBAL: "Наблюдать за всеми",
  T_38_WZY_WS_OBSERVER: "Опции наблюдения",
  T_38_WZY_WS_OBTEAM: "Наблюдать за командой",
  T_38_WZY_WS_OFFSETVEC: "Координаты смещения",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Срабатывает, когда игрок покупает товары из этого торгового автомата. [Сущность игрока] - игрок, совершающий покупку. [Сущность товара] - это купленный предмет.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Срабатывает, когда экипирован [сущность игрока]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Срабатывает, когда игрок завершает действие прыжка",
  T_38_WZY_WS_ONLIE_NAMEDESC: 'Срабатывает, когда игрок завершает действие "лечь на живот"',
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Срабатывает при перезарядке оружия",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Срабатывает, когда игрок завершает действие спринта",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Срабатывает, когда игрок завершает действие приседания",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Срабатывает, когда оружие уничтожает единицу. [Устраненная сущность] - это единица, которая была устранена",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Срабатывает, когда оружие наносит урон боевой сущности. [Цель попадания] - это боевая сущность, которой был нанесен урон. [Урон] - это наносимый урон",
  T_38_WZY_WS_OWNER: "Владелец",
  T_38_WZY_WS_PARAMLIST: "Список параметров",
  T_38_WZY_WS_PARTICALMAP: "Картирование частиц",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Приостановить или возобновить текущую эмоцию для [сущность игрока]. [Пауза или нет] - булево значение. "Да" означает паузу. "Нет" означает возобновление',
  T_38_WZY_WS_PLAENTTRI_DESC: "Активируется, когда игрок входит в триггер",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Активируется при выходе игрока из триггера",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Заставить [сущность игрока] воспроизвести указанную [эмоция] один раз и вернуться в исходное положение после завершения",
  T_38_WZY_WS_PLAYSPEED: "Процент скорости воспроизведения",
  T_38_WZY_WS_PREHUD_NAME: "Иконка предустановки",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Позволить [сущность игрока] покинуть свою текущую фракцию",
  T_38_WZY_WS_RESETENT: "Сброс компонентов каждый раунд",
  T_38_WZY_WS_RESUUID: "UUID ресурса",
  T_38_WZY_WS_RIMCOLOR: "Цвет границы",
  T_38_WZY_WS_RIMTEXTURE: "Текстура границы",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Проверьте, находится ли [сущность] внутри конуса. [центр] и [радиус] - это центр и радиус конуса. Радиус [извлеченный радиус] - это радиус меньшего сектора внутри конуса. Высота - это высота трехмерной структуры. Угол [aугол] - центральный угол конуса. Угол [угол направления] - вектор направления центральной оси",
  T_38_WZY_WS_SECTORJUD_RES: "Результат проверки охвата веерообразной формы. Это булево значение",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Установите статус активности [целевая сущность]. [Статус активности] является булевым значением и влияет на доступность, видимость и возможность столкновения объекта.",
  T_38_WZY_WS_SETROUNDSCORE: "Установить счет раунда для игрока",
  T_38_WZY_WS_SHOOTANGMAX: "Макс. угол стрельбы",
  T_38_WZY_WS_SHOWMAPINFO: "Отображать информацию о карте для одной фракции",
  T_38_WZY_WS_SHOWNAMEHUD: "Отображать HUD для одной и той же фракции",
  T_38_WZY_WS_SOUND1: "Ускорение",
  T_38_WZY_WS_SOUND10: "Старт уровня",
  T_38_WZY_WS_SOUND11: "Зомби",
  T_38_WZY_WS_SOUND12: "Хоррор",
  T_38_WZY_WS_SOUND13: "Трансформация",
  T_38_WZY_WS_SOUND14: "Pounding Heart",
  T_38_WZY_WS_SOUND15: "Среднее сердцебиение",
  T_38_WZY_WS_SOUND16: "Медленное сердцебиение",
  T_38_WZY_WS_SOUND17: "Время Раша",
  T_38_WZY_WS_SOUND18: "Нажать",
  T_38_WZY_WS_SOUND19: "Восстановление навыков",
  T_38_WZY_WS_SOUND2: "Уведомление об исчезновении",
  T_38_WZY_WS_SOUND20: "Присоединиться в игру",
  T_38_WZY_WS_SOUND3: "Визуальные эффекты",
  T_38_WZY_WS_SOUND4: "Ночные щебетания",
  T_38_WZY_WS_SOUND5: "Удар (тупой)",
  T_38_WZY_WS_SOUND6: "Реакция",
  T_38_WZY_WS_SOUND7: "Неожиданная находка",
  T_38_WZY_WS_SOUND8: "Явление",
  T_38_WZY_WS_SOUNDENT: "Сущность музыки",
  T_38_WZY_WS_SPAWNPOS: "Старая Точка Появления",
  T_38_WZY_WS_SPHERENAME: "Базовая сфера",
  T_38_WZY_WS_SPHERERADIUS: "Радиус сферы",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Проверьте, находится ли [сущность] внутри сферической области. [центр] и [радиус] - это центр и радиус сферической структуры.",
  T_38_WZY_WS_SPHERICALJUD_RES: "Результат проверки сферического охвата. Это булево значение.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Проверить, находится ли [сущность] внутри области действия куба. Центр [центр] - это центр куба, [длина], [ширина] и [высота] - длина, ширина и высота куба, а [углы Эйлера] - углы трехмерной ориентации куба.",
  T_38_WZY_WS_SQUAREJUD_RES: "Результат проверки кубического охвата. Это булево значение.",
  T_38_WZY_WS_STARTGENTIME: "Время старта появления",
  T_38_WZY_WS_STAYTIME: "Продолжительность паузы",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Переключить камеру игрока на [сущность камеры]. [Режим переключения] может быть либо без анимации, либо с поступательным движением. [Время переключения] - это время переключения в режиме поступательного движения.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: 'Переключить режим камеры. Можно выбрать между режимами "Без анимации" и "Поступательное движение"',
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'Время переключения в режиме поступательного движения. При выборе "без анимации" эта настройка не действует.',
  T_38_WZY_WS_TEXTHUD: "Компонент текста HUD",
  T_38_WZY_WS_TEXTTYPE: "Размер шрифта",
  T_38_WZY_WS_TEXTUREID: "Тип текстуры",
  T_38_WZY_WS_TRANDIST: "Макс. дистанция",
  T_38_WZY_WS_TWEENERENABLED: "Включать скрипт UITweener или нет",
  T_38_WZY_WS_TYPELIST: "Список типов",
  T_38_WZY_WS_TYPELISTORLIST: "Тип или список типов",
  T_38_WZY_WS_VEST_NAME: "Сущность бронежилета",
  T_38_WZY_WS_VFX1: "Устранение спрятавшихся",
  T_38_WZY_WS_VFX10: "Циклическое горение",
  T_38_WZY_WS_VFX11: "Ядовитый газ",
  T_38_WZY_WS_VFX13: "Сердце",
  T_38_WZY_WS_VFX15: "Дверь",
  T_38_WZY_WS_VFX2: "Катаклизм",
  T_38_WZY_WS_VFX3: "Устранение клона",
  T_38_WZY_WS_VFX4: "Обратная связь по удару",
  T_38_WZY_WS_VFX5: "Клон",
  T_38_WZY_WS_VFX6: "Маскировка",
  T_38_WZY_WS_VFX7: "Искры от светошумовой гранаты",
  T_38_WZY_WS_VFX8: "След движения",
  T_38_WZY_WS_VFX9: "Огненный заряд",
  T_38_WZY_WS_VFXENT: "Пример визуальных эффектов",
  T_38_WZY_WS_VFXTYPEA_NAME: "Настраиваемое отображение VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Ненастраиваемое отображение VFX",
  T_38_WZY_WS_VISIBILITY: "Тип видимости",
  T_38_WZY_WS_VOLUME: "Громкость",
  T_38_WZY_WS_WEAPONGEN: "Генератор Оружия",
  T_38_WZY_WS_WHECYCLE: "Повтор или нет",
  T_38_XXJ_WS_BLOCKMODE: "Заблокированный Режим",
  T_38_XXJ_WS_CUSTOMCAMARA: "Настраиваемая Камера",
  T_38_XXJ_WS_FFCLASSIC: "Классика FF (Стрельба)",
  T_38_XXJ_WS_FOV: "Поле Зрения",
  T_38_XXJ_WS_FOVDESC: "Поле зрения - это зона видимости камеры",
  T_38_XXJ_WS_FPS: "От Первого Лица",
  T_38_XXJ_WS_HORIZONTALANGLE: "Горизонтальный Угол",
  T_38_XXJ_WS_INVISICAM: "Полупрозрачный",
  T_38_XXJ_WS_OFFSET: "Смещение",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Орфография",
  T_38_XXJ_WS_PERSPECTIVE: "Перспектива",
  T_38_XXJ_WS_PROJECTIONMODE: "Режим Проекции",
  T_38_XXJ_WS_STABLE: "Исправлено",
  T_38_XXJ_WS_STARTCAMERA: "Камера По Умолчанию",
  T_38_XXJ_WS_STARTCAMERAMODE: "Режим Камеры По Умолчанию",
  T_38_XXJ_WS_THIRD: "Следовать за Камерой",
  T_38_XXJ_WS_TOPVIEW: "Большой Угол",
  T_38_XXJ_WS_TPS: "От Третьего Лица",
  T_38_XXJ_WS_TRANSVERSE: "Горизонтальное Движение",
  T_38_XXJ_WS_VERTICALANGLE: "Вертикальный Угол",
  T_38_XXJ_WS_ZOOM: "Масштаб",
  T_38_XYL_WS_AISTARTTIME: "Время начала (с)",
  T_38_XYL_WS_ARMORDESTROY: "Бонус Бронебойности",
  T_38_XYL_WS_BONFIRE: "Костёр",
  T_38_XYL_WS_CANDLE01: "Свечка",
  T_38_XYL_WS_CANNON01: "Механическая Пушка",
  T_38_XYL_WS_CLIPAMMOSIZE: "Место в магазине",
  T_38_XYL_WS_DAMAGEDTRUCK: "Сломанный Грузовик",
  T_38_XYL_WS_DOLL01: "Пугающая Кукла",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Кирпичный Дом А",
  T_38_XYL_WS_FENCE002: "Железный Забор Б",
  T_38_XYL_WS_FIREWORK01: "Фейерверки А",
  T_38_XYL_WS_GENERATOR: "Генератор",
  T_38_XYL_WS_GRAVITY: "Усиление Гравитации",
  T_38_XYL_WS_GRAVITYAREA: "Зона Нестандартной Гравитации",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Зона, где игроки могут менять гравитацию",
  T_38_XYL_WS_HOLDWEAPON: "Оружие в Руках",
  T_38_XYL_WS_INDOORFURNITURE: "Мебель",
  T_38_XYL_WS_LIGHTTUBE001: "Столб Света А",
  T_38_XYL_WS_LOVEBALLOON01: "Шарик Влюблённых А",
  T_38_XYL_WS_LOVELAMP01: "Огни Сердечки",
  T_38_XYL_WS_LOVESIGN01: "Неоновый свет любви",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Процент Повреждения Бочки",
  T_38_XYL_WS_OUTDOORPROPS: "Предметы",
  T_38_XYL_WS_PIPEANDBOX: "Трубы и контейнеры",
  T_38_XYL_WS_PLANT: "Растения",
  T_38_XYL_WS_ROSE01: "Роза",
  T_38_XYL_WS_ROSEN: "Букет Роз",
  T_38_XYL_WS_SMALLBUILDING: "Небольшие здания",
  T_38_XYL_WS_SOFA002: "Диван Б",
  T_38_XYL_WS_TOWNHOUSE01: "Старое 2-Этажное Здание",
  T_38_XYL_WS_TV001: "Старый телик",
  T_38_ZP_CC_EXCHANGESTATUS: "Статус",
  T_39_BQ_SKILL_NAME_VILLAIN: "Алая Ярость",
  T_39_CJ_A_BURN: "Знак Победы",
  T_39_HJ_WS_Arrow002: "Стрела 2",
  T_39_HJ_WS_LIKERATE2: "{0} минут",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} минут",
  T_39_HJ_WS_SOUND10: "Шаг",
  T_39_HJ_WS_SOUND11: "Миссия Выполнена 1",
  T_39_HJ_WS_SOUND13: "Предупреждение об опасности 1",
  T_39_HJ_WS_SOUND14: "Предупреждение об опасности 2",
  T_39_HJ_WS_SOUND15: "Обратный отсчет 3",
  T_39_HJ_WS_SOUND16: "Звуки Подсказок",
  T_39_HJ_WS_SOUND17: "Карканье ворон",
  T_39_HJ_WS_SOUND18: "Звук телепортации в неправильную область",
  T_39_HJ_WS_SOUND19: "Звук телепортации в нужную область",
  T_39_HJ_WS_SOUND2: "Обратный отсчет 1",
  T_39_HJ_WS_SOUND20: "Телепорт",
  T_39_HJ_WS_SOUND21: "Электрошок",
  T_39_HJ_WS_SOUND23: "Получить предмет",
  T_39_HJ_WS_SOUND24: "Фоновая музыка - Электронная",
  T_39_HJ_WS_SOUND25: "Фоновая музыка для казуальных игр",
  T_39_HJ_WS_SOUND4: "Эхо механизмов",
  T_39_HJ_WS_SOUND5: "Комар",
  T_39_HJ_WS_SOUND6: "Динь-Динь-Динь 1",
  T_39_HJ_WS_SOUND7: "Динь-Динь-Динь 2",
  T_39_HJ_WS_SOUND8: "Включено переключение снаряжений",
  T_39_HJ_WS_SOUND9: "Заряд 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Бесконечные Стены",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Бесконечные Метательные снаряды",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Спец. звук стрельбы",
  T_39_HQ_UGC_CUSTOMRES: "Пользовательские ресурсы",
  T_39_M_ACCOUNTID: "Аккаунт",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Выполнить после двойного нажатия",
  T_39_MF_SKILLTAG_4: "Движение",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "После нокаута, пометьте их противников в радиусе [FFB300]{0}м[-] от сбитого врага и замедлите их скорость передвижения на [FFB300]{1}%[-]. Действует в течение [FFB300]{2}с[-]. Когда противник сбит с ног, пометьте и замедлите соперника и его напарников.",
  T_39_QL_SKILL_WOLFRAHH_DES: "После нокдауна соперника войдите в режим Лучших Моментов, который увеличивает скорострельность на [FFB300]{0}%[-] и скорость передвижения на [FFB300]{1}%[-], но затем быстро затухает. Длится [FFB300]{2}с[-]. Во время режима Лучших моментов последовательный нокдаун сбрасывает отсчет и дополнительно увеличивает скорострельность на [FFB300]{3}%[-] и скорость передвижения на [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Экстрим-режим: Получи [FFB300]{0} временных ХП[-] на [FFB300]{1}с[-]. В течение этого времени эффекты исцеления ХП увеличиваются на [FFB300]{2}%[-]. Восст. [FFB300]{3}с[-].",
  T_39_RW_GM_DEFEAT: "Не удалось",
  T_39_RW_SKILL_DESC_FORD: "Получая урон, вы получайте [FFB300]{1}ХП/сек[-]  в течение [FFB300]{0}сек[-]. Пассивный навык сбрасывается сразу после того, как вы используете активный навык. Восстановление: [FFB300]{2}с[-].",
  T_39_SP_WS_ITEMENTITY_01: "Сущность предмета",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: "Альваро Детонатор",
  T_39_SY_CHARACTER_VILLAIN_N: "Орион",
  T_39_SY_KATANA_FASTBREAKING23_N: "Катана - 1001 Ночь",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Скин Питомца: Зеленый Эрвин",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Скин Питомца: Королевский Тиго",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Скин Питомца: Укус Скорпиона",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Монстр-трак - Зелёный Великан",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Тук-Тук - Цветочная Колесница",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Пробуждение: За [FFB300]{0}с[-] до взрыва граната создаст доп. [FFB300]{1}[-] гранат, которые могут нанести [FFB300]{2}%[-] урона от первоначального.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Сплит-блиц",
  T_39_WT_WS_EMPTYMAP_TAG: "Пустое пространство",
  T_39_WT_WS_FEMAPMODE: "Название режима",
  T_39_WT_WS_FEMAPTAG: "Метка карты",
  T_39_WT_WS_MAPPLAYER: "Количество игроков",
  T_39_WT_WS_MEDENTERNUM: "Ограничение на кол-во присоединившихся игроков в середине игры",
  T_39_WT_WS_MIDENTER: "Присоединение в середине игры",
  T_39_WT_WS_MIDENTERCOUNT: "Квота на присоединение в середине игры",
  T_39_WT_WS_MIDENTERTIME1: "Ограничение по времени присоед. в игру в середине",
  T_39_WT_WS_MIDENTERTIME2: "Продолжительность присоединения в середине игры",
  T_39_WT_WS_MIDENTERTIMETIP: "Если лимит количества игроков на карте не достигнут, разреши игрокам присоединяться в течение N секунд после начала матча. Игроки не могут присоединиться после N сек.",
  T_39_WT_WS_MIDENTERTIP: "Если включено, игроки могут присоединиться к этой карте в середине игры",
  T_39_WT_WS_PLAYERCOUNT: "Исходный номер игрока",
  T_39_WT_WS_PLAYERCOUNTTIP: "Количество игроков на момент начала матча. В середине игры могут присоединиться другие игроки, пока не будет достигнут предел карты.",
  T_39_WT_WS_TAG1: "Всеобщ. Потасовка",
  T_39_WT_WS_TAG10: "Легкий",
  T_39_WT_WS_TAG11: "Средне",
  T_39_WT_WS_TAG12: "Тяжелый",
  T_39_WT_WS_TAG13: "Очень сложно",
  T_39_WT_WS_TAG14: "Побег",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Пользовательские ресурсы",
  T_39_WT_WS_TAG18: "Головоломки",
  T_39_WT_WS_TAG19: "Гонки",
  T_39_WT_WS_TAG2: "Перестрелка",
  T_39_WT_WS_TAG20: "Музыка",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Приключение",
  T_39_WT_WS_TAG23: "Охота на Зомби",
  T_39_WT_WS_TAG24: "ПвП",
  T_39_WT_WS_TAG25: "Совместная игра",
  T_39_WT_WS_TAG26: "Ком. Бой Насмерть",
  T_39_WT_WS_TAG27: "Защита Турелей",
  T_39_WT_WS_TAG28: "Тренировка",
  T_39_WT_WS_TAG3: "Оружейный Барон",
  T_39_WT_WS_TAG4: "Возрождение",
  T_39_WT_WS_TAG5: "Снайпер",
  T_39_WT_WS_TAG6: "Выживание",
  T_39_WT_WS_TAG7: "Соло",
  T_39_WT_WS_TAG8: "Хоррор",
  T_39_WT_WS_TAG9: "Обычный",
  T_39_WT_WS_TAGMAXTIP: "Выбери до {0} тегов",
  T_39_WT_WS_TAGTYPE1: "Тип геймплея",
  T_39_WT_WS_TAGTYPE2: "Тип Карты",
  T_39_WT_WS_TAGTYPE3: "Тип режима",
  T_39_WT_WS_TAGTYPE4: "Размер Команды",
  T_39_WZY_WS_ACCSPEED: "Ускорение",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Добавить скрипт [Название скрипта] для [Сущность]",
  T_39_WZY_WS_ASC: "Восхождение",
  T_39_WZY_WS_ASCIGZERO: "Игнорировать ноль при восхождении",
  T_39_WZY_WS_BALLISTMOVENT: "Сущность баллистического движения",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Срабатывает, когда предмет используется [Сущность игрока]",
  T_39_WZY_WS_BODYSCALE: "Шкала тела",
  T_39_WZY_WS_BRAKETORQUE: "Мощность тормозов",
  T_39_WZY_WS_CAMTRANTYPE: "Тип перехода камеры",
  T_39_WZY_WS_CARVEHICLE: "4-колесный",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Проверь, существует ли указанный скрипт [Название скрипта] в [Сущность]. (Возвращаемое значение должно быть булевым)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Проверь, есть ли у сущности результат указанного сценария (булевое значение)",
  T_39_WZY_WS_COMBINEALL: "Оружие в двух руках (Разные оружия)",
  T_39_WZY_WS_COMBINESELF: "Оружие в двух руках (Разные оружия)",
  T_39_WZY_WS_CONENAME: "Базовый конус",
  T_39_WZY_WS_COORSYS: "Система координат",
  T_39_WZY_WS_CRASHMAXD: "Макс. повреждение при столкновении",
  T_39_WZY_WS_CRASHMIND: "Мин. повреждение при столкновении",
  T_39_WZY_WS_CRAWLSPEED: "Процент скорости движения (Лежа на животе)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Создание баллистического движение для [Целевая сущность]. Можно редактировать [Начальная скорость], [Ускорение] и [Макс. расстояние], накопленные в направлении начальной скорости для целевого объекта, и вернуть [Сущность баллистического движения]",
  T_39_WZY_WS_CRETWEEN_NAME: "Создание интерполяционного движения",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Создать интерполяционное движение для [Сущность], с [Атрибуты] сущности, плавно перемещающейся от [Начальное значение] до [Целевое значение] в течение [Время]. [Метод] представляет способ движения, включая [В один конец], [Пинг-понг], [Цикл]. [Кривая] - это кривая движения. А [ Интерполяционный объект движения] будет возвращен после создания движения.",
  T_39_WZY_WS_CURVE: "Кривая",
  T_39_WZY_WS_CUSTRESULT: "Результат пользовательского матча",
  T_39_WZY_WS_CYLINDERNAME: "Базовый цилиндр",
  T_39_WZY_WS_DEFAULT: "Нет анимации (По умолчанию)",
  T_39_WZY_WS_DESC: "Спуск",
  T_39_WZY_WS_DIFFUSEALPHA: "Прозрачность поверхности",
  T_39_WZY_WS_DISCONNECT: "Потеря соединения",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Восстановление энергии в секунду",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Потреблять энергию",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Максимальная высота второго прыжка",
  T_39_WZY_WS_ENABLEJOIN: "Разрешить присоединение на середине",
  T_39_WZY_WS_ENDPOS: "Координаты конечной точки",
  T_39_WZY_WS_ENGINETORQUE: "Мощность двигателя",
  T_39_WZY_WS_EXPLODED: "Урон от взрыва",
  T_39_WZY_WS_FEELDSPEED: "Процент скорости движения (Упавший)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Время вспышки по центру",
  T_39_WZY_WS_FLASH_CRANGE: "Центральный диапазон",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Время вспышки по краям",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Эффект попадания светошумовой гранаты",
  T_39_WZY_WS_FLASH_RANGE: "Дальность взрыва",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Скорость спуска",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Макс. высота над уровнем моря",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Горизонтальная скорость скольжения",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Вертикальная скорость скольжения",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Минимальная высота торца",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Минимальная высота взлета",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Скорость спуска после сверхвысоты",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Скорость поворота",
  T_39_WZY_WS_FOLMOVENT: "Сущность движения позиционного следования",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Получить Список Навыков [Сущность Игрока]",
  T_39_WZY_WS_HB_BOOSTCD: "Перезарядка бега",
  T_39_WZY_WS_HB_BOOSTDURATION: "Продолжительность бега",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Перезарядка ускорения доски",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Перезарядка ускорения доски",
  T_39_WZY_WS_HB_BOOSTSPEED: "Скорость бега",
  T_39_WZY_WS_HB_HOVERBCD: "Перезарядка доски",
  T_39_WZY_WS_HB_JUMPCD: "Перезарядка прыжка",
  T_39_WZY_WS_HB_JUMPH: "Высота прыжка с доской",
  T_39_WZY_WS_HEADSCALE: "Шкала головы",
  T_39_WZY_WS_HEADSHOTDESCALE: "Снижение урона хэдшота",
  T_39_WZY_WS_INTITALSPEED: "Начальная скорость",
  T_39_WZY_WS_INVENTORYBASE: "Основные типы предметов",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Затраты энергии в сек.",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Базовая горизонтальная скорость",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Базовая вертикальная скорость",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Затраты энергии в секунду на рывок",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Горизонтальная скорость спринта",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Расстояние спринта",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Затраты энергии в секунду на Раш",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Вертикальная скорость в спринте",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Затраты энергии на повышение в сек.",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Атакуемый",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Самозапуск",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Может ли быть активировано союзниками",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Срабатывание от транспорта",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Продолжительность",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Время активации",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Радиус срабатывания",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Время срабатывания",
  T_39_WZY_WS_LEAVE: "Выйти",
  T_39_WZY_WS_LIMBSCALE: "Шкала конечностей",
  T_39_WZY_WS_LISTLOCSTR: "Список переведенного текста",
  T_39_WZY_WS_LOADRESULT_NAME: "Загрузить результат боя",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Загрузить результат боя [Игрок], включая [Ранг], [Результат], [Название Счёта], [Значение Счёта]. Тип результата - целое число. 1 - победа, 2 - поражение, 3 - Booyah, 4 - ничья.",
  T_39_WZY_WS_LOOKMOVENT: "Сущность, следящая за движением",
  T_39_WZY_WS_MAXCOUNT: "Максимальное количество",
  T_39_WZY_WS_MAXDISTANCE: "Макс. расстояние",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Угол опускания Турели",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Угловая скорость Турели",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Угол подъема Турели",
  T_39_WZY_WS_MINISENTRY_DAM: "Урон Турели",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Скорость снижения урона",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Угол обстрела",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Скорострельность Турели",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Интервал атаки Турели",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Максимальное количество Турелей",
  T_39_WZY_WS_MINISENTRY_RANGE: "Дальность атаки Турели",
  T_39_WZY_WS_MOVEENT: "Сущность движения",
  T_39_WZY_WS_NOCOMBINE: "Нет двойного оружия",
  T_39_WZY_WS_ONCE: "Однажды",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Срабатывает, когда предмет удаляется [Сущность игрока]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Срабатывает, когда предмет экипируется [Сущность игрока]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Срабатывает, когда Крюковая Пушка стреляет",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Срабатывает при активации Мины",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Срабатывает, когда Мина используется [Сущность игрока]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Срабатывает, когда движение сущности останавливается",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Срабатывает, когда сущность возобновляет движение после остановки",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Срабатывает, когда сущность начинает двигаться",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Срабатывает, когда предмет поднимается [Сущность игрока]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Срабатывает, когда Метательный Снаряд попадает в цель",
  T_39_WZY_WS_OPENATTACK: "Управление возможностью атаки",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Сущность остановки движения или список сущностей движения",
  T_39_WZY_WS_PAUSESOUND_NAME: "Звуковой эффект паузы",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Сущность паузы звука или список звуковых сущностей",
  T_39_WZY_WS_PIANOTYPE: "Тип музыкального компонента",
  T_39_WZY_WS_PINGPONG: "Пинг-понг",
  T_39_WZY_WS_PLAYABLELIST: "Список сущностей движения",
  T_39_WZY_WS_PLAYINGSTATUE: "Статус",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Восстановить сущность остановки движения или лист сущностей движения. Можно выбрать возобновление или перезапуск.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Звуковой эффект игры",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Восстановление приостановленной звуковой сущности или списка звуковых сущностей. Можно выбрать возобновление или перезапуск",
  T_39_WZY_WS_PROCIRCLE_NAME: "Круг Прогресса",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Испускает луч вдоль [Направление] из [Начальные координаты], обнаруживает первый объект, пораженный в пределах [Расстояние], и возвращает [Список пораженных объектов] и [Список координат попаданий].",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Испускает луч вдоль [Направление] из [Начальные координаты], обнаруживает первую сущность, пораженную в пределах [Расстояние], и возвращает [Попадание по сущности] и [Координаты попадания].",
  T_39_WZY_WS_REAHEALHP: "Значение восстановления брони",
  T_39_WZY_WS_REAHEALTIME: "Интервал времени действия",
  T_39_WZY_WS_RELATCOORSYS: "Относительная система координат",
  T_39_WZY_WS_REPAIRARM: "Ремонтный Набор",
  T_39_WZY_WS_REVERSE: "Реверс",
  T_39_WZY_WS_RIMALPHA: "Прозрачность краев",
  T_39_WZY_WS_SCORENAME: "Название Счёта",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Отправка сигнала целевой сущности, загружаемые параметры определяются предопределенными параметрами сигнала. Выбор типа сущности во время определения будет генерировать соответствующее событие приема сигнала.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Создать движение позиционного следования для [Целевая сущность]. [Целевая сущность] следует за [Следующая сущность]. [Координаты смещения] - это смещение координат между [Целевая сущность] и [Следующая сущность]. [Система координат] можно выбрать мировую систему координат и относительную систему координат в зависимости от ориентации объекта следования. [Сущность движения позиционного следования] будет возвращено после создания движения.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Создать движение, следующее за взглядом, для [Целевая сущность]. [Целевая сущность] следует за [Следующая сущность]. [Координаты смещения] — это смещение координат между [Целевая сущность] и [Следующая сущность]. [Система координат] можно выбрать мировую систему координат и относительную систему координат в зависимости от ориентации следующей сущности. [Сущность, следящая за движением] будет возвращена после создания движения.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Процент повреждений при падении",
  T_39_WZY_WS_SHOE_MAXENERGY: "Макс. энергии",
  T_39_WZY_WS_SKILLLIST: "Список Навыков",
  T_39_WZY_WS_SKILLTYPE: "Навык Персонажа",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Продолжительность эффекта дыма",
  T_39_WZY_WS_SMOOTH: "Переключить камеру",
  T_39_WZY_WS_SOUNDENTL: "Список звуковых сущностей",
  T_39_WZY_WS_SOUNDENTLORSENT: "Звуковая сущности или список",
  T_39_WZY_WS_SPRINTSPEED: "Процент скорости бега",
  T_39_WZY_WS_SQUATSPEED: "Процент скорости движения (Приседание)",
  T_39_WZY_WS_STARTCOO: "Начальные координаты",
  T_39_WZY_WS_STATE: "Статус игры",
  T_39_WZY_WS_TARGETVAL: "Целевое значение",
  T_39_WZY_WS_THROWSPEED: "Скорость полета крюка",
  T_39_WZY_WS_TOWER_PARAM10: "Угол поворота",
  T_39_WZY_WS_TOWER_PARAM11: "Статус турели",
  T_39_WZY_WS_TOWER_PARAM12: "ID сущности",
  T_39_WZY_WS_TOWER_PARAM9: "Цель атаки",
  T_39_WZY_WS_TOWSPEED: "Скорость передвижения игрока",
  T_39_WZY_WS_TWEENCURVE_NAME: "Пользовательская кривая",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Пользовательская кривая может быть использована для интерполяции движения",
  T_39_WZY_WS_TWEENENT: "Интерполяционный объект движения",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Способы движения",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Способы интерполяции движения",
  T_39_WZY_WS_TWEENSTYLE: "Метод",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Удалить скрипт [Название скрипта] для [Сущность]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Рандомизировать перечисленные элементы",
  T_39_WZY_WS_VISIBLEONBACK: "Видимый на спине",
  T_39_WZY_WS_WEAPCOMBINET: "Тип оружия для двух рук",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Дополнительный урон по упавшему",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Номер пули для одиночного выстрела",
  T_39_WZY_WS_WEAREPLAY: "Перезагрузить движение?",
  T_39_WZY_WS_WORLDCOORSYS: "Мировая система координат",
  T_39_XXJ_WS_ADDFRIEND: "Добавить друга",
  T_39_XXJ_WS_ALLOWZ: "Включить перемещение игрока по оси x",
  T_39_XXJ_WS_BLOCKMODEDESC: "Движение камеры, когда между камерой и объектом находится другой объект",
  T_39_XXJ_WS_CAMERADISTANCE: "Расстояние до цели",
  T_39_XXJ_WS_CAMERATYPEDESC: "Предусмотрено несколько типов предустановленных и пользовательских камер",
  T_39_XXJ_WS_CAMERAUSER: "Пользователь камеры",
  T_39_XXJ_WS_CURENTCAMERA: "Используемая камера",
  T_39_XXJ_WS_DETAILS: "Подробности матча",
  T_39_XXJ_WS_FFECONOMY: "Экономика",
  T_39_XXJ_WS_FOCUSTARGET: "Наблюдаемая цель",
  T_39_XXJ_WS_FOLLOWTARGET: "Преследуемая цель",
  T_39_XXJ_WS_GAMERESULT: "Результат матча",
  T_39_XXJ_WS_GAMETITLE1: "Матч 1",
  T_39_XXJ_WS_GAMETITLE2: "Матч 2",
  T_39_XXJ_WS_GIFT: "Подарки",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Угол поворота камеры по горизонтали",
  T_39_XXJ_WS_INVISICAM: "Полупрозрачный",
  T_39_XXJ_WS_INVISICAMDESC: "Объект между камерой и целью становится полупрозрачным",
  T_39_XXJ_WS_LEFTSCORE: "Счёт команды слева",
  T_39_XXJ_WS_LIKE: "Лайк",
  T_39_XXJ_WS_LOBBY: "Лобби",
  T_39_XXJ_WS_MAINSCORENAME: "Название Общего Счета",
  T_39_XXJ_WS_MAINSCORENUM: "Количество Общего Счета",
  T_39_XXJ_WS_MAPEVALUATE: "Рейтинг карты",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Результат нескольких команд",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Смещение точки наблюдения",
  T_39_XXJ_WS_OFFSET2DESC: "Обычно относится к смещению точки фокусировки камеры относительно исходного положения игрока. (Значение зависит от типа камеры)",
  T_39_XXJ_WS_OFFSETDESC: "Обычно обозначает смещение положения камеры относительно исходного положения игрока. (Значение зависит от типа камеры)",
  T_39_XXJ_WS_ORTHOGONAL: "Ортогональный",
  T_39_XXJ_WS_ORTHOGONALDESC: "Камера изображает удаленные и близкие объекты одинакового размера",
  T_39_XXJ_WS_PERSPECTIVE: "Перспектива",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Камера использует перспективную проекцию для наблюдения за объектом",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Формирование изображения камеры при рендеринге",
  T_39_XXJ_WS_RANK1: "Ранг Команды",
  T_39_XXJ_WS_RANK2: "Ранг Игрока",
  T_39_XXJ_WS_REPORT: "Пожаловаться",
  T_39_XXJ_WS_REVIEW: "Повтор",
  T_39_XXJ_WS_RIGHTSCORE: "Счёт команды справа",
  T_39_XXJ_WS_SCORENUM1: "Счет 1",
  T_39_XXJ_WS_SCORENUM2: "Счет 2",
  T_39_XXJ_WS_SCORENUM3: "Счет 3",
  T_39_XXJ_WS_SCORENUM4: "Счет 4",
  T_39_XXJ_WS_SCORENUM5: "Счет 5",
  T_39_XXJ_WS_SCORETITLELIST: "Титульный список",
  T_39_XXJ_WS_SHARE: "Поделиться",
  T_39_XXJ_WS_SPECTATORSWITCH: "Наблюдатель",
  T_39_XXJ_WS_STABLE: "Стабильный",
  T_39_XXJ_WS_STABLEDESC: "Камера остается стабильной, если между камерой и преследуемым объектом находится другой объект",
  T_39_XXJ_WS_TEAMNAME1: "Название команды слева",
  T_39_XXJ_WS_TEAMNAME2: "Название команды справа",
  T_39_XXJ_WS_TEAMRANK: "Ранг Команды",
  T_39_XXJ_WS_TRANSITIONTIME: "Время перехода камеры",
  T_39_XXJ_WS_TRANSITIONTYPE: "Тип перехода камеры",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Результат 2 команд",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Угол поворота камеры по вертикали",
  T_39_XXJ_WS_ZOOM: "Зум",
  T_39_XXJ_WS_ZOOMDESC: "Камера увеличивает изображение, если между камерой и объектом находится другой объект",
  T_39_XYL_WS_LIGHTINTENSITY: "Интенсивность света",
  T_39_XYL_WS_LIGHTRANGE: "Диапазон освещения",
  T_39_XYL_WS_POINTLIGHT: "Точечный свет",
  T_39_XYL_WS_WATERZONE: "Пользовательская водная зона",
  T_40_B_DISABLE_RECONNECT: "Отключить автоподключение",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Футболка - Полночная Тьма",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Футболка - Алое на Снегу",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Футболка - Вишнёвый Уголь",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Футболка - Солнце и Море",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Жаркая Футболка",
  T_40_DYEING_CLEAR: "Очистить статус окрашивания",
  T_40_HJ_WS_EFFECT32: "Кеды",
  T_40_HJ_WS_EFFECT33: "Взрыв",
  T_40_HJ_WS_EFFECT34: "Точка Появления",
  T_40_HJ_WS_EFFECT35: "Лазер",
  T_40_HJ_WS_EFFECT36: "Патроны",
  T_40_HJ_WS_EFFECT37: "Эффект при попадании",
  T_40_HJ_WS_EFFECT38: "Эффект при стрельбе",
  T_40_HJ_WS_EFFECT43: "Паутина",
  T_40_HJ_WS_EFFECT44: "Использование навыка",
  T_40_HJ_WS_SOUND69: "Открыть ящик",
  T_40_HJ_WS_SOUND70: "Прокачка",
  T_40_HJ_WS_SOUND71: "Максимальный уровень",
  T_40_HJ_WS_SOUND72: "Нажатие кнопки",
  T_40_HJ_WS_SOUND73: "Обратный отсчет 1",
  T_40_HJ_WS_SOUND74: "Свист",
  T_40_HJ_WS_SOUND75: "Конец Игры",
  T_40_HJ_WS_SOUND76: "Вперед",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Контрольная точка",
  T_40_HJ_WS_SOUND79: "Обратный отсчет 2",
  T_40_HJ_WS_SOUND80: "Начало Игры",
  T_40_HJ_WS_SOUND81: "Получено много монет",
  T_40_HJ_WS_SOUND82: "Получены монеты",
  T_40_HJ_WS_SOUND83: "Получено немного монет",
  T_40_HJ_WS_SOUND84: "Присоединение в игру",
  T_40_HJ_WS_SOUND85: "Открытие ящика гильдии",
  T_40_HJ_WS_SOUND86: "Спикер",
  T_40_HJ_WS_SOUND87: "Босс устранен",
  T_40_HJ_WS_SOUND88: "Открытие Боевого Лутбокса",
  T_40_HJ_WS_SOUND89: "Навык Взрывной Краски",
  T_40_HJ_WS_SOUND90: "Попадание пули",
  T_40_HJ_WS_SOUND91: "Навык Щит Краски",
  T_40_HJ_WS_SOUND92: "Нажатие отключенной кнопки",
  T_40_HJ_WS_SOUND93: "Зарядка навыков завершена",
  T_40_HJ_WS_SOUND95: "Навык Лазера",
  T_40_HJ_WS_SOUND96: "Получить предмет 2",
  T_40_HJ_WS_SOUND97: "Конец Игры 2",
  T_40_HJ_WS_SOUND98: "Объявление о Килле",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Фоновая музыка",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Звуковой эффект матча",
  T_40_HJ_WS_SOUNDTYPE_UI: "Звуковой эффект виджета пользовательского интерфейса",
  T_40_JH_WS_MAPTAG1: "Цветная Игра",
  T_40_JH_WS_MAPTAG10: "Цветные Прятки",
  T_40_JH_WS_MAPTAG11: "Годовщина",
  T_40_JH_WS_MAPTAG12: "Ролевая игра",
  T_40_JH_WS_MAPTAG13: "Симуляция",
  T_40_JH_WS_MAPTAG14: "Асимметричный",
  T_40_JH_WS_MAPTAG15: "Ресурсы битвы",
  T_40_JH_WS_MAPTAG16: "Сопровожд. Телеги",
  T_40_JH_WS_MAPTAG17: "Официальная карта",
  T_40_JH_WS_MAPTAG18: "Мини-игра",
  T_40_JH_WS_MAPTAG19: "Челлендж Скорости",
  T_40_JH_WS_MAPTAG2: "Цветной Спрей",
  T_40_JH_WS_MAPTAG20: "Рогалик",
  T_40_JH_WS_MAPTAG3: "Цветная Битва",
  T_40_JH_WS_MAPTAG4: "Перестрелка Цвета",
  T_40_JH_WS_MAPTAG5: "Цветная Площадка",
  T_40_JH_WS_MAPTAG6: "Раскраш. площадки",
  T_40_JH_WS_MAPTAG7: "Цветная Вечеринка",
  T_40_JH_WS_MAPTAG8: "Цветной Паркур",
  T_40_JH_WS_MAPTAG9: '"Паутина Вселенных" - Паркур',
  T_40_JH_WS_TAG30: "Магнат",
  T_40_JH_WS_TAG31: "Домашний аврал",
  T_40_JH_WS_TAG32: "Город Тайн",
  T_40_JH_WS_TAG33: "Кризис Рассвета",
  T_40_JH_WS_TAG34: "Восстание Мёртвых",
  T_40_JH_WS_TAG35: "Кулачный бой",
  T_40_JH_WS_TAG36: "Крыша Фабрики",
  T_40_JH_WS_UGCTOKENNAME: "Жетон Личного Острова",
  T_40_L_QUICKMESSAGE_MODE2: "Битва Отрядов",
  T_40_M_WS_HIS: "из",
  T_40_SP_WS_DYEING: "Цвет",
  T_40_SP_WS_DYEING_AREA: "Площадь окрашивания",
  T_40_SP_WS_DYEING_COLOR: "Номер цвета",
  T_40_SP_WS_DYEING_COUNT: "Количество окрашиваний",
  T_40_SP_WS_DYEING_DIR: "Направление окрашивания",
  T_40_SP_WS_DYEING_DIS: "Расстояние окрашивания",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Фикс. дистанция окрашивания",
  T_40_SP_WS_DYEING_NORMAL: "Обычный",
  T_40_SP_WS_DYEING_PLANE: "Окрашивание плоскости",
  T_40_SP_WS_DYEING_POSITION: "Координата",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Затухание скорости случ. окрашивания",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Случайная скорость окрашивания",
  T_40_SP_WS_DYEING_RANGE: "Дистанция окрашивания",
  T_40_SP_WS_DYEING_STATE: "Статус окрашивания",
  T_40_SP_WS_FACTIONTIPS_11: "Фиолетовый",
  T_40_SP_WS_SHOE_CURENERGY: "Текущая энергия",
  T_40_SW_SKILL_Name_Nanoscientist: "Нанощит",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Сила Пингвина",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Пробуждённый Алок",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Соня",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Сила Пингвина",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Сила Пингвина",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Сила Пингвина",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Сила Пингвина",
  T_40_SY_PET_PUG_N: "Мопс",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Скин Питомца: "НЕчеловек-Паук"',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Скин Питомца: Электро-Эрвин",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Скин Питомца: Терминатор-Мопс",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Скин Питомца: Алоха Мопс",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Скин Питомца: Тигро-Мопс",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Сила Пингвина",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Сила Пингвина",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Сила Пингвина",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Сила Пингвина",
  T_40_SY_UZI_PENGUIN_W_N: "Мини-Узи - Сила Пингвина",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Активировать текстовое содержание",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Текстовое содержание",
  T_40_W_DJMALE_AWAKENING_D: "Пробуждение: Пока аура активна, она будет оставлять ноты со сроком действия [FFB300]{2}с[-] в [FFB300]{1}м[-] за собой в течение [FFB300]{0}с[-]. Союзники, подобравшие ноты, тоже получат эффект ауры Алока.",
  T_40_W_DJMALE_AWAKENING_N: "Ремикс",
  T_40_W_NURSE_D: "Распространить [FFB300]{0}%[-] ваших лечебных эффектов на одну цель (навык, аптечка, леч. оружие и т.д.), на напарников в радиусе [FFB300]{1}м[-].",
  T_40_WH_MP_BOXING_NAME: "Матч по боксу",
  T_40_WH_MP_C_PACK: "Нелегальный Рюкзак",
  T_40_WH_MP_EXCH_COIN: "Деньги",
  T_40_WH_MP_EXCH_TEMPCOIN: "Нелегальные Деньги",
  T_40_WH_MP_PAYCHECK: "Выплаты",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "Скорость оказания помощи напарникам увеличивается на [FFB300]{0}%[-]. Восстановление: [FFB300]{3}с[-]. Напарник восстанавливает [FFB300]{2} ХП[-] за [FFB300]{1}с[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Создает зону исцеления радиусом [FFB300]{0}м[-]. Внутри нее игрок и союзники восстанавливают [FFB300]{1} ХП/с[-]. При необходимости автоматически включается помощь. Зона действует в течение [FFB300]{2}с[-]. Эффект от помощи союзникам может быть усилен другими навыками. Восстановление: [FFB300]{3}с[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Метод отображения",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Капсула",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Высота",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Радиус",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Сфера",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Упрощенный арабский",
  T_40_WZY_WS_FONT_SUPERMARKET: "Супермаркет",
  T_40_WZY_WS_ICONENTITY_COLOR: "Цвет",
  T_40_WZY_WS_ICONENTITY_FILLED: "Прогрессия",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Ресурсы изображений",
  T_40_WZY_WS_ICONENTITY_NAME: "Объект иконки",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Метод отображения",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Простой",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-сетка",
  T_40_WZY_WS_ICONENTITY_TILED: "Плитки",
  T_40_WZY_WS_NEWMAPTAG: "Новая иконка карты",
  T_40_WZY_WS_NEWVFX1: "Нимб",
  T_40_WZY_WS_NEWVFX10: "Проклятье",
  T_40_WZY_WS_NEWVFX11: "Зона заморозки",
  T_40_WZY_WS_NEWVFX12: "Холодный Воздух",
  T_40_WZY_WS_NEWVFX13: "Снежинка",
  T_40_WZY_WS_NEWVFX14: "Пламя",
  T_40_WZY_WS_NEWVFX15: "Световой луч",
  T_40_WZY_WS_NEWVFX16: "Распростр. ядовитого газа",
  T_40_WZY_WS_NEWVFX17: "Ядовитый газ",
  T_40_WZY_WS_NEWVFX18: "Пламя взрыва",
  T_40_WZY_WS_NEWVFX19: "Эффект освещения",
  T_40_WZY_WS_NEWVFX2: "Пузырь",
  T_40_WZY_WS_NEWVFX20: "Звезда",
  T_40_WZY_WS_NEWVFX3: "Пепел",
  T_40_WZY_WS_NEWVFX4: "Каменная крошка",
  T_40_WZY_WS_NEWVFX5: "Линия",
  T_40_WZY_WS_NEWVFX6: "Мерцание",
  T_40_WZY_WS_NEWVFX7: "Кольцо",
  T_40_WZY_WS_NEWVFX8: "Восходящая частица",
  T_40_WZY_WS_NEWVFX9: "Дым",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Размер шрифта",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Стиль шрифта",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Шрифт",
  T_40_WZY_WS_TEXTENTITY_NAME: "Объект текста",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Компонент интерактивной кнопки HUD",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: "Можно ли использовать в декорации. Этот параметр доступен только для чтения и зависит от наличия или отсутствия род. сущности и статуса активности.",
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Все ли род. сущности активны. Этот параметр доступен только для считывания и не виден игрокам.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Наличие или отсутствие род. сущности",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Отображается, когда состояние открытия истинно, в противном случае закрыто",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: "Может ли он быть активным на себя. Чтобы использовать в окружениях, вы должны использовать настройку Можно использовать в  декорациях или нет. Этот параметр доступен только для чтения и настраивается с помощью API.",
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Управление возможностью видимости cullingMask на определенном слое",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Генерировать жетоны в определенном месте",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "Предмет, который можно отдать игроку",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Текущая позиция игрока",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Направление",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "ИИ атакует сущность",
  T_40_XXJ_WS_AITARGET_DESCKEY: "Атакующий ИИ",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "Стиль выравнивания",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "По горизонтали",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "По вертикали",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Прозрачность",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "Кол-во оставшихся патронов",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Оставшиеся патроны",
  T_40_XXJ_WS_ANCHORMAX: "Макс. якорь",
  T_40_XXJ_WS_ANCHORMIN: "Минимальный якорь",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Текущая позиция игрока",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Позиция",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Смена HUD брони",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Настроить ID ассета",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "ID ассета",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Цель атаки",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Метательные снаряды для атаки",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "Сущность, которая атакована ИИ",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Цель атакована",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Доступные координаты Точек Появления",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Доступные координаты",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "Нижнее изображение",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Фон",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Рюкзак",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Прозрачность фона",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Цвет фона",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Цвет фона",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Управление возможностью заполнения фона",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Заполнить фон",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Название фона",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Название фона",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Дельта размера фона",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Дельта размера фона",
  T_40_XXJ_WS_BLUE: "Синий",
  T_40_XXJ_WS_BODY_DESCKEY: "Торс",
  T_40_XXJ_WS_BODY_NAMEKEY: "Торс",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Масштаб скелета",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Точка Появления игрока",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Точка Появления",
  T_40_XXJ_WS_BOTH: "Или",
  T_40_XXJ_WS_BUTTONNAME: "Название кнопки компонента",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Камера",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "Направление, в котором находится камера клиента",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "Местоположение камеры клиента",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Определить линию камеры клиента",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Обнаружение лучей камеры",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Остановить перетаскивание при совпадении с областью просмотра",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Выйти из перетаскивания после подгонки",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "Расстояние между центрами полукругов в форме таблетки. Оно не может быть меньше удвоенного радиуса сферы.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Размер ячейки",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Высота доч. ячейки",
  T_40_XXJ_WS_CELLVALUE: "Считать содержимое определенной ячейки и вернуть объект",
  T_40_XXJ_WS_CENTER_DESCKEY: "Координаты мира, соответствующие центру мини-картины. По умолчанию 0.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Центр мини-карты",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Смещение позиции кнопки",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Смещение позиции",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "Центр масс относительно местных координат",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Центр массы",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Управление возможностью  отображения средней линии",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Показывать среднюю линию или нет",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Позиция средней линии [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Позиция средней линии",
  T_40_XXJ_WS_CHASERANGE: "Дальность преследования",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "Сущность, которая преследуется ИИ",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Цель достигнута",
  T_40_XXJ_WS_CHILD_DESCKEY: "Дочерняя сущность",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Доч. родительской сущности",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "Точка, в которую попадает линия камеры",
  T_40_XXJ_WS_CHOOSECARHUD: "Выбрать сущность карты HUD",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Если параметр находится в числовом диапазоне между минимальным и максимальным значениями, функция вернет значение параметра; если параметр больше диапазона, функция вернет максимальное значение; если аргумент меньше диапазона, функция вернет минимальное значение",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Поддерживаются только сущности с компонентом Трансформация. В настоящее время ограничено всеми объектами.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "Размер области нажатия",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Размер клика",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Тип обрезки",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Тип обрезки",
  T_40_XXJ_WS_CLONEENT_D: "Клонирование выбранной сущности и ее атрибутов с сохранением исходного родителя. Если выбран Объект Уровня, он будет основан на настройке Создать Объект Уровня",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "Список костюмов",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ID костюма",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID костюма",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "ID костюма",
  T_40_XXJ_WS_COL_DESC: "Считать столбец",
  T_40_XXJ_WS_COLNAME_DESC: "Название столбца, чтобы считать",
  T_40_XXJ_WS_COLOR_DESCKEY: "Цвет",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Значение",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Добавление цветовых слоев с использованием цветового канала RGBA. Значение канала лежит в диапазоне от 0 до 255 и хранится в формате Int32. По умолчанию белый (255, 255, 255, 255).",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Цвет шкалы",
  T_40_XXJ_WS_COLOR3_DESCKEY: "Тип цветового канала RGBA, который находится в диапазоне от 0 до 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "Цвет текста",
  T_40_XXJ_WS_COLOR5_DESCKEY: "Цвет HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "Цвет освещения",
  T_40_XXJ_WS_COLORA_DESCKEY: "Значение цвета А",
  T_40_XXJ_WS_COLORB_DESCKEY: "Значение цвета B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Цвет шкалы",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Цветная бочка",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Игрок, пострадавший от взрыва бочки",
  T_40_XXJ_WS_COLORG_DESCKEY: "Значение цвета G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Получить канал RGBA",
  T_40_XXJ_WS_COLORGUN: "Цветной распылитель",
  T_40_XXJ_WS_COLORGUN_01: "Цветной распылитель (Красный)",
  T_40_XXJ_WS_COLORGUN_02: "Цветной распылитель (Желтый)",
  T_40_XXJ_WS_COLORGUN_03: "Цветной распылитель (Синий)",
  T_40_XXJ_WS_COLORGUN_04: "Цветной распылитель (Зеленый)",
  T_40_XXJ_WS_COLORGUN_05: "Цветной распылитель (Фиолетовый)",
  T_40_XXJ_WS_COLORR_DESCKEY: "Значение цвета R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Цвет текста",
  T_40_XXJ_WS_COLVALUE: "Содержание столбца",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "Сущность HUD основной смены HUD",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Сущность HUD основной смены HUD",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Ограничение",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Ограничение",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "Кол-во ограничений",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Кол-во ограничений",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Оригинальный контент",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Направление по умолчанию",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "Начальная точка прокрутки. По умолчанию верхний левый угол.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Создать статичный пиксель для определенного объекта на карте. Пиксель не будет перемещаться вместе с объектом.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Создать иконку мини-карты",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Определить локализованную строку для временной метки",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Создать пользовательский компонент интерфейса в указанном пользовательском HUD и родительском компоненте",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Ползти",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Отображается, если истина, в противном случае закрыт",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Красться",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Это слой рендеринга камеры CullingMask. Вы можете фильтровать сущность рендеринга, используя уровень видимого слоя.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "ID верха",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Верх",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ID грима",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "ID обуви",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Обувь",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "ID головы",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Голова",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ID грима",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Маска",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "ID низа",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Низ",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Грим",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "ID набора",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Комбинезон",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "Величина перетаскивания в направлении xy",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY перетаскивание",
  T_40_XXJ_WS_DB: "Считать значение таблицы",
  T_40_XXJ_WS_DB_DESC: "Считать соответствующее значение идентификатора в определенной таблице в базе данных.",
  T_40_XXJ_WS_DBDELETE_DESC: "Удалить соответствующее значение идентификатора в определенной таблице в базе данных.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Пользовательское имя, используемое для идентификации данных",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Идентификатор",
  T_40_XXJ_WS_DBTABLENAME: "Название таблицы базы данных",
  T_40_XXJ_WS_DBTABLENAME_DESC: "Название таблицы в базе данных",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "Значение для записи",
  T_40_XXJ_WS_DBWRITE: "Записать значение таблицы",
  T_40_XXJ_WS_DBWRITE_DESC: "Записать соответствующее значение идентификатора в определенную таблицу в базе данных.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Защитные метательные снаряды",
  T_40_XXJ_WS_DEFULT: "По умолчанию",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Удаление соответствующего значения определенного ключа в таблице лидеров в базе данных.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Удалить соответствующее значение определенного ранга в таблице лидеров в базе данных.",
  T_40_XXJ_WS_DEPTH: "Слой HUD",
  T_40_XXJ_WS_DEPTH_D: "Базовый слой HUD",
  T_40_XXJ_WS_DICTANDLIST: "Список и Словарь",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "Значение целевого словаря",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "Прозрачность поверхности",
  T_40_XXJ_WS_DIR_DESCKEY: "Вектор",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Точка, которая предоставляется и может быть использована как точка возрождения и т.д.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Координаты",
  T_40_XXJ_WS_DISABLEALL: "Отменить выбор всех",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Отключенный цвет",
  T_40_XXJ_WS_DISTANT_DESCKEY: "Расстояние обнаружения линии камеры",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Расстояние проецирования",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Поддерживает несколько направлений перетаскивания",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Эффект перетаскивания",
  T_40_XXJ_WS_DRIVER_DESCKEY: "Водитель транспорта",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Водитель",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Изменить значение",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Отображать специальные эффекты",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Отображать спецэффекты",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Цвет эффектов",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "Сущность спецэффектов представляет специальный эффект, который должен быть отображен",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "Объект спецэффектов",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Смена HUD эмоции",
  T_40_XXJ_WS_ENABLEALL: "Выбрать все",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Управление возможностью включения логики обновления. Если этот параметр выключен, блоки этой сущности перестанут обновляться каждый кадр.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "При записи в атрибуты оружия, базовая статистика оружия будет зависеть от его кожи.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Написать атрибут оружейного скина",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Сущность - это сосуд, в котором хранятся все компоненты, которые должны быть добавлены к сущностям, чтобы быть активированными",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Тип сущности",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "Основной компонент сущности. Все компоненты объединяют этот компонент.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "Сущность, в которую нужно превратиться",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "Имя параметра, используемое в коде для представления сущности вновь добавленного пользовательского элемента управления UI. Соответствующее значение локальной переменной - сущность вновь добавленного пользовательского элемента управления пользовательским интерфейсом.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "Название переменной сущности",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "Имя параметра, используемое в коде для представления сущности создаваемой иконки. Соответствующее значение локальной переменной - сущность созданной иконки.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "Смена HUD полоски энергии",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Углы Эйлера",
  T_40_XXJ_WS_FACINFECTION: "Фракция (Робогеддон)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Фракция игрока. 1 = Человек, 2 = Дроид",
  T_40_XXJ_WS_FEMALE: "Жен.",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Заполнить направление",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Сортировать направление",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Огонь",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "Значение десятичной дроби",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "Целевая сущность для следования. По умолчанию пустая.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "Размер текста",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Размер шрифта",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "Стиль шрифта",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Футбольная Стена",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "Стиль форматирования",
  T_40_XXJ_WS_FORWARD_DESCKEY: "Направление игрока",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "Направление телепорта",
  T_40_XXJ_WS_FREE_DESCKEY: "Камера, которая управляется игроком и может свободно перемещаться",
  T_40_XXJ_WS_FREE_NAMEKEY: "Свободная камера",
  T_40_XXJ_WS_GENDER: "Пол",
  T_40_XXJ_WS_GENDER_DESCKEY: "Пол",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Перечисление гендеров",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Получить CullingMask камеры",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Поддерживает только те объекты, которые имеют компонент Трансформация. В настоящее время ограничено для всех объектов.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Поддержать только те сущности, которые имеют компонент Трансформация. В настоящее время ограничено для всех объектов.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Поддерживает только те объекты, которые имеют компонент Трансформация. В настоящее время ограничено для всех объектов.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Получить ID костюма игрока",
  T_40_XXJ_WS_GETPLAYERRANK: "Получить Ранг Игрока",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Получить Общий Ранг Игрока",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Получить ранг игрока в раунде",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Получить ранг игрока в конкретном раунде",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Поиск данных жетона игрока",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Получить оружейный скин игрока",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Получить координаты, которые не были заняты Точками Появления",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Получить скайбокс окружения",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Получить регион сервера",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Получить временную метку сервера",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Найдите место рядом с напарником, избегая мест, где игроки не могут стоять",
  T_40_XXJ_WS_GETTEAMRANK: "Получить Ранг Команды",
  T_40_XXJ_WS_GETTEAMRANK_D: "Получить общий ранг команды",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Получить командный ранг в раунде",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Получить командный ранг в конкретном раунде",
  T_40_XXJ_WS_GREEN: "Зеленый",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Половина размеров трехмерной формы",
  T_40_XXJ_WS_HEAD_DESCKEY: "Голова",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Голова",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "Сущность эффекта сердцебиения",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Сущность эффекта сердцебиения",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "Высота",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Кнопка подсказки",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Кнопка подсказок",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "Сущность для отображения в целевом месте",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Таргет. сущность",
  T_40_XXJ_WS_HITPOS_DESCKEY: "Точка удара",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "Горизонтальный тип дисплея",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Горизонтальный тип дисплея",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "Сущность, которая следует за другой сущностью",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "Сущность, которая смотрит на другую сущность",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Смена HUD полоски здоровья",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "Сущность вставки HUD. Это HUD, который игрок изменяет с помощью редактора.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Компонент пустой панели HUD",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "Сущность HUD, которому он принадлежит",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "Сущность вставки HUD. Это HUD, который игрок изменяет с помощью редактора.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "Компонент сетки HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "Сущность вставки HUD. Это HUD, который игрок изменяет с помощью редактора.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "Компонент панели HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "Сущность вставки HUD. Это HUD, который игрок изменяет с помощью редактора.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "Компонент прокрутки HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID модели человека",
  T_40_XXJ_WS_ICON_DESCKEY: "Название ресурса иконки",
  T_40_XXJ_WS_ICON_NAMEKEY: "Иконка",
  T_40_XXJ_WS_ICON1_DESCKEY: "Выбери иконку",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "Сущность иконки представляет отображаемую иконку",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Путь к ресурсу. Встроенный ресурс - in:path. Пользовательский ресурс - out:path. По умолчанию пустой.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Название иконки",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Название иконки",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "Путь к ресурсу. По умолчанию пустой.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Может ли он сканировать триггеры",
  T_40_XXJ_WS_INDEX_DESCKEY: "Индекс доч. сущности около род. сущности",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Начальное значение [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "Значение целого числа",
  T_40_XXJ_WS_IS3D: "3D звуковой эффект",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Всегда лицом к камере",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Полужирный",
  T_40_XXJ_WS_ISBYORDER_D: "Определить, должны ли игроки запускать объекты уровня в хронологическом порядке",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Кнопка FirEditor",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Попала ли линия камеры в объект",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Виден ли он для определенного слоя",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Курсив",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Отмечено сканером или нет",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Сканирован или нет",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Применена или нет кнопка метки",
  T_40_XXJ_WS_ISTRIGGER: "Триггер",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Подчеркнутый",
  T_40_XXJ_WS_ITEMID_DESCKEY: "Идентификатор соответствующего элемента сущности",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "ID предмета",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "ID предмета (в текущей версии доступен только идентификатор оружия)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "ID предмета (оружие)",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "ID предмета",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Территория мегаполиса",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Территория мегаполиса",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Прыжок",
  T_40_XXJ_WS_KEY_DESCKEY: "Значение ключа",
  T_40_XXJ_WS_KEY_NAMEKEY: "Ключ",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "Название ключа для перехода. Вы можете использовать это для получения значения ключа в локальной переменной.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Объявление о килле",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Цвет текста",
  T_40_XXJ_WS_LANDMINEOBJ: "Сущность после создания мины",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "Маска слоя столкновения. Слои, которые не выбраны, не будут включены в сканирование. Если пусто, все слои будут включены в сканирование.",
  T_40_XXJ_WS_LAYERSEDIT: "Редактировать слои",
  T_40_XXJ_WS_LAYERSETTING: "Настройки видимого слоя",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "Слой столкновений для обнаружения линии камеры",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Слой",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Тип отображения",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Тип отображения",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Компонент счет HUD",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "HUD-сущность счета. Изменение свойств сущности повлияет на содержимое, которое будет отображаться в соответствующем пользовательском интерфейсе.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Название таблицы лидеров",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "Название таблицы лидеров в базе данных.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "Ускорение при взмахе",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Покинуть ускорение",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Левая рука",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Левая рука",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "Левый цвет",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Левый цвет",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Управление возможностью отображения специальных эффектов слева",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Отображать или нет эффект слева",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Левая ступня",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Левая ступня",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Левая рука",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Левая рука",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Левая иконка",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Левая иконка",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Левая нога",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Левая нога",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Текст левого счета",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Текст счета слева",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Левый текст",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Левый текст",
  T_40_XXJ_WS_LERP_DESCKEY: "t лежит в промежутке от 0 до 1. Когда t=0, верните значение От. При t=1 верните значение До. При t=0.5 возвращается среднее значение между От и До.",
  T_40_XXJ_WS_LEVELOBJECT: "Объект уровня",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Межстрочный интервал",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Сравнить значения в списке и вернуть наибольшее из них",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Сравнить значения в списке и вернуть наименьшее из них",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "Список или Словарь (Dict)",
  T_40_XXJ_WS_LOCALPOSITION: "Локальная позиция",
  T_40_XXJ_WS_LOCALROTA: "Локальные углы Эйлера",
  T_40_XXJ_WS_LOCALROTATIONQ: "Вращение локального кватерниона",
  T_40_XXJ_WS_LOCALSACLE: "Локальный масштаб",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Переключить локализацию",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "Контейнер для перехода",
  T_40_XXJ_WS_MALE: "Муж.",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Убрать словарь",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Получить длину словаря",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Получение значения обозначенного ключа в элементе словаря",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Удалить указанную пару ключ-значение из словаря",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Настроить значение назначенного ключа в словаре",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "Размер карты минимизации. Его ширина и высота равны.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Размер карты",
  T_40_XXJ_WS_MAPT: "Шаблон словаря (Dict)",
  T_40_XXJ_WS_MAPT_D: "Шаблон данных для словаря (dict). Вы можете указать тип содержимого через T1 и T2.",
  T_40_XXJ_WS_MAPVALUE_D: "Контейнер данных для словаря (dict). Элемент представляет собой пару, состоящую из ключа и значения.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "Целевой словарь",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Словарь (Dict)",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "Тип маски - это имя изображения, используемое при маскировании",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Имя маски",
  T_40_XXJ_WS_MASS_DESCKEY: "Масса (в кг)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Масса (кг)",
  T_40_XXJ_WS_MAX_DESCKEY: "Сравнить 2 значение и вернуть наибольшее",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Макс. длина",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "Максимальное значение",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "Наибольший компонент ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Макс. ID виджета",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Лечащие предметы",
  T_40_XXJ_WS_MIN_DESCKEY: "Сравнить 2 значения и вернуть меньшее из них",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Компонент мини-карты",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Пиксель мини-карты",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Иконка мини-карты",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Мини-карта",
  T_40_XXJ_WS_MINNUM_DESCKEY: "Минимальное значение",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "Коэффициент импульса. Чем больше значение, тем больше импульс при прокрутке.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Фактор момента",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Джойстик перемещения",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Результат матча",
  T_40_XXJ_WS_NEWENTITY_D: "Новая сущность элемента после создания (может быть null).",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Создать новый словарь",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Новый словарь (Dict)",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "Нормаль удара",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "Позиция HUD [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "Позиция HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "Список для преобразования индексов в числа",
  T_40_XXJ_WS_OBJECT_DESCKEY: "Объект, на который попадает распылитель",
  T_40_XXJ_WS_OBSOLETE: "Удалено, в целях безопасности замените этот блок.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "Позиция дисплея. Когда есть отслеживаемая цель, это смещение между новой позицией и исходной позицией. Когда нет сопровождаемой цели, это экранные координаты (по умолчанию Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "Координаты экрана (по умолчанию - Vector3(0))",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "Позиция дисплея. Когда есть отслеживаемая цель, это смещение между новой позицией и исходной позицией. Когда нет сопровождаемой цели, это экранные координаты (по умолчанию Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Положение дисплея (якорь находится в правом верхнем углу)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Горизонтальное смещение",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Горизонтальное смещение",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "Вертикальное смещение",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Вертикальное смещение",
  T_40_XXJ_WS_OK_DESCKEY: "Перевод успешен",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Запуск этого события, когда сущность входит в зону атаки",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Запуск этого события, когда сущность входит в зону преследования",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Запуск этого события, когда сущность покидает зону атаки",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Запуск этого события, когда сущность покидает зону преследования",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Запуск обнаружения линии камеры через клиента",
  T_40_XXJ_WS_ONCOLLISION_D: "Только объекты с подключенным компонентом Коллайдер поддерживают это событие",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Запуск этого события, когда распылитель попадает по сущности",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Когда стрельба прекратится",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Когда игрок переключает окружение",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Отображается, если статус истинен, в противном случае закрыт",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Открыть статус",
  T_40_XXJ_WS_ORANGE: "Оранжевый",
  T_40_XXJ_WS_ORDER_DESC: "Ранг в таблице лидеров",
  T_40_XXJ_WS_ORDER1: "Начальный Ранг",
  T_40_XXJ_WS_ORDER2: "Финальный Ранг",
  T_40_XXJ_WS_ORIGINAL: "Сохранить исходную логику",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Метод переполнения",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "При расстановке приоритетов атрибуты оружия игрока заменяют оригинальные атрибуты оружия.",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Приоритет на оружейный скин игрока",
  T_40_XXJ_WS_OWNER_DESCKEY: "Игрок, которому принадлежит эта сущность",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "Глобальный UID дочернего пейзажа, к которому он принадлежит",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID доч. окружения",
  T_40_XXJ_WS_PARENT_DESCKEY: "Родительская сущность",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Родительский",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID сущности род. компонента",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "Идентификатор файла родительского компонента",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Все пассажиры в транспорте",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Пассажир",
  T_40_XXJ_WS_PHYSICALLAYER: "Физический слой",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Матрица физического слоя",
  T_40_XXJ_WS_PHYSICALTIP1: "Название уже существует",
  T_40_XXJ_WS_PHYSICALTIP2: "Удалить название слоя и сделать его невидимым в матрице физических слоев и при перечислении слоев, но объекты сущностей в пределах этого слоя не будут затронуты.",
  T_40_XXJ_WS_PHYSICS: "Физика",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Смена HUD списка лута",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Играбельная сущность",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Сущность всегда сталкивается с другой сущностью",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Сущность следует за другой сущностью",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "Анимация следа пули представляет собой имитацию следа пули",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "Игрок, который получит сообщение",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "Аватар, который использует игрок",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "Костюм, экипированный игроком",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Костюм игрока",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "Тип HUD игрока",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Тип HUD игрока",
  T_40_XXJ_WS_PLAYERIDINFAC: "Серийный номер Фракции",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "Игрок для записи в лог",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Использовать определенный жетон игрока",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "Список навыков игрока",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "Статус игрока: живой, нокдаун, устранен",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Скорость Проигрывания",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Скорость Проигрывания",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Например, 1,25 означает на 25% быстрее, чем первоначальная скорость",
  T_40_XXJ_WS_POS_DESCKEY: "Координаты для телепортации",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "Тип спецэффектов стикера",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Цвет на печати",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Выполнить обход контейнера для получения пары ключ-значение. Включает дочерний процесс, который является циклом.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Зацикленный словарь (dict)",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Прогресс [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Прогресс [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "Кнопка прогресса навыка",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Кнопка прогресса навыка",
  T_40_XXJ_WS_QUATERNION: "Вращение кватерниона",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Смена HUD быстрых сообщений",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Сообщения рядом со списком команды",
  T_40_XXJ_WS_RADIUS_DESCKEY: "Радиус двух полукругов в форме таблетки",
  T_40_XXJ_WS_READCELL: "Считать ячейку",
  T_40_XXJ_WS_READCSV: "Считать содержание таблицы",
  T_40_XXJ_WS_READCSV_DESC: "Считать содержимое всей таблицы. Вернуть двумерный массив.",
  T_40_XXJ_WS_READCSVCELL: "Считать по ряду # и названию столбца",
  T_40_XXJ_WS_READCSVCOL_DESC: "Считать содержимое определенного столбца таблицы. Возвращает массив.",
  T_40_XXJ_WS_READCSVROW_DESC: "Считать содержимое определенной строки таблицы. Возвращает массив.",
  T_40_XXJ_WS_READLEADERBOARD: "Считать значение таблицы лидеров",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Считать соответствующее значение определенного идентификатора в таблице лидеров в базе данных.",
  T_40_XXJ_WS_READLEADERBOARD2: "Считать по диапазону рангов",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Считать значение разницы между определенным рангом и определенным рангом в таблице лидеров в базе данных.",
  T_40_XXJ_WS_RED: "Красный",
  T_40_XXJ_WS_RELOAD: "Перезарядка",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Метод отображения",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Восстановить костюм игрока по умолчанию",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Восстановить оружейный скин игрока по умолчанию",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Управление возможностью ограничения перетаскивания области просмотра. Выбрано по умолчанию.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Огранич. перетаскивание или нет",
  T_40_XXJ_WS_RESULT_DESCKEY: "Результат считывания",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Результат",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Управление возможностью поиска самого большого числа в списке",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Управление возможностью поиска самого маленького числа в списке",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Найти наименьшее число в списке",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Найти наибольшее число в списке",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "Точка Возрождения игрока. Если нет контрольных точке, используй точку появления. Иначе, используй контрольную точку.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Точка Возрождения",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Правая рука",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Правая рука",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "Правый цвет",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Правый цвет",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Управление возможностью отображения специальных эффектов справа",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Отображать или нет эффект справа",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Правая ступня",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Правая ступня",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Правая рука",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Правая рука",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Правая иконка",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Правая иконка",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Правая нога",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Правая нога",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Текст правого счета",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Текст правого счета",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Правый текст",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Правый текст",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "Компонент жесткого тела",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Компонент жесткого тела",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "Перечисление жесткого тела",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Перечисление жесткого тела",
  T_40_XXJ_WS_ROW_DECS: "Ряд для считывания",
  T_40_XXJ_WS_ROWVALUE: "Содержание ряда",
  T_40_XXJ_WS_SCALE_DESCKEY: "Настроить масштаб объекта",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Шкала",
  T_40_XXJ_WS_SCALE0_DESCKEY: "Масштаб масштабирования серии координат в мире",
  T_40_XXJ_WS_SCALE1_DESCKEY: "Масштаб масштабирования. 1 по умолчанию.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "Значение шкалы",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "Название места",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Табло",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Панель очков",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Поддерживает несколько направлений прокрутки",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Направление прокрутки",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "Коэффициент прокрутки. Чем больше значение, тем быстрее прокрутка.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Коэффициент прокрутки",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Настроить CullingMask камеры",
  T_40_XXJ_WS_SETGLOBAL: "Установить глобальные",
  T_40_XXJ_WS_SETPARENT_D: "Поддерживаются только сущности, имеющие компонент Трансформация",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Настроить ID костюма игрока",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Изменение костюмов нескольких игроков",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Установить направление игрока",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Настроить смену HUD игрока",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Настроить оружейный скин игрока",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Управление возможностью отображения сущностей в целевом месте",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Отображение объекта на цели",
  T_40_XXJ_WS_SHOWPLAYER: "Сущность отображения",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Сущность HUD деталей однопольз. игры",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Сущность HUD для матчей с одним игроком. Изменение свойств сущности влияет на содержимое, которое будет отображаться на соответствующем пользовательском интерфейсе.",
  T_40_XXJ_WS_SIZEDELTA: "Дельта размеров якоря и компонента",
  T_40_XXJ_WS_SKELETON: "Скелет",
  T_40_XXJ_WS_SKELETON_D: "Стержень, используемый для доступа к скелетной маске",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Часть скелета",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Сущность HUD кнопки навыка",
  T_40_XXJ_WS_SLOT_DESCKEY: "Слот оружия",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Если выбрано, при перетаскивании будет происходить медленное движение. При отсутствии выбора перетаскивание соответствует скорости мыши.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Плавное движение или нет",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Мягкость",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Мягкость",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Звуковая сущность",
  T_40_XXJ_WS_SPACE_DESCKEY: "Пробел",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Расст. между доч. ячейками",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "Координаты Точки Появления ИИ",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Координаты Точки Появления",
  T_40_XXJ_WS_SPEED_DESCKEY: "Скорость",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Скорость",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Ускорение",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "Радиус сферы",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "Цвет спрея",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Цвет спрея",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "Результат спрея",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Результат спрея",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "Распылитель (автомат)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Винтовка с распылителем",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Начальная скорость",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Вытащить стикер",
  T_40_XXJ_WS_SPRITEID: "ID ассета спрайта",
  T_40_XXJ_WS_SPRITEID_D: "ID, который используется для описания ассета спрайта",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Тип стикера",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "Целевая сущность для генерации в статичный пиксель",
  T_40_XXJ_WS_STARTPOSITION_D: "Координаты геометрического центра фигуры",
  T_40_XXJ_WS_STAY_D: "Сохранять текущее положение, вращение и масштабирование дочерней сущности? Обычно это значение равно true, и настройки пользовательского интерфейса неэффективны для этого параметра.",
  T_40_XXJ_WS_STRING_NAMEKEY: "Строка",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Конвертировать строку в десятичную дробь",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Преобразить строку в целое число",
  T_40_XXJ_WS_STYLE_DESCKEY: "Метод воспроизведения интерполяции. Варианты включают воспроизведение один раз, цикл и повторное воспроизведение.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Изменить область игрока",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Переключить значение",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Сменить оружие, в зависимости от слота игрока",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Сменить слот предмета",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Переключить предмет",
  T_40_XXJ_WS_TABLENAME_DESC: "Отображается как имя таблицы, но на самом деле является UID",
  T_40_XXJ_WS_TABLEVALUE: "Содержание таблицы",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "Список тегов",
  T_40_XXJ_WS_TARGET_DESCKEY: "Целевая сущность для генерации пикселя карты. По умолчанию пустая.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Сущность для создания пикселя карты",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Атаковать цель",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "Целевая сущность",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Сущность",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "Организация, в которой находится настраиваемая функция",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "Сущность, которая атакована ИИ",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "Целевая сущность для следования",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "Сущность предмета (может быть пустой)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "Целевая сущность, на которую следует обратить внимание",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "Звуковая сущность для паузы",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "Звуковая сущность для использования после паузы",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "Звуковая сущность для удаления",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Информация о напарниках",
  T_40_XXJ_WS_TELEPORTA_D: "Телепортировать игрока в указанное место с заданным направлением",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Текст подсказки",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Цвет текста уведомления",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "Текстовая сущность представляет текст, который будет отображаться",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "Ключи текста для отображения",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Ключ текста",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "Временная метка",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "Стиль отображения локализованной строки",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Стиль отображения временной метки",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "Локализованная строка для временной метки",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Временная метка строки локализации",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Подсказка",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Подсказка",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "Количество предметов для лута",
  T_40_XXJ_WS_TOKENID_DESCKEY: "ID предмета для лута",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "Скорость буксировки игрока",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Тип перевода",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "Сущность анимации интерполяции",
  T_40_XXJ_WS_TYPE_DESCKEY: "Это тип описания. При использовании Typeof вернет его тип.",
  T_40_XXJ_WS_TYPE_NAMEKEY: "Тип жесткого тела",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Различные типы жестких тел выполняют разные функции",
  T_40_XXJ_WS_TYPE3_DESCKEY: "В текущей версии поддерживаются только основные валюты",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Управление возможностью настройки глубины мини-карты",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Использовать карту глубины",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Следует или нет гравитационному закону",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Гравитационный или нет",
  T_40_XXJ_WS_UUID_DESCKEY: "Уникальный идентификатор игрока",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "Значение",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Значение",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Значение [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "Первое значение",
  T_40_XXJ_WS_VALUE2_DESCKEY: "Второе значение",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Значение [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "Целевое значение",
  T_40_XXJ_WS_VALUEB_DESCKEY: "Целевое значение",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "Название значение для перехода. Вы можете использовать это для получения значения локальной переменной.",
  T_40_XXJ_WS_VALUET_DESCKEY: "Прогресс интерполяции. Находится в диапазоне от 0 до 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Тип переменной",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "Вертикальный тип дисплея",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Вертикальный тип дисплея",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "Уровень видимости объекта",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Видимый слой",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Костюм содержит набор, голову, маску, грим, верх, низ и обувь",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Тип костюма",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Слот костюма",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Оружия",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "ID оружейного скина",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID оружейного скина",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "ID оружейного скина",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "Оружейный скин игрока",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Компонент перечисления типов",
  T_40_XXJ_WS_WIDTH_DESCKEY: "Ширина",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Перенос слова",
  T_40_XXJ_WS_WRITELEADERBOARD: "Записать значение Таблицы Лидеров",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Записать соответствующее значение определенного ключа в таблицу лидеров в базе данных.",
  T_40_XYL_WS_BUMPERFACTORY: "Завод машинок с Автодрома",
  T_40_XYL_WS_BURNDAMAGE: "Урон от горения",
  T_40_XYL_WS_BURNINTERVAL: "Интервал урона от горения (с)",
  T_40_XYL_WS_BURNTIME: "Время горения после взрыва",
  T_40_XYL_WS_COLORFULSKY: "Цветное Небо",
  T_40_XYL_WS_CRANEMACHINE: "Крановая машина",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Макс. урон при столкновении",
  T_40_XYL_WS_CRASHMAXSPEED: "Максимальный предел скорости повреждения при столкновении",
  T_40_XYL_WS_CRASHMESS: "Параметр массы во время аварии",
  T_40_XYL_WS_CRASHMINDAMAGE: "Мин. урон при столкновении",
  T_40_XYL_WS_DISPLAYBOARD: "Билборд",
  T_40_XYL_WS_EXPLODEDAMAGE: "Урон взрыва",
  T_40_XYL_WS_EXPLODEDELAY: "Время задержки взрыва",
  T_40_XYL_WS_EXPLODERANGE: "Дальность взрыва",
  T_40_XYL_WS_FERRISWHEEL: "Колесо Обозрения",
  T_40_XYL_WS_FOODTRUCK002: "Грузовичок с Едой B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Время переключения снаряжения (с)",
  T_40_XYL_WS_ICAROUSEL001: `Карусель
Компонент A`,
  T_40_XYL_WS_ICAROUSEL002: `Карусель
Компонент B`,
  T_40_XYL_WS_ICAROUSEL003: "Карусель",
  T_40_XYL_WS_ICEDANCEDOOL: "Синяя кукла",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Коэффициент неконтролируемой парковочной мощности",
  T_40_XYL_WS_LOLLIPOP: "Огромный леденец",
  T_40_XYL_WS_NEWHOOKGUN: "Суперкрюковая пушка",
  T_40_XYL_WS_OPENSWING: "Кнопка взмаха",
  T_40_XYL_WS_OPENTRACTION: "Кнопка буксировки",
  T_40_XYL_WS_PODIUM: "Подиум",
  T_40_XYL_WS_SKYCITY: "Город",
  T_40_XYL_WS_SKYSCRAPER_A001: `Небоскреб А
Компонент А`,
  T_40_XYL_WS_SKYSCRAPER_A002: `Небоскреб A
Компонент B`,
  T_40_XYL_WS_SKYSCRAPER_A003: `Небоскреб A
Компонент C`,
  T_40_XYL_WS_SKYSCRAPER_B001: `Небоскреб B
Компонент А`,
  T_40_XYL_WS_SKYSCRAPER_B002: `Небоскреб B
Компонент B`,
  T_40_XYL_WS_SKYSCRAPER_B003: `Небоскреб B
Компонент C`,
  T_40_XYL_WS_SKYSCRAPER_C001: `Небоскреб C
Компонент А`,
  T_40_XYL_WS_SKYSCRAPER_C002: `Небоскреб C
Компонент B`,
  T_40_XYL_WS_SKYSCRAPER_C003: `Небоскреб C
Компонент C`,
  T_40_XYL_WS_SKYSCRAPER_D001: `Небоскреб D
Компонент А`,
  T_40_XYL_WS_SKYSCRAPER_D002: `Небоскреб D
Компонент B`,
  T_40_XYL_WS_SKYSCRAPER_D003: `Небоскреб D
Компонент C`,
  T_40_XYL_WS_SKYSCRAPER_E001: `Небоскреб E
Компонент А`,
  T_40_XYL_WS_SKYSCRAPER_E002: `Небоскреб E
Компонент B`,
  T_40_XYL_WS_SKYSCRAPER_E003: `Небоскреб E
Компонент C`,
  T_40_XYL_WS_STEERANGLE: "Радиус поворота на скорости",
  T_40_XYL_WS_STEERSPEED: "Макс. скорость при повороте на скорости",
  T_40_XYL_WS_SWINGSPEED: "Скорость взмаха",
  T_40_XYL_WS_TARGETOBJECT: "Якорь движения",
  T_40_XYL_WS_TRACTIONSPEED: "Скорость буксировки",
  T_40_XYL_WS_TRIGGERCAPSULE: "Пользователь триггер капсулы",
  T_40_XYL_WS_TRIGGERSPHERE: "Пользовательский триггер сферы",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Пользовательский объект",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Пустой компонент объекта, который можно использовать с компонентом рендеринга и компонентом столкновений.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Компонент польз. рендера",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Пользовательский компонент рендеринга, используемый для рендеринга с использованием пользовательских ресурсов модели.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Каждая метка на враге назначает цену. Любой союзник, устранивший помеченного противника, получает [FFB300]{0}валюты матча[-]. Ты получишь доп. [FFB300]100[-] за устранение врага. Получи доп. [FFB300]{1} Монет FF[-] из Монетной машины в матчах КБ.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Награда За Поимку",
  T_41_CJ_A_ESPORTS_TH: "Киберспортсмен (Маска)",
  T_41_CJ_B_ESPORTS_TH: "Киберспортсмен (Низ)",
  T_41_CJ_H_ESPORTS_TH: "Киберспортсмен (Голова)",
  T_41_CJ_S_ESPORTS_TH: "Киберспортсмен (Обувь)",
  T_41_CJ_T_ESPORTS_TH: "Киберспортсмен (Верх)",
  T_41_CJ_T_FFSI: "Джерси Чемпиона FFSI",
  T_41_CJ_T_FOOTBALL_EU01: "Джерси - Солнечный Луч",
  T_41_CJ_T_FOOTBALL_EU02: "Джерси - Кричаще-Красный",
  T_41_CJ_T_FOOTBALL_EU03: "Джерси - Корона Спорта",
  T_41_CJ_T_FOOTBALL_EU04: "Джерси - Королевский Титан",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Сью",
  T_41_LXW_TabName_Items: "Предмет",
  T_41_R_CD_COIL: "Сужение Зоны",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Управл. активацией устройства",
  T_41_SJ_WS_SPECIALITEM_NAME: "Устройство",
  T_41_SW_SKILL_DESC_DELIVERY: "При попадании в противника с расстояния [FFB300]{0}м[-], атакующий отмечается на [FFB300]{1}с[-] (информация передается напарникам). Макс. [FFB300]{2} метки[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Получи [FFB300]{0} доп. Очков Щита[-] в начале матча. Восст. Очки Щита после сражения.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "При исп. активного навыка, дает [FFB300]{1} Очков Щита[-] себе и напарникам в пределах [FFB300]{0}м[-]. Очки Щита исчезают после [FFB300]{2}с[-], после чего игроки могут получить эффект снова. Восст: [FFB300]{3}с[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Развернутые Стены восстанавливают [FFB300]{0}[-] прочности в секунду при попадании, в течение этого напарники в радиусе [FFB300]{1}м[-] восстанавливают [FFB300]{2} ХП/с[-]. Макс. [FFB300]{3} ХП[-] на каждого члена команды от каждой Стены.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Скин Питомца: Потусторонний Кактус",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Скин Питомца: Нарисованный Сокол",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Тип",
  T_41_WT_SKILL_DESC_FIREBOY: "Создает огненный экран шириной [FFB300]{1}м[-], который длится [FFB300]{0}с[-] и движется вперед со скоростью [FFB300]{2}м/с[-] до [FFB300]{3}с[-]. Пока экран действует, используйте умение еще раз, чтобы остановить его. [FFB300]Враги (или Стены)[-], которые коснутся экрана, мгновенно получат [FFB300]{4} (или {5}) урона[-], а затем получат [FFB300]{6} (или {7}) урона/с[-]. Длится [FFB300]{8}с[-]. Перезарядка: [FFB300]{9}с[-]. Можно сохранить до [FFB300]{10}[-] использований навыка с перезарядкой [FFB300]{11}с[-] между каждым использованием.",
  T_41_WT_SKILL_NAME_FIREBOY: "Огненный Мираж",
  T_41_WZY_WS_CHARGEMAX: "Макс. зарядов Создателя Стен",
  T_41_WZY_WS_CROSSBOWNAME: "Арбалет",
  T_41_WZY_WS_DECELERATIONRATIO: "Ускорение % в воде",
  T_41_WZY_WS_DEICEWALLPARAM1: "Радиус плавления",
  T_41_WZY_WS_DEICEWALLPARAM2: "Продолжительность плавления",
  T_41_WZY_WS_EXPPERCHIP: "Опыт от чипа стенок",
  T_41_WZY_WS_EXPPERDAMAGE: "Опыт от нанесения урона",
  T_41_WZY_WS_EXPPERMOVEMILE: "Опыт за каждый пройденный метр",
  T_41_WZY_WS_EXPPERSECOND: "Опыт в секунду",
  T_41_WZY_WS_GRENADEEXPTIME: "Задержка взрыва",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Взрывчатки",
  T_41_WZY_WS_GRENADEMAX: "Макс. урон",
  T_41_WZY_WS_GRENADEMIN: "Мин. урон",
  T_41_WZY_WS_GRENADERANGE: "Дальность взрыва",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Коэффициент урона на транспортных средствах",
  T_41_WZY_WS_GRENADERATIOSELF: "Коэффициент урона на себя",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Коэффициент урона на напарниках",
  T_41_WZY_WS_GRENADTHROWSPEED: "Взрывная скорость перемещения",
  T_41_WZY_WS_HANDCANNONNAME: "Ручная Пушка",
  T_41_XXJ_WS_ACCELERATION: "Ускорение",
  T_41_XXJ_WS_ACCELERATION_D: "Создание заданного эффекта ускорения",
  T_41_XXJ_WS_ACTION: "Узел действия",
  T_41_XXJ_WS_ACTION_D: "Поворот действия",
  T_41_XXJ_WS_ADDHP: "Лечащие предметы",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Добавить Макс. ХП",
  T_41_XXJ_WS_AICASTSKILL_D: "Исп. навыка ИИ",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Смещение центра системы помощи при прицеливании",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Расстояние автоприцела",
  T_41_XXJ_WS_AIMASSISTENTITY: "Сущность автоприцела",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Сущность, на которую можно использовать автоприцел",
  T_41_XXJ_WS_AISKILLTYPE: "Тип навыка зомби",
  T_41_XXJ_WS_AISKILLTYPE_D: "Тип навыка зомби",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Все предметы",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Все предметы",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Изменить размер магазина",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Патроны в магазине",
  T_41_XXJ_WS_ANCHORPOSITION_D: "Координаты якоря относительно родительской сущности",
  T_41_XXJ_WS_ANGLE_D: "Угол вращение оси z",
  T_41_XXJ_WS_ANGULARDRAG: "Угловое перетаскивание",
  T_41_XXJ_WS_ANGULARVELOCITY: "Угловая скорость",
  T_41_XXJ_WS_ANIMATIONCLIP: "Состояние анимации",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Контроллер анимации",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Сущность анимации",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "Файл и ресурс, используемый для управления контроллером анимации",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Ресурсы UUID контроллера анимации",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Тип перечисления циклов",
  T_41_XXJ_WS_ANIMATIONSTATE: "Состояние анимации",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Операция, в которой поддерживаются все типы присвоения значений, а цифровые типы также поддерживают самоинкремент, самовычитание, самоумножение и самоделение.",
  T_41_XXJ_WS_ATTACHMENT: "Обвес",
  T_41_XXJ_WS_ATTACHMENT_D: "Обвес",
  T_41_XXJ_WS_ATTACHTARGET: "Связанная сущность",
  T_41_XXJ_WS_BAG: "Рюкзак",
  T_41_XXJ_WS_BAG_D: "Компонент рюкзака",
  T_41_XXJ_WS_BANNERID: "ID Баннера",
  T_41_XXJ_WS_BANNERID_D: "ID Баннера",
  T_41_XXJ_WS_BEHAVIOURTREE: "Дерево поведения",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Дерево поведения",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Сущность древа и поведения",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "Сущность дерева поведения, которое может быть изменено",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Польз. узел дерева поведения",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Пользовательский поворот дерева поведения",
  T_41_XXJ_WS_BODY: "Тело",
  T_41_XXJ_WS_BORDERLR: "Грань (лево;право)",
  T_41_XXJ_WS_BORDERLR_D: "Левая и правая граница",
  T_41_XXJ_WS_BORDERTB: "Граница (верх, низ)",
  T_41_XXJ_WS_BORDERTB_D: "Верхняя и нижняя граница",
  T_41_XXJ_WS_BRPEAKRANK: "Наивысший ранг КБ",
  T_41_XXJ_WS_BRPEAKRANK_D: "Наивысший ранг КБ",
  T_41_XXJ_WS_BRRANK: "Ранг КБ",
  T_41_XXJ_WS_BRRANK_D: "Ранг КБ",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Тип узла дерева поведения",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Тип поворота дерева поведения",
  T_41_XXJ_WS_BTREE: "Дерево поведения",
  T_41_XXJ_WS_BTREENODESTATE: "Состояние узла дерева поведения",
  T_41_XXJ_WS_BTREENODESTATE_D: "Статус поворота дерева поведения",
  T_41_XXJ_WS_BUFFABLEENTITY: "Сущность с поддержкой бонуса",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Позволяет добавлять бонусы, удалять бонусы и получать списки добавленных бонусов",
  T_41_XXJ_WS_BUILDINGICEWALL: "Стена",
  T_41_XXJ_WS_CAMOUFLAGE: "Функциональные предметы",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Доска, камуфляж...",
  T_41_XXJ_WS_CAPICITY_D: "Начальная вместимость",
  T_41_XXJ_WS_CENTERINVISIBLE: "Невидимый для центра",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Не видно для центрирования",
  T_41_XXJ_WS_COLOR: "Цвет",
  T_41_XXJ_WS_COLOR_D: "Цвет",
  T_41_XXJ_WS_CONDITION: "Узел условия",
  T_41_XXJ_WS_CONDITION_D: "Условия представляют собой специальный булев тип",
  T_41_XXJ_WS_CONDITION1_D: "Условие поворота",
  T_41_XXJ_WS_CONSTRAIN: "Ограничение RigidBody",
  T_41_XXJ_WS_CONSTRAIN_D: "Добавить ограничений к RigidBody. Это компиляция типов ограничений RigidBody.",
  T_41_XXJ_WS_COUNT_D: "Количество",
  T_41_XXJ_WS_CROSSBOW_D: "Арбалет",
  T_41_XXJ_WS_CSPEAKRANK: "Наивысший ранг БО",
  T_41_XXJ_WS_CSPEAKRANK_D: "Наивысший ранг БО",
  T_41_XXJ_WS_CSRANK: "Ранг БО",
  T_41_XXJ_WS_CSRANK_D: "Ранг БО",
  T_41_XXJ_WS_CSVNAME_D: "Файл csv в разделе SceneData, соответствующий режиму. Заканчивается символом .csv. Заголовки записываются строчными буквами.",
  T_41_XXJ_WS_CURCAPACITY: "Исп. вместимость",
  T_41_XXJ_WS_CURPROGRESS: "Текущий прогресс",
  T_41_XXJ_WS_CURRENTCLIP: "Текущий клип",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Прогресс текущего клипа",
  T_41_XXJ_WS_CURRENTSTATE: "Текущее состояние",
  T_41_XXJ_WS_CUSTOMHUDID: "ID пользовательского HUD",
  T_41_XXJ_WS_CUSTOMHUDID_D: "ID, используемый для описания пользовательского актива HUD.",
  T_41_XXJ_WS_DASHATTACK: "Атака-рывок",
  T_41_XXJ_WS_DEBUG: "Начать отладку",
  T_41_XXJ_WS_DEBUG_D: "Фикс",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Замедление %: Замедление при нахождении объекта в воде (диапазон временно устанавливается как 0-100)",
  T_41_XXJ_WS_DEPTH_D: "Глубина",
  T_41_XXJ_WS_DRAG: "Коэфф. перетаскивания",
  T_41_XXJ_WS_DRAG_D: "Чем больше коэффициент, тем быстрее снижается скорость движения.",
  T_41_XXJ_WS_DUMMY: "Марионетка",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Включить режим низкой графики",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Если включен режим низкого fps, игра будет работать на скорости 15 fps; в противном случае - 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Вернуть созданную сущность списка",
  T_41_XXJ_WS_ENTITYNAME: "Имя Объекта",
  T_41_XXJ_WS_ENTITYNAME_D: "Имя объекта, заданное игроком",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "ID логической сущности или сборного объекта",
  T_41_XXJ_WS_EQUIPANDBAG: "Броня и Рюкзак",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Перечисление слотов снаряжения",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Перечисление слотов снаряжения",
  T_41_XXJ_WS_EXPLODE: "Самовзрыв",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Взрывное оружие",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Скорость автоперезарядки",
  T_41_XXJ_WS_FILEID: "Внутренний ID",
  T_41_XXJ_WS_FILEID_D: "Внутренний ID элемента управления в сборном объекте",
  T_41_XXJ_WS_FILLAMOUNT: "Заполнить количество",
  T_41_XXJ_WS_FILLAMOUNT_D: "Значение заполнения",
  T_41_XXJ_WS_FILLDIR: "Заполнить направление",
  T_41_XXJ_WS_FILLDIR_D: "Направление заполнения",
  T_41_XXJ_WS_FILLDIR_D1: "Заполнить перечисление направлений",
  T_41_XXJ_WS_FILLTYPE: "Заполнить тип",
  T_41_XXJ_WS_FILLTYPE_D: "Заполнить тип",
  T_41_XXJ_WS_FILLTYPE_D1: "Заполнить перечисление типов",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Найти путь",
  T_41_XXJ_WS_FINISH: "Завершение",
  T_41_XXJ_WS_FIREINTERVAL: "Интервал стрельбы",
  T_41_XXJ_WS_FIREINTERVAL_D: "Интервал атаки",
  T_41_XXJ_WS_FLIP: "Метод переворота",
  T_41_XXJ_WS_FLIP_D: "Метод переворота",
  T_41_XXJ_WS_FLYBOMBBEE: "Летающие Зомби",
  T_41_XXJ_WS_FORCE: "Сила",
  T_41_XXJ_WS_FORCE_D: "Создание силы заданной интенсивности",
  T_41_XXJ_WS_FORCETYPE: "Тип силы",
  T_41_XXJ_WS_FORCETYPE_D: "Различные типы сил, действующих на RigidBody. P.S. Действует только для динамических типов RigidBody.",
  T_41_XXJ_WS_FREEZEALL: "Заморозить движение и вращение",
  T_41_XXJ_WS_FREEZEPOSITION: "Заморозить линейное вращение",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Заморозить ось x",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Заморозить ось y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Заморозить ось z",
  T_41_XXJ_WS_FREEZEROTATION: "Заморозить все вращения",
  T_41_XXJ_WS_FREEZEROTATIONX: "Заморозить х вращение",
  T_41_XXJ_WS_FREEZEROTATIONY: "Заморозить y вращение",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Заморозить z вращение",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Расстояние для макс. урона",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Расстояние для макс. урона",
  T_41_XXJ_WS_GAMEID_D: "ID миссии",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Дать предмет Мегаполиса",
  T_41_XXJ_WS_GRADIENT: "Градиент",
  T_41_XXJ_WS_GRADIENT_D: "Градиент",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Градиент внизу",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "Градиент внизу",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Прозрачность (Низ)",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Прозрачность (Низ)",
  T_41_XXJ_WS_GRADIENTTOP: "Градиент (верх)",
  T_41_XXJ_WS_GRADIENTTOP_D: "Градиент (верх)",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Прозрачность (Верх)",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Прозрачность (Верх)",
  T_41_XXJ_WS_GRAPHID: "ID скрипта",
  T_41_XXJ_WS_GRAPHID_D: "Идентификатор, используемый для описания ассета.",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Компонент стеноплавителя",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Задержка взрыва",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Метательные",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Макс. Урон",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Мин. урон",
  T_41_XXJ_WS_GRENADERANGE_D: "Дальность взрыва",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Множитель урона по себе",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Множитель урона союзника",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Множитель урона транспорта",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Скорость метания",
  T_41_XXJ_WS_GRENADEWEAPON: "Категория Метательные",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Базовые метательные типы",
  T_41_XXJ_WS_HANDCANNON_D: "Метательные",
  T_41_XXJ_WS_HEAD: "Голова",
  T_41_XXJ_WS_HEADID: "ID Аватара",
  T_41_XXJ_WS_HEADID_D: "ID Аватара",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Тяжёлое Оружие",
  T_41_XXJ_WS_HELMET_D: "Текущий шлем",
  T_41_XXJ_WS_HELMET1_D: "Шлем",
  T_41_XXJ_WS_HELMET2_D: "Сущность шлема",
  T_41_XXJ_WS_HITBODYPART_D: "Часть тела, которая подверглась удару",
  T_41_XXJ_WS_HITBPDYPART: "Удар по части тела",
  T_41_XXJ_WS_HITENTITY_D: "Сущность попадания",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "Сущность HUD, которому он принадлежит",
  T_41_XXJ_WS_HUD3DCONTAINER: "Контейнер 3D контента",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "Контейнерный объект HUD 3D. Это HUD, который игроки изменяют из редактора.",
  T_41_XXJ_WS_HUDGRID: "Польз. макет (панель)",
  T_41_XXJ_WS_HUDLAYOUT: "Управление отображением",
  T_41_XXJ_WS_HUDLAYOUT_D: "Объект вставки HUD. Это HUD, который игроки изменяют из редактора.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Управление пользовательским аватаром",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "Информационная сущность профиля HUD. Это HUD, который игроки изменяют из редактора.",
  T_41_XXJ_WS_HUDTEXTURE: "Управление текстурами",
  T_41_XXJ_WS_HUDTEXTURE_D: "Сущность текстуры HUD. Это HUD, который игроки изменяют из редактора.",
  T_41_XXJ_WS_HUDTRANSFORM: "Компонент управления UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "Объект управления UITransform",
  T_41_XXJ_WS_IMPULSE: "Удар",
  T_41_XXJ_WS_IMPULSE_D: "Создание удара заданной интенсивности",
  T_41_XXJ_WS_INITIALWORLDPOS: "Начальные мировые координаты",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Перечисление бонусов",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Соответствует столбцу ID в файле BuffData.csv. Перед добавлением нового содержимого необходимо проверить его совместимость с GPP.",
  T_41_XXJ_WS_INVERTFILL: "Инвертировать заполнение",
  T_41_XXJ_WS_INVERTFILL_D: "Инвертировать заполнение",
  T_41_XXJ_WS_ISLOOP: "Цикл",
  T_41_XXJ_WS_ISLOOP_D: "Зацикливать или нет. По умолчанию false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Генерация стат. NavMesh",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Используется только для проверки генерации стат. NavMesh при статической загрузке объектов.",
  T_41_XXJ_WS_ISSUCCESS_D: "Разрушено или нет",
  T_41_XXJ_WS_ITEMENTITY_D: "Сущность предмета",
  T_41_XXJ_WS_ITEMID: "ID предмета",
  T_41_XXJ_WS_ITEMID_D: "ID предмета",
  T_41_XXJ_WS_ITEMID_D1: "ID соответствующего предмета обвеса",
  T_41_XXJ_WS_ITEMLIST: "Список предметов",
  T_41_XXJ_WS_ITEMTYPE_D: "Тип предмета",
  T_41_XXJ_WS_JUMPATTACK: "Атака в прыжке",
  T_41_XXJ_WS_LANDMINE: "Мина",
  T_41_XXJ_WS_LENGTH: "Длина клипа",
  T_41_XXJ_WS_LENGTH_D: "Длина индикатора выполнения. По умолчанию используется длина, указанная в пользовательском интерфейсе сборного объекта.",
  T_41_XXJ_WS_LIMB: "Конечности",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Не удалось добавить элемент, так как длина списка превысила вместимость",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Список бонусов",
  T_41_XXJ_WS_LOOP: "Цикл",
  T_41_XXJ_WS_LOOP_D: "Цикл",
  T_41_XXJ_WS_MAXCAPACITY: "Вместимость",
  T_41_XXJ_WS_MAXCAPACITY_D: "Вместимость рюкзака",
  T_41_XXJ_WS_MAXPROGRESS: "Макс. прогресс",
  T_41_XXJ_WS_MELEEWEAPON_D: "Оружие ближнего боя",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Расстояние для мин. урона",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Расстояние для мин. урона",
  T_41_XXJ_WS_MINISENTRY: "Автоматическая турель",
  T_41_XXJ_WS_NAME: "Название",
  T_41_XXJ_WS_NAME_D: "Название кнопки навыка. Используется для отправки параметров во время инцидентов OnClick, поэтому должна быть гарантирована уникальность.",
  T_41_XXJ_WS_NAME1_D: "Название товаров",
  T_41_XXJ_WS_NAME2_D: "Название списка товаров",
  T_41_XXJ_WS_NAME3_D: "Название Торгового Автомата",
  T_41_XXJ_WS_NICKNAME: "Никнейм",
  T_41_XXJ_WS_NICKNAME_D: "Имя игрока",
  T_41_XXJ_WS_NOCHANGE: "Нет изменений",
  T_41_XXJ_WS_NONE: "Нет ограничений",
  T_41_XXJ_WS_NONE1: "Отсутствует",
  T_41_XXJ_WS_OFFSET: "Смещение",
  T_41_XXJ_WS_OFFSET_D: "Смещение",
  T_41_XXJ_WS_OFFSET1_D: "Записанное значение смещения",
  T_41_XXJ_WS_ONCE: "Один раз",
  T_41_XXJ_WS_ONCE_D: "Один раз",
  T_41_XXJ_WS_ONHIDE: "Когда интерфейс закрыт",
  T_41_XXJ_WS_ONHIDE_D: "Когда интерфейс закрыт",
  T_41_XXJ_WS_ONNODEENTER_D: "При исп. поворота",
  T_41_XXJ_WS_ONSHOW: "При открытии интерфейса",
  T_41_XXJ_WS_ONSHOW_D: "Когда интерфейс открыт",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Срабатывает при изменении текстового поля",
  T_41_XXJ_WS_PERSONALUAV: "Лёгкий дрон",
  T_41_XXJ_WS_PINID: "ID закрепления",
  T_41_XXJ_WS_PINID_D: "ID закрепления",
  T_41_XXJ_WS_PLAYERBAG: "Сущность рюкзака игрока",
  T_41_XXJ_WS_PLAYERBAG_D: "Сущность рюкзака игрока",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Рюкзак игрока",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Рюкзак игрока",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Модифицированный коэффициент скорости при прицеливании",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Влияние скорости движения при стрельбе",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Влияние скорости движения при стрельбе",
  T_41_XXJ_WS_PREFABID: "ID сборного объекта",
  T_41_XXJ_WS_PREFABID_D: "ID, используемый для описания  сборного объекта",
  T_41_XXJ_WS_PREFABID1_D: "Объект шаблона HUD, который представляет этот ID",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Основное оружие 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Основное Оружие 2",
  T_41_XXJ_WS_PROFILEINFO: "Профиль игрока",
  T_41_XXJ_WS_PROFILEINFO_D: "Биография игрока",
  T_41_XXJ_WS_PROGRESSICON_D: "Иконка прогресса",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Название иконки прогресса",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Покинуть мини-игру Мегаполиса",
  T_41_XXJ_WS_RANGE: "Дальность стрельбы",
  T_41_XXJ_WS_RANGE_D: "Дальность атаки",
  T_41_XXJ_WS_RANGE_D1: "Дальность взрыва",
  T_41_XXJ_WS_RANGE_D2: "Дальность турели",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Считать содержимое всей таблицы. Возвращается двумерный массив.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Считать содержимое определенной ячейки",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Считывает содержимое определенной строки. Возвращает массив.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Считывает содержимое определенной строки. Возвращает массив.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Считать суммарную базу данных",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Чтение значения, соответствующего ключу в таблице накопленной базы данных",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Непрерывное восстановление ХП",
  T_41_XXJ_WS_RELOADSPEED: "Скорость перезарядки",
  T_41_XXJ_WS_RELOADSPEED_D: "Скорость перезарядки (базовая скорость х множитель)",
  T_41_XXJ_WS_RESOURCEID: "UUID ресурса",
  T_41_XXJ_WS_RESOURCEID_D: "UUID ресурса",
  T_41_XXJ_WS_RESUUID: "ID ресурса",
  T_41_XXJ_WS_RESUUID_D: "UUID назначенного ресурса для отображения",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "Тип ограничения RigidBody",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Каждое ограничение определяется бит. маркировкой и может быть использовано как комбинация",
  T_41_XXJ_WS_ROTATION: "Вращение",
  T_41_XXJ_WS_ROTATION_D: "Угол поворота в мировых координатах. x, y, z относятся к поиску, тангажу и крену соответственно.",
  T_41_XXJ_WS_ROTATION1_D: "Вращение",
  T_41_XXJ_WS_RUNNING: "Бег",
  T_41_XXJ_WS_SCALE: "Масштаб",
  T_41_XXJ_WS_SCALE_D: "Масштаб",
  T_41_XXJ_WS_SCALE1_D: "Масштабируется по определенной оси. Может быть комбинацией трех осей.",
  T_41_XXJ_WS_SCATTERMAX: "Макс. разброс пуль",
  T_41_XXJ_WS_SCATTERMAX_D: "Значение, при котором начинается разброс пуль",
  T_41_XXJ_WS_SCATTERMOVE1: "Разброс размеров при перемещении",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Скорость восст. разброса",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Скорость восст. разброса",
  T_41_XXJ_WS_SCATTERSPEED: "Увеличение скорости  разброса",
  T_41_XXJ_WS_SCATTERSPEED_D: "Увеличение скорости разброса (0,1 = перекрестие увеличивается на 10% при каждом увеличении очереди)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Меньший разброс в положении лежа и приседании",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Вспомогательное оружие",
  T_41_XXJ_WS_SHADERNAME: "Название шейдера",
  T_41_XXJ_WS_SHADERNAME_D: "Название шейдера",
  T_41_XXJ_WS_SHIELDBROKEN: "Атака с разбиванием щита",
  T_41_XXJ_WS_SHIELDUP: "Атаки щита",
  T_41_XXJ_WS_SHOCKWAVE: "Шоковая волна",
  T_41_XXJ_WS_SHOWNAME: "Отображение никнейма",
  T_41_XXJ_WS_SHOWNAME_D: "Отображение никнейма",
  T_41_XXJ_WS_SHOWPIN: "Отобразить закрепление",
  T_41_XXJ_WS_SHOWPIN_D: "Отобразить закрепление",
  T_41_XXJ_WS_SHOWRANK: "Показать ранг",
  T_41_XXJ_WS_SHOWRANK_D: "Показать ранг",
  T_41_XXJ_WS_SHOWTYPE: "Дизайн",
  T_41_XXJ_WS_SHOWTYPE_D: "Тип",
  T_41_XXJ_WS_SHRINKSPEED: "Скорость Сужения",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Включить автоприцел при наведении",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Чувствительность автоприцела на расстоянии (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Коэффициент при определении приоритета расстояния для помощи при прицеливании (≥1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Макс. расстояние для определения приоритета расстояния для помощи при прицеливании",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Минимальное расстояние для определения приоритета расстояния для помощи при прицеливании",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Определения приоритета расстояния для помощи при прицеливании",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Чувствительность автоприцела (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Коэфф. увеличения масштаба",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "Коэффициент увеличения FOV",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Коэффициент чувствительности к вращению прицела",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Модифицированный коэффициент x минимального масштаба урона",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Время увеличения масштаба пользовательского интерфейса при стрельбе",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Коэффициент увеличения масштаба пользовательского интерфейса",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Время возобновления работы пользовательского интерфейса",
  T_41_XXJ_WS_SPEED: "Скорость Проигрывания",
  T_41_XXJ_WS_SPEEQUIP: "Функциональное снаряжение",
  T_41_XXJ_WS_SPEITEM: "Устройства",
  T_41_XXJ_WS_STATICGRAPHID: "ID статического скрипта",
  T_41_XXJ_WS_STATICGRAPHID_D: "ID, используемый для описания статического актива скрипта.",
  T_41_XXJ_WS_STATICWAINING: "Не удалось модифицировать статический тип Rigidbody",
  T_41_XXJ_WS_TARGETTREE: "Сущность дерева поведения",
  T_41_XXJ_WS_TARGETTREE_D: "Сущность дерева поведения",
  T_41_XXJ_WS_TEAMINDEX: "Серийный номер команды",
  T_41_XXJ_WS_TEAMINDEX_D: "Индекс команды, совпадающий с индексом команды в помещении",
  T_41_XXJ_WS_TEAMINDEX_D1: "Номер фракции команды",
  T_41_XXJ_WS_TEMPLATEPREFABID: "ID сборного образца",
  T_41_XXJ_WS_TEXT_D: "Содержимое",
  T_41_XXJ_WS_TEXTURENAME: "Название текстуры",
  T_41_XXJ_WS_TEXTURENAME_D: "Название текстуры",
  T_41_XXJ_WS_THROWATTACK: "Граната",
  T_41_XXJ_WS_TICKINTERVAL: "Обновить интервал",
  T_41_XXJ_WS_TICKINTERVAL_D: "Обновить интервал. Чем больше число, тем дольше происходит обновление.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Включение специальных устройств в рюкзаке игрока",
  T_41_XXJ_WS_UVRECTWH: "Ширина и высота УФ",
  T_41_XXJ_WS_UVRECTWH_D: "Ширина и высота УФ",
  T_41_XXJ_WS_UVRECTXY: "УФ-смещение",
  T_41_XXJ_WS_UVRECTXY_D: "УФ-смещение",
  T_41_XXJ_WS_VELOCITY: "Скорость",
  T_41_XXJ_WS_VELOCITY_D: "Воздержаться от прямого изменения скорости RigidBody. Ее можно изменить с помощью соответствующих API.",
  T_41_XXJ_WS_VEST_D: "Текущий жилет",
  T_41_XXJ_WS_VEST1_D: "Жилет",
  T_41_XXJ_WS_WIDGETID: "ID управления",
  T_41_XXJ_WS_WIDGETID_D: "ID, используемый для описания элемента управления в ассетах интерфейса. Он должен быть сопряжен с пользовательским HUD ID, чтобы обеспечить соответствие уникальному идентификатору элемента управления.",
  T_41_XXJ_WS_WINDATTACK: "Торнадо-атака",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Записать накопленное смещение базы данных",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Записать смещение, соответствующее ключу в таблице в накопленной базе данных",
  T_41_XXJ_WS_ZONEDURATION_D: "Продолжительность заморозки",
  T_41_XXJ_WS_ZONEDURATION1_D: "Продолжительность стеноплавителя",
  T_41_XXJ_WS_ZONERADIUS_D: "Заморозить радиус Зоны",
  T_41_XXJ_WS_ZONERADIUS1_D: "Радиус стеноплавителя",
  T_41_XYL_WS_BOT12: "Бурильщик земли",
  T_41_XYL_WS_BOT9: "Мутировавший зомби-метатель",
  T_41_XYL_WS_ITEM262: "Ледяная панель A",
  T_41_XYL_WS_ITEM263: "Ледяной контейнер A",
  T_41_XYL_WS_ITEM264: "Ледяной контейнер для поставки",
  T_41_XYL_WS_ITEM265: "Ледяные металлические ворота",
  T_41_XYL_WS_ITEM266: "Ледяной контейнер B",
  T_41_XYL_WS_ITEM267: "Ледяной камень A",
  T_41_XYL_WS_ITEM268: "Ледяной камень B",
  T_41_XYL_WS_ITEM269: "Ледяной камень C",
  T_41_XYL_WS_ITEM270: "Ледяной камень D",
  T_41_XYL_WS_ITEM271: "Заброшенный вагон метро",
  T_41_XYL_WS_MODELMATCHNAME: "Холст Конкурса",
  T_41_XYL_WS_NAVMESH: "Динамический navmesh",
  T_41_XYL_WS_REFCUBE: "Отражающий куб",
  T_41_XYL_WS_SNOWSKY: "Ледяной мир",
  T_41_XYL_WS_TOYCUBE: "Играть в куб",
  T_42_CJ_F_B_VOCATIONAL: "Основной Чертёж (Низ)",
  T_42_CJ_F_H_VOCATIONAL: "Основной Чертёж (Голова)",
  T_42_CJ_F_S_VOCATIONAL: "Основной Чертёж (Обувь)",
  T_42_CJ_F_T_VOCATIONAL: "Основной Чертёж (Верх)",
  T_42_CJ_HA_THUNDER_GOLD: "Электрогрим",
  T_42_CJ_M_B_VOCATIONAL: "Механик-Мастер (Низ)",
  T_42_CJ_M_H_VOCATIONAL: "Механик-Мастер (Голова)",
  T_42_CJ_M_S_VOCATIONAL: "Механик-Мастер (Обувь)",
  T_42_CJ_M_T_VOCATIONAL: "Механик-Мастер (Верх)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Игни",
  T_42_H_GLOO_EVOTIGER_N: "Стена - Ярость Тигра",
  T_42_H_GRENADE_SMUDGE_N: "Граната - Тень Кошки",
  T_42_H_M1917_EMPIRE_N: "M1917 - Коронованный Завоеватель",
  T_42_HJ_WS_VFX_INK: "Чернила",
  T_42_JH_WS_BANMATCHMAKING: "Подбор не разрешен для этой карты",
  T_42_JH_WS_BANROOMCREATE: "Не получилось создать комнату",
  T_42_JH_WS_FPS: "FPS-шутер",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Ремикс (Алок)",
  T_42_JH_WS_SKILLSETFIREWALL: "Стена Пламени (Игни)",
  T_42_JH_WS_SKILLSETSANTINO: "Сплит (Сантино)",
  T_42_JH_WS_SKILLSETSONIA: "Нанощит (Соня)",
  T_42_JH_WS_TAG1: "Морозная битва",
  T_42_JH_WS_TAG10: "Гонщик Света",
  T_42_JH_WS_TAG11: "Погоня на колесах",
  T_42_JH_WS_TAG12: "Гонка машин",
  T_42_JH_WS_TAG13: "Исключить из популярных",
  T_42_JH_WS_TAG14: "Первая линия",
  T_42_JH_WS_TAG15: "Война Зомби",
  T_42_JH_WS_TAG16: "Легенда Наследия",
  T_42_JH_WS_TAG2: "Тус. Остров 1.0",
  T_42_JH_WS_TAG3: "Тус. Остров 2.0",
  T_42_JH_WS_TAG4: "Играть Вместе",
  T_42_JH_WS_TAG5: "Покоритель Руин",
  T_42_JH_WS_TAG6: "Хищники",
  T_42_JH_WS_TAG7: "Вечеринка Хищников",
  T_42_JH_WS_TAG8: "Форт Феод 2.0",
  T_42_JH_WS_TAG9: "Охота за головами",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Открой портал в любом месте и телепортируйся!",
  T_42_RW_PORTALSPERSONAL_NAME: "Портал",
  T_42_SJ_WS_ACCESSORIESITEM: "Взять обвес",
  T_42_SJ_WS_AUTOPLAY: "Авто игра",
  T_42_SJ_WS_CLIMB: "Перелезть",
  T_42_SJ_WS_CLOCK_EVENTS: "Сборник событий",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Обратный отсчет или нет",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Циклы",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Пауза события",
  T_42_SJ_WS_CLOCK_START_EVENT: "Начало события",
  T_42_SJ_WS_CLOCK_START_TIME: "Время начала обратного отсчета",
  T_42_SJ_WS_CLOCK_STATE: "Статус секундомера",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Окончание события",
  T_42_SJ_WS_DAMRATIOHEAD: "Изменение коэффициента урона при хэдшоте",
  T_42_SJ_WS_DAMRATIOLIMB: "Изменение коэффициента урона по конечностям",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Коэффициент снижения от взрывного урона",
  T_42_SJ_WS_DRIVE: "Поездка",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Отобразить слои",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Дополнительная вместимость рюкзака",
  T_42_SJ_WS_EXTRAHPRATIO: "Соотношение ХП",
  T_42_SJ_WS_GETOFF_DRIVE: "Выйти из транспорта",
  T_42_SJ_WS_GETON_DRIVE: "Зайти в транспорт",
  T_42_SJ_WS_KNIFEITEM: "Кинжал",
  T_42_SJ_WS_KNIFEITEMPICK: "Кинжал (лут на земле)",
  T_42_SJ_WS_MARKBTNHUD: "Кнопка закрепления на HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "Вы можете включить или отключить кнопку закрепления",
  T_42_SJ_WS_MAXDISTANCE: "Макс. расстояние",
  T_42_SJ_WS_MAXDURARATIO: "Макс. коэффициент прочности",
  T_42_SJ_WS_MICBTNHUD: "Переключатель микрофона на HUD",
  T_42_SJ_WS_MICBTNHUD_D: "Вы можете включить или отключить кнопку микрофона",
  T_42_SJ_WS_MINDISTANCE: "Мин. дистанция",
  T_42_SJ_WS_OPE_VEHICLE: "Управлять транспортом",
  T_42_SJ_WS_PLANE_DESC: "Базовая сетка, размер которой можно свободно регулировать.",
  T_42_SJ_WS_PLANENAME: "Базовая плоскость",
  T_42_SJ_WS_PRIORITY: "Приоритет",
  T_42_SJ_WS_REPLACEPRIORITY: "Заменить приоритет",
  T_42_SJ_WS_SETBTNHUD: "Кнопка настроек на HUD",
  T_42_SJ_WS_SETBTNHUD_D: "Вы можете включить или отключить кнопку настроек",
  T_42_SJ_WS_SIGNALBTNHUD: "Кнопка подключения к сети на HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "Вы можете включить или отключить кнопку подключения к сети",
  T_42_SJ_WS_SPEAKERBTNHUD: "Кнопка звукового сигнала на HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "Вы можете включить или отключить кнопку звукового сигнала автомобиля.",
  T_42_SJ_WS_START_TIME: "Время начала (с)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Получите дополнительную вместимость рюкзака [FFB300]{0}[-] для боеприпасов, за исключением гранатомета. ([FFB300]{1}[-] патроны для AR, [FFB300]{2}[-] патроны для ПП, [FFB300]{3}[-] снайперские патроны, [FFB300]{4}[-] патроны для Дробовика)",
  T_42_SW_SKILL_DESC_Bodyguard: "Скорость перезарядки увеличивается на [FFB300]{0}%[-]. Каждый раз, когда пользователь навыка поражает противника, указанная цель получает уменьшение лечения [FFB300]{1}%[-], которое длится [FFB300]{3}с[-] (макс. снижение: [FFB300]{2}% [-]).",
  T_42_SW_SKILL_DESC_Playboy: "Стань невосприимчивым к разрушительным эффектам (например, замедлению, маркировке, отключению навыков) и получи повышение скорости передвижения на [FFB300]{1}%[-] на [FFB300]{2}с[-]. Восстановление: [FFB300]{0} с[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "После сбивания противника с ног или использования активного навыка, перезаряжается автоматически [FFB300]{0}%[-] от максимальной емкости",
  T_42_SW_SKILL_NAME_Playboy: "Везунчик",
  T_42_SY_BACKPACK_EMPIRE_N: "Рюкзак Королевский Рев",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Скин Питомца: Ледяной Скок",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Байк - Городской Скутер",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Кол-во Монет БО , полученных после проигрыша раунда",
  T_42_TYC_CST_LOSE_MONEY_2: "Кол-во Монет БО , полученных после проигрыша 2-х раундов",
  T_42_TYC_CST_LOSE_MONEY_3: "Кол-во Монет БО , полученных после проигрыша 3-х раундов",
  T_42_WH_ITEM_HEALUAV: "Легкий леч. дрон",
  T_42_WH_ITEM_HEALUAV_DESC: "Развертывает Легкий Дрон, который летит вперед и непрерывно лечит напарников в указанном диапазоне",
  T_42_WH_ITEM_SKILLCARD: "Навык: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Используйте, чтобы высвободить активный навык [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Тип Патронов",
  T_42_XXJ_WS_AMMOTYPE_D: "Тип Патронов",
  T_42_XXJ_WS_ASSETCONFIGID: "ID Скина",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Скин",
  T_42_XXJ_WS_ATTACKSTATUS: "Статус атаки",
  T_42_XXJ_WS_AUTOPLAY: "Авто игра",
  T_42_XXJ_WS_AUTOPLAY_D: "Авто игра",
  T_42_XXJ_WS_AVATARABLE: "Изменяемый компонент внешнего вида",
  T_42_XXJ_WS_AVATARABLE_D: "Изменение внешнего вида в зависимости от деталей",
  T_42_XXJ_WS_AVATARRESUUID: "Внешний вид UUID ресурса",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Преобразование представления угла оси вращения в кватернионы",
  T_42_XXJ_WS_B_D: "Значение цвета B",
  T_42_XXJ_WS_BASEVALUE_D: "Основание логарифма",
  T_42_XXJ_WS_BEZIERCURVE: "Кривая Безье",
  T_42_XXJ_WS_BEZIERCURVE_D: "Кривая Безье",
  T_42_XXJ_WS_BOTDIFFICULTY: "Сложность бота",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Метод сочетания гибкости",
  T_42_XXJ_WS_BOUNCINES: "Прыгучесть",
  T_42_XXJ_WS_BTREEID: "ID дерева поведения",
  T_42_XXJ_WS_BTREEID_D: "ID дерева поведения",
  T_42_XXJ_WS_CANPURCHAS: "Возможно купить или нет",
  T_42_XXJ_WS_CANPURCHAS_D: "Возможно купить или нет",
  T_42_XXJ_WS_CLIMBSTATUS: "Поведение при восхождении",
  T_42_XXJ_WS_CLOCK: "Объект таймера",
  T_42_XXJ_WS_CLOCK_D: "Объект таймера",
  T_42_XXJ_WS_CLOCK_D1: "Таймер",
  T_42_XXJ_WS_CONTAINER: "Контейнер",
  T_42_XXJ_WS_CONTROLPOINTS: "Контрольные точки",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Контрольные точки",
  T_42_XXJ_WS_COROUTINEID: "Дескриптор сопрограммы",
  T_42_XXJ_WS_COROUTINEID_D: "Идентификатор сопрограммы относится к дескриптору конкретной сопрограммы. Это позволяет выполнять различные операции.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Создать самоотносительный",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Создать самоотносительный",
  T_42_XXJ_WS_CREATESOUND: "Создать звуковой эффект",
  T_42_XXJ_WS_CREATESOUND_D: "Восп. назначенный звуковой эффект. Если нужно установить дополнительные свойства, вы можете сделать это, настроив свойства объекта.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Завершить специальную миссию",
  T_42_XXJ_WS_DAMAGELIST_D: "Список приращений урона",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Коэффициент урона хэдшота",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Множитель уменьшения урона от взрыва",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Физ. материал по умолчанию",
  T_42_XXJ_WS_DEFAULTFIST_D: "Кулак по умолчанию",
  T_42_XXJ_WS_DELTA: "Дельта",
  T_42_XXJ_WS_DELTA_D: "Дельта",
  T_42_XXJ_WS_DELTATIME: "Интервал логических кадров",
  T_42_XXJ_WS_DELTATIME_D: "Интервал между двумя обновлениями логических кадров GS",
  T_42_XXJ_WS_DEPTH: "Слой",
  T_42_XXJ_WS_DEPTH_D: "Отображение слоев на иконке",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Список отключенного лута на земле",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "Список предметов, не являющихся лутом на земле",
  T_42_XXJ_WS_DRIVER: "Место водителя",
  T_42_XXJ_WS_DRIVINGSTATUS: "Поездка",
  T_42_XXJ_WS_DURATION_D1: "Продолжительность обратного отсчета в секундах",
  T_42_XXJ_WS_DURATION_D2: "Продолжительность в секундах",
  T_42_XXJ_WS_DURATION_D3: "Продолжительность",
  T_42_XXJ_WS_DURATION_D4: "Продолжительность неуязвимости в секундах",
  T_42_XXJ_WS_DURATIONTIMES: "Продолжительность времени",
  T_42_XXJ_WS_DURATIONTIMES_D: "Продолжительность в секундах",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Динамическое трение",
  T_42_XXJ_WS_EASY: "Очень Легкий",
  T_42_XXJ_WS_ENDTIMES: "Время окончания",
  T_42_XXJ_WS_ENDTIMES_D: "Время окончания на таймере в секундах",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Глобальный порог энергии",
  T_42_XXJ_WS_ENTITYVARNAME_D: "Самоотносительная сущность",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Взять обвес",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Преобразовать данные углы Эйлера в кватернионы.",
  T_42_XXJ_WS_EXPONENTIATION_D: "Возведение в степень",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Дополнительная вместимость рюкзака",
  T_42_XXJ_WS_FIST: "Кулак",
  T_42_XXJ_WS_FONTTYPE: "Перечисление шрифтов",
  T_42_XXJ_WS_FONTTYPE_D: "Перечисление шрифтов",
  T_42_XXJ_WS_FORCESYNCVALUE: "Принудительно синхронизировать статус GS",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "Значение принудительной синхронизации",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "Информация о местоположении. из синхронизации GS",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Информация о местоположении из принудительной синхронизации",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Сущность, которая может формулировать свойства",
  T_42_XXJ_WS_FORWARD_D: "Вектор направления",
  T_42_XXJ_WS_FRICTION_COMBINE: "Метод комбинации трения",
  T_42_XXJ_WS_FUNCPOINT: "Указатель функции",
  T_42_XXJ_WS_FUNCPOINT_D: "Указатель, указывающий на экземпляр функции. Он используется для реализации виртуальных функций или механизмов делегирования.",
  T_42_XXJ_WS_GETMAPID_D: "Получить ID Карты",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Выйти из транспорта",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Зайти в транспорт (водитель)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Зайти в транспорт (пассажир)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Поиск данных токена игрока на сегодняшний день",
  T_42_XXJ_WS_GRAVITY: "Глобальная гравитация",
  T_42_XXJ_WS_HANDHELDITEM: "Текущая переноска",
  T_42_XXJ_WS_HANDHELDITEM_D: "Текущая переноска",
  T_42_XXJ_WS_HARD: "Сложный",
  T_42_XXJ_WS_HASCOMPONENT_D: "Существует ли компонент",
  T_42_XXJ_WS_HEIGHTLIST_D: "Список приращений высоты",
  T_42_XXJ_WS_INDEXLIST_D: "Доступ к индексному списку строки",
  T_42_XXJ_WS_INSCENE: "В сцене",
  T_42_XXJ_WS_INSCENE_D: "В сцене",
  T_42_XXJ_WS_IS3D_D: "3D музыка или нет",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Обратный отсчет или секундомер",
  T_42_XXJ_WS_ISLOOP: "Цикл или нет",
  T_42_XXJ_WS_ISLOOP_D: "Команда IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "Начать с начала или нет",
  T_42_XXJ_WS_ISSWITCH_D: "Если установлено значение true, его можно комбинировать с относительным движением. Если установлено значение false, его можно комбинировать с абсолютным движением.",
  T_42_XXJ_WS_JEEP: "Джип",
  T_42_XXJ_WS_JUMPSTATUS: "Статус прыжка",
  T_42_XXJ_WS_LEFTVALUE: "Левое значение",
  T_42_XXJ_WS_LEFTVALUE_D: "База",
  T_42_XXJ_WS_LOGARITHM_D: "Логарифм",
  T_42_XXJ_WS_LOOPABLE: "Зацикливаемый",
  T_42_XXJ_WS_LOOPABLE_D: "Зацикливаемый",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Получить все ключи из словаря",
  T_42_XXJ_WS_MAPVALUE_D: "Целевой словарь",
  T_42_XXJ_WS_MARKBTNHUD: "Кнопка закрепления на HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "Максимальная дистанция",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "Переключатель микрофона на HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "Мин. дистанция",
  T_42_XXJ_WS_MISSIONID_D: "ID миссии",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Прогресс (не может быть отрицательным числом)",
  T_42_XXJ_WS_MODERATE: "Средний",
  T_42_XXJ_WS_MONSTERTRUCK: "Монстр Трак",
  T_42_XXJ_WS_MOTORBIKE: "Байк",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Статус передвижения",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Умножение двух кватернионов (представляющее суперпозицию вращения)",
  T_42_XXJ_WS_NORMAL: "Нормальный",
  T_42_XXJ_WS_OBSOLETE: "Выброшено",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Включить перспективу игрока",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Включить перспективу игрока",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Тип оружия",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Тип оружия",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Установите приоритет конфигурации игрока.",
  T_42_XXJ_WS_PARAMSARRAY: "Массив параметров",
  T_42_XXJ_WS_PARAMSARRAY_D: "Массив параметров — это список параметров, участвующих в выводе. Он должен соответствовать числу %v в описании формата.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "Список фактических параметров, передаваемых пользовательским функциям.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Маска видимости деталей 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Маска видимости деталей 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Маска видимости деталей 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Маска видимости деталей 4",
  T_42_XXJ_WS_PASSENGER1: "Пассажирское место 1",
  T_42_XXJ_WS_PASSENGER2: "Пассажирское место 2",
  T_42_XXJ_WS_PASSENGER3: "Пассажирское место 3",
  T_42_XXJ_WS_PHYMAT: "Физический материал",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Сущность",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Самоотносительное движение в каждом кадре",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Самоотносительное движение в каждом кадре",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Самостоятельное движение",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "Самостоятельное движение",
  T_42_XXJ_WS_PLAYER_D: "Игрок, которому необходимо сесть в транспортное средство",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Объект синхронизации свойств поведения игрока",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "Сущность синхронизации свойства поведения игрока",
  T_42_XXJ_WS_PRIORITY_D: "Приоритет",
  T_42_XXJ_WS_PROPID_D: "ID свойства",
  T_42_XXJ_WS_QUATERNION: "Кватернион",
  T_42_XXJ_WS_QUATERNION_D: "Кватернион — это специальный четырехмерный вектор, используемый только для представления вращения.",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Преобразовать данные кватернионы в представление угла оси.",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Преобразовать данные кватернионы в углы Эйлера. Если кватернионы не соответствуют стандарту, вернуть (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "Количество раз сыграно. По умолчанию — 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Сброс",
  T_42_XXJ_WS_RIGHTVALUE: "Правое значение",
  T_42_XXJ_WS_RIGHTVALUE_D: "Сила",
  T_42_XXJ_WS_SEATTYPE: "Перечисление сидений автомобиля",
  T_42_XXJ_WS_SEPSTR_D: "Строка, используемая для разделения",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Установить урон от падения игрока",
  T_42_XXJ_WS_SETTINGSBTNHUD: "Кнопка настроек на HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Показать местоположение",
  T_42_XXJ_WS_SHOWPOSITION_D: "Показать местоположение",
  T_42_XXJ_WS_SIGNALICOHUD: "Кнопка подключения к сети на HUD",
  T_42_XXJ_WS_SIMPLE: "Простой",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Интерполяция сферических кватернионов от A до B",
  T_42_XXJ_WS_SOUNDENTITY_D: "Сущность звукового эффекта представляет воспроизводимый звуковой эффект.",
  T_42_XXJ_WS_SPEAKERBTNHUD: "Кнопка звукового сигнала на HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Используйте определенную строку в качестве разделителя, чтобы разделить строку на фрагмент.",
  T_42_XXJ_WS_SPORTSCAR: "Спорткар",
  T_42_XXJ_WS_SPRINTSTATUS: "Статус бега",
  T_42_XXJ_WS_SRCVAL_D: "Исходное значение",
  T_42_XXJ_WS_STARTTICKCOUNT: "Момент, когда GS начинает тикать",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "Момент, когда GS начинает тикать",
  T_42_XXJ_WS_STARTTIME_D: "Время начала",
  T_42_XXJ_WS_STARTTIME_D1: "Время начала",
  T_42_XXJ_WS_STATE_D: "Статус игрока: активен, сбит с ног или устранен.",
  T_42_XXJ_WS_STATE_D1: "Проверить, воспроизводится ли этот звуковой эффект",
  T_42_XXJ_WS_STATIC_FRICTION: "Статическое трение",
  T_42_XXJ_WS_STRELEMS_D: "Набор целевых строк",
  T_42_XXJ_WS_STRINGFINDAT_D: "Вернуть окончательную объединенную строку в соответствии со списком индексов.",
  T_42_XXJ_WS_STRINGJOIN_D: "Объединение строк с использованием указанного идентификатора",
  T_42_XXJ_WS_STRINGLOWER_D: "Преобразовать все символы строки в нижний регистр",
  T_42_XXJ_WS_STRINGSTRIP_D: "Удалить пробелы с обеих сторон строки",
  T_42_XXJ_WS_STRINGUPPER_D: "Преобразовать все символы строки в верхний регистр",
  T_42_XXJ_WS_STYLE_D: "Как играть",
  T_42_XXJ_WS_SUV: "Пикап",
  T_42_XXJ_WS_SWITCH: "Переключение",
  T_42_XXJ_WS_SWITCH_D: "Если установлено значение true, его можно комбинировать с относительным движением. Если установлено значение false, оно должно сочетаться с абсолютным движением, иначе свойства не будут действовать правильно.",
  T_42_XXJ_WS_TARGETENTITY_D: "Целевая сущность",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Баннер с результатом командного раунда",
  T_42_XXJ_WS_TEAMSEQ_D: "Серийный номер команды, соответствующий свойству серийного номера сущности команды.",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Временные очки щита",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Временные очки щита",
  T_42_XXJ_WS_TEXT_D: "Исходный текст, к которому будет применен фильтр ненормативной лексики.",
  T_42_XXJ_WS_THREESTATESWITCH: "3-статусный переключатель",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Кинжал (лут на земле)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Кинжал",
  T_42_XXJ_WS_TUKTUK: "Тук Тук",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Подробности матча команд",
  T_42_XXJ_WS_UNIQUEID: "Уникальный идентификатор",
  T_42_XXJ_WS_UNIQUEID_D: "Уникальный идентификатор",
  T_42_XXJ_WS_VALUE_D: "Значение",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Вектор направления к углам Эйлера",
  T_42_XXJ_WS_VEHICLEID: "ID транспорта",
  T_42_XXJ_WS_VEHICLESKINID: "ID скина транспорта",
  T_42_XXJ_WS_VERYHARD: "Очень тяжелый",
  T_42_XXJ_WS_VOLUME_D: "Громкость звука. По умолчанию 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Основной тип оружия",
  T_42_XXJ_WS_WORKSHOPCODE: "Код карты",
  T_42_XXJ_WS_WORKSHOPCODE_D: "Код карты, соответствующий данным в базе данных.",
  T_42_XXJ_WS_WORLDPOSITION: "Мировые координаты",
  T_42_XXJ_WS_WORLDPOSITION_D: "Мировые координаты",
  T_42_XYL_WS_ITEM275: "Топливный бак",
  T_42_XYL_WS_ITEM276: "Мешок с песком A",
  T_42_XYL_WS_ITEM277: "Мешок с песком B",
  T_42_XYL_WS_ITEM278: "Мешок с песком C",
  T_42_XYL_WS_ITEM279: "Мешок с песком",
  T_42_XYL_WS_ITEM280: "Двухэтажная вилла",
  T_42_XYL_WS_ITEM281: "Оружейный завод",
  T_42_XYL_WS_ITEM282: "Каменная стена A",
  T_42_XYL_WS_ITEM283: "Каменная стена B",
  T_42_XYL_WS_ITEM284: "Каменная стена C",
  T_42_XYL_WS_ITEM285: "Каменная стена D",
  T_42_XYL_WS_ITEM286: "Боевой Ящик с Припасами A",
  T_42_XYL_WS_ITEM287: "Медная Монета",
  T_42_XYL_WS_ITEM288: "Серебряная Монета",
  T_42_XYL_WS_ITEM289: "Золотая Монета",
  T_42_XYL_WS_ITEM290: "Алмаз",
  T_42_XYL_WS_ITEM291: "Осколки Алмаза",
  T_42_XYL_WS_ITEM292: "Рубин",
  T_42_XYL_WS_ITEM293: "Изумруд",
  T_42_XYL_WS_ITEM294: "Сапфир",
  T_42_XYL_WS_ITEM295: "Предупреждающий знак",
  T_42_XYL_WS_ITEM297: "Руины",
  T_42_XYL_WS_ITEM297TRUE: "Устройство управления",
  T_42_XYL_WS_ITEM298: "Контейнер Снабжения B",
  T_42_XYL_WS_ITEM299: "Снежная куча",
  T_42_XYL_WS_ITEM300: "Хай-тек стена A",
  T_42_XYL_WS_ITEM301: "Хай-тек стена B",
  T_42_XYL_WS_ITEM302: "Ледяная камень F",
  T_42_XYL_WS_ITEM303: "Ледяная камень E",
  T_42_XYL_WS_ITEM304: "Хай-тек платформа A",
  T_42_XYL_WS_ITEM305: "Хай-тек лестница A",
  T_42_XYL_WS_ITEM306: "Исследовательская лампа A",
  T_42_XYL_WS_ITEM307: "Преграда из Руин A",
  T_42_XYL_WS_ITEM308: "Преграда из Руин B",
  T_42_XYL_WS_ITEM309: "Стальной кронштейн Руин A",
  T_42_XYL_WS_ITEM310: "Камень Руин A",
  T_42_XYL_WS_ITEM311: "Камень Руин B",
  T_42_XYL_WS_ITEM312: "Камень Руин C",
  T_42_XYL_WS_ITEM313: "Прожектор A",
  T_42_XYL_WS_ITEM314: "Арматура Руин A",
  T_42_XYL_WS_LOGICALOBJECT: "Логика",
  T_42_XYL_WS_THEMEHIGHTECH: "Хай-тек",
  T_42_XYL_WS_THEMEICE: "Ледяной",
  T_42_XYL_WS_THEMEMILITARY: "Боевой",
  T_42_XYL_WS_THEMEOBJECTS: "Тем. объект",
  T_42_XYL_WS_TIMERCONTINUE: "Таймер возобновления инцидента",
  T_42_XYL_WS_TIMERCYCLE: "Счет циклов",
  T_42_XYL_WS_TIMERDOWN: "Обратный Отсчёт",
  T_42_XYL_WS_TIMEREND: "Таймер завершения инцидента",
  T_42_XYL_WS_TIMEREVENT: "Инцидент с настроенным таймером",
  T_42_XYL_WS_TIMEREVENT1: "Управление таймером",
  T_42_XYL_WS_TIMEREVENT2: "Установить инциденты с таймером",
  T_42_XYL_WS_TIMERORDER: "Метод синхронизации",
  T_42_XYL_WS_TIMERPAUSE: "Таймер приостановки инцидента",
  T_42_XYL_WS_TIMERSTART1: "Начало таймера",
  T_42_XYL_WS_TIMERSTART2: "Таймер начала инцидента",
  T_42_XYL_WS_TIMERUP: "Посчитать",
  T_42_XYL_WS_TRIGGERTIME_MS: "Время срабатывания (в миллисекундах)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Скайджет, способный вместить несколько игроков.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Личный Счёт",
  T_42_ZZ_GUILDWAR_SCORE: "Счёт",
  T_43_B_SKILL_DESC_MONKEYGOD: "Превращается в куст, эффект длится [FFB300]{1}с[-]. Время восстановления: [FFB300]{0}с[-]. Трансформация заканчивается, когда Вуконг атакует. Время восст. сбрасывается, когда Вуконг уничтожает врага.",
  T_43_B_SKILL_DESC_Nanoscientist: "После получения смертельного урона переходите в неуязвимое и неподвижное состояние на [FFB300]{0} с[-]. Затем получите [FFB300]{1} щит HP[-] на [FFB300]{2} с[-]. Пользователь навыка будет устранен, когда щит исчезнет. Время восстановления: [FFB300]{3} с[-]",
  T_43_B_SKILL_DESC_ORION: "Заменяет Энергию на [FFB300]{0} Алую энергию[-]. Потребляет [FFB300]{1} Алой энергии[-] для активации защиты, во время которой вы не можете получать урон или атаковать врагов и поглощаете [FFB300]{4} ХП[-] (игнорируя очки щита противника) от противников в пределах [FFB300]{3}м[-]. Длится [FFB300]{2}с[-], в течение которого ваша скорость передвижения снизится на [FFB300]{6}%[-]. Время восстановления: [FFB300]{5} с[-]",
  T_43_CJ_F_A_RACER: "Скоростной Гонщик (Маска)",
  T_43_CJ_F_B_RACER: "Скоростной Гонщик (Низ)",
  T_43_CJ_F_H_RACER: "Скоростной Гонщик (Голова)",
  T_43_CJ_F_HA_RACER: "Скоростной Гонщик (Грим)",
  T_43_CJ_F_S_RACER: "Скоростной Гонщик (Обувь)",
  T_43_CJ_F_T_RACER: "Скоростной Гонщик (Верх)",
  T_43_CJ_M_A_RACER: "Турбо-Гонщик (Маска)",
  T_43_CJ_M_B_MACHINERY: "Бирюзовый Техно (Низ)",
  T_43_CJ_M_B_RACER: "Турбо-Гонщик (Низ)",
  T_43_CJ_M_H_MACHINERY: "Бирюзовый Техно (Голова)",
  T_43_CJ_M_H_RACER: "Турбо-Гонщик (Голова)",
  T_43_CJ_M_HA_MACHINERY: "Бирюзовый Техно (Грим)",
  T_43_CJ_M_S_MACHINERY: "Бирюзовый Техно (Обувь)",
  T_43_CJ_M_S_RACER: "Турбо-Гонщик (Обувь)",
  T_43_CJ_M_T_MACHINERY: "Бирюзовый Техно (Верх)",
  T_43_CJ_M_T_RACER: "Турбо-Гонщик (Верх)",
  T_43_H_CHARACTER_GEEK_N: "Райден",
  T_43_H_VSK94_MAMBAS_N: "VSK94 Укус Мамбы",
  T_43_HJ_WS_OPTION8: "Другое",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Бамбук",
  T_43_HJ_WS_TEXTURE_BEACH: "Пляж",
  T_43_HJ_WS_TEXTURE_BRICK1: "Кирпичная Стена A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Кирпичная Стена B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Кирпичная Стена C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Бетонный пол",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Бетон",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Кристалл",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Трава A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Трава B",
  T_43_HJ_WS_TEXTURE_ICE: "Ледяная глыба",
  T_43_HJ_WS_TEXTURE_IRON: "Металлический пол",
  T_43_HJ_WS_TEXTURE_IRON2: "Контейнер",
  T_43_HJ_WS_TEXTURE_LAVA: "Лава",
  T_43_HJ_WS_TEXTURE_MARBLE: "Мраморный пол",
  T_43_HJ_WS_TEXTURE_NONE: "Пусто",
  T_43_HJ_WS_TEXTURE_STONE: "Камень",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Скатерть A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Скатерть B",
  T_43_HJ_WS_TEXTURE_WOOD: "Дерево",
  T_43_HJ_WS_TEXTURE_WOODEN: "Деревянный Пол A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Деревянный Пол B",
  T_43_JH_WS_MAPTAG1: "Подходит для новичков",
  T_43_JH_WS_MAPTAG10: "Скучный новый контент",
  T_43_JH_WS_MAPTAG11: "Малые вознаграждения",
  T_43_JH_WS_MAPTAG12: "Дисбаланс вознаграждений",
  T_43_JH_WS_MAPTAG13: "Слабое ощущение прогресса",
  T_43_JH_WS_MAPTAG14: "Недружелюбный к новичкам",
  T_43_JH_WS_MAPTAG15: "Запутанное руководство",
  T_43_JH_WS_MAPTAG16: "Недостаточно обучения",
  T_43_JH_WS_MAPTAG17: "Игроки часто выходят",
  T_43_JH_WS_MAPTAG18: "Сложное управление",
  T_43_JH_WS_MAPTAG19: "Загроможденный интерфейс",
  T_43_JH_WS_MAPTAG2: "Избранный новый контент",
  T_43_JH_WS_MAPTAG20: "Плохой дизайн карты",
  T_43_JH_WS_MAPTAG21: "Супер шутер",
  T_43_JH_WS_MAPTAG22: "Быстрые матчи",
  T_43_JH_WS_MAPTAG23: "Открытый мир",
  T_43_JH_WS_MAPTAG24: "Богатый сюжет",
  T_43_JH_WS_MAPTAG25: "Прогрессия",
  T_43_JH_WS_MAPTAG26: "Спорт. симуляция",
  T_43_JH_WS_MAPTAG27: "Совместная миссия",
  T_43_JH_WS_MAPTAG28: "Социальная",
  T_43_JH_WS_MAPTAG29: "Разные эффекты",
  T_43_JH_WS_MAPTAG3: "Активные игроки",
  T_43_JH_WS_MAPTAG30: "Исследование",
  T_43_JH_WS_MAPTAG31: "Челлендж Рейтинга",
  T_43_JH_WS_MAPTAG32: "Достижение",
  T_43_JH_WS_MAPTAG33: "Выкуп валюты",
  T_43_JH_WS_MAPTAG4: "Хорошо продуманная карта",
  T_43_JH_WS_MAPTAG40: "Многочисленные награды",
  T_43_JH_WS_MAPTAG41: "Удовлетворяющий прогресс",
  T_43_JH_WS_MAPTAG42: "Популярные Полигоны",
  T_43_JH_WS_MAPTAG43: "Популярная Соло Башня",
  T_43_JH_WS_MAPTAG44: "Полулярное Поле Сражений",
  T_43_JH_WS_MAPTAG5: "Заикание",
  T_43_JH_WS_MAPTAG6: "Сложный кооператив",
  T_43_JH_WS_MAPTAG7: "Багги",
  T_43_JH_WS_MAPTAG8: "Мало обновлений",
  T_43_JH_WS_MAPTAG9: "Скучные внутриматчевые события",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Ядовитая Ловушка (Райден)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Выпадение предметов",
  T_43_SJ_WS_AIRDROP_NAME: "Авиапосылка",
  T_43_SJ_WS_AIRDROP_TIME: "Старт выпадения предметов",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Выпадение предметов",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Автовоспроизведение",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Центральная позиция",
  T_43_SJ_WS_ANITRIGGER_CLIP: "ID анимационного клипа",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Цикл",
  T_43_SJ_WS_ANITRIGGER_NAME: "Компонент HUD анимационного триггера",
  T_43_SJ_WS_RESET_ROUND: "Сброс за раунд",
  T_43_SJ_WS_START_DROPTIME: "Начало времени выпадения (мс)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Триггер анимации",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Скин Питомца: Неко-мими Аксель",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Байк - Воплощающая скорость",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Содержит необходимые припасы, такие как боеприпасы и медицинские предметы",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Ящик с Припасами",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Создай манекен [FFB300]{1} ХП[-], который движется автономно в течение [FFB300]{0} с[-]. Когда манекен окажется в пределах [FFB300]{3}м[-], используйте навык еще раз, чтобы поменяться с ним позициями. Вы можете переключиться только один раз в течение [FFB300]{4}с[-], всего до [FFB300]{2} раз[-]. Игрок, уничтоживший манекен, будет отмечен на [FFB300]{5} с[-]. Время восстановления: [FFB300]{6} с[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Активный Навык",
  T_43_XXJ_WS_AIRDROP: "Авиапосылка и Зомби",
  T_43_XXJ_WS_ALPHA: "Альфа",
  T_43_XXJ_WS_ALPHA_D: "Общая прозрачность HUD в диапазоне от 0 до 1",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Идентификатор контроллера анимации",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "Идентификатор, используемый для описания актива контроллера анимации",
  T_43_XXJ_WS_AUDIOID: "ID аудио",
  T_43_XXJ_WS_AUDIOID_D: "Идентификатор, используемый для описания аудио ассета",
  T_43_XXJ_WS_BACKGRCOLOR: "Фоновый цвет",
  T_43_XXJ_WS_BACKGRCOLOR_D: "Цвет границы полоски здоровья и размытый фон",
  T_43_XXJ_WS_BURNING: "Горение",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "Идентификатор, используемый для описания ассета таблицы конфигурации",
  T_43_XXJ_WS_CURRENTHP: "Текущее ХП",
  T_43_XXJ_WS_CURRENTHP_D: "Текущее значение ХП",
  T_43_XXJ_WS_DAMAGEMAKER_D: "Игровая сущность, наносящая урон",
  T_43_XXJ_WS_DAMAGEZONE: "Уроны Зоны",
  T_43_XXJ_WS_DEFAULT: "По умолчанию",
  T_43_XXJ_WS_DEFAULT_D: "По умолчанию",
  T_43_XXJ_WS_EFFECTID: "ID эффекта",
  T_43_XXJ_WS_EFFECTID_D: "Идентификатор, используемый для описания объекта спецэффекта",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Сущность, которая может сражаться (например, атаковать, подвергаться нападению или быть уничтоженной)",
  T_43_XXJ_WS_FOLLOWTARGET: "Следовать за целью",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Должен следовать за объектом с компонентом Transform",
  T_43_XXJ_WS_GAINHPCOLOR: "Получить цвет ХП",
  T_43_XXJ_WS_GAINHPCOLOR_D: "Увеличенная часть ХП на короткое время будет отображаться этим цветом",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Нет урона",
  T_43_XXJ_WS_ISOPENTWEEN: "Открыть Твин",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Включите это, чтобы отображать изменения ХП разными цветами",
  T_43_XXJ_WS_KNOCKDOWN_D1: "Игрок находится в нокауте",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Настройки реакции на состояние нокаута при устранении",
  T_43_XXJ_WS_KNOCKDOWN_D3: "Тип источника возрождения. Игрока можно возродить в нокауте",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Состояние нокаута",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Тип состояния нокаута",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "Реакция на состояние нокдауна нокаута: сохранить логику по умолчанию, пропустить состояние нокаута или принудительно перевести в нокаут",
  T_43_XXJ_WS_LEVEL: "Уровень",
  T_43_XXJ_WS_LEVEL_D: "Уровень",
  T_43_XXJ_WS_LEVEL_D1: "Текущий уровень зомби",
  T_43_XXJ_WS_LINESPACING: "Межстрочный интервал",
  T_43_XXJ_WS_LINESPACING_D: "Не отображается, если сегментированный ХП между двумя разделителями ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Цвет потери ХП",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "Уменьшенная часть ХП на короткое время будет отображаться этим цветом",
  T_43_XXJ_WS_MAINCOLOR: "Основной цвет",
  T_43_XXJ_WS_MAINCOLOR_D: "Цвет ХП, уровней и контуров",
  T_43_XXJ_WS_MINISENTRY: "Турель",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "Перечисление типов целей, которые может атаковать турель",
  T_43_XXJ_WS_MISSILEEXPLODE: "Ракетный взрыв",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Обязательный нокаут",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Принудительный нокаут",
  T_43_XXJ_WS_OFFSET: "Смещение",
  T_43_XXJ_WS_OFFSET_D: "Смещение относительно цели, за которой следует",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Взрыв нефтяной бочки",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Срабатывает только тогда, когда контроллер инициирует движение",
  T_43_XXJ_WS_PLAYER_D: "Сущность внутриигрового игрока. У каждого игрока есть один",
  T_43_XXJ_WS_PLAYERHEADHUD: "Интерфейс HUD игрока",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "Информация, отображаемая над головой игрока",
  T_43_XXJ_WS_PLAYERNAME: "Имя игрока",
  T_43_XXJ_WS_PLAYERNAME_D: "Отображает имя текущего владельца полосы здоровья",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Игрок или Транспорт",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "Псевдоним для типа объекта игрока/транспортного средства",
  T_43_XXJ_WS_SCALE: "Масштаб",
  T_43_XXJ_WS_SCALE_D: "Определяет общий размер шкалы HUD с соответствующим масштабированием шрифта",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Показать кол-во урона",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "Правда по умолчанию. Отображает количество повреждений",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Пропустить нокаут",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Пропустить состояние нокаута и получить мгновенное устранение",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Пропустить анимацию шатания",
  T_43_XXJ_WS_TEAM_D: "(Устарело. Используйте идентификатор группы.)",
  T_43_XXJ_WS_TERRAIN: "Местность",
  T_43_XXJ_WS_TERRAIN_D: "Компонент ландшафта, атрибуты которого нельзя изменить. Используется только для проверки функций",
  T_43_XXJ_WS_TOTALHP: "Всего ХП",
  T_43_XXJ_WS_TOTALHP_D: "Общее значение ХП",
  T_43_XXJ_WS_TWEENENTITY: "Сущность Твин",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Взрыв Транспорта",
  T_43_XXJ_WS_WIDTH: "Ширина",
  T_43_XXJ_WS_WIDTH_D: "Ширина отображаемой полоски здоровья",
  T_43_XXJ_WS_ZOMBIE: "Зомби",
  T_43_XYL_WS_DROIDFIST: "Кулак Робогеддон",
  T_43_XYL_WS_DROIDFLAME: "Огнемёт Робогеддон",
  T_43_XYL_WS_JAPANESE: "Японский стиль",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Настроить журналы событий матчей. Используется для анализа пользовательского опыта",
  T_43_YU_WS_AIRDROPSTATE: "Состояние авиапосылки",
  T_43_YU_WS_AIRDROPSTATE_D: "Состояние авиапосылки (1: готово, 2: падение, 3: приземление)",
  T_43_YU_WS_ANIMATIONCLIPID: "ID анимационного клипа",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Настроить идентификатор анимационного клипа",
  T_43_YU_WS_ASKBUYTARGET: "Вопрос о покупке цели",
  T_43_YU_WS_ASKBUYTARGET_D: "Указывает цель и отправляет запрос на покупку",
  T_43_YU_WS_ASKEDLIST: "Список вопросов",
  T_43_YU_WS_ASKEDLIST_D: "Список запрошенных предметов",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Цвет фона 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "Верхний цвет фона",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Цвет фона 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "Нижний цвет фона",
  T_43_YU_WS_BATCHCOMBINERENDER: "Пакетный комбинированный рендеринг",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Список сущностей Привязка Денег",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "Перечень связанных валютных сущностей",
  T_43_YU_WS_BINDWALLETENTITYID: "Привязать ID сущности кошелька",
  T_43_YU_WS_BINDWALLETENTITYID_D: "Идентификатор привязанного объекта кошелька",
  T_43_YU_WS_CENTEROFFSET: "Центральное смещение",
  T_43_YU_WS_CENTEROFFSET_D: "Значение смещения для капсульного коллайдера",
  T_43_YU_WS_COLLECTIONID: "ID коллекции",
  T_43_YU_WS_COLLECTIONID_D: "ID коллекции, используемый для сбора информации об ассетах",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Создать авиапосылку",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Создать кол-во урона",
  T_43_YU_WS_CROSSPLATFORM_D: "Если этот параметр выбран, отправлять клиенту, если он вызывается на сервере, и наоборот",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Результаты отображаются в конце каждого раунда",
  T_43_YU_WS_CURRENTEMOTECLIP: "Текущий клип эмоций",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID текущего клипа эмоций",
  T_43_YU_WS_DAMAGE_D: "Урон вне зоны",
  T_43_YU_WS_DICTIONARY: "Словарь",
  T_43_YU_WS_DIRECTIONRULERHUD: "HUD линейки направления",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "Компас наверху",
  T_43_YU_WS_DOTWEEN_D: "Выполнять ли анимацию Твин",
  T_43_YU_WS_DROPITEMS_D: "Предметы в авиапосылке",
  T_43_YU_WS_DURATION: "Продолжительность",
  T_43_YU_WS_ENERGY: "Энергия",
  T_43_YU_WS_ENERGY_D: "Значение модификации Энергии",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Склонный",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Красться",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Бег",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Встать",
  T_43_YU_WS_EVENTID: "ID события",
  T_43_YU_WS_EVENTID_D: "Представляет событие",
  T_43_YU_WS_FACTION: "Фракция",
  T_43_YU_WS_FACTION_D: "Сущность фракции",
  T_43_YU_WS_FACTION_D1: "Попросить фракцию помочь с покупкой",
  T_43_YU_WS_FINALRADIUS_D: "Конечный радиус безопасной зоны",
  T_43_YU_WS_FIRSTAIDKIT: "Аптечка",
  T_43_YU_WS_FIRSTAIDKIT_D: "Аптечка",
  T_43_YU_WS_FIRSTPERSONMODEL: "Модель от первого лица",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "Камера от первого лица",
  T_43_YU_WS_FONTCOLOR_D: "Цвет шрифта",
  T_43_YU_WS_FONTSIZE_D: "Размер шрифта",
  T_43_YU_WS_FORBIDEN: "Запрещено",
  T_43_YU_WS_FORBIDEN_D: "Отключить HUD для запроса на покупку",
  T_43_YU_WS_FREEZINGTIME: "Время заморозки",
  T_43_YU_WS_FREEZINGTIME_D: "Продолжительность, в течение которой пораженная цель остается замороженной",
  T_43_YU_WS_GRAVITY: "Гравитация",
  T_43_YU_WS_GRAVITY_D: "Гравитационное ускорение. Влияет только на контроллер игрока",
  T_43_YU_WS_HANDCATAPULT: "Пусковая Площадка",
  T_43_YU_WS_HANDCATAPULT_D: "Пусковая Площадка",
  T_43_YU_WS_HEALTH: "Здоровье",
  T_43_YU_WS_HEALTH_D: "Значение восстановления прочности брони",
  T_43_YU_WS_HEIGHT: "Высота",
  T_43_YU_WS_HELPEDPLAYER_D: "Игрок, которому помогают",
  T_43_YU_WS_HELPPLAYER_D: "Игрок, который помогает с покупкой",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Горизонтальный Макс. Угол",
  T_43_YU_WS_HORIZONTALMINANGLE: "Горизонтальный мин. угол",
  T_43_YU_WS_HUDTOGGLE: "Переключить HUD",
  T_43_YU_WS_HUDTOGGLE_D: "Сущность HudToggle, который игроки могут редактировать в редакторе HUD",
  T_43_YU_WS_INHALER: "Противогаз",
  T_43_YU_WS_INHALER_D: "Противогаз",
  T_43_YU_WS_INITRADIUS_D: "Начальный радиус безопасной зоны",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "64-битное целое число со знаком",
  T_43_YU_WS_ISAPPLYSHADOW: "Применить тень",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Столкновение низа",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Текущий цикл эмоции",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Зацикливать текущую анимацию эмоций или нет",
  T_43_YU_WS_ISSIDECOLLIDING: "Боковое столкновение",
  T_43_YU_WS_ISSLIDING: "Скольжение",
  T_43_YU_WS_ISTOPCOLLIDING: "Столкновение сверху",
  T_43_YU_WS_ITEM331: "Хай-тек Устройство A",
  T_43_YU_WS_ITEM332: "Светящийся Камень A",
  T_43_YU_WS_ITEM333: "Хай-тек Экран A",
  T_43_YU_WS_ITEM334: "Хай-тек Контейнер A",
  T_43_YU_WS_ITEM335: "Хай-тек Контейнер A",
  T_43_YU_WS_ITEM336: "Каменный Диван A",
  T_43_YU_WS_ITEM337: "Хай-тек  Переключатель A",
  T_43_YU_WS_ITEM338: "Хай-тек Труба A",
  T_43_YU_WS_ITEM339: "Металлическая Платформа A",
  T_43_YU_WS_ITEM340: "Хай-тек Таблица A",
  T_43_YU_WS_ITEM341: "Хай-тек Таблица B",
  T_43_YU_WS_ITEM342: "Хай-тек Таблица С",
  T_43_YU_WS_ITEM343: "Хай-тек Компьютер A",
  T_43_YU_WS_ITEM344: "Камень A",
  T_43_YU_WS_ITEM345: "Камень B",
  T_43_YU_WS_ITEM346: "Камень C",
  T_43_YU_WS_ITEM347: "Камень D",
  T_43_YU_WS_ITEM348: "Камень E",
  T_43_YU_WS_ITEM349: "Камень F",
  T_43_YU_WS_ITEM350: "Камень G",
  T_43_YU_WS_ITEM351: "Занавеска в японском стиле A",
  T_43_YU_WS_ITEM352: "Занавеска в японском стиле B",
  T_43_YU_WS_ITEM353: "Занавеска в японском стиле C",
  T_43_YU_WS_ITEM354: "Лестница в японском стиле A",
  T_43_YU_WS_ITEM355: "Забор в японском стиле A",
  T_43_YU_WS_ITEM356: "Забор в японском стиле B",
  T_43_YU_WS_ITEM357: "Забор в японском стиле C",
  T_43_YU_WS_ITEM358: "Платформа в японском стиле A",
  T_43_YU_WS_ITEM359: "Стена в японском стиле B",
  T_43_YU_WS_ITEM360: "Ворота в японском стиле B",
  T_43_YU_WS_ITEM361: "Хай-тек Стена D",
  T_43_YU_WS_ITEM362: "Хай-тек Стена B",
  T_43_YU_WS_ITEM363: "Хай-тек Угловой Плинтус",
  T_43_YU_WS_LEFTCOLOR: "Цвет слева",
  T_43_YU_WS_LEFTCOLOR_D: "Цвет левой стороны",
  T_43_YU_WS_LEFTPLAYERARRAY: "Левый массив игроков",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "Левый массив игроков",
  T_43_YU_WS_LEFTSCORE: "Счет слева",
  T_43_YU_WS_LEFTSCORE_D: "Счет на левой стороне",
  T_43_YU_WS_LEFTSCOREAFTER: "После счета слева",
  T_43_YU_WS_LEFTSCOREAFTER_D: "Итоговый счет левой стороны. Используется в анимации перехода партитур",
  T_43_YU_WS_LEVELOBJECTID: "ID объекта уровня",
  T_43_YU_WS_LEVELOBJECTID_D: "Описывает тип объекта. Перед загрузкой требуется анализ таблицы конфигурации SceneEditPrefab",
  T_43_YU_WS_LOCALPOSITION_D: "Координаты в местной системе координат",
  T_43_YU_WS_LOCALPOSITION_D1: "Относительное положение",
  T_43_YU_WS_LOCALPOSITION_D2: "Положение относительно правого нижнего якоря",
  T_43_YU_WS_LOCALPOSITION_D3: "Положение относительно якоря",
  T_43_YU_WS_LOCALROTATION_D: "Углы поворота в местной системе координат (X: отклонение, Y: тангаж и Z: крен)",
  T_43_YU_WS_LOCALROTATIONQ_D: "Кватернион в локальной системе координат",
  T_43_YU_WS_LOCALSCALE_D: "Размер масштаба в мировой системе координат",
  T_43_YU_WS_MASS: "Масса",
  T_43_YU_WS_MATERIALS: "Материалы",
  T_43_YU_WS_MATERIALS_D: "Список материалов, использованных для рендеринга",
  T_43_YU_WS_MAXSPEED: "Макс. скорость",
  T_43_YU_WS_MAXSPEED_D: "После достижения максимальной скорости мощность больше не будет генерироваться, но скорость автомобиля может превысить предел (например, из-за ускорения при спуске с холма)",
  T_43_YU_WS_MESHID: "ID сетки",
  T_43_YU_WS_MESHID_D: "Описывает тип сетки",
  T_43_YU_WS_MESHID1: "ID сетки",
  T_43_YU_WS_MESHID1_D: "Сетка, которая будет использоваться для рендеринга",
  T_43_YU_WS_MINMOVEDISTANCE: "Мин. расстояние перемещения",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Движение на расстояние меньше этого значения не будет выполнено. Рекомендуется установить значение 0, если нет особых требований",
  T_43_YU_WS_MODULE_AI: "ИИ",
  T_43_YU_WS_MODULE_AIRDROP: "Авиапосылка",
  T_43_YU_WS_MODULE_ANIMATION: "Анимация",
  T_43_YU_WS_MODULE_AVATAR: "Аватар",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Базовые атрибуты",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Дерево поведения",
  T_43_YU_WS_MODULE_BUFF: "Усиление",
  T_43_YU_WS_MODULE_CAMERA: "Камера",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Канал чата",
  T_43_YU_WS_MODULE_CHECKPOINT: "Контрольная точка",
  T_43_YU_WS_MODULE_COLLECTION: "Коллекция",
  T_43_YU_WS_MODULE_COMBAT: "Сражение",
  T_43_YU_WS_MODULE_COMPONENT: "Компонент",
  T_43_YU_WS_MODULE_CONVERT: "Конвертировать",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Настроить параметры комнаты",
  T_43_YU_WS_MODULE_DATABASE: "Хранилище данных",
  T_43_YU_WS_MODULE_DYEING: "Крашение",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Динамическая NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Экономика",
  T_43_YU_WS_MODULE_FF_PLATFORM: "Платформа FF",
  T_43_YU_WS_MODULE_FOOTBALL: "Футбол",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Режим частоты кадров",
  T_43_YU_WS_MODULE_GAMERESULT: "Очки и расчеты",
  T_43_YU_WS_MODULE_GLOBAL: "Глобальный",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Глобальные скрипты",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Читы",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Система ввода",
  T_43_YU_WS_MODULE_ITEMS: "Предметы",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Объект уровня",
  T_43_YU_WS_MODULE_LIST: "Список",
  T_43_YU_WS_MODULE_MAP: "Карта",
  T_43_YU_WS_MODULE_MATCHING: "Матч",
  T_43_YU_WS_MODULE_MATH: "Математика",
  T_43_YU_WS_MODULE_MECHANISM: "Параметры механизма",
  T_43_YU_WS_MODULE_MINIMAP: "Миникарта",
  T_43_YU_WS_MODULE_MORPH: "Маскировка игрока",
  T_43_YU_WS_MODULE_OTHER: "Другое",
  T_43_YU_WS_MODULE_PET: "Питомец",
  T_43_YU_WS_MODULE_PHYSICS: "Физика",
  T_43_YU_WS_MODULE_PLAYABLE: "Играбельно",
  T_43_YU_WS_MODULE_PLAYER: "Игрок",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Скрипты игрока",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Предустановленный Персонаж",
  T_43_YU_WS_MODULE_PROFILE: "Профиль",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Формула свойства",
  T_43_YU_WS_MODULE_SAFEZONE: "Безопасная Зона",
  T_43_YU_WS_MODULE_SCENE: "Сцена",
  T_43_YU_WS_MODULE_SKILL: "Навык",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Статические скрипты",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Жалоба",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Библиотека",
  T_43_YU_WS_MODULE_STRINGS: "Строки",
  T_43_YU_WS_MODULE_TEAM: "Команда",
  T_43_YU_WS_MODULE_WORKFLOW: "Рабочий процесс",
  T_43_YU_WS_MONEYICON: "Иконка денег",
  T_43_YU_WS_MONEYICON_D: "Иконка валюты",
  T_43_YU_WS_MONEYICONCOLOR: "Цвет иконки денег",
  T_43_YU_WS_MONEYICONCOLOR_D: "Цвет иконки валюты",
  T_43_YU_WS_MOVESAFEZONE_D: "Плавно перемещает безопасную зону из исходного положения в конечное. Игроки за пределами зоны получат определенное количество урона",
  T_43_YU_WS_NEWVECTOR2: "Новый Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Получить новый 2D вектор",
  T_43_YU_WS_OFFSET_D: "Смещение мировой позиции относительно целевого объекта",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Когда запрос на покупку игрока удовлетворен",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Когда игрок обращается за помощью с покупкой в магазине",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Срабатывает при изменении состояния компонента Toggle",
  T_43_YU_WS_OPENSTATE: "Открыть состоянеие",
  T_43_YU_WS_OPENSTATE_D: "Отображается, если установлено значение true, и скрывается, если нет",
  T_43_YU_WS_PACEMAKER: "Горизалин",
  T_43_YU_WS_PACEMAKER_D: "Горизалин",
  T_43_YU_WS_PARAMS_D: "Список параметров",
  T_43_YU_WS_PARENT_D: "ID сущности, записанный во время сериализации",
  T_43_YU_WS_PHYSICALCCT: "Физ. CCT",
  T_43_YU_WS_PHYSICALCCT_D: "Контроллер игрока с физическими эффектами",
  T_43_YU_WS_PLAYER_D: "Покупающий игрок",
  T_43_YU_WS_PLAYERDATAID: "ID данных игрока",
  T_43_YU_WS_PLAYERDATAID_D: "Настроить ID ассета персонажа",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Тип PhysX движения игрока",
  T_43_YU_WS_POSITION: "Позиция",
  T_43_YU_WS_POSITION_D: "Координаты в мировой системе координат",
  T_43_YU_WS_POSITION_D1: "Координаты в мировой системе координат. Эффективен только для 3D-музыки",
  T_43_YU_WS_PRESSEDSPRITE: "Нажатый спрайт",
  T_43_YU_WS_PRESSEDSPRITE_D: "Нажатый спрайт",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Тип нажатого спрайта",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "Тип нажатого спрайта",
  T_43_YU_WS_PRETIME: "Предварительное время",
  T_43_YU_WS_RADIUS: "Радиус",
  T_43_YU_WS_RANDOMRANGE_D: "Корректировать заданное положение на основе случайного диапазона",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Запросить тип покупки",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Запрос на покупку в магазине",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "Тип цели, запрошенный текущим игроком HUD",
  T_43_YU_WS_RESPLAYERUUID: "Тип Пресета Игрока",
  T_43_YU_WS_RESPLAYERUUID_D: "ID ассета игрока",
  T_43_YU_WS_RESUUID: "UUID ассета",
  T_43_YU_WS_RESUUID_D: "Указывает UUID пакетного ресурса, который необходимо отобразить",
  T_43_YU_WS_RIGHTCOLOR: "Правый цвет",
  T_43_YU_WS_RIGHTCOLOR_D: "Цвет правой стороны",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Правый массив игроков",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "Правый массив игроков",
  T_43_YU_WS_RIGHTSCORE: "Правый счет",
  T_43_YU_WS_RIGHTSCORE_D: "Счет правой стороны",
  T_43_YU_WS_RIGHTSCOREAFTER: "После правого счета",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "Итоговый счет правой стороны. Используется в анимации перехода партитур",
  T_43_YU_WS_ROTATIONQ_D: "Кватернион в мировой системе координат",
  T_43_YU_WS_ROUNDINFOHUD: "Информация о раунде HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Информация, отображаемая в начале раунда",
  T_43_YU_WS_SELECTEDCOLOR: "Выбранный цвет",
  T_43_YU_WS_SELECTEDCOLOR_D: "Выбранный цвет спрайта",
  T_43_YU_WS_SELECTEDSPRITE: "Выбранный спрайт",
  T_43_YU_WS_SELECTEDSPRITE_D: "Выбранный спрайт",
  T_43_YU_WS_SELECTEDTYPE: "Выбранный тип",
  T_43_YU_WS_SELECTEDTYPE_D: "Выбранный тип спрайта",
  T_43_YU_WS_SHADOWCOLOR: "Цвет тени",
  T_43_YU_WS_SHADOWOFFSET: "Смещение тени",
  T_43_YU_WS_SHOWTAG: "Показать тег",
  T_43_YU_WS_SHOWTAG_D: "Показать маркировку команды/фракции",
  T_43_YU_WS_SHRINKDURATION_D: "Продолжительность сужения безопасной зоны",
  T_43_YU_WS_SIMPLERENDER_D: "Компонент мостового рендеринга, используемый для рендеринга с помощью встроенных моделей",
  T_43_YU_WS_SKINWIDTH: "Ширина скина",
  T_43_YU_WS_SKINWIDTH_D: "Глубина проникновения в капсулу не позволяет персонажу застревать или трястись",
  T_43_YU_WS_SLOPELIMIT: "Предел наклона",
  T_43_YU_WS_SLOPELIMIT_D: "Объекты, расположенные на склоне, превышающем этот угол, соскользнут вниз",
  T_43_YU_WS_SPEED: "Скорость",
  T_43_YU_WS_STARTDROPTIME_D: "Время прибытия авиапосылки в миллисекундах",
  T_43_YU_WS_STARTPOS_D: "Начальное положение безопасной зоны",
  T_43_YU_WS_STATICICONCOLORS: "Цвета статических иконок",
  T_43_YU_WS_STATICICONCOLORS_D: "Цвета иконок, отображаемые на линейке",
  T_43_YU_WS_STATICICONS: "Статические иконки",
  T_43_YU_WS_STATICICONS_D: "Иконки, изображенные на линейках",
  T_43_YU_WS_STEPOFFSET: "Шаг смещения",
  T_43_YU_WS_STEPOFFSET_D: "Только препятствия, превышающие эту высоту, будут иметь блокирующий эффект",
  T_43_YU_WS_SUBTITLE: "Подзаголовок",
  T_43_YU_WS_SUBTITLE_D: "Субтитры",
  T_43_YU_WS_TARGET: "Цель",
  T_43_YU_WS_TARGET_D: "Целевой объект для отображаемого количества повреждений",
  T_43_YU_WS_TARGETICONCOLORS: "Цвета иконки цели",
  T_43_YU_WS_TARGETICONCOLORS_D: "Цвета значка, отображаемого отмеченной целью",
  T_43_YU_WS_TARGETICONS: "Значки Цели",
  T_43_YU_WS_TARGETICONS_D: "Значки, отображаемые отмеченными целями",
  T_43_YU_WS_TARGETPOS_D: "Целевое конечное положение безопасной зоны",
  T_43_YU_WS_TEAM: "Команда",
  T_43_YU_WS_TEAM_D: "Сущность команды в игре. Каждая команда имеет одну сущность",
  T_43_YU_WS_TEAM_D1: "Попросить команду помочь с покупкой",
  T_43_YU_WS_TIMEOFSTAY_D: "Длительность отображения в миллисекундах",
  T_43_YU_WS_TITLE: "Титул",
  T_43_YU_WS_TITLE_D: "Основное название",
  T_43_YU_WS_TRANSFORM_D: "Вращение, масштабирование и родительско-дочерняя запись",
  T_43_YU_WS_UNSELECTEDCOLOR: "Невыбранный цвет",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "Невыбранный цвет спрайта",
  T_43_YU_WS_UNSELECTEDSPRITE: "Невыбранный спрайт",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Невыбранный спрайт",
  T_43_YU_WS_UNSELECTEDTYPE: "Невыбранный тип",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Невыбранный тип спрайта",
  T_43_YU_WS_USEPHYSICALCCT: "Исп. Физ. CCT",
  T_43_YU_WS_VALUE_D: "Отображаемый контент",
  T_43_YU_WS_VECTOR2ADD: "Добавить Vector2",
  T_43_YU_WS_VECTOR2GETX: "Vector2 получить X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 получить Y",
  T_43_YU_WS_VECTOR2SCALE: "Масштаб Vector2",
  T_43_YU_WS_VECTOR2SETX: "Установить X Vector2",
  T_43_YU_WS_VECTOR2SETY: "Установить Y Vector2",
  T_43_YU_WS_VECTOR2SUB: "Суб-Vector2",
  T_43_YU_WS_VELOCITY: "Скорость",
  T_43_YU_WS_VERTICALMAXANGLE: "Вертикальный Макс. Угол",
  T_43_YU_WS_VERTICALMINANGLE: "Вертикальный Мин. Угол",
  T_43_YU_WS_VISIBILITY_D: "Указывает, можно ли настроить видимость",
  T_43_YU_WS_VISIBLE_D: "Настройка видимости. Если установлено значение «невидимый», клиент перестает отображать цель",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Хай-тек Стена A",
  T_43_ZY_WS_ITEM320: "Хай-тек Стена C",
  T_43_ZY_WS_ITEM321: "Хай-тек Окно",
  T_43_ZY_WS_ITEM322: "Хай-тек Дверь",
  T_43_ZY_WS_ITEM323: "Хай-тек прямоугольная крыша",
  T_43_ZY_WS_ITEM324: "Хай-тек Круглая Крыша",
  T_43_ZY_WS_ITEM325: "Хай-тек Плинтус",
  T_43_ZY_WS_ITEM326: "Хай-тек Круглый Плинтус",
  T_43_ZY_WS_ITEM327: "Хай-тек Лестница",
  T_43_ZY_WS_ITEM328: "Хай-тек Декорации A",
  T_43_ZY_WS_ITEM329: "Хай-тек Здание A",
  T_43_ZY_WS_ITEM330: "Хай-тек Здание B",
  T_44_CJ_M_B_SPORT_TH: "Спортивная форма (Низ)",
  T_44_CJ_M_H_SPORT_TH: "Спортивная форма (Голова)",
  T_44_CJ_M_S_SPORT_TH: "Спортивная форма (Обувь)",
  T_44_CJ_M_T_SPORT_TH: "Спортивная форма (Верх)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Кайрос",
  T_44_H_M24_ONIMUSHA_N: "M24 - Блуждающая Атака",
  T_44_H_USP45_CARNIVORE_N: "USP - Ядовитый Зуб",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Байк - Гром и Молния",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Принудительный запуск с мин. игроками",
  T_44_JH_WS_HALFWAYKEY1: "Расставьте приоритеты: начните с полной командой",
  T_44_PD_PVE_DRAGON_NAME: "Меха-Драко",
  T_44_QL_GRENADE_DRAGON: "Крио-Драко",
  T_44_QL_GRENADE_DRAGON_DES: "Усовершенствованная технология Крио-Гранаты, которая взорвется три раза подряд при ударе",
  T_44_QL_JUMPSHOESX: "Драконы-Спринтеры",
  T_44_QL_JUMPSHOESX_DES: "Пара специальных прыжковых ботинок, позволяющих бегать в воздухе во время двойного прыжка",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Время закрытия Безопасной Зоны",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Время, когда безопасная зона исчезает. Если время закрытия безопасной зоны меньше времени начала безопасной зоны, безопасная зона не будет создана",
  T_44_SJ_WS_SAFEZONE_COLOR: "Цвет Безопасной Зоны",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Интервал Урона",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Интервал урона",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Значение урона",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "Урон, нанесенный игроку, находящемуся за пределами зоны, за один раз",
  T_44_SJ_WS_SAFEZONE_DESC: "Размещаемый объект вне Зоны",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Конечный радиус вне зоны",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Конечный радиус зоны вне зоны",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Список игроков Безопасной Зоны",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Получить список игроков Безопасной Зоны",
  T_44_SJ_WS_SAFEZONE_NAME: "Область вне Зоны",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Продолжительность сужения (с)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Время, в течение которого происходит сужение зоны",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Начальный радиус вне зоны",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Начальный радиус зоны вне зоны",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Время начала сужения",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Время начала сужения Зоны",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Старт Безопасной Зоны",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Время, когда Безопасная Зона появляется в каждом раунде матча. По умолчанию — 0",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "ПЛАЗМА-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Активированная Альфа",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Активированная альфа",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Интерфейс кнопки активного навыка",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Добавьте компонент в сущность. Поддерживает только пользовательские компоненты. (Компонент не будет добавлен повторно, если он уже существует.)",
  T_44_XXJ_WS_ALLMEMBERS: "Все участники",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Разрешить нажатие снаружи",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Разрешить срабатывание за пределами обозначенной Зоны",
  T_44_XXJ_WS_ARROWIMAGE: "Изображение Стрелки",
  T_44_XXJ_WS_ARROWIMAGE_D: "Изображение стрелки",
  T_44_XXJ_WS_ARROWOFFSET: "Смещение Стрелки",
  T_44_XXJ_WS_ARROWOFFSET_D: "Смещение стрелки",
  T_44_XXJ_WS_ARROWSIZE: "Размер Стрелки",
  T_44_XXJ_WS_ARROWSIZE_D: "Размер стрелки",
  T_44_XXJ_WS_AUTOPLAY_D: "Автоматически воспроизводиться при создании",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Изображение на заднем плане",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Базовое изображение",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Фоновый радиус",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Базовый радиус",
  T_44_XXJ_WS_BAGSKINID: "ID скина рюкзака",
  T_44_XXJ_WS_BAGSKINID_D: "ID скина рюкзака",
  T_44_XXJ_WS_BONEPOSITION: "Положение костей",
  T_44_XXJ_WS_BONEPOSITION_D: "Мировые координаты костного узла",
  T_44_XXJ_WS_CCTMOVE: "Движение CCT",
  T_44_XXJ_WS_COLLIDER: "Коллайдер",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Коллекция коллайдеров",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "Компонент, используемый для описания формы столкновения",
  T_44_XXJ_WS_COLOR: "Цвет",
  T_44_XXJ_WS_CONTENT: "Контент",
  T_44_XXJ_WS_CONTENT_D: "Содержимое кошелька представляет собой набор валют",
  T_44_XXJ_WS_CONTEXT_D: "Содержимое для печати",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Интерфейс перекрестия",
  T_44_XXJ_WS_CURVE_D: "Изгиб",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Цвет текстуры поверхности",
  T_44_XXJ_WS_ENABLE: "Включить",
  T_44_XXJ_WS_ENTITY_D: "Сущность",
  T_44_XXJ_WS_GETBAGSKINID_D: "Получить конфигурацию скина рюкзака игрока",
  T_44_XXJ_WS_GETFACTION_D: "Получить фракцию",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Получить загруженные сцены, которые не были удалены",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Получить локального игрока",
  T_44_XXJ_WS_GROUPID: "ID группы",
  T_44_XXJ_WS_GROUPID_D: "Для внутренней логики",
  T_44_XXJ_WS_HUDJOYSTICK: "Виджет джойстика HUD",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Джойстик. Игроки могут редактировать HUD через редактор HUD",
  T_44_XXJ_WS_HUDTOUCHPAD: "Виджет сенсорной панели HUD",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "Виджет сенсорной панели HUD, который игроки могут редактировать в редакторе HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Пользовательский HUD или виджет HUD",
  T_44_XXJ_WS_ICON: "Иконка",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Всегда показывать отметку",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Всегда показывайте отметки на компасе",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Неактивированная Альфа",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Неактивированная альфа",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "При вызове количество фактических параметров не совпадает с количеством формальных параметров. Ожидаемое число — {0}, фактическое — {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Динамическое препятствие",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Является динамическим препятствием для NavMesh",
  T_44_XXJ_WS_ISEND: "Завершение",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Управляемый сервером",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "Если значение false, пользовательские объекты не могут управляться API",
  T_44_XXJ_WS_ISSUC_D: "Возврат результата выполнения",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Радиус сопротивления джойстика",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Радиус сопротивления джойстика",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Изображение джойстика",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Изображение джойстика",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Радиус джойстика",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Радиус джойстика",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Список ID навыков персонажей",
  T_44_XXJ_WS_LOOPTYPE_D: "Тип циклов",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Выйти из конфигурации Midway",
  T_44_XXJ_WS_MOUNTABLE: "Иерархический",
  T_44_XXJ_WS_MOUNTABLE_D: "Объект, способный монтировать дочерние узлы",
  T_44_XXJ_WS_MOVEMENT: "Движение",
  T_44_XXJ_WS_NAME_D: "Название",
  T_44_XXJ_WS_NATURALCONST: "Естественная константа",
  T_44_XXJ_WS_NATURALCONST_D: "Перечисление естественных констант для уменьшения избыточных определений",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Воспроизвести анимацию иконки",
  T_44_XXJ_WS_OFFSET_D: "Базовое смещение по умолчанию",
  T_44_XXJ_WS_ONFIRE_D: "Событие вызывается каждый раз, когда игрок стреляет, атакует кулаками или атакует оружием ближнего боя",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Запускает событие, когда игрок встает из лежания/приседания",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Запускает событие, когда игрок нажимает кнопку огня",
  T_44_XXJ_WS_OPTION: "Опции",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Интерфейс пассивных навыков",
  T_44_XXJ_WS_PHYSICALMOVER: "Физический двигающийся",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Игроки на этой платформе будут автоматически следить за движением и вращением",
  T_44_XXJ_WS_PHYSICALOBJECT: "Физический объект",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Можно применить к нему силу",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "Математическая константа π (Пи)",
  T_44_XXJ_WS_PLAYERS: "Список Игроков",
  T_44_XXJ_WS_PLAYERS_D: "Список игроков",
  T_44_XXJ_WS_PLAYERSKILLID: "ID навыка персонажа",
  T_44_XXJ_WS_PLAYERSKILLID_D: "ID навыка персонажа в AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "Предыдущее движение перед тем, как игрок встает",
  T_44_XXJ_WS_PRINT: "Печать",
  T_44_XXJ_WS_PRINTERROR: "Ошибка печати",
  T_44_XXJ_WS_PRINTERROR_D: "Распечатать целевые данные как ошибку на консоли",
  T_44_XXJ_WS_PRINTWARNING: "Распечатать предупреждение",
  T_44_XXJ_WS_PRINTWARNING_D: "Распечатать целевые данные в качестве предупреждения на консоли",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Приоритизация конфигурации скина игрока",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Установить приоритет конфигурации скина игрока, не подходящего для матча",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Прочитать содержимое ячеек строки по номеру столбца и ключу",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Очистить конфигурацию скина рюкзака игрока",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Удалить компонент из сущности. Поддерживает только пользовательские компоненты",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Сбросить конфигурацию скина рюкзака игрока до несоответствующей конфигурации",
  T_44_XXJ_WS_SETBAGSKINID_D: "Установить конфигурацию скина рюкзака игрока",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Объект, поддерживающий компоненты Transform, SkeletonPart, Player и MountPoint",
  T_44_XXJ_WS_SHOWBACKGROUND: "Показать фон",
  T_44_XXJ_WS_SKINID_D: "ID скина рюкзака и конфигурация скина",
  T_44_XXJ_WS_SPEED_D: "Скорость Проигрывания",
  T_44_XXJ_WS_TARGET: "Цель",
  T_44_XXJ_WS_TARGET_D: "Целевой объект",
  T_44_XXJ_WS_TITLE: "Титул",
  T_44_XXJ_WS_TYPEID_D: "ID типа компонента. Поддерживает только пользовательские компоненты",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Загрузить результаты собственных матчей",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Несоответствие типов. Невозможно прочитать содержимое таблицы",
  T_44_XXJ_WS_X_D: "Координата оси X",
  T_44_XXJ_WS_Y_D: "Координата оси Y",
  T_44_XYL_WS_CTZSAFEZONE: "Пользовательская Безопасная Зона",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Генерирует начальную и конечную точку Безопасной Зоны на основе заданных положений и свойств",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Полусферическая оболочка",
  T_44_XYL_WS_QUARTERCYLINDER: "Четверть цилиндра",
  T_44_XYL_WS_SQUAREPYRAMID: "Квадратная пирамида",
  T_44_XYL_WS_TORUS: "Тор",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Треугольная пирамида",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Добавить карту журнала игровых событий",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Добавить журнал событий пользователя",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "Журнал событий пользовательского совпадения, используемый для анализа данных UX",
  T_44_YU_WS_ITEM366: "Укрепленная Стена A",
  T_44_YU_WS_ITEM367: "Укрепленная Стена B",
  T_44_YU_WS_ITEM368: "Укрепленная Стена C",
  T_44_YU_WS_ITEM369: "Укрепленная Стена D",
  T_44_YU_WS_ITEM370: "Укрепленное Окно A",
  T_44_YU_WS_ITEM371: "Укрепленное Окно B",
  T_44_YU_WS_ITEM372: "Укрепленное Окно C",
  T_44_YU_WS_ITEM373: "Укрепленная Дверь A",
  T_44_YU_WS_ITEM374: "Укрепленная Дверь B",
  T_44_YU_WS_ITEM375: "Укрепленная Крыша A",
  T_44_YU_WS_ITEM376: "Укрепленная Крыша B",
  T_44_YU_WS_ITEM377: "Укрепленная Лестница A",
  T_44_YU_WS_ITEM378: "Укрепленная Лестница B",
  T_44_YU_WS_ITEM379: "Укрепленный Столб A",
  T_44_YU_WS_ITEM380: "Укрепленный Поручень A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Настроить",
  T_45_CJ_TREATMENTGUN_Y_N: "Леч. Пистолет-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Кэсси",
  T_45_H_EMOTE_MVPDANCE_N: "Шаг Чемпиона",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Осмотреть",
  T_45_HL_Moderation_fail_1: "К сожалению, представленный вами проект не прошел проверку",
  T_45_HL_Moderation_fail_2: "включает",
  T_45_HL_Moderation_fail_3: "Причины включали:",
  T_45_HL_Moderation_fail_Location_1: "Игровой контент",
  T_45_HL_Moderation_fail_reason_1: "Токсичный контент",
  T_45_HL_Moderation_fail_reason_10: "Нарушение правил сообщества",
  T_45_HL_Moderation_fail_reason_11: "Негативное влияние на внутриигровую экономику и нарушение прав виртуальной собственности",
  T_45_HL_Moderation_fail_reason_2: "Недопустимый контент",
  T_45_HL_Moderation_fail_reason_3: "Политическая чувствительность",
  T_45_HL_Moderation_fail_reason_4: "Ложная информация",
  T_45_HL_Moderation_fail_reason_5: "Нарушение авторского права",
  T_45_HL_Moderation_fail_reason_6: "Нарушение конфиденциальности",
  T_45_HL_Moderation_fail_reason_7: "Проблемы безопасности",
  T_45_HL_Moderation_fail_reason_8: "Разжигание ненависти",
  T_45_HL_Moderation_fail_reason_9: "Спам",
  T_45_HL_Moderation_fail_reason_999: "Другие вопросы",
  T_45_JH_WS_CLEMPTYOBJECT: "Группа объектов",
  T_45_JH_WS_PETSWITCH1: "Показывать ли питомцев в матче",
  T_45_QL_CSFPP_DES: "Устраните всех противников с видом от первого лица в этом специальном режиме БО!",
  T_45_QL_CSFPP_NAME: "БО: FPP",
  T_45_QL_CSFPP_RANKNAME: "Первое лицо",
  T_45_SJ_WS_REVIEW_23: "Игровой контент",
  T_45_SJ_WS_REVIEW_24: "{0} включает {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} включает {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Нажмите, чтобы просмотреть подробности >>[-]",
  T_45_SJ_WS_REVIEW_27: "Не одобрено",
  T_45_SJ_WS_REVIEW_28: "Обзор отзывов",
  T_45_SJ_WS_REVIEW_29: "Контент содержит {0} нарушений",
  T_45_SJ_WS_REVIEW_31: "Не одобрено",
  T_45_SJ_WS_REVIEW_32: "Проверка не удалась из-за исключений сервера",
  T_45_SJ_WS_REVIEW_TITLE: "Подробности нарушения",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Триггеры для прыжков (прыжков через препятствия)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Расстояние склада",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Изменяет расстояние прыжка",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Высота прыжка",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Контролирует высоту перемещения вверх и вниз при прыжках",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Триггер Склада",
  T_45_TYC_CL_TEMPLATE_WS: `Режим на выбывание, в котором игроки уничтожают все команды соперников в хаотичном сражении за победу.
Вы можете устанавливать правила игрового процесса и редактировать параметры игрового процесса по своему усмотрению.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Небесный Бластер",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = автоатака, 1 = защитная атака, 2 = не атаковать",
  T_45_XXJ_WS_ADDFRIEND: "Добавить в друзья",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Авто",
  T_45_XXJ_WS_BASEDATA: "Базовые данные",
  T_45_XXJ_WS_BOTH: "Оба",
  T_45_XXJ_WS_BYHIERARCHY: "По иерархии",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "По приоритету от высокого к низкому",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "По приоритету от низкого к высокому",
  T_45_XXJ_WS_CAMERA: "Камера",
  T_45_XXJ_WS_CAMERATYPE: "Тип камеры",
  T_45_XXJ_WS_CENTERINVISIBLE: "Невидимый центр",
  T_45_XXJ_WS_CLIENT: "Клиент",
  T_45_XXJ_WS_COLLIDERID: "Идентификатор коллайдера",
  T_45_XXJ_WS_COLLIDERID_D: "Идентификатор коллайдера",
  T_45_XXJ_WS_COMPONENT: "Компонент",
  T_45_XXJ_WS_CURRENTCAMERA: "Текущая камера",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Пользовательская сила нажатия",
  T_45_XXJ_WS_DOUBLE: "Двойной",
  T_45_XXJ_WS_DUMP: "Бросок",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Включить движение в воздухе",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Включить вращение с помощью гравитации",
  T_45_XXJ_WS_ENUM: "Перечисление",
  T_45_XXJ_WS_EVENT: "Событие",
  T_45_XXJ_WS_FILLAMOUNT: "Заполнить количество",
  T_45_XXJ_WS_FILLDIR: "Направление заполнения",
  T_45_XXJ_WS_FIRETYPE: "Тип огня",
  T_45_XXJ_WS_FIRETYPE_D: "Тип стрельбы",
  T_45_XXJ_WS_FIXEDDELTATIME: "Фиксированная разница во времени",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "Фиксированный интервал времени обновления кадров в миллисекундах",
  T_45_XXJ_WS_FORWARD: "Вперед",
  T_45_XXJ_WS_FORWARD_D: "Направление оси z в местной системе координат",
  T_45_XXJ_WS_FUNCTIONTYPE: "Тип функции",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "Тип функции",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "Направление прицеливания локального игрока",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Получить местную временную метку",
  T_45_XXJ_WS_GRADIENT: "Градиент",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Градиент Низ",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Градиент Верх Альфа",
  T_45_XXJ_WS_GRADIENTTOP: "Градиент Верх",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Градиент Низ Альфа",
  T_45_XXJ_WS_HITPOSITION_D: "Мировое положение цели, пораженной пулями",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "Виджет социальных кнопок UI",
  T_45_XXJ_WS_INVERTFILL: "Инвертировать заливку",
  T_45_XXJ_WS_ISGROUNDED: "Заземлен",
  T_45_XXJ_WS_ISSILENCE: "Тишина",
  T_45_XXJ_WS_ISSILENCE_D: "Тишина или нет",
  T_45_XXJ_WS_ISSINGLESHOT: "Одиночный выстрел",
  T_45_XXJ_WS_ISSINGLESHOT_D: "Одноразовый или нет",
  T_45_XXJ_WS_JUMPHEIGHT: "Высота прыжка",
  T_45_XXJ_WS_JUMPHEIGHT_D: "Высота прыжка",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Тип сортировки макета",
  T_45_XXJ_WS_LIGHT_D: "Свет",
  T_45_XXJ_WS_LOCAL: "Локальный",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Макс. количество прыжков",
  T_45_XXJ_WS_MODULE: "Модуль",
  T_45_XXJ_WS_NONE: "Отсутствует",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Выполняйте команду каждый раз, прежде чем сущность нанесет урон",
  T_45_XXJ_WS_ONDISABLE_D: "Выполнять, когда объект отключен",
  T_45_XXJ_WS_ONEACHLOOP_D: "Выполнять каждый раз, когда Играбельно зацикливается. Действует только на стороне клиента для таких объектов, как Звуковой эффект и Специальный эффект",
  T_45_XXJ_WS_ONENABLE_D: "Выполнять, когда объект включен",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "При входе в кадр с фиксированным 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Запустить клиентское событие, когда игрок добавляет или удаляет друга",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Запустить событие, когда игра приостановлена из-за вызванного API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Запустить событие, когда игра возобновляется из-за вызванного API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Когда игрок прекращает бежать",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Когда игрок прекращает серфинг",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Когда игрок занимается серфингом",
  T_45_XXJ_WS_PHYSICALLAYER_D: "Пользовательский физический уровень в диапазоне от 0 до 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Тип платформы",
  T_45_XXJ_WS_PLATFORMTYPE_D: "Тип платформы",
  T_45_XXJ_WS_PLAYER: "Игрок",
  T_45_XXJ_WS_PLAYERCCT: "Игрок CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "Контроллер персонажа с физическими эффектами, используемый только для персонажей Free Fire",
  T_45_XXJ_WS_PRIORITY: "Приоритет",
  T_45_XXJ_WS_REMAINMULTINUM: "Оставшийся прыжки",
  T_45_XXJ_WS_REPORT: "Пожаловаться",
  T_45_XXJ_WS_RIGHT: "Право",
  T_45_XXJ_WS_RIGHT_D: "Направление оси X в местной системе координат",
  T_45_XXJ_WS_SERVER: "Сервер",
  T_45_XXJ_WS_SINGLE: "Одиночный",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Тип стиля социальной кнопки",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "Тип стиля социальной кнопки",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Тип социальной кнопки",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "Тип социальной кнопки",
  T_45_XXJ_WS_SORTTYPE_D: "Типы сортировки: ненулевой по возрастанию, по убыванию и по возрастанию",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Скорость перемещения при ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "Скорость движения при прицеливании",
  T_45_XXJ_WS_STRINGORLOCSTRING: "Строка или локализованная строка",
  T_45_XXJ_WS_TRIPLE: "Тройной",
  T_45_XXJ_WS_UP: "Верх",
  T_45_XXJ_WS_UP_D: "Направление оси Y в местной системе координат",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Использовать пользовательскую силу нажатия",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Бросьте сигнальную ракету в указанную область, чтобы вызвать случайное транспортное средство",
  T_45_ZD_VEHICLEDROP_R_NAME: "Тайный Транспорт",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Лила",
  T_46_HJ_SHARE_GAMEDURATION: "Время в игре",
  T_46_HJ_WS_SHAREBY: "До {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Игровой Режим",
  T_46_HJ_WS_SHARETEAM: "Команда",
  T_46_HJ_WS_SHARETEAMVS: "{0} против {1}",
  T_46_HX_B_SCHOOL_VN: "Лучший в классе (Низ)",
  T_46_HX_H_SCHOOL_VN: "Лучший в классе (Голова)",
  T_46_HX_S_SCHOOL_VN: "Лучший в классе (Обувь)",
  T_46_HX_T_SCHOOL_VN: "Лучший в классе (Верх)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Руководство",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Другие",
  T_46_XXJ_WS_ACTUALPOSITION: "Фактическое положение",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Добавьте объект для мониторинга с синхронизацией AOI за пределами прямой видимости",
  T_46_XXJ_WS_APPEARANCE: "Внешний Вид",
  T_46_XXJ_WS_APPEARANCERES: "Ресурсы Внешнего Вида",
  T_46_XXJ_WS_BECOME: "Активировать",
  T_46_XXJ_WS_BRAKETORQUE_D: "Мощность, развиваемая транспортным средством при использовании тормоза/реверса",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Тип ограничения угла поворота камеры",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Очистить все контролируемые объекты от цели",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "Максимальный ущерб от аварии, используемый для расчета ущерба",
  T_46_XXJ_WS_CRASHMAXSPEED: "Макс. скорость при столкновении",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Используется для расчета повреждений при столкновении. После превышения этой скорости больше повреждений не будет",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Фактор массы при столкновении",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Параметр, используемый в формуле расчета ущерба при столкновении",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "Минимальный ущерб от аварии, используемый для расчета ущерба",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Превышен лимит чтения и записи хранилища данных",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Параметр исключения",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Истекло время ожидания хранения данных. В основном применяется для чтения и записи",
  T_46_XXJ_WS_DELTA: "Дельта",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Редактировать Внешний Вид",
  T_46_XXJ_WS_ENDVALUE_D: "Целевое значение",
  T_46_XXJ_WS_ENGINETORQUE_D: "Мощность, развиваемая транспортным средством при нажатии на педаль газа",
  T_46_XXJ_WS_ERRORCODE_D: "Код ошибки перечисление",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Угол Эйлера к Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Преобразовать угол Эйлера в трехмерный вектор",
  T_46_XXJ_WS_EXPIRE: "Истекает",
  T_46_XXJ_WS_FEMALEAVATAR: "Женский Персонаж",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Получить дату истечения срока действия членства",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Наблюдает ли наблюдатель за объектом или нет",
  T_46_XXJ_WS_HELICOPTER: "Небесный Бластер",
  T_46_XXJ_WS_HELICOPTER_D: "Тип летающего транспорта",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Ограничение на высокой скорости",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "Максимальный угол поворота на высокой скорости",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Угол поворота на высокой скорости",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "Порог скорости для максимального угла поворота рулевого колеса на высокой скорости",
  T_46_XXJ_WS_IDLE: "Анимация бездействия",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Входной сигнал холостого хода",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Если вы не управляете транспортным средством, замедлите его на (Усилие торможения холостым ходом) x (Тормозной момент).",
  T_46_XXJ_WS_INTTOFLOAT: "Int в Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Преобразовать целое число в число с плавающей точкой",
  T_46_XXJ_WS_ISPREMIUM: "Членство",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "Название таблицы лидеров в базе данных",
  T_46_XXJ_WS_MALEAVATAR: "Мужской Персонаж",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "ИИ Персона",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Новый внешний вид UMA",
  T_46_XXJ_WS_NONE_D: "Нет ошибки",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "Объект NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Советы: гуманоидные NPC обычно имеют модель столкновения с капсулой высотой 1,4 м и радиусом 0,25 м. Питомцы NPC обычно имеют модель столкновения с капсулой высотой 1 м и радиусом 0,4 м.",
  T_46_XXJ_WS_OBSERVER_D: "Наблюдатель, который следит за объектами",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "При входе Членство Личного Острова",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "При выходе Членство Личного Острова",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Открыть Членство Личного Острова",
  T_46_XXJ_WS_PERSONA: "Персона",
  T_46_XXJ_WS_PERSONACENTER: "Центр Персона",
  T_46_XXJ_WS_PET: "Питомец",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Игрок или Трансформ",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Псевдоним для сущности Игрок и Трансформация",
  T_46_XXJ_WS_PREMIUM: "Членство",
  T_46_XXJ_WS_PREMIUMSTATUS: "Статус Членства",
  T_46_XXJ_WS_PROXYOBSERVER: "Прокси-Наблюдатель",
  T_46_XXJ_WS_PROXYOBSERVER_D: "Прокси-Наблюдатель",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Удалите контролируемый объект и отмените синхронизацию AOI за пределами прямой видимости",
  T_46_XXJ_WS_RENEWAL: "Купить",
  T_46_XXJ_WS_ROTATEVECTOR: "Поворот вектора",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Поворот вектора на основе кватернионов",
  T_46_XXJ_WS_SKIN: "Механизм",
  T_46_XXJ_WS_STARTVALUE_D: "Исходное значение",
  T_46_XXJ_WS_STATUS: "Статус",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Переключение прокси-наблюдателя пользователя",
  T_46_XXJ_WS_TARGET_D: "Цель, которая контролируется",
  T_46_XXJ_WS_USER_D: "Пользователь",
  T_46_XXJ_WS_VALUE: "Значение",
  T_46_XXJ_WS_VALUE_D: "Вектор",
  T_46_XYL_WS_CTZSAFEZONEEND: "Крайняя Точка Безопасной Зоны",
  T_46_XYL_WS_RESOURCETYPE1: "Базовые Структуры",
  T_46_XYL_WS_RESOURCETYPE1_1: "Геометрия",
  T_46_XYL_WS_RESOURCETYPE1_2: "Визуал и Аудио",
  T_46_XYL_WS_RESOURCETYPE2: "Предметы Сцены",
  T_46_XYL_WS_RESOURCETYPE2_2: "Припасы Битвы",
  T_46_XYL_WS_RESOURCETYPE3: "Природа",
  T_46_XYL_WS_RESOURCETYPE4: "Модулярные Компоненты",
  T_46_XYL_WS_TYPEOTHERPROP: "Разнообразный",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Контейнеры и коробки",
  T_47_CJ_FOREGRIP_SOFT_N: "Легкая рукоятка",
  T_47_CJ_MAGEZINE_FAST_N: "Быстрый Магазин",
  T_47_CJ_STOCK_FAST_N: "Мощность запаса",
  T_47_GT_WS_USERMANUAL: "Руководство пользователя",
  T_47_HJ_WS_VFX_FOG: "Туман VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Свет VFX",
  T_47_HJ_WS_VFX_TRAILING: "Преследование VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Талант Комьюнити",
  T_47_HL_CL_MAP_LABEL1: "Выбранные работы Таланта Комьюнити",
  T_47_JH_WS_MODERATION_REASON12: "Связанные с гэмблингом",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "Коллаборация NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "Файл материала",
  T_47_SD_RES_MESH: "Сетка",
  T_47_SD_WS_MAPTAG_AI: "Генерация ИИ Карты",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Специальный нож, который прилипает к точке удара после броска, вызывая огненный взрыв после короткой задержки, наносящий ожоговый урон",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Огненный Кунай",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Специальный нож, который прилипает к точке удара после броска, вызывая удар молнии с небольшой задержкой, парализующий цель",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Кунай Молнии",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Специальный нож, который прилипает к точке удара после броска, вызывая с небольшой задержкой бурю, которая замедляет цель и уносит ее в центр",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Кунай Ветра",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Разновидность сюрикена, подходящая для боя на средних и дальних дистанциях. Одним броском быстро запускает один предмет, нанося большой урон",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Тяжелый Сюрикен",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Тип сюрикена, подходящий для боя на ближней и средней дистанции, с двумя режимами атаки. Один бросок запускает три куска, нанося небольшой урон",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Легкий Сюрикен",
  T_47_XXJ_WS_ACTION: "Действие",
  T_47_XXJ_WS_AOISETTING: "Настройки AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "Тип Скин Рюкзака",
  T_47_XXJ_WS_CLEARMEMORY: "Очистить память",
  T_47_XXJ_WS_CLNPC: "Продвинутый NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Тип Скина Наряда",
  T_47_XXJ_WS_COMMON_ERROR: "Общая Ошибка",
  T_47_XXJ_WS_CONTENT: "Контент",
  T_47_XXJ_WS_CREATERANDOMSEED: "Создать Случайный Сид",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Прошедший процент",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Включить функцию тумана",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Включить функцию вращения света",
  T_47_XXJ_WS_ERRORCODE: "Код Ошибки",
  T_47_XXJ_WS_EXPONENTIAL: "Экспоненциальный",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Экспоненциальный квадрат",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Не удалось создать комнату: нет ID персон",
  T_47_XXJ_WS_FOG: "Туман",
  T_47_XXJ_WS_FOGDENSITY: "Плотность тумана",
  T_47_XXJ_WS_FOGENDDISTANCE: "Дистанция завершения тумана",
  T_47_XXJ_WS_FOGMODE: "Режим Тумана",
  T_47_XXJ_WS_FOGMODETYPE: "Тип Режима Тумана",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Дистанция старта тумана",
  T_47_XXJ_WS_HEIGHTSCALE: "Шкала высоты",
  T_47_XXJ_WS_ISVISIBLE: "Видимый",
  T_47_XXJ_WS_JOINNEWTEAM: "Присоединиться к новой команде",
  T_47_XXJ_WS_JOINTEAM: "Присоединиться",
  T_47_XXJ_WS_LIGHTROTATE: "Вращение света",
  T_47_XXJ_WS_LINEAR: "Линейная",
  T_47_XXJ_WS_LLMCHATHUD: "Отправить сообщение пользователю Персоны",
  T_47_XXJ_WS_NEWTEAM: "Новая Команда",
  T_47_XXJ_WS_NEXT: "Следующий",
  T_47_XXJ_WS_NPC_TIP: "Вы можете редактировать внешний вид NPC и заставлять NPC воспроизводить анимацию",
  T_47_XXJ_WS_OBSERVERS: "Наблюдатели",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "Отправка игроку сообщения через UI Чат Персоны",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "При изменении статуса членства",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "При получении действия от Персоны",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "При получении контента от Персоны",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "При получении завершения от Персоны",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "При получении статуса от Персоны",
  T_47_XXJ_WS_PARTICLESID: "ID частиц",
  T_47_XXJ_WS_PERSONAAVATAR: "Аватар Персоны",
  T_47_XXJ_WS_PERSONAID: "ID Персона",
  T_47_XXJ_WS_PERSONANICKNAME: "Ник Персоны",
  T_47_XXJ_WS_PLAYERORNPC: "Игрок или NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Членство закрыто",
  T_47_XXJ_WS_RANDOM: "Случайно",
  T_47_XXJ_WS_SEED: "Сид",
  T_47_XXJ_WS_SENDER: "Отправитель",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Установть наблюдателя Персона",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Установить игроку выход на полпути",
  T_47_XXJ_WS_SHOULDREPLY: "Должен ответить",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Показать ответ системы",
  T_47_XXJ_WS_SPOTANGLE: "Угол места",
  T_47_XXJ_WS_SPOTLIGHT: "Софиты",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Отправить системное сообщение Персоне",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Стрим Системных Сообщений Персоне",
  T_47_XXJ_WS_TARGETTEAM: "Целевая команда",
  T_47_XXJ_WS_THISENTITY: "Эта Сущность",
  T_47_XXJ_WS_USERAVATAR: "Аватар Пользователя",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Отправить сообщение пользователю Персоны",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Стрим Сообщений Пользователя Персоне",
  T_47_XXJ_WS_USERNICKNAME: "Никнейм Пользователя",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Тип Скина Транспорта",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Тип Скина Оружия",
  T_47_XYL_NB_UGC_EFFECT001: "Расэнган VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Тидори VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Удар Расцветающей Вишни VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Катон: Дзюцу огненного шара VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Суитон: Дзюцу водного дракона VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Футон: Великий порыв VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Бомба Хвостатого Зверя VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Возрождение в бренном мире! VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Магазин Ассетов",
  T_47_XYL_UGC_DONKEYCART: "Тележка с осликом",
  T_47_XYL_UGC_SPOTLIGHT: "Софиты",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Угол Освещения",
  T_48_H_EMOTE_WATERFEST25_N: "Быстрые шаги",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Байк - Танец Моря",
  T_48_HJ_AC_STATENOTEXIST: "Состояние {0} не существует в контроллере анимации",
  T_48_HL_CODESCRIPT: "Код Скрипта",
  T_48_HL_GLOBAL_VAR: "Название Глобальной Переменной",
  T_48_HL_GRAPH: "Блок",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Таблица лидеров",
  T_48_HL_LOCAL_VAR: "Название Локальной Переменной",
  T_48_HL_LOCALIZATION: "Название локализации",
  T_48_HL_OPEN_ATTRIBUTES: "Открыть название атрибута",
  T_48_HX_A_WATERFEST25: "Танец Моря (Маска)",
  T_48_HX_B_WATERFEST25: "Танец Моря (Низ)",
  T_48_HX_F_B_BLACKDRESS: "Антиматерия (Низ)",
  T_48_HX_F_H_BLACKDRESS: "Антиматерия (Голова)",
  T_48_HX_F_HA_BLACKDRESS: "Антиматерия (Грим)",
  T_48_HX_F_S_BLACKDRESS: "Антиматерия (Обувь)",
  T_48_HX_F_T_BLACKDRESS: "Антиматерия (Верх)",
  T_48_HX_H_WATERFEST25: "Танец Моря (Голова)",
  T_48_HX_HA_WATERFEST25: "Танец Моря (Грим)",
  T_48_HX_M_A_BLACKDRESS: "Темная Материя (Маска)",
  T_48_HX_M_B_BLACKDRESS: "Темная Материя (Низ)",
  T_48_HX_M_H_BLACKDRESS: "Темная Материя (Голова)",
  T_48_HX_M_HA_BLACKDRESS: "Темная Материя (Грим)",
  T_48_HX_M_S_BLACKDRESS: "Темная Материя (Обувь)",
  T_48_HX_M_T_BLACKDRESS: "Темная Материя (Верх)",
  T_48_HX_S_WATERFEST25: "Танец Моря (Обувь)",
  T_48_HX_T_WATERFEST25: "Танец Моря (Верх)",
  T_48_JH_WS_STRINGDESC: "Введите абзац текста или другие строки. Некоторые виджеты могут отображать форматированный текст. Добавьте цвет к тексту с помощью форматированного текста, используя следующий формат: [#XXXXXX] текст текст [-]. «#XXXXXX» — это цвет, который вы хотите отобразить. Обратите внимание, что цвет текста соответствующего виджета должен быть установлен на белый.",
  T_48_M_WS_P_ICON: "Аватар",
  T_48_META_API_10001: "Найти сущность по ID",
  T_48_META_API_10001_P0: "ID сущности",
  T_48_META_API_1098: "Пакетное чтение значения листа базы данных",
  T_48_META_API_1098_D: "Пакетное чтение нескольких записей данных из указанного листа базы данных, где записи списка уникальных идентификаторов игроков соответствуют один к одному записям списка ключей.",
  T_48_META_API_1098_P1: "ID Аккаунта",
  T_48_META_API_1098_P1_D: "Список уникальных идентификаторов игроков, который считывает данные, соответствующие ключам с тем же индексом в списке ключей",
  T_48_META_API_1098_P2: "Ключи",
  T_48_META_API_1098_P2_D: "Список ключей, который считывает данные, соответствующие уникальным идентификаторам игроков по тому же индексу в списке идентификаторов.",
  T_48_META_API_1098_P5: "Коды статуса",
  T_48_META_API_1098_P5_D: "Список кодов статуса",
  T_48_META_API_1105: "Уведомить о начале сюжета",
  T_48_META_API_1105_D: "Начать воспроизведение указанного сюжета для запустившего игрока",
  T_48_META_API_1105_P1_D: "ID сюжета",
  T_48_META_API_1108: "Получить местный язык",
  T_48_META_API_1500_P0: "Вектор",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Установить вес части тела",
  T_48_META_API_3300_D: "Установите вес целевой части тела при смешивании ее с другими анимациями с более низким приоритетом",
  T_48_META_API_3300_P0_D: "Добавляемый компонент контроллера анимации, к которому принадлежит часть тела",
  T_48_META_API_3300_P1: "Название части тела",
  T_48_META_API_3300_P1_D: "Название части тела",
  T_48_META_API_3300_P2: "Вес",
  T_48_META_API_3300_P2_D: "Вес со значением в диапазоне [0, 1], представляющий степень смешивания с анимациями с более низким приоритетом.",
  T_48_META_API_3315: "Выполнить переопределение анимации персонажа",
  T_48_META_API_3315_D: "Воспроизвести анимационный клип персонажа с возможностью переопределения стандартной анимации игры",
  T_48_META_API_3315_P3: "Переопределить управление игровым процессом",
  T_48_META_API_3315_P3_D: "Следует ли переопределять стандартную анимацию игры",
  T_48_META_API_3316: "Остановить Анимацию",
  T_48_META_API_3316_D: "Остановить воспроизведение анимации для цели в указанном статусе",
  T_48_META_API_90_P1: "Можно выйти на полпути",
  T_48_META_API_93: "Создать движение по траектории",
  T_48_META_API_93_D: "Создать интерполированное движение по траектории, чтобы объект двигался по указанной траектории",
  T_48_META_API_93_P1: "Путь",
  T_48_META_API_93_P1_D: "Путь движения",
  T_48_META_API_93_P3_D: "Величина скорости",
  T_48_META_API_93_P4: "Касательная грань",
  T_48_META_API_93_P4_D: "Направлен ли объект в сторону движения. Это свойство остается неизменным, даже если ориентация объекта принудительно изменена другими способами.",
  T_48_META_API_96: "Создать префаб",
  T_48_META_API_96_D: "Создайте экземпляр префаба с возможностью его асинхронной обработки",
  T_48_META_API_96_P2: "Асинхронная загрузка",
  T_48_META_API_96_P2_D: "Асинхронная ли загрузка",
  T_48_META_EVT_3140: "При смене команды",
  T_48_META_EVT_3140_D: "Срабатывает при изменении команды текущего субъекта",
  T_48_META_EVT_3140_P0: "Бывшая команда",
  T_48_META_EVT_3140_P0_D: "Команда, к которой принадлежал первый до изменения",
  T_48_META_EVT_3140_P1: "Текущая Команда",
  T_48_META_EVT_3140_P1_D: "Команда, к которой принадлежит человек после изменения",
  T_48_META_EVT_3141: "При старте сюжета",
  T_48_META_EVT_3141_D: "Срабатывает, когда начинается сюжет",
  T_48_META_EVT_3141_P1: "ID сюжета",
  T_48_META_EVT_3141_P1_D: "ID сюжета",
  T_48_META_EVT_3142: "При завершении сюжета",
  T_48_META_EVT_3142_D: "Срабатывает, когда сюжет заканчивается",
  T_48_META_EVT_3142_P0_D: "Игрок-инициатор",
  T_48_META_EVT_3142_P1_D: "ID сюжета",
  T_48_META_EVT_3143: "Вариант графика при срабатывании триггера",
  T_48_META_EVT_3143_D: "Срабатывает при выборе опции на графике",
  T_48_META_EVT_3143_P1_D: "ID сюжета",
  T_48_META_EVT_3143_P2: "ID опции",
  T_48_META_EVT_3143_P2_D: "ID выбранной опции",
  T_48_META_TYP_409_I10: "Изменить настройку команды Failed_Invalid",
  T_48_META_TYP_409_I11: "Изменить настройку команды Failed_Eliminated",
  T_48_META_TYP_409_I12: "Изменить настройку команды Failed_In",
  T_48_META_TYP_409_I7: "Изменить настройку команды Failed_Not",
  T_48_META_TYP_409_I8: "Изменить настройку команды Failed_Already",
  T_48_META_TYP_409_I9: "Изменить настройку цели Failed_Invalid",
  T_48_META_TYP_41_I19: "Отключить коллайдер",
  T_48_META_TYP_417: "Частицы",
  T_48_META_TYP_428: "Трансформация игрока или наряд NPC",
  T_48_META_TYP_431: "Движение по траектории",
  T_48_META_TYP_431_I1: "Путь",
  T_48_META_TYP_432: "Пользовательская кривая точка маршрута",
  T_48_META_TYP_432_I0: "Катиться",
  T_48_META_TYP_432_I1: "Тангенс",
  T_48_META_TYP_433: "Пользовательский тип кривой траектории",
  T_48_META_TYP_433_I0: "Линейный",
  T_48_META_TYP_433_I1: "Плавный",
  T_48_META_TYP_433_I2: "Пользовательский",
  T_48_META_TYP_434: "Пользовательский путь кривой",
  T_48_META_TYP_434_I2: "Закрытый Цикл",
  T_48_META_TYP_434_I3: "Точки Маршрута",
  T_48_META_TYP_437_I5: "Названия типа счета",
  T_48_META_TYP_437_I6: "Контент счета слева",
  T_48_META_TYP_437_I7: "Контент Правого Счета",
  T_48_META_TYP_438_I1: "Игроки",
  T_48_META_TYP_438_I2: "Ранги",
  T_48_META_TYP_438_I3: "Общий счет",
  T_48_META_TYP_438_I4: "Названия типа счета",
  T_48_META_TYP_438_I5: "Цвета",
  T_48_META_TYP_438_I6: "Счет",
  T_48_META_TYP_439: "Группа",
  T_48_META_TYP_442_I1: "Счет слева",
  T_48_META_TYP_442_I10: "Иконка устраненных справа",
  T_48_META_TYP_442_I2: "Правый счет",
  T_48_META_TYP_442_I3: "Количество в игре слева",
  T_48_META_TYP_442_I4: "Количество в игре справа",
  T_48_META_TYP_442_I5: "Количество устраненных слева",
  T_48_META_TYP_442_I6: "Количество устраненных справа",
  T_48_META_TYP_442_I7: "Левый значок игрока в игре",
  T_48_META_TYP_442_I8: "Правый значок игрока в игре",
  T_48_META_TYP_442_I9: "Иконка устраненных слева",
  T_48_META_TYP_444: "Тип Языка",
  T_48_META_TYP_444_I0: "Английский",
  T_48_META_TYP_444_I1: "Упрощенный Китайский",
  T_48_META_TYP_444_I10: "Французский",
  T_48_META_TYP_444_I11: "Немецкий",
  T_48_META_TYP_444_I12: "Турецкий",
  T_48_META_TYP_444_I13: "Хинди",
  T_48_META_TYP_444_I14: "Японский",
  T_48_META_TYP_444_I15: "Румынский",
  T_48_META_TYP_444_I16: "Арабский",
  T_48_META_TYP_444_I17: "Бирманский",
  T_48_META_TYP_444_I18: "Урду",
  T_48_META_TYP_444_I19: "Бенгальский",
  T_48_META_TYP_444_I2: "Традиционный Китайский",
  T_48_META_TYP_444_I3: "Тайский",
  T_48_META_TYP_444_I4: "Вьетнамский",
  T_48_META_TYP_444_I5: "Индонезийский",
  T_48_META_TYP_444_I6: "Португальский",
  T_48_META_TYP_444_I7: "Испанский",
  T_48_META_TYP_444_I8: "Русский",
  T_48_META_TYP_444_I9: "Корейский",
  T_48_SD_ERROR_DIVISOR: "Делитель не может быть 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "Указанный ключ не существует в карте: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Индекс списка вне диапазона: {0}",
  T_48_SD_SK_WARNING: "Не найдено {1} в {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: "Поскольку атрибут IsServerDriven контроллера персонажа Личного Острова {0} отключен, соответствующий API сервера не вступает в силу",
  T_48_XXJ_WS_PARENTERROR: "Не удалось установить родителя",
  T_48_XXJ_WS_PERFORMANCE: "Производительность",
  T_48_XXJ_WS_TANGENT: "Тангенс",
  T_48_XXJ_WS_WAYPOINT: "Точка маршрута",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Список Объектов",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Использовать Пользовательскую Мини-Карту",
  T_48_XYL_UGC_HIDEMINIMAP: "Скрыть HUD мини-карты",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Базовая пользовательская поверхность",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Вырез цилиндра",
  T_48_XYL_WS_BASICHEMISPHERE: "Основное полушарие",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Четверть тора",
  T_48_XYL_WS_BASICQUARTERTORUS: "Четверть квадратного тора",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Тор",
  T_48_XYL_WS_BASICTRIANGLE: "Треугольная поверхность",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Игроки матча = Количество команд x Количество игроков в команде. Чем больше игроков в матче, тем больше время подбора",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Большое количество игроков может привести к увеличению времени подбора соперника",
  T_49_HL_CL_CREATOR_LABEL2: "Талант Сообщества Личного Острова",
  T_49_HL_CL_MAPS_LABEL2: "Победитель Карты",
  T_49_HL_CL_MAPS_LABEL3: "Победитель Геймплея",
  T_49_HX_T_TUNG: "Тун Тун Тун",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Траектория",
  T_49_JH_WS_SKILLKASSIE: "Электротерапия (Кэсси)",
  T_49_JH_WS_SKILLKODA: "Зрение Авроры (Кода)",
  T_49_JH_WS_SKILLOSCAR: "Доблестный рывок (Оскар)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Генерация с ИИ",
  T_49_META_API_10065: "Переключить пользовательскую камеру",
  T_49_META_API_10067: "Получить текущую пользовательскую камеру",
  T_49_META_API_10069: "Создать Настраиваемую Камеру",
  T_49_META_API_10070: "Установить пользовательскую маску отбраковки камер",
  T_49_META_API_10070_D: "Установить маску отбраковки целевой камеры для управления видимостью на всех слоях",
  T_49_META_API_10071: "Получить пользовательскую маску отбраковки камер",
  T_49_META_API_10071_D: "Получить маску отбраковки целевой камеры",
  T_49_META_API_10072: "Установить пользовательский слой маски отбраковки камеры",
  T_49_META_API_10072_D: "Установить видимость целевой камеры для определенного слоя",
  T_49_META_API_10073: "Сделать снимок экрана",
  T_49_META_API_10073_D: "Сделать снимок экрана (для внутреннего тестирования)",
  T_49_META_API_106: "Получить временную метку сервера (мс)",
  T_49_META_API_106_D: "Получите временную метку сервера с точностью до миллисекунды",
  T_49_META_API_107: "Временная метка для локализованной строки (мс)",
  T_49_META_API_107_D: "Преобразовать временные метки (в мс) в строки на основе определенных форматов",
  T_49_META_API_107_P0: "Временная метка (мс)",
  T_49_META_API_107_P0_D: "Временная метка в миллисекундах",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Выполнить линейную интерполяцию из 3D-вектора A в вектор B",
  T_49_META_API_1089_P2: "ID запроса",
  T_49_META_API_109: "Обновить контекст до Персоны",
  T_49_META_API_109_D: "Обновить контекст модели указанной персоны в текущей комнате и перезаписать исходный контекст после выполнения. Контекст будет влиять на интерпретацию персоной фона, истории или определенных параметров текущего диалога.",
  T_49_META_API_109_P1: "Контекст",
  T_49_META_API_109_P1_D: "Подробности контекста",
  T_49_META_API_110: "Обратная связь об ответе Персоны",
  T_49_META_API_110_D: "Отправьте отзыв о содержании ответа персоны, который будет использован для оптимизации нашей модели.",
  T_49_META_API_110_P1: "Нравится",
  T_49_META_API_110_P1_D: "Нравится ответ или нет. Правда = нравится.",
  T_49_META_API_1109: "Установить позицию локального игрока",
  T_49_META_API_1109_D: "Когда игрок использует классических игровых персонажей, этот API может установить позицию игрока.",
  T_49_META_API_1109_P0_D: "Целевая позиция",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Выполнить сферическую интерполяцию из 3D-вектора A в вектор B для плавного вращения",
  T_49_META_API_1110: "Установить локального игрока вперед",
  T_49_META_API_1110_D: "Когда игрок использует классических игровых персонажей, этот API может задать направление взгляда игрока.",
  T_49_META_API_1110_P0_D: "Прямой вектор",
  T_49_META_API_112: "Откатить память Персоны",
  T_49_META_API_112_D: "Откатить память персоны до определенного идентификатора ответа. Вся память диалогов, включая и после ответа, будет очищена.",
  T_49_META_API_113: "Воспроизвести одноразовый звук",
  T_49_META_API_113_D: "Воспроизведение однократного звукового эффекта с регулируемой громкостью",
  T_49_META_API_113_P0_D: "ID ресурса звукового эффекта, который будет воспроизведен",
  T_49_META_API_113_P1: "Звук",
  T_49_META_API_113_P1_D: "Громкость воспроизведения звукового эффекта в диапазоне от 0 до 1.",
  T_49_META_API_97: "Создать контроллер просмотра на часть скелета",
  T_49_META_API_97_D: "После создания сущности контроллера просмотра части скелета вы можете использовать эту сущность для управления указанной частью скелета и заставить ее всегда быть обращенной к определенной цели.",
  T_49_META_API_97_P0_D: "Скелетная часть просмотра контроллера сущности. Если сущность будет уничтожена, функциональность look-at прекратится.",
  T_49_META_API_97_P1_D: "Часть скелета, которая контролируется",
  T_49_META_API_97_P2_D: "Цель, на которую смотрят",
  T_49_META_API_98: "Проекция",
  T_49_META_API_98_D: "Вычислить проекцию вектора А на вектор В",
  T_49_META_API_99: "Получить локальную временную метку (мс)",
  T_49_META_API_99_D: "Получите локальную временную метку с точностью до миллисекунды",
  T_49_META_EVT_16_P1_D: "Начиная с 0, каждый исходящий запрос будет использовать последовательный числовой ID, например, для создания комнаты и очистки памяти.",
  T_49_META_EVT_16_P2: "ID ответа",
  T_49_META_EVT_16_P2_D: "Каждый полный ответ будет иметь уникальный идентификатор.",
  T_49_META_TYP_122_I19: "Индивидуальный материал",
  T_49_META_TYP_122_I19_D: "Разрешить замену скайбокса на индивидуальный материал",
  T_49_META_TYP_14_I78_D: "Получить или задать сущность камеры, которая в данный момент визуализирует сцену на клиенте проигрывателя. Примечание: сущность камеры по сути представляет собой данные конфигурации для управления камерой на стороне клиента.",
  T_49_META_TYP_335_I9: "Прошедшее время (мс)",
  T_49_META_TYP_335_I9_D: "Длительность воспроизведения звукового эффекта в миллисекундах. Это свойство доступно только на стороне клиента.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "ID игры",
  T_49_META_TYP_445: "ID игрового контроллера",
  T_49_META_TYP_446: "Подключаемый игровой контроллер",
  T_49_META_TYP_446_I0: "Игровой контроллер",
  T_49_META_TYP_447: "Контроллер части скелета",
  T_49_META_TYP_448: "Контроллер просмотра деталей скелета",
  T_49_META_TYP_448_I0: "Управляемая цель",
  T_49_META_TYP_448_I1: "Просмотр цели",
  T_49_META_TYP_449: "Настраиваемая Камера",
  T_49_META_TYP_449_I2: "Орфографический размер",
  T_49_META_TYP_449_I2_D: "Управляйте размером области, видимой камерой",
  T_49_META_TYP_450: "Локализованная строка метки времени (мс)",
  T_49_META_TYPE_449_D: "Пользовательская камера полностью контролируется разработчиком и определяет, что видит игрок во время игры.",
  T_49_META_TYPE_450_D: "Форматировать временную метку на уровне миллисекунд в читаемый текстовый формат",
  T_49_SD_SEARCH_ICONDESC: "Умная ассоциация",
  T_49_SD_SEARCHKEY_ACTION: "Действие",
  T_49_SD_SEARCHKEY_ANICLIPID: "ID анимации клипа",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "ID Обвеса",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Тип звуковых эффектов",
  T_49_SD_SEARCHKEY_BAGSKINID: "ID скина рюкзака",
  T_49_SD_SEARCHKEY_BEZIER: "Кривая Безье",
  T_49_SD_SEARCHKEY_BOOL: "Булево",
  T_49_SD_SEARCHKEY_BREAK: "Прерывание",
  T_49_SD_SEARCHKEY_BTREEID: "ID Дерева Поведения",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "При нажатии кнопки",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "При двойном нажатии кнопки",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "При нажании кнопки",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "При отпуске кнопки",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Тип костюма",
  T_49_SD_SEARCHKEY_COLOR: "Цвет",
  T_49_SD_SEARCHKEY_COMMENT: "Комментирование",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Перечисление компонента",
  T_49_SD_SEARCHKEY_CONCANT: "Соединить",
  T_49_SD_SEARCHKEY_CONTINUE: "Продолжить",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Пользовательский HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Пользовательский виджет HUD",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "динамическое создание уровня типа объекта",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Тип визуальных эффектов",
  T_49_SD_SEARCHKEY_ENTITY: "Выбрать объект сцены",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "Для индекса",
  T_49_SD_SEARCHKEY_FOREACH: "Для каждого",
  T_49_SD_SEARCHKEY_FUNCTION: "Функция",
  T_49_SD_SEARCHKEY_GETCSV: "Получить CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Получить зарегистрированный ассет по ключу",
  T_49_SD_SEARCHKEY_GETVALUE: "Получить значение свойства",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Получить Глобальную Переменную",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Установить Глобальную Переменную",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Тип Спрайта",
  T_49_SD_SEARCHKEY_INT: "Целое",
  T_49_SD_SEARCHKEY_INTERNALHUD: "Тип HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "Тип предмета",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Добавить список",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Добавить диапазон списка",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Очистить список",
  T_49_SD_SEARCHKEY_LISTCLONE: "Список клонов",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Содержание списка",
  T_49_SD_SEARCHKEY_LISTCREATE: "Создать список",
  T_49_SD_SEARCHKEY_LISTDELETE: "Удалить список",
  T_49_SD_SEARCHKEY_LISTGET: "Получить список",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Список индексов",
  T_49_SD_SEARCHKEY_LISTINSERT: "Ввод списка",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Список последних индексов",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Длина списка",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Реверсировать список",
  T_49_SD_SEARCHKEY_LISTSET: "Установить список",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Перетасовка списка",
  T_49_SD_SEARCHKEY_LOCALKEY: "Локализован. контент",
  T_49_SD_SEARCHKEY_LOCALVAR: "Локальная переменная",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Советы по печати",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "получить все ключи словаря получить все ключи карты",
  T_49_SD_SEARCHKEY_MAPCLEAR: "очистить словарь очистить карту",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "ключи словаря ключи карты",
  T_49_SD_SEARCHKEY_MAPCREATE: "создать словарь создать карту",
  T_49_SD_SEARCHKEY_MAPGET: "получить значение словаря по ключу получить значение карты по ключу",
  T_49_SD_SEARCHKEY_MAPLENGTH: "длина словаря длина карты",
  T_49_SD_SEARCHKEY_MAPREMOVE: "удалить словарь удалить карту",
  T_49_SD_SEARCHKEY_MAPSET: "установить значение словаря установить значение карты",
  T_49_SD_SEARCHKEY_MATH: "складывать вычитать умножать делить",
  T_49_SD_SEARCHKEY_NEWLIST: "Новый список",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Число в строку",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Свойства частиц",
  T_49_SD_SEARCHKEY_PERSONA: "Персона",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ID данных игрока",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Тип навыка персонажа",
  T_49_SD_SEARCHKEY_PREEFFECT: "Специальный тип стикера",
  T_49_SD_SEARCHKEY_PREFAB: "Префаб",
  T_49_SD_SEARCHKEY_RAWID: "Исходный ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Прочитать накопленные данные",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "UUID ресурса",
  T_49_SD_SEARCHKEY_RETURN: "Возврат",
  T_49_SD_SEARCHKEY_SCENEENUM: "Файл сцены",
  T_49_SD_SEARCHKEY_SCRIPTID: "Скрипт",
  T_49_SD_SEARCHKEY_SETVALUE: "Установить значение свойства",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Тип ID специального предмета",
  T_49_SD_SEARCHKEY_TEXT: "Текст",
  T_49_SD_SEARCHKEY_TEXTUREID: "Тип текстуры",
  T_49_SD_SEARCHKEY_THISENTITY: "Эта Сущность",
  T_49_SD_SEARCHKEY_TIMELINE: "Временная шкала",
  T_49_SD_SEARCHKEY_TYPEENUM: "Любой тип",
  T_49_SD_SEARCHKEY_V2VCREATE: "Создать Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Получить Vector2 компоненты",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Операция Vector2 сложение вычитание умножение скалярное произведение расстояние угол",
  T_49_SD_SEARCHKEY_V2VSET: "Установить Vector2 компоненты",
  T_49_SD_SEARCHKEY_V3VCREATE: "Создать Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Получить Vector3 компоненты",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Операция Vector3 сложение вычитание умножение скалярное произведение векторное произведение расстояние угол",
  T_49_SD_SEARCHKEY_V3VSET: "Установить Vector3 компоненты",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ID скина транспорта",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "ID оружейного скина",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Запись накопленного смещения базы данных",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Запись накопл. смещения базы данных по коду карты",
  T_49_XXJ_WS_DURATIONS: "Продолжительность (cек.)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Редактировать игру",
  T_49_XXJ_WS_PERFORMANCE: "Производительность",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Удалить игру",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Удаленная игра не может быть восстановлена, продолжить?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Редактирование {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Это имя уже используется, измените и попробуйте еще раз",
  T_49_XXJ_WS_PERFORMANCENAME: "Название Игры",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Добавить Ключевой Кадр",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Добавить Суб-Трак",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Добавить Трак",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Удалить Трак",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Трак Актора",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Трак События",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Ключевой кадр уже существует",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "Соответствующий трек актора уже существует",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Контент",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Обнаружены дубликаты названий траков. Измените их и попробуйте еще раз",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Пожалуйста, начните запись или сначала выберите ключевой кадр",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Запись...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Удалить ключевой кадр",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Вид сцены",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Выберите объект для создания трека или нажмите кнопку Добавить трек напрямую",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Нажмите кнопку Добавить трек, чтобы создать новый трек",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Суб-Трак",
  T_49_XXJ_WS_TIMELINE_TRACK: "Трак",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Просмотр трека",
  T_49_XYL_WS_DAILYPROPS: "Основное",
  T_49_XYL_WS_STOREGAMPLAY: "Геймплей",
  T_49_YU_QCITEM_ALL_11: "Тун Тун Тун Сахур!",
  T_50_H_M4A1_VA_N: "M4A1 - Академия Суматохи",
  T_50_H_MACHETE_VA_N: "Паранг - Академия Суматохи",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Поля таблицы лидеров",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Переполнение",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Обернуть вокруг",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Уменьшить шрифт",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Создать кортеж",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Получить кортеж",
  T_50_HJ_SEARCHKEY_TUPLESET: "Установить кортеж",
  T_50_HJ_TEXTOBGJ_H: "Высота",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Параметры переполнения",
  T_50_HJ_TEXTOBGJ_W: "Ширина",
  T_50_HZY_REVIEW_TEXTOBJ: "Содержимое текстового объекта",
  T_50_JH_WS_HIDEMAPERROR: "Невозможно скрыть мини-карту без пользовательского изображения обложки",
  T_50_JH_WS_HIDEMAPTIP: "Когда мини-карта скрыта, она больше не будет использоваться в качестве обложки",
  T_50_JH_WS_HIDEMINIMAP: "Скрыть мини-карту",
  T_50_META_API_10073_P0: "Название Файла",
  T_50_META_API_10073_P0_D: "Имя файла",
  T_50_META_API_10073_P1_D: "Результат выполнения. Проверьте перечисление Кода Статуса.",
  T_50_META_API_1102: "Прочитать значение столбца листа базы данных",
  T_50_META_API_1102_D: "Прочитать значение определенного столбца для заданного ключа из стандартной таблицы базы данных",
  T_50_META_API_1102_P3: "Индекс столбца",
  T_50_META_API_1102_P3_D: "Индекс столбца таблицы базы данных (0 = первый столбец)",
  T_50_META_API_1106: "Создать производ.",
  T_50_META_API_1106_D: "Создать сущность производительности",
  T_50_META_API_1106_P0_D: "Ассет производительности",
  T_50_META_API_1111: "Прочитать значение базы данных таблицы лидеров",
  T_50_META_API_1111_D: "Прочитать комбинацию значений из таблицы лидеров и связанной с ней таблицы в базе данных",
  T_50_META_API_1111_P5: "Код статуса ассоциации",
  T_50_META_API_1111_P5_D: "Код ошибки ассоциации",
  T_50_META_API_1112: "Прочитать базу данных таблицы лидеров значений ассоциации",
  T_50_META_API_1112_D: "Считать значения из таблицы лидеров в указанном диапазоне рангов, считывает соответствующие значения по извлеченным ключам из связанной таблицы и объединяет их.",
  T_50_META_API_1112_P6: "Код статуса ассоциации",
  T_50_META_API_1112_P6_D: "Код ошибки ассоциации",
  T_50_META_API_1113: "Запись базы данных таблицы лидеров значений ассоциации",
  T_50_META_API_1113_D: "Запиcать значение для данного ключа в таблицу лидеров и связанную с ней таблицу в базе данных",
  T_50_META_API_1113_P5: "Код статуса ассоциации",
  T_50_META_API_1113_P5_D: "Код ошибки ассоциации",
  T_50_META_API_114_D: "Создать пользовательский интерфейс",
  T_50_META_API_114_P0_D: "Код используется в качестве имени параметра для создания сущности пользовательского интерфейса, а соответствующее ему значение локальной переменной представляет созданную сущность пользовательского интерфейса.",
  T_50_META_API_114_P1_D: "Сущность игрока, которой принадлежит объект, видимая только игроку",
  T_50_META_API_114_P2: "ID ассета UI",
  T_50_META_API_114_P2_D: "Ассет ID пользовательского UI",
  T_50_META_API_115_D: "Создать указанный пользовательский интерфейс",
  T_50_META_API_116: "Установить основные моменты объекта ур.",
  T_50_META_API_116_D: "Устанавливает статус подсветки объекта. На него может влиять другая игровая логика.",
  T_50_META_API_116_P0_D: "Целевой объект",
  T_50_META_API_116_P1_D: "Статус основных моментов",
  T_50_META_API_117: "Побитовый общий",
  T_50_META_API_117_D: "Побитовое и/или/исключающее ИЛИ/сдвиг влево/сдвиг вправо",
  T_50_META_API_117_P0_D: "Левое значение",
  T_50_META_API_117_P1_D: "Правое значение",
  T_50_META_API_117_P2_D: "Тип операции",
  T_50_META_API_118: "Не побитовое",
  T_50_META_API_118_D: "Побитовое НЕТ, также известное как побитовое дополнение.",
  T_50_META_API_118_P0_D: "Значение",
  T_50_META_API_119: "Побитовый список в Int",
  T_50_META_API_119_D: "Выполнить побитовую операцию ИЛИ над всеми элементами списка и преобразовать вывод в целое значение.",
  T_50_META_API_119_P0: "Битовый массив",
  T_50_META_API_119_P0_D: "Побитовый массив",
  T_50_META_API_120: "Побитовое преобразование Int в список",
  T_50_META_API_120_D: "Преобразовать десятичные значения, представленные битами в позиции 1 целого числа в его двоичной форме, в список",
  T_50_META_API_120_P0_D: "Целое",
  T_50_META_API_121: "Угол кватерниона",
  T_50_META_API_121_D: "Вычислить угол между двумя кватернионами",
  T_50_META_API_121_P0_D: "Кватернион 1",
  T_50_META_API_121_P1_D: "Кватернион 2",
  T_50_META_API_122: "Кватернионная точка",
  T_50_META_API_122_D: "Вычислить скалярное произведение двух кватернионов",
  T_50_META_API_123: "Обратный кватернион",
  T_50_META_API_123_D: "Вычислить обратный кватернион",
  T_50_META_API_123_P0_D: "Кватернион",
  T_50_META_API_124: "Кватернион От К Вращению",
  T_50_META_API_124_D: 'Вычислить кватернион вращения от "от" до "до"',
  T_50_META_API_124_P0_D: "Начальная точка",
  T_50_META_API_124_P1_D: "Конечная точка",
  T_50_META_API_125: "Вращение кватерниона в направл.",
  T_50_META_API_125_D: 'Рассчитайте кватернион поворота от точки "от" до точки "до". Макс. дельта градусов — это максимальный угол поворота.',
  T_50_META_API_125_P0: "От",
  T_50_META_API_125_P0_D: "Начальный кватернион",
  T_50_META_API_125_P1: "К",
  T_50_META_API_125_P1_D: "Целевой кватернион",
  T_50_META_API_125_P2: "Дельта макс. градуса",
  T_50_META_API_125_P2_D: "Макс. угол поворота",
  T_50_META_API_126: "Получить ориентацию гироскопа",
  T_50_META_API_126_D: "Ориентация устройства в трехмерном пространстве, представляющая собой углы поворота вокруг трех осей.",
  T_50_META_API_127: "Получить гравитацию гироскопа",
  T_50_META_API_127_D: "Компонент гравитации, обнаруженный датчиком вашего устройства",
  T_50_META_API_128: "Получить скорость вращения гироскопа",
  T_50_META_API_128_D: "Это относится к скорости вращения устройства. Этот термин относится к датчикам гироскопа и описывает скорость вращения устройства в трёхмерном пространстве.",
  T_50_META_API_129: "Получить вращение гироскопа беспристрастным",
  T_50_META_API_129_D: "Описывает скорость вращения устройства и обеспечивает более точный результат за счет компенсации шума или смещения датчиков устройства.",
  T_50_META_API_130: "Получить ускорение пользователя гироскопа",
  T_50_META_API_130_D: "Часть ускорения устройства без учета гравитационного компонента, то есть ускорения, вызванного действиями пользователя или внешними силами.",
  T_50_META_API_131: "Получить информацию о нажатии",
  T_50_META_API_131_D: "Получить указанную индексную информацию о касании экрана (включая положение, смещение и время изменения).",
  T_50_META_API_131_P0_D: "Распределить идентификаторы точек касания, начиная с 0",
  T_50_META_API_131_P1_D: "Позиция касания",
  T_50_META_API_131_P2: "Дельта-позиция",
  T_50_META_API_131_P2_D: "Сдвиг положения по сравнению с последним кадром",
  T_50_META_API_131_P3: "Дельта Времени",
  T_50_META_API_131_P3_D: "Время, прошедшее с момента последнего кадра",
  T_50_META_API_132: "Получить количество касаний экрана",
  T_50_META_API_132_D: "Получить текущее количество точек касания на экране",
  T_50_META_API_133: "Вибрация устройства",
  T_50_META_API_133_D: "Заставить устройство вибрировать один раз",
  T_50_META_API_134_D: "Уведомить целевое устройство проигрывателя о необходимости воспроизведения звука",
  T_50_META_API_134_P0_D: "Целевой игрок",
  T_50_META_API_134_P1_D: "Ассет аудио",
  T_50_META_API_134_P2_D: "Скорость воспроизведения (допустимый диапазон: 0,1~3,0; 1 = нормальная, <1 = замедленная, >1 = ускоренная)",
  T_50_META_API_135_D: "Воспроизвести одноразовый аудиофайл",
  T_50_META_API_135_P0_D: "Аудио ресурсы",
  T_50_META_API_135_P1_D: "Скорость игры",
  T_50_META_API_136: "Формат строки",
  T_50_META_API_136_D: "Формат строк",
  T_50_META_API_136_P0_D: "Форматированные строки, использующие элементы управления глаголами форматирования Go",
  T_50_META_API_136_P1: "Массив параметров",
  T_50_META_API_136_P1_D: "Список параметров",
  T_50_META_API_137: "Вставить компонент",
  T_50_META_API_137_D: "Копировать или добавить данные компонента",
  T_50_META_API_137_P0: "Источник",
  T_50_META_API_137_P0_D: "Исходный объект",
  T_50_META_API_137_P1_D: "Целевая Сущность",
  T_50_META_API_137_P2: "Тип Компонента",
  T_50_META_API_137_P2_D: "Тип компонента",
  T_50_META_API_137_P3: "Успешно",
  T_50_META_API_137_P3_D: "Успешно или нет",
  T_50_META_API_138: "Возродить в след. кадре",
  T_50_META_API_138_D: "Возродить в следующем кадре",
  T_50_META_API_139: "Устранить на след. кадре",
  T_50_META_API_139_D: "Устранить боевую сущность в следующем кадре",
  T_50_META_API_139_P0_D: "Боевая Сущность",
  T_50_META_API_140: "Выйти из игры на след. кадре",
  T_50_META_API_140_D: "Выйти из игры на следующем кадре",
  T_50_META_API_141: "Получить громкость микрофона",
  T_50_META_API_141_D: "Получить уровень громкости микрофона. Возвращает статус, если микрофон игрока выключен или доступ к нему запрещён.",
  T_50_META_API_141_P0: "Громкость",
  T_50_META_API_141_P0_D: "Громкость микрофона",
  T_50_META_API_141_P1_D: "Микрофон включен или выключен",
  T_50_META_API_142: "Получить качество рендеринга",
  T_50_META_API_142_D: "Получить текущее качество рендеринга (перечисление: Низкое/Среднее/Высокое/Ультра)",
  T_50_META_API_143: "Получить разрешение рендеринга",
  T_50_META_API_143_D: "Получить текущее разрешение рендеринга",
  T_50_META_API_144: "Привязать пользоват. игрока",
  T_50_META_API_144_D: "Динамически задаёт цель, к которой привязывается этот игрок, переопределяя существующие привязки. Возвращает false в случае неудачи.",
  T_50_META_API_144_P0: "Пользовательский игрок",
  T_50_META_API_144_P0_D: "После привязки этого пользовательского игрока такие данные, как положение и направление, будут автоматически синхронизированы",
  T_50_META_API_144_P1_D: "Целевой игрок",
  T_50_META_API_145: "Отвязать пользоват. игрока",
  T_50_META_API_145_D: "Отменить привязку. Возвращает false в случае неудачи.",
  T_50_META_API_145_P0: "Пользовательский игрок",
  T_50_META_API_145_P0_D: "Очистить все привязки для этой цели. После отмены привязки такие данные, как местоположение и направление, больше не будут автоматически синхронизироваться.",
  T_50_META_API_146_P0_D: "Пользовательский игрок",
  T_50_META_API_147: "Установить пользоват. состояние игрока",
  T_50_META_API_147_D: "Автоматическая загрузка на сервер и синхронизация со всеми клиентами. Возвращает false в случае неудачи.",
  T_50_META_API_147_P0: "Пользовательский игрок",
  T_50_META_API_147_P1: "Состояние",
  T_50_META_API_147_P1_D: "Обычно используется для сохранения состояний анимации. Чтобы получить синхронизированное состояние, используйте функцию Пользовательского Состояния Игрока",
  T_50_META_API_148: "Получить пользоват. состояние игрока",
  T_50_META_API_148_D: "Данные о состоянии автоматически синхронизируются с сервером. Возвращает false в случае неудачи.",
  T_50_META_API_148_P0: "Пользовательский игрок",
  T_50_META_API_148_P1: "Состояние",
  T_50_META_API_148_P1_D: "Установить состояние с помощью команды Состояния Пользовательского Игрока",
  T_50_META_API_149: "Установить расстояние объемов",
  T_50_META_API_149_D: "Установите диапазоны расстояний между игроками для динамической настройки громкости звука.",
  T_50_META_API_149_P0: "Список расстояний",
  T_50_META_API_149_P0_D: "Список диапазонов расстояний, каждый из которых соответствует элементу в списке объемов.",
  T_50_META_API_149_P1: "Список громкости",
  T_50_META_API_149_P1_D: "Список томов, каждый из которых соответствует элементу в списке расстояний.",
  T_50_META_API_150: "Найди друзей",
  T_50_META_API_150_D: "Получить список идентификаторов друзей игрока",
  T_50_META_API_151: "Получить информацию про UI по умолчанию",
  T_50_META_API_151_D: "Получить местоположение пользовательского интерфейса игрока по умолчанию",
  T_50_META_API_151_P0_D: "Интерфейс по умолчанию",
  T_50_META_API_151_P1_D: "Статус",
  T_50_META_API_151_P2_D: "Позиция UI",
  T_50_META_API_151_P3: "Размер",
  T_50_META_API_151_P3_D: "Размер UI",
  T_50_META_API_152: "Трансляция пользоват. события",
  T_50_META_API_152_D: "Транслировать пользовательское событие, чтобы любой субъект мог получить (прослушать) это событие",
  T_50_META_API_153: "Отправка события сущности",
  T_50_META_API_153_D: "Отправка пользоват. события целевому объекту",
  T_50_META_EVT_17: "Начало нажатия на экран",
  T_50_META_EVT_17_D: "Запустить событие при касании экрана",
  T_50_META_EVT_17_P0: "Сенсорный индекс",
  T_50_META_EVT_17_P0_D: "Индекс точки касания",
  T_50_META_EVT_17_P1_D: "Положение касания",
  T_50_META_EVT_18: "Завершение нажатия на экран",
  T_50_META_EVT_18_D: "Завершение события при касании экрана",
  T_50_META_EVT_18_P0: "Индекс касания",
  T_50_META_EVT_18_P0_D: "Индекс точки касания",
  T_50_META_EVT_18_P1_D: "Позиции касания на экране",
  T_50_META_EVT_19: "При получении результата создания комнаты персоны",
  T_50_META_EVT_19_D: "Получить соответствующий результат, если не удалось создать чат-комнату персоны",
  T_50_META_EVT_19_P1: "ID комнаты",
  T_50_META_EVT_19_P1_D: "ID комнаты",
  T_50_META_EVT_20: "При выходе пользователя или завершении матча пользователя",
  T_50_META_EVT_20_D: "Срабатывает, когда игрок выходит из матча или когда матч заканчивается",
  T_50_META_TYP_11_I44: "Объем расстояния",
  T_50_META_TYP_11_I44_D: "Динамическое регулирование громкости звука в зависимости от расстояния между игроками",
  T_50_META_TYP_22_I9_D: "Идентификатор актива, используемый для создания пользовательского интерфейса",
  T_50_META_TYP_244_I12_D: "Ширина текстового поля",
  T_50_META_TYP_244_I13_D: "Высота текстового поля",
  T_50_META_TYP_244_I14_D: "Тип переполнения",
  T_50_META_TYP_335_I10_D: "Скорость воспроизведения (допустимое значение > 0, по умолчанию = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "Операция ввода-вывода не выполнена: произошла ошибка при создании файла.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "Ошибка операции ввода-вывода. Неверное имя файла.",
  T_50_META_TYP_448_I0_D: "Управляемая часть скелета",
  T_50_META_TYP_448_I1_D: "Цель, на которую смотрит скелетная часть",
  T_50_META_TYP_451: "Тип переполнения",
  T_50_META_TYP_451_D: "Метод обработки переполнения текста",
  T_50_META_TYP_452: "ID ассета пользоват. UI",
  T_50_META_TYP_452_D: "Идентификатор, описывающий пользовательский ассет HUD",
  T_50_META_TYP_453: "Тип качества рендера",
  T_50_META_TYP_453_D: "Перечисление качества рендеринга",
  T_50_META_TYPE_448_D: "Эта сущность используется для управления скелетной частью, чтобы смотреть на цель",
  T_50_SD_WS_MAPTAG_AI3DGEN: "Генерация карты (3D-объект)",
  T_50_SD_WS_MAPTAG_AIRACING: "ИИ генерация карты (гонка)",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Имя состояния анимации перечисление",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Отключить вибрацию шагов",
  T_50_XXJ_WS_NOPERFORMANCE: "Файла производительности пока нет",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Бета версия",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Уважаемые создатели, редактор производительности всё ещё находится на стадии тестирования. Он может содержать ошибки или не иметь необходимых функций. Пожалуйста, используйте его с осторожностью.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Добавить производительность",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Добавить зажим для ключей",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Трек вдоль пути",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Анимация",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Трек анимации",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Аудио трек",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Держать",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Вечный цикл",
  T_50_XXJ_WS_TIMELINE_DURATION: "Продолжительность: {0}с",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Несоответствие между анимацией и моделью",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Перекрытие зажима ключа",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Связанная сущность отсутствует",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "Название трека не может быть пустым",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC трек",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Трек недвижимости",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Удалить зажим для ключей",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}с",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Превышен лимит количества треков",
  T_50_XYL_WS_AIGETERATESHOW: "Постройка Блоков",
  T_50_YU_F_B_VA_WITCH: "Мистическая Суматоха (Низ)",
  T_50_YU_F_H_VA_WITCH: "Мистическая Суматоха (Голова)",
  T_50_YU_F_HA_VA_WITCH: "Мистическая Суматоха (Грим)",
  T_50_YU_F_S_VA_WITCH: "Мистическая Суматоха (Обувь)",
  T_50_YU_F_T_VA_WITCH: "Мистическая Суматоха (Верх)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Пользовательское Событие",
  T_51_GT_WS_BASIC: "Базовый",
  T_51_GT_WS_GLOBALEVENT: "Глобальное событие",
  T_51_GT_WS_PRIVATEEVENT: "Приватное событие",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Время подготовки перед началом игры",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Свойство только для чтения",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Чёрная Кожаная Куртка (Жен.)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Охотница за грибами",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Тёмный Спринтер (Обувь)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Шортики GW2018 (жен.)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Юбка GW2018 (жен.)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Тёмный Спринтер (Худи)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Топ День Нептуна (жен.)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Рубашка сантехницы",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Майка GW2018 (жен.)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Белое Процветание (Низ)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Чёрные Спортивки (муж.)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Главрь Банды (Низ)",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Штаны Выжившего",
  TXT_AVATAR_MALE_PANTS_MARIO: "Мамамиа",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Обувь Выжившего",
  TXT_AVATAR_MALE_SHOE_RED: "Красная Обувь (муж.)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Белое Процветание (Верх)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Чёрная Бейсбольная Кофта (муж.)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Толстовка повстанца",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Крутой Спринтер (Худи)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Главарь Банды (Верх)",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Рубашка Выжившего",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Рубашка сантехника",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Гоночная Куртка (жен.)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Ночной Клоун (Голова)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Гоночная Куртка (муж.)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Жилетка (Зеленая)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Кальмарчик",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Зомби Самурай (Маска)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Татуировка на всю руку",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Объятие",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Виктория",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Ретро стиль",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Лиса",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Лисья обувь",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Спортивная обувь (синяя)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Шорты из денима (жен.)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Лисья Роба",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Боевые штаны (муж.)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Штаны Ангела",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Штаны Бусидо",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Худи с молнией (серая)",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Повседневная Обувь",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Обувь Бусидо (муж.)",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Обувь Астро",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Шорты из денима (муж.)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Боевой Жилет (муж.)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Костюм Знаменитости",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Костюм Воина Бусидо",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Шорты Белые",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Бейсбольное трико (жен.)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Мото-Куртка (жен.)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Бейсбольная Куртка (жен.)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Штаны Крутого Капитана (муж.)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Кепка Hip-Hop (муж.)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Обувь Капитана Команды (муж.)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Мото-Куртка (муж.)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Куртка Капитана Команды (муж.)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Динозавр (муж.)",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Серебряные Бутсы",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Английский Лев",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Смокинг (Маска)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Смокинг (Голова)",
  TXT_AVATAR_PARACHUTE_8: "Смайлик",
  TXT_AVATAR_SHIRT_PLAID_2: "Выбор программиста (Красная)",
  TXT_AVATAR_SHOES_1: "Сникеры (Белые)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Школьный топ (Бегония)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Школьный топ (Роза)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Школьный топ (Хризантема)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Школьный топ (Фиалка)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Школьный топ (Жасмин)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Школьный топ (Тёмный)",
  TXT_AVATAR_TSHIRT_WEEK_007: "Воскресенье",
  TXT_BANNER_NAME_MISHA: "Скорость",
  TXT_CHARACTER_ADAM_NAME: "Примий",
  TXT_CHARACTER_BODYGUARD_NAME: "Никита",
  TXT_CHARACTER_COP_NAME: "Эндрю",
  TXT_CHARACTER_EVA_NAME: "Уна",
  TXT_CHARACTER_NURSE_NAME: "Оливия",
  TXT_CHARACTER_RACERGIRL_NAME: "Лиза",
  TXT_CHARACTER_RUNNER_NAME: "Келли",
  TXT_CHARACTER_SEAMAN_NAME: "Форд",
  TXT_CLAN_NAME: "Название",
  TXT_COLLECTION_DESCRIPTION: "Описание",
  TXT_COLLECTION_HEADPORTRAIT: "Аватар",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Снаряжение",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "Автомат",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Рюкзак Ур.1",
  TXT_ITEM_BAG2: "Рюкзак Ур.2",
  TXT_ITEM_BAG3: "Рюкзак Ур.3",
  TXT_ITEM_BASEBALLPOLE: "Бита",
  TXT_ITEM_BOWAMMO: "Стрела",
  TXT_ITEM_CHANGUO: "Сковорода",
  TXT_ITEM_CROSSBOW: "Арбалет",
  TXT_ITEM_DESC_FLASH: "Временно дезориентирует противника.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Аптечка",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Кулак",
  TXT_ITEM_FLASH: "Светошумовая Граната",
  TXT_ITEM_FOREGRIP1: "Рукоятка Ур.1",
  TXT_ITEM_FOREGRIP2: "Рукоятка Ур.2",
  TXT_ITEM_FOREGRIP3: "Рукоятка Ур.3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Граната",
  TXT_ITEM_GROZA: "ГРОЗА",
  TXT_ITEM_HANDCANNON: "Ручная Пушка",
  TXT_ITEM_HEATSIGHT: "Тепловой Прицел",
  TXT_ITEM_HELMET1: "Шлем Ур.1",
  TXT_ITEM_HELMET2: "Шлем Ур.2",
  TXT_ITEM_HELMET3: "Шлем Ур.3",
  TXT_ITEM_HGAMMO: "Пистолет",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "Снаряд40мм",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Паранг",
  TXT_ITEM_MAGEZINE1: "Магазин Ур.1",
  TXT_ITEM_MAGEZINE2: "Магазин Ур.2",
  TXT_ITEM_MAGEZINE3: "Магазин Ур.3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Дуло Ур.1",
  TXT_ITEM_MUZZLE2: "Дуло Ур.2",
  TXT_ITEM_MUZZLE3: "Дуло Ур.3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "Дробовик",
  TXT_ITEM_SIGHT2: "2x Прицел",
  TXT_ITEM_SIGHT4: "4x Прицел",
  TXT_ITEM_SILENCER1: "Глушитель",
  TXT_ITEM_SKS: "СКС",
  TXT_ITEM_SMGAMMO: "ПП",
  TXT_ITEM_SNAMMO: "Патроны к Снайперке",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "СВД",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Бронежилет Ур.1",
  TXT_ITEM_VEST2: "Бронежилет Ур.2",
  TXT_ITEM_VEST3: "Бронежилет Ур.3",
  TXT_ITEM_VSS: 'VSS "Винторез"',
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Результат",
  TXT_MESSAGEBOX_ERROR: "Ошибка",
  TXT_OB10_HQW_ITEM_BIPOD: "Сошки",
  TXT_OB10_HQW_ITEM_M60: "М60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Бочка",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Мигель",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Безумный убийца",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Мексиканская жареная кукуруза",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Дальность взрыва",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Палач",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Мина",
  TXT_OB11_HQW_LANDMINE_DESC: "Мина, которую можно установить на земле. Внимание, не наступайте на неё!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Каролина",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Аплодисменты",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Даб",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Танец Цыплёнка",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Привет!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Провокация",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Когда в руках дробовик, скорость передвижения увеличивается на [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Ловкость",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Клыки Гепарда",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Футуристический",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Ремонтный Набор",
  TXT_OB5_HISTORY_HEADSHOOT: "Хэдшоты",
  TXT_OB5_HISTORY_LIVE: "Выживание",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Максим",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Уменьшает время активации аптечки и поедания грибов на [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Обжорство",
  TXT_OB7_ZC_CLAN_NICKNAME: "Ник",
  TXT_OB7_ZJS_HISTORY_TIME: "Время",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Костёр",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Молния",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Тимур",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Сила удара увеличена на [FFB300]{0}%[-]",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Неистовый Кулак",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Фиолетовые Луга",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Дезинтегратор",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Сухой",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Ангел с небес",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Снежный Барс",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "София",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Оружейная Королева",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Зелёная Звезда",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Стена",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Цифровой Камуфляж",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Кровавая Мэри",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Пустынный Охотник",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Синее Пламя",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Сиреневый Парад",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Течение Жизни",
  TXT_OB9_ZXR_M1873_NAME: "Глубокий Океан",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Рыба-Меч",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Пожинатель",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Сиреневый Кварц",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Сгоревшая Земля",
  TXT_OPTION_HIGH_BRIGHTNESS: "Ярко",
  TXT_PLAYER_RANK: "РАНГ",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Бермуды",
  TXT_SETTING_CHANGEWEAPON: "Кнопка быстрого переключения оружия",
  TXT_SETTING_OB4_NOTREAL: "Тёмные",
  TXT_SKILL_DESC_COP: "Потеря прочности брони уменьшена на [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "Скорость бега увеличена на [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Специалист По Броне",
  TXT_SKILL_NAME_NURSE: "Целебное Прикосновение",
  TXT_SKILL_NAME_RACERGIRL: "Форсаж",
  TXT_SKILL_NAME_RUNNER: "Рывок",
  TXT_SKILL_NAME_SEAMAN: "Железная Воля",
  TXT_TUTORIAL_HUD: "Интерфейс (HUD)",
  TXT_TUTORIAL_HUD_LABEL10: "Спринт",
  TXT_TUTORIAL_PICKUP_LABEL0: "Оружие",
  T_34_M_WS_VFXTYPE: "Тип VFX",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Цель атаки",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Тип интерфейса игрока UI",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Тип навыка монстра",
  T_45_META_WS_DESCRIPTIVECOLOR: "Описательный цвет",
  T_45_META_WS_GAMETIME: "Время игры",
  T_45_META_WS_PROPERTY: "Свойство",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Тип стиля кнопки",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Тип кнопки",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Ускорение",
  T_46_META_WS_A_ACCOUNTID: "ID аккаунта",
  T_46_META_WS_A_ACTIONTYPE: "Тип действия",
  T_46_META_WS_A_ACTIVE: "Активно",
  T_46_META_WS_A_ANGLE: "Угол",
  T_46_META_WS_A_ANY: "Любой",
  T_46_META_WS_A_APPEARANCEGROUP: "Группа внешнего вида",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Выражение утверждения",
  T_46_META_WS_A_ATTACHMENT: "Аксессуар",
  T_46_META_WS_A_ATTACHMENTS: "Список аксессуаров",
  T_46_META_WS_A_ATTACKABLE: "Доступен для атаки",
  T_46_META_WS_A_ATTACKER: "Атакующий",
  T_46_META_WS_A_ATTACKTARGET: "Цель атаки",
  T_46_META_WS_A_AUTOPLAY: "Автовоспроизведение",
  T_46_META_WS_A_AXIS: "Ось",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "База",
  T_46_META_WS_A_BOUNDTARGET: "Связанный объект",
  T_46_META_WS_A_BTREE: "Дерево поведения",
  T_46_META_WS_A_BUFF: "Бафф",
  T_46_META_WS_A_CAMERA: "Камера",
  T_46_META_WS_A_CAPICITY: "Вместимость",
  T_46_META_WS_A_CENTER: "Центр",
  T_46_META_WS_A_CHANGEROTATION: "Изменить вращение",
  T_46_META_WS_A_CHANNEL: "Канал",
  T_46_META_WS_A_CHASEENEMY: "Преследование врага",
  T_46_META_WS_A_CHILD: "Дочерний элемент",
  T_46_META_WS_A_COLOR: "Цвет",
  T_46_META_WS_A_COLUMN: "Столбец",
  T_46_META_WS_A_COLUMNNAME: "Название столбца",
  T_46_META_WS_A_COMEBACK: "Вернуться",
  T_46_META_WS_A_COMPONENT: "Компонент",
  T_46_META_WS_A_CONTENT: "Содержание",
  T_46_META_WS_A_COORDINATESYSTEM: "Система координат",
  T_46_META_WS_A_COUNT: "Количество",
  T_46_META_WS_A_COUNTS: "Количество",
  T_46_META_WS_A_CREATEDENTITY: "Созданная сущность",
  T_46_META_WS_A_CROSSPLATFORM: "Кросс-платформа",
  T_46_META_WS_A_CULLINGMASK: "Маска отсечения",
  T_46_META_WS_A_CURVE: "Кривая",
  T_46_META_WS_A_CUSTOMTAG: "Пользовательский тег",
  T_46_META_WS_A_CUTRADIUS: "Радиус отсечения",
  T_46_META_WS_A_DAMAGE: "Урон",
  T_46_META_WS_A_DAMAGESEGMENTS: "Сегменты урона",
  T_46_META_WS_A_DEGREE: "Градус",
  T_46_META_WS_A_DELTA: "Дельта",
  T_46_META_WS_A_DEPTH: "Глубина",
  T_46_META_WS_A_DESTVAL: "Конечное значение",
  T_46_META_WS_A_DIFFICULTY: "Сложность",
  T_46_META_WS_A_DIRECTION: "Направление",
  T_46_META_WS_A_DISABLE: "Отключен",
  T_46_META_WS_A_DISPLACEMENT: "Смещение",
  T_46_META_WS_A_DISTANCE: "Расстояние",
  T_46_META_WS_A_DIVINGMAXSPEED: "Максимальная скорость погружения",
  T_46_META_WS_A_DOTWEEN: "Применить интерполяцию",
  T_46_META_WS_A_DURATION: "Продолжительность (с)",
  T_46_META_WS_A_EMOTE: "Эмоция",
  T_46_META_WS_A_ENABLE: "Включить",
  T_46_META_WS_A_ENDAREACENTER: "Центр конечной области",
  T_46_META_WS_A_ENDAREARANGE: "Диапазон конечной области",
  T_46_META_WS_A_ENDPOSITION: "Конечная позиция",
  T_46_META_WS_A_ENDRANK: "Конечный ранг",
  T_46_META_WS_A_EQUIPMENTS: "Оборудование",
  T_46_META_WS_A_EVENTID: "ID события",
  T_46_META_WS_A_EXPONENT: "Показатель",
  T_46_META_WS_A_FACTION: "Фракция",
  T_46_META_WS_A_FACTORTYPE: "Тип фактора",
  T_46_META_WS_A_FILTERTYPE: "Тип фильтра",
  T_46_META_WS_A_FINALRADIUS: "Конечный радиус",
  T_46_META_WS_A_FINDVALUE: "Найти значение",
  T_46_META_WS_A_FIXEDRANGE: "Фиксированный диапазон",
  T_46_META_WS_A_FOLLOWTARGET: "Следовать за целью",
  T_46_META_WS_A_FONTCOLOR: "Цвет шрифта",
  T_46_META_WS_A_FONTSIZE: "Размер шрифта",
  T_46_META_WS_A_FOOTBALL: "Футбол",
  T_46_META_WS_A_FORCE: "Сила",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Принудительная высота парашюта",
  T_46_META_WS_A_FORCEMODE: "Режим силы",
  T_46_META_WS_A_FORWARD: "Направление",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID игры",
  T_46_META_WS_A_HALFEXTENTS: "Половина размера",
  T_46_META_WS_A_HEIGHT: "Высота",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Сегменты высоты",
  T_46_META_WS_A_HITDISTANCE: "Дистанция удара",
  T_46_META_WS_A_HITDISTANCES: "Ударные дистанции",
  T_46_META_WS_A_HITENTITIES: "Ударить по объектам",
  T_46_META_WS_A_HITENTITY: "Удар по объекту",
  T_46_META_WS_A_HITNORMAL: "Нормаль удара",
  T_46_META_WS_A_HITNORMALS: "Нормали удара",
  T_46_META_WS_A_HITPOINTS: "Ударные точки",
  T_46_META_WS_A_HITPOSITION: "Позиция удара",
  T_46_META_WS_A_INCLUDETRIGGER: "Включить триггер",
  T_46_META_WS_A_INDEX: "Индекс",
  T_46_META_WS_A_INDEXS: "Индексы",
  T_46_META_WS_A_INITIALVELOCITY: "Начальная скорость",
  T_46_META_WS_A_INITRADIUS: "Начальный радиус",
  T_46_META_WS_A_INWALLET: "Кошелек для ввода",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Нижняя граница столкновения",
  T_46_META_WS_A_ISEXIST: "Существует ли",
  T_46_META_WS_A_ISLOOP: "Зациклено",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Отображается на экране",
  T_46_META_WS_A_ISPAUSE: "Пауза",
  T_46_META_WS_A_ISSIDECOLLIDING: "Боковая граница столкновения",
  T_46_META_WS_A_ISSUCCESS: "Успешно ли",
  T_46_META_WS_A_ISTOPCOLLIDING: "Верхняя граница столкновения",
  T_46_META_WS_A_ITEM: "Предмет",
  T_46_META_WS_A_ITEMID: "ID предмета",
  T_46_META_WS_A_ITEMS: "Предметы",
  T_46_META_WS_A_ITEMTYPE: "Тип предмета",
  T_46_META_WS_A_JERSEYTYPE: "Тип фор",
  T_46_META_WS_A_KEEPVELOCITY: "Сохранить скорость",
  T_46_META_WS_A_KEY: "Ключ",
  T_46_META_WS_A_KEYCOLUMN: "Ключевой столбец",
  T_46_META_WS_A_KEYS: "Ключи",
  T_46_META_WS_A_LAYER: "Слой",
  T_46_META_WS_A_LAYERMASK: "Маска слоя",
  T_46_META_WS_A_LEFT: "Лево",
  T_46_META_WS_A_LEFTVALUE: "Левое значение",
  T_46_META_WS_A_LENGTH: "Длина",
  T_46_META_WS_A_LEVELOBJECT: "Объект уровня",
  T_46_META_WS_A_LOG: "Журнал",
  T_46_META_WS_A_LOOKATTARGET: "Смотри на цель",
  T_46_META_WS_A_LOOPTYPE: "Тип цикла",
  T_46_META_WS_A_MAINCOLOR1: "Основной цвет1",
  T_46_META_WS_A_MAINCOLOR2: "Основной цвет2",
  T_46_META_WS_A_MAPCODE: "Код карты",
  T_46_META_WS_A_MAPPEDPOSITION: "Отображаемая позиция",
  T_46_META_WS_A_MAX: "Максимум",
  T_46_META_WS_A_MAXDISPLACEMENT: "Макс. смещение",
  T_46_META_WS_A_MAXDISTANCE: "Максимальное расстояние",
  T_46_META_WS_A_MIN: "Минимум",
  T_46_META_WS_A_MISSIONID: "ID миссии",
  T_46_META_WS_A_MISSIONPROGRESS: "Прогресс миссии",
  T_46_META_WS_A_MODIFYTYPE: "Тип модификации",
  T_46_META_WS_A_MONEYTYPE: "Тип валюты",
  T_46_META_WS_A_MUST: "Обязательно",
  T_46_META_WS_A_NAME: "Имя",
  T_46_META_WS_A_NEWVALUE: "Новое значение",
  T_46_META_WS_A_NODE: "Узел",
  T_46_META_WS_A_NORMAL: "Норма",
  T_46_META_WS_A_NOT: "Не",
  T_46_META_WS_A_OBSERVER: "Наблюдатель",
  T_46_META_WS_A_OFFSET: "Смещение",
  T_46_META_WS_A_OLDVALUE: "Старое значение",
  T_46_META_WS_A_OPERATIOMETHOD: "Способ операции",
  T_46_META_WS_A_OPTIONS: "Опции",
  T_46_META_WS_A_OTHERCOLOR: "Другой цвет",
  T_46_META_WS_A_OUTFIT: "Наряд",
  T_46_META_WS_A_OUTFITS: "Наряды",
  T_46_META_WS_A_OUTWALLET: "Кошелек для вывода",
  T_46_META_WS_A_OWNER: "Владелец",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Максимальная скорость парашюта",
  T_46_META_WS_A_PARAMS: "Параметры",
  T_46_META_WS_A_PARENT: "Родитель",
  T_46_META_WS_A_PARENTWIDGET: "Родительский виджет",
  T_46_META_WS_A_PATH: "Путь",
  T_46_META_WS_A_PATHPOINTS: "Точки пути",
  T_46_META_WS_A_PHASEINDEX: "Индекс фазы",
  T_46_META_WS_A_PLATFORM: "Платформа",
  T_46_META_WS_A_PLAYER: "Игрок",
  T_46_META_WS_A_PLAYSPEED: "Скорость воспроизведения",
  T_46_META_WS_A_POSITION: "Позиция",
  T_46_META_WS_A_POSITIONS: "Позиции",
  T_46_META_WS_A_POSTION: "Позиция",
  T_46_META_WS_A_PREFAB: "Префаб",
  T_46_META_WS_A_PROPERTY: "Свойство",
  T_46_META_WS_A_PROPERTYID: "ID свойства",
  T_46_META_WS_A_PURSUITTARGET: "Цель преследования",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Радиус",
  T_46_META_WS_A_RANDOMDECAY: "Коэффициент случайного затухания",
  T_46_META_WS_A_RANDOMRANGE: "Случайный диапазон",
  T_46_META_WS_A_RANDOMRATIO: "Случайный коэффициент",
  T_46_META_WS_A_RANGE: "Диапазон",
  T_46_META_WS_A_RANK: "Ранг",
  T_46_META_WS_A_REALCOIN: "Реальная монета",
  T_46_META_WS_A_REALNUMBER: "Действительное число",
  T_46_META_WS_A_RESET: "Сброс",
  T_46_META_WS_A_RESOURCE: "Ресурс",
  T_46_META_WS_A_RESULT: "Результат",
  T_46_META_WS_A_RIGHT: "Право",
  T_46_META_WS_A_RIGHTVALUE: "Правое значение",
  T_46_META_WS_A_ROTATION: "Вращение",
  T_46_META_WS_A_ROW: "Строка",
  T_46_META_WS_A_SAMPLEPOINT: "Точка выборки",
  T_46_META_WS_A_SCALE: "Масштаб",
  T_46_META_WS_A_SCENEID: "Идентификатор сцены",
  T_46_META_WS_A_SCORE: "Оценка",
  T_46_META_WS_A_SCORENAME: "Название оценки",
  T_46_META_WS_A_SCREENPOSITION: "Позиция на экране",
  T_46_META_WS_A_SCRIPT: "Скрипт",
  T_46_META_WS_A_SEAT: "Сиденье",
  T_46_META_WS_A_SEP: "Разделитель",
  T_46_META_WS_A_SEPSTR: "Разделитель",
  T_46_META_WS_A_SHEETNAME: "Имя таблиц",
  T_46_META_WS_A_SHOPITEM: "Предмет магазина",
  T_46_META_WS_A_SHOWBACKGROUND: "Показать фон",
  T_46_META_WS_A_SHOWMATCHRESULT: "Показать результат игры",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Показать сообщение при отмене",
  T_46_META_WS_A_SKILL: "Навык",
  T_46_META_WS_A_SKILLS: "Навыки",
  T_46_META_WS_A_SKILLTARGET: "Цель навыка",
  T_46_META_WS_A_SKIN: "Скин Рюкзака",
  T_46_META_WS_A_SLOT: "Слот",
  T_46_META_WS_A_SRCVAL: "Исходное значение",
  T_46_META_WS_A_SRCVALUE: "Исходное значение",
  T_46_META_WS_A_STARTAREACENTER: "Центр начальной области",
  T_46_META_WS_A_STARTAREARANGE: "Диапазон начальной области",
  T_46_META_WS_A_STARTINDEX: "Начальный индекс",
  T_46_META_WS_A_STARTPOSITION: "Начальная позиция",
  T_46_META_WS_A_STARTRANK: "Начальный ранг",
  T_46_META_WS_A_STATE: "Состояние",
  T_46_META_WS_A_STATUS: "Статус",
  T_46_META_WS_A_STATUSCODE: "Код состояния",
  T_46_META_WS_A_STYLE: "Стиль",
  T_46_META_WS_A_SURFINGMAXSPEED: "Максимальная скорость серфинга",
  T_46_META_WS_A_TARGET: "Цель",
  T_46_META_WS_A_TARGETPOSITION: "Целевая позиция",
  T_46_META_WS_A_TEAMSEQ: "Последовательность команды",
  T_46_META_WS_A_THRESHOLD: "Порог",
  T_46_META_WS_A_TIMESTAMP: "Отметка времени",
  T_46_META_WS_A_TIPS: "Подсказки",
  T_46_META_WS_A_TITLE: "Заголовок",
  T_46_META_WS_A_TOKENCOUNT: "Количество",
  T_46_META_WS_A_TOKENID: "ID жетона",
  T_46_META_WS_A_TORQUE: "Крутящий момент",
  T_46_META_WS_A_TOUCHPOINT: "Точка касания",
  T_46_META_WS_A_TRANSITIONTIME: "Время перехода (мс)",
  T_46_META_WS_A_TRANSITIONTYPE: "Тип перехода",
  T_46_META_WS_A_TRIGGER: "Триггер",
  T_46_META_WS_A_TYPE: "Тип",
  T_46_META_WS_A_UI: "Интерфейс пользователя",
  T_46_META_WS_A_UIID: "ID UI",
  T_46_META_WS_A_UPWARD: "Вверх",
  T_46_META_WS_A_VALUE: "Значение",
  T_46_META_WS_A_VALUEA: "Значение A",
  T_46_META_WS_A_VALUEB: "Значение B",
  T_46_META_WS_A_VALUES: "Значения",
  T_46_META_WS_A_VALUET: "ValueT",
  T_46_META_WS_A_VALUETYPE: "Тип значения",
  T_46_META_WS_A_VEHICLE: "Транспортное средство",
  T_46_META_WS_A_VEHICLESKIN: "Скин транспортного средства",
  T_46_META_WS_A_VELOCITY: "Скорость",
  T_46_META_WS_A_VELOCITYXZ: "Скорость по XZ",
  T_46_META_WS_A_VELOCITYY: "Скорость по Y",
  T_46_META_WS_A_VISIBLE: "Видимый",
  T_46_META_WS_A_WAITTIME: "Время ожидания (с)",
  T_46_META_WS_A_WALLET: "Кошелек",
  T_46_META_WS_A_WEAPON: "Оружие",
  T_46_META_WS_A_WEAPONSKIN: "Скин оружия",
  T_46_META_WS_A_WIDGETID: "Идентификатор виджета",
  T_46_META_WS_A_WIDGETTYPE: "Тип виджета",
  T_46_META_WS_A_WIDTH: "Ширина",
  T_46_META_WS_A_WORLDPOSITION: "Позиция в мире",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Положение в мире остается",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Abs",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Добавить особое внимание AOI",
  T_46_META_WS_ADDATTACHMENTS: "Добавить приспособления",
  T_46_META_WS_ADDBUFF: "Добавить бафф",
  T_46_META_WS_ADDCOMPONENT: "Добавить компонент",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Добавить скорость футбольного мяча",
  T_46_META_WS_ADDFORCE: "Применить силу",
  T_46_META_WS_ADDFORCEATPOSITION: "Применить силу в позиции",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Добавить коэффициент формулы свойства",
  T_46_META_WS_ADDGAMEEVENTLOG: "Добавить журнал игровых событий",
  T_46_META_WS_ADDHP: "Добавить ХП",
  T_46_META_WS_ADDITEM: "Добавить Предмет",
  T_46_META_WS_ADDITEMINSCENE: "Создать Предмет в Сцене",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Добавить предмет в товар",
  T_46_META_WS_ADDMONEY: "Добавить деньги",
  T_46_META_WS_ADDSCRIPT: "Добавить скрипт",
  T_46_META_WS_ADDTAG: "Добавить метку",
  T_46_META_WS_ADDTOKEN: "Добавить Токен",
  T_46_META_WS_ADDTORQUE: "Применить крутящий момент",
  T_46_META_WS_ADDUSEREVENTLOG: "Добавить журнал пользовательских событий",
  T_46_META_WS_ANGEL: "Ангел",
  T_46_META_WS_APPEND: "Добавить",
  T_46_META_WS_APPENDRANGE: "Добавить Диапазон",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Применить конфигурацию интерфейса для выхода",
  T_46_META_WS_ASIN: "ASin",
  T_46_META_WS_ASSERT: "Утверждение",
  T_46_META_WS_ASSISTPLAYER: "Ассистировавший игрок",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Нападающий",
  T_46_META_WS_ATTACKTARGET: "Цель атаки",
  T_46_META_WS_AXISANGLETOQUATERNION: "Угловая ось в кватернион",
  T_46_META_WS_BOXCAST: "Обнаружение коробки",
  T_46_META_WS_BOXOVERLAP: "Перекрытие коробки",
  T_46_META_WS_BUTTONNAME: "Имя кнопки",
  T_46_META_WS_C_ACTIONTYPE: "Тип действия",
  T_46_META_WS_C_AIMABLE: "Цельный компонент",
  T_46_META_WS_C_AIMASSISTABLE: "Помощник прицеливания",
  T_46_META_WS_C_AIMASSISTTYPE: "Тип Помощи при Целеполагании",
  T_46_META_WS_C_AIRDROP: "Авиапосылка",
  T_46_META_WS_C_AMMO: "Боеприпасы",
  T_46_META_WS_C_AMMOTYPE: "Тип Патронов",
  T_46_META_WS_C_AMPHIBIAN: "Амфибия",
  T_46_META_WS_C_ANIMATIONCLIP: "Клип анимации",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID клипа анимации",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Контроллер анимации",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Подключаемый контроллер анимации",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID контроллера анимации",
  T_46_META_WS_C_ANIMATIONSTATE: "Состояние анимации",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Триггер анимации",
  T_46_META_WS_C_APPEARENCE: "Внешний вид",
  T_46_META_WS_C_ASSETCONFIGID: "Идентификатор конфигурации активов",
  T_46_META_WS_C_ASSETID: "ID актива",
  T_46_META_WS_C_ATTACHMENT: "Прикрепление",
  T_46_META_WS_C_ATTACKABLETYPE: "Тип атакуемого",
  T_46_META_WS_C_AUDIOID: "ID аудио",
  T_46_META_WS_C_BACKPACK: "Рюкзак",
  T_46_META_WS_C_BACKPACKSKINID: "Идентификатор скина рюкзака",
  T_46_META_WS_C_BASEDATAALIAS: "Псевдоним базовых данных",
  T_46_META_WS_C_BASICAPPEARANCE: "Основной вид",
  T_46_META_WS_C_BASICCYLINDER: "Основной цилиндр",
  T_46_META_WS_C_BASICSCALABLE: "Основной масштабируемый",
  T_46_META_WS_C_BASICSPHERE: "Основная сфера",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Компонент объединения рендеринга пакета",
  T_46_META_WS_C_BEVTREE: "Дерево поведения",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Прикрепляемое дерево поведения",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Пользовательский узел дерева поведения",
  T_46_META_WS_C_BEVTREEID: "Идентификатор дерева поведения",
  T_46_META_WS_C_BEVTREENODESTATUS: "Статус узла дерева поведения",
  T_46_META_WS_C_BEVTREENODETYPE: "Тип узла дерева поведения",
  T_46_META_WS_C_BEZIERCURVE: "Безье кривая",
  T_46_META_WS_C_BOOL: "Логический",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Тип сложности бота",
  T_46_META_WS_C_BOUNCINGTIRE: "Прыгающая шина",
  T_46_META_WS_C_BUFFABLE: "Могущий получить бафф",
  T_46_META_WS_C_BUFFGENERATOR: "Генератор баффов",
  T_46_META_WS_C_BUFFTYPE: "Тип баффа",
  T_46_META_WS_C_BUILTINRENDER: "Встроенный рендер",
  T_46_META_WS_C_BUILTINUI: "Встроенный интерфейс",
  T_46_META_WS_C_BUILTINUITYPE: "Встроенный тип интерфейса",
  T_46_META_WS_C_CAMERA: "Камера",
  T_46_META_WS_C_CAMERABLOCKMODE: "Режим блокировки камеры",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Режим проекции камеры",
  T_46_META_WS_C_CAMERARAYCASTUI: "UI лучевого сканирования камеры",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Тип перехода камеры",
  T_46_META_WS_C_CAMERATYPE: "Тип камеры",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Ограничение угла обзора камеры",
  T_46_META_WS_C_CAPSULETRIGGER: "Капсульный триггер",
  T_46_META_WS_C_CAR: "Автомобиль",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Контроллер персонажа",
  T_46_META_WS_C_CHATCHANNEL: "Канал чата",
  T_46_META_WS_C_CHATCHANNELTYPE: "Тип канала чата",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Триггер контрольной точки",
  T_46_META_WS_C_COINGENERATOR: "Генератор монет",
  T_46_META_WS_C_COLLECTIONID: "ID коллекции",
  T_46_META_WS_C_COLLIDER: "Коллайдер",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Форма коллайдера",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID коллекции коллайдеров",
  T_46_META_WS_C_COLORDRUM: "Цветной барабан",
  T_46_META_WS_C_COMBATABLE: "Боеспособный",
  T_46_META_WS_C_COMPONENT: "Компонент",
  T_46_META_WS_C_CONDITION: "Условие",
  T_46_META_WS_C_CONTAINER: "Контейнер",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Тип системы координат",
  T_46_META_WS_C_CROSSBOW: "Граната арбалет",
  T_46_META_WS_C_CSVID: "ID CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Пользовательский триггер",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Пользовательский объект",
  T_46_META_WS_C_CUSTOMPATH: "Пользовательский Путь",
  T_46_META_WS_C_CUSTOMUI: "Пользовательский интерфейс",
  T_46_META_WS_C_CUSTOMUIID: "ID пользовательского интерфейса",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "Пользовательский интерфейс или виджет",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID виджета пользовательского интерфейса",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Поврежденный тип части тела",
  T_46_META_WS_C_DAMAGETYPE: "Тип Повреждения",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Триггер устранения или неуязвимости",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Разрушаемый объект",
  T_46_META_WS_C_DICE: "Кубик",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Обувь для двойного прыжка",
  T_46_META_WS_C_DRUMMUSIC: "Музыка на барабанах",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Двойное Оружие",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Общий уровень объекта",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Динамический тип создаваемого объекта уровня",
  T_46_META_WS_C_DYNAMICFENCE: "Динамическое ограждение",
  T_46_META_WS_C_EFFECT: "Эффект",
  T_46_META_WS_C_EFFECTCONTAINER: "Контейнер эффектов",
  T_46_META_WS_C_EFFECTID: "ID эффекта",
  T_46_META_WS_C_EMOTETYPE: "Тип эмоции",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Триггер конечной точки",
  T_46_META_WS_C_ENTITY: "Сущность",
  T_46_META_WS_C_ENTITYORPREFABID: "Сущность или ID префаба",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Оборудование аксессуара",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Тип Слота Оборудования",
  T_46_META_WS_C_EQUIPMENTTYPE: "Тип Оборудования",
  T_46_META_WS_C_EVENTID: "ID события",
  T_46_META_WS_C_FACTION: "Фракция",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Тип направления заполнения",
  T_46_META_WS_C_FILLTYPE: "Тип заполнения",
  T_46_META_WS_C_FIRETYPE: "Тип Огня",
  T_46_META_WS_C_FLOAT: "Вещественное число",
  T_46_META_WS_C_FOLDWING: "Складные крылья",
  T_46_META_WS_C_FOLLOW: "Следовать",
  T_46_META_WS_C_FONTTYPE: "Тип шрифта",
  T_46_META_WS_C_FOOTBALL: "Футбол",
  T_46_META_WS_C_FORCETYPE: "Тип силы",
  T_46_META_WS_C_FORMULABLE: "Формулируемый",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Самоотносительное по кадрам",
  T_46_META_WS_C_GAMERESULTTYPE: "Тип результата игры",
  T_46_META_WS_C_GENDERTYPE: "Пол",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Общая точка спауна",
  T_46_META_WS_C_GRENADEDEICEWALL: "Граната для дезледяной стены",
  T_46_META_WS_C_GRENADEFLASHBANG: "Осветительная граната",
  T_46_META_WS_C_GRENADEFROZEN: "Граната замедления",
  T_46_META_WS_C_GRENADELAUNCHER: "Гранатомет",
  T_46_META_WS_C_GRENADESMOKE: "Дымовая граната",
  T_46_META_WS_C_GRENADEWEAPON: "База гранаты",
  T_46_META_WS_C_GRID: "Сетка",
  T_46_META_WS_C_HANDCANNON: "Граната ручной пистолет",
  T_46_META_WS_C_HELMET: "Шлем",
  T_46_META_WS_C_HIERARCHICAL: "Иерархический",
  T_46_META_WS_C_HOOKGUN: "Крюковая Пушка",
  T_46_META_WS_C_HORIZALINE: "Горизонтальная линия",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI Трансформер",
  T_46_META_WS_C_HUMANMODELID: "ID модели человека",
  T_46_META_WS_C_ICEWALL: "Стена",
  T_46_META_WS_C_ICEWALLCREATED: "Созданная ледяная стена",
  T_46_META_WS_C_ICEWALLMAKER: "Создатель Стен",
  T_46_META_WS_C_ICON: "Иконка-сущность",
  T_46_META_WS_C_ICONTYPE: "Тип Иконки",
  T_46_META_WS_C_INHALER: "Противогаз",
  T_46_META_WS_C_INT: "Целое число",
  T_46_META_WS_C_INT64: "Int64",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Шаблон целых чисел",
  T_46_META_WS_C_INTORINTLIST: "Целое число или список целых чисел",
  T_46_META_WS_C_INVENTORYTYPE: "Инвентарный Тип",
  T_46_META_WS_C_ITEMBASE: "Базовый элемент",
  T_46_META_WS_C_ITEMCONTAINER: "Контейнер Предметов",
  T_46_META_WS_C_ITEMID: "Идентификатор предмета",
  T_46_META_WS_C_ITEMIDTYPE: "Тип Идентификатора Предмета",
  "T_46_META_WS_C_JERSEY STYLE": "Стиль Джерси",
  T_46_META_WS_C_JERSEYMACHINE: "JerseyMachine",
  T_46_META_WS_C_JETSHOES: "Реактивные ботинки",
  T_46_META_WS_C_KEYBOARD: "Клавиатура",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Тип Падения",
  T_46_META_WS_C_LANDMINE: "Минное поле",
  T_46_META_WS_C_LANDMINECREATED: "Созданное минное поле",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Уровень объекта пусковой площадки",
  T_46_META_WS_C_LAUNCHPAD: "Пусковая площадка",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Тип сортировки макета",
  T_46_META_WS_C_LEAD1MUSIC: "Музыка Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Музыка Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Музыка Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "Идентификатор уровня объекта",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Тип объекта уровня",
  T_46_META_WS_C_LIST: "Список",
  T_46_META_WS_C_LISTORMAP: "Список или карта",
  T_46_META_WS_C_LISTT: "Шаблон списка",
  T_46_META_WS_C_LISTT_BOOL: "Список булевых значений",
  T_46_META_WS_C_LISTT_CONDITION: "Список условий",
  T_46_META_WS_C_LISTT_ENTITY: "Список Сущностей",
  T_46_META_WS_C_LISTT_FLOAT: "Список с плавающей точкой",
  T_46_META_WS_C_LISTT_INT: "Список целых чисел",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Список предметов",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Список Уровней Объектов",
  T_46_META_WS_C_LISTT_LOCKEY: "Список локализационных ключей",
  T_46_META_WS_C_LISTT_PLAYABLE: "Список играбельных объектов",
  T_46_META_WS_C_LISTT_PLAYER: "Список Игроков",
  T_46_META_WS_C_LISTT_SKILLID: "Список ID навыков",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Список звуковых эффектов",
  T_46_META_WS_C_LISTT_STRING: "Список строк",
  T_46_META_WS_C_LISTT_TEAM: "Список Команд",
  T_46_META_WS_C_LISTT_TYPE: "Список типов",
  T_46_META_WS_C_LISTT_VECTOR3: "Список Vector3",
  T_46_META_WS_C_LOCKEY: "Ключ локализации",
  T_46_META_WS_C_LOOKAT: "Смотреть",
  T_46_META_WS_C_LOOPABLE: "Циклический",
  T_46_META_WS_C_LOOPTYPE: "Тип цикла",
  T_46_META_WS_C_LOOTAMMOTYPE: "Тип лут-патронов",
  T_46_META_WS_C_LOOTARMOR: "Взять броню",
  T_46_META_WS_C_LOOTARMORTYPE: "Тип лут-брони",
  T_46_META_WS_C_LOOTCONSUMABLE: "Взять потребляемое",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Тип лут-потребляемого",
  T_46_META_WS_C_LOOTIAMMO: "Взять патроны",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Коробка для футбольного лута",
  T_46_META_WS_C_LOOTSCOPE: "Взять прицел",
  T_46_META_WS_C_LOOTSCOPETYPE: "Тип лут-прицела",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Тип футбольного лута",
  T_46_META_WS_C_LOOTTHROWABLE: "Взять метательное",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Тип лут-метательного",
  T_46_META_WS_C_LOOTWEAPON: "Взять оружие",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Тип лут-оружия",
  T_46_META_WS_C_LOWGRAVITY: "Зона с низким гравитацией",
  T_46_META_WS_C_MAP: "Карта",
  T_46_META_WS_C_MAPT: "Шаблон карты",
  T_46_META_WS_C_MATERIALID: "ID материала",
  T_46_META_WS_C_MEDKIT: "Аптечка",
  T_46_META_WS_C_MESHID: "ID сетки",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Конфигурация выхода из игры",
  T_46_META_WS_C_MINIMAP: "Мини-карта",
  T_46_META_WS_C_MINIMAPICON: "Иконка мини-карты",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Отображение пикселей миникарты UI",
  T_46_META_WS_C_MINISENTRY: "Мини-опорное устройство",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Тип диапазона атаки мини-опорного устройства",
  T_46_META_WS_C_MINISENTRYCREATED: "Мини-опорное устройство создано",
  T_46_META_WS_C_MONEY: "Деньги",
  T_46_META_WS_C_MONEYTYPE: "Тип денег",
  T_46_META_WS_C_MONSTER: "Монстр",
  T_46_META_WS_C_MONSTERSPAWN: "Спавн монстра",
  T_46_META_WS_C_MONSTERTYPE: "Тип Монстра",
  T_46_META_WS_C_MORPHABLEOBJECT: "Объект, который можно морфировать",
  T_46_META_WS_C_MORPHOBJECT: "Объект для морфирования",
  T_46_META_WS_C_MOTOBIKE: "Мотоцикл",
  T_46_META_WS_C_MOVEPLATFORM: "Платформа перемещения",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Тип перемещаемой платформы",
  T_46_META_WS_C_MUSHROOM: "Гриб",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Натуральная константа",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Число",
  T_46_META_WS_C_OBJECT: "Объект",
  T_46_META_WS_C_OILDRUM: "Бочка с маслом",
  T_46_META_WS_C_OUTFITID: "Идентификатор наряда",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Тип слота для одежды",
  T_46_META_WS_C_PATHPOINT: "Точка Пути",
  T_46_META_WS_C_PATROLSTYLETYPE: "Тип Стиля Патруля",
  T_46_META_WS_C_PATROLTYPE: "Тип Патруля",
  T_46_META_WS_C_PERSONA: "Персонаж",
  T_46_META_WS_C_PHASE: "Фаза",
  T_46_META_WS_C_PHYSICALMOVER: "Физический перемещатель",
  T_46_META_WS_C_PHYSICALOBJECT: "Физический объект",
  T_46_META_WS_C_PLATFORMTYPE: "Тип платформы",
  T_46_META_WS_C_PLAYABLE: "Игровой",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Игровые элементы или массив игровых элементов",
  T_46_META_WS_C_PLAYER: "Игрок",
  T_46_META_WS_C_PLAYERBACKPACK: "Рюкзак игрока",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Тип статуса поведения игрока",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Тип поведения игрока",
  T_46_META_WS_C_PLAYERCCT: "Контроллер персонажа для FF",
  T_46_META_WS_C_PLAYERDATAID: "Тип предустановленного персонажа",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Игрок или трансформация",
  T_46_META_WS_C_PLAYERORVEHICLE: "Игрок или транспортное средство",
  T_46_META_WS_C_PLAYEROUTFIT: "Игрок Одежда",
  T_46_META_WS_C_PLAYERPOSETYPE: "Тип позы игрока",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Источник Возрождения Игрока",
  T_46_META_WS_C_PLAYERSTATETYPE: "Тип состояния игрока",
  T_46_META_WS_C_POINTLIGHT: "Точечный свет",
  T_46_META_WS_C_PORTAL: "Портал",
  T_46_META_WS_C_PREFABID: "ID префаба",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Генератор эффекта презентации",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Тип текстуры эффекта",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Виджет профиля",
  T_46_META_WS_C_PROPERTY: "Свойство",
  T_46_META_WS_C_PROPERTYFORMULA: "Формула свойств",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Тип фактора формулы свойств",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Тип изменения свойств",
  T_46_META_WS_C_QUATERNION: "Кватернион",
  T_46_META_WS_C_RANKABLE: "Ранжируемый",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Тип слоя для лучей",
  T_46_META_WS_C_REPAIRKIT: "Ремонтный комплект",
  T_46_META_WS_C_RESETABLE: "Сбрасываемый",
  T_46_META_WS_C_RIGIDBODY: "Жесткое тело",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Тип ограничения жесткого тела",
  T_46_META_WS_C_RIGIDBODYTYPE: "Тип жесткого тела",
  T_46_META_WS_C_ROUND: "Раунд",
  T_46_META_WS_C_SAFEZONE: "Безопасная зона",
  T_46_META_WS_C_SCOREABLE: "Оценочный",
  T_46_META_WS_C_SCRIPTID: "ID скрипта",
  T_46_META_WS_C_SEATTYPE: "Тип сидения",
  T_46_META_WS_C_SELFRELATIVE: "Самоотносительное",
  T_46_META_WS_C_SHOP: "Магазин",
  T_46_META_WS_C_SHOPITEM: "Товар магазина",
  T_46_META_WS_C_SHOPSHELF: "Полка магазина",
  T_46_META_WS_C_SKATEBOARD: "Скейтборд",
  T_46_META_WS_C_SKELETON: "Скелет",
  T_46_META_WS_C_SKELETONPART: "Часть скелета",
  T_46_META_WS_C_SKILLID: "ID навыка",
  T_46_META_WS_C_SKYBLASTER: "Небесный Бластер",
  T_46_META_WS_C_SKYBOX: "Скайбокс",
  T_46_META_WS_C_SKYBOXTYPE: "Основной тип скайбокса",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Тусовочный Остров",
  T_46_META_WS_C_SORTTYPE: "Тип Сортировки",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Тип звука барабана",
  T_46_META_WS_C_SOUNDEFFECT: "Звуковой эффект",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Звуковой эффект или список звуковых эффектов",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Тип Звукового Эффекта",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Тип звука Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Тип звука Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Тип звука Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Тип звука фортепиано",
  T_46_META_WS_C_SPAWN: "Спавн",
  T_46_META_WS_C_SPAWNABLE: "Поддерживаемый спавн",
  T_46_META_WS_C_SPAWNBOX: "Зона Появления",
  T_46_META_WS_C_SPAWNPOSITION: "Точка спауна",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Специальный Тип ID Предмета",
  T_46_META_WS_C_SPHERETRIGGER: "Сфера-триггер",
  T_46_META_WS_C_SPORTSCAR: "Спорткар",
  T_46_META_WS_C_SPRAYCOLOR: "Цвет спрея",
  T_46_META_WS_C_SPRAYGUN: "Распылитель",
  T_46_META_WS_C_SPRAYRESULTUI: "UI результатов распыла",
  T_46_META_WS_C_SPRAYRIFLE: "Ручной распылитель",
  T_46_META_WS_C_SPRITEID: "ID спрайта",
  T_46_META_WS_C_STATICSCRIPTID: "ID статического скрипта",
  T_46_META_WS_C_STRING: "Строка",
  T_46_META_WS_C_STRINGORLOCSTRING: "Строка или локализированная строка",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Триггер ящика с припасами",
  T_46_META_WS_C_SWINGGUN: "Пушечка с качанием",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Переключение слота оборудования",
  T_46_META_WS_C_TEAM: "Команда",
  T_46_META_WS_C_TERRAIN: "Поверхность",
  T_46_META_WS_C_TEXT: "Текстовая сущность",
  T_46_META_WS_C_TEXTUREID: "ID текстуры",
  T_46_META_WS_C_TEXTURETYPE: "Текстура объекта",
  T_46_META_WS_C_TIMER: "Таймер",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Тип форматирования временной метки",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Локализованная строка временной метки",
  T_46_META_WS_C_TRAJECTORY: "Траектория",
  T_46_META_WS_C_TRANSFORM: "Преобразование",
  T_46_META_WS_C_TUKTUK: "Тук-тук",
  T_46_META_WS_C_TURRET: "Башня",
  T_46_META_WS_C_TWEEN: "Твин",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Кривая Твин",
  T_46_META_WS_C_TWEENSTYLE: "Стиль Твин",
  T_46_META_WS_C_TYPE: "Тип",
  T_46_META_WS_C_TYPEENUM: "Перечисление типа",
  T_46_META_WS_C_TYPEORTYPELIST: "Тип или список типов",
  T_46_META_WS_C_UIADDSCORE: "Добавить очки UI",
  T_46_META_WS_C_UIANITRIGGERHUD: "Триггер анимации UI",
  T_46_META_WS_C_UIBUILTINSWITCH: "Встроенный переключатель UI",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "Встроенный переключатель интерфейса UI",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "Панель выбора карт UI",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "Индикатор контрольной точки UI",
  T_46_META_WS_C_UICOMPASS: "Компас UI",
  T_46_META_WS_C_UICOUNTDOWN5: "Обратный отсчет на 5 секунд UI",
  T_46_META_WS_C_UICOUNTDOWNHINT: "Подсказка обратного отсчета UI",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "Напоминание об обратном отсчете UI",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Полоска здоровья над головой персонажа",
  T_46_META_WS_C_UIHEALTHBAR: "Полоса здоровья UI",
  T_46_META_WS_C_UIHEARTBEAT: "Сердцебиение UI",
  T_46_META_WS_C_UIICONNOTIFICATION: "Уведомление об иконке UI",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "Уведомление о личности UI",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "Кнопка взаимодействия UI",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "Кнопка таблицы лидеров UI",
  T_46_META_WS_C_UIMATCHSUBTITLE: "Субтитры матча UI",
  T_46_META_WS_C_UIMONSTERLEVEL: "Уровень монстра UI",
  T_46_META_WS_C_UIMONSTERUI: "UI монстра",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "Таблица лидеров нескольких команд UI",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "Панель результата нескольких команд UI",
  T_46_META_WS_C_UIOPENINGBANNER: "Баннер открытия UI",
  T_46_META_WS_C_UIPANEL: "Панель UI",
  T_46_META_WS_C_UIPANELEMPTY: "Пустая панель UI",
  T_46_META_WS_C_UIPHASETIMER: "Таймер фазы UI",
  T_46_META_WS_C_UIPROGRESSBAR: "Полоса прогресса UI",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "Круг прогресса UI",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "Кнопка навыка прогресса UI",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "Тип запроса на покупку UI",
  T_46_META_WS_C_UIROUNDINFOBANNER: "Информация о раунде HUD",
  T_46_META_WS_C_UIROUNDNUMBER: "Номер раунда UI",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "Баннер результата раунда UI",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "Баннер начала раунда UI",
  T_46_META_WS_C_UIROUNDTRANSITION: "Переход между раундами UI",
  T_46_META_WS_C_UISCOREBAR: "Полоса счета UI",
  T_46_META_WS_C_UISCROLLPANEL: "Панель прокрутки UI",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "Простой баннер счета раунда UI",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "Простой баннер начала раунда UI",
  T_46_META_WS_C_UISIMPLETIP: "Простая подсказка UI",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "Простой баннер противостояния UI",
  T_46_META_WS_C_UISKILLBUTTON: "Кнопка навыка UI",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Виджет кнопки для социальных функций",
  T_46_META_WS_C_UISOLOLEADERBOARD: "Таблица лидеров соло UI",
  T_46_META_WS_C_UISTORE: "Интерфейс магазина UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "Информация о матче команды UI",
  T_46_META_WS_C_UITEXTTIP: "Подсказка текста UI",
  T_46_META_WS_C_UITIMERINFO: "Информация о таймере UI",
  T_46_META_WS_C_UITIPBUTTON: "Кнопка подсказки UI",
  T_46_META_WS_C_UITITLEBANNER: "Баннер заголовка UI",
  T_46_META_WS_C_UITWEENTIP: "Всплывающая подсказка UI",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "Краткая информация о двух командах UI",
  T_46_META_WS_C_UITWOTEAMINFO: "Информация о двух командах UI",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "Таблица лидеров двух команд UI",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "Панель результата двух команд UI",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "Баннер счета двух команд UI",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "Панель счета двух команд UI",
  T_46_META_WS_C_UIVERSUSBANNER: "Баннер противостояния UI",
  T_46_META_WS_C_UIWIDGET: "Виджет UI",
  T_46_META_WS_C_UIWIDGETBUTTON: "Кнопка виджета UI",
  T_46_META_WS_C_UIWIDGETCONTAINER: "Контейнер виджета UI",
  T_46_META_WS_C_UIWIDGETEMPTY: "Пустой виджет UI",
  T_46_META_WS_C_UIWIDGETIMAGE: "Изображение виджета UI",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "Вводная метка виджета UI",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "Джойстик виджета UI",
  T_46_META_WS_C_UIWIDGETLABEL: "Метка виджета UI",
  T_46_META_WS_C_UIWIDGETLAYOUT: "Макет виджета UI",
  T_46_META_WS_C_UIWIDGETPROFILE: "Профиль виджета UI",
  T_46_META_WS_C_UIWIDGETTEXTURE: "Текстура виджета UI",
  T_46_META_WS_C_UIWIDGETTOGGLE: "Переключатель виджета UI",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "Тачпад виджета UI",
  T_46_META_WS_C_UIWINORLOSEBANNER: "Баннер выигрыша или проигрыша UI",
  T_46_META_WS_C_UNITSPAWN: "Генератор Юнитов",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Объект логики взлома окна",
  T_46_META_WS_C_VECTOR2: "Vector2",
  T_46_META_WS_C_VECTOR3: "Vector3",
  T_46_META_WS_C_VEHICLE: "Транспортное средство",
  T_46_META_WS_C_VEHICLEIDTYPE: "Тип ID транспортного средства",
  T_46_META_WS_C_VEHICLESKINID: "ID скина транспортного средства",
  T_46_META_WS_C_VENDINGMACHINE: "Торговый автомат",
  T_46_META_WS_C_VEST: "Жилет",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Заменяемая текстура VFX",
  T_46_META_WS_C_VFXTEXTURE: "Текстура VFX",
  T_46_META_WS_C_VISIBILITY: "Видимость",
  T_46_META_WS_C_WALLET: "Кошелек",
  T_46_META_WS_C_WALLETHUD: "UI кошелька",
  T_46_META_WS_C_WATERZONE: "Водная зона",
  T_46_META_WS_C_WAVECOUNTTYPE: "Тип Волны",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Тип Интервала Волны",
  T_46_META_WS_C_WEAPON: "Оружие",
  T_46_META_WS_C_WEAPONGENERATOR: "Генератор Оружия",
  T_46_META_WS_C_WEAPONSKINID: "ID скина оружия",
  T_46_META_WS_C_WEAPONTYPE: "Тип Оружия",
  T_46_META_WS_C_WIDGETTYPE: "Тип виджета",
  T_46_META_WS_C_ZIPLINE: "Канатная дорога",
  T_46_META_WS_CAMERADIRECTION: "Направление камеры",
  T_46_META_WS_CAMERAPOSITION: "Положение камеры",
  T_46_META_WS_CAPSULECAST: "Обнаружение капсулы",
  T_46_META_WS_CAPSULEOVERLAP: "Перекрытие капсулы",
  T_46_META_WS_CEIL: "Округлить Вверх",
  T_46_META_WS_CHATCHANNEL: "Канал чата",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Проверить Триггер по Порядку",
  T_46_META_WS_CLAMP: "Ограничение",
  T_46_META_WS_CLEAR: "Очистить",
  T_46_META_WS_CLEARALLCHILDREN: "Очистить всех детей",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Очистить особое внимание AOI",
  T_46_META_WS_CLEARBACKPACK: "Очистить рюкзак",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Очистить коэффициент формулы свойства",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Очистить Остаточные Объекты Уровня",
  T_46_META_WS_CLIPNAME: "Имя клипа",
  T_46_META_WS_CLONE: "Клонировать",
  T_46_META_WS_COLLIDEDENTITY: "CollidedEntity",
  T_46_META_WS_COLORGET: "Получить Цвет",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Завершить Пользовательскую Задачу",
  T_46_META_WS_CONNECT: "Соединить",
  T_46_META_WS_CONSUMABLEID: "ConsumableID",
  T_46_META_WS_CONTAIN: "Содержит",
  T_46_META_WS_CONTAINKEY: "Проверить Наличие Ключа",
  T_46_META_WS_COPYTOMORPH: "Копировать в преобразование",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Стоимость денег",
  T_46_META_WS_COSTTOKEN: "Израсходовать Токен",
  T_46_META_WS_CREATEAIRDROP: "Создать авиапосылку",
  T_46_META_WS_CREATEBOT: "Создать бота",
  T_46_META_WS_CREATEBUILTINUI: "Создать Встроенный UI",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Создать Встроенный UI",
  T_46_META_WS_CREATECAMERA: "Создать камеру",
  T_46_META_WS_CREATECURVE: "Создать кривую",
  T_46_META_WS_CREATECUSTOMUI: "Создать Пользовательский UI",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Создать Пользовательский UI",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Создать пользовательский виджет UI",
  T_46_META_WS_CREATEDAMAGENUM: "Создать число урона",
  T_46_META_WS_CREATEEFFECT: "Создать эффект",
  T_46_META_WS_CREATEEFFECTCLIENT: "Создать эффект",
  T_46_META_WS_CREATEFACTION: "Создать фракцию",
  T_46_META_WS_CREATEFOLLOW: "Создать следование",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Создать относительно себя для кадра",
  T_46_META_WS_CREATEFROMPREFAB: "Создать из префаба",
  T_46_META_WS_CREATELEVELOBJECT: "Создать Объект Уровня",
  T_46_META_WS_CREATELOOKAT: "Создать взгляд",
  T_46_META_WS_CREATEMINIMAPICON: "Создать иконку мини-карты",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Создать пиксель мини-карты",
  T_46_META_WS_CREATEMONSTER: "Создать монстра",
  T_46_META_WS_CREATEMORPH: "Создать преобразование",
  T_46_META_WS_CREATESELFRELATIVE: "Создать относительно себя",
  T_46_META_WS_CREATESHOP: "Создать магазин",
  T_46_META_WS_CREATESHOPITEM: "Создать товар",
  T_46_META_WS_CREATESHOPSHELF: "Создать полку для магазина",
  T_46_META_WS_CREATESOUND: "Создать звук",
  T_46_META_WS_CREATESOUNDCLIENT: "Создать звук",
  T_46_META_WS_CREATETOKENINSCENE: "Создать Жетон в Сцене",
  T_46_META_WS_CREATETRAJECTORY: "Создать траекторию",
  T_46_META_WS_CREATETWEEN: "Создать интерполяцию",
  T_46_META_WS_CREATEWALLET: "Создать кошелек",
  T_46_META_WS_CROSS: "Векторное Произведение",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Имя столбца CSV в целое число",
  T_46_META_WS_CURRENTAMMOCOUNT: "Текущее количество патронов",
  T_46_META_WS_DAMAGE: "Повреждения",
  T_46_META_WS_DAMAGEDBODYPART: "Поврежденная часть тела",
  T_46_META_WS_DAMAGEDPLAYERS: "Игроки ",
  T_46_META_WS_DAMAGETYPE: "Тип урона",
  T_46_META_WS_DEALDAMAGE: "Нанести Урон",
  T_46_META_WS_DELETE: "Удалить",
  T_46_META_WS_DELETEAT: "Удалить",
  T_46_META_WS_DELETECUSTOMUI: "Удалить Пользовательский UI",
  T_46_META_WS_DELETEFROMDATABASE: "Удалить из базы данных",
  T_46_META_WS_DELETEFROMDATASTORE: "Удалить из хранилища данных",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Удалить из таблицы лидеров по ключу",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Удалить из таблицы лидеров по рангу",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Удалить из хранилища данных таблицы лидеров по ключу",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Удалить из хранилища данных таблицы лидеров по рангу",
  T_46_META_WS_DELETETAG: "Удалить метку",
  T_46_META_WS_DELTA: "Дельта",
  T_46_META_WS_DESTROY: "Уничтожить",
  T_46_META_WS_DESTROYBOT: "Уничтожить бота",
  T_46_META_WS_DESTROYBUILTINUI: "Удалить Встроенный UI",
  T_46_META_WS_DESTROYEQUIPMENT: "Уничтожить оборудование",
  T_46_META_WS_DESTROYITEM: "Удалить Предмет",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Направление в углы Эйлера",
  T_46_META_WS_DISABLESAFEZONE: "Отключить Зону Безопасности",
  T_46_META_WS_DISPATCHEVENT: "Отправить событие",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Отправить событие с платформой",
  T_46_META_WS_DISTANCE: "Расстояние",
  T_46_META_WS_DOT: "Скалярное Произведение",
  T_46_META_WS_DROPITEM: "Урон",
  T_46_META_WS_DYEATAREA: "Окрасить в области",
  T_46_META_WS_DYEATPLANE: "Окрасить на плоскости",
  T_46_META_WS_DYEATPOSITION: "Окрасить в позиции",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Зона с низкой гравитацией",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Ускорение",
  T_46_META_WS_E_ACTIONNODE: "Узел Действия",
  T_46_META_WS_E_ACTIVE: "Активный",
  T_46_META_WS_E_ACTIVESKILL: "Активный навык",
  T_46_META_WS_E_ADBOARD: "Рекламный щит",
  T_46_META_WS_E_ADD: "Добавить",
  T_46_META_WS_E_ADDFRIEND: "Добавить друга",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Прицел",
  T_46_META_WS_E_AIR: "Воздух",
  T_46_META_WS_E_AIRCONDITIONERA: "Кондиционер",
  T_46_META_WS_E_AIRDROP: "Авиапосылка, Устранение Зомби",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Живой",
  T_46_META_WS_E_AMMO: "Эффект пули",
  T_46_META_WS_E_AMPHIBIANCAR: "Амфибия",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Явление",
  T_46_META_WS_E_AR: "Винтовка",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Патроны AR",
  T_46_META_WS_E_ARMAGAZINE: "Магазин для автоматической винтовки",
  T_46_META_WS_E_ARMOR: "Броня",
  T_46_META_WS_E_ARMORBUFF: "Броневой бафф",
  T_46_META_WS_E_ARMORLV1: "Броня Ур.1",
  T_46_META_WS_E_ARMORLV2: "Броня Ур.2",
  T_46_META_WS_E_ARMORLV3: "Броня Ур.3",
  T_46_META_WS_E_ARMORPIERCING: "Разрушение брони",
  T_46_META_WS_E_ARMORSPECIALIST: "Навык 1",
  T_46_META_WS_E_ARROW: "Стрелка",
  T_46_META_WS_E_ASC: "Восходящий порядок",
  T_46_META_WS_E_ASCIGNOREZERO: "Восходящий порядок исключает нули",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Взрыв газа",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Attachment1ForCompatibility",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Attachment4ForCompatibility",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Attachment5ForCompatibility",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Attachment6ForCompatibility",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Attachment8ForCompatibility",
  T_46_META_WS_E_ATTACK: "Атака",
  T_46_META_WS_E_ATTACKGRENADE: "Граната для атаки",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Автоматический",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Возврат",
  T_46_META_WS_E_BACKANDFORTH: "Туда и обратно",
  T_46_META_WS_E_BAG: "Рюкзак",
  T_46_META_WS_E_BAG1: "Bag1",
  T_46_META_WS_E_BAG2: "Bag2",
  T_46_META_WS_E_BAG3: "Bag3",
  T_46_META_WS_E_BAMBOOA: "Бамбук A",
  T_46_META_WS_E_BANANATREE: "Банановое дерево",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Базовый коэффициент",
  T_46_META_WS_E_BASIC: "Основной",
  T_46_META_WS_E_BASICCONE: "Основной конус",
  T_46_META_WS_E_BASICCYLINDER: "Основной цилиндр",
  T_46_META_WS_E_BASICSPHERE: "Основная сфера",
  T_46_META_WS_E_BATTLEINSTYLE: "Играй на Стиле",
  T_46_META_WS_E_BELL: "Колокол",
  T_46_META_WS_E_BENCH: "Скамейка",
  T_46_META_WS_E_BIGHEADHAMMER: "Клёвый Молоток",
  T_46_META_WS_E_BILLBOARD: "Большой экран",
  T_46_META_WS_E_BIPOD: "Сошка",
  T_46_META_WS_E_BISGRAFFITIWALL: "Стена с темой BIS",
  T_46_META_WS_E_BIZON: "Бизон",
  T_46_META_WS_E_BLACKHOLE: "Визуальные эффекты взрыва черной дыры",
  T_46_META_WS_E_BLACKHOLEBOOM: "Визуальные эффекты кристального шара",
  T_46_META_WS_E_BLAST: "Взрыв",
  T_46_META_WS_E_BLOCK: "Квадрат",
  T_46_META_WS_E_BLOODBALL: "Эффект черной дыры",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Синий",
  T_46_META_WS_E_BLUEDOLL: "Ледяная кукла",
  T_46_META_WS_E_BOARD: "Двигающаяся платформа",
  T_46_META_WS_E_BODY: "Тело",
  T_46_META_WS_E_BOMBINDICATION: "Предупреждение о бомбе",
  T_46_META_WS_E_BOMBPLIERS: "BombPliers",
  T_46_META_WS_E_BONFIRE: "Горящий костер",
  T_46_META_WS_E_BOOM: "Гул",
  T_46_META_WS_E_BOOYAH: "Победа",
  T_46_META_WS_E_BOTH: "Оба",
  T_46_META_WS_E_BOUNCETIRE: "Шина",
  T_46_META_WS_E_BOWAMMO: "Патроны для лука",
  T_46_META_WS_E_BREAKABLEBOX: "Разрушимый деревянный ящик",
  T_46_META_WS_E_BREAKABLECONTAINER: "Разрушаемый контейнер",
  T_46_META_WS_E_BREAKABLEFENCE: "Разрушаемое ограждение",
  T_46_META_WS_E_BRICKA: "Кирпич A",
  T_46_META_WS_E_BRICKB: "Кирпич B",
  T_46_META_WS_E_BRICKC: "Кирпич C",
  T_46_META_WS_E_BRICKHOUSEA: "Малый дом A",
  T_46_META_WS_E_BRIGHT: "Светлый",
  T_46_META_WS_E_BUBBLE: "Пузырь",
  T_46_META_WS_E_BUFFGENERATOR: "Генератор усиления",
  T_46_META_WS_E_BULLETBUFF: "Патронный бафф",
  T_46_META_WS_E_BULLETHITTING: "Попадание пули",
  T_46_META_WS_E_BUMPERCAR: "Автодромное колесо",
  T_46_META_WS_E_BUMPERCARFACTORY: "Производитель машин на надувных колесах",
  T_46_META_WS_E_BURNING: "Повреждение от взрыва транспортного средства",
  T_46_META_WS_E_BUSHES: "Кусты",
  T_46_META_WS_E_BUSSTOP: "Автобусная станция",
  T_46_META_WS_E_BUTTOM: "Нижняя одежда",
  T_46_META_WS_E_BUTTONWIDGET: "Виджет кнопки",
  T_46_META_WS_E_BYHIERARCHY: "По иерархии",
  T_46_META_WS_E_CABINET: "Шкаф",
  T_46_META_WS_E_CACTUS: "Кактус",
  T_46_META_WS_E_CAMOUFLAGE: "Навык 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Капсульный триггер",
  T_46_META_WS_E_CARDIOTONIC: "Кардиотоник",
  T_46_META_WS_E_CASUALGAMEBGM: "Легкое игровое BGM",
  T_46_META_WS_E_CEMENTA: "Цемент A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Канал A",
  T_46_META_WS_E_CHANNELB: "Канал B",
  T_46_META_WS_E_CHANNELC: "Канал C",
  T_46_META_WS_E_CHANNELD: "Канал D",
  T_46_META_WS_E_CHANNELE: "Канал E",
  T_46_META_WS_E_CHANNELF: "Канал F",
  T_46_META_WS_E_CHARACTERSKILL: "Навык персонажа",
  T_46_META_WS_E_CHARACTOR: "Персонаж",
  T_46_META_WS_E_CHARGE: "Заряд 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Контрольная точка",
  T_46_META_WS_E_CHEER: "Аплодисменты",
  T_46_META_WS_E_CHERRYBLOSSOM: "Дерево сакуры",
  T_46_META_WS_E_CIRCLE: "Круг",
  T_46_META_WS_E_CIRCLEBACK: "Цикл",
  T_46_META_WS_E_CIRCLEOFHEAT: "Луч у земли",
  T_46_META_WS_E_CITY: "Город",
  T_46_META_WS_E_CLAPS: "Аплодисменты",
  T_46_META_WS_E_CLEAR: "Очистить",
  T_46_META_WS_E_CLIENT: "Клиент",
  T_46_META_WS_E_CLONE: "Изменение вида",
  T_46_META_WS_E_CLONEKILL: "Смерть клона",
  T_46_META_WS_E_CLOSE: "Закрыть",
  T_46_META_WS_E_CLOTHES: "Одежда",
  T_46_META_WS_E_COINGENERATOR: "Генератор монет",
  T_46_META_WS_E_COLDAIR: "Туман",
  T_46_META_WS_E_COLORBLOCK: "Окрашенный блок",
  T_46_META_WS_E_COLOROILBARREL: "Окрашенная бочка",
  T_46_META_WS_E_COMBINEALL: "Полное совмещение",
  T_46_META_WS_E_COMBINESELF: "CombineSelf",
  T_46_META_WS_E_COMBOKEYA1: "Музыкальные ноты - Синтезатор A",
  T_46_META_WS_E_COMBOKEYA2: "Музыкальные ноты - Синтезатор A",
  T_46_META_WS_E_COMBOKEYB1: "Музыкальные ноты - Синтезатор B",
  T_46_META_WS_E_COMBOKEYB2: "Музыкальные ноты - Синтезатор B",
  T_46_META_WS_E_COMBOKEYC1: "Музыкальные ноты - Синтезатор C",
  T_46_META_WS_E_COMBOKEYC2: "Музыкальные ноты - Синтезатор C",
  T_46_META_WS_E_CONCRETEPILLAR: "Бетонная колонна",
  T_46_META_WS_E_CONDITIONNODE: "Узел Условий",
  T_46_META_WS_E_CONTAINERA: "Контейнер A",
  T_46_META_WS_E_CONTAINERB: "Контейнер B",
  T_46_META_WS_E_CONTAINERC: "Контейнер C",
  T_46_META_WS_E_CONTAINERWIDGET: "Виджет контейнера",
  T_46_META_WS_E_CONTINUOUS: "Непрерывный",
  T_46_META_WS_E_COUNTDOWN: "Обратный отсчет",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Обратный отсчет",
  T_46_META_WS_E_COUNTDOWNDIDI: "Звуковой сигнал обратного отсчета",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Обратный отсчет",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Обратный отсчет 3",
  T_46_META_WS_E_CROSS: "Крест",
  T_46_META_WS_E_CROSSBOW: "Арбалет",
  T_46_META_WS_E_CROSSHAIR: "Перекрестие",
  T_46_META_WS_E_CROSSHAIRS: "Прицел",
  T_46_META_WS_E_CROUCH: "Присесть",
  T_46_META_WS_E_CROUCHING: "Сидящий",
  T_46_META_WS_E_CROWCAW: "Крик птицы",
  T_46_META_WS_E_CROWN: "Корона",
  T_46_META_WS_E_CUBE: "Механизм блока",
  T_46_META_WS_E_CURSE: "Амулет",
  T_46_META_WS_E_CURSEEXPLOSION: "Взрыв амулета",
  T_46_META_WS_E_CUSTOM: "Пользовательская",
  T_46_META_WS_E_CUSTOMTRIGGER: "Пользовательский триггер",
  T_46_META_WS_E_CUSTOMWATERZONE: "Пользовательская акватория",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Циклическое горение",
  T_46_META_WS_E_CYLIC: "Циклический",
  T_46_META_WS_E_DAGGER: "Метательный нож",
  T_46_META_WS_E_DAMAGEDTRUCK: "Поврежденный грузовик",
  T_46_META_WS_E_DAMAGEZONE: "Зона повреждений",
  T_46_META_WS_E_DANGERALARM: "Опасность 2",
  T_46_META_WS_E_DANGERVIBRATING: "Опасность 1",
  T_46_META_WS_E_DARK: "Тёмный",
  T_46_META_WS_E_DARKNESS: "Тьма",
  T_46_META_WS_E_DASHATTACK: "Атака в рывке",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Превышен лимит хранения данных",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Ошибка параметра хранения данных",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Истекло время хранения данных",
  T_46_META_WS_E_DATETIME: "Дата и время",
  T_46_META_WS_E_DAY: "День",
  T_46_META_WS_E_DEAD: "Устраненный",
  T_46_META_WS_E_DEATH: "Устранение",
  T_46_META_WS_E_DEFAULT: "По умолчанию",
  T_46_META_WS_E_DEFAULTFIST: "Кулак",
  T_46_META_WS_E_DEFENCEGRENADE: "Граната для защиты",
  T_46_META_WS_E_DESC: "Убывающий порядок",
  T_46_META_WS_E_DIALOGUE: "Диалог",
  T_46_META_WS_E_DIAMOND: "Алмаз",
  T_46_META_WS_E_DIRECTIONSIGN: "Знак",
  T_46_META_WS_E_DIRVEVEHICLE: "Управление транспортом",
  T_46_META_WS_E_DISABLE: "Отключить",
  T_46_META_WS_E_DISABLED: "Отключен",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Подсказка о исчезновении",
  T_46_META_WS_E_DISCONNECT: "Отключение",
  T_46_META_WS_E_DISGUISE: "Клон",
  T_46_META_WS_E_DOGHOUSE: "Домик для собак",
  T_46_META_WS_E_DOOR: "Дверь",
  T_46_META_WS_E_DOUBLE: "Двойной",
  T_46_META_WS_E_DOUBLEDOOR: "Дверь с двумя створками",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Двойные прыжковые ботинки",
  T_46_META_WS_E_DOUBLEMAGEZINE: "DoubleMagezine",
  T_46_META_WS_E_DRAW: "Ничья",
  T_46_META_WS_E_DRILLZOMBIE: "Зомби с дрелью",
  T_46_META_WS_E_DRIVE: "Вождение",
  T_46_META_WS_E_DRIVER: "Водитель",
  T_46_META_WS_E_DROPBEAT: "Навык 4",
  T_46_META_WS_E_DRUMKEY1: "Музыкальные ноты - Барабан",
  T_46_META_WS_E_DRUMKEY2: "Музыкальные ноты - Барабан",
  T_46_META_WS_E_DUEL: "Битва",
  T_46_META_WS_E_DUMMY: "Манекен",
  T_46_META_WS_E_DUMMYGRENADE: "DummyGrenade",
  T_46_META_WS_E_DUMP: "Сбросить",
  T_46_META_WS_E_DUSK: "Сумерки",
  T_46_META_WS_E_DUST: "Дым и пыль",
  T_46_META_WS_E_DYNAMIC: "Динамический",
  T_46_META_WS_E_E: "Природная константа",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Легкий",
  T_46_META_WS_E_ELECTRICSHOCK: "Электрический шок",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Электрический серфборд",
  T_46_META_WS_E_ELECTRICZONE: "ElectricZone",
  T_46_META_WS_E_ELECTRONICBGM: "Милое электронное фэнтези BGM",
  T_46_META_WS_E_ELIMINATEDBOSS: "Отстранение лидера гильдии",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Подсказка об устранении",
  T_46_META_WS_E_EMOTE: "Эмоция",
  T_46_META_WS_E_ENABLE: "Включить",
  T_46_META_WS_E_ENERGETIC: "Энергичный",
  T_46_META_WS_E_ENTERVEHICLE: "Войти в транспорт",
  T_46_META_WS_E_EP: "Энергия",
  T_46_META_WS_E_EXCLAMATIONMARK: "Восклицательный знак",
  T_46_META_WS_E_EXIT: "Выход",
  T_46_META_WS_E_EXITVEHICLE: "Выйти из транспорта",
  T_46_META_WS_E_EXPLODE: "Саморазрушение",
  T_46_META_WS_E_EXPLOSION: "Эффект взрыва",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Пламя взрыва",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Навык энергического шара",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Взрывной зомби",
  T_46_META_WS_E_EYE: "Очки",
  T_46_META_WS_E_FACEPAINT: "Грим",
  T_46_META_WS_E_FACTION: "Фракция",
  T_46_META_WS_E_FALLING: "Падение",
  T_46_META_WS_E_FALLINGSTAR: "Получить расходный материал",
  T_46_META_WS_E_FALSE: "Нет",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Механизм пропеллера",
  T_46_META_WS_E_FAR: "Далеко",
  T_46_META_WS_E_FEATHER: "Перо",
  T_46_META_WS_E_FEMALE: "Женский",
  T_46_META_WS_E_FENCE: "Забор",
  T_46_META_WS_E_FGL24: "FGL-24",
  T_46_META_WS_E_FIGHTINGENTITY: "FightingEntity",
  T_46_META_WS_E_FILLED: "Заполненный",
  T_46_META_WS_E_FINISH: "Завершить",
  T_46_META_WS_E_FINISHINGPOINT: "Конечная точка",
  T_46_META_WS_E_FINISHLINEARCH: "Баннер финиша",
  T_46_META_WS_E_FIRE: "Огонь",
  T_46_META_WS_E_FIRECHARGE: "Огненный шар",
  T_46_META_WS_E_FIREWORK: "Фейерверк",
  T_46_META_WS_E_FIRINGEFFECT: "Эффект стрельбы",
  T_46_META_WS_E_FIRSTPERSON: "Камера от первого лица",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Камера от первого лица (классический вид)",
  T_46_META_WS_E_FIST: "Кулак",
  T_46_META_WS_E_FIT: "Подходит",
  T_46_META_WS_E_FLAG: "Флаг",
  T_46_META_WS_E_FLAME: "Огонь",
  T_46_META_WS_E_FLAMEGUN: "Огнемет",
  T_46_META_WS_E_FLAMETHROWER: "Огнемет",
  T_46_META_WS_E_FLASH: "Светошумовая граната",
  T_46_META_WS_E_FLASHBANG: "Светошумовая Граната",
  T_46_META_WS_E_FLASHBANGSPARKS: "Дым от ослепляющего заряда",
  T_46_META_WS_E_FLASHFREEZE: "Заморозка",
  T_46_META_WS_E_FLEXWALL: "Раздвижная стена",
  T_46_META_WS_E_FLICKER: "Мерцание",
  T_46_META_WS_E_FLOWER: "Цветок",
  T_46_META_WS_E_FLYBOMBBEE: "Летучая бомба-пчела",
  T_46_META_WS_E_FLYPAN: "Механизм сковороды",
  T_46_META_WS_E_FLYSHOE: "Летающие ботинки",
  T_46_META_WS_E_FOLDER: "Папка",
  T_46_META_WS_E_FOLDWINGS: "Складные крылья",
  T_46_META_WS_E_FOODTRUCK: "Фургон с едой",
  T_46_META_WS_E_FOODTRUCKB: "Маленький фургончик с едой B",
  T_46_META_WS_E_FOOTBALL: "Футбол",
  T_46_META_WS_E_FOOTBALLGUN: "Футбольное оружие",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Футбольный стрелок",
  T_46_META_WS_E_FORCE: "Сила",
  T_46_META_WS_E_FOREGRIP_MR: "FOREGRIP_MR",
  T_46_META_WS_E_FOREGRIP1: "Foregrip1",
  T_46_META_WS_E_FOREGRIP2: "Передняя рукоятка2",
  T_46_META_WS_E_FOREGRIP3: "Foregrip3",
  T_46_META_WS_E_FORWARD: "Вперед",
  T_46_META_WS_E_FOUNTAIN: "Фонтан",
  T_46_META_WS_E_FREE: "Свободная камера",
  T_46_META_WS_E_FREEZEALL: "Заморозить всё",
  T_46_META_WS_E_FREEZEPOSITION: "Заморозить позицию",
  T_46_META_WS_E_FREEZEPOSITIONX: "Заморозить позицию X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Заморозить позицию Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Заморозить позицию Z",
  T_46_META_WS_E_FREEZEROTATION: "Заморозить поворот",
  T_46_META_WS_E_FREEZEROTATIONX: "Заморозить поворот X",
  T_46_META_WS_E_FREEZEROTATIONY: "Заморозить поворот Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Заморозить поворот Z",
  T_46_META_WS_E_FREEZEZONE: "Замороженная зона",
  "T_46_META_WS_E_FROST GALAXY": "Ледяная Галактика",
  T_46_META_WS_E_FROZEN: "Заморозка",
  T_46_META_WS_E_FROZENGRENADE: "Крио-граната",
  T_46_META_WS_E_FUNCTIONALITEMS: "Функциональные предметы",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Игра",
  T_46_META_WS_E_GAMEOVER: "Конец игры 2",
  T_46_META_WS_E_GAMESTART: "Начало игры",
  T_46_META_WS_E_GARAGE: "Гараж",
  T_46_META_WS_E_GATLING: "Миниган",
  T_46_META_WS_E_GEARSWITCHEDON: "Активирован механизм",
  T_46_META_WS_E_GENTLETAP: "Легкое касание",
  T_46_META_WS_E_GETITEM: "Получить расходный материал 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Призрак",
  T_46_META_WS_E_GIANTDICE: "Кубик",
  T_46_META_WS_E_GIANTLOLLIPOP: "Огромный леденец",
  T_46_META_WS_E_GIFT: "Подарок",
  T_46_META_WS_E_GLOOWALL: "Стена",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Цветочная клумба с темой BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Граффити стена",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Крюковая Пушка",
  T_46_META_WS_E_GREATCONDUCTOR: "GreatConductor",
  T_46_META_WS_E_GREEN: "Зеленый",
  T_46_META_WS_E_GRENADE: "Граната",
  T_46_META_WS_E_GRID: "Сетка",
  T_46_META_WS_E_GROZA: "ГРОЗА",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Турель",
  T_46_META_WS_E_GUILD: "Гильдия",
  T_46_META_WS_E_GUN: "Оружие",
  T_46_META_WS_E_GUNFIRE: "Стрельба",
  T_46_META_WS_E_HALO: "Нимб",
  T_46_META_WS_E_HAMMER: "Механизм гигантского молота",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Сушилка для одежды",
  T_46_META_WS_E_HARD: "Сложный",
  T_46_META_WS_E_HATTRICK: "Навык 8",
  T_46_META_WS_E_HAYSTACK: "Стог сена",
  T_46_META_WS_E_HEAD: "Головной убор",
  T_46_META_WS_E_HEADSHOOT: "Хэдшот",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Лечащий пистолет",
  T_46_META_WS_E_HEART: "Сердце",
  T_46_META_WS_E_HEARTBEAT: "Сердцебиение",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "HeavyWeapon",
  T_46_META_WS_E_HELL: "Очень сложно",
  T_46_META_WS_E_HELMET: "Шлем",
  T_46_META_WS_E_HELMET1: "Helmet1",
  T_46_META_WS_E_HELMET2: "Helmet2",
  T_46_META_WS_E_HELMET3: "Helmet3",
  T_46_META_WS_E_HEXAGON: "Шестиугольник",
  T_46_META_WS_E_HGAMMO: "Патроны HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Огнемет для игры в прятки",
  T_46_META_WS_E_HIDERKILL: "Прячущийся устранен",
  T_46_META_WS_E_HIHATS: "Закрытые тарелки",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Тупой удар",
  T_46_META_WS_E_HITEFFECT: "Эффект попадания пули",
  T_46_META_WS_E_HITFEEDBACK: "Обратная связь по стрельбе",
  T_46_META_WS_E_HOOK: "Крючок",
  T_46_META_WS_E_HOOKGUN: "Крюковая Пушка",
  T_46_META_WS_E_HOOKGUNAMMO: "Боеприпасы для крючковой пушки",
  T_46_META_WS_E_HORIZALINE: "Горизалин",
  T_46_META_WS_E_HORIZONTAL: "Горизонтальный",
  T_46_META_WS_E_HORN: "Динамик",
  T_46_META_WS_E_HORROR: "Ужас",
  T_46_META_WS_E_HOURGLASS: "Песочные часы",
  T_46_META_WS_E_HOUSE: "Дом",
  T_46_META_WS_E_HOUSEA: "Одноэтажный дом",
  T_46_META_WS_E_HOUSEB: "Двухэтажный дом",
  T_46_META_WS_E_HOUSEC: "Трехэтажный дом",
  T_46_META_WS_E_HP: "ХП",
  T_46_META_WS_E_HPBUFF: "ХП Бафф",
  T_46_META_WS_E_HUT: "Кабина",
  T_46_META_WS_E_ICEA: "Лёд A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "IceWallMaker",
  T_46_META_WS_E_ICONOBJECT: "Иконка",
  T_46_META_WS_E_IMAGEWIDGET: "Виджет изображения",
  T_46_META_WS_E_IMPULSE: "Импульс",
  T_46_META_WS_E_INHALER: "Ингалятор",
  T_46_META_WS_E_INJUREDFEMALE: "Крик женщины при попадании",
  T_46_META_WS_E_INJUREDMALE: "Крик мужчины при попадании",
  T_46_META_WS_E_INK: "Эффект чернил",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Виджет ввода текста",
  T_46_META_WS_E_INSECTCHIRPING: "Жужжание насекомых",
  T_46_META_WS_E_INTERVAL10SECONDS: "10с",
  T_46_META_WS_E_INTERVAL15SECONDS: "15с",
  T_46_META_WS_E_INTERVAL30SECONDS: "30с",
  T_46_META_WS_E_INTERVAL3SECONDS: "3с",
  T_46_META_WS_E_INTERVAL5SECONDS: "5с",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999с",
  T_46_META_WS_E_INVISIBLE: "Невидимость",
  T_46_META_WS_E_IPIPE: "Труба I",
  T_46_META_WS_E_IRONFENCE: "Забор",
  T_46_META_WS_E_IRONFENCEB: "Забор B",
  T_46_META_WS_E_IRONPLATFORM: "Железная платформа",
  T_46_META_WS_E_ITEMENTITY: "Генератор расходных материалов",
  T_46_META_WS_E_JEEP: "Джип",
  T_46_META_WS_E_JERRYCAN: "Бочка с нефтью",
  T_46_META_WS_E_JERSEYMACHINE: "Машина для изготовления футбольных форм",
  T_46_META_WS_E_JOINEDGAMEDULL: "Присоединиться к битве",
  T_46_META_WS_E_JOINGAME: "Присоединиться к игре",
  T_46_META_WS_E_JOYSTICKWIDGET: "Виджет джойстика",
  T_46_META_WS_E_JUMP: "Прыжок",
  T_46_META_WS_E_JUMPATTACK: "Прыжковая атака",
  T_46_META_WS_E_JUSTPATROL: "JustPatrol",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Катана",
  T_46_META_WS_E_KEY: "Ключ",
  T_46_META_WS_E_KICK: "Удар",
  T_46_META_WS_E_KILLINGTIPS: "Подсказки об убийствах",
  T_46_META_WS_E_KILLZONE: "KillZone",
  T_46_META_WS_E_KINEMATIC: "Кинематический",
  T_46_META_WS_E_KNIFE: "Нож",
  T_46_META_WS_E_KNOCKDOWN: "Нокдаун",
  T_46_META_WS_E_KNOCKEDDOWN: "Нокаут",
  T_46_META_WS_E_KORD: "Корд",
  T_46_META_WS_E_LABELWIDGET: "Виджет метки",
  T_46_META_WS_E_LANDINGA: "Площадка лестницы A",
  T_46_META_WS_E_LANDINGB: "Площадка лестницы B",
  T_46_META_WS_E_LANDINGC: "Площадка лестницы C",
  T_46_META_WS_E_LANDMINE: "Мина",
  T_46_META_WS_E_LANUNCHERAMMO: "Боеприпасы для гранатомета",
  T_46_META_WS_E_LASER: "Эффект лазера",
  T_46_META_WS_E_LASERSKILL: "Лазерный навык",
  T_46_META_WS_E_LATTICESCREEN: "Экран",
  T_46_META_WS_E_LAWNA: "Лужайка A",
  T_46_META_WS_E_LAWNB: "Лужайка B",
  T_46_META_WS_E_LAYOUTWIDGET: "Виджет макета",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Мертвая древесина",
  T_46_META_WS_E_LEVELMAXED: "Максимальный уровень",
  T_46_META_WS_E_LEVELUP: "Повышение ранга",
  T_46_META_WS_E_LEVELUPDISCARDED: "Повышение ранга",
  T_46_META_WS_E_LIGHTBEAM: "Луч света",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Световой луч",
  T_46_META_WS_E_LIGHTEFFECT: "Световой эффект",
  T_46_META_WS_E_LIGHTNING: "Молния",
  T_46_META_WS_E_LIMB: "Конечность",
  T_46_META_WS_E_LINE: "Линия",
  T_46_META_WS_E_LIQUID: "Жидкость",
  T_46_META_WS_E_LOCAL: "Локальный",
  T_46_META_WS_E_LOCALPOSITION: "Локальные координаты",
  T_46_META_WS_E_LOCK: "Замок",
  T_46_META_WS_E_LONGBOX: "Длинный деревянный ящик",
  T_46_META_WS_E_LOOP: "Цикл",
  T_46_META_WS_E_LOOTITEMBOX: "Взять оружие",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Взять боеприпасы",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Взять броню",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Взять потребительские",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Взять метательные предметы",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Взять прицел",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Ящик с добычей Футб",
  T_46_META_WS_E_LOOTSOCCERICE: "Лут Ледяной Футбол",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Случайный лут на футболе",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Футбольный щит",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Случайная добыча оружия",
  T_46_META_WS_E_LOSE: "Поражение",
  T_46_META_WS_E_LOUDSPEAKER: "Динамик",
  T_46_META_WS_E_LOWFALLING: "Падающий",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Граната M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Специализированная граната M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Паранг",
  T_46_META_WS_E_MACHINEGUN: "ПП",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Магазин 1",
  T_46_META_WS_E_MAGEZINE2: "Magezine2",
  T_46_META_WS_E_MAGEZINE3: "Magezine3",
  T_46_META_WS_E_MAGMAA: "Магма A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Лупа",
  T_46_META_WS_E_MALE: "Мужской",
  T_46_META_WS_E_MARK: "Знак",
  T_46_META_WS_E_MARKER: "Метка",
  T_46_META_WS_E_MASK: "Грим",
  T_46_META_WS_E_MAXVALUE: "Максимальное значение",
  T_46_META_WS_E_MECHANICAL: "Быстрое звяканье 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Эхо механического устройства",
  T_46_META_WS_E_MEDICALPROPS: "Медицинские предметы",
  T_46_META_WS_E_MEDICALTENT: "Медицинская палатка",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Среднее сердцебиение",
  T_46_META_WS_E_MEDKIT: "Аптечка",
  T_46_META_WS_E_MELEE: "Холодное оружие",
  T_46_META_WS_E_MELEEWEAPONS: "Холодное оружие",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Микрофон",
  T_46_META_WS_E_MIDDLE: "Средний",
  T_46_META_WS_E_MINIHANDLE: "Мини-рукоятка",
  T_46_META_WS_E_MINIMAP: "Мини-карта",
  T_46_META_WS_E_MINISENTRY: "Мини-сентри",
  T_46_META_WS_E_MINVALUE: "Минимальное значение",
  T_46_META_WS_E_MISSILEEXPLODE: "Оружие типа ракеты",
  T_46_META_WS_E_MISSIONCOMPLETE: "Успех миссии 1",
  T_46_META_WS_E_MISTAKE: "Ошибка",
  T_46_META_WS_E_MODERATE: "Умеренный",
  T_46_META_WS_E_MONEY: "Деньги",
  T_46_META_WS_E_MONSTER: "Зомби",
  T_46_META_WS_E_MONSTERSPAWN: "Точка появления монстра",
  T_46_META_WS_E_MONSTERTRUCK: "Monster_Truck",
  T_46_META_WS_E_MOON: "Луна",
  T_46_META_WS_E_MOSQUITO: "Комар",
  T_46_META_WS_E_MOTIONTRAIL: "След движения",
  T_46_META_WS_E_MOTOBIKE: "Мотоцикл",
  T_46_META_WS_E_MOTORBIKE: "Мотоцикл",
  T_46_META_WS_E_MOVE: "Двигать",
  T_46_META_WS_E_MOVEMENT: "Двигаться",
  T_46_META_WS_E_MOVINGJOYSTICK: "Движение джойстиком",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "MrV",
  T_46_META_WS_E_MULTIPLIER: "Множитель",
  T_46_META_WS_E_MULTIPLY: "Умножить",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Умножить и накапливать",
  T_46_META_WS_E_MUSHROOM1: "Гриб 1",
  T_46_META_WS_E_MUSHROOM2: "Mushroom2",
  T_46_META_WS_E_MUSHROOM3: "Mushroom3",
  T_46_META_WS_E_MUSHROOM4: "Mushroom4",
  T_46_META_WS_E_MUSHSHADE: "Кластер гигантских грибов",
  T_46_META_WS_E_MUSIC: "Музыка",
  T_46_META_WS_E_MUZZLE1: "Muzzle1",
  T_46_META_WS_E_MUZZLE2: "Muzzle2",
  T_46_META_WS_E_MUZZLE3: "Muzzle3",
  T_46_META_WS_E_NEAR: "Близко",
  T_46_META_WS_E_NIGHT: "Ночь",
  T_46_META_WS_E_NOATTACK: "Без атаки",
  T_46_META_WS_E_NODUALWIELDING: "Невозможно использовать двойное оружие",
  T_46_META_WS_E_NOERROR: "Нет ошибки",
  T_46_META_WS_E_NONE: "Нет",
  T_46_META_WS_E_NORMAL: "Нормальный",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Без пропуска поверженного",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Навык 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Получить среднее золото",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Получить большие золото",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Получить малое золото",
  T_46_META_WS_E_OILDRUMEXPLODE: "Взрыв бочки с маслом",
  T_46_META_WS_E_ONCE: "Один раз",
  T_46_META_WS_E_ONEWAY: "Односторонний",
  T_46_META_WS_E_OPENFOLDER: "Открытая папка",
  T_46_META_WS_E_OPENHIHATS: "Открытые тарелки",
  T_46_META_WS_E_OPENINGBOX: "Открыть коробку",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Поставка гильдии",
  T_46_META_WS_E_OPENINGWARCHEST: "Сохранить склад",
  T_46_META_WS_E_ORANGE: "Оранжевый",
  T_46_META_WS_E_ORTHOGONAL: "Ортогональный",
  T_46_META_WS_E_OUTPOST: "Охрана",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Расписная стена",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Навык алого бассейна",
  T_46_META_WS_E_PALM: "Бумага",
  T_46_META_WS_E_PANEL: "Панель",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Пассажир A",
  T_46_META_WS_E_PASSENGERB: "Пассажир B",
  T_46_META_WS_E_PASSENGERC: "Пассажир C",
  T_46_META_WS_E_PASSIVE: "Пассивный",
  T_46_META_WS_E_PASSIVESKILL: "Пассивный навык",
  T_46_META_WS_E_PATROLWHILEATTACK: "Патруль и атака",
  T_46_META_WS_E_PERSONALUAV: "Личный Дрон",
  T_46_META_WS_E_PERSPECTIVE: "Перспективный",
  T_46_META_WS_E_PETTABBG: "Питомец",
  T_46_META_WS_E_PHASESTART: "Начало фазы",
  T_46_META_WS_E_PHONEBOOTH: "Телефонная будка",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Музыкальные ноты - Пианино",
  T_46_META_WS_E_PIANOKEY2: "Музыкальные ноты - Пианино",
  T_46_META_WS_E_PICKUPS: "Подбор предметов",
  T_46_META_WS_E_PICKUPTRUCK: "Внедорожник",
  T_46_META_WS_E_PILLAR: "Бетонная колонна",
  T_46_META_WS_E_PIN: "Вызов",
  T_46_META_WS_E_PINGPONG: "Пинг-понг",
  T_46_META_WS_E_PIPECORNER: "Трубка с углом",
  T_46_META_WS_E_PIPEINTERSECTION: "Перекрестная труба",
  T_46_META_WS_E_PISTOL: "Пистолет",
  T_46_META_WS_E_PISTOLAMMO: "Боеприпасы для пистолета",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Плитка для парка аттракционов в клеточку",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Игрок",
  T_46_META_WS_E_PLUS: "Плюс",
  T_46_META_WS_E_PODIUM: "Подиум",
  T_46_META_WS_E_POISONGAS: "Ядовитый газ",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Ядовитый газ",
  T_46_META_WS_E_PORTAL: "Портал",
  T_46_META_WS_E_POSTACCUMULATOR: "Пост-аккумулятор",
  T_46_META_WS_E_POT: "Горшок",
  T_46_META_WS_E_POUNDINGHEART: "Быстрое сердцебиение",
  T_46_META_WS_E_PREACCUMULATOR: "Предварительный аккумулятор",
  T_46_META_WS_E_PRIMARYWEAPONA: "Основное оружие A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Основное оружие B",
  T_46_META_WS_E_PRIOREXPLOSION: "Перед взрывом бомбы",
  T_46_META_WS_E_PROFILEWIDGET: "Виджет профиля",
  T_46_META_WS_E_PRONE: "Лежачий",
  T_46_META_WS_E_PUMPKIN: "Тыква",
  T_46_META_WS_E_PURPLE: "Фиолетовый",
  T_46_META_WS_E_QUADRILATERAL: "Четырехугольник",
  T_46_META_WS_E_QUESTIONMARK: "Вопросительный знак",
  T_46_META_WS_E_QUICKCHAT: "Быстрый чат",
  T_46_META_WS_E_QUICKCHATSHOW: "Отображение быстрого чата",
  T_46_META_WS_E_RADIAL180: "Радиальный 180°",
  T_46_META_WS_E_RADIAL360: "Радиальный 360°",
  T_46_META_WS_E_RADIAL90: "Радиальный 90°",
  T_46_META_WS_E_RAMPAGE: "Катаклизм",
  T_46_META_WS_E_RANDOM: "Случайный",
  T_46_META_WS_E_RANDOMBUFF: "Случайный бафф",
  T_46_META_WS_E_RANKDOWN: "Понижение ранга",
  T_46_META_WS_E_REACTION: "Реагировать",
  T_46_META_WS_E_RECOVER: "Восстановление",
  T_46_META_WS_E_RECYCLE: "Переработка",
  T_46_META_WS_E_RED: "Красный",
  T_46_META_WS_E_REFINERYTANK: "Водяной кувшин",
  T_46_META_WS_E_REFLECTIVECUBE: "Отражающий блок основного цвета 1",
  T_46_META_WS_E_REFRESH: "Обновить",
  T_46_META_WS_E_RELEASINGSKILL: "Эффект использования навыка",
  T_46_META_WS_E_RELOAD: "Перезарядка",
  T_46_META_WS_E_REMINDER: "Напоминание",
  T_46_META_WS_E_REPAIR: "Ремонт",
  T_46_META_WS_E_REPAIREQUIP: "Ремонт оборудования",
  T_46_META_WS_E_REPAIRKIT: "Набор для ремонта",
  T_46_META_WS_E_REPLACER: "Заменитель",
  T_46_META_WS_E_REPORT: "Сообщить",
  T_46_META_WS_E_REST: "Отдых",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Райд",
  T_46_META_WS_E_RIDICULE: "Насмешка",
  T_46_META_WS_E_RIDICULEFUNNY: "Смешная насмешка",
  T_46_META_WS_E_RIFLE: "Винтовка",
  T_46_META_WS_E_RIFLEAMMO: "Боеприпасы для винтовки",
  T_46_META_WS_E_RIGHT: "Правильно",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Прямоугольный трапециевид",
  T_46_META_WS_E_RING: "Механизм кольца",
  T_46_META_WS_E_RINGPREDISCARDED: "RingPreDiscarded",
  T_46_META_WS_E_RIPTIDERHYTHM: "Навык 9",
  T_46_META_WS_E_RISINGPARTICLE: "Восходящие частицы",
  T_46_META_WS_E_ROADBLOCK: "Баррикада",
  T_46_META_WS_E_ROTATE: "Вращение",
  T_46_META_WS_E_RUNNING: "Работающий",
  T_46_META_WS_E_RUSHTIME: "Катаклизм",
  T_46_META_WS_E_SAMURAI: "Самурай",
  T_46_META_WS_E_SANDA: "Песок A",
  T_46_META_WS_E_SANDSTRUCTURE: "Песчаная скульптура",
  T_46_META_WS_E_SCALE: "Масштаб",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Чучело",
  T_46_META_WS_E_SCISSORS: "Ножницы",
  T_46_META_WS_E_SCOPE2X: "2x прицел",
  T_46_META_WS_E_SCOPE4X: "4x прицел",
  T_46_META_WS_E_SCROLLPANEL: "Панель прокрутки",
  T_46_META_WS_E_SECONDARYWEAPON: "SecondaryWeapon",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Навык 10",
  T_46_META_WS_E_SERVER: "Сервер",
  T_46_META_WS_E_SET: "Комбинезон",
  T_46_META_WS_E_SETTING: "Настройки",
  T_46_META_WS_E_SETTINGS: "Настройки",
  T_46_META_WS_E_SG: "Дробовик",
  T_46_META_WS_E_SGAMMO: "Патроны SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Быстрое звяканье 1",
  T_46_META_WS_E_SHIELD: "Оборона",
  T_46_META_WS_E_SHIELDBROKEN: "Щит сломан",
  T_46_META_WS_E_SHIELDGUN: "Щитовая Пушка",
  T_46_META_WS_E_SHIELDUP: "Щит поднят",
  T_46_META_WS_E_SHOCKWAVE: "Ударная волна",
  T_46_META_WS_E_SHOES: "Обувь",
  T_46_META_WS_E_SHOOTINGTARGET: "Двигающаяся мишень",
  T_46_META_WS_E_SHORTDATE: "Короткая дата",
  T_46_META_WS_E_SHORTDATETIME: "Короткие дата и время",
  T_46_META_WS_E_SHORTTIME: "Короткое время",
  T_46_META_WS_E_SHOTGUN: "Дробовик",
  T_46_META_WS_E_SHOTGUNAMMO: "Патроны для дробовика",
  T_46_META_WS_E_SHOTGUNMUZZLE: "ShotgunMuzzle",
  T_46_META_WS_E_SHOW: "Показать",
  T_46_META_WS_E_SHRUB: "Длинный деревянный ящик, покрытый кустарником",
  T_46_META_WS_E_SICKLE: "Коса",
  T_46_META_WS_E_SIDESCROLLING: "Боковой вид",
  T_46_META_WS_E_SIGNAL: "Сигнал",
  T_46_META_WS_E_SIGNOUT: "Выход",
  T_46_META_WS_E_SILENCER: "Глушитель",
  T_46_META_WS_E_SIMPLE: "Простой",
  T_46_META_WS_E_SIMPLEWIDGET: "Простой виджет",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Одиночный",
  T_46_META_WS_E_SITEHUT: "Контейнерный дом",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Завершение зарядки навыков",
  T_46_META_WS_E_SKILLRECOVER: "Восстановление навыков",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Пропустить поверженного",
  T_46_META_WS_E_SKS: "СКС",
  T_46_META_WS_E_SLICED: "Нарезанный",
  T_46_META_WS_E_SLOPE: "Склон",
  T_46_META_WS_E_SLOWHEARTBEAT: "Медленное сердцебиение",
  T_46_META_WS_E_SMG: "ПП",
  T_46_META_WS_E_SMGAMMO: "Патроны ПП",
  T_46_META_WS_E_SMGMUZZLE: "Дульный тормоз для пистолета-пулемета",
  T_46_META_WS_E_SMILEY: "Улыбающееся лицо",
  T_46_META_WS_E_SMOKE: "Дым",
  T_46_META_WS_E_SMOKEGRENADE: "Дымовая граната",
  T_46_META_WS_E_SMOKEY: "Дым",
  T_46_META_WS_E_SMOOTH: "Плавный",
  T_46_META_WS_E_SNAMMO: "Патроны SN",
  T_46_META_WS_E_SNARES: "Малые барабаны",
  T_46_META_WS_E_SNEAKERS: "Эффект беговых туфель",
  T_46_META_WS_E_SNIPER: "Снайперская винтовка",
  T_46_META_WS_E_SNIPERAMMO: "Патроны для снайперской винтовки",
  T_46_META_WS_E_SNOWA: "Снег A",
  T_46_META_WS_E_SNOWFLAKE: "Снежинка",
  T_46_META_WS_E_SOCCER: "Футбол",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Виджет социальных кнопок",
  T_46_META_WS_E_SOLARPANEL: "Солнечная панель",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "По приоритету от высокого к низкому",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "По приоритету от низкого к высокому",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Эффект точки появления",
  T_46_META_WS_E_SPEAKER: "Громкоговоритель",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Специальный звук оружия",
  T_46_META_WS_E_SPECIALGUN: "Специальное оружие",
  T_46_META_WS_E_SPHERE: "Сфера",
  T_46_META_WS_E_SPHERETRIGGER: "Сферический коллизионный триггер",
  T_46_META_WS_E_SPIDERWEB: "Эффект навыка",
  T_46_META_WS_E_SPORTSCAR: "Спорткар",
  T_46_META_WS_E_SPOTLIGHT: "Свет",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Рассеивание ядовитого газа",
  T_46_META_WS_E_SPRINT: "Мчится",
  T_46_META_WS_E_SQUARE: "Квадрат",
  T_46_META_WS_E_SQUAREBOX: "Квадратный деревянный ящик",
  T_46_META_WS_E_SR: "Снайперская винтовка",
  T_46_META_WS_E_STABLE: "Стабильный",
  T_46_META_WS_E_STAIRS: "Лестница",
  T_46_META_WS_E_STANDING: "Стоящий",
  T_46_META_WS_E_STAR: "Звезда",
  T_46_META_WS_E_STATIC: "Статический",
  T_46_META_WS_E_STATUSTRIGGER: "Триггер устранения или неуязвимости",
  T_46_META_WS_E_STEP: "Шаги",
  T_46_META_WS_E_STEPTRIGGER: "Активировать механизм",
  T_46_META_WS_E_STOCK_S: "STOCK_S",
  T_46_META_WS_E_STOCK_SR: "STOCK_SR",
  T_46_META_WS_E_STOCK1: "Stock1",
  T_46_META_WS_E_STOCK2: "Stock2",
  T_46_META_WS_E_STOCK3: "Stock3",
  T_46_META_WS_E_STONE: "Камень",
  T_46_META_WS_E_STONEBRIDGE: "Каменный арочный мост",
  T_46_META_WS_E_STONELANTERN: "Дворцовый фонарь",
  T_46_META_WS_E_STONESPLASH: "Летающие обломки",
  T_46_META_WS_E_STORE: "Магазин",
  T_46_META_WS_E_STREETLAMP: "Уличный светильник",
  T_46_META_WS_E_STYLEA: "Стиль A",
  T_46_META_WS_E_STYLEB: "Стиль B",
  T_46_META_WS_E_STYLEC: "Стиль C",
  T_46_META_WS_E_SUBMACHINEGUN: "ПП",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Патроны для пистолета-пулемета",
  T_46_META_WS_E_SUCCESSFULHIT: "Попадание",
  T_46_META_WS_E_SUN: "Солнце",
  T_46_META_WS_E_SUNSHADE: "Комплект для патио с зонтом",
  T_46_META_WS_E_SUPERCAR: "Спортивный автомобиль",
  T_46_META_WS_E_SUPERMARKET: "Супермаркет",
  T_46_META_WS_E_SURPRISEFIND: "Открыть сюрприз",
  T_46_META_WS_E_SUV: "Внедорожник",
  T_46_META_WS_E_SVD: "СВД",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Быстрая смена оружия",
  T_46_META_WS_E_SWIMRING: "Спасательный круг",
  T_46_META_WS_E_SWORD: "Меч",
  T_46_META_WS_E_SYMBOLIC: "Разметка на земле",
  T_46_META_WS_E_TANKZOMBIE: "Танковый зомби",
  T_46_META_WS_E_TAP: "Нажать",
  T_46_META_WS_E_TAPPINGBUTTON: "Кнопка нажать",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Нажать кнопку отключения",
  T_46_META_WS_E_TEAM: "Команда",
  T_46_META_WS_E_TEAMMATESINFO: "Информация о товарищах",
  T_46_META_WS_E_TELEPORT: "Телепортация",
  T_46_META_WS_E_TELEPORTCORRECT: "Правильная цель маяка",
  T_46_META_WS_E_TELEPORTWRONG: "Неправильная цель маяка",
  T_46_META_WS_E_TEXT: "Текст",
  T_46_META_WS_E_TEXTOBJECT: "Текст",
  T_46_META_WS_E_TEXTUREWIDGET: "Виджет текстуры",
  T_46_META_WS_E_THERMALSCOPE: "Термальный прицел",
  T_46_META_WS_E_THIRDPERSON: "Камера от третьего лица",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Камера от третьего лица (классический вид)",
  T_46_META_WS_E_THIRDPERSONLOCK: "Камера от третьего лица (фиксация на спине)",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "ThowingKnife2ForCompatibility",
  T_46_META_WS_E_THRILLBATTLE: "Навык 5",
  T_46_META_WS_E_THROWATTACK: "Бросить гранату",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Метатель-красный зомби",
  T_46_META_WS_E_THROWZOMBIE: "Метатель-зомби",
  T_46_META_WS_E_THUMBSUP: "Лайк",
  T_46_META_WS_E_THUNDER: "Электрошок",
  T_46_META_WS_E_TILEA: "Плитка A",
  T_46_META_WS_E_TILEB: "Плитка B",
  T_46_META_WS_E_TILEC: "Плитка C",
  T_46_META_WS_E_TILED: "Мозаичный",
  T_46_META_WS_E_TIPSSOUND: "Показать советы",
  T_46_META_WS_E_TOGGLEWIDGET: "Виджет переключателя",
  T_46_META_WS_E_TOILETBOWL: "Туалет",
  T_46_META_WS_E_TONEA: "Камень A",
  T_46_META_WS_E_TOP: "Верхняя одежда",
  T_46_META_WS_E_TOPDOWN: "Вид сверху",
  T_46_META_WS_E_TORII: "Тории",
  T_46_META_WS_E_TOUCHPADWIDGET: "Виджет сенсорной панели",
  T_46_META_WS_E_TOWER: "Крепость",
  T_46_META_WS_E_TPIPE: "Труба T",
  T_46_META_WS_E_TRACINGSTEPS: "Навык 3",
  T_46_META_WS_E_TRAILER: "Прицеп",
  T_46_META_WS_E_TRANSFORMATION: "Превращение",
  T_46_META_WS_E_TRANSPARENT: "Прозрачный",
  T_46_META_WS_E_TRAPEZOID: "Трапеция",
  T_46_META_WS_E_TRASHCAN: "Мусорное ведро",
  T_46_META_WS_E_TRIANGLE: "Треугольник",
  T_46_META_WS_E_TRIGGERS: "Триггер",
  T_46_META_WS_E_TRIPLE: "Тройной",
  T_46_META_WS_E_TROPHY: "Трофей",
  T_46_META_WS_E_TRUE: "Да",
  T_46_META_WS_E_TUKTUK: "Тук-тук",
  T_46_META_WS_E_TUTUCAR: "Тук-тук",
  T_46_META_WS_E_TYRANTZOMBIE: "Тиран-зомби",
  T_46_META_WS_E_UAVLITE: "Легкий Дрон",
  T_46_META_WS_E_UIFINISH: "Конец",
  T_46_META_WS_E_UITAP: "Нажатие интерфейса",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Генератор единиц",
  T_46_META_WS_E_UPWARDTURBULENCE: "Восходящий поток",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "УЗИ",
  T_46_META_WS_E_VAULTOVER: "Перепрыгнуть",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Транспортное средство",
  T_46_META_WS_E_VEHICLEEXPLODE: "Взрыв транспортного средства",
  T_46_META_WS_E_VELOCITY: "Скорость",
  T_46_META_WS_E_VENDINGMACHINE: "Торговый автомат",
  T_46_META_WS_E_VERTICAL: "Вертикальный",
  T_46_META_WS_E_VEST: "Бронежилет",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Vest4",
  T_46_META_WS_E_VISUALEFFECTS: "Визуальные эффекты",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Стена A",
  T_46_META_WS_E_WALLBRAWL: "Навык 2",
  T_46_META_WS_E_WARNING: "Предупреждение",
  T_46_META_WS_E_WATERRING: "Всплеск воды",
  T_46_META_WS_E_WAVE1: "Wave1",
  T_46_META_WS_E_WAVE2: "Wave2",
  T_46_META_WS_E_WAVE3: "Wave3",
  T_46_META_WS_E_WEAPONGENERATOR: "Оружие",
  T_46_META_WS_E_WEAPONSLOT: "Слот для оружия",
  T_46_META_WS_E_WHISTLE: "Побеждать врага",
  T_46_META_WS_E_WIDERANGE: "Широкий диапазон",
  T_46_META_WS_E_WIN: "Победа",
  T_46_META_WS_E_WINDATTACK: "Атака торнадо",
  T_46_META_WS_E_WOODA: "Дерево A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Древоруб-зомби",
  T_46_META_WS_E_WOODENPLANK: "Деревянный мост",
  T_46_META_WS_E_WORLDPOSITION: "Мировые координаты",
  T_46_META_WS_E_WRECKEDBUS: "Разрушенный автобус",
  T_46_META_WS_E_WRECKEDCAR: "Разрушенная машина",
  T_46_META_WS_E_WRONG: "Ошибка",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Зомби",
  T_46_META_WS_E_ZOMBIES: "Зомби",
  T_46_META_WS_E_ZOOM: "Приближение",
  T_46_META_WS_ELIMINATE: "Устранить",
  T_46_META_WS_ELIMINATEDENTITY: "Устраненный игрок",
  T_46_META_WS_ELIMINATEDPLAYER: "Устраненный игрок",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Включить дерево поведения по умолчанию",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Включить Двигающуюся Зону Безопасности",
  T_46_META_WS_ENABLESAFEZONE: "Включить Зону Безопасности",
  T_46_META_WS_ENDCURRENTPHASE: "Завершить Текущую Фазу",
  T_46_META_WS_ENDMORPH: "Завершить преобразование",
  T_46_META_WS_ENDPOSITION: "Конечная позиция",
  T_46_META_WS_ENTERVEHICLE: "Сесть в транспортное средство",
  T_46_META_WS_ENTITY: "Сущность ",
  T_46_META_WS_EQUIPMENTID: "ID снаряжения",
  T_46_META_WS_EULERANGLETOQUATERNION: "Углы Эйлера в кватернион",
  T_46_META_WS_EXITVEHICLE: "Выйти из транспортного средства",
  T_46_META_WS_EXPONENTIATION: "Возведение в степень",
  T_46_META_WS_FILTERENTITY: "Фильтровать сущности",
  T_46_META_WS_FILTERLEVELOBJECTS: "Фильтровать Объекты Уровня",
  T_46_META_WS_FIND: "Найти",
  T_46_META_WS_FINDAT: "Найти по",
  T_46_META_WS_FINDPATH: "Найти путь",
  T_46_META_WS_FLOOR: "Округлить Вниз",
  T_46_META_WS_FOOTBALLGOAL: "Футбольный гол",
  T_46_META_WS_FORMAT: "Форматировать",
  T_46_META_WS_GETALLKEYS: "Получить Все Ключи",
  T_46_META_WS_GETALLPLAYERS: "Получить Всех Игроков",
  T_46_META_WS_GETALLSHOPS: "Получить все магазины",
  T_46_META_WS_GETALLTEAMS: "Получить Все Команды",
  T_46_META_WS_GETATTACKABLEENTITY: "Получить атакуемую сущность",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Получить атакуемые фракции",
  T_46_META_WS_GETBACKPACKSKIN: "Получить скин рюкзака",
  T_46_META_WS_GETBLACKBOARDVALUE: "Получить значение черного доски",
  T_46_META_WS_GETBUFFS: "Получить баффы",
  T_46_META_WS_GETCHATCHANNEL: "Получить канал чата",
  T_46_META_WS_GETCHILDBYINDEX: "Получить ребенка по индексу",
  T_46_META_WS_GETCHILDBYNAME: "Получить ребенка по имени",
  T_46_META_WS_GETCHILDREN: "Получить детей",
  T_46_META_WS_GETCOLORCHANNEL: "Получить цветовой канал",
  T_46_META_WS_GETCONSUMABLES: "Получить расходуемые предметы",
  T_46_META_WS_GETCULLINGMASK: "Получить маску отсечения",
  T_46_META_WS_GETCURRENTCAMERA: "Получить текущую камеру",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Получить текущий канал чата",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Получить прогресс пользовательской миссии",
  T_46_META_WS_GETDYEDCOUNT: "Получить количество окрашиваний",
  T_46_META_WS_GETDYEDSTATUS: "Получить статус окраски",
  T_46_META_WS_GETEQUIPMENTS: "Получить снаряжение",
  T_46_META_WS_GETFACTION: "Получить фракцию",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Получить глобальный порог сна",
  T_46_META_WS_GETITEMCOUNT: "Получить Количество Предметов",
  T_46_META_WS_GETLOADEDSCENES: "Получить загруженные сцены",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Получить локальное направление прицеливания",
  T_46_META_WS_GETLOCALPLAYER: "Получить локального игрока",
  T_46_META_WS_GETLOCALTIMESTAMP: "Получить локальную временную метку",
  T_46_META_WS_GETMAPID: "Получить ID карты",
  T_46_META_WS_GETMINIMAP: "Получить мини-карту",
  T_46_META_WS_GETMONEY: "Получить деньги",
  T_46_META_WS_GETMONEYCOUNT: "Получить количество денег",
  T_46_META_WS_GETMORPH: "Получить преобразование",
  T_46_META_WS_GETNODEVARIABLE: "Получить переменную узла",
  T_46_META_WS_GETOUTFIT: "Получить наряд",
  T_46_META_WS_GETOWNER: "Получить Владельца",
  T_46_META_WS_GETPARENT: "Получить родителя",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Получить Позицию Рядом с Напарником",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Получить Случайную Позицию Спауна",
  T_46_META_WS_GETRESULTFROMCURVE: "Получить результат из кривой",
  T_46_META_WS_GETSCENESKYBOX: "Получить небо сцены",
  T_46_META_WS_GETSERVERREGION: "Получить Регион Сервера",
  T_46_META_WS_GETSERVERTIMESTAMP: "Получить Временную Метку Сервера",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Получить часть скелета по имени",
  T_46_META_WS_GETSKILLS: "Получить навыки",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Получить порог сна",
  T_46_META_WS_GETTOKENCOUNT: "Получить Количество Токенов",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Получить Количество Жетонов Сегодня",
  T_46_META_WS_GETTYPE: "Получить тип",
  T_46_META_WS_GETVEHICLESKIN: "Получить скин транспортного средства",
  T_46_META_WS_GETWALLET: "Получить кошелек",
  T_46_META_WS_GETWEAPONSKIN: "Получить скин оружия",
  T_46_META_WS_GETWIDGETBYPATH: "Получить виджет по пути",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Получить Виджет из Пользовательского UI",
  T_46_META_WS_GIVEJAILBREAKITEM: "Дать предмет за побег из тюрьмы",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Дать вознаграждение за побег из тюрьмы",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Есть особое внимание AOI",
  T_46_META_WS_HASCOMPONENT: "Имеет компонент",
  T_46_META_WS_HASSCRIPT: "Имеется скрипт",
  T_46_META_WS_HASTAG: "Имеется метка",
  T_46_META_WS_HELPEDPLAYER: "Помочь игроку",
  T_46_META_WS_HELPPLAYER: "Помочь игроку",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Скрыть группу внешности",
  T_46_META_WS_HITENTITY: "Попадание в объект",
  T_46_META_WS_HITFLY: "Отправить в полет",
  T_46_META_WS_HITNORMAL: "Нормальное попадание",
  T_46_META_WS_HITOBJECT: "Попадание в объект ",
  T_46_META_WS_HITPOSITION: "Позиция удара",
  T_46_META_WS_INDEXOF: "Индекс",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Зомби Инфицированный Растет",
  T_46_META_WS_INSERT: "Вставить",
  T_46_META_WS_ISATTACKABLE: "Можно атаковать",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Канал чата пуст",
  T_46_META_WS_ISEQUAL: "Равно",
  T_46_META_WS_ISFRIEND: "Является другом",
  T_46_META_WS_ISHIT: "Попадание",
  T_46_META_WS_ISINSIDEBOX: "Внутри Коробки",
  T_46_META_WS_ISINSIDECYLINDER: "Внутри Цилиндра",
  T_46_META_WS_ISINSIDESECTOR: "Внутри Сектора",
  T_46_META_WS_ISINSIDESPHERE: "Внутри Сферы",
  T_46_META_WS_ISSLEEPING: "Спит ли",
  T_46_META_WS_ISSUBTYPEOF: "Является подтипом",
  T_46_META_WS_ITEM: "Предмет",
  T_46_META_WS_ITEMID: "ID предмета",
  T_46_META_WS_JOIN: "Объединить",
  T_46_META_WS_JOINCHATCHANNEL: "Присоединиться к каналу чата",
  T_46_META_WS_JOINFACTION: "Присоединиться к фракции",
  T_46_META_WS_LASTINDEXOF: "Последний Индекс",
  T_46_META_WS_LENGTH: "Длина",
  T_46_META_WS_LERP: "Интерполяция",
  T_46_META_WS_LOADSCENE: "Загрузить сцену",
  T_46_META_WS_LOGARITHM: "Логарифм",
  T_46_META_WS_LOGERROR: "Записать ошибку",
  T_46_META_WS_LOGINFO: "Записать Информацию",
  T_46_META_WS_LOGWARNING: "Записать предупреждение",
  T_46_META_WS_LOOKROTATION: "Поворот взгляда",
  T_46_META_WS_MAGNITUDE: "Модуль",
  T_46_META_WS_MAKER: "Создатель",
  T_46_META_WS_MAX: "Макс",
  T_46_META_WS_MECHANISM: "Механизм",
  T_46_META_WS_MIN: "Мин",
  T_46_META_WS_MONSTERUSESKILL: "Использовать умение",
  T_46_META_WS_MORPHOBJECT: "Объект морфа",
  T_46_META_WS_MORPHTO: "Преобразовать в",
  T_46_META_WS_MORPHTOBYITEMID: "Преобразовать по ID предмета",
  T_46_META_WS_MOVECCT: "Переместить CCT",
  T_46_META_WS_MOVEPOSITION: "Переместить позицию",
  T_46_META_WS_MOVEROTATION: "Переместить вращение",
  T_46_META_WS_MULTIPLYQUATERNION: "Умножить кватернион",
  T_46_META_WS_MULTIRAYCAST: "Многократное лучевое обнаружение",
  T_46_META_WS_NEGATE: "Отрицательное",
  T_46_META_WS_NEW: "Новый",
  T_46_META_WS_NODENAME: "Имя узла",
  T_46_META_WS_NORMALIZE: "Нормализовать",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Уведомить о Воспроизведении Эффекта",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Уведомить о воспроизведении анимации иконки",
  T_46_META_WS_NOTIFYPLAYSOUND: "Уведомить о Воспроизведении Звука",
  T_46_META_WS_NOTIFYSHOWTIPS: "Уведомить о Показе Подсказок",
  T_46_META_WS_NUMTOSTRING: "Преобразовать число в строку",
  T_46_META_WS_ONACCESSEQUIPMENT: "Доступ к снаряжению",
  T_46_META_WS_ONACCESSITEM: "Доступ к предмету",
  T_46_META_WS_ONACCESSWEAPON: "Доступ к оружию",
  T_46_META_WS_ONACE: "Выполнение ACE",
  T_46_META_WS_ONAIMED: "Завершение прицеливания",
  T_46_META_WS_ONAIMING: "Прицеливание",
  T_46_META_WS_ONASSIST: "Ассист",
  T_46_META_WS_ONATTACK: "Атака",
  T_46_META_WS_ONATTACKSTOP: "Остановка атаки",
  T_46_META_WS_ONAWAKE: "Пробуждение",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Падение",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Отскок от шины",
  T_46_META_WS_ONBOUNCEENTITY: "Отскок сущности",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Нажатие встроенной кнопки",
  T_46_META_WS_ONBULLETHIT: "Попадание пули",
  T_46_META_WS_ONCAMERARAYCAST: "Проверка луча камеры",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Удар контроллера персонажа",
  T_46_META_WS_ONCHASE: "Преследование",
  T_46_META_WS_ONCHASESTOP: "Завершение преследования",
  T_46_META_WS_ONCLIPEND: "Окончание клипа",
  T_46_META_WS_ONCOLLISIONENTER: "Начало столкновения",
  T_46_META_WS_ONCOLLISIONEXIT: "Конец столкновения",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Окончание обратного отсчета",
  T_46_META_WS_ONCREEP: "Подкрадывание",
  T_46_META_WS_ONCROUCH: "Приседание",
  T_46_META_WS_ONDEALDAMAGE: "Нанесение урона",
  T_46_META_WS_ONDESTROY: "Уничтожение",
  T_46_META_WS_ONDISABLE: "Отключение",
  T_46_META_WS_ONDISCONNECT: "Отключение",
  T_46_META_WS_ONDOUBLETAPPED: "Двойное нажатие",
  T_46_META_WS_ONDRAG: "Перетаскивание",
  T_46_META_WS_ONDRAGEND: "Завершение перетаскивания",
  T_46_META_WS_ONDRAGSTART: "Начало перетаскивания",
  T_46_META_WS_ONDRIVED: "Вождение",
  T_46_META_WS_ONDRIVEVEHICLE: "Управление транспортом",
  T_46_META_WS_ONDROPCONSUMABLE: "Бросок расходуемого предмета",
  T_46_META_WS_ONDROPPED: "Бросок",
  T_46_META_WS_ONDROPWEAPON: "Бросок оружия",
  T_46_META_WS_ONEACHLOOP: "Каждый цикл",
  T_46_META_WS_ONELIMINATE: "Исключение",
  T_46_META_WS_ONELIMINATED: "Устранение",
  T_46_META_WS_ONENABLE: "Включение",
  T_46_META_WS_ONEND: "Завершение",
  T_46_META_WS_ONENTERED: "Вход",
  T_46_META_WS_ONENTERVEHICLE: "Вход в транспорт",
  T_46_META_WS_ONENTITYENTER: "При входе сущности",
  T_46_META_WS_ONENTITYEXIT: "При выходе сущности",
  T_46_META_WS_ONEQUIPARMOR: "Экипировка брони",
  T_46_META_WS_ONEQUIPED: "Экипировка",
  T_46_META_WS_ONEQUIPWEAPON: "Экипировка оружия",
  T_46_META_WS_ONEXPLODE: "Взрыв",
  T_46_META_WS_ONFALL: "При падении",
  T_46_META_WS_ONFALLSTOP: "При остановке падения",
  T_46_META_WS_ONFIRE: "Стрельба",
  T_46_META_WS_ONFIXEDUPDATE: "Фиксированное обновление",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Столкновение с футбольным мячом",
  T_46_META_WS_ONFRIENDSUPDATE: "Обновление статуса дружбы ",
  T_46_META_WS_ONGAMEEND: "Конец игры",
  T_46_META_WS_ONGAMEPAUSE: "Пауза игры",
  T_46_META_WS_ONGAMERESUME: "Возобновление игры",
  T_46_META_WS_ONGAMESTART: "Начало игры",
  T_46_META_WS_ONGOAL: "Гол",
  T_46_META_WS_ONHITBYBULLET: "Попадание пули",
  T_46_META_WS_ONHITFLY: "Попадание в полет",
  T_46_META_WS_ONHITFLYENTITY: "Попадание в летящую сущность",
  T_46_META_WS_ONHOOKGUNFIRE: "Выстрел из крюкового пистолета",
  T_46_META_WS_ONIDLE: "Простой",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Начало зоны побега",
  T_46_META_WS_ONJAILBREAKAREAEND: "Завершение зоны побега",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Присоединение игрока к зоне побега",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Выход игрока из зоны побега",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Успешное подключение к чату",
  T_46_META_WS_ONJOYSTICKMOVE: "Движение джойстика",
  T_46_META_WS_ONJOYSTICKPRESSED: "Нажатие",
  T_46_META_WS_ONJOYSTICKRELEASED: "Отпускание",
  T_46_META_WS_ONJUMP: "Прыжок",
  T_46_META_WS_ONJUMPSTOP: "При остановке прыжка",
  T_46_META_WS_ONLANDMINEACTIVE: "Активация мины",
  T_46_META_WS_ONLANDMINETRIGGER: "Срабатывание мины",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Выход из чата",
  T_46_META_WS_ONLEAVEVEHICLE: "Выход из транспорта",
  T_46_META_WS_ONLEFT: "Выход",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Изменение объекта уровня",
  T_46_META_WS_ONMOVE: "Движение",
  T_46_META_WS_ONNODEENTER: "Вход в узел",
  T_46_META_WS_ONNODEEXIT: "Выход из узла",
  T_46_META_WS_ONPAUSE: "Пауза",
  T_46_META_WS_ONPHASEEND: "Конец фазы",
  T_46_META_WS_ONPHASESTART: "Начало фазы",
  T_46_META_WS_ONPICKEDUP: "Подбор",
  T_46_META_WS_ONPLAYERASSIST: "Ассист игрока",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Исключение игрока",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Падение игрока",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Нанесение урона игроком",
  T_46_META_WS_ONPLAYERELIMINATE: "Исключение игроком",
  T_46_META_WS_ONPLAYERENTER: "Вход игрока",
  T_46_META_WS_ONPLAYERJOIN: "Присоединение игрока",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Неудачное подключение к чату",
  T_46_META_WS_ONPLAYERLEAVE: "Выход игрока",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Запрос покупки",
  T_46_META_WS_ONPLAYERQUIT: "Игрок вышел из игры в середине матча",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Изменение ранга игрока",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Удовлетворение запроса покупки",
  T_46_META_WS_ONPLAYERREVIVED: "Воскрешение игрока",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Воскрешение игрока в точке спавна",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Изменение очков игрока",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Переключение сцены игроком",
  T_46_META_WS_ONPREDEALDAMAGE: "До нанесения урона",
  T_46_META_WS_ONPREPURCHASE: "До покупки",
  T_46_META_WS_ONPRESSED: "Нажатие",
  T_46_META_WS_ONPRETAKEDAMAGE: "До получения урона",
  T_46_META_WS_ONPURCHASE: "Покупка",
  T_46_META_WS_ONRANKCHANGED: "Изменение ранга сущности",
  T_46_META_WS_ONRECONNECT: "Повторное подключение",
  T_46_META_WS_ONRELEASED: "Отпускание",
  T_46_META_WS_ONRELOAD: "Перезарядка",
  T_46_META_WS_ONRESUME: "Возобновление",
  T_46_META_WS_ONREVIVED: "Воскрешение",
  T_46_META_WS_ONROUNDEND: "Конец раунда",
  T_46_META_WS_ONROUNDSTART: "Начало раунда",
  T_46_META_WS_ONSCENELOAD: "Загрузка сцены",
  T_46_META_WS_ONSCENESWITCH: "Переключение сцены",
  T_46_META_WS_ONSCORECHANGE: "Изменение очков сущности",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Попадание футбольным стрелком",
  T_46_META_WS_ONSLEEP: "Сон",
  T_46_META_WS_ONSPAWN: "Спавн",
  T_46_META_WS_ONSPRAY: "Распыление",
  T_46_META_WS_ONSPRAYED: "Распыление",
  T_46_META_WS_ONSPRINT: "Спринт",
  T_46_META_WS_ONSPRINTSTOP: "Остановка спринта",
  T_46_META_WS_ONSTANDUP: "Вставание",
  T_46_META_WS_ONSTART: "Начало",
  T_46_META_WS_ONSTARTFIRE: "Атака",
  T_46_META_WS_ONSTATEEND: "Окончание состояния",
  T_46_META_WS_ONSURFING: "Серфинг",
  T_46_META_WS_ONSURFINGSTOP: "Остановка серфинга",
  T_46_META_WS_ONSWITCHHANDHELD: "Смена ручного предмета",
  T_46_META_WS_ONTAKEDAMAGE: "Получение урона",
  T_46_META_WS_ONTAPPED: "Нажатие",
  T_46_META_WS_ONTEAMACE: "Полное уничтожение команды",
  T_46_META_WS_ONTEAMADD: "Добавление команды",
  T_46_META_WS_ONTEAMREMOVE: "Удаление команды",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Изменение командного ранга в раунде",
  T_46_META_WS_ONTEAMSCORECHANGE: "Изменение очков команды",
  T_46_META_WS_ONTELEPORTENTITY: "Телепортация сущности",
  T_46_META_WS_ONTEXTCHANGE: "Изменение текста",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Взрыв метаемого предмета",
  T_46_META_WS_ONTOGGLE: "Переключение",
  T_46_META_WS_ONTOUCHDOWN: "Касание вниз",
  T_46_META_WS_ONTOUCHUP: "Касание вверх",
  T_46_META_WS_ONUIHIDE: "Скрытие интерфейса",
  T_46_META_WS_ONUISHOW: "Показ интерфейса",
  T_46_META_WS_ONUPDATE: "Обновление",
  T_46_META_WS_ONUSEAVATARSKILL: "Использование навыка аватара",
  T_46_META_WS_ONUSECONSUMABLE: "Использование расходуемого предмета",
  T_46_META_WS_ONUSED: "Использование",
  T_46_META_WS_ONUSEPORTAL: "Использование портала",
  T_46_META_WS_ONWAKEUP: "Пробуждение",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Экипировка оружия",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Нанесение урона оружием",
  T_46_META_WS_ONWEAPONELIMINATE: "Устранение оружием",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Остановка стрельбы",
  T_46_META_WS_OWNER: "Владелец",
  T_46_META_WS_P_ACCELERATE: "Ускорение",
  T_46_META_WS_P_ACCELERATION: "Ускорение",
  T_46_META_WS_P_ACCOUNTID: "ID аккаунта",
  T_46_META_WS_P_ACCURACY: "Точность",
  T_46_META_WS_P_ACTIONTYPE: "Тип действия",
  T_46_META_WS_P_ACTIVATEDALPHA: "Активный альфа",
  T_46_META_WS_P_ACTIVE: "Активный",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Активен в иерархии",
  T_46_META_WS_P_ACTIVESELF: "Активное само",
  T_46_META_WS_P_ACTIVETEXT: "Активный текст",
  T_46_META_WS_P_ACTUALPOSITION: "Фактическое положение",
  T_46_META_WS_P_AFTERACCUMULATOR: "Постаккумулятор",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Смещение центра помощи прицеливания",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Расстояние помощи прицеливания",
  T_46_META_WS_P_AIMASSISTTYPE: "Помощь при прицеливании",
  T_46_META_WS_P_AIRDROPSTATE: "Состояние Авиапосылки",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Горизонтальное выравнивание",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Вертикальное выравнивание",
  T_46_META_WS_P_ALLITEMS: "Все предметы",
  T_46_META_WS_P_ALLMEMBERS: "Все участники",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Разрешить блокировку при помощи прицела",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Разрешить нажатие вне области",
  T_46_META_WS_P_ALLPLAYERS: "Все Игроки",
  T_46_META_WS_P_ALLTEAMMATES: "Все товарищи",
  T_46_META_WS_P_ALPHA: "Прозрачность",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Всегда Показать Отметку",
  T_46_META_WS_P_AMBIENTCOLOR: "Цвет окружающей среды",
  T_46_META_WS_P_AMMOCLIPSIZE: "Размер магазина",
  T_46_META_WS_P_AMMOMAGSIZE: "Размер магазина патронов",
  T_46_META_WS_P_AMMOPERSHOT: "Патроны на выстрел",
  T_46_META_WS_P_AMMOTYPE: "Тип патронов",
  T_46_META_WS_P_ANCHORMAX: "Максимальное значение якоря",
  T_46_META_WS_P_ANCHORMIN: "Минимальное значение якоря",
  T_46_META_WS_P_ANCHOROBJECT: "Закрепить объект",
  T_46_META_WS_P_ANCHORPOSITION: "Позиция якоря",
  T_46_META_WS_P_ANCHORTYPE: "Тип якоря",
  T_46_META_WS_P_ANGLE: "Угол",
  T_46_META_WS_P_ANGLEDOWN: "Угол Вниз",
  T_46_META_WS_P_ANGLEUP: "Угол Вверх",
  T_46_META_WS_P_ANGULARDRAG: "Угловое сопротивление",
  T_46_META_WS_P_ANGULARSPEED: "Угловая Скорость",
  T_46_META_WS_P_ANGULARVELOCITY: "Угловая скорость (рад/с)",
  T_46_META_WS_P_ANIMATIONCLIP: "Имя Анимации",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Контроллер анимации",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "Ресурс ID контроллера анимации",
  T_46_META_WS_P_ARMORPENETRATION: "Пробивная Способность Брони",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Фактор пробивания брони",
  T_46_META_WS_P_ARMORTYPE: "Тип брони",
  T_46_META_WS_P_ARROWOFFSET: "Смещение стрелки",
  T_46_META_WS_P_ARROWSIZE: "Размер стрелки",
  T_46_META_WS_P_ARROWSPRITE: "Спрайт стрелки",
  T_46_META_WS_P_ASKBUYTARGET: "Запрос на покупку цели",
  T_46_META_WS_P_ATTACHTARGET: "Цель прикрепления",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Враждебные фракции",
  T_46_META_WS_P_ATTACKDAMAGE: "Урон от атаки",
  T_46_META_WS_P_ATTACKINTERVAL: "Интервал атаки",
  T_46_META_WS_P_ATTACKRANGE: "Дальность атаки",
  T_46_META_WS_P_ATTACKTARGET: "Цель атаки",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Целевые объекты для атаки",
  T_46_META_WS_P_AUTOPLAY: "Автоматический статус воспроизведения",
  T_46_META_WS_P_AVAILABLEPOINT: "Доступная точка",
  T_46_META_WS_P_AVATAR: "Аватар",
  T_46_META_WS_P_AVATARID: "ID аватара",
  T_46_META_WS_P_BACKGROUND: "Фон",
  T_46_META_WS_P_BACKGROUNDALPHA: "Альфа фона",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Цвет фона",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Цвет Фона 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Цвет Фона 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Заполнение фона",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Название фоновой иконки",
  T_46_META_WS_P_BACKGROUNDNAME: "Имя фона",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Смещение фона",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Радиус фона",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Изменение размера фона",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Спрайт фона",
  T_46_META_WS_P_BACKPACK: "Рюкзак",
  T_46_META_WS_P_BACKPACKSKINID: "ID скинов Рюкзака",
  T_46_META_WS_P_BACKWARDSPEED: "Скорость Назад",
  T_46_META_WS_P_BANNERID: "ID баннера",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Базовая горизонтальная скорость",
  T_46_META_WS_P_BASEMULTIPLIER: "Базовый коэффициент",
  T_46_META_WS_P_BASETIME: "Базовое время",
  T_46_META_WS_P_BASEVERTICALSPEED: "Базовая вертикальная скорость",
  T_46_META_WS_P_BEFOREACCUMULATOR: "BeforeAccumulator",
  T_46_META_WS_P_BEVTREEID: "ID дерева поведения",
  T_46_META_WS_P_BINDPROPERTYID: "ID привязки",
  T_46_META_WS_P_BODY: "Торс",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Множитель урона по телу",
  T_46_META_WS_P_BONEPOSITION: "Позиция кости",
  T_46_META_WS_P_BONESCALE: "Масштабирование скелета",
  T_46_META_WS_P_BOOSTCD: "Время перезарядки буста",
  T_46_META_WS_P_BOOSTDURATION: "Продолжительность спринта",
  T_46_META_WS_P_BOOSTSPEED: "Скорость спринта",
  T_46_META_WS_P_BORDERLR: "Левая и правая границы",
  T_46_META_WS_P_BORDERTB: "Верхняя и нижняя границы",
  T_46_META_WS_P_BOTTOMALPHA: "Нижний альфа",
  T_46_META_WS_P_BOUNDWALLET: "Тип якоря HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Мощность тормозов",
  T_46_META_WS_P_BRAKETORQUE: "Мощность тормозов",
  T_46_META_WS_P_BRRANK: "Ранг КБ",
  T_46_META_WS_P_BUFFTYPE: "Тип буфера",
  T_46_META_WS_P_BURNDAMAGE: "Урон от горения",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Интервал урона от горения",
  T_46_META_WS_P_BURNTIME: "Время горения",
  T_46_META_WS_P_BUTTOM: "Низ",
  T_46_META_WS_P_BUTTONCOLORS: "Цвета кнопок",
  T_46_META_WS_P_BUTTONNAMES: "Названия кнопок",
  T_46_META_WS_P_BUTTONSTYLE: "Стиль кнопки",
  T_46_META_WS_P_CAMERABLOCKMODE: "Режим блокировки камеры",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Режим проекции камеры",
  T_46_META_WS_P_CAMERATYPE: "Тип камеры",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Отменить перетаскивание, если подходит",
  T_46_META_WS_P_CANCOSTDURABILITY: "Может тратить прочность",
  T_46_META_WS_P_CANDAMAGED: "Могут повреждаться",
  T_46_META_WS_P_CANDESTROY: "Можно уничтожить",
  T_46_META_WS_P_CANDESTROYED: "Могут быть разрушены",
  T_46_META_WS_P_CANSELFTRIGGER: "Может быть активирован самим",
  T_46_META_WS_P_CANTEAMTRIGGER: "Может быть активирован командой",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Может быть активировано собой",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Может быть активировано командой",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Может быть активировано транспортом",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Может быть активирован транспортным средством",
  T_46_META_WS_P_CELLSIZE: "Размер ячейки",
  T_46_META_WS_P_CELLSPACE: "Интервал между ячейками",
  T_46_META_WS_P_CENTER: "Центр",
  T_46_META_WS_P_CENTERINVISIBLE: "Центр невидим",
  T_46_META_WS_P_CENTEROFFSET: "Смещение центра",
  T_46_META_WS_P_CENTEROFMASS: "Центр масс",
  T_46_META_WS_P_CENTERRANGE: "Центральный радиус",
  T_46_META_WS_P_CENTRALFLASHTIME: "Время вспышки по краям",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Активная Центральная Линия",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Позиция Центральной Линии",
  T_46_META_WS_P_CHANNELID: "ID Канала Чата",
  T_46_META_WS_P_CHARGEMAX: "Макс. заряд",
  T_46_META_WS_P_CHASETARGET: "Цель преследования",
  T_46_META_WS_P_CHATCHANNEL: "Канал чата",
  T_46_META_WS_P_CHECKPOINTID: "ID контрольной точки",
  T_46_META_WS_P_CHILDINDEX: "Индекс ребенка",
  T_46_META_WS_P_CHIPEXP: "Опыт за чип",
  T_46_META_WS_P_CLICKSIZE: "Размер клика",
  T_46_META_WS_P_CLIPLENGTH: "Длина Клипса",
  T_46_META_WS_P_CLIPPINGTYPE: "Тип отсечения",
  T_46_META_WS_P_COLLIDERID: "ID Коллайдера",
  T_46_META_WS_P_CONSTRAIN: "Ограничение",
  T_46_META_WS_P_CONSTRAINT: "Ограничение",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Количество ограничений",
  T_46_META_WS_P_CONSUMABLETYPE: "Тип расходных материалов",
  T_46_META_WS_P_CONTENT: "Содержание",
  T_46_META_WS_P_CONTENTORIGIN: "Начало содержимого",
  T_46_META_WS_P_CONTROLPOINTS: "Контрольные Точки",
  T_46_META_WS_P_COORDINATESYSTEM: "Координатная Система",
  T_46_META_WS_P_COUNT: "Количество",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Время Завершения Обратного Отсчета (с)",
  T_46_META_WS_P_COUNTDOWNKEY: "Ключ обратного отсчета",
  T_46_META_WS_P_COUNTDOWNTIME: "Время обратного отсчета",
  T_46_META_WS_P_COUNTPERWAVE: "Количество на волну",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Максимальный урон от удара",
  T_46_META_WS_P_CRASHMAXSPEED: "Максимальная скорость удара",
  T_46_META_WS_P_CRASHMESSFACTOR: "Фактор качества удара",
  T_46_META_WS_P_CRASHMINDAMAGE: "Минимальный урон от удара",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Масштаб скорости передвижения при ползании",
  T_46_META_WS_P_CREATEDENTITY: "Созданная сущность",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Масштаб скорости передвижения при приседании",
  T_46_META_WS_P_CSRANK: "Ранг БО",
  "T_46_META_WS_P_CURRENT AMMO": "Текущие патроны",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Текущий анимационный ресурс",
  T_46_META_WS_P_CURRENTCLIP: "Текущий Клип",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Прогресс Текущего Клипа",
  T_46_META_WS_P_CURRENTDURABILITY: "Текущая прочность",
  T_46_META_WS_P_CURRENTENERGY: "Текущая энергия",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Текущий ручной предмет",
  T_46_META_WS_P_CURRENTHP: "Текущее Здоровье",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Индекс текущей фазы",
  T_46_META_WS_P_CURRENTPROGRESS: "Текущий прогресс",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Индекс текущего раунда",
  T_46_META_WS_P_CURRENTSTATE: "Текущее Состояние",
  T_46_META_WS_P_CURRENTVALUE: "Текущее значение",
  T_46_META_WS_P_CURRENTWAVE: "Текущая волна",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Ресурс пользовательского персонажа",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Результат пользовательской игры",
  T_46_META_WS_P_CUSTOMGRAVITY: "Индивидуальная Гравитация",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Сила толчка",
  T_46_META_WS_P_CUSTOMXY: "Пользовательские XY",
  T_46_META_WS_P_DAMAGE: "Урон",
  "T_46_META_WS_P_DAMAGE RANGE": "Диапазон",
  T_46_META_WS_P_DAMAGEFACTOR: "Фактор Урона",
  T_46_META_WS_P_DAMAGEINTERVAL: "Интервал Урона (с)",
  T_46_META_WS_P_DAMAGERADIUS: "Радиус Урона",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Коэффициент урона хэдшота",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Коэффициент урона по конечностям",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Коэффициент снижения урона",
  T_46_META_WS_P_DAMAGETAKENPCT: "Процент полученного урона",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Процент полученного урона",
  T_46_META_WS_P_DAMAGEVALUE: "Значение урона",
  T_46_META_WS_P_DARKNESS: "Тьма",
  T_46_META_WS_P_DECELERATIONPERCENT: "Процент замедления",
  T_46_META_WS_P_DEFAULTTEXT: "Текст по умолчанию",
  T_46_META_WS_P_DEFENSE: "Коэффициент защиты",
  T_46_META_WS_P_DEFENSERATE: "Коэффициент защиты",
  T_46_META_WS_P_DELTA: "Δ (Дельта)",
  T_46_META_WS_P_DELTATIME: "Дельта времени",
  T_46_META_WS_P_DELTAVALUE: "Значение Дельта",
  T_46_META_WS_P_DEPTH: "Глубина",
  T_46_META_WS_P_DESC: "Описание",
  T_46_META_WS_P_DESCRIPTION: "Описание",
  T_46_META_WS_P_DESCRIPTIONKEY: "Ключ описания",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Параметры описания подсказки",
  T_46_META_WS_P_DESTVAL: "Конечное Значение",
  T_46_META_WS_P_DETECTRANGE: "Диапазон обнаружения",
  T_46_META_WS_P_DIFFUSEALPHA: "Диффузная альфа",
  T_46_META_WS_P_DIFFUSECOLOR: "Диффузный цвет",
  T_46_META_WS_P_DIFFUSETEXTURE: "Диффузная текстура",
  T_46_META_WS_P_DISABLECOLOR: "Отключить цвет",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Отключить урон при падении",
  T_46_META_WS_P_DISABLEITEMDROP: "Отключить сброс предметов",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Отключить подъем предметов",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Отключить ручное закрытие",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Отключить быстрый чат",
  T_46_META_WS_P_DISABLERECIPROCATING: "Отключить возвратное движение",
  T_46_META_WS_P_DISABLEVOICECHAT: "Отключить голосовой чат",
  T_46_META_WS_P_DISTANCE: "Дистанция",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Тип двойного оружия",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Масштаб скорости передвижения при ползании",
  T_46_META_WS_P_DOWNSPEED: "Скорость Вниз",
  T_46_META_WS_P_DRAG: "Сопротивление",
  T_46_META_WS_P_DRIVER: "Водитель",
  T_46_META_WS_P_DROPITEMS: "Предметы Падения",
  T_46_META_WS_P_DURABILITY: "Прочность",
  T_46_META_WS_P_DURABILITYRECOVERY: "Восстановление прочности",
  T_46_META_WS_P_DURATION: "Продолжительность",
  T_46_META_WS_P_EDGEFLASHTIME: "Переключатель эффекта светошума",
  T_46_META_WS_P_EFFECTACTIVE: "Показать эффект",
  T_46_META_WS_P_EFFECTCOLOR: "Цвет Эффекта",
  T_46_META_WS_P_EFFECTDURATION: "Длительность эффекта",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Интервал времени действия",
  T_46_META_WS_P_EFFECTRESID: "Путь к ресурсу эффекта",
  T_46_META_WS_P_ENABLE: "Включить",
  T_46_META_WS_P_ENABLEATTACK: "Включить Атаку",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Включить восстановление бота",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Включить Глубинную Карты",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Включить выпадение при устранении",
  T_46_META_WS_P_ENABLELOCALIZATION: "Локализация",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Перемещение в воздухе",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Включить возрождение игрока",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Вид игрока",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Вращение с гравитацией",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Включить атрибуты кожи",
  T_46_META_WS_P_ENABLESWINGING: "Включить раскачивание",
  T_46_META_WS_P_ENABLETRACTION: "Включить сцепление",
  T_46_META_WS_P_ENDPOSITION: "Конечная Позиция",
  T_46_META_WS_P_ENDRADIUS: "Конечный Радиус",
  T_46_META_WS_P_ENDTIME: "Время Истечения (с)",
  T_46_META_WS_P_ENDTIMES: "Время Завершения",
  T_46_META_WS_P_ENDVALUE: "Конечное Значение",
  T_46_META_WS_P_ENERGY: "Энергия",
  T_46_META_WS_P_ENERGYCOST: "Стоимость энергии",
  T_46_META_WS_P_ENERGYRECOVERY: "Восстановление энергии",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Мощность двигателя",
  T_46_META_WS_P_ENGINETORQUE: "Мощность двигателя",
  T_46_META_WS_P_EP: "Энергия",
  T_46_META_WS_P_EPMAX: "Макс. Энергии",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Количество восстановления энергии (EP)",
  T_46_META_WS_P_EVENTS: "События",
  T_46_META_WS_P_EXPLODEDAMAGE: "Урон от взрыва",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Коэффициент снижения взрывного урона",
  T_46_META_WS_P_EXPLODEDELAY: "Задержка взрыва",
  T_46_META_WS_P_EXPLODERANGE: "Радиус взрыва",
  T_46_META_WS_P_EXPLOSIONDELAY: "Задержка взрыва",
  T_46_META_WS_P_EXPLOSIONRANGE: "Радиус взрыва",
  T_46_META_WS_P_EXPLOSIONTIME: "Задержка взрыва",
  T_46_META_WS_P_EXPPERDAMAGE: "Опыт за урон",
  T_46_META_WS_P_EXPPERMOVEMILE: "Опыт за пройденное расстояние",
  T_46_META_WS_P_EXPPERSECOND: "Опыт за время",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Дополнительная вместимость рюкзака",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Дополнительное пространство для рюкзака",
  T_46_META_WS_P_EXTRAHPRATIO: "Коэффициент дополнительного здоровья",
  T_46_META_WS_P_FACEPAINT: "Грим",
  T_46_META_WS_P_FACTION: "Фракция",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Коэффициент урона от падения",
  T_46_META_WS_P_FALLSPEED: "Скорость падения",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Автоматическая скорость перезарядки",
  T_46_META_WS_P_FILEID: "Внутренний ID",
  T_46_META_WS_P_FILL: "Заполнение",
  T_46_META_WS_P_FILLAMOUNT: "Значение заполнения",
  T_46_META_WS_P_FILLDIRECTION: "Направление заполнения",
  T_46_META_WS_P_FILLTYPE: "Тип заполнения",
  T_46_META_WS_P_FIREANGLELIMIT: "Ограничение Угла Огня",
  T_46_META_WS_P_FIRETYPE: "Тип огня",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Параметры первого счета",
  T_46_META_WS_P_FIRSTSCORETITLE: "Название первого счета",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Значение первого счета",
  T_46_META_WS_P_FIXEDDELTATIME: "Фиксированное дельта-время",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Длительность эффекта",
  T_46_META_WS_P_FLIP: "Переворот",
  T_46_META_WS_P_FLIPTYPE: "Тип переворота",
  T_46_META_WS_P_FLYMAXHEIGHT: "Максимальная высота полета",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Скорость горизонтального полета",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Скорость вертикального полета",
  T_46_META_WS_P_FOGCOLOR: "Цвет тумана",
  T_46_META_WS_P_FOLLOWTARGET: "Следовать за целью",
  T_46_META_WS_P_FONT: "Шрифт",
  T_46_META_WS_P_FONTSIZE: "Размер шрифта",
  T_46_META_WS_P_FONTSTYLE: "Стиль шрифта",
  T_46_META_WS_P_FONTTYPE: "Тип шрифта",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Принудительная синхронизация с клиентом",
  T_46_META_WS_P_FORWARD: "Вперед",
  T_46_META_WS_P_FORWARDSPEED: "Скорость Вперед",
  T_46_META_WS_P_FOV: "Поле зрения",
  T_46_META_WS_P_FREEZEDURATION: "Длительность заморозки (с)",
  T_46_META_WS_P_FRIENDFACTIONS: "Дружественные фракции",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Дружественные игроки",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Полный урон на расстоянии",
  T_46_META_WS_P_FUNCTIONTYPE: "Тип функции",
  T_46_META_WS_P_GAINHPCOLOR: "Цвет Прибавки Здоровья",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Количество кадров",
  T_46_META_WS_P_GAMETIMECOUNT: "Время игры",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Задержка Переключения Передачи",
  T_46_META_WS_P_GENDER: "Пол",
  T_46_META_WS_P_GETONBOOSTCD: "Время перезарядки после того как встал на буст",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Переключатель времени перезарядки после того как встал на буст",
  T_46_META_WS_P_GETONSKATEBOARDCD: "Время перезарядки после того как встал на скейтборд",
  T_46_META_WS_P_GRADIENT: "Градиент",
  T_46_META_WS_P_GRADIENTBOTTOM: "Нижний градиент",
  T_46_META_WS_P_GRADIENTTOP: "Верхний градиент",
  T_46_META_WS_P_GRAVITY: "Гравитация",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Максимальный Урон Гранаты",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Минимальный Урон Гранаты",
  T_46_META_WS_P_GRENADERANGE: "Дальность Гранаты",
  T_46_META_WS_P_GROUPID: "ID Группы",
  T_46_META_WS_P_HEAD: "Головной убор",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Множитель урона хэдшотов",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Уменьшение урона при хэдшота",
  T_46_META_WS_P_HEIGHT: "Высота",
  T_46_META_WS_P_HELMET: "Шлем",
  T_46_META_WS_P_HIGHESTBRRANK: "Высший ранг КБ",
  T_46_META_WS_P_HIGHESTCSRANK: "Высший ранг БО",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Минимальный угол подъема",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Лимит рулевого управления на высокой скорости",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "HighSpeedSteerAngleAtspeed",
  T_46_META_WS_P_HITPOINTEFFECT: "Эффект точки удара",
  T_46_META_WS_P_HORIZONTALBAR: "Горизонтальная полоса",
  T_46_META_WS_P_HORIZONTALOFFSET: "Горизонтальное смещение",
  T_46_META_WS_P_HOSTILETEAMS: "Враждебные команды",
  T_46_META_WS_P_HOSTTEAM: "Команда хоста",
  T_46_META_WS_P_HP: "ХП",
  T_46_META_WS_P_HPMAX: "Макс. Здоровье",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Количество восстановления здоровья",
  T_46_META_WS_P_HPRECOVERYSPEED: "Скорость восстановления здоровья (мс)",
  T_46_META_WS_P_ICON: "Иконка",
  T_46_META_WS_P_ICONCOLOR: "Цвет иконки",
  T_46_META_WS_P_ICONNAME: "Название иконки",
  T_46_META_WS_P_ICONRESOURCE: "Ресурс Иконки",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Интервал Урона (с)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Вход тормоза в режиме ожидания",
  T_46_META_WS_P_INACTIVATEDALPHA: "Неактивный альфа",
  T_46_META_WS_P_INDEX: "Индекс",
  T_46_META_WS_P_INITIALMAGCOUNT: "Начальное количество магазинов",
  T_46_META_WS_P_INITIALSPEED: "Начальная Скорость",
  T_46_META_WS_P_INITIALVALUE: "Начальное Значение",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Начальная Мировая Позиция",
  T_46_META_WS_P_INSCENE: "В сцене",
  T_46_META_WS_P_INSTANCEID: "ID эффекта",
  T_46_META_WS_P_INTENSITY: "Интенсивность",
  T_46_META_WS_P_INVERTFILL: "Инвертировать заполнение",
  T_46_META_WS_P_INVINCIBLE: "Непобедимый",
  "T_46_META_WS_P_IS SHOW": "Является ли видимым",
  T_46_META_WS_P_IS3D: "3D",
  T_46_META_WS_P_ISACE: "Является ли Team Wipeout",
  T_46_META_WS_P_ISACED: "Team Wipeout",
  T_46_META_WS_P_ISAI: "Является ли ИИ",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Всегда на экране",
  T_46_META_WS_P_ISAPPLYSHADOW: "Применить тень",
  T_46_META_WS_P_ISATTACKABLE: "Может быть атакован",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Автоматическое преследование врага",
  T_46_META_WS_P_ISAUTOPLAY: "Автоматическое Воспроизведение",
  T_46_META_WS_P_ISAUTOTELEPORT: "Является ли автоматической телепортацией",
  T_46_META_WS_P_ISBILLBOARD: "Всегда в видеокадре",
  T_46_META_WS_P_ISBOLD: "Жирный",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Столкновение снизу",
  T_46_META_WS_P_ISCENTERPOS: "Является Центр Позиции",
  T_46_META_WS_P_ISCONSUMEAMMO: "Расход патронов",
  T_46_META_WS_P_ISCONTINUOUS: "Является ли непрерывным",
  T_46_META_WS_P_ISCOUNTDOWN: "Является Обратным Отсчетом",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Является ли текущая анимация цикличной",
  T_46_META_WS_P_ISDEADDROP: "Поддержка устранения",
  T_46_META_WS_P_ISDEATHTRIGGER: "Является ли триггером устранения",
  T_46_META_WS_P_ISDEBUG: "Включить Отладку BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Является ли это точкой спауна по умолчанию",
  T_46_META_WS_P_ISDROPONELIMINATED: "Падает при уничтожении",
  T_46_META_WS_P_ISEND: "Конец",
  T_46_META_WS_P_ISFEBUTTON: "Это кнопка FE",
  T_46_META_WS_P_ISGREY: "Является ли серым",
  T_46_META_WS_P_ISGROUNDED: "На земле",
  T_46_META_WS_P_ISIGNOREDEPTH: "Игнорировать глубину",
  T_46_META_WS_P_ISINVINCIBLE: "Неуязвимость",
  T_46_META_WS_P_ISITALIC: "Курсив",
  T_46_META_WS_P_ISLASTROUND: "Является ли это последним раундом",
  T_46_META_WS_P_ISLOCALPOS: "Включить Локальные Координаты",
  T_46_META_WS_P_ISLOOP: "Повторение",
  T_46_META_WS_P_ISMATCHPOINT: "Является ли это решающим раундом",
  T_46_META_WS_P_ISMOVEABLE: "Могу двигаться",
  T_46_META_WS_P_ISOCCUPIED: "Занята ли точка",
  T_46_META_WS_P_ISOPENTWEEN: "Включить Эффект Изменения Здоровья",
  T_46_META_WS_P_ISPLAYING: "Воспроизводится ли",
  T_46_META_WS_P_ISPURCHASABLE: "Список товаров",
  T_46_META_WS_P_ISREVERSE: "Обратный",
  T_46_META_WS_P_ISSERVERDRIVEN: "Управляется сервером",
  T_46_META_WS_P_ISSHOW: "Показывать",
  T_46_META_WS_P_ISSHOWHUDNAME: "Показывать Имя HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "Показывать Информацию на Карте",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Показывать Быстрое Сообщение",
  T_46_META_WS_P_ISSHOWSCAN: "Показывать Сканирование",
  T_46_META_WS_P_ISSHOWTAG: "Показывать Тег",
  T_46_META_WS_P_ISSIDECOLLIDING: "Столкновение сбоку",
  T_46_META_WS_P_ISSILENCE: "Является бесшумным",
  T_46_META_WS_P_ISSINGLESHOT: "Является одиночным выстрелом",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Пропустить анимацию падения",
  T_46_META_WS_P_ISSLIDING: "Скользит ли",
  T_46_META_WS_P_ISTOPCOLLIDING: "Столкновение сверху",
  T_46_META_WS_P_ISUNDERLINE: "Подчёркнутый",
  T_46_META_WS_P_ISVISIBLE: "Видимый ли объект",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Цвет фона карточек",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Фон карточек",
  T_46_META_WS_P_ITEMCOUNTS: "Можно ли купить",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Описания карточек",
  T_46_META_WS_P_ITEMICONS: "Иконки карточек",
  T_46_META_WS_P_ITEMID: "ID оружия",
  T_46_META_WS_P_ITEMIDS: "ID предметов",
  T_46_META_WS_P_ITEMNAMES: "Названия карточек",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Список запрещенных предметов",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Радиус перетаскивания колпачка джойстика",
  T_46_META_WS_P_JOYSTICKIMAGE: "Изображение колпачка джойстика",
  T_46_META_WS_P_JOYSTICKRADIUS: "Радиус колпачка джойстика",
  T_46_META_WS_P_JUMPCD: "Время перезарядки прыжка",
  T_46_META_WS_P_JUMPHEIGHT: "Высота прыжка",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Масштаб высоты прыжка",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Бонус урона при сбивании",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Статус нокаута",
  T_46_META_WS_P_LABEL: "Ярлык",
  T_46_META_WS_P_LABELCOLOR: "Цвет метки",
  T_46_META_WS_P_LABELKEY: "Ключ ярлыка",
  T_46_META_WS_P_LABELPARAMS: "Параметры ярлыка",
  T_46_META_WS_P_LASTCHECKPOINTID: "Текущий идентификатор контрольной точки",
  T_46_META_WS_P_LASTSURVIVALTIME: "Последнее время выживания",
  T_46_META_WS_P_LAYERTYPE: "Тип слоя",
  T_46_META_WS_P_LAYOUTTYPE: "Тип макета",
  T_46_META_WS_P_LEFTARM: "Левая рука",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Цвет фона слева",
  T_46_META_WS_P_LEFTCOLOR: "Цвет слева",
  T_46_META_WS_P_LEFTDESCRIPTION: "Описание слева",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Активный Эффект Слева",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Угол стрельбы влево",
  T_46_META_WS_P_LEFTFOOT: "Левая стопа",
  T_46_META_WS_P_LEFTHAND: "Левая кисть",
  T_46_META_WS_P_LEFTICON: "Левая Иконка",
  T_46_META_WS_P_LEFTICONNAME: "Название иконки слева",
  T_46_META_WS_P_LEFTLEG: "Левая нога",
  T_46_META_WS_P_LEFTPLAYERS: "Игроки слева",
  T_46_META_WS_P_LEFTSCORE: "Левый Счет",
  T_46_META_WS_P_LEFTSCOREAFTER: "Левый Финальный Счет",
  T_46_META_WS_P_LEFTSCORETEXT: "Левый Счет",
  T_46_META_WS_P_LEFTTEAM: "Правая команда",
  T_46_META_WS_P_LEFTTEAMINDEX: "Индекс левой команды",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Количество живых игроков слева",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Количество флагов слева",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Состояния слева",
  T_46_META_WS_P_LEFTTEAMNAME: "Название левой команды",
  T_46_META_WS_P_LEFTTEAMSCORE: "Счет левой команды",
  T_46_META_WS_P_LEFTTEXT: "Левый Текст",
  T_46_META_WS_P_LENGTH: "Длина",
  T_46_META_WS_P_LENSFLARE: "Блики на объективе",
  T_46_META_WS_P_LEVEL: "Уровень",
  T_46_META_WS_P_LIFETIME: "Время Жизни (с)",
  T_46_META_WS_P_LIGHTCOLOR: "Цвет света",
  T_46_META_WS_P_LIGHTINTENSITY: "Интенсивность света",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Множитель урона по конечностям",
  T_46_META_WS_P_LINESPACING: "Межстрочный интервал",
  T_46_META_WS_P_LOCALPOSITION: "Локальная позиция",
  T_46_META_WS_P_LOCALROTATION: "Локальное вращение",
  T_46_META_WS_P_LOCALROTATIONQ: "Локальное вращение кватернион",
  T_46_META_WS_P_LOCALSCALE: "Локальный масштаб",
  T_46_META_WS_P_LOCKEY: "Ключ локализации",
  T_46_META_WS_P_LOOPCOUNT: "Количество Циклов",
  T_46_META_WS_P_LOOTSOCCER: "Лут футбол",
  T_46_META_WS_P_LOSEHPCOLOR: "Цвет Потери ХП",
  T_46_META_WS_P_LOSEMVPS: "Проигравшие MVP",
  T_46_META_WS_P_LOSETEXT: "Текст поражения",
  "T_46_META_WS_P_MAIN CAMERA": "Главная камера",
  T_46_META_WS_P_MAINCOLOR: "Основной Цвет",
  T_46_META_WS_P_MAINSCORELIST: "Основные Очки",
  T_46_META_WS_P_MAINSCORETITLE: "Основное Название Очков",
  T_46_META_WS_P_MAINWEAPON: "Основное оружие",
  T_46_META_WS_P_MAPSIZE: "Размер Карты",
  T_46_META_WS_P_MASK: "Маска",
  T_46_META_WS_P_MASKNAME: "Имя маски",
  T_46_META_WS_P_MASS: "Масса (кг)",
  T_46_META_WS_P_MATCHTITLELEFT: "Название Матча Слева",
  T_46_META_WS_P_MATCHTITLERIGHT: "Название Матча Справа",
  T_46_META_WS_P_MAXCAPACITY: "Максимальная емкость",
  T_46_META_WS_P_MAXCOUNT: "Макс. количество",
  T_46_META_WS_P_MAXDAMAGE: "Максимальный урон",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Максимальный угол снижения",
  T_46_META_WS_P_MAXDISPLACEMENT: "Максимальное Перемещение",
  T_46_META_WS_P_MAXDISTANCE: "Макс. дистанция",
  T_46_META_WS_P_MAXDURABILITY: "Максимальная прочность",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Коэффициент максимальной прочности",
  T_46_META_WS_P_MAXENERGY: "Максимальная энергия",
  T_46_META_WS_P_MAXEP: "Макс. энергия",
  T_46_META_WS_P_MAXHP: "Макс. ХП",
  T_46_META_WS_P_MAXJUMPCOUNT: "Максимум прыжков",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Максимальная высота прыжка",
  T_46_META_WS_P_MAXLENGTH: "Максимальная длина",
  T_46_META_WS_P_MAXPROGRESS: "Максимум прогресса",
  T_46_META_WS_P_MAXSCATTERRATIO: "Максимальное соотношение разброса",
  T_46_META_WS_P_MAXSPEED: "Максимальная скорость",
  T_46_META_WS_P_MAXTURRETCOUNT: "Макс. Количество Турелей",
  T_46_META_WS_P_MAXVALUE: "Максимальное значение",
  T_46_META_WS_P_MAXWIDGETID: "Максимальный ID виджета",
  T_46_META_WS_P_MINDAMAGE: "Минимальный урон",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Минимальное расстояние до урона",
  T_46_META_WS_P_MINDISTANCE: "Мин. дистанция",
  T_46_META_WS_P_MINELEVATIONANGLE: "Минимальный угол подъема",
  T_46_META_WS_P_MINENDHEIGHT: "Минимальная конечная высота",
  T_46_META_WS_P_MINFLYHEIGHT: "Минимальная высота полета",
  T_46_META_WS_P_MINMOVEDISTANCE: "Минимальное расстояние",
  T_46_META_WS_P_MINVALUE: "Минимальное значение",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Максимальный урон от ракеты",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Минимальный урон от ракеты",
  T_46_META_WS_P_MISSILERANGE: "Дальность ракеты",
  T_46_META_WS_P_MODEL: "Модель",
  T_46_META_WS_P_MODELVISIBILITY: "Видимость модели",
  T_46_META_WS_P_MODELVISIBLE: "Видимость модели",
  T_46_META_WS_P_MONEY: "Деньги",
  T_46_META_WS_P_MONEYLIST: "Список валют",
  T_46_META_WS_P_MONEYS: "Привязанный кошелек",
  T_46_META_WS_P_MONEYTYPE: "Тип валюты",
  T_46_META_WS_P_MONSTERTYPE: "Тип монстра",
  T_46_META_WS_P_MOTIONTYPE: "Тип движения",
  T_46_META_WS_P_MOTIONVALUEX: "Значение движения по оси X",
  T_46_META_WS_P_MOTIONVALUEY: "Значение движения по оси Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Значение движения по оси Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Продолжительность движения",
  T_46_META_WS_P_MULTIPLIER: "Множитель",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Тип музыкального элемента",
  T_46_META_WS_P_MUZZLEVELOCITY: "Скорость вылета пули",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Название",
  T_46_META_WS_P_NEXTROUNDINDEX: "Индекс следующего раунда",
  T_46_META_WS_P_NICKNAME: "Псевдоним",
  T_46_META_WS_P_NORMALCOLOR: "Обычный цвет",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Нормализованная Позиция",
  T_46_META_WS_P_NUMBERINFACTION: "Номер во фракции",
  T_46_META_WS_P_OBJECTID: "ID объекта",
  T_46_META_WS_P_OFFSET: "Смещение",
  T_46_META_WS_P_OPTIONS: "Опции",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Множитель урона по другим объектам",
  T_46_META_WS_P_OUTFIT: "Одежда",
  T_46_META_WS_P_OVERFLOW: "Переполнение",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Скорость падения после превышения высоты",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Перенос приоритетов конфигурации игрока",
  T_46_META_WS_P_OWNER: "Владелец",
  T_46_META_WS_P_PARAMS: "Параметры информации подсказки",
  T_46_META_WS_P_PARENT: "Родитель",
  T_46_META_WS_P_PARENTID: "ID родителя",
  T_46_META_WS_P_PARENTUI: "Родительский UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "ID родительского виджета",
  T_46_META_WS_P_PARENTWIDGETFILEID: "ID файла родительского виджета",
  T_46_META_WS_P_PARTMASKA: "Маска части 1",
  T_46_META_WS_P_PASSENGERS: "Пассажиры",
  T_46_META_WS_P_PATHID: "ID Пути",
  T_46_META_WS_P_PAUSEEVENT: "Пауза События",
  T_46_META_WS_P_PERSONAID: "ID Персонажа",
  T_46_META_WS_P_PHASEDURATION: "Продолжительность (мс)",
  T_46_META_WS_P_PHASEENDTIME: "Время окончания (мс)",
  T_46_META_WS_P_PHYSICALLAYER: "Физический слой",
  T_46_META_WS_P_PINID: "ID значка",
  T_46_META_WS_P_PITCH: "Вертикальный угол",
  T_46_META_WS_P_PIVOT: "Центр поворота",
  T_46_META_WS_P_PLAYER: "Игрок",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Коэффициент скорости прицеливания игрока",
  T_46_META_WS_P_PLAYERLIST: "Список Игроков",
  T_46_META_WS_P_PLAYERNAME: "Имя Игрока",
  T_46_META_WS_P_PLAYERRANK: "Рейтинг Игрока",
  T_46_META_WS_P_PLAYERRANKS: "Рейтинги игроков",
  T_46_META_WS_P_PLAYERS: "Игроки",
  T_46_META_WS_P_PLAYERSCORETYPES: "Типы счета игрока",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Коэффициент скорости игрока",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Коэффициент скорости игрока при стрельбе",
  T_46_META_WS_P_PLAYERSTATUS: "Статус игрока",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Скорость сцепления игрока",
  T_46_META_WS_P_PLAYINGSTATUS: "Статус воспроизведения",
  T_46_META_WS_P_PLAYSPEED: "Скорость воспроизведения",
  T_46_META_WS_P_POINTPOSITION: "Позиция точки",
  T_46_META_WS_P_POINTS: "Очки",
  T_46_META_WS_P_POSITION: "Позиция",
  T_46_META_WS_P_PREFABID: "ID префаба",
  T_46_META_WS_P_PRESSEDCOLOR: "Цвет при нажатии",
  T_46_META_WS_P_PRESSEDSPRITE: "Спрайт при нажатии",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Тип спрайта при нажатии",
  T_46_META_WS_P_PRICE: "Цена",
  T_46_META_WS_P_PRIORITY: "Приоритет",
  T_46_META_WS_P_PROFILEINFO: "Информация о профиле",
  T_46_META_WS_P_PROGRESS: "Прогресс [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Иконка прогресса",
  T_46_META_WS_P_PROGRESSICONNAME: "Название иконки",
  T_46_META_WS_P_PROPID: "ID Реквизита",
  T_46_META_WS_P_PURCHASELIMIT: "Лимит покупки",
  T_46_META_WS_P_RADIUS: "Радиус",
  T_46_META_WS_P_RANGE: "Диапазон",
  T_46_META_WS_P_RANK: "Рейтинг",
  T_46_META_WS_P_RATIOSELFFACTOR: "Коэффициент собственного урона",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Коэффициент урона для товарищей",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Коэффициент урона транспортным средствам",
  T_46_META_WS_P_REFRESHTIME: "Время обновления буфера (с)",
  T_46_META_WS_P_RELOADSPEED: "Скорость перезарядки",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Коэффициент скорости перезарядки",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Оставшиеся прыжки",
  T_46_META_WS_P_REMAINQUANTITY: "Оставшееся количество",
  T_46_META_WS_P_RENDERTYPE: "Тип рендера",
  T_46_META_WS_P_REPEATTIMES: "Количество повторов",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Приоритет замены",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ID триггерного игрока",
  T_46_META_WS_P_REQUESTTYPE: "Список запрашиваемых предметов",
  T_46_META_WS_P_RESETPERROUND: "Сброс за раунд",
  T_46_META_WS_P_RESETPOSITION: "Сброс позиции",
  T_46_META_WS_P_RESETTIME: "Время сброса",
  T_46_META_WS_P_RESOURCE: "Ресурс",
  T_46_META_WS_P_RESOURCEID: "ID ресурса",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Ограничить внутри панели",
  T_46_META_WS_P_RESULT: "Результат",
  T_46_META_WS_P_RESULTTYPE: "Тип результата",
  T_46_META_WS_P_REVIVALPOINT: "Точка возрождения",
  T_46_META_WS_P_REVIVECD: "Время восстановления",
  T_46_META_WS_P_RIGHT: "Правый",
  T_46_META_WS_P_RIGHTARM: "Правая рука",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Цвет фона справа",
  T_46_META_WS_P_RIGHTCOLOR: "Цвет справа",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Описание справа",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Активный Эффект Справа",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Угол стрельбы вправо",
  T_46_META_WS_P_RIGHTFOOT: "Правая стопа",
  T_46_META_WS_P_RIGHTHAND: "Правая кисть",
  T_46_META_WS_P_RIGHTICON: "Правая Иконка",
  T_46_META_WS_P_RIGHTICONNAME: "Название иконки справа",
  T_46_META_WS_P_RIGHTLEG: "Правая нога",
  T_46_META_WS_P_RIGHTPLAYERS: "Игроки справа",
  T_46_META_WS_P_RIGHTSCORE: "Правый Счет",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Правый Финальный Счет",
  T_46_META_WS_P_RIGHTSCORETEXT: "Правый Счет",
  T_46_META_WS_P_RIGHTTEAM: "Список титулов",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Индекс правой команды",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Количество живых игроков справа",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Количество флажков у правого игрока",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Состояния справа",
  T_46_META_WS_P_RIGHTTEAMNAME: "Название правой команды",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Счет правой команды",
  T_46_META_WS_P_RIGHTTEXT: "Правый Текст",
  T_46_META_WS_P_RIMALPHA: "Рим Альфа",
  T_46_META_WS_P_RIMCOLOR: "Цвет края",
  T_46_META_WS_P_RIMTEXTURE: "Текстура края",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Коэффициент скольжения",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Множитель трения (столкновение)",
  T_46_META_WS_P_ROTATION: "Вращение",
  T_46_META_WS_P_ROTATIONANGLE: "Угол поворота",
  T_46_META_WS_P_ROTATIONQ: "Вращение кватернион",
  T_46_META_WS_P_ROUNDINCOME: "Доход за раунд",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Числовые данные детализации дохода за раунд",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Заголовки детализации дохода за раунд",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Заголовок дохода за раунд",
  T_46_META_WS_P_ROUNDNUM: "Номер раунда",
  T_46_META_WS_P_ROUNDNUMKEY: "Ключ раунда",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Параметры ключа раунда",
  T_46_META_WS_P_RUNSPEED: "Скорость бега",
  T_46_META_WS_P_RUNSPEEDSCALE: "Масштаб скорости бега",
  T_46_META_WS_P_RUSHDISTANCE: "Расстояние рывка",
  T_46_META_WS_P_RUSHENERGYCOST: "Стоимость энергии при рывке",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Скорость вертикального рывка",
  T_46_META_WS_P_SCALE: "Масштаб",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Скорость увеличения разброса",
  T_46_META_WS_P_SCATTERMAX: "Максимальный разброс",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Множитель разброса при движении",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Скорость восстановления разброса",
  T_46_META_WS_P_SCATTERSPEED: "Скорость разброса",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Скорость разброса при приседе/лежа",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Порог разброса",
  T_46_META_WS_P_SCOPETYPE: "Тип прицела",
  T_46_META_WS_P_SCORE: "Счет",
  T_46_META_WS_P_SCORES1: "Scores1",
  T_46_META_WS_P_SCORES2: "Scores2",
  T_46_META_WS_P_SCORES3: "Scores3",
  T_46_META_WS_P_SCORES4: "Scores4",
  T_46_META_WS_P_SCORES5: "Scores5",
  T_46_META_WS_P_SCORETEXTKEY: "Ключ текста счета",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Параметры ключа текста счета",
  T_46_META_WS_P_SCROLLCONTINUITY: "Непрерывность прокрутки",
  T_46_META_WS_P_SCROLLDIRECTION: "Направление прокрутки",
  T_46_META_WS_P_SCROLLEFFECT: "Эффект прокрутки",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Скорость прокрутки колёсиком",
  T_46_META_WS_P_SECONDSCORETITLE: "Название второго счета",
  T_46_META_WS_P_SECONDSCOREVALUE: "Значение второго счета",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Параметры второго счета",
  T_46_META_WS_P_SELECTEDCOLOR: "Цвет при выборе",
  T_46_META_WS_P_SELECTEDINDEX: "Индекс выбранного элемента",
  T_46_META_WS_P_SELECTEDSPRITE: "Спрайт при выборе",
  T_46_META_WS_P_SELECTEDTYPE: "Тип при выборе",
  T_46_META_WS_P_SELF: "Сам",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Фактор самовызываемого урона",
  T_46_META_WS_P_SET: "Набор",
  T_46_META_WS_P_SHADERNAME: "Название шейдера",
  T_46_META_WS_P_SHADOWCOLOR: "Цвет тени",
  T_46_META_WS_P_SHADOWOFFSET: "Смещение тени",
  T_46_META_WS_P_SHADOWSTRENGTH: "Сила теней",
  T_46_META_WS_P_SHELFS: "Запрещено ли ручное закрытие",
  T_46_META_WS_P_SHOES: "Обувь",
  T_46_META_WS_P_SHOOTANGLEMAX: "Максимальный угол стрельбы",
  T_46_META_WS_P_SHOOTANGLEMIN: "Минимальный угол стрельбы",
  T_46_META_WS_P_SHOP: "Магазин",
  T_46_META_WS_P_SHOPITEMS: "Список полок",
  T_46_META_WS_P_SHOWADDFRIEND: "Показать Добавить Друга",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Показать атакующую гранату",
  T_46_META_WS_P_SHOWBACKGROUND: "Показать фон",
  T_46_META_WS_P_SHOWCROUCH: "Показать приседание",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Показывать урон",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Показать защитную гранату",
  T_46_META_WS_P_SHOWECCONOMY: "Показать Экономику",
  T_46_META_WS_P_SHOWECONOMY: "Показать Экономику",
  T_46_META_WS_P_SHOWFIRE: "Показать стрельбу",
  T_46_META_WS_P_SHOWFRAME: "Показать рамку",
  T_46_META_WS_P_SHOWGIFT: "Показать Подарок",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Показать эффект точки удара",
  T_46_META_WS_P_SHOWJUMP: "Показать прыжок",
  T_46_META_WS_P_SHOWLIKE: "Показать Лайк",
  T_46_META_WS_P_SHOWLOBBY: "Показать Лобби",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Показать Оценку Карты",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Показать Детали Матча",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Показать джойстик перемещения",
  T_46_META_WS_P_SHOWNAME: "Показать ник",
  T_46_META_WS_P_SHOWPIN: "Показать значок",
  T_46_META_WS_P_SHOWPRONE: "Показать ползание",
  T_46_META_WS_P_SHOWRANK: "Показать ранг",
  T_46_META_WS_P_SHOWREPLAY: "Показать Повтор",
  T_46_META_WS_P_SHOWREPORT: "Показать Жалобу",
  T_46_META_WS_P_SHOWSHARE: "Показать Поделиться",
  T_46_META_WS_P_SHOWSPRINT: "Показать бег",
  T_46_META_WS_P_SHOWTAG: "Показать Метку",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Показать информацию о товарищах по команде",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Состояние команды",
  T_46_META_WS_P_SHOWTEAMSCORE: "Показать счет команды",
  T_46_META_WS_P_SHOWTIMETYPE: "Показать время",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Счет двух команд",
  T_46_META_WS_P_SHRINKDURATION: "Время Уменьшения Радиуса (мс)",
  T_46_META_WS_P_SHRINKENDTIME: "Время Завершения Уменьшения Радиуса (мс)",
  T_46_META_WS_P_SHRINKSPEED: "Скорость сходимости",
  T_46_META_WS_P_SHRINKSTARTTIME: "Время Начала Уменьшения Радиуса (с)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Разрешить помощь при прицеливании",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Коэффициент затухания дистанции помощи при прицеливании (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Коэффициент влияния приоритета дистанции помощи при прицеливании (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Максимальная дистанция приоритета помощи при прицеливании",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Минимальная дистанция приоритета помощи при прицеливании",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Разрешить приоритет дистанц. помощи при прицел.",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Коэффициент притяжения прицела в пределах экрана (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Коэффициент увеличения зума",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Увеличение угла обзора (FOV)",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Чувствительность вращения прицела",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Коэффициент минимальной дистанции урона при прицеливании",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Время увеличения прицела (с)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Увеличение прицела",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Время восстановления прицела (с)",
  T_46_META_WS_P_SIZE: "Размер",
  T_46_META_WS_P_SIZEDELTA: "Изменение размера",
  T_46_META_WS_P_SKELETON: "Скелет",
  T_46_META_WS_P_SKIN: "Скин",
  T_46_META_WS_P_SKINID: "ID скина",
  T_46_META_WS_P_SKINWIDTH: "Толщина кожи",
  T_46_META_WS_P_SKYBOXENV: "Скайбокс",
  T_46_META_WS_P_SKYBOXRESOURCE: "Ресурс скайбокса",
  T_46_META_WS_P_SLOPELIMIT: "Предел наклона",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Плавный старт прокрутки",
  T_46_META_WS_P_SOFTNESS: "Мягкость",
  T_46_META_WS_P_SORTTYPE: "Тип сортировки",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Количество спаунов за волну",
  T_46_META_WS_P_SPAWNPOINT: "Точка возрождения",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Количество точек спауна",
  T_46_META_WS_P_SPAWNPOSITION: "Позиция спауна",
  T_46_META_WS_P_SPEED: "Скорость",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Уровень чувствительности",
  T_46_META_WS_P_SPRAYCOLOR: "Цвет Распылителя",
  T_46_META_WS_P_SPRINTENERGYCOST: "Стоимость энергии при спринте",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Скорость горизонтального спринта",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Масштаб скорости передвижения при спринте",
  T_46_META_WS_P_SPRITENAME: "Форма спрайта",
  T_46_META_WS_P_SPRITERESOURCE: "Ресурс спрайта",
  T_46_META_WS_P_SRCVAL: "Исходное Значение",
  T_46_META_WS_P_STARTDROPTIME: "Время Падения (мс)",
  T_46_META_WS_P_STARTEVENT: "Начало События",
  T_46_META_WS_P_STARTPOSITION: "Начальная Позиция",
  T_46_META_WS_P_STARTRADIUS: "Начальный Радиус",
  T_46_META_WS_P_STARTSPAWNTIME: "Время начала спауна (с)",
  T_46_META_WS_P_STARTTIME: "Время Начала (c)",
  T_46_META_WS_P_STARTVALUE: "Начальное Значение",
  T_46_META_WS_P_STATICICONCOLORS: "Цвета Статичных Иконок",
  T_46_META_WS_P_STATICICONS: "Статичные Иконки",
  T_46_META_WS_P_STATUS: "Состояние мини-сенсора",
  T_46_META_WS_P_STEPOFFSET: "Смещение ступеней",
  T_46_META_WS_P_STOPDURATION: "Продолжительность остановки",
  T_46_META_WS_P_STOPEVENT: "Остановка События",
  T_46_META_WS_P_STORE: "Магазин",
  T_46_META_WS_P_STROPID: "ID Стропа",
  T_46_META_WS_P_STYLE: "Стиль",
  T_46_META_WS_P_SUBTITLE: "Субтитры",
  T_46_META_WS_P_SUMMULTIPLIER: "Множитель суммы",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Ускорение выхода из раскачивания",
  T_46_META_WS_P_SWINGINGSPEED: "Скорость раскачивания",
  T_46_META_WS_P_TAGS: "Теги",
  T_46_META_WS_P_TARGETCHECKPOINTID: "Целевой идентификатор контрольной точки",
  T_46_META_WS_P_TARGETICONCOLORS: "Цвета Иконок Целей",
  T_46_META_WS_P_TARGETICONS: "Иконки Целей",
  T_46_META_WS_P_TARGETID: "ID цели",
  T_46_META_WS_P_TARGETITEMID: "ID Целевого Элемента",
  T_46_META_WS_P_TARGETROTATION: "Вращение Цели",
  T_46_META_WS_P_TARGETSCALE: "Масштаб Цели",
  T_46_META_WS_P_TEAMCOLOR: "Цвет команды",
  T_46_META_WS_P_TEAMCOLORS: "Цвета команд",
  T_46_META_WS_P_TEAMINDEXS: "Индексы команд",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Фактор повреждений союзников",
  T_46_META_WS_P_TEAMMEMBERNUM: "Количество членов команды",
  T_46_META_WS_P_TEAMNUM: "Количество команд",
  T_46_META_WS_P_TEAMRANK: "Рейтинг Команды",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Отображение Рейтинга Команды",
  T_46_META_WS_P_TEAMRANKS: "Рейтинги команд",
  T_46_META_WS_P_TEAMSCORES: "Счеты команд",
  T_46_META_WS_P_TEAMSEQ: "Последовательность команды",
  T_46_META_WS_P_TEMPLATEENTITY: "Шаблон сущности",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Временные щиты",
  T_46_META_WS_P_TERRAINWETNESS: "Влажность местности",
  T_46_META_WS_P_TEXT: "Текст",
  T_46_META_WS_P_TEXTCOLOR: "Цвет Текста",
  T_46_META_WS_P_TEXTKEY: "Ключ текста",
  T_46_META_WS_P_TEXTKEYPARAMS: "Параметры ключа",
  T_46_META_WS_P_TEXTURERESOURCE: "Ресурс текстуры",
  T_46_META_WS_P_THEMECOLOR: "Цвет темы",
  T_46_META_WS_P_THROWABLETYPE: "Тип бросаемых предметов",
  T_46_META_WS_P_THROWINGSPEED: "Скорость броска",
  T_46_META_WS_P_THROWSPEED: "Скорость броска",
  T_46_META_WS_P_TICKINTERVAL: "Интервал Тиков",
  T_46_META_WS_P_TIMEREQUIRED: "Требуемое время (мс)",
  T_46_META_WS_P_TIPSTYPE: "Тип подсказки",
  T_46_META_WS_P_TITLE: "Название",
  T_46_META_WS_P_TITLELIST: "Титулы",
  T_46_META_WS_P_TITLES: "Титулы",
  T_46_META_WS_P_TOP: "Верх",
  T_46_META_WS_P_TOPALPHA: "Верхний альфа",
  T_46_META_WS_P_TOTALHP: "Всего ХП",
  T_46_META_WS_P_TOTALLEVEL: "Общий уровень",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Общее количество раундов",
  T_46_META_WS_P_TOWSPEED: "Скорость буксировки",
  T_46_META_WS_P_TRANSITIONSTAGE: "Этап перехода",
  T_46_META_WS_P_TRANSITIONTYPE: "Тип перехода",
  T_46_META_WS_P_TRIGGERPLAYERID: "Деньги",
  T_46_META_WS_P_TRIGGERRADIUS: "Дальность триггера",
  T_46_META_WS_P_TRIGGERRANGE: "Дальность срабатывания",
  T_46_META_WS_P_TRIGGERTIME: "Время активации",
  T_46_META_WS_P_TURNSPEED: "Скорость поворота",
  T_46_META_WS_P_TWEENERENABLED: "Левая команда",
  T_46_META_WS_P_TWEENSTYLE: "Стиль анимации",
  T_46_META_WS_P_TYPE: "Тип",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Цвет при невыборе",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Спрайт при невыборе",
  T_46_META_WS_P_UNSELECTEDTYPE: "Тип при невыборе",
  T_46_META_WS_P_UP: "Вверх",
  T_46_META_WS_P_UPDATETYPE: "Тип обновления",
  T_46_META_WS_P_UPENERGYCOST: "Стоимость энергии вверх",
  T_46_META_WS_P_UPSPEED: "Скорость Вверх",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Индивидуальная сила толчка",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Использовать Пользовательский Ресурс",
  T_46_META_WS_P_USEDCAPACITY: "Используемая емкость",
  T_46_META_WS_P_USEGRAVITY: "Использовать гравитацию",
  T_46_META_WS_P_USEPHYSICALCCT: "Использовать физический CCT",
  T_46_META_WS_P_USERUID: "Пользователь UID",
  T_46_META_WS_P_UVOFFSET: "Смещение UV",
  T_46_META_WS_P_UVSIZE: "Размер UV",
  T_46_META_WS_P_VALUE: "Значение",
  T_46_META_WS_P_VAULTDISTANCE: "Расстояние Перепрыгивания",
  T_46_META_WS_P_VAULTHEIGHT: "Высота Перепрыгивания",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Фактор повреждений транспортного средства",
  T_46_META_WS_P_VEHICLESKINID: "ID обшивки транспортного средства",
  T_46_META_WS_P_VEHICLESKINIDS: "ID скина транспортного средства",
  T_46_META_WS_P_VELOCITY: "Скорость (м/с)",
  T_46_META_WS_P_VELOCITYXZ: "Скорость по осям XZ",
  T_46_META_WS_P_VELOCITYY: "Скорость по оси Y",
  T_46_META_WS_P_VERTICALBAR: "Вертикальная полоса",
  T_46_META_WS_P_VERTICALOFFSET: "Вертикальное смещение",
  T_46_META_WS_P_VEST: "Жилет",
  T_46_META_WS_P_VFXTEXTURETYPE: "Тип текстуры эффекта",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Ограничение угла обзора",
  T_46_META_WS_P_VISIBILITYLAYER: "Слой видимости",
  T_46_META_WS_P_VISIBLE: "Видимый",
  T_46_META_WS_P_VISIBLEONBACK: "Видимый на спине",
  T_46_META_WS_P_VISIBLEPLAYERS: "Список Видимых Игроков",
  T_46_META_WS_P_VOLUME: "Громкость",
  T_46_META_WS_P_WALLETID: "ID кошелька",
  T_46_META_WS_P_WANDERRANGE: "Диапазон блуждания",
  T_46_META_WS_P_WAVECOUNT: "Количество волн",
  T_46_META_WS_P_WAVEINTERVAL: "Интервал между волнами",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Скорость урона оружия",
  T_46_META_WS_P_WEAPONSKINIDS: "Идентификаторы скинов оружия",
  T_46_META_WS_P_WEAPONSUBTYPE: "Подтип оружия",
  T_46_META_WS_P_WEAPONTYPE: "Тип оружия",
  T_46_META_WS_P_WIDTH: "Ширина",
  T_46_META_WS_P_WINMVPS: "Победители MVP",
  T_46_META_WS_P_WINTEXT: "Текст победы",
  T_46_META_WS_P_WORDWRAP: "Перенос слов",
  T_46_META_WS_P_WORLDPOSITION: "Мировая позиция",
  T_46_META_WS_P_YAW: "Отклонение",
  T_46_META_WS_PATROLALONG: "Патрулировать вдоль",
  T_46_META_WS_PATROLTO: "Патрулировать до",
  T_46_META_WS_PAUSE: "Пауза",
  T_46_META_WS_PAUSEEMOTE: "Приостановить Эмодзи",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Приостановить фиксированное обновление",
  T_46_META_WS_PHASE: "Фаза",
  T_46_META_WS_PLAY: "Воспроизвести",
  T_46_META_WS_PLAYANIMATION: "Воспроизвести анимацию",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Воспроизвести анимационный клип персонажа",
  T_46_META_WS_PLAYEMOTE: "Запустить Эмоцию",
  T_46_META_WS_PLAYER: "Игрок",
  T_46_META_WS_PORTAL: "Портал",
  T_46_META_WS_POSE: "Поза",
  T_46_META_WS_POSITION: "Позиция",
  T_46_META_WS_PREPOSE: "Предварительная поза",
  T_46_META_WS_PROFANITYFILTER: "Фильтр нецензурной лексики",
  T_46_META_WS_PURSUITTARGET: "Цель преследования",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Кватернион в угловую ось",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Кватернион в углы Эйлера",
  T_46_META_WS_QUITCHATCHANNEL: "Выйти из канала чата",
  T_46_META_WS_QUITFACTION: "Выйти из фракции",
  T_46_META_WS_QUITGAME: "Выйти из игры",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Выйти из мини-игры по побегу из тюрьмы",
  T_46_META_WS_RANDOMFLOAT: "Случайное Вещественное",
  T_46_META_WS_RANDOMINT: "Случайное Целое",
  T_46_META_WS_RANK: "Рейтинг",
  T_46_META_WS_READCSV: "Читать CSV",
  T_46_META_WS_READCSVCELL: "Читать ячейку CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Читать ячейку CSV по имени",
  T_46_META_WS_READCSVCELLFROMSERVER: "Читать ячейку CSV с сервера",
  T_46_META_WS_READCSVCOLUMN: "Читать столбец CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Читать столбец CSV с сервера",
  T_46_META_WS_READCSVFROMSERVER: "Читать CSV с сервера",
  T_46_META_WS_READCSVROW: "Читать строку CSV",
  T_46_META_WS_READCSVROWBYKEY: "Читать строку CSV по ключу",
  T_46_META_WS_READCSVROWFROMSERVER: "Читать строку CSV с сервера",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Прочитать из накопленного хранилища данных",
  T_46_META_WS_READFROMDATASTORE: "Прочитать из хранилища данных",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Прочитать из хранилища данных таблицы лидеров",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Прочитать из хранилища данных таблицы лидеров по рангу",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Удалить особое внимание AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Удалить скин рюкзака",
  T_46_META_WS_REMOVEBUFF: "Удалить бафф",
  T_46_META_WS_REMOVECOMPONENT: "Удалить компонент",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Удалить коэффициент формулы свойства",
  T_46_META_WS_REMOVEOUTFIT: "Удалить наряд",
  T_46_META_WS_REMOVESCRIPT: "Удалить скрипт",
  T_46_META_WS_REMOVEVEHICLESKIN: "Удалить скин транспортного средства",
  T_46_META_WS_REMOVEWEAPONSKIN: "Удалить скин оружия",
  T_46_META_WS_REPLACE: "Заменить",
  T_46_META_WS_REQUESTMATCHMAKING: "Запрос на матчмейкинг",
  T_46_META_WS_RESET: "Сбросить",
  T_46_META_WS_RESETBACKPACKSKIN: "Сбросить скин рюкзака",
  T_46_META_WS_RESETDYEING: "Сбросить окраску",
  T_46_META_WS_RESETJERSEY: "Сбросить форму",
  T_46_META_WS_RESETOUTFIT: "Сбросить наряд",
  T_46_META_WS_RESETVEHICLESKIN: "Сбросить скин транспортного средства",
  T_46_META_WS_RESETWEAPONSKIN: "Сбросить скин оружия",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Возобновить фиксированное обновление",
  T_46_META_WS_REVERSE: "Обратить",
  T_46_META_WS_REVIVALSOURCE: "Источник возрождения",
  T_46_META_WS_REVIVE: "Возродить",
  T_46_META_WS_ROUND: "Округлить",
  T_46_META_WS_ROUNDINDEX: "Индекс раунда",
  T_46_META_WS_SAMPLEONCURVE: "Сэмплинг по кривой",
  T_46_META_WS_SCENENAME: "Название сцены",
  T_46_META_WS_SCORE: "Очки",
  T_46_META_WS_SCORER: "Забиватель",
  T_46_META_WS_SCORETYPE: "Тип очков",
  T_46_META_WS_SCREENMULTIRAYCAST: "Множественные лучи касания экрана",
  T_46_META_WS_SCREENSINGLERAYCAST: "Один луч касания экрана",
  T_46_META_WS_SCREENTOUCHRAY: "Луч касания экрана",
  T_46_META_WS_SCREENTOWORLDPOINT: "Экран в мир",
  T_46_META_WS_SENDEVENT: "Отправить событие",
  T_46_META_WS_SETACTIVE: "Установить активное",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Установить Статус Движения для Всех Игроков",
  T_46_META_WS_SETATTACKABLEENTITY: "Установить атакуемую сущность",
  T_46_META_WS_SETATTACKABLEFACTION: "Установить атакуемую фракцию",
  T_46_META_WS_SETATTACKABLETEAM: "Установить атакуемую команду",
  T_46_META_WS_SETBACKPACKSKIN: "Установить скин рюкзака",
  T_46_META_WS_SETBEHAVIORSTATUS: "Установить статус поведения",
  T_46_META_WS_SETBLACKBOARDVALUE: "Установить значение черного доски",
  T_46_META_WS_SETBUNDLE: "Установить комплект",
  T_46_META_WS_SETCAMERAFOCUS: "Установить фокус камеры",
  T_46_META_WS_SETCAMERAFOLLOW: "Установить следование камеры",
  T_46_META_WS_SETCHARACTER: "Установить персонажа",
  T_46_META_WS_SETCULLINGMASK: "Установить маску отсечения",
  T_46_META_WS_SETCULLINGMASKLAYER: "Установить слой маски отсечения",
  T_46_META_WS_SETDEFAULTUISTATUS: "Установить статус интерфейса по умолчанию",
  T_46_META_WS_SETDROPSTATUS: "Установить статус выброса",
  T_46_META_WS_SETFALLINGDAMAGE: "Установить урон от падения",
  T_46_META_WS_SETFOOTBALLPOSITION: "Установить позицию футбольного мяча",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Установить абсолютное свойство формулы",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Установить относительное свойство формулы",
  T_46_META_WS_SETFORWARD: "Установить направление",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Установить глобальный порог сна",
  T_46_META_WS_SETINVINCIBILITY: "Установить Статус Невозможности Получения Урона",
  T_46_META_WS_SETJERSEY: "Установить форму",
  T_46_META_WS_SETOUTFIT: "Установить наряд",
  T_46_META_WS_SETPARENT: "Установить родителя",
  T_46_META_WS_SETPARENTCLIENT: "Установить родительский элемент",
  T_46_META_WS_SETPICKUPSTATUS: "Установить статус подбора",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Установить статус быстрого сообщения игрока",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Установить статус голосовой связи игрока",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Установить свойство плавно",
  T_46_META_WS_SETSKILLS: "Установить навыки",
  T_46_META_WS_SETSKYBOX: "Установить Скайбокс",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Установить порог сна",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Установить Статус Специального Предмета",
  T_46_META_WS_SETVEHICLESKIN: "Установить скина транспортного средства",
  T_46_META_WS_SETWEAPONSKIN: "Установить скин оружия",
  T_46_META_WS_SETWIDGETPARENT: "Установить родителя виджета",
  T_46_META_WS_SHOPITEM: "Магазин предметов",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Показать группу внешности",
  T_46_META_WS_SHUFFLE: "Перемешать",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Однократное лучевое обнаружение",
  T_46_META_WS_SKILL: "Навык",
  T_46_META_WS_SLEEP: "Сон",
  T_46_META_WS_SLERPQUATERNION: "Интерполяция кватерниона",
  T_46_META_WS_SPAWNABLES: "Можно спаун",
  T_46_META_WS_SPAWNEDITEM: "Порожденный предмет",
  T_46_META_WS_SPAWNNEXTWAVE: "Создать следующую волну",
  T_46_META_WS_SPHERECAST: "Обнаружение сферы",
  T_46_META_WS_SPHEREOVERLAP: "Перекрытие сферы",
  T_46_META_WS_SPLIT: "Разделить",
  T_46_META_WS_SQRT: "Квадратный Корень",
  T_46_META_WS_STARTPARACHUTE: "Начать парашютирование",
  T_46_META_WS_STARTPOSITION: "Стартовая позиция",
  T_46_META_WS_STATENAME: "Имя состояния",
  T_46_META_WS_STATUS: "Статус",
  T_46_META_WS_STRINGTOFLOAT: "Строка в число с плавающей запятой",
  T_46_META_WS_STRINGTOINT: "Строка в целое число",
  T_46_META_WS_STRIP: "Полоска",
  T_46_META_WS_SUB: "Вычесть",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Переключить наблюдателя AOI-прокси",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Переключить группу внешности",
  T_46_META_WS_SWITCHAREA: "Переключить область",
  T_46_META_WS_SWITCHCAMERA: "Переключить камеру",
  T_46_META_WS_SWITCHPHASE: "Переключить Фазу",
  T_46_META_WS_SWITCHSCENE: "Переключить сцену",
  T_46_META_WS_SWITCHWEAPON: "Переключить оружие",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Раненый игрок ",
  T_46_META_WS_TEAM: "Команда",
  T_46_META_WS_TELEPORT: "Телепортироваться",
  T_46_META_WS_TELEPORTCCT: "Телепортировать CCT",
  T_46_META_WS_TEXT: "Текст",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Временная метка в строку локализации",
  T_46_META_WS_TIRE: "Шина",
  T_46_META_WS_TOLOWER: "Преобразовать в нижний регистр",
  T_46_META_WS_TOSTRING: "В строку",
  T_46_META_WS_TOUPPER: "Преобразовать в верхний регистр",
  T_46_META_WS_TRANSFERMONEY: "Перевести деньги",
  T_46_META_WS_TRIGGER: "Триггер",
  T_46_META_WS_TYPEIS: "Тип является",
  T_46_META_WS_UNLOADSCENE: "Разгрузить сцену",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Обновить миссию по побегу из тюрьмы",
  T_46_META_WS_UPLOADGAMERESULT: "Загрузить результат игры",
  T_46_META_WS_VALUE: "Повреждения",
  T_46_META_WS_VECTOR2ANGLE: "Vector2Angle",
  T_46_META_WS_VECTOR2DISTANCE: "Расстояние Вектора 2D",
  T_46_META_WS_VECTOR2DOT: "Vector2Dot",
  T_46_META_WS_VECTOR2MAGNITUDE: "Vector2Magnitude",
  T_46_META_WS_VECTOR2NORMALIZE: "Vector2Normalize",
  T_46_META_WS_VECTOR2REFLECT: "Vector2Reflect",
  T_46_META_WS_VECTOR2TOVECTOR3: "Vector2 на Vector3",
  T_46_META_WS_VECTOR3REFLECT: "Vector3Reflect",
  T_46_META_WS_VECTOR3TOVECTOR2: "Vector3 на Vector2",
  T_46_META_WS_VEHICLE: "Транспортное средство",
  T_46_META_WS_VELOCITY: "Скорость ",
  T_46_META_WS_WAITFORMILESECOND: "Подождать Миллисекунды",
  T_46_META_WS_WAITFORNEXTFRAME: "Подождать Следующий Кадр",
  T_46_META_WS_WAKEUP: "Разбудить",
  T_46_META_WS_WAVES: "Волны",
  T_46_META_WS_WEAPON: "Оружие",
  T_46_META_WS_WORLDTOSCREENPOINT: "Мир в экран",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Записать в накопленное хранилище данных",
  T_46_META_WS_WRITETODATASTORE: "Записать в хранилище данных",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Записать в хранилище данных таблицы лидеров",
  T_48_META_API_1_D: "Получите всех игроков в текущей игре и верните список игроков.",
  T_48_META_API_1_R_D: "Список игроков",
  T_48_META_API_10_D: "Получение объектов сцены",
  T_48_META_API_10_P0_D: "Какие типы объектов сцены следует фильтровать",
  T_48_META_API_10_R_D: "Список объектов сцены",
  T_48_META_API_100_D: "Загрузка сценариев без автоматической выгрузки уже загруженных сценариев",
  T_48_META_API_100_P0_D: "Идентификатор сцены, которая будет загружена",
  T_48_META_API_10000_D: "Возвращает сущность, к которой привязан текущий скрипт",
  T_48_META_API_10000_R_D: "Сущность, к которой привязан текущий скрипт",
  T_48_META_API_10001_D: "Используйте ID сущности, чтобы найти соответствующую сущность. Этот API предназначен только для редакторов, использование этого API пользователем не гарантирует его совместимости, например, удаление или корректировка",
  T_48_META_API_10001_P0_D: "Идентификатор целевой организации",
  T_48_META_API_10001_R_D: "вещь, имеющая материальное существование (в отличие от концептуального, виртуального или сетевого существования)",
  T_48_META_API_10002_D: "Получите глобальную сущность для игры",
  T_48_META_API_10002_R_D: "глобальная организация",
  T_48_META_API_10003_D: "Телепортирует игроков в определенные координаты (устарело, используйте Teleport).",
  T_48_META_API_10003_P0_D: "Телепортированные игроки",
  T_48_META_API_10003_P1_D: "Координаты перемещаемой точки",
  T_48_META_API_10004_D: "Получает позицию рядом с товарищами по команде, обходит позиции игроков, которые не могут стоять (устарело, используйте GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "целевой игрок",
  T_48_META_API_10004_R_D: "Координаты рядом с товарищами по команде",
  T_48_META_API_10005_D: "Игроки, принадлежащие компании-покупателю",
  T_48_META_API_10005_P0_D: "Целевая сущность, сущность будет синхронизироваться только с игроком, которому она принадлежит",
  T_48_META_API_10005_R_D: "Игрок, которому принадлежит целевая сущность",
  T_48_META_API_10006_D: "Сделать игрока непобедимым",
  T_48_META_API_10006_P0_D: "целевой игрок",
  T_48_META_API_10006_P1_D: "Длительность эффекта неуязвимости, в секундах",
  T_48_META_API_10007_D: "Клонирование выбранной сущности и всех ее свойств в исходное положение",
  T_48_META_API_10007_P0_D: "Созданные субъекты",
  T_48_META_API_10007_P1_D: "объект для клонирования",
  T_48_META_API_10008_D: "Наносит урон игроку, если не выбран источник урона, цель получает урон от системы",
  T_48_META_API_10008_P0_D: "Пострадавшие субъекты игорного бизнеса",
  T_48_META_API_10008_P1_D: "Игровые сущности, наносящие урон",
  T_48_META_API_10008_P2_D: "Тип повреждения",
  T_48_META_API_10008_P3_D: "количество повреждений",
  T_48_META_API_10009_D: "Воскрешение назначенного игрока",
  T_48_META_API_10009_P0_D: "Воскрешенные игроки",
  T_48_META_API_1001_D: "Если условие выполнено, выполняется узел в строке IF. Если условие не выполнено, выполняется узел ELSE, если есть ELSE, в противном случае завершается оператор IF.",
  T_48_META_API_1001_P0_D: "Список условий должен соответствовать количеству списков подпроцедур (списков логических ветвей).",
  T_48_META_API_10010_D: "Создает элемент или список элементов в указанном месте.",
  T_48_META_API_10010_P0_D: "Место создания предмета",
  T_48_META_API_10010_P1_D: "Созданные элементы или списки элементов",
  T_48_META_API_10010_P2_D: "Количество создаваемых элементов. При создании списка элементов необходимо заполнить список количеством элементов, соответствующим порядку списка элементов.",
  T_48_META_API_10011_D: "ИИ-существа, патрулирующие к целевым точкам",
  T_48_META_API_10011_P0_D: "Целевые объекты искусственного интеллекта",
  T_48_META_API_10011_P1_D: "Движущаяся точка прицеливания",
  T_48_META_API_10011_P2_D: "Вернуться ли в точку отправления",
  T_48_META_API_10011_P3_D: "Обнаружены ли враждебные цели и атакованы ли они во время патрулирования",
  T_48_META_API_10012_D: "Патрулирование сущностей ИИ в порядке возрастания списка координат",
  T_48_META_API_10012_P0_D: "Целевые объекты искусственного интеллекта",
  T_48_META_API_10012_P1_D: "Список движущихся координатных точек",
  T_48_META_API_10012_P2_D: "Тип патруля, с возможностью выбора одиночного, кольцевого цикла или цикла",
  T_48_META_API_10012_P3_D: "Обнаружены ли враждебные цели и атакованы ли они во время патрулирования",
  T_48_META_API_10013_D: "Генератор немедленно обновляет следующую волну сущностей.",
  T_48_META_API_10013_P0_D: "генераторная установка",
  T_48_META_API_10014_D: "Добавьте фактор для расчета вычисляемых атрибутов, которые будут вычисляться по формуле, состоящей из факторов, для получения конечного результата.",
  T_48_META_API_10014_P0_D: "целевая организация",
  T_48_META_API_10014_P1_D: "Вычисляемые типы атрибутов",
  T_48_META_API_10014_P2_D: "Тип коэффициента вычисления",
  T_48_META_API_10014_P3_D: "Расчет значений коэффициентов",
  T_48_META_API_10015_D: "Очистить коэффициент вычисления для вычисляемых атрибутов",
  T_48_META_API_10015_P0_D: "целевая организация",
  T_48_META_API_10015_P1_D: "Вычисляемые типы атрибутов",
  T_48_META_API_10016_D: "Очистить все вычислительные коэффициенты для всех вычисляемых атрибутов целевой сущности",
  T_48_META_API_10016_P0_D: "целевая организация",
  T_48_META_API_10017_D: "Изменение атрибутов",
  T_48_META_API_10017_P0_D: "целевая организация",
  T_48_META_API_10017_P1_D: "Тип атрибута",
  T_48_META_API_10017_P2_D: "Метод модификации",
  T_48_META_API_10017_P3_D: "(стоить",
  T_48_META_API_10018_D: "Установка значения вычисляемого свойства",
  T_48_META_API_10018_P0_D: "целевая организация",
  T_48_META_API_10018_P1_D: "Тип атрибута",
  T_48_META_API_10018_P2_D: "(стоить",
  T_48_META_API_10019_D: "Очистка отдельных модификаций вычисляемых свойств",
  T_48_META_API_10019_P0_D: "целевая организация",
  T_48_META_API_10019_P1_D: "Тип атрибута",
  T_48_META_API_1002_D: "Параметр i начинается с минимального значения, и при каждом запуске узла i увеличивается с шагом, пока i не станет больше или равным максимальному значению.",
  T_48_META_API_1002_P0_D: "Имя циклического индекса, которое можно использовать для получения значения циклического индекса локальной переменной.",
  T_48_META_API_1002_P1_D: "Циклическое начальное значение",
  T_48_META_API_1002_P2_D: "стоимость в конце цикла",
  T_48_META_API_1002_P3_D: "Размер шага цикла, когда начальное значение меньше конечного, размер шага должен быть больше 0; когда начальное значение больше конечного, размер шага должен быть меньше 0",
  T_48_META_API_10020_D: "Получите все объекты в игре, которые соответствуют критериям фильтрации",
  T_48_META_API_10020_P0_D: "Результат фильтрации должен содержать тип, указанный в этом параметре",
  T_48_META_API_10020_P1_D: "Результат фильтрации не должен содержать тип, указанный в этом параметре",
  T_48_META_API_10020_P2_D: "Результаты фильтрации содержат хотя бы один из типов, введенных в этом параметре",
  T_48_META_API_10020_R_D: "Отфильтруйте список полученных сущностей",
  T_48_META_API_10021_D: "Если к футбольному мячу добавить скорость, то скорость изменится на ускорение в том же направлении",
  T_48_META_API_10021_P0_D: "Футбол по воротам",
  T_48_META_API_10021_P1_D: "Добавлена скорость движения в 3D-пространстве",
  T_48_META_API_10022_D: "Уничтожение обозначенных организаций",
  T_48_META_API_10022_P0_D: "Целевые объекты, подлежащие уничтожению",
  T_48_META_API_10023_D: "Добавление меток к сущностям",
  T_48_META_API_10023_P0_D: "целевая организация",
  T_48_META_API_10023_P1_D: "Пользовательские этикетки",
  T_48_META_API_10024_D: "Удаление меток для сущностей",
  T_48_META_API_10024_P0_D: "целевая организация",
  T_48_META_API_10024_P1_D: "Пользовательские этикетки",
  T_48_META_API_10025_D: "Определите, содержит ли целевая сущность указанный тег",
  T_48_META_API_10025_P0_D: "целевая организация",
  T_48_META_API_10025_P1_D: "Пользовательские этикетки",
  T_48_META_API_10025_R_D: "Включать или не включать указанный тег",
  T_48_META_API_10026_D: "Установка футбольной позиции",
  T_48_META_API_10026_P0_D: "футбольная организация",
  T_48_META_API_10026_P1_D: "размещение",
  T_48_META_API_10026_P2_D: "Поддержание скорости",
  T_48_META_API_10027_D: "Получите объект камеры, который в данный момент используется целевым игроком",
  T_48_META_API_10027_P0_D: "целевой игрок",
  T_48_META_API_10027_R_D: "Текущая используемая сущность камеры",
  T_48_META_API_10028_D: "Переключая камеру целевого игрока на камеру цели, можно",
  T_48_META_API_10028_P0_D: "целевой игрок",
  T_48_META_API_10028_P1_D: "целевая камера",
  T_48_META_API_10028_P2_D: "Метод переключения, вы можете выбрать, чтобы сохранить оригинальную логику или прогрессивный",
  T_48_META_API_10028_P3_D: "Время переключения - это время переключения камер в прогрессивном режиме",
  T_48_META_API_10029_D: "Создайте камеру",
  T_48_META_API_10029_P0_D: "Тип созданной камеры",
  T_48_META_API_10029_P1_D: "Созданная сущность камеры",
  T_48_META_API_1003_D: "Реализуйте обход контейнера данных, чтобы добраться до каждого подэлемента, содержащего подпроцедуры, тело цикла - это подпроцедура",
  T_48_META_API_1003_P0_D: "Итерация по имени дочернего элемента, которая может быть использована для получения значения дочернего элемента в локальной переменной",
  T_48_META_API_1003_P1_D: "Имя циклического индекса, которое можно использовать для получения значения циклического индекса локальной переменной.",
  T_48_META_API_1003_P2_D: "Контейнер данных для обхода, в настоящее время поддерживаются следующие типы: тип массива",
  T_48_META_API_10030_D: "Убивать боеспособных существ",
  T_48_META_API_10030_P0_D: "Целевая структура, которая должна быть боеспособной",
  T_48_META_API_10031_D: "Установите активное состояние целевой сущности и ее дочерних узлов; доступность, видимость, коллизии и т.д. отключаются для неактивных объектов",
  T_48_META_API_10031_P0_D: "целевая организация",
  T_48_META_API_10031_P1_D: "Активный или неактивный",
  T_48_META_API_10032_D: "Установите положение объекта камеры так, чтобы она всегда следовала за целевым объектом",
  T_48_META_API_10032_P0_D: "целевой объект камеры",
  T_48_META_API_10032_P1_D: "Целевой объект для следования.",
  T_48_META_API_10032_P2_D: "Смещение относительно координат целевого объекта",
  T_48_META_API_10032_P3_D: "Система координат для смещений",
  T_48_META_API_10033_D: "Установите объект камеры так, чтобы он всегда был обращен к целевому объекту",
  T_48_META_API_10033_P0_D: "целевой объект камеры",
  T_48_META_API_10033_P1_D: "целевая организация",
  T_48_META_API_10033_P2_D: "Смещение точки взгляда от целевых координат",
  T_48_META_API_10033_P3_D: "Система координат для смещений",
  T_48_META_API_10034_D: "Создать твин",
  T_48_META_API_10034_P0_D: "целевая организация",
  T_48_META_API_10034_P1_D: "Идентификатор собственности",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Стиль",
  T_48_META_API_10034_P5_D: "Кривая",
  T_48_META_API_10034_P6_D: "Продолжительность",
  T_48_META_API_10034_P7_D: "между сущностями",
  T_48_META_API_10035_D: "Для установки родительского узла необходимо, чтобы и родительский, и дочерний узел имели компонент Transform",
  T_48_META_API_10035_P0_D: "родительский узел",
  T_48_META_API_10035_P1_D: "дочерний узел",
  T_48_META_API_10035_P2_D: "Сохранять ли текущую позицию мира, вращение и масштабирование дочерних узлов, этот элемент недействителен при настройке UI.",
  T_48_META_API_10036_D: "NewCurve (устарело, используйте CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Точки контроля",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Попытка воспроизвести целевую сущность, которая должна иметь воспроизводимый компонент",
  T_48_META_API_10037_P0_D: "Целевая играбельная сущность",
  T_48_META_API_10037_P1_D: `Нужно ли воспроизводить 
true: воспроизведение 
false: продолжение воспроизведения`,
  T_48_META_API_10038_D: "Приостановить воспроизводимые объекты",
  T_48_META_API_10038_P0_D: "Целевая играбельная сущность",
  T_48_META_API_10039_D: "При создании баллистического движения целевой объект получает начальную скорость и ускорение с направлением",
  T_48_META_API_10039_P0_D: "целевая организация",
  T_48_META_API_10039_P1_D: "начальная скорость",
  T_48_META_API_10039_P2_D: "ускорение движения",
  T_48_META_API_10039_P3_D: "Максимальное расстояние перемещения",
  T_48_META_API_10039_P4_D: "Созданные объекты баллистического движения",
  T_48_META_API_10039_P5_D: "Начинается ли воспроизведение автоматически после создания",
  T_48_META_API_1004_D: "Прерывает текущий процесс цикла и завершает его",
  T_48_META_API_10040_D: "Создает движение с позиционным следованием, в котором целевой объект следует за указанным объектом.",
  T_48_META_API_10040_P0_D: "целевая организация",
  T_48_META_API_10040_P1_D: "Объекты, которые следуют за движением",
  T_48_META_API_10040_P2_D: "Расстояние следует за смещением координат цели",
  T_48_META_API_10040_P3_D: "Используемая система координат",
  T_48_META_API_10040_P4_D: "Созданная сущность Follow Motion Entity",
  T_48_META_API_10040_P5_D: "Начинается ли воспроизведение автоматически после создания",
  T_48_META_API_10041_D: "Создает движение следования взглядом, при котором целевая сущность остается ориентированной на указанный объект.",
  T_48_META_API_10041_P0_D: "целевая организация",
  T_48_META_API_10041_P1_D: "рассматриваемая организация",
  T_48_META_API_10041_P2_D: "Смещение точки взгляда от объекта",
  T_48_META_API_10041_P3_D: "Используемая система координат",
  T_48_META_API_10041_P4_D: "Созданные объекты, следящие за движением взгляда",
  T_48_META_API_10041_P5_D: "Начинается ли воспроизведение автоматически после создания",
  T_48_META_API_10042_D: "заброшенный",
  T_48_META_API_10042_P0_D: "субъект игрока",
  T_48_META_API_10042_P1_D: "результаты конкурса",
  T_48_META_API_10042_P2_D: "заброшенный",
  T_48_META_API_10042_P3_D: "заброшенный",
  T_48_META_API_10042_P4_D: "заброшенный",
  T_48_META_API_10043_D: "Сглаживание устанавливает свойства целевой сущности, свойства изменяются немедленно, но клиент воспроизводит плавный переход производительности",
  T_48_META_API_10043_P0_D: "целевая организация",
  T_48_META_API_10043_P1_D: "Атрибут целевой сущности",
  T_48_META_API_10043_P2_D: "Целевое значение, которое должно соответствовать типу, требуемому при определении свойства",
  T_48_META_API_10044_D: "Выполните обнаружение луча и верните первый объект, попадающий в направлении луча. Для объекта попадания требуется компонент столкновения. Если параметр уровня заполнен пустым местом, можно обнаружить ландшафт.",
  T_48_META_API_10044_P0_D: "Координаты начальной позиции",
  T_48_META_API_10044_P1_D: "Направление обнаружения излучения",
  T_48_META_API_10044_P2_D: "Расстояние обнаружения радиации, принимаются только положительные значения",
  T_48_META_API_10044_P3_D: "Маска слоя обнаружения лучей, в сканировании будут участвовать только заполненные слои, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_10044_P4_D: "Возможно ли сканирование на наличие триггеров",
  T_48_META_API_10044_P5_D: "объект поражения",
  T_48_META_API_10044_P6_D: "координаты точки попадания",
  T_48_META_API_10044_P7_D: "Расстояние точки попадания от начальной точки",
  T_48_META_API_10044_P8_D: "попасть в нормаль к поверхности .",
  T_48_META_API_10045_D: "Выполните обнаружение луча и верните все объекты, попадающие в направлении луча от ближнего до дальнего. Если параметр уровня заполнен пустым местом, местность может быть обнаружена.",
  T_48_META_API_10045_P0_D: "Координаты начальной позиции",
  T_48_META_API_10045_P1_D: "Направление обнаружения излучения",
  T_48_META_API_10045_P2_D: "Расстояние обнаружения радиации, принимаются только положительные значения",
  T_48_META_API_10045_P3_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_10045_P4_D: "Можно ли обнаружить триггер",
  T_48_META_API_10045_P5_D: "Список объектов, попавших под удар",
  T_48_META_API_10045_P6_D: "Список очков попадания",
  T_48_META_API_10045_P7_D: "Список расстояний точек попадания от начальных точек",
  T_48_META_API_10045_P8_D: "попасть в нормаль к поверхности .",
  T_48_META_API_10046_D: "Создание твердых тел для шаблонов с помощью сборных тел",
  T_48_META_API_10046_P0_D: "Созданные субъекты",
  T_48_META_API_10046_P1_D: "Идентификатор сборного корпуса",
  T_48_META_API_10047_D: "обесцветить",
  T_48_META_API_10047_P0_D: "Установка нормалей объектов",
  T_48_META_API_10047_P1_D: "Установка точки окрашивания",
  T_48_META_API_10047_P2_D: "цвет",
  T_48_META_API_10048_D: "Состояние цвета",
  T_48_META_API_10048_P0_D: "Установка точки окрашивания",
  T_48_META_API_10048_P1_D: "Установление направления",
  T_48_META_API_10048_P2_D: "Расстояние установки",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Статистика раскрашивания",
  T_48_META_API_10049_P0_D: "цвет",
  T_48_META_API_10049_R_D: "Количество цветов",
  T_48_META_API_1005_D: "Пропустите оставшуюся часть тела петли и перейдите непосредственно к следующей петле.",
  T_48_META_API_10050_D: 'Раскраска "Плоский диапазон',
  T_48_META_API_10050_P0_D: "Установка нормалей объектов",
  T_48_META_API_10050_P1_D: "Установка точки окрашивания",
  T_48_META_API_10050_P2_D: "Установка диапазона окрашивания",
  T_48_META_API_10050_P3_D: "цвет",
  T_48_META_API_10050_P4_D: "Количество цветов",
  T_48_META_API_10051_D: "региональное пятно",
  T_48_META_API_10051_P0_D: "Установка нормалей объектов",
  T_48_META_API_10051_P1_D: "Установка точки окрашивания",
  T_48_META_API_10051_P2_D: "Установка диапазона окрашивания",
  T_48_META_API_10051_P3_D: "цвет",
  T_48_META_API_10051_P4_D: "Фиксированная зона окрашивания",
  T_48_META_API_10051_P5_D: "Коэффициент случайности (математика)",
  T_48_META_API_10051_P6_D: "случайный коэффициент затухания",
  T_48_META_API_10051_P7_D: "Количество цветов",
  T_48_META_API_10052_D: "Получение всех дочерних элементов целевого родительского объекта",
  T_48_META_API_10052_P0_D: "головная организация",
  T_48_META_API_10052_R_D: "список дочерних узлов",
  T_48_META_API_10053_D: "Получение указанного дочернего узла целевой родительской сущности на основе индекса",
  T_48_META_API_10053_P0_D: "головная организация",
  T_48_META_API_10053_P1_D: "Индекс поднода",
  T_48_META_API_10053_R_D: "дочерняя организация",
  T_48_META_API_10054_D: "Получение родителя целевой дочерней сущности",
  T_48_META_API_10054_P0_D: "дочерняя организация",
  T_48_META_API_10054_R_D: "головная организация",
  T_48_META_API_10055_D: "Удаляет все дочерние узлы под указанным родительским узлом; узлы должны иметь компонент Transform",
  T_48_META_API_10055_P0_D: "головная организация",
  T_48_META_API_10056_D: "Телепортировать цель в указанное место",
  T_48_META_API_10056_P0_D: "транспортная единица (например, военная)",
  T_48_META_API_10056_P1_D: "координаты точки передачи",
  T_48_META_API_10056_P2_D: "ориентация устройства после передачи",
  T_48_META_API_10057_D: "Получите случайное местоположение товарища по команде поблизости и вернитесь к своим собственным координатам поблизости, когда у вас нет товарища, что позволит избежать местоположения игроков, которые не могут стоять на ногах",
  T_48_META_API_10057_P0_D: "целевой игрок",
  T_48_META_API_10057_R_D: "Координаты рядом с товарищами по команде целевого игрока",
  T_48_META_API_10058_D: "Четкое состояние окраски",
  T_48_META_API_10059_D: "Воспроизведите указанный звуковой эффект, и если нужно задать больше атрибутов, то задайте атрибуты его сущности дальше через сущность",
  T_48_META_API_10059_P0_D: "В коде это имя формального параметра, используемого для представления сущности, создающей звуковой эффект, а соответствующее ему значение локальной переменной - это сущность, создающая звуковой эффект",
  T_48_META_API_10059_P1_D: "Сущность игрока, которой она принадлежит, видимая только для этого игрока",
  T_48_META_API_10059_P2_D: "Типы звуков - виды звуковых эффектов, которые может выбрать игрок.",
  T_48_META_API_1006_D: "Завершите текущий процесс выполнения, вернитесь непосредственно к месту вызова, вы можете перенести данные вместе с возвратом",
  T_48_META_API_1006_P0_D: "Данные, которые вы хотите вернуть в место вызова",
  T_48_META_API_10060_D: "Выбросить целевого игрока из игры",
  T_48_META_API_10060_P0_D: "целевой игрок",
  T_48_META_API_10060_P1_D: "Отображать ли информацию о расчетах",
  T_48_META_API_10061_D: "Целевой игрок запрашивает матч для определенной карты",
  T_48_META_API_10061_P0_D: "целевой игрок",
  T_48_META_API_10061_P1_D: "код поля боя",
  T_48_META_API_10061_P2_D: "Выводить или нет всплывающее окно с предложением вернуться в исходную игру при отмене матча.",
  T_48_META_API_10062_D: "Прерывание звукового объекта при воспроизведении",
  T_48_META_API_10062_P0_D: "Звуковые образования, которые необходимо приостановить",
  T_48_META_API_10063_D: "Продолжение воспроизведения звуковых эффектов, по желанию с самого начала",
  T_48_META_API_10063_P0_D: "Звуковые объекты, которые должны продолжать воспроизведение после приостановки",
  T_48_META_API_10063_P1_D: "Стоит ли начинать с нуля",
  T_48_META_API_10064_D: "Создайте каплю, у капли есть три фазы: 1. готовность, 2. падение, 3. приземление, только в состоянии 1 можно изменять свойства капли",
  T_48_META_API_10064_P0_D: "Созданные сущности Drop Box",
  T_48_META_API_1007_D: "Реализуйте цикл, который продолжает выполняться в зависимости от того, истинно условие или нет, пока условие не станет ложным и цикл не завершится.",
  T_48_META_API_1007_P0_D: "Когда условие истинно, цикл продолжается, а когда условие ложно, цикл завершается.",
  T_48_META_API_1008_D: `Дождитесь начала следующего логического кадра
На сервере включите режим низкой частоты кадров, он будет ждать дольше
На клиенте время ожидания зависит от производительности устройства и сложности логики текущего кадра
Функции, использующие этот API, до`,
  T_48_META_API_1009_D: "Подождите определенное время, и функции, использующие этот API, должны быть объявлены как async.",
  T_48_META_API_1009_P0_D: "Время ожидания в миллисекундах",
  T_48_META_API_101_D: "Удаление указанной сцены",
  T_48_META_API_101_P0_D: "Идентификатор сцены, которую нужно удалить",
  T_48_META_API_1010: "Обратный звонок по событию",
  T_48_META_API_1010_D: "Действия, выполняемые при наступлении события",
  T_48_META_API_1010_P0: "Имена параметров событий",
  T_48_META_API_1010_P0_D: "Имя формального параметра параметра события, по которому можно получить значение реального параметра в локальной переменной",
  T_48_META_API_1011: "Блок кода",
  T_48_META_API_1011_D: "Блок кода для размещения комбинации API.",
  T_48_META_API_1011_P0: "Имена параметров",
  T_48_META_API_1011_P0_D: "Формальные имена параметров, когда блок кода является пользовательской функцией",
  T_48_META_API_1012: "Найти и вызвать пользовательский API с помощью последовательного порта",
  T_48_META_API_1012_D: "Последовательно вызывает пользовательские функции, и если в пользовательской функции есть ожидание, то место вызова также ожидает.",
  T_48_META_API_1012_P0_D: "Сущность, в которой находится пользовательская функция",
  T_48_META_API_1012_P1: "Идентификатор графика",
  T_48_META_API_1012_P1_D: "Идентификатор сценария, в котором находится пользовательская функция",
  T_48_META_API_1012_P2: "Идентификатор функции",
  T_48_META_API_1012_P2_D: "Идентификатор функции целевого вызова",
  T_48_META_API_1012_P3_D: "Список реальных параметров, передаваемых пользовательской функции",
  T_48_META_API_1013: "Найти и вызвать пользовательский API с помощью Parallel",
  T_48_META_API_1013_D: "Вызывает пользовательские функции параллельно, немедленно возвращаясь в позицию вызова для продолжения работы, независимо от того, есть ли ожидание в пользовательской функции.",
  T_48_META_API_1013_P0_D: "Сущность, в которой находится пользовательская функция",
  T_48_META_API_1013_P1: "Идентификатор графика",
  T_48_META_API_1013_P1_D: "Идентификатор сценария, в котором находится пользовательская функция",
  T_48_META_API_1013_P2: "Идентификатор функции",
  T_48_META_API_1013_P2_D: "Идентификатор функции целевого вызова",
  T_48_META_API_1013_P3_D: "Список реальных параметров, передаваемых пользовательской функции",
  T_48_META_API_1014: "Найти и вызвать собственный API с помощью последовательного порта",
  T_48_META_API_1014_D: "Последовательно вызывает пользовательскую функцию в текущем скрипте, и если в пользовательской функции есть ожидание, то место вызова также ожидает.",
  T_48_META_API_1014_P0: "Идентификатор функции",
  T_48_META_API_1014_P0_D: "Идентификатор функции целевого вызова",
  T_48_META_API_1014_P1_D: "Список реальных параметров, передаваемых пользовательской функции",
  T_48_META_API_1015: "Найти и вызвать собственный API с помощью Parallel",
  T_48_META_API_1015_D: "Вызывает пользовательские функции параллельно, немедленно возвращаясь в позицию вызова для продолжения работы, независимо от того, есть ли ожидание в пользовательской функции.",
  T_48_META_API_1015_P0: "Установить локальную переменную по индексу",
  T_48_META_API_1015_P0_D: "Идентификатор функции целевого вызова",
  T_48_META_API_1015_P1_D: "Список реальных параметров, передаваемых пользовательской функции",
  T_48_META_API_1016_D: "Получение типа цели при вызове этого API",
  T_48_META_API_1016_P0_D: "запрашиваемая цель",
  T_48_META_API_1016_R_D: "Переменный тип",
  T_48_META_API_1017_D: "Определите, относится ли целевая переменная к указанному типу",
  T_48_META_API_1017_P0_D: "запрашиваемая цель",
  T_48_META_API_1017_P1_D: "Тип сравнения",
  T_48_META_API_1017_R_D: "консистенция",
  T_48_META_API_1018_D: "Определяет, является ли целевая переменная подклассом определенного типа, возвращаемое значение - булево значение",
  T_48_META_API_1018_P0_D: "Целевая переменная, которая запрашивается",
  T_48_META_API_1018_P1_D: "Тип сравнения",
  T_48_META_API_1018_R_D: "Является ли он подклассом или нет",
  T_48_META_API_1019_D: "Заставляет целевую сущность вызвать указанное пользовательское событие",
  T_48_META_API_1019_P0_D: "Отправка пользовательских идентификаторов событий",
  T_48_META_API_1019_P1_D: "целевая организация",
  T_48_META_API_1019_P2_D: "список параметров",
  T_48_META_API_102_D: "Переключение на определенную сцену выгружает другие загруженные сцены.",
  T_48_META_API_102_P0_D: "Идентификатор сцены для переключения",
  T_48_META_API_1020_D: "Реализация обхода контейнера, чтобы добраться до каждой пары ключ-значение, содержит подпроцедуры, тело цикла - это подпроцедура",
  T_48_META_API_1020_P0_D: "Итерируя имя ключа, вы можете использовать его для получения значения ключа в локальной переменной",
  T_48_META_API_1020_P1_D: "Итерация по имени значения, которое может быть использовано для получения значения локальной переменной",
  T_48_META_API_1020_P2_D: "Контейнеры, которые необходимо обойти",
  T_48_META_API_1021_D: "Уничтожить указанного бота",
  T_48_META_API_1021_P0_D: "Боты-игроки, которых нужно уничтожить",
  T_48_META_API_1022_D: "Заставьте целевого игрока покинуть носитель",
  T_48_META_API_1022_P0_D: "целевой игрок",
  T_48_META_API_1023_D: "Создание прыгунов для травм",
  T_48_META_API_1023_P0_D: "содержание с пропущенными словами",
  T_48_META_API_1023_P1_D: "размер шрифта",
  T_48_META_API_1023_P2_D: "цвет шрифта",
  T_48_META_API_1023_P3_D: "Время ожидания в миллисекундах",
  T_48_META_API_1023_P4_D: "пострадавший субъект",
  T_48_META_API_1023_P5_D: "Смещение слова перехода урона относительно мировых координат целевой сущности",
  T_48_META_API_1023_P6_D: "Величина диапазона случайных позиционных поправок в местах перехода повреждений снова",
  T_48_META_API_1023_P7_D: "Выполнять ли анимацию заполнения",
  T_48_META_API_1024_D: "заброшенный",
  T_48_META_API_1024_P0_D: "заброшенный",
  T_48_META_API_1024_P1_D: "целевая организация",
  T_48_META_API_1024_P2_D: "При выборе этого параметра, если он вызывается на сервере, он отправляется клиенту, а если вызывается на клиенте, он отправляется на сервер.",
  T_48_META_API_1024_P3_D: "список параметров",
  T_48_META_API_1025_D: "Запрос хода выполнения пользовательской задачи",
  T_48_META_API_1025_P0_D: "целевой игрок",
  T_48_META_API_1025_P1_D: "Пользовательский идентификатор задачи",
  T_48_META_API_1025_R_D: "Ход выполнения миссии",
  T_48_META_API_1026_D: "Получить скин рюкзака целевого игрока",
  T_48_META_API_1026_P0_D: "целевой игрок",
  T_48_META_API_1026_R_D: "Идентификатор кожи рюкзака",
  T_48_META_API_1027_D: "Установка кожи рюкзака целевого игрока",
  T_48_META_API_1027_P0_D: "целевой игрок",
  T_48_META_API_1027_P1_D: "Идентификатор кожи рюкзака",
  T_48_META_API_1028_D: "Восстановите скин рюкзака целевого игрока до стандартной конфигурации вне бюро",
  T_48_META_API_1028_P0_D: "целевой игрок",
  T_48_META_API_1029_D: "Опустошить кожу рюкзака целевого игрока",
  T_48_META_API_1029_P0_D: "целевой игрок",
  T_48_META_API_103_D: 'Замените стиль окружения "скайбокс" в игре на выбор: день, сумерки, ночь и т.д.',
  T_48_META_API_103_P0_D: "Тип скайбокса",
  T_48_META_API_1030_D: "Получение части скелета по имени",
  T_48_META_API_1030_P0_D: "целевая организация",
  T_48_META_API_1030_P1_D: "Название скелетной точки подвеса",
  T_48_META_API_1030_R_D: "точка привязки рамы",
  T_48_META_API_1031_D: "Устанавливает родительский узел объектной сущности, поддерживающей сущности, на которых установлены компоненты Transform, SkeletonPart, Player, MountPoint.",
  T_48_META_API_1031_P0_D: "родительский узел",
  T_48_META_API_1031_P1_D: "дочерний узел",
  T_48_META_API_1031_P2_D: "Сохранять ли текущее положение в мире, вращение и масштабирование дочерних узлов, если установка этого элемента в пользовательском интерфейсе недействительна",
  T_48_META_API_1032_D: "Воспроизводит эффект анимированного значка, при котором значок перемещается от начальной до конечной позиции со скоростью воспроизведения.",
  T_48_META_API_1032_P0_D: "Идентификатор ресурса значка",
  T_48_META_API_1032_P1_D: "цвет",
  T_48_META_API_1032_P2_D: "Значок Увеличить",
  T_48_META_API_1032_P3_D: "Центр стартовой позиции",
  T_48_META_API_1032_P4_D: "Начальный региональный масштаб",
  T_48_META_API_1032_P5_D: "Центр конечного положения",
  T_48_META_API_1032_P6_D: "Диапазон конечных положений",
  T_48_META_API_1032_P7_D: "Скорость воспроизведения - это расстояние, которое проходит значок за секунду.",
  T_48_META_API_1033_D: "Выполните операцию обратного тангенса, чтобы получить угол",
  T_48_META_API_1033_P0_D: "Координаты оси Y",
  T_48_META_API_1033_P1_D: "Координаты по оси X",
  T_48_META_API_1033_R_D: "Угол, диапазон (-180, 180]",
  T_48_META_API_1034_D: "Добавление компонентов к сущностям, поддерживаются только пользовательские компоненты, созданные пользователем",
  T_48_META_API_1034_P0_D: "целевая организация",
  T_48_META_API_1034_P1_D: "ID типа компонента, поддерживаются только пользовательские компоненты, созданные пользователем",
  T_48_META_API_1034_P2_D: "Независимо от того, будет ли он успешно добавлен или нет, существующие компоненты или нестандартные компоненты не будут добавлены.",
  T_48_META_API_1035_D: "Удаление компонентов из сущностей, поддерживаются только пользовательские компоненты",
  T_48_META_API_1035_P0_D: "целевая организация",
  T_48_META_API_1035_P1_D: "ID типа компонента, поддерживаются только пользовательские компоненты, созданные пользователем",
  T_48_META_API_1035_P2_D: "Независимо от того, было ли удаление успешным или нет, несуществующие или нестандартные компоненты не будут удалены.",
  T_48_META_API_1036_D: "Настройка экрана выхода игрока",
  T_48_META_API_1036_P0_D: "Надпись",
  T_48_META_API_1036_P1_D: "элемент",
  T_48_META_API_1036_P2_D: "опции",
  T_48_META_API_1036_P3_D: "Нужно ли показывать фон",
  T_48_META_API_1037_D: "Получите все загруженные в данный момент сцены",
  T_48_META_API_1037_R_D: "Список сцен",
  T_48_META_API_1038_D: "Получение локального направления прицеливания игрока",
  T_48_META_API_1038_R_D: "двигаться в правильном направлении",
  T_48_META_API_1039_D: "Получить локальную метку времени",
  T_48_META_API_1039_R_D: "метка времени",
  T_48_META_API_104_D: "Переключает игрока на указанное место в указанной сцене, незагруженные сцены будут загружаться автоматически, а уже загруженные не будут автоматически выгружаться",
  T_48_META_API_104_P0_D: "игрок",
  T_48_META_API_104_P1_D: "Идентификатор сцены, которая будет загружена",
  T_48_META_API_104_P2_D: "Позиция игрока в новом сценарии",
  T_48_META_API_104_P3_D: "Ориентация игрока в новом сценарии",
  T_48_META_API_1040_D: "Приостановите обновление фиксированного кадра для текущей платформы, и событие обновления фиксированного кадра для этой платформы не будет запускаться после паузы.",
  T_48_META_API_1041_D: "Возобновление обновления фиксированного кадра для текущей платформы, и событие обновления фиксированного кадра для этой платформы начинает срабатывать снова после возобновления",
  T_48_META_API_1042_D: "Определите приятельские отношения целевого игрока с текущим игроком клиента, сам текущий клиент не является его приятелем",
  T_48_META_API_1042_P0_D: "целевой игрок",
  T_48_META_API_1042_R_D: "Дружите ли вы с текущим клиентом или нет",
  T_48_META_API_1043_D: "Запуск пользовательских событий",
  T_48_META_API_1043_P0_D: "Пользовательский идентификатор события",
  T_48_META_API_1043_P1_D: "целевая организация",
  T_48_META_API_1043_P2_D: "Работает на серверных или клиентских платформах",
  T_48_META_API_1043_P3_D: "список параметров",
  T_48_META_API_1044_D: "Открытый прыжок с парашютом",
  T_48_META_API_1044_P0_D: "целевой игрок",
  T_48_META_API_1044_P1_D: "Ниже этой высоты парашют будет вынужден раскрыться.",
  T_48_META_API_1044_P2_D: "Скорость при скольжении, компонент X представляет горизонтальную скорость, компонент Y - вертикальную скорость; игрок приземляется вниз, если компонент Y отрицательный",
  T_48_META_API_1044_P3_D: "Скорость при погружении, компонент X представляет горизонтальную скорость, компонент Y - вертикальную скорость; игрок опускается вниз, если компонент Y отрицательный",
  T_48_META_API_1044_P4_D: "Скорость при раскрытии парашюта, компонент X представляет горизонтальную скорость, компонент Y - вертикальную скорость; когда компонент Y отрицательный, игрок приземляется вниз",
  T_48_META_API_1045_D: "Считывает значение, соответствующее указанному идентификатору в таблице данных.",
  T_48_META_API_1045_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_1045_P1_D: "Уникальный идентификатор игрока",
  T_48_META_API_1045_P2_D: "указанный идентификатор",
  T_48_META_API_1045_P3_D: "Результаты чтений",
  T_48_META_API_1045_P4_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1045_P5_D: "код ошибки",
  T_48_META_API_1046_D: "Получает значение, соответствующее указанному идентификатору в таблице данных графика.",
  T_48_META_API_1046_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_1046_P1_D: "указанный идентификатор",
  T_48_META_API_1046_P2_D: "Результаты чтений",
  T_48_META_API_1046_P3_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1046_P4_D: "код ошибки",
  T_48_META_API_1047_D: "Получение значения указанного интервала рангов в таблице данных Leaderboards",
  T_48_META_API_1047_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_1047_P1_D: "Начальный ранг должен быть меньше или равен конечному рангу, а ранг начинается с 1.",
  T_48_META_API_1047_P2_D: "финишная позиция",
  T_48_META_API_1047_P3_D: "Результаты чтений",
  T_48_META_API_1047_P4_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1047_P5_D: "код ошибки",
  T_48_META_API_1048_D: "Считывает значение, соответствующее указанному идентификатору в таблице кумулятивных данных.",
  T_48_META_API_1048_P0_D: "Имя таблицы кумулятивных данных в базе данных",
  T_48_META_API_1048_P1_D: "указанный идентификатор",
  T_48_META_API_1048_P2_D: "Результаты чтений",
  T_48_META_API_1048_P3_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1048_P4_D: "код ошибки",
  T_48_META_API_1049_D: "Запишите значение, соответствующее указанному идентификатору, в таблицу данных.",
  T_48_META_API_1049_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_1049_P1_D: "Уникальный идентификатор игрока",
  T_48_META_API_1049_P2_D: "указанный идентификатор",
  T_48_META_API_1049_P3_D: "Выписанная стоимость",
  T_48_META_API_1049_P4_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1049_P5_D: "код ошибки",
  T_48_META_API_105_D: "Получите небосвод сцены",
  T_48_META_API_105_P0_D: "Идентификатор сцены",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "Получите количество элементов в списке",
  T_48_META_API_1050_P0_D: "список целей",
  T_48_META_API_1050_R_D: "Количество элементов",
  T_48_META_API_1051_D: "Получить значение элемента с указанным индексом в списке",
  T_48_META_API_1051_P0_D: "список целей",
  T_48_META_API_1051_P1_D: "Значения индексов, начиная с 0",
  T_48_META_API_1051_R_D: "элементарная ценность",
  T_48_META_API_1052_D: "Устанавливает значение элемента, соответствующего указанному индексу в списке",
  T_48_META_API_1052_P0_D: "список целей",
  T_48_META_API_1052_P1_D: "Значения индексов, начиная с 0",
  T_48_META_API_1052_P2_D: "элементарная ценность",
  T_48_META_API_1053_D: "Добавление элементов в конец списка",
  T_48_META_API_1053_P0_D: "список целей",
  T_48_META_API_1053_P1_D: "Элементы для добавления",
  T_48_META_API_1054_D: "Удаляет из списка элемент с указанным индексом",
  T_48_META_API_1054_P0_D: "список целей",
  T_48_META_API_1054_P1_D: "Значения индексов, начиная с 0",
  T_48_META_API_1055_D: "Очистите список от всех элементов",
  T_48_META_API_1055_P0_D: "список целей",
  T_48_META_API_1056_D: "Изменяет порядок элементов в указанном списке.",
  T_48_META_API_1056_P0_D: "список целей",
  T_48_META_API_1057_D: "Копирование списка",
  T_48_META_API_1057_P0_D: "список целей",
  T_48_META_API_1057_R_D: "Новый список скопирован",
  T_48_META_API_1058_D: "Вставляет новый элемент в указанную индексную позицию в списке, а элементы в этой и последующих индексных позициях сдвигаются на одно место назад по порядку.",
  T_48_META_API_1058_P0_D: "список целей",
  T_48_META_API_1058_P1_D: "Позиция индекса для вставки, индекс отсчитывается от 0",
  T_48_META_API_1058_P2_D: "Значение нового элемента, который будет вставлен",
  T_48_META_API_1059_D: "Переставить элементы списка в случайном порядке",
  T_48_META_API_1059_P0_D: "список целей",
  T_48_META_API_1060_D: "Сравнивает обе стороны аргумента и возвращает true или false.",
  T_48_META_API_1060_P0_D: "Левое значение, используемое для сравнения",
  T_48_META_API_1060_P1_D: "Поддерживаются следующие методы сравнения: >,>=,==,! =,<=,<,And(qualified bool type),Or(qualified bool type)",
  T_48_META_API_1060_P2_D: "Левое значение, используемое для сравнения",
  T_48_META_API_1060_R_D: "Сравнительные результаты",
  T_48_META_API_1061_D: "Основные четыре операции, включая сложение, вычитание, умножение, деление и остаток. Операция с остатком поддерживает только целые числа, а остальные операции - целые или десятичные числа.",
  T_48_META_API_1061_P0_D: "левое значение операции",
  T_48_META_API_1061_P1_D: "Виды четырех операций, включая сложение, вычитание, умножение, деление и остаток, которые не поддерживают десятичные числа",
  T_48_META_API_1061_P2_D: "правое значение операции",
  T_48_META_API_1061_R_D: "результат расчёта",
  T_48_META_API_1062_D: "Сгенерируйте случайное целое число между целым числом минимального значения (включено) и целым числом максимального значения (не включено)",
  T_48_META_API_1062_P0_D: "Случайный диапазон левого интервала с возможностью рандомизации к заполненному значению",
  T_48_META_API_1062_P1_D: "Правый интервал случайного диапазона, не будет рандомизирован к заполненному значению",
  T_48_META_API_1062_R_D: "Случайный результат, целое число",
  T_48_META_API_1063_D: "Генерируйте случайное десятичное число между десятичным числом минимального значения (включено) и десятичным числом максимального значения (не включено)",
  T_48_META_API_1063_P0_D: "Случайный диапазон левого интервала, с небольшой вероятностью случайного перехода к заполненному значению",
  T_48_META_API_1063_P1_D: "Правый интервал случайного диапазона, не будет рандомизирован к заполненному значению",
  T_48_META_API_1063_R_D: "Рандомизированные результаты, десятичные числа, до 7 знаков после запятой",
  T_48_META_API_1064_D: "Определите, является ли объект пустым",
  T_48_META_API_1064_P0_D: "пустой объект для оценки",
  T_48_META_API_1064_R_D: "Пустой ли он",
  T_48_META_API_1065_D: "Логическая инверсия, входное значение: true или false, возвращаемое значение: false или true",
  T_48_META_API_1065_P0_D: "Значения, которые необходимо запросить для не",
  T_48_META_API_1065_R_D: "Результат не-суммирования",
  T_48_META_API_1066_D: "Принимает абсолютные значения и поддерживает целые и десятичные числа.",
  T_48_META_API_1066_P0_D: "Значения, для которых требуются абсолютные значения",
  T_48_META_API_1066_R_D: "Результат принятия абсолютных значений",
  T_48_META_API_1067_D: "вычисление квадратного корня",
  T_48_META_API_1067_P0_D: "Нужно узнать значение квадратного корня",
  T_48_META_API_1067_R_D: "Результат нахождения квадратного корня",
  T_48_META_API_1068_D: "Вычисление отрицательных значений",
  T_48_META_API_1068_P0_D: "Запрашиваемые отрицательные значения",
  T_48_META_API_1068_R_D: "Отрицательные результаты",
  T_48_META_API_1069_D: "Соединение двух струн вместе",
  T_48_META_API_1069_P0_D: "левое значение строки",
  T_48_META_API_1069_P1_D: "правое значение строки",
  T_48_META_API_1069_R_D: "Результат конкатенации строк",
  T_48_META_API_1070_D: "Получить длину строки",
  T_48_META_API_1070_P0_D: "строка",
  T_48_META_API_1070_R_D: "длина строки",
  T_48_META_API_1071_D: "Округлите указанное значение до ближайшего целого числа.",
  T_48_META_API_1071_P0_D: "Значение должно быть округлено в меньшую сторону",
  T_48_META_API_1071_R_D: "округление вниз",
  T_48_META_API_1072_D: "Округлите указанное значение до ближайшего целого числа.",
  T_48_META_API_1072_P0_D: "Значения, подлежащие округлению в большую сторону",
  T_48_META_API_1072_R_D: "Результаты округления",
  T_48_META_API_1073_D: "Округлите указанное значение до ближайшего целого числа.",
  T_48_META_API_1073_P0_D: "Количество округляемых значений",
  T_48_META_API_1073_R_D: "округлённый результат",
  T_48_META_API_1074_D: "Выводит новую строку после замены всех указанных строк в целевой строке",
  T_48_META_API_1074_P0_D: "целевая строка",
  T_48_META_API_1074_P1_D: "Старая строка, которую нужно заменить",
  T_48_META_API_1074_P2_D: "Новая строка для замены",
  T_48_META_API_1074_R_D: "Замена завершенной строки",
  T_48_META_API_1075_D: "Находит первое вхождение указанной строки в целевой строке.",
  T_48_META_API_1075_P0_D: "целевая строка",
  T_48_META_API_1075_P1_D: "Указанная строка для поиска",
  T_48_META_API_1075_P2_D: "Находит строку с начальной позиции, позиция строки отсчитывается от 0",
  T_48_META_API_1075_R_D: "Указывает позицию первого вхождения строки в целевую строку, позиция строки отсчитывается от 0.",
  T_48_META_API_1076_D: "Выводит новую строку после перехвата строки заданной длины из указанной позиции.",
  T_48_META_API_1076_P0_D: "целевая строка",
  T_48_META_API_1076_P1_D: "Позиция, с которой следует начать перехват, позиция строки отсчитывается от 0",
  T_48_META_API_1076_P2_D: "Длина перехвата, по умолчанию - до конца строки.",
  T_48_META_API_1076_R_D: "Перехваченная строка",
  T_48_META_API_1077_D: "Сравните два списка с одинаковыми элементами, размер списка не влияет на результат.",
  T_48_META_API_1077_P0_D: "Левое значение списка, используемое для сравнения",
  T_48_META_API_1077_P1_D: "Правое значение списка, используемое для сравнения",
  T_48_META_API_1077_R_D: "Сравните результаты: согласованность содержания возвращает True, несогласованность содержания возвращает False.",
  T_48_META_API_1078_D: "Возьмите указанную строку в качестве разделителя, разрежьте целевую строку на несколько фрагментов и выведите новую строку, N последовательных разделителей будут разрезаны на N-1 пробелов половинной ширины, как элементы списка строк.",
  T_48_META_API_1078_P0_D: "целевая строка",
  T_48_META_API_1078_P1_D: "строка-разделитель",
  T_48_META_API_1078_R_D: "Выводит список строк, всегда заканчивающийся элементом пробела половинной ширины",
  T_48_META_API_1079_D: "Извлечение символов из списка позиций строки и объединение их в новый строковый вывод",
  T_48_META_API_1079_P0_D: "целевая строка",
  T_48_META_API_1079_P1_D: "Список позиций строк, позиции строк отсчитываются от 0",
  T_48_META_API_1079_R_D: "Выходная строка",
  T_48_META_API_1080_D: "Преобразовывает все символы целевой строки в верхний регистр",
  T_48_META_API_1080_P0_D: "целевая строка",
  T_48_META_API_1080_R_D: "Выходная строка",
  T_48_META_API_1081_D: "Преобразует все символы целевой строки в нижний регистр",
  T_48_META_API_1081_P0_D: "целевая строка",
  T_48_META_API_1081_R_D: "Выходная строка",
  T_48_META_API_1082_D: "Удаляет все пробелы перед первым символом, не содержащим пробелов, и после последнего символа, не содержащего пробелов, целевой строки.",
  T_48_META_API_1082_P0_D: "целевая строка",
  T_48_META_API_1082_R_D: "Выходная строка",
  T_48_META_API_1083_D: "Выводит новую строку после связывания с указанным идентификатором.",
  T_48_META_API_1083_P0_D: "Список целевых строк",
  T_48_META_API_1083_P1_D: "Указанный идентификатор используется для конкатенации строк",
  T_48_META_API_1083_R_D: "Выходная строка",
  T_48_META_API_1084_D: "Записывает значение, соответствующее указанному идентификатору, в таблицу данных таблицы лидеров",
  T_48_META_API_1084_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_1084_P1_D: "указанный идентификатор",
  T_48_META_API_1084_P2_D: "Выписанная стоимость",
  T_48_META_API_1084_P3_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1084_P4_D: "код ошибки",
  T_48_META_API_1085_D: "Запись значения смещения, соответствующего указанному идентификатору, в таблицу кумулятивных данных",
  T_48_META_API_1085_P0_D: "Имя таблицы кумулятивных данных в базе данных",
  T_48_META_API_1085_P1_D: "указанный идентификатор",
  T_48_META_API_1085_P2_D: "Виды квадратичных операций",
  T_48_META_API_1085_P3_D: "Записанное значение смещения",
  T_48_META_API_1085_P4_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1085_P5_D: "код ошибки",
  T_48_META_API_1086_D: "Удаляет значение, соответствующее указанному идентификатору в таблице данных.",
  T_48_META_API_1086_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_1086_P1_D: "Уникальный идентификатор игрока",
  T_48_META_API_1086_P2_D: "указанный идентификатор",
  T_48_META_API_1086_P3_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1086_P4_D: "код ошибки",
  T_48_META_API_1087_D: "Удаляет значение, соответствующее указанному идентификатору, в таблице данных графика.",
  T_48_META_API_1087_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_1087_P1_D: "указанный идентификатор",
  T_48_META_API_1087_P2_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1087_P3_D: "код ошибки",
  T_48_META_API_1088_D: "Удаляет значение, соответствующее указанному рангу в таблице лидеров.",
  T_48_META_API_1088_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_1088_P1_D: "получил престижную должность",
  T_48_META_API_1088_P2_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_1088_P3_D: "код ошибки",
  T_48_META_API_1089_D: "Отправить пользовательское сообщение для Persona",
  T_48_META_API_1089_P0_D: "Идентификатор целевой персоны",
  T_48_META_API_1089_P1_D: "Сообщение",
  T_48_META_API_1090_D: "Отправить системное сообщение для Persona",
  T_48_META_API_1090_P0_D: "Идентификатор целевой персоны",
  T_48_META_API_1090_P1_D: "Сообщение",
  T_48_META_API_1091_D: "Очистить память персоны",
  T_48_META_API_1091_P0_D: "код ошибки",
  T_48_META_API_1092_D: "Центр для участников Evoke",
  T_48_META_API_1092_P0_D: "код ошибки",
  T_48_META_API_1093_D: "Получение временной метки окончания срока действия члена",
  T_48_META_API_1093_P0_D: "целевой игрок",
  T_48_META_API_1093_P1_D: "метка времени",
  T_48_META_API_1093_P2_D: "код ошибки",
  T_48_META_API_1094_D: "Определите, является ли игрок членом клуба",
  T_48_META_API_1094_P0_D: "код ошибки",
  T_48_META_API_1094_P1_D: "Являетесь ли вы членом",
  T_48_META_API_1095_D: "Получение временной метки окончания срока действия члена",
  T_48_META_API_1095_P0_D: "метка времени",
  T_48_META_API_1095_P1_D: "код ошибки",
  T_48_META_API_1096_D: "Определите, является ли игрок членом клуба",
  T_48_META_API_1096_P0_D: "целевой игрок",
  T_48_META_API_1096_P1_D: "код ошибки",
  T_48_META_API_1096_P2_D: "Являетесь ли вы членом",
  T_48_META_API_1097_D: "Центр для участников Evoke",
  T_48_META_API_1097_P0_D: "целевой игрок",
  T_48_META_API_1097_P1_D: "код ошибки",
  T_48_META_API_1099_D: "Настройка наблюдателей Persona, после чего разговоры с Persona также отправляются наблюдателю",
  T_48_META_API_1099_P0_D: "Идентификатор целевой персоны",
  T_48_META_API_1099_P1_D: "список наблюдения",
  T_48_META_API_11_D: "Завершите текущую фазу и перейдите к следующей",
  T_48_META_API_1100_D: "Отправка сообщений пользователя в Persona с помощью потоковой передачи",
  T_48_META_API_1100_P0_D: "Идентификатор целевой персоны",
  T_48_META_API_1100_P1_D: "Сообщение",
  T_48_META_API_1101_D: "Отправка системных сообщений в Persona с помощью потоковой передачи",
  T_48_META_API_1101_P0_D: "Идентификатор целевой персоны",
  T_48_META_API_1101_P1_D: "Сообщение",
  T_48_META_API_1101_P2_D: "Отвечать или нет",
  T_48_META_API_1103_D: "Создание случайных семян",
  T_48_META_API_1103_P0_D: "торрент",
  T_48_META_API_1103_R_D: "Генератор случайных чисел",
  T_48_META_API_1104_D: "Получение следующего случайного числа из указанного генератора случайных чисел, максимальное значение 32767",
  T_48_META_API_1104_P0_D: "Генератор случайных чисел",
  T_48_META_API_1104_P1_D: "Диапазон Минимальный",
  T_48_META_API_1104_P2_D: "Диапазон Максимальный",
  T_48_META_API_1104_R_D: "случайное число",
  T_48_META_API_1108_D: "Получите клиентский язык, используемый игроком",
  T_48_META_API_12_D: "Вывод журналов на консоль",
  T_48_META_API_12_P0_D: "Что печатать",
  T_48_META_API_13_D: "Выводит строку с параметрами",
  T_48_META_API_13_P0_D: "Используйте %v для параметра, количество %v и количество параметров должно быть одинаковым.",
  T_48_META_API_13_P1_D: "Список параметров, участвующих в выводе, должен соответствовать количеству %v в описании формата",
  T_48_META_API_13_R_D: "Выходная строка",
  T_48_META_API_14_D: "Очистите остатки объектов на карте, включая ящики смерти, созданные объекты, размещенные объекты, остатки снарядов и т.д.",
  T_48_META_API_15_D: "Пользовательские журналы захоронений для анализа пользовательского опыта",
  T_48_META_API_15_P0_D: "Список имен полей для отчета",
  T_48_META_API_15_P1_D: "Список значений полей для отчета",
  T_48_META_API_1500_D: "Получение x-компоненты 3D-вектора",
  T_48_META_API_1500_P0_D: "3D вектор",
  T_48_META_API_1500_R_D: "3D-вектор x-компонент",
  T_48_META_API_1501_D: "Получение y-компоненты 3D-вектора",
  T_48_META_API_1501_P0_D: "3D вектор",
  T_48_META_API_1501_R_D: "Y-компонента трехмерного вектора",
  T_48_META_API_1502_D: "Получение z-компоненты 3D-вектора",
  T_48_META_API_1502_P0_D: "3D вектор",
  T_48_META_API_1502_R_D: "Трехмерный вектор z-компонента",
  T_48_META_API_1503_D: "Установите x-компоненту 3D-вектора",
  T_48_META_API_1503_P0_D: "3D вектор",
  T_48_META_API_1503_P1_D: "Х-компонент",
  T_48_META_API_1504_D: "Установите компонент Y 3D-вектора",
  T_48_META_API_1504_P0_D: "3D вектор",
  T_48_META_API_1504_P1_D: "Y-компонент",
  T_48_META_API_1505_D: "Задайте z-компоненту 3D-вектора",
  T_48_META_API_1505_P0_D: "3D вектор",
  T_48_META_API_1505_P1_D: "Z-компонент",
  T_48_META_API_1506_D: "Сложить два 3D-вектора",
  T_48_META_API_1506_P0_D: "Левый операнд",
  T_48_META_API_1506_P1_D: "Правый операнд",
  T_48_META_API_1506_R_D: "Результат суммирования 3D-векторов",
  T_48_META_API_1507_D: "Вычитание двух трехмерных векторов",
  T_48_META_API_1507_P0_D: "Левый операнд",
  T_48_META_API_1507_P1_D: "Правый операнд",
  T_48_META_API_1507_R_D: "Результат вычитания правого значения из левого значения 3D-вектора",
  T_48_META_API_1508_D: "Масштабирование 3D-векторов",
  T_48_META_API_1508_P0_D: "3D-векторы для масштабирования",
  T_48_META_API_1508_P1_D: "Дефляция 3D-вектора",
  T_48_META_API_1508_R_D: "Результаты масштабирования 3D-векторов",
  T_48_META_API_1509_D: "Точечное умножение двух трехмерных векторов, результат точечного умножения - скаляр",
  T_48_META_API_1509_P0_D: "Левый операнд",
  T_48_META_API_1509_P1_D: "Правый операнд",
  T_48_META_API_1509_R_D: "Результат точечного произведения",
  T_48_META_API_1510_D: "Перекрестное умножение двух трехмерных векторов, результатом перекрестного умножения является вектор, перпендикулярный плоскости, в которой расположены два вектора",
  T_48_META_API_1510_P0_D: "Левый операнд",
  T_48_META_API_1510_P1_D: "Правый операнд",
  T_48_META_API_1510_R_D: "Результат перекрестного произведения, ориентированный перпендикулярно плоскости, в которой расположены два вектора, участвующие в операции",
  T_48_META_API_1511_D: "Нормализация трехмерных векторов",
  T_48_META_API_1511_P0_D: "3D вектор",
  T_48_META_API_1511_R_D: "Возвращает новый нормализованный вектор. Длина модуля равна 1",
  T_48_META_API_1512_D: "Моделирование трехмерных векторов",
  T_48_META_API_1512_P0_D: "3D вектор",
  T_48_META_API_1512_R_D: "Результат моделирования, длина векторного модуля",
  T_48_META_API_1513_D: "Вычислите евклидово расстояние между двумя 3D-векторами",
  T_48_META_API_1513_P0_D: "Левый операнд",
  T_48_META_API_1513_P1_D: "Правый операнд",
  T_48_META_API_1513_R_D: "После вычитания двух векторов модуль результирующего вектора",
  T_48_META_API_1514_D: "Вычислить угол между двумя трехмерными векторами",
  T_48_META_API_1514_P0_D: "Левый операнд",
  T_48_META_API_1514_P1_D: "Правый операнд",
  T_48_META_API_1514_R_D: "Угол вектора, диапазон углов 0-180",
  T_48_META_API_1515_D: "Создайте 3D-вектор",
  T_48_META_API_1515_P0_D: "X-компонент трехмерного вектора",
  T_48_META_API_1515_P1_D: "Y-компонента трехмерного вектора",
  T_48_META_API_1515_P2_D: "Z-компонента трехмерного вектора",
  T_48_META_API_1515_R_D: "Созданные 3D-векторы",
  T_48_META_API_1516_D: "Получить точку ориентации новой конструкции (устарело, пожалуйста, не используйте его)",
  T_48_META_API_1516_P0_D: "размещение",
  T_48_META_API_1516_P1_D: "открыть на",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Принять положение точки направления (устарело, не используйте)",
  T_48_META_API_1517_P0_D: "точка ориентации",
  T_48_META_API_1517_R_D: "Позиция",
  T_48_META_API_1518_D: "Ориентирование по точкам направления (устарело, пожалуйста, не используйте)",
  T_48_META_API_1518_P0_D: "точка ориентации",
  T_48_META_API_1518_R_D: "Вперед",
  T_48_META_API_1519_D: "Создайте список",
  T_48_META_API_1519_P0_D: "Начальная длина списка, которая должна быть меньше или равна начальной емкости",
  T_48_META_API_1519_P1_D: "Начальная емкость списка должна быть больше или равна начальной длине. Емкость может быть динамически увеличена, но это потребует некоторой производительности, поэтому рекомендуется задавать соответствующее значение при конструировании.",
  T_48_META_API_1519_R_D: "Создание списка",
  T_48_META_API_1520_D: "Проверяет, содержит ли список указанный элемент",
  T_48_META_API_1520_P0_D: "список целей",
  T_48_META_API_1520_P1_D: "Указанный элемент, который необходимо проверить",
  T_48_META_API_1520_R_D: "Содержит ли он указанный элемент или нет",
  T_48_META_API_1521_D: "Добавление нескольких элементов в конец целевого списка",
  T_48_META_API_1521_P0_D: "список целей",
  T_48_META_API_1521_P1_D: "Дополнительный список",
  T_48_META_API_1522_D: "Удаляет указанный элемент из списка",
  T_48_META_API_1522_P0_D: "список целей",
  T_48_META_API_1522_P1_D: "Значение элемента, который нужно удалить",
  T_48_META_API_1523_D: "Получает индекс первой позиции элемента в списке, если в списке нет целевого элемента, то возвращается -1.",
  T_48_META_API_1523_P0_D: "список целей",
  T_48_META_API_1523_P1_D: "элементарная ценность",
  T_48_META_API_1523_R_D: "индекс местоположения",
  T_48_META_API_1524_D: "Получает индекс последней позиции элемента в списке, если в списке нет целевого элемента, возвращает -1.",
  T_48_META_API_1524_P0_D: "список целей",
  T_48_META_API_1524_P1_D: "элементарная ценность",
  T_48_META_API_1524_R_D: "индекс местоположения",
  T_48_META_API_1525_D: "Найдите синус угла",
  T_48_META_API_1525_P0_D: "Угол, 360 для 360 градусов",
  T_48_META_API_1525_R_D: "синус",
  T_48_META_API_1526_D: "Нахождение косинуса угла",
  T_48_META_API_1526_P0_D: "Угол, 360 для 360 градусов",
  T_48_META_API_1526_R_D: "косинус",
  T_48_META_API_1527_D: "Нахождение тангенса угла",
  T_48_META_API_1527_P0_D: "Угол, 360 для 360 градусов",
  T_48_META_API_1527_R_D: "касательная",
  T_48_META_API_1528_D: "Сконструируйте значение цвета с прозрачностью, фиксированной на десятичном значении 255, сначала преобразуйте канал в двоичное число, каждые 8 бит которого представляют канал, разбитый на R, G, B и прозрачность, а затем преобразуйте это двоичное число в т",
  T_48_META_API_1528_P0_D: "Значение красного канала цвета в диапазоне [0,255], если оно выходит за пределы диапазона, то будет ограничено до допустимого значения.",
  T_48_META_API_1528_P1_D: "Значение зеленого канала цвета в диапазоне [0,255], если оно выходит за пределы диапазона, то будет ограничено до допустимого значения.",
  T_48_META_API_1528_P2_D: "Значение синего канала цвета в диапазоне [0,255], если оно выходит за пределы диапазона, то будет ограничено до допустимого значения.",
  T_48_META_API_1528_R_D: "Значения цветов, созданные в результате",
  T_48_META_API_1529_D: "Выполните операцию обратного синуса, чтобы получить угол",
  T_48_META_API_1529_P0_D: "Значение, для которого выполняется операция обратного синуса, в диапазоне [-1,1].",
  T_48_META_API_1529_R_D: "перспективы",
  T_48_META_API_1530_D: "Выполните операцию обратного косинуса, чтобы получить угол",
  T_48_META_API_1530_P0_D: "Значение операции обратного косинуса, в диапазоне [-1,1].",
  T_48_META_API_1530_R_D: "перспективы",
  T_48_META_API_1531_D: "Выполните операцию обратного тангенса, чтобы получить угол",
  T_48_META_API_1531_P0_D: "Значение, для которого выполняется операция арктангенса",
  T_48_META_API_1531_R_D: "перспективы",
  T_48_META_API_1532_D: "Определяет, находится ли целевая сущность в пределах указанной сферы, если сущность не имеет позиционных атрибутов, возвращает false",
  T_48_META_API_1532_P0_D: "целевая организация",
  T_48_META_API_1532_P1_D: "Укажите центр сферы",
  T_48_META_API_1532_P2_D: "Укажите радиус сферы",
  T_48_META_API_1532_R_D: "Выводы",
  T_48_META_API_1533_D: "Определяет, находится ли целевая сущность в указанном диапазоне цилиндров, если у сущности нет атрибута location, возвращает false",
  T_48_META_API_1533_P0_D: "целевая организация",
  T_48_META_API_1533_P1_D: "Укажите центр цилиндра",
  T_48_META_API_1533_P2_D: "Укажите радиус поперечного сечения цилиндра",
  T_48_META_API_1533_P3_D: "Укажите высоту цилиндра",
  T_48_META_API_1533_P4_D: "Укажите угол Эйлера для цилиндра, вращающегося в трех измерениях вокруг своей центральной точки",
  T_48_META_API_1533_R_D: "Выводы",
  T_48_META_API_1534_D: "Определите, находится ли целевой объект в указанном диапазоне кубов",
  T_48_META_API_1534_P0_D: "целевая организация",
  T_48_META_API_1534_P1_D: "Укажите центр куба",
  T_48_META_API_1534_P2_D: "Укажите длину куба",
  T_48_META_API_1534_P3_D: "Укажите ширину куба",
  T_48_META_API_1534_P4_D: "Укажите высоту куба",
  T_48_META_API_1534_P5_D: "Укажите углы Эйлера для трехмерного вращения куба вокруг его центральной точки",
  T_48_META_API_1534_R_D: "Выводы",
  T_48_META_API_1535_D: "Определите, находится ли целевой объект в пределах указанных столбцов сектора.",
  T_48_META_API_1535_P0_D: "целевая организация",
  T_48_META_API_1535_P1_D: "Укажите центр окружности средней части секторообразной колонны",
  T_48_META_API_1535_P2_D: "Укажите радиус центральной части колонны секторной формы",
  T_48_META_API_1535_P3_D: "Радиус поперечного сечения веерообразной колонны, которая не будет обнаружена, с центральной точкой в виде круга, не будет обнаружен в этой области малой веерообразной колонны, будет обнаружена только разница между предписанной веерообразной колонной и ма",
  T_48_META_API_1535_P4_D: "Укажите высоту веерообразной колонны",
  T_48_META_API_1535_P5_D: "Обнаружение веерообразного цилиндрического сечения по углу центроида, больше 360 при обнаружении цилиндрического, меньше 0 при размере области обнаружения 0",
  T_48_META_API_1535_P6_D: "Укажите эйлеровский угол поворота веерообразной колонны вокруг центральной точки в трех местах",
  T_48_META_API_1535_R_D: "Выводы",
  T_48_META_API_1536_D: "Сравнивает значения двух чисел и возвращает большее.",
  T_48_META_API_1536_P0_D: "Левый операнд",
  T_48_META_API_1536_P1_D: "Правый операнд",
  T_48_META_API_1536_R_D: "большая цифра",
  T_48_META_API_1537_D: "Возвращает максимальное значение в списке",
  T_48_META_API_1537_P0_D: "Целевой список, принимает только элементы списка типа numeric",
  T_48_META_API_1537_P1_D: "Сравните результаты, если в списке есть не-числа и т.д., сравнение завершится неудачей и вернется false.",
  T_48_META_API_1537_P2_D: "Возвращает наибольшее значение в списке, если сравнение прошло успешно, или 0, если сравнение прошло неудачно.",
  T_48_META_API_1538_D: "Сравнивает значения двух чисел и возвращает меньшее.",
  T_48_META_API_1538_P0_D: "Левый операнд",
  T_48_META_API_1538_P1_D: "Правый операнд",
  T_48_META_API_1538_R_D: "Маленькие фигурки",
  T_48_META_API_1539_D: "Возвращает наименьшее значение в списке.",
  T_48_META_API_1539_P0_D: "Целевой список, принимает только элементы списка типа numeric",
  T_48_META_API_1539_P1_D: "Сравните результаты, если в списке есть не-числа и т.д., сравнение завершится неудачей и вернется false.",
  T_48_META_API_1539_P2_D: "Возвращает наименьшее значение в списке, если сравнение прошло успешно, или 0, если сравнение прошло неудачно.",
  T_48_META_API_1540_D: "Линейная интерполяция, возвращает значение, соответствующее ходу интерполяции между начальным и целевым значением, коэффициенты интерполяции [0,1]",
  T_48_META_API_1540_P0_D: "Значение начала линейной интерполяции, которое возвращается, когда прогресс интерполяции равен 0.",
  T_48_META_API_1540_P1_D: "Целевое значение линейной интерполяции, которое возвращается, когда прогресс интерполяции равен 1",
  T_48_META_API_1540_P2_D: "Прогресс интерполяции, диапазон значений [0,1], примите значение 0 для возврата к начальному значению, примите значение 1 для возврата к целевому значению, примите значение 0,5 для возврата к начальному значению и среднему значению целевого значения",
  T_48_META_API_1540_R_D: "Возвращаемое значение линейной интерполяции",
  T_48_META_API_1541_D: "Ограничить диапазон целевого значения, получить значение в середине трех входов; его роль заключается в ограничении целевого значения в указанном диапазоне, целевое значение меньше, чем минимальное значение, чтобы вернуться к наименьшему значению, больше,",
  T_48_META_API_1541_P0_D: "целевое значение",
  T_48_META_API_1541_P1_D: "Минимальное значение предельного диапазона",
  T_48_META_API_1541_P2_D: "Максимальное значение предельного диапазона",
  T_48_META_API_1541_R_D: "Возвращаемое значение после ограничения",
  T_48_META_API_1542_D: "Получите значения каналов целевого цвета",
  T_48_META_API_1542_P0_D: "цвет цели",
  T_48_META_API_1542_P1_D: "R-значение цвета, в диапазоне [0 , 255].",
  T_48_META_API_1542_P2_D: "G-значение цвета, диапазон [0 , 255].",
  T_48_META_API_1542_P3_D: "B-значение цвета, диапазон [0 , 255].",
  T_48_META_API_1542_P4_D: "A-значение цвета в диапазоне [0 , 255].",
  T_48_META_API_1543_D: "работа с питанием",
  T_48_META_API_1543_P0_D: "основание",
  T_48_META_API_1543_P1_D: "экспоненты",
  T_48_META_API_1543_R_D: "результат расчёта",
  T_48_META_API_1544_D: "логарифмическая операция",
  T_48_META_API_1544_P0_D: "основание",
  T_48_META_API_1544_P1_D: "логарифм",
  T_48_META_API_1544_R_D: "результат расчёта",
  T_48_META_API_1545_D: "Вектор направления на угол Эйлера",
  T_48_META_API_1545_P0_D: "вектор направления",
  T_48_META_API_1545_R_D: "Угол Эйлера",
  T_48_META_API_1546_D: "Вектор направления поворота с углом Эйлера",
  T_48_META_API_1546_P0_D: "Угол Эйлера",
  T_48_META_API_1546_R_D: "вектор направления",
  T_48_META_API_1547_D: "преобразование целого числа в число с плавающей точкой",
  T_48_META_API_1547_P0_D: "целое число",
  T_48_META_API_1547_R_D: "плавающая точка",
  T_48_META_API_1548_D: "Поверните целевой вектор в соответствии с кватернионом",
  T_48_META_API_1548_P0_D: "вектор цели",
  T_48_META_API_1548_P1_D: "вращающийся кватернион",
  T_48_META_API_1548_R_D: "повернутый вектор",
  T_48_META_API_1549_D: "Преобразование целевого числа в строку",
  T_48_META_API_1549_P0_D: "Номер места назначения преобразуемой строки",
  T_48_META_API_1549_P1_D: "Формат выводимой числовой строки",
  T_48_META_API_1549_R_D: "строка",
  T_48_META_API_1598_D: "Получение временной метки сервера",
  T_48_META_API_1598_R_D: "Возвращает количество секунд от 0:0:0 1 января 1970 года.",
  T_48_META_API_1599_D: "Получить область сервера",
  T_48_META_API_1599_R_D: "Вернуться к региональным аббревиатурам (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Пользовательские журналы захоронений для анализа пользовательского опыта",
  T_48_META_API_16_P0_D: "Чтобы отслеживать заявленных игроков",
  T_48_META_API_16_P1_D: "Список имен полей для отчета",
  T_48_META_API_16_P2_D: "Список значений полей для отчета",
  T_48_META_API_1601_D: "Создание словаря",
  T_48_META_API_1601_R_D: "Созданный словарь",
  T_48_META_API_1602_D: "Получить значение, соответствующее указанному ключу в словаре",
  T_48_META_API_1602_P0_D: "Целевой словарь",
  T_48_META_API_1602_P1_D: "Ключ",
  T_48_META_API_1602_R_D: "Значение",
  T_48_META_API_1603_D: "Устанавливает значение, соответствующее указанному ключу в словаре",
  T_48_META_API_1603_P0_D: "Целевой словарь",
  T_48_META_API_1603_P1_D: "Ключ",
  T_48_META_API_1603_P2_D: "Значение",
  T_48_META_API_1604_D: "Удаляет указанную пару ключ-значение из словаря",
  T_48_META_API_1604_P0_D: "Целевой словарь",
  T_48_META_API_1604_P1_D: "Ключ",
  T_48_META_API_1605_D: "Очистите все пары ключ-значение в словаре",
  T_48_META_API_1605_P0_D: "Целевой словарь",
  T_48_META_API_1606_D: "Получите количество пар ключ-значение в словаре",
  T_48_META_API_1606_P0_D: "Целевой словарь",
  T_48_META_API_1606_R_D: "Длина словаря",
  T_48_META_API_1607_D: "Определите, существует ли ключ в словаре",
  T_48_META_API_1607_P0_D: "Целевой словарь",
  T_48_META_API_1607_P1_D: "Ключ",
  T_48_META_API_1607_R_D: "Существует ли",
  T_48_META_API_1608_D: "Получите все ключи словаря и верните их в виде списка.",
  T_48_META_API_1608_P0_D: "Целевой словарь",
  T_48_META_API_1608_R_D: "Список всех значений ключей",
  T_48_META_API_17_D: "Используйте для обнаружения прямоугольную область линейного движения и возвращайте все объекты, встреченные на маршруте прямоугольной области, от ближнего до дальнего. Если они изначально находятся в пределах коробчатого диапазона, они не будут обнаружены; если иерархические параметры заполнены в пробелах, их можно обнаружить на местности.",
  T_48_META_API_17_P0_D: "Половина длины трех сторон области с рамкой, принимаются только положительные значения",
  T_48_META_API_17_P1_D: "Центральная точка обведенной рамкой области",
  T_48_META_API_17_P2_D: "Вращение области коробки",
  T_48_META_API_17_P3_D: "Направление движения в зоне с рамками",
  T_48_META_API_17_P4_D: "Расстояние, пройденное в зоне бокса, принимаются только положительные значения",
  T_48_META_API_17_P5_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_17_P6_D: "Можно ли обнаружить триггер",
  T_48_META_API_17_P7_D: "Список объектов, попавших под удар",
  T_48_META_API_1700_D: "Преобразование строки в целое число",
  T_48_META_API_1700_P0_D: "целевая строка",
  T_48_META_API_1700_P1_D: "результирующее целое число",
  T_48_META_API_1700_P2_D: "Успешно ли прошло преобразование или нет",
  T_48_META_API_1701_D: "Преобразование строки в число с плавающей точкой",
  T_48_META_API_1701_P0_D: "целевая строка",
  T_48_META_API_1701_P1_D: "результирующий плавающий",
  T_48_META_API_1701_P2_D: "Успешно ли прошло преобразование или нет",
  T_48_META_API_18_D: "Используйте для обнаружения прямолинейную сферическую область и возвращайте все объекты, встреченные на маршруте сферической области, от ближнего до дальнего. Если они изначально находятся в сферической области, они не будут обнаружены, если параметр уровня заполнен пустым полем. , местность может быть обнаружена",
  T_48_META_API_18_P0_D: "Радиус сферической области, принимаются только положительные значения",
  T_48_META_API_18_P1_D: "центральная точка сферической области",
  T_48_META_API_18_P2_D: "Направление движения в сферической области",
  T_48_META_API_18_P3_D: "Расстояние перемещения по сферической области, принимаются только положительные значения",
  T_48_META_API_18_P4_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_18_P5_D: "Можно ли обнаружить триггер",
  T_48_META_API_18_P6_D: "Список объектов, попавших под удар",
  T_48_META_API_19_D: "Используйте для обнаружения линейно движущуюся область капсулы и возвращайте все объекты, встреченные на маршруте области капсулы, от ближнего до дальнего. Если они изначально находятся в области капсулы, они не будут обнаружены, если параметр уровня заполнен; можно обнаружить местность.",
  T_48_META_API_19_P0_D: "Радиус полусферы на каждом конце области корпуса капсулы, принимаются только положительные значения",
  T_48_META_API_19_P1_D: "Расстояние между сферическими центрами полусфер на каждом конце области корпуса капсулы, которое должно быть больше, чем двукратный радиус полусфер на каждом конце",
  T_48_META_API_19_P2_D: "Центральная точка области корпуса капсулы",
  T_48_META_API_19_P3_D: "Вращение области корпуса капсулы",
  T_48_META_API_19_P4_D: "Направление движения в области корпуса капсулы",
  T_48_META_API_19_P5_D: "Расстояние, пройденное в области капсулы, принимаются только положительные значения.",
  T_48_META_API_19_P6_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_19_P7_D: "Можно ли обнаружить триггер",
  T_48_META_API_19_P8_D: "Список объектов, попавших под удар",
  T_48_META_API_2_D: "Получите все команды в текущей игре и верните список команд.",
  T_48_META_API_2_R_D: "Список команды",
  T_48_META_API_20_D: "Используйте статическую область в форме коробки для обнаружения и возвращайте все объекты в области в форме коробки. Если параметр уровня заполнен пробелами, местность можно обнаружить.",
  T_48_META_API_20_P0_D: "Половина длины трех сторон области с рамкой, принимаются только положительные значения",
  T_48_META_API_20_P1_D: "Центральная точка обведенной рамкой области",
  T_48_META_API_20_P2_D: "Вращение области коробки",
  T_48_META_API_20_P3_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_20_P4_D: "Можно ли обнаружить триггер",
  T_48_META_API_20_P5_D: "Список объектов, попавших под удар",
  T_48_META_API_2000_D: "Установка значения атрибута целевой сущности требует, чтобы атрибут уже был определен.",
  T_48_META_API_2000_P0_D: "целевая организация",
  T_48_META_API_2000_P1_D: "Атрибут целевой сущности",
  T_48_META_API_2000_P2_D: "Целевое значение, которое должно соответствовать типу, требуемому при определении свойства",
  T_48_META_API_2000_P3_D: "Все типы поддерживают присваивание, а числовые типы - самоприбавление, самоминусование, самоумножение, самоделение и самоостаток.",
  T_48_META_API_2001_D: "Получение значения атрибута сущности",
  T_48_META_API_2001_P0_D: "целевая организация",
  T_48_META_API_2001_P1_D: "Идентификатор атрибута этой сущности",
  T_48_META_API_2001_R_D: "значение атрибута",
  T_48_META_API_2002: "Установить свойство графика",
  T_48_META_API_2002_D: "Установка переменных сценария",
  T_48_META_API_2002_P0_D: "целевая организация",
  T_48_META_API_2002_P1: "Идентификатор графика",
  T_48_META_API_2002_P1_D: "Идентификатор целевого сценария",
  T_48_META_API_2002_P2: "Идентификатор недвижимости",
  T_48_META_API_2002_P2_D: "Идентификатор свойства-члена, определенного в сценарии",
  T_48_META_API_2002_P3: "Стоимость недвижимости",
  T_48_META_API_2002_P3_D: "Целевое значение, которое должно соответствовать типу, требуемому при определении свойства",
  T_48_META_API_2002_P4_D: "Все типы поддерживают присваивание, а числовые типы - самоприбавление, самоминусование, самоумножение, самоделение и самоостаток.",
  T_48_META_API_2003: "Получить свойство графика",
  T_48_META_API_2003_D: "Получение переменных сценария",
  T_48_META_API_2003_P0_D: "целевая организация",
  T_48_META_API_2003_P1: "Идентификатор графика",
  T_48_META_API_2003_P1_D: "Идентификатор целевого сценария",
  T_48_META_API_2003_P2: "Идентификатор недвижимости",
  T_48_META_API_2003_P2_D: "Идентификатор целевого атрибута",
  T_48_META_API_2003_R_D: "значение атрибута",
  T_48_META_API_2004_D: "Определите и инициализируйте локальную переменную, которая имеет диапазон от позиции объявления до конца блока операторов, в котором она находится.",
  T_48_META_API_2004_P0_D: "имя переменной",
  T_48_META_API_2004_P1_D: "начальное значение переменной",
  T_48_META_API_2004_P2_D: "Тип объявления переменной, присвоение должно соответствовать объявленному типу",
  T_48_META_API_2005_D: "Устанавливает значение локальной переменной, которая имеет диапазон от позиции объявления до конца блока оператора, в котором она находится.",
  T_48_META_API_2005_P0_D: "имя переменной",
  T_48_META_API_2005_P1: "Значение переменной",
  T_48_META_API_2005_P1_D: "значение переменной",
  T_48_META_API_2005_P2_D: "Все типы поддерживают присваивание, а числовые типы - самоприбавление, самоминусование, самоумножение, самоделение и самоостаток.",
  T_48_META_API_2006: "Получить локальную переменную",
  T_48_META_API_2006_D: "Получение значения локальной переменной, которая имеет диапазон от позиции объявления до конца блока оператора.",
  T_48_META_API_2006_P0: "Имя переменной",
  T_48_META_API_2006_P0_D: "имя переменной",
  T_48_META_API_2006_R_D: "значение переменной",
  T_48_META_API_2009: "Найти и вызвать глобальный пользовательский API с помощью последовательного порта",
  T_48_META_API_2009_D: "Последовательно вызывает глобальные пользовательские функции, и если в пользовательской функции есть ожидание, то место вызова также ожидает.",
  T_48_META_API_2009_P0: "Идентификатор графика",
  T_48_META_API_2009_P0_D: "Идентификатор сценария, в котором находится пользовательская функция",
  T_48_META_API_2009_P1: "Идентификатор функции",
  T_48_META_API_2009_P1_D: "Идентификатор пользовательской функции, вызываемой",
  T_48_META_API_2009_P2_D: "Список аргументов, передаваемых пользовательской функции",
  T_48_META_API_2010: "Поиск и вызов глобального пользовательского API с помощью Parallel",
  T_48_META_API_2010_D: "Параллельно вызывает глобальные пользовательские функции, немедленно возвращаясь к месту вызова для продолжения работы, независимо от того, есть ли ожидание в пользовательской функции.",
  T_48_META_API_2010_P0: "Идентификатор графика",
  T_48_META_API_2010_P0_D: "Идентификатор сценария, в котором находится пользовательская функция",
  T_48_META_API_2010_P1: "Идентификатор функции",
  T_48_META_API_2010_P1_D: "Идентификатор пользовательской функции, вызываемой",
  T_48_META_API_2010_P2_D: "Список аргументов, передаваемых пользовательской функции",
  T_48_META_API_2013: "Установить свойство собственного графика",
  T_48_META_API_2013_D: "Установка переменных для текущего сценария",
  T_48_META_API_2013_P0: "Идентификатор недвижимости",
  T_48_META_API_2013_P0_D: "Идентификатор целевого атрибута",
  T_48_META_API_2013_P1: "Стоимость недвижимости",
  T_48_META_API_2013_P1_D: "целевое значение",
  T_48_META_API_2013_P2_D: "Все типы поддерживают присваивание, а числовые типы - самоприбавление, самоминусование, самоумножение, самоделение и самоостаток.",
  T_48_META_API_2014: "Получить свойство Self Graph",
  T_48_META_API_2014_D: "Получение переменных для текущего сценария",
  T_48_META_API_2014_P0: "Идентификатор недвижимости",
  T_48_META_API_2014_P0_D: "Идентификатор целевого атрибута",
  T_48_META_API_2014_R_D: "значение атрибута",
  T_48_META_API_21_D: "Используйте статическую сферическую область для обнаружения и возвращайте все объекты в сферической области. Если параметр уровня заполнен пробелами, местность можно обнаружить.",
  T_48_META_API_21_P0_D: "Радиус сферической области, принимаются только положительные значения",
  T_48_META_API_21_P1_D: "центральная точка сферической области",
  T_48_META_API_21_P2_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_21_P3_D: "Можно ли обнаружить триггер",
  T_48_META_API_21_P4_D: "Список объектов, попавших под удар",
  T_48_META_API_22_D: "Используйте статическую область капсулы для обнаружения и возвращайте все объекты в области капсулы. Если параметр уровня заполнен, местность можно обнаружить.",
  T_48_META_API_22_P0_D: "Радиус полусферы на каждом конце области корпуса капсулы, принимаются только положительные значения",
  T_48_META_API_22_P1_D: "Расстояние между сферическими центрами полусфер на каждом конце области корпуса капсулы, которое должно быть больше, чем двукратный радиус полусфер на каждом конце",
  T_48_META_API_22_P2_D: "Центральная точка области корпуса капсулы",
  T_48_META_API_22_P3_D: "Вращение области корпуса капсулы",
  T_48_META_API_22_P4_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_22_P5_D: "Можно ли обнаружить триггер",
  T_48_META_API_22_P6_D: "Список объектов, попавших под удар",
  T_48_META_API_23_D: "Устанавливает статус особого предмета для игрока, особые предметы могут иметь только один статус",
  T_48_META_API_23_P0_D: "игрок",
  T_48_META_API_23_P1_D: "ID предмета",
  T_48_META_API_23_P2_D: "Включать ли элемент",
  T_48_META_API_23_P3_D: "особое вещество",
  T_48_META_API_24_D: "Приложите одну силу к цели, которая должна быть физическим объектом.",
  T_48_META_API_24_P0_D: "целевой физический объект",
  T_48_META_API_24_P1_D: "вектор силы",
  T_48_META_API_24_P2_D: "Тип силы",
  T_48_META_API_25_D: "Приложите силу один раз к точке, цель должна быть жестким телом",
  T_48_META_API_25_P0_D: "целевое жёсткое тело",
  T_48_META_API_25_P1_D: "вектор силы",
  T_48_META_API_25_P2_D: "Положение приложения силы",
  T_48_META_API_25_P3_D: "Тип силы",
  T_48_META_API_26_D: "Приложите один крутящий момент к мишени, которая должна быть жесткой.",
  T_48_META_API_26_P0_D: "целевое жёсткое тело",
  T_48_META_API_26_P1_D: "торсион",
  T_48_META_API_26_P2_D: "Тип прилагаемой силы",
  T_48_META_API_27_D: "Переместить целевое жесткое тело в указанную позицию",
  T_48_META_API_27_P0_D: "целевое жёсткое тело",
  T_48_META_API_27_P1_D: "определённое место",
  T_48_META_API_28_D: "Поворот целевого жесткого тела",
  T_48_META_API_28_P0_D: "целевое жёсткое тело",
  T_48_META_API_28_P1_D: "вращающийся кватернион",
  T_48_META_API_29_D: "Создает интерполированное движение, в котором указанные свойства целевого объекта сглаживаются в соответствии с заданными настройками.",
  T_48_META_API_29_P0_D: "целевая организация",
  T_48_META_API_29_P1_D: "Идентификаторы атрибутов, требующие изменения движения",
  T_48_META_API_29_P2_D: "Начальное значение атрибута",
  T_48_META_API_29_P3_D: "Конечное значение атрибута",
  T_48_META_API_29_P4_D: `Вы можете выбрать одиночный, циклический и возвратно-поступательный. 
 Цикл означает, что после завершения каждого движения сущность снова переместится от начального значения. Возвратно-поступательный означает, что после завершения движения от начального значения до целевого значения сущность снова переместится от целевого значения до начального значения, а затем повторит процесс`,
  T_48_META_API_29_P5_D: "Контрольная точка кривой Бесселя",
  T_48_META_API_29_P6_D: "Продолжительность изменения в миллисекундах",
  T_48_META_API_29_P7_D: "Созданные интерполированные объекты движения",
  T_48_META_API_29_P8_D: "Начинается ли воспроизведение автоматически после создания",
  T_48_META_API_3_D: "Переключая игру на целевую фазу, ход также является специальной фазой. При переходе на этап в раунде счетчик раундов равен 0.",
  T_48_META_API_3_P0_D: "Индекс целевых раундов или фаз",
  T_48_META_API_30_D: "Заставляет целевого игрока войти в указанное транспортное средство",
  T_48_META_API_30_P0_D: "целевой игрок",
  T_48_META_API_30_P1_D: "организация-перевозчик",
  T_48_META_API_30_P2_D: "Номер места",
  T_48_META_API_30_P3_D: "Удастся ли ему затащить игрока на носитель.",
  T_48_META_API_3001_D: "Заставьте целевого игрока выбросить предмет",
  T_48_META_API_3001_P0_D: "целевой игрок",
  T_48_META_API_3001_P1_D: "физическое лицо",
  T_48_META_API_3002_D: "Получить доступные координаты в доступной в данный момент случайной точке рождения, которая не полностью занята (устарело, используйте GetRandomSpawnPosition).",
  T_48_META_API_3002_P0_D: "Игроки, которым необходимо назначить зону точек рождения",
  T_48_META_API_3002_R_D: "Произвольные координаты точек, назначенные случайным образом",
  T_48_META_API_3003_D: "Получите общее количество очков игрока для указанного типа очков",
  T_48_META_API_3003_P0_D: "игрок",
  T_48_META_API_3003_P1_D: "Тип очков",
  T_48_META_API_3003_R_D: "значение точки",
  T_48_META_API_3004_D: "Установка счета раунда для указанного типа очков игрока",
  T_48_META_API_3004_P0_D: "субъект игрока",
  T_48_META_API_3004_P1_D: "Тип очков",
  T_48_META_API_3004_P2_D: "значение точки",
  T_48_META_API_3005_D: "Получите общее количество очков команды для указанного типа очков",
  T_48_META_API_3005_P0_D: "командный состав",
  T_48_META_API_3005_P1_D: "Тип очков",
  T_48_META_API_3005_R_D: "значение точки",
  T_48_META_API_3006_D: "Установка счета раунда для указанного типа очков команды",
  T_48_META_API_3006_P0_D: "командный состав",
  T_48_META_API_3006_P1_D: "Тип очков",
  T_48_META_API_3006_P2_D: "значение точки",
  T_48_META_API_3007_D: "Получите счет игрока за указанный раунд и тип очков",
  T_48_META_API_3007_P0_D: "субъект игрока",
  T_48_META_API_3007_P1_D: "Круглый индекс",
  T_48_META_API_3007_P2_D: "Тип очков",
  T_48_META_API_3007_R_D: "значение точки",
  T_48_META_API_3008_D: "Получите результат команды за указанный раунд, тип очков",
  T_48_META_API_3008_P0_D: "командный состав",
  T_48_META_API_3008_P1_D: "Круглый индекс",
  T_48_META_API_3008_P2_D: "Тип очков",
  T_48_META_API_3008_R_D: "значение точки",
  T_48_META_API_3009_D: "Получите общий рейтинг игрока в игре",
  T_48_META_API_3009_P0_D: "субъект игрока",
  T_48_META_API_3009_R_D: "место в рейтинге имен",
  T_48_META_API_3011_D: "Получите общий игровой рейтинг команды",
  T_48_META_API_3011_P0_D: "заброшенный",
  T_48_META_API_3011_R_D: "место в рейтинге имен",
  T_48_META_API_3013_D: "Получите рейтинг игрока для данного раунда",
  T_48_META_API_3013_P0_D: "субъект игрока",
  T_48_META_API_3013_P1_D: "Круглый индекс",
  T_48_META_API_3013_R_D: "место в рейтинге имен",
  T_48_META_API_3014_D: "Получите рейтинг команд для данного раунда",
  T_48_META_API_3014_P0_D: "заброшенный",
  T_48_META_API_3014_P1_D: "Круглый индекс",
  T_48_META_API_3014_R_D: "место в рейтинге имен",
  T_48_META_API_3015_D: "Получить кошелек целевого объекта",
  T_48_META_API_3015_P0_D: "целевая организация",
  T_48_META_API_3015_P1_D: "Наличие кошелька",
  T_48_META_API_3015_P2_D: "Приобретенные кошельковые предприятия",
  T_48_META_API_3016_D: "Создает кошелек для целевого игрока, не действует, если у игрока уже есть кошелек.",
  T_48_META_API_3016_P0_D: "целевой игрок",
  T_48_META_API_3016_P1_D: "Привязанный к кошельку субъект, владелец кошелька",
  T_48_META_API_3016_P2_D: "единица кошелька",
  T_48_META_API_3017_D: "Добавить валюту в определенный кошелек",
  T_48_META_API_3017_P0_D: "Целевой кошелек",
  T_48_META_API_3017_P1_D: "Тип добавленной валюты",
  T_48_META_API_3017_P2_D: "Увеличение количества валют",
  T_48_META_API_3018_D: "Уменьшение валюты для данного кошелька",
  T_48_META_API_3018_P0_D: "Целевой кошелек",
  T_48_META_API_3018_P1_D: "Сокращение типа валюты",
  T_48_META_API_3018_P2_D: "Сокращение количества валют",
  T_48_META_API_3019_D: "Перевод валюты из одного кошелька в другой кошелек",
  T_48_META_API_3019_P0_D: "Кошелек для перевода валюты",
  T_48_META_API_3019_P1_D: "Виды денежных переводов",
  T_48_META_API_3019_P2_D: "Количество переведенных валют",
  T_48_META_API_3019_P3_D: "Кошелек, на который переводится валюта",
  T_48_META_API_3020_D: "Получение количества валют заданного типа в заданном кошельке",
  T_48_META_API_3020_P0_D: "Целевой кошелек",
  T_48_META_API_3020_P1_D: "Тип валюты запроса",
  T_48_META_API_3020_R_D: "Сумма валюты",
  T_48_META_API_3021_D: "Получение сущностей указанного типа валюты в указанном кошельке",
  T_48_META_API_3021_P0_D: "Целевой кошелек",
  T_48_META_API_3021_P1_D: "Тип валюты запроса",
  T_48_META_API_3021_R_D: "Денежные единицы",
  T_48_META_API_3022_D: "Получите все магазины в игре, верните их в виде списка",
  T_48_META_API_3022_R_D: "Список объектов магазина",
  T_48_META_API_3023_D: "Заменяет форму целевого игрока формой указанного объекта сцены.",
  T_48_META_API_3023_P0_D: "целевой игрок",
  T_48_META_API_3023_P1_D: "Целевые объекты сцены для замены",
  T_48_META_API_3023_P2_D: "Замена компонента камуфляжа трансформации игрока, созданного после",
  T_48_META_API_3024_D: "Отменяет статус маскировки игрока",
  T_48_META_API_3024_P0_D: "целевой игрок",
  T_48_META_API_3025_D: "Создайте альтер-эго в виде объекта сцены у целевого игрока",
  T_48_META_API_3025_P0_D: "целевой игрок",
  T_48_META_API_3025_P1_D: "Объекты сцены для разделенных изображений",
  T_48_META_API_3025_P2_D: "Созданные билокационные сущности",
  T_48_META_API_3026_D: "Получение замаскированной сущности игрока",
  T_48_META_API_3026_P0_D: "игрок",
  T_48_META_API_3026_R_D: "Маскировка игрока",
  T_48_META_API_3027_D: "Получить сущность канала чата по индексу",
  T_48_META_API_3027_P0_D: "Индекс канала чата, диапазон [1,8]",
  T_48_META_API_3027_R_D: "Сущности чат-канала",
  T_48_META_API_3028_D: "Получает сущность канала чата, в котором в данный момент находится указанный игрок",
  T_48_META_API_3028_P0_D: "целевой игрок",
  T_48_META_API_3028_R_D: "Сущности чат-канала",
  T_48_META_API_3029_D: "Позволяет игрокам присоединяться к назначенному каналу чата и переключаться на целевой канал, когда игроки уже находятся в других каналах чата.",
  T_48_META_API_3029_P0_D: "целевой игрок",
  T_48_META_API_3029_P1_D: "Сущности чат-канала",
  T_48_META_API_3030_D: "Вызывает выход игрока из канала, в котором он находится в данный момент, и переводит его в состояние, в котором он не находится ни в одном канале чата после этого",
  T_48_META_API_3030_P0_D: "целевой игрок",
  T_48_META_API_3031_D: "заброшенный",
  T_48_META_API_3031_P0_D: "Сущность канала чата, пустая, если в канале нет игрока",
  T_48_META_API_3032_D: "Установка поведенческого состояния игрока",
  T_48_META_API_3032_P0_D: "целевой игрок",
  T_48_META_API_3032_P1_D: "Типы поведения игроков",
  T_48_META_API_3032_P2_D: `Включено: кнопка HUD доступна, обычно доступна
 Отключено: кнопка HUD отключена, не может активно или пассивно получить доступ к поведенческому состоянию
 Заблокировано: кнопка HUD скрыта, не может активно получить доступ к поведенческому состоянию, но `,
  T_48_META_API_3033_D: "Игрок превращается в объект в данной сцене",
  T_48_META_API_3033_P0_D: "целевой игрок",
  T_48_META_API_3033_P1_D: "объект, который нужно преобразовать в",
  T_48_META_API_3033_P2_D: "Сущности, созданные после преобразования",
  T_48_META_API_3034_D: "Игрок создает альтер-эго собственной внешности",
  T_48_META_API_3034_P0_D: "целевой игрок",
  T_48_META_API_3034_P1_D: "Созданные сущности альтер-эго",
  T_48_META_API_3035_D: "Создайте пользовательский магазин с полками в качестве следующего уровня магазина",
  T_48_META_API_3035_P0_D: "Созданные сущности магазина",
  T_48_META_API_3036_D: "Создайте пользовательскую полку, на верхнем уровне которой будет находиться магазин, а на нижнем - товары",
  T_48_META_API_3036_P0_D: "Создание шельфовых организаций",
  T_48_META_API_3037_D: "Создайте пользовательский продукт, в него можно добавлять товары",
  T_48_META_API_3037_P0_D: "Создание товарных предприятий",
  T_48_META_API_3038_D: "Добавление элементов к товару позволяет добавить несколько элементов к товару, используя элемент несколько раз.",
  T_48_META_API_3038_P0_D: "Товарные предприятия",
  T_48_META_API_3038_P1_D: "Предметы для добавления",
  T_48_META_API_3038_P2_D: "Количество предметов",
  T_48_META_API_3039_D: "Получение вознаграждения за побег из тюрьмы",
  T_48_META_API_3039_P0_D: "субъект игрока",
  T_48_META_API_3039_P1_D: "количество",
  T_48_META_API_3039_P2_D: "реальные деньги",
  T_48_META_API_3040_D: "Обновленные задачи джейлбрейка",
  T_48_META_API_3040_P0_D: "субъект игрока",
  T_48_META_API_3040_P1_D: "Идентификатор задачи",
  T_48_META_API_3040_P2_D: "(стоить",
  T_48_META_API_3041_D: "Получает координаты случайной точки рождения, только из доступных точек рождения, которые не полностью заняты.",
  T_48_META_API_3041_P0_D: "целевой игрок",
  T_48_META_API_3041_R_D: "Случайным образом определяет координаты точки рождения, если нет точки рождения, соответствующей критериям, то возвращает местоположение вблизи (0, 0, 0).",
  T_48_META_API_3042_D: "Выйти из игры Побег из тюрьмы",
  T_48_META_API_3042_P0_D: "субъект игрока",
  T_48_META_API_3042_P1_D: "Идентификатор задачи",
  T_48_META_API_3043_D: "На основе реквизитов для джейлбрейка",
  T_48_META_API_3043_P0_D: "субъект игрока",
  T_48_META_API_3043_P1_D: "Тип реквизита",
  T_48_META_API_3043_P2_D: "Идентификатор реквизита",
  T_48_META_API_31_D: "Создает движение относительно себя, при котором целевая сущность каждый раз изменяется относительно своих текущих значений атрибутов",
  T_48_META_API_31_P0_D: "целевая организация",
  T_48_META_API_31_P1_D: "Свойства, требующие изменения движения",
  T_48_META_API_31_P2_D: "Величина изменения за одно движение",
  T_48_META_API_31_P3_D: "Контрольная точка кривой Бесселя",
  T_48_META_API_31_P4_D: `Одиночное: движение останавливается, когда атрибут изменяется на дельта-величину 
 Циклическое: движение повторяется, каждый раз, когда атрибут изменяется на дельта-величину`,
  T_48_META_API_31_P5_D: "Продолжительность изменения в миллисекундах",
  T_48_META_API_31_P6_D: "Созданные сущности, которые перемещаются относительно самих себя",
  T_48_META_API_31_P7_D: "Начинается ли воспроизведение автоматически после создания",
  T_48_META_API_3100_D: "Цель воспроизводит анимацию в указанном состоянии",
  T_48_META_API_3100_P0_D: "Компоненты сущности, воспроизводящие анимацию с помощью монтируемых контроллеров анимации",
  T_48_META_API_3100_P1_D: "Указанное состояние контроллера анимации",
  T_48_META_API_3100_P2_D: "Масштабирование скорости воспроизведения анимации",
  T_48_META_API_3100_P3_D: "Тип Loop позволяет сохранить исходную логику анимации, воспроизвести ее только один раз или зациклить.",
  T_48_META_API_3101_D: "Воспроизведение анимации персонажей, поддержка пользовательских анимационных ресурсов",
  T_48_META_API_3101_P0_D: "целевой игрок",
  T_48_META_API_3101_P1_D: "Пользовательский идентификатор ресурса анимации",
  T_48_META_API_3101_P2_D: "Зацикливать или нет",
  T_48_META_API_3102_D: "Установка ресурсов персонажа для данного игрока",
  T_48_META_API_3102_P0_D: "целевой игрок",
  T_48_META_API_3102_P1_D: "Идентификатор ресурса пользовательской роли",
  T_48_META_API_3109_D: "При включении движение до конца зоны безопасности будет плавным.",
  T_48_META_API_3109_P0_D: "Начальная позиция зоны безопасности",
  T_48_META_API_3109_P1_D: "Расположение конца зоны безопасности",
  T_48_META_API_3109_P2_D: "Начальный радиус зоны безопасности",
  T_48_META_API_3109_P3_D: "Конечный радиус зоны безопасности",
  T_48_META_API_3109_P4_D: "Время в секундах для достижения зоной безопасности конечного состояния",
  T_48_META_API_3109_P5_D: "Количество урона в секунду, получаемого за пределами безопасной зоны",
  T_48_META_API_3110_D: "Переключение групп внешнего вида персонажей",
  T_48_META_API_3110_P0_D: "цели",
  T_48_META_API_3110_P1_D: 'Группа "Внешний вид',
  T_48_META_API_3111_D: "Показать роль Внешний вид Группа",
  T_48_META_API_3111_P0_D: "цели",
  T_48_META_API_3111_P1_D: 'Группа "Внешний вид',
  T_48_META_API_3112_D: "Группа появления скрытых символов",
  T_48_META_API_3112_P0_D: "цели",
  T_48_META_API_3112_P1_D: 'Группа "Внешний вид',
  T_48_META_API_3121_D: "Отправка результатов утверждений в ПК Craftland Studio для статистического использования",
  T_48_META_API_3121_P0_D: "утверждающее выражение",
  T_48_META_API_3121_P1_D: "привлекать внимание к чему-л.",
  T_48_META_API_32_D: "Получите данные о сегодняшнем токене игрока",
  T_48_META_API_32_P0_D: "целевой игрок",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Количество жетонов",
  T_48_META_API_32_P3_D: "Успешно ли был вызван кортеж",
  T_48_META_API_3200_D: "Добавляет предметы в плеер и возвращает список выданных предметов",
  T_48_META_API_3200_P0_D: "игрок",
  T_48_META_API_3200_P1_D: "ID предмета",
  T_48_META_API_3200_P2_D: "Количество предметов",
  T_48_META_API_3200_P3_D: "Список предметов, добавленных для игрока, даже если добавлен только один предмет, он возвращается в виде списка.",
  T_48_META_API_3201_D: "Восстанавливает кровь назначенному игроку без превышения лимита крови",
  T_48_META_API_3201_P0_D: "целевой игрок",
  T_48_META_API_3201_P1_D: "Значение, добавляющее игроку кровь, принимаются только положительные числа",
  T_48_META_API_3202_D: "Установка списка навыков целевого игрока",
  T_48_META_API_3202_P0_D: "целевой игрок",
  T_48_META_API_3202_P1_D: "Список навыков",
  T_48_META_API_3203_D: "Получите список навыков целевого игрока",
  T_48_META_API_3203_P0_D: "целевой игрок",
  T_48_META_API_3203_R_D: "Список навыков",
  T_48_META_API_3205_D: "Удалить определенное количество предметов из проигрывателя",
  T_48_META_API_3205_P0_D: "целевой игрок",
  T_48_META_API_3205_P1_D: "Тип удаляемого элемента",
  T_48_META_API_3205_P2_D: "Количество удаляемых предметов, если оно превышает количество предметов, находящихся у игрока, то будут удалены только те предметы, которые находятся у игрока",
  T_48_META_API_3206_D: "Получить указанное количество предметов, находящихся у игрока",
  T_48_META_API_3206_P0_D: "целевой игрок",
  T_48_META_API_3206_P1_D: "Тип изделия",
  T_48_META_API_3206_R_D: "Количество холдингов игроков",
  T_48_META_API_3207_D: "Определите, может ли игрок вызвать текущую контрольную точку",
  T_48_META_API_3207_P0_D: "целевой игрок",
  T_48_META_API_3207_P1_D: "Tриггер",
  T_48_META_API_3207_R_D: "True: может быть вызван, False: не может быть вызван",
  T_48_META_API_3208_D: "Режим заражения Эволюция зомби",
  T_48_META_API_3208_P0_D: "целевой игрок",
  T_48_META_API_3209_D: "Сущность ИИ останавливает/исполняет дерево поведения по умолчанию",
  T_48_META_API_3209_P0_D: "Для достижения цели поведенческого дерева",
  T_48_META_API_3209_P1_D: "Следует ли реализовать дерево поведения по умолчанию",
  T_48_META_API_3210_D: "Объект искусственного интеллекта, преследующий заданную цель",
  T_48_META_API_3210_P0_D: "Сущности искусственного интеллекта, выполняющие преследование",
  T_48_META_API_3210_P1_D: "цель",
  T_48_META_API_3211_D: "Уничтожить предметы игрока (устарело, используйте DeleteEquipment)",
  T_48_META_API_3211_P0_D: "Игрок, чей предмет был уничтожен",
  T_48_META_API_3211_P1_D: "Тип уничтоженного предмета",
  T_48_META_API_3211_P2_D: "Оружейный слот, только оружие.",
  T_48_META_API_3212_D: "Смена футболок",
  T_48_META_API_3212_P0_D: "целевой игрок",
  T_48_META_API_3212_P1_D: "Стиль одежды",
  T_48_META_API_3212_P2_D: "Основные цвета I",
  T_48_META_API_3212_P3_D: "Основной цвет II",
  T_48_META_API_3212_P4_D: "настроить",
  T_48_META_API_3213_D: "Восстановите исходное состояние майки игрока",
  T_48_META_API_3213_P0_D: "целевой игрок",
  T_48_META_API_3214_D: "Переключение голосового чата игроков",
  T_48_META_API_3214_P0_D: "целевой игрок",
  T_48_META_API_3214_P1_D: "Закрывать ли голосовой чат, True:Close False:Open",
  T_48_META_API_3215_D: "Быстрый чат с игроками",
  T_48_META_API_3215_P0_D: "целевой игрок",
  T_48_META_API_3215_P1_D: "Закрывать ли быстрый чат, True:Close False:Open",
  T_48_META_API_3216_D: "Установите, может ли целевой игрок подбирать предметы",
  T_48_META_API_3216_P0_D: "целевой игрок",
  T_48_META_API_3216_P1_D: "Запрещено ли подбирать предметы, true: подбирать запрещено false: подбирать разрешено",
  T_48_META_API_3217_D: "Установите, может ли целевой игрок выбрасывать предметы",
  T_48_META_API_3217_P0_D: "целевой игрок",
  T_48_META_API_3217_P1_D: "Запрещено ли бросать предметы, true: поднимать запрещено false: поднимать можно",
  T_48_META_API_3218_D: "Уничтожает оружие в указанном игроком слоте",
  T_48_META_API_3218_P0_D: "целевой игрок",
  T_48_META_API_3218_P1_D: "Оружейные слоты, которые будут уничтожены",
  T_48_META_API_3218_P2_D: "Количество, подлежащее уничтожению",
  T_48_META_API_3218_P3_D: "Успешное уничтожение или нет, уничтожение не происходит, если в слоте оружия нет оружия",
  T_48_META_API_3219_D: "Очистите рюкзак целевого игрока от всех предметов, включая экипированные.",
  T_48_META_API_3219_P0_D: "целевой игрок",
  T_48_META_API_3220_D: "Настройка ориентации игрока",
  T_48_META_API_3220_P0_D: "целевой игрок",
  T_48_META_API_3220_P1_D: "Ориентация игрока",
  T_48_META_API_3221_D: "<Player>(устаревший, не использовать, см. атрибут :Skeleton для информации)",
  T_48_META_API_3221_P0_D: "субъект игрока",
  T_48_META_API_3221_P1_D: "область масштабирования",
  T_48_META_API_3221_P2_D: "значение масштабирования",
  T_48_META_API_3222_D: "Предоставить игроку эффект отбрасывания, целевой игрок будет падать с фиксированнойскоростью, и эффект отбрасывания будет принудительно прекращен при столкновении в воздухе.",
  T_48_META_API_3222_P0_D: "целевой игрок",
  T_48_META_API_3222_P1_D: "Направление выбивания",
  T_48_META_API_3222_P2_D: "время наезда",
  T_48_META_API_3222_P3_D: "Начальная скорость оси Y при ударе",
  T_48_META_API_3222_P4_D: "Начальная скорость в плоскости XZ при ударе",
  T_48_META_API_3222_P5_D: "Нужно ли менять ориентацию игрока",
  T_48_META_API_3223_D: "Получите идентификатор костюма целевого игрока или NPC",
  T_48_META_API_3223_P0_D: "Целевой игрок или NPC",
  T_48_META_API_3223_P1_D: "Тип одежды",
  T_48_META_API_3223_R_D: "Идентификатор одежды",
  T_48_META_API_3224_D: "Установка идентификатора костюма целевого игрока или NPC",
  T_48_META_API_3224_P0_D: "Целевой игрок или NPC",
  T_48_META_API_3224_P1_D: "Идентификатор одежды",
  T_48_META_API_3225_D: "Восстанавливает стандартную одежду целевого игрока, не может применяться к NPC.",
  T_48_META_API_3225_P0_D: "целевой игрок",
  T_48_META_API_3226_D: "Атаки субъектов ИИ на назначенную цель",
  T_48_META_API_3226_P0_D: "ИИ-существо, выполняющее атаку",
  T_48_META_API_3226_P1_D: "цель",
  T_48_META_API_3227_D: "Переключает оружие игрока на оружие в указанном слоте",
  T_48_META_API_3227_P0_D: "целевой игрок",
  T_48_META_API_3227_P1_D: "Переключаемый слот оружия",
  T_48_META_API_3227_P2_D: "Независимо от того, удалось ли переключение или нет, оно завершится неудачей, если в слоте для оружия нет экипированного оружия.",
  T_48_META_API_3228_D: "Получение скинов оружия для целевых игроков или NPC",
  T_48_META_API_3228_P0_D: "Целевой игрок или NPC",
  T_48_META_API_3228_P1_D: "Идентификатор скина оружия",
  T_48_META_API_3228_R_D: "Идентификатор скина оружия",
  T_48_META_API_3229_D: "Установка скина оружия целевого игрока или NPC",
  T_48_META_API_3229_P0_D: "Целевой игрок или NPC",
  T_48_META_API_3229_P1_D: "Идентификатор скина оружия",
  T_48_META_API_3230_D: "Восстанавливает стандартный скин оружия целевого игрока, который не может быть применен к NPC.",
  T_48_META_API_3230_P0_D: "целевой игрок",
  T_48_META_API_3230_P1_D: "Идентификатор оружия",
  T_48_META_API_3231_D: "Настройка костюма игрока",
  T_48_META_API_3231_P0_D: "целевой игрок",
  T_48_META_API_3231_P1_D: "Список одежды",
  T_48_META_API_3232_D: "Удалить все костюмы указанного типа с целевого игрока или NPC",
  T_48_META_API_3232_P0_D: "Целевой игрок или NPC",
  T_48_META_API_3232_P1_D: "Тип одежды",
  T_48_META_API_3233_D: "Снять кожу с оружия игрока или NPC",
  T_48_META_API_3233_P0_D: "Целевой игрок или NPC",
  T_48_META_API_3233_P1_D: "Идентификатор оружия",
  T_48_META_API_3234_D: "Добавить баффы к цели",
  T_48_META_API_3234_P0_D: "Целевая сущность, должна быть сущностью, к которой могут быть добавлены баффы",
  T_48_META_API_3234_P1_D: "Идентификатор буфера",
  T_48_META_API_3235_D: "Снимает баффы с цели",
  T_48_META_API_3235_P0_D: "Целевая сущность, должна быть сущностью, к которой могут быть добавлены баффы",
  T_48_META_API_3235_P1_D: "Идентификатор буфера",
  T_48_META_API_3236_D: "Получить текущий бафф цели",
  T_48_META_API_3236_P0_D: "Целевая сущность, должна быть сущностью, к которой могут быть добавлены баффы",
  T_48_META_API_3236_R_D: "Список баффов",
  T_48_META_API_3237_D: "Получите предметы из бара реквизита рюкзака целевого игрока.",
  T_48_META_API_3237_P0_D: "целевой игрок",
  T_48_META_API_3237_P1_D: "Список реквизита",
  T_48_META_API_3238_D: "Добавьте аксессуары в указанный слот оружия, аксессуары, которые не соответствуют слоту, не подойдут; подходящие, но дублирующие аксессуары заменят оригинальные аксессуары, оригинальные аксессуары будут отправлены в рюкзак игрока, а когда рюкзак игрока бу",
  T_48_META_API_3238_P0_D: "целевой игрок",
  T_48_META_API_3238_P1_D: "оборудование бар слот",
  T_48_META_API_3238_P2_D: "замена (детали)",
  T_48_META_API_3238_P3_D: `Был ли аксессуар успешно добавлен
 True: аксессуар был экипирован к оружию в соответствующем слоте
 False: аксессуар не был добавлен и не появится в рюкзаке игрока`,
  T_48_META_API_3238_P4_D: "Добавленные аксессуары, обнуляются при отказе",
  T_48_META_API_3239_D: 'Получение снаряжения в колонке "Снаряжение рюкзака',
  T_48_META_API_3239_P0_D: "целевой игрок",
  T_48_META_API_3239_P1_D: "оборудование бар слот",
  T_48_META_API_3239_P2_D: "Оборудование в указанном слоте, пустое, если не оборудовано",
  T_48_META_API_3239_P3_D: "Все аксессуары для данного оборудования",
  T_48_META_API_3240_D: "Двумерный вектор принимает x-компоненту",
  T_48_META_API_3240_P0_D: "двумерный вектор",
  T_48_META_API_3240_R_D: "Двумерный вектор x-компонент",
  T_48_META_API_3241_D: "Двумерные векторы берут y-компоненту",
  T_48_META_API_3241_P0_D: "двумерный вектор",
  T_48_META_API_3241_R_D: "Y-компонента двумерного вектора",
  T_48_META_API_3242_D: "Двумерный вектор, задающий x-компоненту",
  T_48_META_API_3242_P0_D: "двумерный вектор",
  T_48_META_API_3242_P1_D: "Двумерный вектор x-компонент",
  T_48_META_API_3243_D: "Двумерный вектор, задающий y-компоненту",
  T_48_META_API_3243_P0_D: "двумерный вектор",
  T_48_META_API_3243_P1_D: "Y-компонента двумерного вектора",
  T_48_META_API_3244_D: "Сложить два двумерных вектора",
  T_48_META_API_3244_P0_D: "Левый операнд",
  T_48_META_API_3244_P1_D: "Правый операнд",
  T_48_META_API_3244_R_D: "Результат суммирования двумерных векторов",
  T_48_META_API_3245_D: "Вычитание двух двумерных векторов",
  T_48_META_API_3245_P0_D: "Левый операнд",
  T_48_META_API_3245_P1_D: "Правый операнд",
  T_48_META_API_3245_R_D: "Результат вычитания 2D-векторов",
  T_48_META_API_3246_D: "Умножьте двумерные векторы на",
  T_48_META_API_3246_P0_D: "двумерный вектор",
  T_48_META_API_3246_P1_D: "Значения масштабирования 2D-векторов",
  T_48_META_API_3246_R_D: "Результат умножения двумерных векторов",
  T_48_META_API_3247_D: "Точечное умножение двух двумерных векторов, результатом точечного умножения является скаляр, характеризующий угол между двумя векторами",
  T_48_META_API_3247_P0_D: "Левый операнд",
  T_48_META_API_3247_P1_D: "Правый операнд",
  T_48_META_API_3247_R_D: "Результат точечного произведения",
  T_48_META_API_3248_D: "Вычислите евклидово расстояние между двумя двумерными векторами",
  T_48_META_API_3248_P0_D: "Левый операнд",
  T_48_META_API_3248_P1_D: "Правый операнд",
  T_48_META_API_3248_R_D: "После вычитания двух векторов модуль результирующего вектора",
  T_48_META_API_3249_D: "Вычислите угол между двумя двумерными векторами",
  T_48_META_API_3249_P0_D: "Левый операнд",
  T_48_META_API_3249_P1_D: "Правый операнд",
  T_48_META_API_3249_R_D: "Угол вектора, диапазон углов 0-180",
  T_48_META_API_3250_D: "Нормализуйте двумерный вектор",
  T_48_META_API_3250_P0_D: "двумерный вектор",
  T_48_META_API_3250_R_D: "Нормированный результат для векторов длиной 1 м в том же направлении, что и вектор",
  T_48_META_API_3251_D: "Моделирование двумерного вектора",
  T_48_META_API_3251_P0_D: "двумерный вектор",
  T_48_META_API_3251_R_D: "Результат моделирования в виде длины вектора",
  T_48_META_API_3252_D: "Вычислите вектор двумерного вектора после отражения нормальной вертикальной линией",
  T_48_META_API_3252_P0_D: "падающий двумерный вектор",
  T_48_META_API_3252_P1_D: "Нормальный двумерный вектор",
  T_48_META_API_3252_R_D: "Отражающий двумерный вектор",
  T_48_META_API_3253_D: "Вычисление трехмерных векторов после отражения от нормали вертикальной плоскости",
  T_48_META_API_3253_P0_D: "падающий 3D-вектор",
  T_48_META_API_3253_P1_D: "Нормальный 3D вектор",
  T_48_META_API_3253_R_D: "отражающий 3D вектор",
  T_48_META_API_3254_D: "Преобразование 3D-вектора в 2D-вектор, удаление Z-компоненты 3D-вектора",
  T_48_META_API_3254_P0_D: "Целевой 3D-вектор",
  T_48_META_API_3254_R_D: "Преобразованный двумерный вектор",
  T_48_META_API_3255_D: "2D-вектор в 3D-вектор, Z-компонента 3D-вектора установлена в 0",
  T_48_META_API_3255_P0_D: "Целевой двумерный вектор",
  T_48_META_API_3255_R_D: "Преобразованный 3D-вектор",
  T_48_META_API_3256_D: "Создание двумерного вектора",
  T_48_META_API_3256_P0_D: "x-компонента двумерного вектора",
  T_48_META_API_3256_P1_D: "Y-компонента двумерного вектора",
  T_48_META_API_3256_R_D: "Созданный двумерный вектор",
  T_48_META_API_3257_D: "Пользовательские журналы захоронений для анализа пользовательского опыта",
  T_48_META_API_3257_P0_D: "журнал",
  T_48_META_API_3258_D: "Пользовательские журналы захоронений для анализа пользовательского опыта",
  T_48_META_API_3258_P0_D: "Чтобы отслеживать заявленных игроков",
  T_48_META_API_3258_P1_D: "журнал",
  T_48_META_API_33_D: "Фильтры для грязных слов",
  T_48_META_API_33_P0_D: "Исходный текст, требующий фильтрации грязных слов",
  T_48_META_API_33_R_D: "Отфильтрованный текст",
  T_48_META_API_3301_D: "Создание лагеря",
  T_48_META_API_3301_P0_D: "Формирующие организации",
  T_48_META_API_3302_D: "Целевая организация присоединяется к обозначенному лагерю",
  T_48_META_API_3302_P0_D: "целевая организация",
  T_48_META_API_3302_P1_D: "Формирующие организации",
  T_48_META_API_3303_D: "Получение лагерей для атакуемых лагерей",
  T_48_META_API_3303_P0_D: "атакующий лагерь",
  T_48_META_API_3303_R_D: "Список подразделений лагеря",
  T_48_META_API_3304_D: "Атакуемые лагеря для создания лагерей",
  T_48_META_API_3304_P0_D: "атакующий лагерь",
  T_48_META_API_3304_P1_D: "целевой лагерь",
  T_48_META_API_3304_P2_D: "Возможность атаки",
  T_48_META_API_3305_D: "Установка атакуемых игроков",
  T_48_META_API_3305_P0_D: "игрок",
  T_48_META_API_3305_P1_D: "Атакуемые игроки",
  T_48_META_API_3305_P2_D: "Возможность атаки",
  T_48_META_API_3306_D: "Установка атакуемой команды",
  T_48_META_API_3306_P0_D: "ударная группа",
  T_48_META_API_3306_P1_D: "целевая группа",
  T_48_META_API_3306_P2_D: "Возможность атаки",
  T_48_META_API_3307_D: "заброшенный",
  T_48_META_API_3307_P0_D: "заброшенный",
  T_48_META_API_3307_R_D: "Список объектов игроков",
  T_48_META_API_3308_D: "Вывод назначенной организации из текущего лагеря",
  T_48_META_API_3308_P0_D: "целевая организация",
  T_48_META_API_3309_D: "Лагерь приобретения объекта",
  T_48_META_API_3309_P0_D: "целевая организация",
  T_48_META_API_3309_R_D: "Формирующие организации",
  T_48_META_API_3310_D: "Определите, может ли цель быть атакована",
  T_48_META_API_3310_P0_D: "агрессоры",
  T_48_META_API_3310_P1_D: "целевая организация",
  T_48_META_API_3310_R_D: "Возможность атаки",
  T_48_META_API_3311_D: "Настройка целей, которые можно атаковать.",
  T_48_META_API_3311_P0_D: "агрессоры",
  T_48_META_API_3311_P1_D: "целевая организация",
  T_48_META_API_3311_P2_D: "Возможность атаки",
  T_48_META_API_3312_D: "Приобретение атакуемых целей организации",
  T_48_META_API_3312_P0_D: "агрессоры",
  T_48_META_API_3312_R_D: "Список атакуемых объектов",
  T_48_META_API_34_D: "Определите, существует ли компонент для целевого объекта",
  T_48_META_API_34_P0_D: "целевая организация",
  T_48_META_API_34_P1_D: "Тип компонента",
  T_48_META_API_34_R_D: "Существует ли",
  T_48_META_API_35_D: "Добавить бота",
  T_48_META_API_35_P0_D: "Уровень сложности бота",
  T_48_META_API_35_P1_D: "Команда бота",
  T_48_META_API_35_P2_D: "Созданная сущность бота-игрока",
  T_48_META_API_3500_D: "Получение данных о токене игрока",
  T_48_META_API_3500_P0_D: "целевой игрок",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Количество жетонов",
  T_48_META_API_3500_P3_D: "успех или неудача",
  T_48_META_API_3501_D: "Добавление данных о маркере в плеер",
  T_48_META_API_3501_P0_D: "целевой игрок",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Количество жетонов",
  T_48_META_API_3501_P3_D: "Успешно ли был вызван кортеж",
  T_48_META_API_3502_D: "Потребление жетона целевого игрока",
  T_48_META_API_3502_P0_D: "целевой игрок",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Количество жетонов",
  T_48_META_API_3502_P3_D: "Успешно ли был вызван кортеж",
  T_48_META_API_3503_D: "Добавьте маркер в указанное место",
  T_48_META_API_3503_P0_D: "размещение",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Количество жетонов",
  T_48_META_API_3503_P3_D: "Успешно ли был вызван кортеж",
  T_48_META_API_3504_D: "Целевой ИИ выпускает указанный навык",
  T_48_META_API_3504_P0_D: "Целевой ИИ",
  T_48_META_API_3504_P1_D: "техника",
  T_48_META_API_3504_P2_D: "цель навыка",
  T_48_META_API_3504_P3_D: "Успешно ли освобожден навык",
  T_48_META_API_3505_D: "Создает пути от начала до конца, которые обходят блоки и могут быть использованы для поиска путей ИИ",
  T_48_META_API_3505_P0_D: "координаты начальной точки",
  T_48_META_API_3505_P1_D: "координаты пункта назначения",
  T_48_META_API_3505_P2_D: "Был ли успешно установлен путь поиска пути",
  T_48_META_API_3505_P3_D: "Соберитесь у путевой точки.",
  T_48_META_API_3506_D: "Установка переменной доски дерева поведения",
  T_48_META_API_3506_P0_D: "Дерево целевого поведения",
  T_48_META_API_3506_P1_D: "имя переменной",
  T_48_META_API_3506_P2_D: "значение переменной",
  T_48_META_API_3507_D: "Получите переменную доски поведенческого дерева",
  T_48_META_API_3507_P0_D: "Дерево целевого поведения",
  T_48_META_API_3507_P1_D: "имя переменной",
  T_48_META_API_3507_P2_D: "значение переменной",
  T_48_META_API_3508_D: "Получение параметров узлов поведенческого дерева",
  T_48_META_API_3508_P0_D: "Узлы дерева целевого поведения",
  T_48_META_API_3508_P1_D: "имя параметра",
  T_48_META_API_3508_P2_D: "значение параметра",
  T_48_META_API_3509_D: "Получить скин носителя целевого игрока",
  T_48_META_API_3509_P0_D: "целевой игрок",
  T_48_META_API_3509_P1_D: "Идентификатор перевозчика",
  T_48_META_API_3509_R_D: "Кожа носителя",
  T_48_META_API_3510_D: "Установка кожи носителя целевого игрока",
  T_48_META_API_3510_P0_D: "целевой игрок",
  T_48_META_API_3510_P1_D: "Идентификатор кожи носителя",
  T_48_META_API_3511_D: "Очистить скин указанного транспортного средства целевого игрока",
  T_48_META_API_3511_P0_D: "целевой игрок",
  T_48_META_API_3511_P1_D: "Идентификатор перевозчика",
  T_48_META_API_3512_D: "Восстановить стандартный скин игрока-носителя",
  T_48_META_API_3512_P0_D: "целевой игрок",
  T_48_META_API_3512_P1_D: "Идентификатор перевозчика",
  T_48_META_API_36_D: "Неактивная цель, может использоваться только для жестких тел типа Dynamic.",
  T_48_META_API_36_P0_D: "целевое жёсткое тело",
  T_48_META_API_37_D: "Пробуждающаяся цель, может быть использована только для жестких тел типа Dynamic.",
  T_48_META_API_37_P0_D: "целевое жёсткое тело",
  T_48_META_API_38_D: "Проверьте, не находится ли целевое жесткое тело в состоянии покоя",
  T_48_META_API_38_P0_D: "целевое жёсткое тело",
  T_48_META_API_38_R_D: "Впадает ли он в спячку или нет",
  T_48_META_API_39_D: "Установка порога спящего режима",
  T_48_META_API_39_P0_D: "целевое жёсткое тело",
  T_48_META_API_39_P1_D: "Порог покоя, движение и вращение жесткого тела меньше, чем это значение в течение определенного периода времени, чтобы войти в состояние покоя, состояние покоя жесткого тела больше не будет выполнять физические расчеты",
  T_48_META_API_4_D: "Установите, могут ли все игроки двигаться",
  T_48_META_API_4_P0_D: `Правда: можно перемещать 
 Ложь: нельзя перемещать`,
  T_48_META_API_40_D: "Получение порога спящего режима",
  T_48_META_API_40_P0_D: "целевое жёсткое тело",
  T_48_META_API_40_R_D: "Порог покоя, движение и вращение жесткого тела меньше, чем это значение в течение определенного периода времени, чтобы войти в состояние покоя, состояние покоя жесткого тела больше не будет выполнять физические расчеты",
  T_48_META_API_4000_D: "Считывает содержимое всей таблицы и возвращает двумерный массив в порядке следования строк",
  T_48_META_API_4000_P0_D: "название таблицы",
  T_48_META_API_4000_R_D: "Содержание таблицы",
  T_48_META_API_4001_D: "Считывает строку таблицы и возвращает массив",
  T_48_META_API_4001_P0_D: "название таблицы",
  T_48_META_API_4001_P1_D: "Количество строк для чтения, считая от 1",
  T_48_META_API_4001_R_D: "Таблица определяет содержимое строки",
  T_48_META_API_4002_D: "Считывает содержимое столбца таблицы и возвращает массив",
  T_48_META_API_4002_P0_D: "название таблицы",
  T_48_META_API_4002_P1_D: "Количество столбцов для чтения, считая от 1",
  T_48_META_API_4002_R_D: "Таблица определяет содержимое столбца",
  T_48_META_API_4003_D: "Чтение содержимого ячейки в таблице",
  T_48_META_API_4003_P0_D: "название таблицы",
  T_48_META_API_4003_P1_D: "Количество строк для чтения, считая от 1",
  T_48_META_API_4003_P2_D: "Количество столбцов для чтения, считая от 1",
  T_48_META_API_4003_R_D: "Содержимое указанной ячейки таблицы",
  T_48_META_API_4004_D: "Чтение содержимого ячейки в таблице по имени строки и столбца",
  T_48_META_API_4004_P0_D: "название таблицы",
  T_48_META_API_4004_P1_D: "Количество строк для чтения, считая от 1",
  T_48_META_API_4004_P2_D: "Имя столбца для чтения",
  T_48_META_API_4004_R_D: "Содержимое указанной ячейки таблицы",
  T_48_META_API_4005_D: "Считывает содержимое всей таблицы и возвращает двумерный массив",
  T_48_META_API_4005_P0_D: "название таблицы",
  T_48_META_API_4005_R_D: "Содержимое таблицы, двумерный массив",
  T_48_META_API_4006_D: "Прочитайте строку таблицы и верните массив.",
  T_48_META_API_4006_P0_D: "название таблицы",
  T_48_META_API_4006_P1_D: "Количество строк для чтения, считая от 1",
  T_48_META_API_4006_R_D: "Таблица определяет содержимое строки, массива",
  T_48_META_API_4007_D: "Прочитайте содержимое столбца всей таблицы и верните массив",
  T_48_META_API_4007_P0_D: "название таблицы",
  T_48_META_API_4007_P1_D: "Количество столбцов для чтения, считая от 1",
  T_48_META_API_4007_R_D: "Таблица определяет содержимое столбца, массива",
  T_48_META_API_4008_D: "Чтение содержимого ячейки в таблице",
  T_48_META_API_4008_P0_D: "название таблицы",
  T_48_META_API_4008_P1_D: "Количество строк для чтения, считая от 1",
  T_48_META_API_4008_P2_D: "Количество столбцов для чтения, считая от 1",
  T_48_META_API_4008_R_D: "Содержимое указанной ячейки таблицы",
  T_48_META_API_4009_D: "Находит указанную строку по количеству столбцов и значению ячейки.",
  T_48_META_API_4009_P0_D: "название таблицы",
  T_48_META_API_4009_P1_D: "Количество столбцов для чтения",
  T_48_META_API_4009_P2_D: "Значение ячейки для поиска",
  T_48_META_API_4009_R_D: "Содержимое найденных строк, массив",
  T_48_META_API_4010_D: "Получение номера столбца по его имени",
  T_48_META_API_4010_P0_D: "название таблицы",
  T_48_META_API_4010_P1_D: "Имя столбца для поиска серийного номера",
  T_48_META_API_4010_R_D: "Колонки, считая от 1",
  T_48_META_API_41_D: "Устанавливает глобальный порог сна, действительный только для вновь созданных жестких тел типа Dynamic.",
  T_48_META_API_41_P0_D: "Порог покоя, движение и вращение жесткого тела меньше, чем это значение в течение определенного периода времени, чтобы войти в состояние покоя, состояние покоя жесткого тела больше не будет выполнять физические расчеты",
  T_48_META_API_42_D: "Получение глобального порога спящего режима",
  T_48_META_API_42_R_D: "Порог покоя, по умолчанию 0.005, движение и вращение жесткого тела меньше этого значения в течение определенного периода времени, чтобы войти в состояние покоя, спящее жесткое тело больше не будет выполнять физические расчеты",
  T_48_META_API_43_D: "Преобразуйте заданный кватернион в угол Эйлера, порядок поворота угла Эйлера - YXZ, если входящий кватернион не является законным, верните (0,0,0)",
  T_48_META_API_43_P0_D: "Входной кватернион",
  T_48_META_API_43_R_D: "Возвращенные углы Эйлера",
  T_48_META_API_44_D: "Преобразование заданного угла Эйлера в кватернион",
  T_48_META_API_44_P0_D: "Входные углы Эйлера",
  T_48_META_API_44_R_D: "Возвращаемый кватернион",
  T_48_META_API_45_D: "Преобразование вращений осевых угловых представлений в кватернионы",
  T_48_META_API_45_P0_D: "ось вращения",
  T_48_META_API_45_P1_D: "Угол поворота по часовой стрелке вокруг оси вращения",
  T_48_META_API_45_R_D: "Возвращаемый кватернион",
  T_48_META_API_46_D: "Преобразование кватернионов в представления осевых углов",
  T_48_META_API_46_P0_D: "Входной кватернион",
  T_48_META_API_46_P1_D: "ось вращения",
  T_48_META_API_46_P2_D: "Угол поворота по часовой стрелке вокруг оси вращения",
  T_48_META_API_47_D: "Настройка пользовательского прогресса завершения задачи",
  T_48_META_API_47_P0_D: "целевой игрок",
  T_48_META_API_47_P1_D: "Идентификатор задачи",
  T_48_META_API_47_P2_D: "Прогресс на пути к завершению, отрицательные числа не допускаются",
  T_48_META_API_48_D: "Создайте кривую Безье, которую можно использовать для интерполяции движения",
  T_48_META_API_48_P0_D: "контрольная точка кривой",
  T_48_META_API_48_R_D: "Кривая Бесселя",
  T_48_META_API_49_D: "Получить идентификатор карты сцены",
  T_48_META_API_49_P0_D: "Идентификатор сцены",
  T_48_META_API_49_R_D: "Идентификатор карты",
  T_48_META_API_5_D: "Удаление размещенных объектов в сцене (устарело, используйте DeleteEntity)",
  T_48_META_API_5_P0_D: "Объекты, подлежащие удалению",
  T_48_META_API_50_D: "Создает движение относительно себя каждый кадр, при этом целевая сущность изменяет свои атрибуты один раз за кадр, каждый раз относительно своих текущих значений атрибутов",
  T_48_META_API_50_P0_D: "целевая организация",
  T_48_META_API_50_P1_D: "Свойства, требующие изменения движения",
  T_48_META_API_50_P2_D: "Величина изменения за одно движение",
  T_48_META_API_50_P3_D: `Конфигурация при использовании в сочетании с другими режимами движения
 Правда: можно использовать в сочетании с относительным движением
 Ложь: можно использовать в сочетании с абсолютным движением`,
  T_48_META_API_50_P4_D: "Созданные сущности покадрового движения относительно самих себя",
  T_48_META_API_50_P5_D: "Начинается ли воспроизведение автоматически после создания",
  T_48_META_API_5000_D: "Считывание значения, соответствующего ключу в таблице базы данных.",
  T_48_META_API_5000_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5000_P1_D: "Метки игроков и обработка параллелизма",
  T_48_META_API_5000_P2_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5000_P3_D: "Возвращает результат чтения",
  T_48_META_API_5000_P4_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5001_D: "Запишите значение, соответствующее ключу в таблице базы данных.",
  T_48_META_API_5001_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5001_P1_D: "Метки игроков и обработка параллелизма",
  T_48_META_API_5001_P2_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5001_P3_D: "Выписанная стоимость",
  T_48_META_API_5001_P4_D: "Код поля боя, соответствующий базе данных, который можно заполнить пробелами, представляет собой код поля боя текущей карты.",
  T_48_META_API_5002_D: "Удаление значения, соответствующего ключу в таблице базы данных.",
  T_48_META_API_5002_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5002_P1_D: "Метки игроков и обработка параллелизма",
  T_48_META_API_5002_P2_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5002_P3_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5003_D: "Получение значения ключа в таблице базы данных.",
  T_48_META_API_5003_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_5003_P1_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5003_P2_D: "Возвращает результат чтения",
  T_48_META_API_5003_P3_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5004_D: "Запишите значение, соответствующее ключу, в таблицу диаграмм в базе данных.",
  T_48_META_API_5004_P0_D: "Имя таблицы лидеров в базе данных",
  T_48_META_API_5004_P1_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5004_P2_D: "Выписанная стоимость",
  T_48_META_API_5004_P3_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5005_D: "Удаление значения, соответствующего ключу в таблице диаграмм в базе данных.",
  T_48_META_API_5005_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5005_P1_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5005_P2_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5006_D: "Удаление значения, соответствующего рангу в таблице рангов в базе данных.",
  T_48_META_API_5006_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5006_P1_D: "Рейтинг в таблице лидеров",
  T_48_META_API_5006_P2_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5007_D: "Получение значений из таблицы ранжирования в базе данных от определенного ранга до определенного ранга.",
  T_48_META_API_5007_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5007_P1_D: "исходное положение",
  T_48_META_API_5007_P2_D: "финишная позиция",
  T_48_META_API_5007_P3_D: "Возвращает результат чтения",
  T_48_META_API_5007_P4_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5008_D: "Чтение значения, соответствующего ключу Key в таблице базы данных кумулятивных данных.",
  T_48_META_API_5008_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5008_P1_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5008_P2_D: "Возвращает результат чтения",
  T_48_META_API_5008_P3_D: "Битва код, соответствующий базе данных",
  T_48_META_API_5009_D: "Запишите значение смещения, соответствующее ключу в таблице кумулятивной базы данных",
  T_48_META_API_5009_P0_D: "Имена таблиц в базе данных",
  T_48_META_API_5009_P1_D: "Пользовательское имя, используемое для идентификации данных",
  T_48_META_API_5009_P2_D: "Типы четырех операций в настоящее время поддерживают следующие типы: тип Int поддерживает сложение, вычитание, умножение, деление и остаток; тип Float поддерживает сложение, вычитание, умножение и деление.",
  T_48_META_API_5009_P3_D: "Записанное значение смещения",
  T_48_META_API_5009_P4_D: "Битва код, соответствующий базе данных",
  T_48_META_API_51_D: "Сброс воспроизводимой сущности, возвращает воспроизводимую сущность к ее первоначальному виду без изменения состояния воспроизведения",
  T_48_META_API_51_P0_D: "Целевая играбельная сущность",
  T_48_META_API_52_D: "Умножение двух кватернионов A*B означает вращение A, а затем B. Другой порядок вращения приведет к другому результату.",
  T_48_META_API_52_P0_D: "левозначный кватернион",
  T_48_META_API_52_P1_D: "правозначный кватернион",
  T_48_META_API_52_R_D: "Результирующий кватернион",
  T_48_META_API_53_D: "Создает вращающийся кватернион, направленный в заданную сторону",
  T_48_META_API_53_P0_D: "указывать направление",
  T_48_META_API_53_P1_D: "вверх",
  T_48_META_API_53_R_D: "Величина поворота, необходимая для выравнивания в указанном направлении.",
  T_48_META_API_54_D: "Кватернионная сферическая интерполяция из A в B",
  T_48_META_API_54_P0_D: "A-значение",
  T_48_META_API_54_P1_D: "B-значение",
  T_48_META_API_54_P2_D: "Прогресс интерполяции, диапазон значений [0,1], значение 0 возвращает к началу значения, значение 1 возвращает к целевому значению",
  T_48_META_API_54_R_D: "Результирующий кватернион",
  T_48_META_API_57_D: "Выводит данные о цели в виде предупреждения на консоль",
  T_48_META_API_57_P0_D: "Что печатать",
  T_48_META_API_58_D: "Выводит данные о цели на консоль в качестве сообщения об ошибке.",
  T_48_META_API_58_P0_D: "Что печатать",
  T_48_META_API_59_D: "Получение значения на кривой",
  T_48_META_API_59_P0_D: "окольным путем",
  T_48_META_API_59_P1_D: "Точка выборки, диапазон значений [0,1]",
  T_48_META_API_59_R_D: "в конце концов",
  T_48_META_API_6_D: "Создает объекты сцены по заданным координатам",
  T_48_META_API_6_P0_D: "Созданные объекты сцены",
  T_48_META_API_6_P1_D: "Расположение генерации объектов",
  T_48_META_API_6_P2_D: "Идентификатор созданного типа объекта, который необходимо предварительно зарегистрировать в реестре активов для использования в сценариях кода.",
  T_48_META_API_60_D: "Интерполяция на основе кривых",
  T_48_META_API_60_P0_D: "тип значения",
  T_48_META_API_60_P1_D: "начальное значение",
  T_48_META_API_60_P2_D: "целевое значение",
  T_48_META_API_60_P3_D: "окольным путем",
  T_48_META_API_60_P4_D: "Точка выборки, диапазон значений [0,1]",
  T_48_META_API_60_R_D: "в конце концов",
  T_48_META_API_6000_D: "Добавление сценариев к целевым сущностям",
  T_48_META_API_6000_P0_D: "целевая организация",
  T_48_META_API_6000_P1_D: "Идентификатор сценария",
  T_48_META_API_6001_D: "Выгрузка скриптов для целевых сущностей",
  T_48_META_API_6001_P0_D: "целевая организация",
  T_48_META_API_6001_P1_D: "Идентификатор сценария",
  T_48_META_API_6002_D: "Проверяет, существует ли указанный скрипт для целевой сущности.",
  T_48_META_API_6002_P0_D: "целевая организация",
  T_48_META_API_6002_P1_D: "Идентификатор сценария",
  T_48_META_API_6002_R_D: "Существование указанного сценария",
  T_48_META_API_61_D: "Установка родительского узла элемента управления пользовательского интерфейса",
  T_48_META_API_61_P0_D: "Родительский узел, может указывать элемент управления пользовательским интерфейсом или пользовательский пользовательский интерфейс",
  T_48_META_API_61_P1_D: "дочерний узел",
  T_48_META_API_62_D: "заброшенный",
  T_48_META_API_62_P0_D: "заброшенный",
  T_48_META_API_62_P1_D: "заброшенный",
  T_48_META_API_62_P2_D: "заброшенный",
  T_48_META_API_62_P3_D: "заброшенный",
  T_48_META_API_62_P4_D: "заброшенный",
  T_48_META_API_63_D: "Создание луча от текущей камеры к точке касания экрана",
  T_48_META_API_63_P0_D: "контакт экрана",
  T_48_META_API_63_P1_D: "порог",
  T_48_META_API_63_P2_D: "направление луча",
  T_48_META_API_64_D: "Загрузка пользовательской информации для выставления счетов",
  T_48_META_API_64_P0_D: "субъект игрока",
  T_48_META_API_64_P1_D: "результаты конкурса",
  T_48_META_API_64_P2_D: "Интегральное название (вычислительная техника)",
  T_48_META_API_64_P3_D: "значение точки",
  T_48_META_API_65_D: "Воспроизведите указанный звуковой эффект и задайте свойства его сущности, если вам нужно задать больше свойств.",
  T_48_META_API_65_P0_D: "Создание звуковых образований",
  T_48_META_API_65_P1_D: "Целевой игрок, только целевой игрок может слышать звуковые эффекты",
  T_48_META_API_65_P2_D: "Тип звукового эффекта",
  T_48_META_API_65_P3_D: "Тип петли",
  T_48_META_API_65_P4_D: "Играть или не играть сразу",
  T_48_META_API_66_D: "Создает указанный визуальный эффект и устанавливает свойства его сущности, если необходимо установить больше свойств.",
  T_48_META_API_66_P0_D: "Создание сущностей со спецэффектами",
  T_48_META_API_66_P1_D: "Целевые игроки, видимые только целевым игрокам",
  T_48_META_API_66_P2_D: "Тип специального эффекта",
  T_48_META_API_66_P3_D: "Тип петли",
  T_48_META_API_66_P4_D: "Играть или не играть сразу",
  T_48_META_API_67_D: "Создает указанный звуковой эффект и устанавливает свойства его сущности, если необходимо установить больше свойств.",
  T_48_META_API_67_P0_D: "Создание звуковых образований",
  T_48_META_API_67_P1_D: "Тип звукового эффекта",
  T_48_META_API_67_P2_D: "Тип петли",
  T_48_META_API_67_P3_D: "Играть или не играть сразу",
  T_48_META_API_68_D: "Преобразование мировых координат в координаты экрана",
  T_48_META_API_68_P0_D: "мировая координата",
  T_48_META_API_68_P1_D: "Отображается ли он в пределах экрана",
  T_48_META_API_68_P2_D: "положение на карте",
  T_48_META_API_69_D: "Преобразование координат экрана в мировые координаты",
  T_48_META_API_69_P0_D: "координата экрана",
  T_48_META_API_69_P1_D: "Расстояние от экрана",
  T_48_META_API_69_P2_D: "мировая координата",
  T_48_META_API_7_D: "Преобразование целевого значения в строку",
  T_48_META_API_7_P0_D: "Целевое значение преобразуемой строки",
  T_48_META_API_7_R_D: "строка",
  T_48_META_API_70_D: "Обнаружение лучей при касании экрана возвращает первую попавшуюся сущность",
  T_48_META_API_70_P0_D: "Начальный экран Контакты",
  T_48_META_API_70_P1_D: "Расстояние обнаружения",
  T_48_META_API_70_P2_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_70_P3_D: "Можно ли обнаружить триггер",
  T_48_META_API_70_P4_D: "объект поражения",
  T_48_META_API_70_P5_D: "координаты точки попадания",
  T_48_META_API_70_P6_D: "Расстояние точки попадания от начальной точки",
  T_48_META_API_70_P7_D: "попасть в нормаль к поверхности .",
  T_48_META_API_71_D: "Обнаружение лучей при касании экрана, возврат всех пораженных сущностей",
  T_48_META_API_71_P0_D: "Начальный экран Контакты",
  T_48_META_API_71_P1_D: "Расстояние обнаружения",
  T_48_META_API_71_P2_D: "Маска слоя, только заполненные слои будут участвовать в сканировании, если оставить ее пустой, то все слои будут участвовать в сканировании",
  T_48_META_API_71_P3_D: "Можно ли обнаружить триггер",
  T_48_META_API_71_P4_D: "Список объектов, попавших под удар",
  T_48_META_API_71_P5_D: "Список координат точек попадания",
  T_48_META_API_71_P6_D: "Список расстояний между точкой попадания и начальной точкой",
  T_48_META_API_71_P7_D: "Список нормалей поверхности",
  T_48_META_API_72_D: "Создает указанный визуальный эффект и устанавливает свойства его сущности, если необходимо установить больше свойств.",
  T_48_META_API_72_P0_D: "Создание сущностей со спецэффектами",
  T_48_META_API_72_P1_D: "Тип специального эффекта",
  T_48_META_API_72_P2_D: "Тип петли",
  T_48_META_API_72_P3_D: "Играть или не играть сразу",
  T_48_META_API_73_D: "Создайте встроенный пользовательский интерфейс, который не синхронизируется с другими клиентами",
  T_48_META_API_73_P0_D: "Созданы встроенные сущности пользовательского интерфейса",
  T_48_META_API_73_P1_D: "Встроенные типы пользовательского интерфейса",
  T_48_META_API_74_D: "Создание пользовательского пользовательского интерфейса, который не синхронизируется с другими клиентами",
  T_48_META_API_74_P0_D: "Создание пользовательских сущностей пользовательского интерфейса",
  T_48_META_API_74_P1_D: "Пользовательский индекс пользовательского интерфейса",
  T_48_META_API_75_D: "Получите соответствующего игрока текущего клиента",
  T_48_META_API_75_R_D: "субъект игрока",
  T_48_META_API_76_D: "Создание монстров ИИ",
  T_48_META_API_76_P0_D: "Целевой ИИ",
  T_48_META_API_76_P1_D: "Создать местоположение",
  T_48_META_API_76_P2_D: "Тип ИИ",
  T_48_META_API_76_P3_D: "аффилированная команда",
  T_48_META_API_76_P4_D: "следует ли автоматически утверждать, что враг",
  T_48_META_API_76_P5_D: "режим атаки",
  T_48_META_API_76_P6_D: "Маршрут путешествия",
  T_48_META_API_77_D: "Установите первый компонент вектора",
  T_48_META_API_77_P0_D: "векторы",
  T_48_META_API_77_P1_D: "Стоимость первого компонента",
  T_48_META_API_77_R_D: "Вектор после модификации первого компонента",
  T_48_META_API_78_D: "Установите вторую компоненту вектора",
  T_48_META_API_78_P0_D: "векторы",
  T_48_META_API_78_P1_D: "Значение второго компонента",
  T_48_META_API_78_R_D: "Вектор после модификации второго компонента",
  T_48_META_API_79_D: "Установите третью компоненту вектора",
  T_48_META_API_79_P0_D: "векторы",
  T_48_META_API_79_P1_D: "Стоимость третьего компонента",
  T_48_META_API_79_R_D: "Вектор после модификации третьего компонента",
  T_48_META_API_8_D: "Откройте зону безопасности, которая сужается до центральной координатной точки.",
  T_48_META_API_8_P0_D: "Центральная точка зоны безопасности",
  T_48_META_API_8_P1_D: "Радиус зоны безопасности",
  T_48_META_API_8_P2_D: "Время ожидания в секундах, по истечении которого зона безопасности начнет уменьшаться по направлению к центральной точке",
  T_48_META_API_8_P3_D: "Время, необходимое для уменьшения зоны безопасности до центральной точки, в секундах",
  T_48_META_API_8_P4_D: "Количество урона в секунду, получаемого за пределами безопасной зоны",
  T_48_META_API_80_D: "Установка первой компоненты двумерного вектора",
  T_48_META_API_80_P0_D: "двумерный вектор",
  T_48_META_API_80_P1_D: "Стоимость первого компонента",
  T_48_META_API_80_R_D: "Двумерный вектор после модификации первого компонента",
  T_48_META_API_81_D: "Установка второй компоненты двумерного вектора",
  T_48_META_API_81_P0_D: "двумерный вектор",
  T_48_META_API_81_P1_D: "Значение второго компонента",
  T_48_META_API_81_R_D: "Двумерный вектор после модификации второй компоненты",
  T_48_META_API_82_D: "Переместите контроллер персонажа в указанное место, если он действует на игрока, то игрок должен включить контроллер игрока, который использует физический эффект, чтобы он начал действовать",
  T_48_META_API_82_P0_D: "Контроллер целевой роли",
  T_48_META_API_82_P1_D: "определённое место",
  T_48_META_API_83_D: "Получение указанного дочернего узла целевой родительской сущности по имени",
  T_48_META_API_83_P0_D: "головная организация",
  T_48_META_API_83_P1_D: "Имя подузла",
  T_48_META_API_83_R_D: "дочерняя организация",
  T_48_META_API_84_D: "Добавьте AOI особое внимание и всегда синхронизируйте независимо от расстояния",
  T_48_META_API_84_P0_D: "Цели, требующие особого внимания",
  T_48_META_API_84_P1_D: "наблюдатель",
  T_48_META_API_85_D: "Уберите особое внимание к AOI и отмените синхронизацию AOI вне обзора",
  T_48_META_API_85_P0_D: "Цели, требующие особого внимания",
  T_48_META_API_85_P1_D: "наблюдатель",
  T_48_META_API_86_D: "Очистить все особые зоны AOI для указанной цели.",
  T_48_META_API_86_P0_D: "Цели, требующие особого внимания",
  T_48_META_API_87_D: "Определите, существует ли объект особой важности AOI",
  T_48_META_API_87_P0_D: "Цели, требующие особого внимания",
  T_48_META_API_87_P1_D: "заброшенный",
  T_48_META_API_87_R_D: "Существует ли",
  T_48_META_API_88_D: "Переключение прокси-наблюдателя игрока",
  T_48_META_API_88_P0_D: "игрок",
  T_48_META_API_88_P1_D: "прокси-наблюдатель",
  T_48_META_API_89_D: "Отключает контроллер персонажа один раз, и если он действует на игрока, игрок должен включить контроллер игрока, который использует физический эффект, чтобы он начал действовать",
  T_48_META_API_89_P0_D: "Целевой объект или, в случае с игроком, игрок должен иметь контроллер игрока, использующий физические эффекты, включенный для того, чтобы эффект начал действовать",
  T_48_META_API_89_P1_D: "вектор перемещения",
  T_48_META_API_9_D: "Отключите механизм безопасной зоны, когда безопасная зона сократится до минимума, игроки за пределами безопасной зоны будут продолжать получать урон, после отключения механизма безопасной зоны игроки вернутся в безопасное место",
  T_48_META_API_90_D: "Установите, может ли игрок свободно выйти из игры",
  T_48_META_API_90_P0_D: "целевой игрок",
  T_48_META_API_90_P1_D: "Свобода выхода",
  T_48_META_API_9000_D: "Создайте встроенный пользовательский интерфейс, который могут видеть только указанные игроки",
  T_48_META_API_9000_P0_D: "Созданы встроенные сущности пользовательского интерфейса",
  T_48_META_API_9000_P1_D: "Сущность игрока, которой принадлежит пользовательский интерфейс, видимый только для этого игрока",
  T_48_META_API_9000_P2_D: "Встроенные типы пользовательского интерфейса",
  T_48_META_API_9001_D: "Удалите встроенный игровой пользовательский интерфейс",
  T_48_META_API_9001_P0_D: "Встроенные сущности пользовательского интерфейса должны быть удалены",
  T_48_META_API_9002_D: "Создает иконку с указанным типом иконки и, если нужно задать больше свойств, устанавливает свойства сущности через сущность (устарело, используйте CreateLevelObject).",
  T_48_META_API_9002_P0_D: "В коде это имя формального параметра, используемого для представления сущности, создающей иконку, а соответствующее ему значение локальной переменной - сущность, создающая иконку",
  T_48_META_API_9002_P1_D: "Сущность игрока, которой она принадлежит, видимая только для этого игрока",
  T_48_META_API_9002_P2_D: "Путь к ресурсу, путь к ресурсу, соответствующий иконке, выбранной игроком",
  T_48_META_API_9003_D: "Удалить указанный значок (устарело, используйте DeleteEntity)",
  T_48_META_API_9003_P0_D: "Сущность значка, которую нужно удалить",
  T_48_META_API_9004_D: "Создает текст с указанным содержимым, а если нужно задать больше атрибутов, то устанавливает атрибуты сущности через сущность (устарело, используйте CreateLevelObject).",
  T_48_META_API_9004_P0_D: "В коде это имя формального параметра, используемого для представления сущности, создающей текст, а соответствующее ему значение локальной переменной - сущность, создающая текст",
  T_48_META_API_9004_P1_D: "Сущность игрока, которой она принадлежит, видимая только для этого игрока",
  T_48_META_API_9004_P2_D: "Текстовое содержание для представления",
  T_48_META_API_9005_D: "Удалить указанный текст (устарело, используйте DeleteEntity)",
  T_48_META_API_9005_P0_D: "Текстовые объекты, которые необходимо удалить",
  T_48_META_API_9006_D: "Создает иконку с указанным типом эффекта, а если нужно задать больше свойств, то устанавливает свойства сущности далее через сущность (устарело, используйте CreateEffect).",
  T_48_META_API_9006_P0_D: "В коде это имя формального параметра, используемого для представления сущности, создающей эффект, а значение соответствующей локальной переменной - сущность, создающая эффект.",
  T_48_META_API_9006_P1_D: "Сущность игрока, которой она принадлежит, видимая только для этого игрока",
  T_48_META_API_9006_P2_D: "Типы специальных эффектов, виды эффектов, которые могут выбрать игроки",
  T_48_META_API_9007_D: "Удалить указанный эффект (устарело, используйте DeleteEntity)",
  T_48_META_API_9007_P0_D: "Объект эффектов, который необходимо удалить",
  T_48_META_API_9008_D: "Создайте пользовательский пользовательский интерфейс, который могут видеть только указанные игроки",
  T_48_META_API_9008_P0_D: "Создание пользовательских сущностей пользовательского интерфейса",
  T_48_META_API_9008_P1_D: "Сущность игрока, которой принадлежит пользовательский интерфейс, видимый только для этого игрока",
  T_48_META_API_9008_P2_D: "Пользовательский индекс пользовательского интерфейса",
  T_48_META_API_9009_D: "Удалить пользовательский игровой пользовательский интерфейс",
  T_48_META_API_9009_P0_D: "Пользовательские сущности пользовательского интерфейса должны быть удалены",
  T_48_META_API_9010_D: "Получение элементов управления пользовательским интерфейсом из пользовательского пользовательского интерфейса",
  T_48_META_API_9010_P0_D: "Сущность игрока, которой принадлежит пользовательский интерфейс",
  T_48_META_API_9010_P1_D: "Пользовательские сущности пользовательского интерфейса",
  T_48_META_API_9010_P2_D: "Контрольный уникальный индекс",
  T_48_META_API_9010_R_D: "Элемент управления пользовательским интерфейсом",
  T_48_META_API_9011_D: "Воспроизведите указанный звук и, если необходимо задать дополнительные свойства, установите свойства сущности далее через сущность (устарело, используйте CreateSound)",
  T_48_META_API_9011_P0_D: "В коде это имя формального параметра, используемого для представления сущности, создающей звуковой эффект, а соответствующее ему значение локальной переменной - это сущность, создающая звуковой эффект",
  T_48_META_API_9011_P1_D: "Сущность игрока, которой она принадлежит, видимая только для этого игрока",
  T_48_META_API_9011_P2_D: "Типы звуков - виды звуковых эффектов, которые может выбрать игрок.",
  T_48_META_API_9012_D: "Удалить указанный звуковой эффект (устарело, используйте DeleteEntity)",
  T_48_META_API_9012_P0_D: "Звуковые образования, которые необходимо удалить",
  T_48_META_API_9013_D: "Получение элемента управления пользовательским интерфейсом из пользовательского пользовательского интерфейса с помощью пути",
  T_48_META_API_9013_P0_D: "Сущность игрока, которой принадлежит пользовательский интерфейс",
  T_48_META_API_9013_P1_D: "Пользовательский пользовательский интерфейс",
  T_48_META_API_9013_P2_D: "Путь управления",
  T_48_META_API_9013_R_D: "Элемент управления пользовательским интерфейсом",
  T_48_META_API_9014_D: "Звуковая сущность в прерывании воспроизведения (устарело, используйте PauseSound)",
  T_48_META_API_9014_P0_D: "Звуковые образования, которые необходимо приостановить",
  T_48_META_API_9015_D: "Возобновление звука, по желанию с самого начала (устарело, используйте ResumeSound)",
  T_48_META_API_9015_P0_D: "Звуковые объекты, которые должны продолжать воспроизведение после приостановки",
  T_48_META_API_9015_P1_D: "Стоит ли начинать с нуля",
  T_48_META_API_9016_D: "Создание пользовательских элементов управления пользовательским интерфейсом",
  T_48_META_API_9016_P0_D: "Создание пользовательских сущностей управления",
  T_48_META_API_9016_P1_D: "Тип созданного контроля",
  T_48_META_API_9016_P2_D: "Аффилированные организации пользовательского интерфейса",
  T_48_META_API_9016_P3_D: "Родительский элемент управления, если он не заполнен, то родительским узлом будет сущность UI.",
  T_48_META_API_9017_D: "Установка маски слоя целевой камеры",
  T_48_META_API_9017_P0_D: "целевой объект камеры",
  T_48_META_API_9017_P1_D: "Маска слоя, в целевой камере будут показаны только заполненные слои, если оставить этот параметр пустым, то будут показаны все слои.",
  T_48_META_API_9018_D: "Получение маски слоя целевой камеры",
  T_48_META_API_9018_P0_D: "целевой объект камеры",
  T_48_META_API_9018_R_D: "Маска слоя, в целевой камере отображаются только слои в пределах маски слоя",
  T_48_META_API_9019_D: "Устанавливает, виден ли указанный уровень целевой камере.",
  T_48_META_API_9019_P0_D: "целевой объект камеры",
  T_48_META_API_9019_P1_D: "Иерархия видимости",
  T_48_META_API_9019_P2_D: "видимость",
  T_48_META_API_9020_D: "Установка состояния интерфейса целевого игрока по умолчанию",
  T_48_META_API_9020_P0_D: "целевой игрок",
  T_48_META_API_9020_P1_D: "Типы интерфейса игрока, которые представляют собой элементы пользовательского интерфейса, используемые для манипулирования игроком и связанным с ним содержимым",
  T_48_META_API_9020_P2_D: "Значение переключателя, определяет видимость интерфейса игрока",
  T_48_META_API_9021_D: "Создание строки локализации временной метки",
  T_48_META_API_9021_P0_D: "метка времени",
  T_48_META_API_9021_P1_D: "Стили форматирования",
  T_48_META_API_9021_R_D: "Временная метка Строка локализации",
  T_48_META_API_9022_D: "Создание значка мини-карты",
  T_48_META_API_9022_P0_D: "Созданы сущности в виде значков мини-карты",
  T_48_META_API_9022_P1_D: "Игрок, к которому вы принадлежите, создает значок мини-карты, который виден только этому игроку.",
  T_48_META_API_9022_P2_D: "Mindmap Иконка Путь к ресурсам",
  T_48_META_API_9023_D: "Создает иконку с указанным типом эффекта и далее устанавливает ее свойства через сущность, если необходимо установить больше свойств.",
  T_48_META_API_9023_P0_D: "В коде это имя формального параметра, используемого для представления сущности, создающей эффект, а значение соответствующей локальной переменной - сущность, создающая эффект.",
  T_48_META_API_9023_P1_D: "Сущность игрока, которой она принадлежит, видимая только для этого игрока",
  T_48_META_API_9023_P2_D: "Типы специальных эффектов, виды эффектов, которые могут выбрать игроки",
  T_48_META_API_9024_D: "Удалить указанный эффект (устарело, используйте DeleteEntity)",
  T_48_META_API_9024_P0_D: "Объект эффектов, который необходимо удалить",
  T_48_META_API_9025_D: "Создает статичные пиксели на карте для целевого объекта, которые не перемещаются вместе с ним.",
  T_48_META_API_9025_P0_D: "Создание статических пиксельных сущностей",
  T_48_META_API_9025_P1_D: "Игрок, которому он принадлежит, создает статичные пиксели, видимые только этому игроку",
  T_48_META_API_9025_P2_D: "целевой объект сущность",
  T_48_META_API_9026_D: "Получить объект мини-карты целевого игрока",
  T_48_META_API_9026_P0_D: "целевой игрок",
  T_48_META_API_9026_R_D: "Мини-карта текущего игрока",
  T_48_META_API_9027_D: "Настройте урон от падения игрока, можно установить различный урон в зависимости от высоты сегментов",
  T_48_META_API_9027_P0_D: "целевой игрок",
  T_48_META_API_9027_P1_D: "Сегментированный список высот",
  T_48_META_API_9027_P2_D: "Список сегментов повреждений",
  T_48_META_API_91_D: "Добавление цели в определенную команду приведет к тому, что цель покинет команду, в которой она ранее состояла.",
  T_48_META_API_91_P0_D: "Цели, которые необходимо добавить в команду",
  T_48_META_API_91_P1_D: "Присоединяйтесь к команде",
  T_48_META_API_91_P2_D: "успех или неудача",
  T_48_META_API_92_D: "Добавление цели во вновь созданную команду приведет к тому, что цель выбывает из команды, в которой она находилась ранее.",
  T_48_META_API_92_P0_D: "Цели, которые необходимо добавить в команду",
  T_48_META_API_92_P1_D: "Название новой команды",
  T_48_META_API_92_P2_D: "успех или неудача",
  T_48_META_API_94_D: "Установить значение локальной переменной по индексу; перед установкой переменная должна быть определена в текущем процессе вызова",
  T_48_META_API_94_P0: "Индекс",
  T_48_META_API_94_P0_D: "Получить переменную по индексу",
  T_48_META_API_94_P1: "Значение переменной",
  T_48_META_API_94_P1_D: "Целевое значение переменной",
  T_48_META_API_94_P2: "Арифметический тип",
  T_48_META_API_94_P2_D: "Метод операции; все типы поддерживают присваивание, а числовые типы также поддерживают операции увеличения, уменьшения, умножения, деления и модуля.",
  T_48_META_API_94_P3: "Имя переменной",
  T_48_META_API_94_P3_D: "Имя целевой переменной. Используется только для вывода ошибок",
  T_48_META_API_95: "Получить локальную переменную по индексу",
  T_48_META_API_95_D: "Получить значение локальной переменной; перед получением переменная должна быть определена в текущем процессе вызова",
  T_48_META_API_95_P0: "Индекс",
  T_48_META_API_95_P0_D: "Переменный индекс",
  T_48_META_API_95_P1: "Имя переменной",
  T_48_META_API_95_P1_D: "Имя целевой переменной. Используется только для вывода ошибок",
  T_48_META_API_9500_D: "Эффекты воспроизведения на стороне клиента, которые уведомляют целевой плеер",
  T_48_META_API_9500_P0_D: "целевой игрок",
  T_48_META_API_9500_P1_D: "Путь к ресурсам специальных эффектов",
  T_48_META_API_9500_P2_D: "цвет",
  T_48_META_API_9500_P3_D: "Размер масштаба, по умолчанию 1",
  T_48_META_API_9500_P4_D: "Связанный объект, к которому добавляются эффекты в качестве его дочерних узлов",
  T_48_META_API_9500_P5_D: "Смещение в мировых координатах относительно связанного объекта",
  T_48_META_API_9501_D: "Уведомление клиента целевого игрока о необходимости воспроизвести звуковой эффект",
  T_48_META_API_9501_P0_D: "целевой игрок",
  T_48_META_API_9501_P1_D: "Тип звукового эффекта",
  T_48_META_API_9502_D: "Уведомить клиента целевого игрока о необходимости отображения плавающих символов",
  T_48_META_API_9502_P0_D: "целевой игрок",
  T_48_META_API_9502_P1_D: 'Содержание слова "поплавок',
  T_48_META_API_9502_P2_D: "Цвет плавающего символа, цвет типа",
  T_48_META_API_9502_P3_D: "Длительность плавающего слова в миллисекундах",
  T_48_META_API_9503_D: "Заставьте целевую единицу один раз сыграть выражение действия Emote",
  T_48_META_API_9503_P0_D: "Цели игры Emote",
  T_48_META_API_9503_P1_D: "Тип эмоций",
  T_48_META_API_9504_D: "Приостановить/возобновить выражение движения эмоций юнита",
  T_48_META_API_9504_P0_D: "Приостановить/возобновить выполнение целей Эмоте",
  T_48_META_API_9504_P1_D: "True: приостановить воспроизведение, False: возобновить воспроизведение",
  T_48_META_EVT_1_D: "Срабатывает в начале игры, сервер будет готов за некоторое время до того, как клиент",
  T_48_META_EVT_10_D: "Срабатывает до того, как текущая сущность получит урон",
  T_48_META_EVT_10_P0_D: "Атакующая сущность, возможно, null",
  T_48_META_EVT_10_P1_D: "Тип повреждения",
  T_48_META_EVT_10_P2_D: "Количество нанесенного ущерба",
  T_48_META_EVT_10_P3_D: "раненая часть",
  T_48_META_EVT_1000_D: "Срабатывает при изменении очков игрока",
  T_48_META_EVT_1000_P0_D: "Игроки, у которых изменилось количество очков",
  T_48_META_EVT_1000_P1_D: "Типы точек изменения",
  T_48_META_EVT_1000_P2_D: "Интегральное значение после изменения интеграла",
  T_48_META_EVT_1001_D: "Срабатывает при изменении очков команды",
  T_48_META_EVT_1001_P0_D: "Команды, у которых изменилось количество очков",
  T_48_META_EVT_1001_P1_D: "Типы точек изменения",
  T_48_META_EVT_1001_P2_D: "Интегральное значение после изменения интеграла",
  T_48_META_EVT_1002_D: "Срабатывает при изменении рейтинга игрока",
  T_48_META_EVT_1002_P0_D: "Игроки с измененным рейтингом",
  T_48_META_EVT_1002_P1_D: "Рейтинг после изменения рейтинга",
  T_48_META_EVT_1003_D: "заброшенный",
  T_48_META_EVT_1003_P0_D: "заброшенный",
  T_48_META_EVT_1003_P1_D: "Рейтинг после изменения рейтинга",
  T_48_META_EVT_11_D: "Срабатывает, когда игрок выходит из игры в середине матча",
  T_48_META_EVT_11_P0_D: "Выбывшие игроки",
  T_48_META_EVT_12_D: "Срабатывает, когда контроллер игрока касается объекта, и срабатывает только тогда, когда контроллер активно перемещается",
  T_48_META_EVT_12_P0_D: "Встреченные объекты",
  T_48_META_EVT_13_D: "Срабатывает до того, как текущая сущность нанесет урон",
  T_48_META_EVT_13_P0_D: "Субъекты, которым был нанесен ущерб",
  T_48_META_EVT_13_P1_D: "Тип повреждения",
  T_48_META_EVT_13_P2_D: "Количество нанесенного ущерба",
  T_48_META_EVT_13_P3_D: "раненая часть",
  T_48_META_EVT_14_D: "Это событие срабатывает при каждом цикле воспроизводимой сущности, только если воспроизводимая сущность - это звук, эффект и т.д.",
  T_48_META_EVT_2_D: "Срабатывает при обновлении логического фрейма; в зависимости от платформы и настроек частота этого события может меняться.",
  T_48_META_EVT_2002_D: "Срабатывает при смерти игрока",
  T_48_META_EVT_2002_P0_D: "Мертвые игроки",
  T_48_META_EVT_2003_D: "Срабатывает при передачах игрока",
  T_48_META_EVT_2003_P0_D: "Игроки с передачами",
  T_48_META_EVT_2003_P1_D: "Убитые игроки",
  T_48_META_EVT_2004_D: "Срабатывает, когда игрок наносит урон",
  T_48_META_EVT_2004_P0_D: "Игрок, который нанес урон",
  T_48_META_EVT_2004_P1_D: "поврежденный плеер",
  T_48_META_EVT_2004_P2_D: "Тип повреждения",
  T_48_META_EVT_2004_P3_D: "количество повреждений",
  T_48_META_EVT_2004_P4_D: "раненая часть",
  T_48_META_EVT_2005_D: "Срабатывает, когда игрок совершает убийство",
  T_48_META_EVT_2005_P0_D: "игрок, совершивший наезд",
  T_48_META_EVT_2005_P1_D: "Убитые игроки",
  T_48_META_EVT_2005_P2_D: "Тип повреждения",
  T_48_META_EVT_2006_D: "Срабатывает, когда игрок присоединяется к игре",
  T_48_META_EVT_2006_P0_D: "Игроки присоединяются к игре",
  T_48_META_EVT_2007_D: "Срабатывает, когда игрок возрождается",
  T_48_META_EVT_2007_P0_D: "Воскрешенные игроки",
  T_48_META_EVT_2007_P1_D: "Источники о воскресении",
  T_48_META_EVT_2008_D: "Срабатывает, когда игрок сбит с ног",
  T_48_META_EVT_2008_P0_D: "Нокаутированный игрок",
  T_48_META_EVT_2008_P1_D: "агрессор",
  T_48_META_EVT_2009_D: "Срабатывает, когда игрок отключается от сети",
  T_48_META_EVT_2009_P0_D: "Отключенные игроки",
  T_48_META_EVT_2010_D: "Срабатывает при повторном подключении игрока",
  T_48_META_EVT_2010_P0_D: "Воссоединенные игроки",
  T_48_META_EVT_2100_D: "Срабатывает, когда команда удаляется",
  T_48_META_EVT_2100_P0_D: "Удаленные команды",
  T_48_META_EVT_2101_D: "Срабатывает при добавлении команды",
  T_48_META_EVT_2101_P0_D: "Добавлены команды",
  T_48_META_EVT_2102_D: "Срабатывает, когда команда уничтожается группой",
  T_48_META_EVT_2102_P0_D: "Команда, которая была уничтожена",
  T_48_META_EVT_3_D: "Срабатывает в конце игры и перед ее завершением на сервере",
  T_48_META_EVT_30_D: "Срабатывает при успешной загрузке сцены",
  T_48_META_EVT_30_P0_D: "название сцены",
  T_48_META_EVT_3000_D: "Срабатывает после создания текущей сущности",
  T_48_META_EVT_3001_D: "Срабатывает перед уничтожением текущей сущности",
  T_48_META_EVT_3002_D: "Срабатывает, когда игрок входит в триггер",
  T_48_META_EVT_3002_P0_D: "Игроки вступают в игру",
  T_48_META_EVT_3003_D: "Срабатывает, когда игрок покидает триггер",
  T_48_META_EVT_3003_P0_D: "Игроки, покидающие триггер",
  T_48_META_EVT_3004_D: "Срабатывает после нажатия на элемент управления кнопкой пользовательского интерфейса",
  T_48_META_EVT_3004_P0_D: "Кликающие игроки",
  T_48_META_EVT_3005_D: "Срабатывает при нажатии на кнопку во встроенном пользовательском интерфейсе",
  T_48_META_EVT_3005_P0_D: "Имя элемента управления кнопкой, на которую нужно нажать",
  T_48_META_EVT_3006_D: "Срабатывает, когда игрок использует водные лыжи",
  T_48_META_EVT_3007_D: "Срабатывает после того, как текущая сущность становится доступной",
  T_48_META_EVT_3008_D: "Срабатывает после того, как текущая сущность становится недоступной",
  T_48_META_EVT_3009_D: "Срабатывает, когда сущность входит в триггер. Когда срабатывает событие триггера, обе стороны получают событие. Одна сторона должна быть жестким телом, а другая сторона должна быть триггером. В частности, когда триггер является пользовательским объектом триггера, только триггер получит событие.",
  T_48_META_EVT_3009_P0_D: "Противостоящая организация на момент наступления события",
  T_48_META_EVT_3010_D: "Срабатывает, когда сущность покидает триггер. Когда событие срабатывает, обе стороны получают событие. Одна сторона должна быть жестким телом, а другая сторона должна быть триггером. В частности, когда триггер является пользовательским объектом триггера, только триггер получит событие.",
  T_48_META_EVT_3010_P0_D: "Противостоящая организация на момент наступления события",
  T_48_META_EVT_3011_D: "Срабатывает, когда текущая сущность уничтожается",
  T_48_META_EVT_3011_P0_D: "Атакующая сущность, возможно, null",
  T_48_META_EVT_3011_P1_D: "Тип повреждения",
  T_48_META_EVT_3011_P2_D: "раненая часть",
  T_48_META_EVT_3012_D: "Срабатывает после того, как текущая сущность подвергается нападению",
  T_48_META_EVT_3012_P0_D: "Атакующая сущность, возможно, null",
  T_48_META_EVT_3012_P1_D: "Тип повреждения",
  T_48_META_EVT_3012_P2_D: "Количество нанесенного ущерба",
  T_48_META_EVT_3012_P3_D: "раненая часть",
  T_48_META_EVT_3013_D: "Срабатывает после того, как текущее существо наносит урон",
  T_48_META_EVT_3013_P0_D: "Субъекты, которым был нанесен ущерб",
  T_48_META_EVT_3013_P1_D: "Тип повреждения",
  T_48_META_EVT_3013_P2_D: "Количество нанесенного ущерба",
  T_48_META_EVT_3013_P3_D: "раненая часть",
  T_48_META_EVT_3014_D: "Срабатывает после того, как текущая сущность уничтожает другую сущность",
  T_48_META_EVT_3014_P0_D: "Элиминированные предприятия",
  T_48_META_EVT_3014_P1_D: "раненая часть",
  T_48_META_EVT_3015_D: "Срабатывает, когда этот игрок воскресает",
  T_48_META_EVT_3015_P0_D: "Тип игрока Источник воскрешения",
  T_48_META_EVT_3016_D: "Срабатывает, когда генератор генерирует сущность",
  T_48_META_EVT_3016_P0_D: "Список созданных сущностей",
  T_48_META_EVT_3016_P1_D: "волновое число",
  T_48_META_EVT_3017_D: "Вызывается, когда игрок переходит в положение колена для нокаута",
  T_48_META_EVT_3018_D: "Срабатывает, когда все члены команды мертвы",
  T_48_META_EVT_3019_D: "Срабатывает при использовании шлема, бронежилета или рюкзака.",
  T_48_META_EVT_3019_P0_D: "Идентификатор оборудования",
  T_48_META_EVT_3020_D: "Срабатывает при удержании основного, дополнительного оружия или оружия ближнего боя, в том числе при переключении на кулак",
  T_48_META_EVT_3020_P0_D: "Оружие, экипированное на момент срабатывания",
  T_48_META_EVT_3021_D: "Срабатывает после использования реквизита; реквизиты, требующие времени для использования, вызывают это событие после завершения использования.",
  T_48_META_EVT_3021_P0_D: "Идентификатор реквизита",
  T_48_META_EVT_3021_P1_D: "Реквизит сущности, возможно, null",
  T_48_META_EVT_3021_P2_D: "Новая сущность реквизита, созданная с помощью реквизита, может быть пустой",
  T_48_META_EVT_3022_D: "Срабатывает при приобретении предмета",
  T_48_META_EVT_3022_P0_D: "Тип изделия",
  T_48_META_EVT_3022_P1_D: "Объект сущности, возможно, null",
  T_48_META_EVT_3023_D: "Срабатывает при изменении точек сущности",
  T_48_META_EVT_3023_P0_D: "Типы точек изменения",
  T_48_META_EVT_3023_P1_D: "Интегральное значение после изменения интеграла",
  T_48_META_EVT_3024_D: "Срабатывает при изменении рейтинга сущности",
  T_48_META_EVT_3024_P0_D: "Рейтинг после изменения рейтинга",
  T_48_META_EVT_3025_D: "Срабатывает при получении ассиста",
  T_48_META_EVT_3025_P0_D: "попасть на",
  T_48_META_EVT_3026_D: "Срабатывает, когда объект входит в транспортное средство, в том числе в качестве водителя и пассажира",
  T_48_META_EVT_3026_P0_D: "Субъекты, входящие в состав перевозчика",
  T_48_META_EVT_3026_P1_D: "Перевозчики вошли",
  T_48_META_EVT_3027_D: "Срабатывает, когда объект покидает носитель",
  T_48_META_EVT_3027_P0_D: "Организации, покидающие перевозчика",
  T_48_META_EVT_3027_P1_D: "Уходящие перевозчики",
  T_48_META_EVT_3028_D: "Срабатывает при физическом управлении перевозчиком, при нахождении в автомобиле в качестве водителя",
  T_48_META_EVT_3028_P0_D: "Организация, управляющая перевозчиком",
  T_48_META_EVT_3028_P1_D: "Управляемые автомобили",
  T_48_META_EVT_3029_D: "Срабатывает при физическом входе на носитель",
  T_48_META_EVT_3029_P0_D: "инициирующий субъект",
  T_48_META_EVT_3030_D: "Срабатывает, когда носитель уходит",
  T_48_META_EVT_3030_P0_D: "инициирующий субъект",
  T_48_META_EVT_3031_D: "Срабатывает, когда транспортным средством управляет субъект",
  T_48_META_EVT_3031_P0_D: "инициирующий субъект",
  T_48_META_EVT_3032_D: "Срабатывает после телепортации, когда существо использует портал (устарело, используйте OnBouncesOffTire).",
  T_48_META_EVT_3032_P0_D: "Организации, использующие портал",
  T_48_META_EVT_3032_P1_D: "Используемый портал",
  T_48_META_EVT_3033_D: "Срабатывает, когда объект отскакивает",
  T_48_META_EVT_3033_P0_D: "инициирующий субъект",
  T_48_META_EVT_3033_P1_D: "Использование прыгающих предметов",
  T_48_META_EVT_3034_D: "Срабатывает после того, как портал позволяет сущности телепортироваться",
  T_48_META_EVT_3034_P0_D: "передающая организация",
  T_48_META_EVT_3035_D: "Срабатывает после того, как шина отскакивает от объекта",
  T_48_META_EVT_3035_P0_D: "всплывающее устройство",
  T_48_META_EVT_3036_D: "Срабатывает, когда машина посылает объект, совершающий полет",
  T_48_META_EVT_3036_P0_D: "объект, который отбрасывается",
  T_48_META_EVT_3036_P1_D: "сгенерированный машиной объект",
  T_48_META_EVT_3037_D: "Срабатывает, когда объект входит в триггер",
  T_48_META_EVT_3037_P0_D: "Повод для входа",
  T_48_META_EVT_3038_D: "Срабатывает, когда объект покидает триггер",
  T_48_META_EVT_3038_P0_D: "Побуждение к отъезду",
  T_48_META_EVT_3039_D: "Срабатывает при приобретении оружейной сущности",
  T_48_META_EVT_3039_P0_D: "оружейная организация",
  T_48_META_EVT_3040_D: "Срабатывает, когда объект сбивается машиной.",
  T_48_META_EVT_3040_P0_D: "объект, который отбрасывается",
  T_48_META_EVT_3040_P1_D: "сгенерированный машиной объект",
  T_48_META_EVT_3041_D: "Срабатывает при нацеливании на объект, на который можно нацелиться",
  T_48_META_EVT_3041_P0_D: "Целевые организации",
  T_48_META_EVT_3042_D: "Срабатывает, когда игрок становится целью",
  T_48_META_EVT_3042_P0_D: "Прицеливание игроков",
  T_48_META_EVT_3043_D: "Срабатывает, когда пуля попадает в цель",
  T_48_META_EVT_3043_P0_D: "попасть на",
  T_48_META_EVT_3043_P1_D: "Мировые координаты мест попадания пуль",
  T_48_META_EVT_3044_D: "Срабатывает при попадании оружия",
  T_48_META_EVT_3044_P0_D: "оружие",
  T_48_META_EVT_3044_P1_D: "Мировые координаты зоны поражения",
  T_48_META_EVT_3045_D: "Срабатывает, когда игрок решает превратиться в объект для этого уровня",
  T_48_META_EVT_3045_P0_D: "Игрок превращается в сущность, а не в сам объект сцены",
  T_48_META_EVT_3046_D: "Срабатывает, когда игрок воскресает в этой точке воскрешения",
  T_48_META_EVT_3046_P0_D: "Игроки, воскрешенные в этой точке воскрешения",
  T_48_META_EVT_3047_D: "Срабатывает, когда игрок выбрасывает оружие",
  T_48_META_EVT_3047_P0_D: "Выброшенные сущности оружия",
  T_48_META_EVT_3048_D: "Срабатывает, когда игрок выбрасывает предмет, отличный от оружия",
  T_48_META_EVT_3048_P0_D: "Тип изделия",
  T_48_META_EVT_3048_P1_D: "Объект сущности, возможно, null",
  T_48_META_EVT_3049_D: "Срабатывает при попадании футбольного мяча.",
  T_48_META_EVT_3049_P0_D: "игрок",
  T_48_META_EVT_3049_P1_D: "Скорость после удара",
  T_48_META_EVT_3050_D: "Срабатывает при столкновении футбольного мяча с твердым покрытием",
  T_48_META_EVT_3050_P0_D: "объект столкновения",
  T_48_META_EVT_3050_P1_D: "Скорость после столкновения",
  T_48_META_EVT_3051_D: "Срабатывает, когда игрок успешно присоединяется к голосовому каналу",
  T_48_META_EVT_3051_P0_D: "объект голосового канала",
  T_48_META_EVT_3052_D: "Срабатывает, когда игроку не удается присоединиться к голосовому каналу",
  T_48_META_EVT_3052_P0_D: "объект голосового канала",
  T_48_META_EVT_3053_D: "Срабатывает, когда игрок выходит из голосового канала",
  T_48_META_EVT_3053_P0_D: "объект голосового канала",
  T_48_META_EVT_3054_D: "Срабатывает, когда мяч входит в ворота",
  T_48_META_EVT_3054_P0_D: "ворота",
  T_48_META_EVT_3054_P1_D: "Забивающий игрок, последний игрок, коснувшийся мяча перед тем, как попасть в ворота",
  T_48_META_EVT_3054_P2_D: "Ассистенты - предпоследние игроки, коснувшиеся мяча перед забитым голом",
  T_48_META_EVT_3055_D: "Срабатывает, когда игрок нажимает кнопку огня",
  T_48_META_EVT_3056_D: "Срабатывает, когда игрок прыгает",
  T_48_META_EVT_3057_D: "Срабатывает, когда игрок приседает",
  T_48_META_EVT_3058_D: "Срабатывает, когда игрок падает.",
  T_48_META_EVT_3059_D: "Срабатывает, когда игрок делает спринт",
  T_48_META_EVT_3060_D: "Срабатывает, когда предмет успешно куплен в магазине",
  T_48_META_EVT_3060_P0_D: "Игроки, которые покупают товары",
  T_48_META_EVT_3060_P1_D: "товары",
  T_48_META_EVT_3061_D: "Срабатывает, когда игрок экипирует оружие.",
  T_48_META_EVT_3061_P0_D: "Игроки с оружием",
  T_48_META_EVT_3062_D: "Срабатывает, когда юнит убит этим оружием",
  T_48_META_EVT_3062_P0_D: "Убитые существа",
  T_48_META_EVT_3063_D: "Срабатывает при использовании этого оружия для нанесения урона юниту",
  T_48_META_EVT_3063_P0_D: "пострадавший субъект",
  T_48_META_EVT_3063_P1_D: "количество повреждений",
  T_48_META_EVT_3064_D: "Срабатывает, когда оружие меняет пули.",
  T_48_META_EVT_3065_D: "Срабатывает, когда субъект въезжает на территорию перевозчика в качестве водителя или пассажира",
  T_48_META_EVT_3065_P0_D: "Перевозчики вошли",
  T_48_META_EVT_3066_D: "Срабатывает, когда объект покидает носитель",
  T_48_META_EVT_3066_P0_D: "Уходящие перевозчики",
  T_48_META_EVT_3067_D: "Срабатывает при физическом перемещении носителя",
  T_48_META_EVT_3067_P0_D: "Управляемые автомобили",
  T_48_META_EVT_3068_D: "Срабатывает после телепортации, когда существо использует портал",
  T_48_META_EVT_3068_P0_D: "Используемый портал",
  T_48_META_EVT_3069_D: "Срабатывает, когда объект отскакивает от шины",
  T_48_META_EVT_3069_P0_D: "Используемые шины",
  T_48_META_EVT_3070_D: "Срабатывает, когда объект сбивается машиной.",
  T_48_META_EVT_3070_P0_D: "сгенерированный машиной объект",
  T_48_META_EVT_3071_D: "Срабатывает после нажатия игроком кнопки управления пользовательским интерфейсом",
  T_48_META_EVT_3071_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3072_D: "Срабатывает при поднятии элемента управления кнопкой пользовательского интерфейса",
  T_48_META_EVT_3072_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3073_D: "Срабатывает после двойного нажатия игроком кнопки управления пользовательским интерфейсом",
  T_48_META_EVT_3073_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3074_D: "Начало зоны джейлбрейка",
  T_48_META_EVT_3075_D: "Зона побега из тюрьмы закрыта",
  T_48_META_EVT_3076_D: "Срабатывает, когда игрок перестает использовать водные лыжи",
  T_48_META_EVT_3077_D: "Срабатывает, когда текстовое содержимое элемента управления UI input box изменяется игроком",
  T_48_META_EVT_3077_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3077_P1_D: "Изменение содержания текста",
  T_48_META_EVT_3078_D: "Срабатывает, когда играющий объект начинает играть",
  T_48_META_EVT_3078_P0_D: "играбельное существо",
  T_48_META_EVT_3079_D: "Это событие срабатывает, когда воспроизводимая сущность заканчивает воспроизведение. Это событие работает на стороне клиента, только если воспроизводимая сущность - это звук, эффект и т.д.",
  T_48_META_EVT_3079_P0_D: "играбельное существо",
  T_48_META_EVT_3080_D: "Срабатывает, когда играющий объект продолжает играть",
  T_48_META_EVT_3080_P0_D: "играбельное существо",
  T_48_META_EVT_3081_D: "Срабатывает, когда воспроизводимый объект приостанавливает воспроизведение",
  T_48_META_EVT_3081_P0_D: "играбельное существо",
  T_48_META_EVT_3082_D: "Игроки с побегом из тюрьмы присоединяются",
  T_48_META_EVT_3082_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3083_D: "Игроки с побегом из тюрьмы уходят",
  T_48_META_EVT_3083_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3084_D: "Срабатывает по окончании обратного отсчета",
  T_48_META_EVT_3084_P0_D: "аффилированная организация",
  T_48_META_EVT_3085_D: "Срабатывает, когда предмет взят в руки",
  T_48_META_EVT_3085_P0_D: "Игрок, подобравший предмет",
  T_48_META_EVT_3086_D: "Срабатывает, когда предмет выбрасывается",
  T_48_META_EVT_3086_P0_D: "Игрок, который уронил предмет",
  T_48_META_EVT_3087_D: "Срабатывает, когда этот предмет экипирован",
  T_48_META_EVT_3088_D: "Срабатывает при запуске объекта после создания шахты",
  T_48_META_EVT_3089_D: "Срабатывает, когда объект срабатывает после создания шахты",
  T_48_META_EVT_3089_P0_D: "Нацеливание на объекты после создания шахты",
  T_48_META_EVT_3090_D: "Срабатывает перед покупкой товара в магазине",
  T_48_META_EVT_3090_P0_D: "Игроки, которые покупают товары",
  T_48_META_EVT_3090_P1_D: "товары",
  T_48_META_EVT_3091_D: "Срабатывает при использовании данного устройства",
  T_48_META_EVT_3092_D: "Срабатывает при выстреле из пистолета с крючковым замком",
  T_48_META_EVT_3093_D: "Срабатывает, когда снаряд взрывается после броска.",
  T_48_META_EVT_3093_P0_D: "точка взрыва",
  T_48_META_EVT_3094_D: "Срабатывает при попадании пейнтбольного ружья",
  T_48_META_EVT_3094_P0_D: "Предметы для краскопульта",
  T_48_META_EVT_3094_P1_D: "хит-пойнт",
  T_48_META_EVT_3094_P2_D: "попасть в цель",
  T_48_META_EVT_3095_D: "Срабатывает при ударе краскопультом",
  T_48_META_EVT_3095_P0_D: "объект поражения",
  T_48_META_EVT_3095_P1_D: "хит-пойнт",
  T_48_META_EVT_3095_P2_D: "попасть в цель",
  T_48_META_EVT_3096_D: "Срабатывает при взрыве носителя или ведра с красителем",
  T_48_META_EVT_3096_P0_D: "Игрок, вызвавший взрыв",
  T_48_META_EVT_3096_P1_D: "Список игроков, пострадавших от взрыва",
  T_48_META_EVT_3097_D: "Срабатывает, когда оружие прекращает стрельбу",
  T_48_META_EVT_3097_P0_D: "Текущая емкость магазина на момент прекращения огня",
  T_48_META_EVT_3098_D: "Срабатывает, когда преследуемая цель входит в зону преследования",
  T_48_META_EVT_3099_D: "Срабатывает, когда преследуемая цель покидает зону преследования",
  T_48_META_EVT_31_D: "Срабатывает при успешном переключении сцены",
  T_48_META_EVT_31_P0_D: "название сцены",
  T_48_META_EVT_3100_D: "Срабатывает, когда цель атаки входит в зону действия атаки",
  T_48_META_EVT_3101_D: "Срабатывает, когда цель атаки выходит за пределы досягаемости.",
  T_48_META_EVT_3102_D: "Срабатывает, когда обнаружение лучей камеры запускается событием щелчка клиента.",
  T_48_META_EVT_3102_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3102_P1_D: "Попадает ли луч камеры в объект",
  T_48_META_EVT_3102_P2_D: "Позиция попадания луча камеры",
  T_48_META_EVT_3102_P3_D: "Ориентация камеры клиента",
  T_48_META_EVT_3102_P4_D: "Положение камеры клиента",
  T_48_META_EVT_3102_P5_D: "попасть в цель",
  T_48_META_EVT_3103_D: "Срабатывает при открытии экрана магазина",
  T_48_META_EVT_3103_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3104_D: "Срабатывает при закрытии экрана магазина",
  T_48_META_EVT_3104_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3105_D: "Срабатывает, когда логика дерева поведения входит в узел",
  T_48_META_EVT_3105_P0_D: "Имя узла",
  T_48_META_EVT_3105_P1_D: "аффилированная организация",
  T_48_META_EVT_3106_D: "Срабатывает, когда логика дерева поведения выходит из узла",
  T_48_META_EVT_3106_P0_D: "Имя узла",
  T_48_META_EVT_3106_P1_D: "аффилированная организация",
  T_48_META_EVT_3107_D: "Срабатывает при пробуждении жесткого тела",
  T_48_META_EVT_3108_D: "Срабатывает, когда жесткое тело переходит в спящий режим",
  T_48_META_EVT_3109_D: "Срабатывает, когда игрок перемещается",
  T_48_META_EVT_3109_P0_D: "увертюры",
  T_48_META_EVT_3110_D: "Срабатывает, когда плеер находится в режиме ожидания",
  T_48_META_EVT_3110_P0_D: "увертюры",
  T_48_META_EVT_3111_D: "Срабатывает, когда игрок использует навык",
  T_48_META_EVT_3111_P0_D: "Используемые навыки",
  T_48_META_EVT_3112_D: "Срабатывает, когда игрок заканчивает спринт",
  T_48_META_EVT_3113_D: "Срабатывает, когда приобретается элемент, соответствующий слоту в перечислении SwitchEquipSlot.",
  T_48_META_EVT_3113_P0_D: "Приобретенные объекты",
  T_48_META_EVT_3114_D: "Срабатывает при переключении ручных предметов, в том числе при переключении на кулаки",
  T_48_META_EVT_3114_P0_D: "Объекты, удерживаемые после переключения",
  T_48_META_EVT_3115_D: "Срабатывает, когда игрок в магазине просит кого-нибудь купить предмет",
  T_48_META_EVT_3115_P0_D: "Игроки, запрашивающие атрибутику",
  T_48_META_EVT_3115_P1_D: "товары",
  T_48_META_EVT_3116_D: "Срабатывает, когда игрок в магазине запрашивает предмет у другого игрока и запрос принимается.",
  T_48_META_EVT_3116_P0_D: "Помощь приобретенным игрокам",
  T_48_META_EVT_3116_P1_D: "Игроки просят помочь им с покупками",
  T_48_META_EVT_3116_P2_D: "товары",
  T_48_META_EVT_3117_D: "Срабатывает при обновлении кадров с фиксированной частотой 30 раз в секунду",
  T_48_META_EVT_3118_D: "Срабатывает после вызова API Pause Game",
  T_48_META_EVT_3119_D: "Срабатывает после вызова API Restore Game",
  T_48_META_EVT_3120_D: "Срабатывает, когда игрок добавляет или удаляет друга",
  T_48_META_EVT_3121_D: "Срабатывает при получении сообщения Persona",
  T_48_META_EVT_3121_P0_D: "Информационное наполнение",
  T_48_META_EVT_3121_P1_D: "Персона отправителя",
  T_48_META_EVT_3122_D: "Срабатывает в конце прыжка игрока",
  T_48_META_EVT_3123_D: "Срабатывает при падении игрока",
  T_48_META_EVT_3124_D: "Срабатывает в конце падения игрока",
  T_48_META_EVT_3125_D: "Срабатывает при получении поведения персоны",
  T_48_META_EVT_3125_P0_D: "поведение",
  T_48_META_EVT_3125_P1_D: "Персона отправителя",
  T_48_META_EVT_3126_D: "Срабатывает при изменении информации о пользователе",
  T_48_META_EVT_3126_P0_D: "Изменение статуса участника",
  T_48_META_EVT_3127_D: "Срабатывает при входе в Центр участника",
  T_48_META_EVT_3128_D: "Срабатывает при выходе из Центра участника",
  T_48_META_EVT_3129_D: "Срабатывает, когда игрок входит в состояние нокдауна",
  T_48_META_EVT_3129_P0_D: "Атакующая сущность, возможно, null",
  T_48_META_EVT_3130_D: "Срабатывает при получении статуса персоны",
  T_48_META_EVT_3130_P0_D: "Персона отправителя",
  T_48_META_EVT_3130_P1_D: "код ошибки",
  T_48_META_EVT_3131_D: "Срабатывает при отправке сообщения Persona через пользовательский интерфейс",
  T_48_META_EVT_3131_P0_D: "Информационное наполнение",
  T_48_META_EVT_3131_P1_D: "Персона отправителя",
  T_48_META_EVT_3132_D: "Срабатывает в конце получения персоны",
  T_48_META_EVT_3132_P0_D: "Персона отправителя",
  T_48_META_EVT_3132_P1_D: "код ошибки",
  T_48_META_EVT_32_D: "Срабатывает, когда игрок переключает сцену",
  T_48_META_EVT_32_P0_D: "название сцены",
  T_48_META_EVT_3200_D: "Срабатывает, когда анимационный клип заканчивает воспроизведение",
  T_48_META_EVT_3200_P0_D: "Название анимированного сегмента",
  T_48_META_EVT_3201_D: "Срабатывает, когда состояние анимации завершает воспроизведение",
  T_48_META_EVT_3201_P0_D: "Название состояния анимации",
  T_48_META_EVT_3204_D: "Срабатывает при изменении состояния элемента управления Toggle.",
  T_48_META_EVT_3204_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3204_P1_D: "положение дел",
  T_48_META_EVT_3260_D: "Срабатывает, когда игрок нажимает на сенсорную панель.",
  T_48_META_EVT_3260_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3260_P1_D: "Положение пресса",
  T_48_META_EVT_3261_D: "Срабатывает при поднятии сенсорной панели.",
  T_48_META_EVT_3261_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3261_P1_D: "Положение подъема",
  T_48_META_EVT_3262_D: "Срабатывает, когда сенсорная панель начинает скользить.",
  T_48_META_EVT_3262_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3262_P1_D: "Стартовая позиция слайда",
  T_48_META_EVT_3263_D: "Срабатывает при скольжении тачпада, это событие запускается один раз за кадр во время скольжения",
  T_48_META_EVT_3263_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3263_P1_D: "Стартовая позиция слайда",
  T_48_META_EVT_3263_P2_D: "перемещение",
  T_48_META_EVT_3264_D: "Срабатывает в конце скольжения сенсорной панели",
  T_48_META_EVT_3264_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3264_P1_D: "Положение торцевой горки",
  T_48_META_EVT_3265_D: "Срабатывает при нажатии на JoyStick",
  T_48_META_EVT_3265_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3266_D: "Срабатывает при поднятии JoyStick",
  T_48_META_EVT_3266_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3267_D: "Срабатывает при использовании джойстика JoyStick",
  T_48_META_EVT_3267_P0_D: "триггерный проигрыватель",
  T_48_META_EVT_3267_P1_D: "Выходное смещение",
  T_48_META_EVT_3268_D: "Срабатывает, когда игрок встает из другой позиции.",
  T_48_META_EVT_3268_P0_D: "Стойка игрока перед тем, как встать",
  T_48_META_EVT_3269_D: "Срабатывает при выстреле из оружия",
  T_48_META_EVT_4_D: "Срабатывает в начале каждого хода",
  T_48_META_EVT_4_P0_D: "Круглый индекс, отсчитываемый от 0",
  T_48_META_EVT_5_D: "Срабатывает в конце каждого хода",
  T_48_META_EVT_5_P0_D: "Круглый индекс, отсчитываемый от 0",
  T_48_META_EVT_6_D: "Срабатывает при столкновении объекта, поддерживается только объектами, у которых установлен компонент Rigid Body.",
  T_48_META_EVT_6_P0_D: "Встреченные объекты",
  T_48_META_EVT_7_D: "Срабатывает в начале каждой фазы",
  T_48_META_EVT_7_P0_D: "ступенчатая структура",
  T_48_META_EVT_8_D: "Срабатывает в конце каждой фазы",
  T_48_META_EVT_8_P0_D: "ступенчатая структура",
  T_48_META_EVT_9_D: "Срабатывает в конце столкновения сущностей, поддерживается только сущностями, на которых установлен компонент Rigid Body.",
  T_48_META_EVT_9_P0_D: "Встреченные объекты",
  T_49_META_TYP_10_I1_D: "Список тегов",
  T_49_META_TYP_10_I2_D: "Доступен ли он сам по себе",
  T_49_META_TYP_10_I3_D: "Доступен ли он во всех родителях",
  T_49_META_TYP_10_I4_D: "Доступна ли она в сцене",
  T_49_META_TYP_10_I5_D: "Включено ли логическое обновление, если оно выключено, скрипт на этой сущности перестает обновляться каждый кадр",
  T_49_META_TYP_10_I6_D: "Имя сущности",
  T_49_META_TYP_10_I7_D: "Параметры фильтрации региона, 0 для автоматического расчета контролируемого или нет, 1 для неконтролируемого всегда синхронизированного, 2 для контролируемого",
  T_49_META_TYP_100_I0_D: "Установка диапазона срабатывания",
  T_49_META_TYP_100_I1_D: "Видимость модели",
  T_49_META_TYP_101_I0_D: "Игрок",
  T_49_META_TYP_101_I1_D: "ID Целевого Элемента",
  T_49_META_TYP_101_I2_D: "Вращение Цели",
  T_49_META_TYP_101_I3_D: "Масштаб Цели",
  T_49_META_TYP_1010_I1_D: "Длительность тайминга в секундах",
  T_49_META_TYP_1010_I2_D: "Время начала тайминга, в секундах игрового момента",
  T_49_META_TYP_1010_I3_D: "Тип обновления таймера, см. `EUITimeUpdateType`, на выбор: статический, по таймеру, обратный отсчет.",
  T_49_META_TYP_1010_I4_D: "Позиция отображения, если есть цель для следования, это смещение относительно начала цели, если цели для следования нет, это координаты экрана.",
  T_49_META_TYP_1011_I10_D: "Название иконки",
  T_49_META_TYP_1011_I2_D: "Цвет темы",
  T_49_META_TYP_1011_I3_D: "Включать ли локализованное отображение",
  T_49_META_TYP_1011_I4_D: "Название",
  T_49_META_TYP_1011_I5_D: "Описание",
  T_49_META_TYP_1011_I6_D: "Имя ресурса иконки",
  T_49_META_TYP_1011_I7_D: "Максимум прогресса",
  T_49_META_TYP_1011_I8_D: "Текущий прогресс",
  T_49_META_TYP_1011_I9_D: "Иконка прогресса",
  T_49_META_TYP_1012_I1_D: "Включить или отключить локализацию",
  T_49_META_TYP_1012_I2_D: "Текст подсчета раундов",
  T_49_META_TYP_1012_I3_D: "Параметры ключа раунда",
  T_49_META_TYP_1012_I5_D: "Цвет слева",
  T_49_META_TYP_1012_I6_D: "Цвет справа",
  T_49_META_TYP_1013_I2_D: "Текст подсчета раундов",
  T_49_META_TYP_1013_I3_D: "Параметры ключа раунда",
  T_49_META_TYP_1014_I2_D: "Заголовок первого балла Текст",
  T_49_META_TYP_1014_I3_D: "Первый балл",
  T_49_META_TYP_1014_I4_D: "Параметры первого счета",
  T_49_META_TYP_1014_I5_D: "Текст заголовка второго балла",
  T_49_META_TYP_1014_I6_D: "Значение второго счета",
  T_49_META_TYP_1014_I7_D: "Параметры второго счета",
  T_49_META_TYP_1016_I1_D: "Отображение соответствующего статуса в зависимости от значения, Победа (1), Поражение (2), Ничья (3), Буйство (4)",
  T_49_META_TYP_1016_I2_D: "Показывать, если счет двух команд верен, в противном случае скрыт",
  T_49_META_TYP_1016_I3_D: "Счет левой команды",
  T_49_META_TYP_1016_I4_D: "Счет правой команды",
  T_49_META_TYP_1016_I5_D: "Дата окончания этапа",
  T_49_META_TYP_1017_I1_D: "Название левой команды",
  T_49_META_TYP_1017_I2_D: "Описание слева",
  T_49_META_TYP_1017_I3_D: "Название правой команды",
  T_49_META_TYP_1017_I4_D: "Описание справа",
  T_49_META_TYP_1018_I1_D: "Номер раунда",
  T_49_META_TYP_1018_I4_D: "Счет левой команды",
  T_49_META_TYP_1018_I6_D: "Счет правой команды",
  T_49_META_TYP_1019_I1_D: "1 2 3 для победы/поражения/ничьей",
  T_49_META_TYP_102_I0_D: "Тип источника воскрешения, игрок воскресает после смерти",
  T_49_META_TYP_102_I1_D: "Тип источника воскрешения, игрок воскресает из состояния падения.",
  T_49_META_TYP_1020_I2_D: "Текстовый ключ для отображения",
  T_49_META_TYP_1020_I3_D: "Массив параметров, соответствующих текстовому ключу",
  T_49_META_TYP_1021_I1_D: "Базовое время в секундах",
  T_49_META_TYP_1021_I2_D: "Продолжительность в секундах",
  T_49_META_TYP_1021_I3_D: "Позиция отображения, если есть цель для следования, это смещение начала цели, если цели для следования нет, это координаты экрана, по умолчанию Vector3(0).",
  T_49_META_TYP_1022_I2_D: "ключ отображаемого текста",
  T_49_META_TYP_1022_I3_D: "Массив параметров, соответствующих текстовой клавише",
  T_49_META_TYP_1023_I1_D: "отображать счет команды, если он истинный, в противном случае он будет выключен.",
  T_49_META_TYP_1023_I4_D: "Если статус команды истинный, то отображается, иначе будет закрыт.",
  T_49_META_TYP_1023_I5_D: "Массив статусов левого игрока, 0: жив, 1: мертв, 2: упал.",
  T_49_META_TYP_1023_I6_D: "Массив состояний правого игрока, 0: жив, 1: мертв, 2: упал.",
  T_49_META_TYP_1023_I7_D: "Количество флагов слева",
  T_49_META_TYP_1023_I8_D: "Количество флажков у правого игрока",
  T_49_META_TYP_1024_I2_D: "Смещение",
  T_49_META_TYP_1024_I3_D: "Рейтинг",
  T_49_META_TYP_1024_I4_D: "Цвет команды",
  T_49_META_TYP_1024_I5_D: "Название иконки",
  T_49_META_TYP_1024_I6_D: "Отображается, если border равен true, в противном случае выключается.",
  T_49_META_TYP_1024_I7_D: "Ключ текста счета",
  T_49_META_TYP_1024_I8_D: "Параметры ключа текста счета",
  T_49_META_TYP_1028_I1_D: "Количество живых игроков слева",
  T_49_META_TYP_1028_I2_D: "Количество живых игроков справа",
  T_49_META_TYP_1028_I3_D: "Цвет фона слева",
  T_49_META_TYP_1028_I4_D: "Цвет фона справа",
  T_49_META_TYP_1028_I5_D: "Название иконки слева",
  T_49_META_TYP_1028_I6_D: "Название иконки справа",
  T_49_META_TYP_1029_I1_D: "Название иконки",
  T_49_META_TYP_1029_I2_D: "Название фоновой иконки",
  T_49_META_TYP_103_I0_D: "Основное оружие A",
  T_49_META_TYP_103_I1_D: "Основное оружие B",
  T_49_META_TYP_103_I10_D: "Замораживающая бомба",
  T_49_META_TYP_103_I11_D: "Ледяная стена",
  T_49_META_TYP_103_I12_D: "Минное поле",
  T_49_META_TYP_103_I13_D: "Автоматическая турель",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Скейтборды, камуфляж ....",
  T_49_META_TYP_103_I2_D: "SecondaryWeapon",
  T_49_META_TYP_103_I3_D: "Взрывное оружие",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Количество живых игроков слева",
  T_49_META_TYP_1030_I4_D: "Количество живых игроков справа",
  T_49_META_TYP_1030_I5_D: "Название значка левой команды",
  T_49_META_TYP_1030_I6_D: "Название иконки правой команды",
  T_49_META_TYP_1031_I2_D: "Описание сообщения",
  T_49_META_TYP_1031_I3_D: "Время начала обратного отсчета, в секундах",
  T_49_META_TYP_1031_I4_D: "Параметры описания подсказки",
  T_49_META_TYP_1032_I1_D: "Тип подсказки",
  T_49_META_TYP_1032_I3_D: "Параметры информации подсказки",
  T_49_META_TYP_1033_I1_D: "Фаза переключения, 0 - текущий раунд, 1 - начало следующего раунда.",
  T_49_META_TYP_1033_I10_D: "Текст подсказки о поражении, по умолчанию не заполняется",
  T_49_META_TYP_1033_I11_D: "Заголовок дохода за раунд",
  T_49_META_TYP_1033_I12_D: "Доход за раунд",
  T_49_META_TYP_1033_I13_D: "Заголовки детализации дохода за раунд",
  T_49_META_TYP_1033_I14_D: "Подробный список значений выручки за раунд, соответствующий по очереди вышеуказанному списку названий деталей",
  T_49_META_TYP_1033_I15_D: "MVP Прозвище игрока",
  T_49_META_TYP_1033_I16_D: "Индекс следующего раунда",
  T_49_META_TYP_1033_I17_D: "Является ли это решающим раундом",
  T_49_META_TYP_1033_I18_D: "Является ли это последним раундом",
  T_49_META_TYP_1033_I6_D: "Название значка левой команды",
  T_49_META_TYP_1033_I7_D: "Название значка правой команды",
  T_49_META_TYP_1033_I8_D: "В зависимости от значения будет отображаться соответствующий статус, Победа (1), Поражение (2).",
  T_49_META_TYP_1033_I9_D: 'Текст подсказки "Победа", по умолчанию, если не заполнен',
  T_49_META_TYP_1036_I1_D: "Указывает, сколько всего уровней в игре",
  T_49_META_TYP_1036_I2_D: "Указывает текущий уровень бота",
  T_49_META_TYP_1037_I1_D: "Указывает, сколько очков отображается",
  T_49_META_TYP_1039_I3_D: "Временная метка начала обратного отсчета, в секундах",
  T_49_META_TYP_104_I0_D: "Стиль A",
  T_49_META_TYP_104_I1_D: "Стиль B",
  T_49_META_TYP_104_I2_D: "Стиль C",
  T_49_META_TYP_1040_I10_D: "Описания карточек",
  T_49_META_TYP_1040_I11_D: "Индекс выбранного элемента, начиная с 0, меньше 0 означает невыбранный.",
  T_49_META_TYP_1040_I12_D: "Названия кнопок",
  T_49_META_TYP_1040_I13_D: "Цвета кнопок",
  T_49_META_TYP_1040_I2_D: "Ключ обратного отсчета",
  T_49_META_TYP_1040_I3_D: "Время обратного отсчета",
  T_49_META_TYP_1040_I4_D: "Ключ описания",
  T_49_META_TYP_1040_I5_D: "Массив параметров Description",
  T_49_META_TYP_1040_I6_D: "Фон карточек",
  T_49_META_TYP_1040_I7_D: "Цвет фона карточек",
  T_49_META_TYP_1040_I8_D: "Иконки карточек",
  T_49_META_TYP_1040_I9_D: "Названия карточек",
  T_49_META_TYP_1041_I2_D: "Позиция",
  T_49_META_TYP_1041_I3_D: "Иконка",
  T_49_META_TYP_1041_I4_D: "Ярлык",
  T_49_META_TYP_1041_I5_D: "Цвет фона",
  T_49_META_TYP_1042_I1_D: "Локальная позиция",
  T_49_META_TYP_1043_I4_D: "Цвет",
  T_49_META_TYP_1043_I5_D: "Ключ ярлыка",
  T_49_META_TYP_1043_I6_D: "Параметры ярлыка",
  T_49_META_TYP_1045_I2_D: "Иконка кнопки",
  T_49_META_TYP_1045_I3_D: "Цвет иконки",
  T_49_META_TYP_1045_I4_D: "Размер, одинаковый по ширине и высоте",
  T_49_META_TYP_1045_I5_D: "Положение относительно якоря в правом нижнем углу",
  T_49_META_TYP_1045_I6_D: "Количество зарядов, меньше 0 означает скрытый",
  T_49_META_TYP_1045_I7_D: "Время начала CD, в миллисекундах",
  T_49_META_TYP_1045_I8_D: "Длительность CD, в миллисекундах",
  T_49_META_TYP_1045_I9_D: "True - кнопка будет выделена серым цветом, False - восстановлена.",
  T_49_META_TYP_106_I1_D: "Включить",
  T_49_META_TYP_106_I2_D: "Отключить",
  T_49_META_TYP_109_I0_D: "ID Канала Чата",
  T_49_META_TYP_109_I1_D: "Список Игроков",
  T_49_META_TYP_11_I0_D: "Находится ли текущая игра в незаконном состоянии, если она находится в незаконном состоянии, это означает, что игра потеряла ценность противостояния, и рекомендуется завершить игру напрямую.",
  T_49_META_TYP_11_I1_D: "Длительность текущей игры, в миллисекундах.",
  T_49_META_TYP_11_I10_D: "Нужно ли сбрасывать снаряжение каждый ход",
  T_49_META_TYP_11_I11_D: 'Включать или нет механику "Ядовитое кольцо',
  T_49_META_TYP_11_I12_D: "Размер безопасной зоны",
  T_49_META_TYP_11_I13_D: "Время начала сужения",
  T_49_META_TYP_11_I14_D: "Продолжительность сужения",
  T_49_META_TYP_11_I15_D: "Урон вне зоны",
  T_49_META_TYP_11_I18_D: "Тип оживления",
  T_49_META_TYP_11_I2_D: "Индекс текущего хода, по этому значению вы можете получить сущность текущего хода.",
  T_49_META_TYP_11_I27_D: "Общее количество раундов",
  T_49_META_TYP_11_I3_D: "Индекс текущей стадии, по этому значению вы можете получить сущность текущей стадии.",
  T_49_META_TYP_11_I32_D: "Количество монет, получаемых в начале раунда",
  T_49_META_TYP_11_I33_D: "Количество монет за убийства",
  T_49_META_TYP_11_I34_D: "Количество монет, получаемых при победе",
  T_49_META_TYP_11_I35_D: "Отображать ли пользовательский интерфейс кошелька",
  T_49_META_TYP_11_I36_D: "Сущность Skybox",
  T_49_META_TYP_11_I37_D: "Суммарный пробег кадров с начала игры",
  T_49_META_TYP_11_I38_D: "Могу двигаться",
  T_49_META_TYP_11_I39_D: "Можно ли настраивать поселение",
  T_49_META_TYP_11_I4_D: "ID шаблона предустановленного режима UGC",
  T_49_META_TYP_11_I40_D: "Разрешить ли вступление в игру в середине игры",
  T_49_META_TYP_11_I41_D: "Включить режим низкой частоты кадров, игра будет работать с частотой 15FPS, в противном случае 30FPS",
  T_49_META_TYP_11_I42_D: "Логический интервал обновления кадров между двумя обновлениями игрового сервера",
  T_49_META_TYP_11_I43_D: "Фиксированный интервал обновления кадров в миллисекундах",
  T_49_META_TYP_11_I5_D: "Отключить воскрешение игроков, если выключено",
  T_49_META_TYP_11_I6_D: "Отключить воскрешение ботов, если выключено",
  T_49_META_TYP_11_I7_D: "Длительность воскрешения в секундах",
  T_49_META_TYP_11_I8_D: "Общее количество команд в игре",
  T_49_META_TYP_11_I9_D: "Количество членов в каждой команде",
  T_49_META_TYP_110_I0_D: "Канал A",
  T_49_META_TYP_110_I1_D: "Канал B",
  T_49_META_TYP_110_I2_D: "Канал C",
  T_49_META_TYP_110_I3_D: "Канал D",
  T_49_META_TYP_110_I4_D: "Канал E",
  T_49_META_TYP_110_I5_D: "Канал F",
  T_49_META_TYP_111_I1_D: "Спринт",
  T_49_META_TYP_111_I2_D: "Атака",
  T_49_META_TYP_111_I3_D: "Прыжок",
  T_49_META_TYP_111_I4_D: "Перепрыгнуть",
  T_49_META_TYP_111_I5_D: "Вождение",
  T_49_META_TYP_111_I6_D: "Войти в транспорт",
  T_49_META_TYP_111_I7_D: "Выйти из транспорта",
  T_49_META_TYP_111_I8_D: "Управление транспортом",
  T_49_META_TYP_112_I0_D: "Включить",
  T_49_META_TYP_112_I1_D: "Отключить",
  T_49_META_TYP_112_I2_D: "Невидимость",
  T_49_META_TYP_117_I0_D: "Аплодисменты",
  T_49_META_TYP_117_I1_D: "Закрытые тарелки",
  T_49_META_TYP_117_I2_D: "Удар",
  T_49_META_TYP_117_I3_D: "Открытые тарелки",
  T_49_META_TYP_117_I4_D: "Райд",
  T_49_META_TYP_117_I5_D: "Малые барабаны",
  T_49_META_TYP_118_I0_D: "Все ли члены лагеря находятся при смерти",
  T_49_META_TYP_118_I1_D: "Список всех членов команды",
  T_49_META_TYP_118_I2_D: "Союзные Фракции",
  T_49_META_TYP_118_I3_D: "Враждебные фракции",
  T_49_META_TYP_118_I4_D: "Показывать ли название пользовательского интерфейса",
  T_49_META_TYP_118_I5_D: "Показывать ли информацию о карте",
  T_49_META_TYP_118_I6_D: "Показывать или нет",
  T_49_META_TYP_118_I7_D: "Показывать или нет",
  T_49_META_TYP_118_I8_D: "Все участники",
  T_49_META_TYP_118_I9_D: "Показывать Быстрое Сообщение",
  T_49_META_TYP_119_I0_D: "Да",
  T_49_META_TYP_119_I1_D: "Нет",
  T_49_META_TYP_120_I1_D: "Целевая сущность для следования, по умолчанию пусто",
  T_49_META_TYP_120_I2_D: "Цвет пользовательского интерфейса",
  T_49_META_TYP_120_I3_D: "Длина пользовательского интерфейса",
  T_49_META_TYP_120_I4_D: "Текущее значение прогресса, от 0 до 1.0",
  T_49_META_TYP_120_I5_D: "Позиция отображения, когда есть цель для следования, это смещение относительно начала цели, когда нет цели для следования, это экранная координата, по умолчанию Vector3(0)",
  T_49_META_TYP_121_I0_D: "3с",
  T_49_META_TYP_121_I1_D: "5с",
  T_49_META_TYP_121_I2_D: "10с",
  T_49_META_TYP_121_I3_D: "15с",
  T_49_META_TYP_121_I4_D: "30с",
  T_49_META_TYP_121_I5_D: "9999с",
  T_49_META_TYP_122_I0_D: "Ресурс скайбокса",
  T_49_META_TYP_122_I1_D: "Светлый цвет",
  T_49_META_TYP_122_I10_D: "GUID субсцены",
  T_49_META_TYP_122_I11_D: "Переключатель функции тумана",
  T_49_META_TYP_122_I12_D: "Режим эффекта тумана",
  T_49_META_TYP_122_I13_D: "Экспоненциальная плотность тумана",
  T_49_META_TYP_122_I14_D: "Начальное расстояние линейного тумана",
  T_49_META_TYP_122_I15_D: "Конечное расстояние линейного тумана",
  T_49_META_TYP_122_I16_D: "Включение функции эффекта тумана",
  T_49_META_TYP_122_I17_D: "Угол поворота основного источника света",
  T_49_META_TYP_122_I18_D: "Включите функцию угла поворота основного источника света",
  T_49_META_TYP_122_I2_D: "Интенсивность света",
  T_49_META_TYP_122_I3_D: "Тьма",
  T_49_META_TYP_122_I4_D: "Сила тени",
  T_49_META_TYP_122_I5_D: "Влажность местности",
  T_49_META_TYP_122_I6_D: "Блик объектива",
  T_49_META_TYP_122_I7_D: "Цвет тумана",
  T_49_META_TYP_122_I8_D: "Окружающий цвет",
  T_49_META_TYP_123_I0_D: "День",
  T_49_META_TYP_123_I1_D: "Ночь",
  T_49_META_TYP_123_I2_D: "Сумерки",
  T_49_META_TYP_123_I3_D: "Вид на город",
  T_49_META_TYP_123_I4_D: "Цветное Небо",
  T_49_META_TYP_123_I5_D: "Морозная луна",
  T_49_META_TYP_124_I0_D: "Ближняя дистанция",
  T_49_META_TYP_124_I1_D: "Средняя дальность",
  T_49_META_TYP_124_I2_D: "Дальняя дистанция",
  T_49_META_TYP_125_I0_D: "Диффузия цвета",
  T_49_META_TYP_125_I2_D: "Диффузная текстура",
  T_49_META_TYP_125_I4_D: "Диффуз Альфа",
  T_49_META_TYP_126_I1_D: "Название",
  T_49_META_TYP_126_I2_D: "Текущее значение прогресса",
  T_49_META_TYP_126_I3_D: "Максимальное значение прогресса",
  T_49_META_TYP_126_I4_D: "Экранная координата, по умолчанию - Vector3(0).",
  T_49_META_TYP_126_I5_D: "Длина прогресс-бара, по умолчанию - длина UI на префабе.",
  T_49_META_TYP_127_I0_D: "Панорамирование вдоль оси, можно комбинировать по трем осям",
  T_49_META_TYP_127_I1_D: "Поворот вдоль оси, можно комбинировать с тремя осями",
  T_49_META_TYP_127_I2_D: "Масштабирование вдоль оси, можно комбинировать с тремя осями",
  T_49_META_TYP_128_I0_D: "Кусты",
  T_49_META_TYP_128_I1_D: "Тыква",
  T_49_META_TYP_128_I2_D: "Чучело",
  T_49_META_TYP_128_I3_D: "Шкаф",
  T_49_META_TYP_129_I0_D: "Случайный лут",
  T_49_META_TYP_129_I1_D: "Патроны AR",
  T_49_META_TYP_129_I2_D: "Патроны ПП",
  T_49_META_TYP_129_I3_D: "Патроны SN",
  T_49_META_TYP_129_I4_D: "Патроны HG",
  T_49_META_TYP_129_I5_D: "SG Пули",
  T_49_META_TYP_129_I6_D: "Патроны для лука",
  T_49_META_TYP_13_I1_D: "Координаты якоря относительно родительского узла.",
  T_49_META_TYP_13_I10_D: "Разница в размерах рамок виджета и якоря",
  T_49_META_TYP_13_I11_D: "Центр поворота",
  T_49_META_TYP_13_I12_D: "Глубина",
  T_49_META_TYP_13_I14_D: "Порядок расположения всех дочерних элементов в одном родительском узле",
  T_49_META_TYP_13_I15_D: "ID родителя",
  T_49_META_TYP_13_I16_D: "Уникальный идентификатор",
  T_49_META_TYP_13_I17_D: "Приоритет",
  T_49_META_TYP_13_I18_D: "Фактическое положение",
  T_49_META_TYP_13_I2_D: "Ширина",
  T_49_META_TYP_13_I4_D: "Угол поворота по оси Z",
  T_49_META_TYP_13_I6_D: "Внутренний идентификатор элемента управления в префабе",
  T_49_META_TYP_13_I7_D: "Сущность пользовательского интерфейса, в которой он находится",
  T_49_META_TYP_13_I8_D: "Минимальное значение якоря",
  T_49_META_TYP_13_I9_D: "Максимальное значение якоря",
  T_49_META_TYP_130_I0_D: "Случайный расходный лут",
  T_49_META_TYP_130_I1_D: "Аптечка",
  T_49_META_TYP_130_I2_D: "Ремонтный комплект",
  T_49_META_TYP_130_I3_D: "Горизалин",
  T_49_META_TYP_130_I4_D: "Противогаз",
  T_49_META_TYP_131_I0_D: "Случайный лут с брони",
  T_49_META_TYP_131_I1_D: "Броня первого уровня",
  T_49_META_TYP_131_I2_D: "Вторичная броня",
  T_49_META_TYP_131_I3_D: "Броня третьего уровня",
  T_49_META_TYP_132_I0_D: "Случайный предмет для метания",
  T_49_META_TYP_132_I1_D: "Граната",
  T_49_META_TYP_132_I4_D: "Заморозка",
  T_49_META_TYP_133_I0_D: "Случайный множитель лута",
  T_49_META_TYP_133_I1_D: "2x прицел",
  T_49_META_TYP_133_I2_D: "4x прицел",
  T_49_META_TYP_133_I3_D: "Термальный прицел",
  T_49_META_TYP_134_I0_D: "Случайная добыча оружия",
  T_49_META_TYP_134_I5_D: "Дробовик",
  T_49_META_TYP_134_I8_D: "Футбольное оружие",
  T_49_META_TYP_135_I0_D: "Очки награбленных патронов",
  T_49_META_TYP_136_I0_D: "Очки расходных материалов",
  T_49_META_TYP_137_I0_D: "Очки расходных материалов",
  T_49_META_TYP_138_I0_D: "Очки множителя лута",
  T_49_META_TYP_139_I0_D: "Очки разграбленной брони",
  T_49_META_TYP_14_I0_D: "Текущий уровень крови игрока",
  T_49_META_TYP_14_I1_D: "Текущий максимальный уровень крови игрока",
  T_49_META_TYP_14_I11_D: "Стан игрока",
  T_49_META_TYP_14_I12_D: "Множитель урона игрока, например, 2x настроен как 2.0",
  T_49_META_TYP_14_I13_D: "Использует тот же скелет, что и мужской или женский персонаж, 0 означает отсутствие замены модели",
  T_49_META_TYP_14_I14_D: "Не конфликтует с существующим масштабированием скорости",
  T_49_META_TYP_14_I15_D: "Не конфликтует с существующим масштабированием высоты прыжка",
  T_49_META_TYP_14_I16_D: "Личность,0 Нормальный игрок,1 Охотник,2 Матричный зомби,3 Нормальный зомби,4 Эволюционировавший зомби 1-го, 5 Эволюционировавший зомби 2-го, 6 Эволюционировавший зомби 3-го типа",
  T_49_META_TYP_14_I17_D: "Уровень зомби, 1~3",
  T_49_META_TYP_14_I19_D: "Прозвище игрока",
  T_49_META_TYP_14_I2_D: "Определить, является ли текущий игрок игроком AI, AI обычно является NPC или PVE-монстром.",
  T_49_META_TYP_14_I20_D: "Процент нанесенного урона при получении урона, может быть уменьшен или увеличен",
  T_49_META_TYP_14_I21_D: "Текущий EP игрока",
  T_49_META_TYP_14_I22_D: "Максимальное количество EP игрока",
  T_49_META_TYP_14_I23_D: "Основное оружие, находящееся в руке",
  T_49_META_TYP_14_I24_D: "Падает при уничтожении",
  T_49_META_TYP_14_I26_D: "Тип Помощи при Целеполагании",
  T_49_META_TYP_14_I27_D: "Разрешить блокировку при помощи прицела",
  T_49_META_TYP_14_I28_D: "Включить/выключить голосовой чат: true - выключить голос, false - включить голос",
  T_49_META_TYP_14_I29_D: "Переключение быстрого чата: trueЗакрыть голос, falseОткрыть голос",
  T_49_META_TYP_14_I3_D: "Статус игрока",
  T_49_META_TYP_14_I30_D: "Канал",
  T_49_META_TYP_14_I35_D: "Переключение подбора: trueНе может подбирать, falseМожет подбирать",
  T_49_META_TYP_14_I36_D: "Переключить выброс предметов: trueНе выбрасывать, falseМожно выбрасывать",
  T_49_META_TYP_14_I37_D: "Целевые объекты для атаки",
  T_49_META_TYP_14_I38_D: "Дружественные игроки",
  T_49_META_TYP_14_I39_D: "Фракция",
  T_49_META_TYP_14_I4_D: "Время выживания игрока, если игрок умрет, время будет пересчитано.",
  T_49_META_TYP_14_I40_D: "Номер во фракции",
  T_49_META_TYP_14_I41_D: "Камера, которую использует игрок",
  T_49_META_TYP_14_I42_D: "Индивидуальная Гравитация",
  T_49_META_TYP_14_I43_D: "Шлем",
  T_49_META_TYP_14_I44_D: "Жилет",
  T_49_META_TYP_14_I5_D: "Непобедимость игрока",
  T_49_META_TYP_14_I52_D: "UID пользователя",
  T_49_META_TYP_14_I53_D: "Уменьшение урона при хэдшота",
  T_49_META_TYP_14_I54_D: "AVATAR, к которому привязан игрок",
  T_49_META_TYP_14_I55_D: "Пол",
  T_49_META_TYP_14_I56_D: "Идентификаторы скинов оружия",
  T_49_META_TYP_14_I57_D: "Точка рождения игрока",
  T_49_META_TYP_14_I58_D: "Точка воскрешения игрока, если не записаны контрольные точки, то используется точка рождения, в противном случае используются контрольные точки",
  T_49_META_TYP_14_I59_D: "Текущая позиция игрока",
  T_49_META_TYP_14_I6_D: "Сущность команды, к которой принадлежит игрок",
  T_49_META_TYP_14_I60_D: "Текущая ориентация игрока",
  T_49_META_TYP_14_I61_D: "Узел, используемый для доступа к скелету с кожей",
  T_49_META_TYP_14_I62_D: "Рюкзак",
  T_49_META_TYP_14_I63_D: "Временные щиты",
  T_49_META_TYP_14_I64_D: "ID обшивки транспортного средства",
  T_49_META_TYP_14_I65_D: "Пропустить анимацию падения",
  T_49_META_TYP_14_I66_D: "Отключить урон при падении",
  T_49_META_TYP_14_I67_D: "Текущий ручной предмет",
  T_49_META_TYP_14_I68_D: "Список запрещенных предметов",
  T_49_META_TYP_14_I69_D: "Идентификатор ресурса игрока",
  T_49_META_TYP_14_I7_D: "ID текущей контрольной точки",
  T_49_META_TYP_14_I70_D: 'Цель, которой было отправлено сообщение "Запрос на покупку".',
  T_49_META_TYP_14_I71_D: "Идентификатор ресурса играющего в данный момент эмоута",
  T_49_META_TYP_14_I72_D: "Зациклен ли играющий в данный момент эмоут",
  T_49_META_TYP_14_I73_D: "Обработка статуса нокдауна",
  T_49_META_TYP_14_I74_D: "Включать ли пропуск урона, по умолчанию True, что означает, что он включен",
  T_49_META_TYP_14_I76_D: "Выходить ли из игры в середине игры",
  T_49_META_TYP_14_I77_D: "Информация об одежде, которая будет сохраняться при трансформации игрока в других персонажей",
  T_49_META_TYP_14_I8_D: "ID контрольной точки, к которой движется цель.",
  T_49_META_TYP_140_I0_D: "Волна 1",
  T_49_META_TYP_140_I1_D: "Волна 2",
  T_49_META_TYP_140_I2_D: "Волна 3",
  T_49_META_TYP_140_I3_D: "Непрерывный",
  T_49_META_TYP_141_I0_D: "Случайный лут на футболе",
  T_49_META_TYP_141_I1_D: "Футбольный щит",
  T_49_META_TYP_141_I2_D: "Крио-граната",
  T_49_META_TYP_142_I0_D: "Лут футбол",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (стрельба)",
  T_49_META_TYP_147_I1_D: "От третьего лица",
  T_49_META_TYP_147_I2_D: "От первого лица (стрельба)",
  T_49_META_TYP_147_I3_D: "Вид сверху",
  T_49_META_TYP_147_I4_D: "Горизонтальная прокрутка",
  T_49_META_TYP_147_I5_D: "Пользовательская",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Свободно перемещающаяся камера, управляемая игроком",
  T_49_META_TYP_147_I8_D: "Новая версия камеры с видом от первого лица",
  T_49_META_TYP_148_I0_D: "Несколько предустановленных типов камер, а также пользовательские типы камер.",
  T_49_META_TYP_148_I1_D: "Поле зрения - это угол обзора камеры.",
  T_49_META_TYP_148_I10_D: "Тип анимации переключения камеры",
  T_49_META_TYP_148_I11_D: "Время перехода в миллисекундах для переключения на эту камеру, только если тип переключения - Плавный",
  T_49_META_TYP_148_I12_D: "Режим движения камеры при наличии окклюзии между камерой и целью, за которой она следит.",
  T_49_META_TYP_148_I13_D: "Как камера отображается на экране",
  T_49_META_TYP_148_I14_D: "Система опорных координат со смещением объекта",
  T_49_META_TYP_148_I15_D: "Система опорных координат со смещением объекта при наблюдении",
  T_49_META_TYP_148_I16_D: "Маска слоя рендеринга камеры, которая позволяет фильтровать отрисованные объекты камеры по уровню видимости",
  T_49_META_TYP_148_I17_D: "Ограничение угла обзора",
  T_49_META_TYP_148_I2_D: "Обычно обозначает смещение положения камеры относительно исходного положения игрока, имеет разные значения для разных типов камер.",
  T_49_META_TYP_148_I3_D: "Фокус камеры - это смещение точки фокусировки камеры от исходного положения игрока, которое зависит от типа камеры.",
  T_49_META_TYP_148_I4_D: "Угол поворота камеры в вертикальном направлении",
  T_49_META_TYP_148_I5_D: "Угол поворота камеры в горизонтальном направлении",
  T_49_META_TYP_148_I7_D: "Цель, за которой следит камера",
  T_49_META_TYP_148_I8_D: "Цель, на которую смотрит камера",
  T_49_META_TYP_148_I9_D: "Игрок, использующий камеру",
  T_49_META_TYP_15_I0_D: "Все ли игроки в команде мертвы на данный момент",
  T_49_META_TYP_15_I1_D: "Список всех игроков в команде",
  T_49_META_TYP_15_I3_D: "Список вражеских команд",
  T_49_META_TYP_15_I4_D: "Список дружественных команд",
  T_49_META_TYP_15_I5_D: "Номер команды",
  T_49_META_TYP_150_I0_D: "Прочность",
  T_49_META_TYP_150_I1_D: "Радиус полусфер на концах корпуса капсулы.",
  T_49_META_TYP_150_I2_D: "Фактор Урона",
  T_49_META_TYP_152_I1_D: "Индивидуальная Гравитация",
  T_49_META_TYP_152_I2_D: "Если нужно или не нужно показывать триггер, то True - показывать.",
  T_49_META_TYP_154_I0_D: "Не может быть двойным оружием",
  T_49_META_TYP_154_I1_D: "Можно использовать только в комбинации с одним и тем же оружием",
  T_49_META_TYP_154_I2_D: "Можно использовать в комбинации с другим оружием, а также с самим собой",
  T_49_META_TYP_155_I0_D: "Уровень",
  T_49_META_TYP_155_I1_D: "Максимальная прочность",
  T_49_META_TYP_155_I2_D: "Текущая прочность",
  T_49_META_TYP_155_I3_D: "Коэффициент снижения урона",
  T_49_META_TYP_155_I4_D: "Коэффициент снижения взрывного урона",
  T_49_META_TYP_155_I5_D: "Может тратить прочность",
  T_49_META_TYP_155_I6_D: "Можно уничтожить",
  T_49_META_TYP_156_I1_D: "Максимальная прочность",
  T_49_META_TYP_156_I2_D: "Текущая прочность",
  T_49_META_TYP_156_I3_D: "Коэффициент снижения урона",
  T_49_META_TYP_156_I4_D: "Коэффициент снижения взрывного урона",
  T_49_META_TYP_156_I5_D: "Может тратить прочность",
  T_49_META_TYP_156_I6_D: "Можно уничтожить",
  T_49_META_TYP_157_I0_D: "Нет анимации",
  T_49_META_TYP_157_I1_D: "Плавный",
  T_49_META_TYP_158_I2_D: "Перечисление типа якоря пользовательского интерфейса, по умолчанию значение 9 (центр)",
  T_49_META_TYP_158_I6_D: "Ключ ярлыка",
  T_49_META_TYP_158_I7_D: "Параметры ярлыка",
  T_49_META_TYP_158_I8_D: "Левая команда",
  T_49_META_TYP_16_I1_D: "Идентификатор предмета",
  T_49_META_TYP_16_I2_D: "Только для статической загрузки объектов, оцените, является ли это статической генерацией NavMesh.",
  T_49_META_TYP_16_I3_D: "Является ли это динамической блокировкой NavMesh или нет",
  T_49_META_TYP_16_I4_D: "Асинхронная загрузка",
  T_49_META_TYP_160_I0_D: "Кирпич A",
  T_49_META_TYP_160_I1_D: "Плитка A",
  T_49_META_TYP_160_I10_D: "Песок A",
  T_49_META_TYP_160_I11_D: "Снег A",
  T_49_META_TYP_160_I12_D: "Дерево A",
  T_49_META_TYP_160_I13_D: "Камень A",
  T_49_META_TYP_160_I14_D: "Лужайка B",
  T_49_META_TYP_160_I15_D: "Кирпич B",
  T_49_META_TYP_160_I16_D: "Кирпич C",
  T_49_META_TYP_160_I17_D: "Очистить",
  T_49_META_TYP_160_I2_D: "Плитка B",
  T_49_META_TYP_160_I3_D: "Плитка C",
  T_49_META_TYP_160_I4_D: "Бамбук A",
  T_49_META_TYP_160_I5_D: "Цемент A",
  T_49_META_TYP_160_I6_D: "Контейнер A",
  T_49_META_TYP_160_I7_D: "Лужайка A",
  T_49_META_TYP_160_I8_D: "Лёд A",
  T_49_META_TYP_160_I9_D: "Магма A",
  T_49_META_TYP_165_I0_D: "Включать ли столкновение",
  T_49_META_TYP_165_I1_D: "Действовать или нет в качестве триггера",
  T_49_META_TYP_165_I2_D: "Физические слои, настройка слоев в модуле физики, до 16.",
  T_49_META_TYP_166_I0_D: "Эмоут1",
  T_49_META_TYP_166_I1_D: "Эмоут2",
  T_49_META_TYP_166_I2_D: "Эмоте3",
  T_49_META_TYP_166_I3_D: "Эмоте4",
  T_49_META_TYP_166_I4_D: "Эмоут5",
  T_49_META_TYP_167_I0_D: "Тип текстуры эффекта",
  T_49_META_TYP_170_I0_D: "Видимый или нет, клиент прекращает отрисовку цели, если она не видна.",
  T_49_META_TYP_170_I1_D: "Уровень видимости, значение в диапазоне [0,15], влияет на видимость в камере.",
  T_49_META_TYP_171_I0_D: "Энергия",
  T_49_META_TYP_172_I0_D: "Количество пуль",
  T_49_META_TYP_173_I0_D: "Дополнительная вместимость рюкзака",
  T_49_META_TYP_173_I1_D: "Конфигурации кожи за пределами станции игрока имеют приоритет",
  T_49_META_TYP_173_I2_D: "ID скина рюкзака, конфигурация скина самого рюкзака.",
  T_49_META_TYP_174_I2_D: "Максимальный урон",
  T_49_META_TYP_174_I4_D: "Скорость броска",
  T_49_META_TYP_174_I5_D: "Задержка взрыва, в секундах",
  T_49_META_TYP_174_I6_D: "Коэффициент собственного урона",
  T_49_META_TYP_174_I7_D: "Коэффициент урона для товарищей",
  T_49_META_TYP_174_I8_D: "Коэффициент урона транспортным средствам",
  T_49_META_TYP_174_I9_D: "Скин",
  T_49_META_TYP_175_I0_D: "Радиус замороженной области",
  T_49_META_TYP_175_I1_D: "Длительность замороженной области в секундах",
  T_49_META_TYP_176_I0_D: "Основной тип оружия",
  T_49_META_TYP_176_I1_D: "Подтип оружия",
  T_49_META_TYP_177_I0_D: "Если между камерой и объектом, за которым нужно следовать, есть препятствие, камера не будет меняться.",
  T_49_META_TYP_177_I1_D: "Если между камерой и объектом, за которым нужно следовать, есть препятствие, камера будет приближена к объекту, за которым нужно следовать.",
  T_49_META_TYP_177_I2_D: "Если между камерой и объектом есть препятствие, оно становится полупрозрачным.",
  T_49_META_TYP_178_I0_D: "Когда камера наблюдает за объектом, ближний объект будет большим, а дальний - маленьким.",
  T_49_META_TYP_178_I1_D: "Ближние и дальние объекты имеют одинаковый размер, когда камера наблюдает за ними.",
  T_49_META_TYP_184_I0_D: "UUID ресурса, который будет отрисовываться.",
  T_49_META_TYP_185_I0_D: "Сетка модели, используемая для рендеринга",
  T_49_META_TYP_185_I1_D: "Список материалов, используемых для рендеринга",
  T_49_META_TYP_187_I0_D: "ID предмета",
  T_49_META_TYP_190_I0_D: "Статус открытия",
  T_49_META_TYP_190_I1_D: "Результат совпадения",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Победители MVP",
  T_49_META_TYP_190_I14_D: "Проигравшие MVP",
  T_49_META_TYP_190_I15_D: "Показать Детали Матча",
  T_49_META_TYP_190_I16_D: "Показать Оценку Карты",
  T_49_META_TYP_190_I17_D: "Показать Подарок",
  T_49_META_TYP_190_I18_D: "Показать Жалобу",
  T_49_META_TYP_190_I19_D: "Показать Повтор",
  T_49_META_TYP_190_I20_D: "Показать Поделиться",
  T_49_META_TYP_190_I21_D: "Показать Лобби",
  T_49_META_TYP_190_I22_D: "Показать Лайк",
  T_49_META_TYP_190_I23_D: "Показать Добавить Друга",
  T_49_META_TYP_190_I24_D: "Показать Экономику",
  T_49_META_TYP_190_I4_D: "Правая команда",
  T_49_META_TYP_190_I5_D: "Список титулов",
  T_49_META_TYP_190_I6_D: "Рейтинг Игрока",
  T_49_META_TYP_190_I9_D: "Титулы",
  T_49_META_TYP_191_I0_D: "Центральный радиус",
  T_49_META_TYP_191_I4_D: "Длительность вспышки в центре в миллисекундах",
  T_49_META_TYP_191_I5_D: "Длительность вспышки по краям в миллисекундах",
  T_49_META_TYP_191_I6_D: "Длительность эффекта",
  T_49_META_TYP_192_I3_D: "Длительность эффекта, в секундах",
  T_49_META_TYP_193_I1_D: "Название Матча Слева",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Победители MVP",
  T_49_META_TYP_193_I16_D: "Проигравшие MVP",
  T_49_META_TYP_193_I17_D: "Показать Детали Матча",
  T_49_META_TYP_193_I18_D: "Показать Оценку Карты",
  T_49_META_TYP_193_I19_D: "Показать Подарок",
  T_49_META_TYP_193_I2_D: "Название Матча Справа",
  T_49_META_TYP_193_I20_D: "Показать Жалобу",
  T_49_META_TYP_193_I21_D: "Показать Повтор",
  T_49_META_TYP_193_I22_D: "Показать Поделиться",
  T_49_META_TYP_193_I23_D: "Показать Лобби",
  T_49_META_TYP_193_I24_D: "Показать Лайк",
  T_49_META_TYP_193_I25_D: "Показать Добавить Друга",
  T_49_META_TYP_193_I26_D: "Показать Экономику",
  T_49_META_TYP_193_I3_D: "Результат матча",
  T_49_META_TYP_193_I4_D: "Рейтинг Команды",
  T_49_META_TYP_193_I5_D: "Рейтинг Игрока",
  T_49_META_TYP_193_I6_D: "Положение команды",
  T_49_META_TYP_193_I7_D: "Основное Название Очков",
  T_49_META_TYP_193_I8_D: "Основные Очки",
  T_49_META_TYP_193_I9_D: "Титулы",
  T_49_META_TYP_194_I0_D: "Время действия мины, в секундах",
  T_49_META_TYP_194_I1_D: "Радиус срабатывания",
  T_49_META_TYP_194_I2_D: "Время, необходимое для срабатывания мины в радиусе действия, в секундах",
  T_49_META_TYP_194_I3_D: "Может быть активирован самим",
  T_49_META_TYP_194_I4_D: "Может быть активирован командой",
  T_49_META_TYP_194_I5_D: "Может быть активировано транспортом",
  T_49_META_TYP_194_I6_D: "Длительность существования мины, которая автоматически взрывается по окончании действия, с момента ее падения, в секундах",
  T_49_META_TYP_194_I7_D: "Может быть атакован",
  T_49_META_TYP_194_I8_D: "Значение жизни",
  T_49_META_TYP_195_I0_D: "Один раз",
  T_49_META_TYP_195_I2_D: "Рецепт",
  T_49_META_TYP_197_I0_D: "Играет ли волна или нет",
  T_49_META_TYP_197_I1_D: "Бит флага",
  T_49_META_TYP_197_I2_D: "Если отмечен, то волна будет автоматически воспроизводиться при создании.",
  T_49_META_TYP_198_I0_D: "Идентификатор привязанности",
  T_49_META_TYP_199_I0_D: "Макс. энергия",
  T_49_META_TYP_199_I1_D: "Стоимость энергии",
  T_49_META_TYP_199_I10_D: "Коэффициент урона от падения",
  T_49_META_TYP_199_I11_D: "Текущая энергия",
  T_49_META_TYP_199_I2_D: "Стоимость энергии вверх",
  T_49_META_TYP_199_I3_D: "Стоимость энергии при спринте",
  T_49_META_TYP_199_I4_D: "Стоимость энергии при рывке",
  T_49_META_TYP_199_I5_D: "Базовая горизонтальная скорость",
  T_49_META_TYP_199_I6_D: "Скорость горизонтального спринта",
  T_49_META_TYP_199_I7_D: "Базовая вертикальная скорость",
  T_49_META_TYP_199_I8_D: "Вертикальная скорость спринта",
  T_49_META_TYP_199_I9_D: "Расстояние рывка",
  T_49_META_TYP_200_I0_D: "ID зоны",
  T_49_META_TYP_200_I1_D: "Идентификатор игры",
  T_49_META_TYP_201_I0_D: "Процент замедления: процент замедления скорости передвижения в открытой воде для водных объектов",
  T_49_META_TYP_203_I0_D: "целевая организация",
  T_49_META_TYP_203_I1_D: "ID Реквизита",
  T_49_META_TYP_203_I10_D: "Момент, когда игровой сервер начинает тикать",
  T_49_META_TYP_203_I11_D: "Начальное Значение",
  T_49_META_TYP_203_I12_D: "Конечное Значение",
  T_49_META_TYP_203_I13_D: "Процент прохождения",
  T_49_META_TYP_203_I4_D: "Стиль анимации",
  T_49_META_TYP_203_I6_D: "Продолжительность (с)",
  T_49_META_TYP_203_I7_D: "Обратный",
  T_49_META_TYP_203_I8_D: "Точки управления",
  T_49_META_TYP_203_I9_D: "Принудительная синхронизация с состоянием игрового сервера",
  T_49_META_TYP_204_I0_D: "Максимальная высота прыжка",
  T_49_META_TYP_204_I1_D: "Процент повреждений при падении",
  T_49_META_TYP_204_I2_D: "Восстановление энергии",
  T_49_META_TYP_204_I3_D: "Расход энергии",
  T_49_META_TYP_204_I4_D: "Максимальная энергия",
  T_49_META_TYP_205_I0_D: "Минимальная высота полета",
  T_49_META_TYP_205_I1_D: "Минимальная конечная высота",
  T_49_META_TYP_205_I2_D: "Скорость горизонтального полета",
  T_49_META_TYP_205_I3_D: "Скорость вертикального полета",
  T_49_META_TYP_205_I4_D: "Скорость падения",
  T_49_META_TYP_205_I5_D: "Скорость поворота",
  T_49_META_TYP_205_I6_D: "Максимальная высота полета",
  T_49_META_TYP_205_I7_D: "Скорость падения после превышения высоты",
  T_49_META_TYP_205_I8_D: "Изменение скорости Ускорение",
  T_49_META_TYP_206_I0_D: "Скорость",
  T_49_META_TYP_206_I1_D: "Ускорение",
  T_49_META_TYP_206_I10_D: "Максимальный угол поворота руля на высокой скорости",
  T_49_META_TYP_206_I11_D: "Интерполированная базовая скорость для угла поворота на высокой скорости",
  T_49_META_TYP_206_I2_D: "Скорость спринта",
  T_49_META_TYP_206_I3_D: "Продолжительность спринта, в секундах",
  T_49_META_TYP_206_I4_D: "Время задержки спринта, в секундах",
  T_49_META_TYP_206_I6_D: "Кд прыжка, в секундах",
  T_49_META_TYP_206_I7_D: "Кд спринта после катания на скейтборде, в секундах",
  T_49_META_TYP_206_I8_D: "Переключатель времени перезарядки после того как встал на буст",
  T_49_META_TYP_206_I9_D: "Кд заезда на борд, в секундах",
  T_49_META_TYP_207_I1_D: "Начальный индекс",
  T_49_META_TYP_207_I2_D: "Конечная Позиция",
  T_49_META_TYP_207_I3_D: "Идентификатор слайда",
  T_49_META_TYP_207_I4_D: "Идентификатор группы",
  T_49_META_TYP_207_I5_D: "Завершить или нет",
  T_49_META_TYP_21_I0_D: "Базовый уровень пользовательского интерфейса",
  T_49_META_TYP_210_I1_D: "Начальная скорость",
  T_49_META_TYP_210_I2_D: "Ускорение",
  T_49_META_TYP_210_I3_D: "Макс. смещение",
  T_49_META_TYP_210_I4_D: "Начальная Мировая Позиция",
  T_49_META_TYP_210_I5_D: "Принудительная синхронизация информации о положении игровым сервером",
  T_49_META_TYP_211_I0_D: "Локальные координаты",
  T_49_META_TYP_211_I1_D: "Позиция в мире",
  T_49_META_TYP_212_I0_D: "Сам",
  T_49_META_TYP_212_I2_D: "Координата смещения",
  T_49_META_TYP_213_I0_D: "Сам",
  T_49_META_TYP_213_I2_D: "Координата смещения",
  T_49_META_TYP_215_I0_D: "Победа",
  T_49_META_TYP_215_I1_D: "Поражение",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Ничья",
  T_49_META_TYP_218_I0_D: "Интенсивность",
  T_49_META_TYP_218_I1_D: "Диапазон",
  T_49_META_TYP_218_I2_D: "Цвет света",
  T_49_META_TYP_22_I0_D: "Отображается, если значение on равно true, в противном случае выключено",
  T_49_META_TYP_22_I1_D: "ID префаба",
  T_49_META_TYP_22_I2_D: "Идентификатор текущего самого большого элемента управления",
  T_49_META_TYP_22_I3_D: "Базовый уровень пользовательского интерфейса",
  T_49_META_TYP_22_I4_D: "Вид игрока",
  T_49_META_TYP_22_I5_D: "Позиция в мире",
  T_49_META_TYP_22_I6_D: "Находится ли он в сцене",
  T_49_META_TYP_22_I7_D: "Вращение в мировой системе координат",
  T_49_META_TYP_22_I8_D: "Масштаб в мировой системе координат",
  T_49_META_TYP_221_I0_D: "Задержка переключения передач, чем больше значение, тем медленнее скорость переключения передач",
  T_49_META_TYP_222_I0_D: "Задержка переключения передач, чем больше это значение, тем медленнее переключается передача.",
  T_49_META_TYP_225_I0_D: "Урон от турели",
  T_49_META_TYP_225_I1_D: "Интервал Урона (с)",
  T_49_META_TYP_225_I10_D: "Стрелять только под углом",
  T_49_META_TYP_225_I11_D: "Скорость снижения урона",
  T_49_META_TYP_225_I12_D: "Пробивная Способность Брони",
  T_49_META_TYP_225_I2_D: "Точность",
  T_49_META_TYP_225_I3_D: "Диапазон",
  T_49_META_TYP_225_I4_D: "Угловая Скорость",
  T_49_META_TYP_225_I5_D: "Угол Вверх",
  T_49_META_TYP_225_I6_D: "Угол Вниз",
  T_49_META_TYP_225_I7_D: "Макс. Здоровье",
  T_49_META_TYP_225_I8_D: "Время Жизни (с)",
  T_49_META_TYP_225_I9_D: "Макс. Количество Турелей",
  T_49_META_TYP_226_I0_D: "Значение текущего ресурса турели",
  T_49_META_TYP_226_I1_D: "Включить Атаку",
  T_49_META_TYP_227_I0_D: "Простой виджет",
  T_49_META_TYP_227_I1_D: "Виджет изображения",
  T_49_META_TYP_227_I10_D: "Виджет текстуры",
  T_49_META_TYP_227_I11_D: "Виджет профиля",
  T_49_META_TYP_227_I12_D: "Виджет переключателя",
  T_49_META_TYP_227_I13_D: "Виджет сенсорной панели",
  T_49_META_TYP_227_I14_D: "Виджет джойстика",
  T_49_META_TYP_227_I15_D: "Виджет социальных кнопок",
  T_49_META_TYP_227_I2_D: "Виджет метки",
  T_49_META_TYP_227_I3_D: "Виджет кнопки",
  T_49_META_TYP_227_I4_D: "Виджет ввода метки",
  T_49_META_TYP_227_I5_D: "Панель",
  T_49_META_TYP_227_I6_D: "Панель прокрутки",
  T_49_META_TYP_227_I7_D: "Сетка",
  T_49_META_TYP_227_I8_D: "Виджет макета",
  T_49_META_TYP_227_I9_D: "Виджет контейнера",
  T_49_META_TYP_231_I0_D: "Восстановление прочности",
  T_49_META_TYP_231_I1_D: "Эффективный интервал времени, в секундах",
  T_49_META_TYP_233_I2_D: "Время до истечения, в секундах",
  T_49_META_TYP_233_I4_D: "Название ресурса иконки",
  T_49_META_TYP_234_I0_D: "Время срабатывания, в секундах",
  T_49_META_TYP_234_I1_D: "Может быть активирован самим",
  T_49_META_TYP_234_I10_D: "Текущее значение срока службы",
  T_49_META_TYP_234_I2_D: "Может быть активирован командой",
  T_49_META_TYP_234_I3_D: "Может быть активировано транспортом",
  T_49_META_TYP_234_I4_D: "Продолжительность в секундах",
  T_49_META_TYP_234_I5_D: "Может быть атакован",
  T_49_META_TYP_234_I6_D: "Значение жизни",
  T_49_META_TYP_235_I0_D: "Максимальное значение срока службы",
  T_49_META_TYP_235_I2_D: "Макс. количество",
  T_49_META_TYP_237_I0_D: "Скорость броска",
  T_49_META_TYP_237_I1_D: "Скорость сцепления игрока",
  T_49_META_TYP_238_I0_D: "Цвет спрея",
  T_49_META_TYP_239_I0_D: "Начальная скорость",
  T_49_META_TYP_239_I1_D: "Скорость ускорения (например, под действием силы тяжести)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Оружие",
  T_49_META_TYP_24_I10_D: "Урон от удара по воздуху, урон от самоубийства монстра",
  T_49_META_TYP_24_I11_D: "Повреждение от взрыва транспортного средства",
  T_49_META_TYP_24_I12_D: "Взрыв бочки с маслом",
  T_49_META_TYP_24_I13_D: "Оружие типа ракеты",
  T_49_META_TYP_24_I14_D: "Урон монстра",
  T_49_META_TYP_24_I15_D: "Зона повреждений",
  T_49_META_TYP_24_I17_D: "Навык персонажа",
  T_49_META_TYP_24_I2_D: "Бросить гранату",
  T_49_META_TYP_24_I3_D: "Безопасная зона",
  T_49_META_TYP_24_I4_D: "Транспортное средство",
  T_49_META_TYP_24_I5_D: "Падение",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Выход",
  T_49_META_TYP_24_I8_D: "Отключение",
  T_49_META_TYP_24_I9_D: "Взрыв транспортного средства",
  T_49_META_TYP_241_I0_D: "Скорость тяги",
  T_49_META_TYP_241_I1_D: "Скорость качания",
  T_49_META_TYP_241_I2_D: "Включение кнопки тяги",
  T_49_META_TYP_241_I3_D: "Кнопка поворота включена",
  T_49_META_TYP_241_I4_D: "Точка привязки движения",
  T_49_META_TYP_241_I5_D: "Ускорение выхода из раскачивания",
  T_49_META_TYP_242_I2_D: "Активный Эффект Слева",
  T_49_META_TYP_242_I3_D: "Активный Эффект Справа",
  T_49_META_TYP_242_I4_D: "Активная Центральная Линия",
  T_49_META_TYP_242_I5_D: "Значение",
  T_49_META_TYP_242_I7_D: "Положение UI, действительны только компоненты XY",
  T_49_META_TYP_242_I8_D: "Положение медианы [0,1]",
  T_49_META_TYP_243_I0_D: "Верхняя одежда",
  T_49_META_TYP_243_I1_D: "Нижняя одежда",
  T_49_META_TYP_243_I2_D: "Обувь",
  T_49_META_TYP_243_I3_D: "Грим",
  T_49_META_TYP_243_I4_D: "Головной убор",
  T_49_META_TYP_243_I5_D: "Комбинезон",
  T_49_META_TYP_243_I6_D: "Грим",
  T_49_META_TYP_244_I0_D: "Отображаемый текстовый контент",
  T_49_META_TYP_244_I10_D: "Вы можете просмотреть список игроков этой сущности.",
  T_49_META_TYP_244_I11_D: "Уровень отображения",
  T_49_META_TYP_244_I2_D: "Следовать за целью",
  T_49_META_TYP_244_I3_D: "Если глубина игнорируется, он может отображаться через стену, в противном случае он не будет работать",
  T_49_META_TYP_244_I4_D: "Всегда в видеокадре",
  T_49_META_TYP_244_I5_D: "При значении true, когда позиция находится за пределами экрана, текст будет отображаться внутри экрана.",
  T_49_META_TYP_244_I6_D: "Стиль шрифта",
  T_49_META_TYP_244_I7_D: "Тип шрифта",
  T_49_META_TYP_244_I8_D: "Размер шрифта",
  T_49_META_TYP_245_I0_D: "Путь к ресурсу эффекта",
  T_49_META_TYP_245_I11_D: "Слои отображения",
  T_49_META_TYP_245_I3_D: "Если игнорировать глубину, он может отображаться через стену, в противном случае он не будет работать.",
  T_49_META_TYP_245_I4_D: "При установке значения true, когда позиция находится за пределами экрана, она будет отображаться внутри экрана.",
  T_49_META_TYP_245_I5_D: "Всегда в видеокадре",
  T_49_META_TYP_245_I6_D: "Тип рендера",
  T_49_META_TYP_245_I7_D: "Ширина",
  T_49_META_TYP_246_I0_D: "Оранжевый",
  T_49_META_TYP_246_I1_D: "Фиолетовый",
  T_49_META_TYP_246_I2_D: "Красный",
  T_49_META_TYP_246_I3_D: "Зеленый",
  T_49_META_TYP_246_I4_D: "Синий",
  T_49_META_TYP_247_I1_D: "Спринт",
  T_49_META_TYP_247_I14_D: "Эмоция",
  T_49_META_TYP_247_I15_D: "Быстрый чат",
  T_49_META_TYP_247_I16_D: "Подбор предметов",
  T_49_META_TYP_247_I17_D: "Отображение быстрого чата",
  T_49_META_TYP_247_I18_D: "ХП",
  T_49_META_TYP_247_I19_D: "Энергия",
  T_49_META_TYP_247_I2_D: "Атака",
  T_49_META_TYP_247_I20_D: "Броня",
  T_49_META_TYP_247_I21_D: "Перезарядка",
  T_49_META_TYP_247_I22_D: "Кнопка быстрой смены",
  T_49_META_TYP_247_I23_D: "Кнопка динамика носителя",
  T_49_META_TYP_247_I24_D: "Кнопка включения/выключения голоса (микрофона)",
  T_49_META_TYP_247_I25_D: "Кнопка включения/выключения маркера",
  T_49_META_TYP_247_I27_D: "Кнопка включения/выключения сетевого сигнала",
  T_49_META_TYP_247_I28_D: "Активный навык",
  T_49_META_TYP_247_I29_D: "Прицел",
  T_49_META_TYP_247_I3_D: "Прыжок",
  T_49_META_TYP_247_I30_D: "Пассивный навык",
  T_49_META_TYP_247_I4_D: "Подсказки об убийствах",
  T_49_META_TYP_247_I5_D: "Слот для оружия",
  T_49_META_TYP_247_I6_D: "Мини-карта",
  T_49_META_TYP_247_I7_D: "Пользовательский интерфейс рюкзака",
  T_49_META_TYP_247_I8_D: "Медицинские предметы",
  T_49_META_TYP_247_I9_D: "Отображается при значении True, в противном случае выключено",
  T_49_META_TYP_249_I3_D: "Оружие разрушения",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Замораживающая бомба",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Индекс текущей сцены, соответствующий индексу в редакторе потока",
  T_49_META_TYP_25_I1_D: "Время начала текущей сцены, в мс",
  T_49_META_TYP_25_I2_D: "Время окончания текущей сцены, в мс",
  T_49_META_TYP_25_I3_D: "Длительность текущего этапа, в мс",
  T_49_META_TYP_250_I1_D: "Цвет спецэффекта, RGBA четыре канала, диапазон значений одного канала 0~255, хранится в Int32.",
  T_49_META_TYP_250_I3_D: "Тип текстуры эффекта",
  T_49_META_TYP_250_I4_D: "Диффуз Альфа",
  T_49_META_TYP_2500_I1_D: "Является ли это точкой спауна по умолчанию",
  T_49_META_TYP_2500_I3_D: "Был ли игрок уже рожден в районе места рождения.",
  T_49_META_TYP_2500_I4_D: "Координаты текущего назначаемого места рождения",
  T_49_META_TYP_2502_I0_D: "Является ли это триггером смерти, если это не триггер смерти, то это триггер неуязвимости. (Это наследие OB32, пожалуйста, разделите функцию в будущем!)",
  T_49_META_TYP_2502_I1_D: "Показывать ли границу триггера, true для показа",
  T_49_META_TYP_2503_I0_D: "ID контрольной точки",
  T_49_META_TYP_2503_I2_D: "Расположение контрольных точек",
  T_49_META_TYP_2507_I0_D: "К какому лагерю относится башня, если к тому же, что и игрок, то она не будет атаковать игрока.",
  T_49_META_TYP_2507_I1_D: "ХП",
  T_49_META_TYP_2507_I10_D: "ID объекта",
  T_49_META_TYP_2507_I2_D: "Макс. ХП",
  T_49_META_TYP_2507_I3_D: "Урон атаки, сколько урона может нанести игроку одна атака.",
  T_49_META_TYP_2507_I4_D: "Интервал между атаками, в секундах.",
  T_49_META_TYP_2507_I5_D: "Атаки можно совершать в радиусе от центра башни.",
  T_49_META_TYP_2507_I6_D: "Коэффициент снижения урона - десятичное число, меньшее 1. Итоговый урон - это урон, умноженный на (1 - коэффициент снижения урона).",
  T_49_META_TYP_2507_I7_D: "Цель атаки",
  T_49_META_TYP_2507_I8_D: "Угол",
  T_49_META_TYP_2507_I9_D: "Состояние мини-сенсора",
  T_49_META_TYP_2508_I0_D: "Сколько зомби будет порождено в каждой волне",
  T_49_META_TYP_2508_I1_D: "Сколько волн зомби будет порождено в общей сложности",
  T_49_META_TYP_2508_I2_D: "Будет ли зомби появляться непрерывно, но будет ли верхняя граница одного экрана.",
  T_49_META_TYP_2508_I3_D: "Сколько волн будет порождено в текущей волне?",
  T_49_META_TYP_2508_I5_D: "Какой тип зомби будет порожден в текущей волне.",
  T_49_META_TYP_2508_I6_D: "Выбрасывает ли ИИ снаряжение или предметы после смерти.",
  T_49_META_TYP_2508_I7_D: "Время начала спауна (с)",
  T_49_META_TYP_2508_I8_D: "Временной интервал между следующей и предыдущей волной.",
  T_49_META_TYP_2509_I0_D: "Количество тел юнитов, которые будут генерироваться в каждой волне",
  T_49_META_TYP_2509_I1_D: "Сколько волн генераторов юнитов будет сгенерировано в общей сложности",
  T_49_META_TYP_2509_I2_D: "Сколько волн генерируется в данный момент",
  T_49_META_TYP_2509_I4_D: "Какая сущность будет использоваться в качестве шаблона для генерации каждой волны",
  T_49_META_TYP_2509_I5_D: "Когда начнется генерация юнитов",
  T_49_META_TYP_2509_I6_D: "Будут ли они генерироваться непрерывно или нет, но будет установлен верхний предел на одном экране",
  T_49_META_TYP_2509_I7_D: "Временной интервал между следующей и предыдущей волной.",
  T_49_META_TYP_2509_I8_D: "prefabID шаблона",
  T_49_META_TYP_2510_I0_D: "Количество точек спауна",
  T_49_META_TYP_252_I1_D: "Левая Иконка",
  T_49_META_TYP_252_I2_D: "Левый Текст",
  T_49_META_TYP_252_I3_D: "Левый Счет",
  T_49_META_TYP_252_I5_D: "Правая Иконка",
  T_49_META_TYP_252_I6_D: "Правый Текст",
  T_49_META_TYP_252_I7_D: "Правый Счет",
  T_49_META_TYP_252_I8_D: "Прогресс [0,1]",
  T_49_META_TYP_253_I0_D: "Иконка выбора",
  T_49_META_TYP_253_I1_D: "Текст",
  T_49_META_TYP_253_I2_D: "Показать эффект",
  T_49_META_TYP_253_I3_D: "Позиция пользовательского интерфейса",
  T_49_META_TYP_254_I1_D: "Например, 1.25 означает в 1.25 раза больше обычной скорости.",
  T_49_META_TYP_254_I2_D: "Цвет",
  T_49_META_TYP_256_I0_D: "Полностью неподвижные. Минимальная производительность",
  T_49_META_TYP_256_I1_D: "Обычное приложение силы. Самая дорогая производительность",
  T_49_META_TYP_256_I2_D: "Движение может контролироваться с помощью скриптов и может рассматриваться как бесконечная масса",
  T_49_META_TYP_257_I0_D: "Функции различных типов жестких тел",
  T_49_META_TYP_257_I1_D: "Использовать гравитацию",
  T_49_META_TYP_257_I2_D: "Масса (кг), минимальная эффективная масса - 0,001 кг, если она равна 0, то масса бесконечна и не будет двигаться под действием силы.",
  T_49_META_TYP_257_I3_D: "Положение центра тяжести, местная система координат",
  T_49_META_TYP_257_I4_D: "Линейная скорость движения твердого тела",
  T_49_META_TYP_257_I5_D: "Угловая скорость движения твердого тела",
  T_49_META_TYP_257_I6_D: "Коэффициент естественного убывания линейной скорости, чем больше коэффициент, тем быстрее убывает скорость.",
  T_49_META_TYP_257_I7_D: "Коэффициент естественного убывания угловой скорости, чем больше коэффициент, тем быстрее убывает скорость.",
  T_49_META_TYP_257_I8_D: "Ограничения, накладываемые на жесткое тело, коллекция RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Фон",
  T_49_META_TYP_259_I1_D: "Текст",
  T_49_META_TYP_259_I2_D: "Положение пользовательского интерфейса",
  T_49_META_TYP_259_I4_D: "Цвет Текста",
  T_49_META_TYP_260_I0_D: "Иконка выбора",
  T_49_META_TYP_260_I1_D: "Цвет прогресс-бара",
  T_49_META_TYP_260_I2_D: "Значение",
  T_49_META_TYP_260_I3_D: "Скорость в м/с",
  T_49_META_TYP_260_I4_D: "Отображать ли специальные эффекты",
  T_49_META_TYP_260_I5_D: "Положение пользовательского интерфейса [0,1].",
  T_49_META_TYP_260_I6_D: "Начальный прогресс навыка, значение [0, 1], прогресс будет синхронизирован с текущим прогрессом сразу после создания пользовательского интерфейса.",
  T_49_META_TYP_260_I7_D: "Цвет Эффекта",
  T_49_META_TYP_260_I8_D: "Установка значения масштабирования объекта",
  T_49_META_TYP_265_I1_D: "Заливать или не заливать фон",
  T_49_META_TYP_265_I2_D: "Имя фона",
  T_49_META_TYP_265_I3_D: "Цвет фона",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Тип обрезки",
  T_49_META_TYP_265_I7_D: "Тип маски - имя изображения, выбранного для маскирования",
  T_49_META_TYP_265_I8_D: "Единица смягчения краев",
  T_49_META_TYP_267_I0_D: "Точка начала прокрутки, по умолчанию - левый верхний угол.",
  T_49_META_TYP_267_I1_D: "Поддержка нескольких направлений прокрутки",
  T_49_META_TYP_267_I10_D: "Горизонтальная полоса",
  T_49_META_TYP_267_I11_D: "Показывать позицию",
  T_49_META_TYP_267_I2_D: "Компонент перетаскивания в направлении XY",
  T_49_META_TYP_267_I3_D: "Поддержка нескольких эффектов перетаскивания",
  T_49_META_TYP_267_I4_D: "Фактор прокрутки, чем больше значение, тем быстрее прокрутка.",
  T_49_META_TYP_267_I5_D: "Фактор инерции, чем больше значение, тем больше инерция при прокрутке.",
  T_49_META_TYP_267_I6_D: "Ограничивать или нет перетаскивание рамками области просмотра, по умолчанию отмечено.",
  T_49_META_TYP_267_I7_D: "Если флажок установлен, перетаскивание начнется медленно, если флажок снят, перетаскивание начнется со скоростью мыши.",
  T_49_META_TYP_267_I8_D: "Завершите перетаскивание, когда оно поместится в область просмотра.",
  T_49_META_TYP_267_I9_D: "Вертикальная полоса",
  T_49_META_TYP_268_I0_D: "По умолчанию",
  T_49_META_TYP_268_I1_D: "Закрыть",
  T_49_META_TYP_268_I2_D: "Показать",
  T_49_META_TYP_269_I0_D: "Владелец",
  T_49_META_TYP_269_I1_D: "ID костюма",
  T_49_META_TYP_269_I2_D: "ID головного убора",
  T_49_META_TYP_269_I3_D: "ID лица",
  T_49_META_TYP_269_I4_D: "ID макияжа",
  T_49_META_TYP_269_I5_D: "ID верхней части тела",
  T_49_META_TYP_269_I6_D: "ID нижней части тела",
  T_49_META_TYP_269_I7_D: "ID обуви",
  T_49_META_TYP_272_I0_D: "Женский",
  T_49_META_TYP_272_I1_D: "Мужской",
  T_49_META_TYP_273_I0_D: "Мировые координаты центра мини-карты",
  T_49_META_TYP_273_I1_D: "Размер мини-карты, одинаковая ширина и высота",
  T_49_META_TYP_273_I2_D: "Включить или отключить режим отображения карты глубины на мини-карте",
  T_49_META_TYP_274_I1_D: "Размер масштаба",
  T_49_META_TYP_274_I4_D: "Уровень отображения значков",
  T_49_META_TYP_275_I0_D: "Масштабирование скелета",
  T_49_META_TYP_275_I1_D: "Мировые координаты узлов костей",
  T_49_META_TYP_276_I0_D: "Голова",
  T_49_META_TYP_276_I1_D: "Левая рука",
  T_49_META_TYP_276_I2_D: "Левая кисть",
  T_49_META_TYP_276_I3_D: "Правая рука",
  T_49_META_TYP_276_I4_D: "Правая кисть",
  T_49_META_TYP_276_I5_D: "Торс",
  T_49_META_TYP_276_I6_D: "Левая нога",
  T_49_META_TYP_276_I7_D: "Левая стопа",
  T_49_META_TYP_276_I8_D: "Правая нога",
  T_49_META_TYP_276_I9_D: "Правая стопа",
  T_49_META_TYP_277_I1_D: "Расстояние для обнаружения лучей камеры",
  T_49_META_TYP_277_I2_D: "Маска слоя столкновений для обнаружения лучей камеры",
  T_49_META_TYP_277_I3_D: "Смещение позиции кнопки",
  T_49_META_TYP_277_I4_D: "Идентификатор ресурса значка",
  T_49_META_TYP_277_I5_D: "Размер области нажатия",
  T_49_META_TYP_277_I6_D: "Отображаются ли объекты в целевой точке",
  T_49_META_TYP_277_I7_D: "Объекты, отображаемые в целевой точке",
  T_49_META_TYP_278_I0_D: "Целевая сущность для генерации пикселей карты",
  T_49_META_TYP_28_I0_D: "Можно ли сбрасывать команду каждый раунд",
  T_49_META_TYP_280_I0_D: "Радиус сферы",
  T_49_META_TYP_281_I0_D: "Радиус полусфер на концах капсулы.",
  T_49_META_TYP_29_I0_D: "Сфера",
  T_49_META_TYP_29_I1_D: "Световой луч",
  T_49_META_TYP_29_I10_D: "Столб света под ногами, теперь используется для обратной связи при выходе на финишную прямую",
  T_49_META_TYP_29_I11_D: "Заморозка",
  T_49_META_TYP_29_I12_D: "Свет",
  T_49_META_TYP_29_I13_D: "Восходящий поток",
  T_49_META_TYP_29_I14_D: "Взрыв газа",
  T_49_META_TYP_29_I15_D: "Прячущийся устранен",
  T_49_META_TYP_29_I16_D: "Катаклизм",
  T_49_META_TYP_29_I17_D: "Смерть клона",
  T_49_META_TYP_29_I18_D: "Обратная связь по стрельбе",
  T_49_META_TYP_29_I19_D: "Смерть клона",
  T_49_META_TYP_29_I2_D: "Гул",
  T_49_META_TYP_29_I20_D: "Клон",
  T_49_META_TYP_29_I21_D: "Портал",
  T_49_META_TYP_29_I22_D: "Дым от ослепляющего заряда",
  T_49_META_TYP_29_I23_D: "Огненный шар",
  T_49_META_TYP_29_I24_D: "Циклическое горение",
  T_49_META_TYP_29_I25_D: "Ядовитый газ",
  T_49_META_TYP_29_I26_D: "Сердце",
  T_49_META_TYP_29_I29_D: "Дверь",
  T_49_META_TYP_29_I30_D: "Фейерверк",
  T_49_META_TYP_29_I31_D: "Эффект беговых туфель",
  T_49_META_TYP_29_I32_D: "Эффект взрыва",
  T_49_META_TYP_29_I33_D: "Эффект точки появления",
  T_49_META_TYP_29_I34_D: "Эффект лазера",
  T_49_META_TYP_29_I35_D: "Эффект использования навыка",
  T_49_META_TYP_29_I36_D: "Эффект пули",
  T_49_META_TYP_29_I37_D: "Эффект попадания пули",
  T_49_META_TYP_29_I38_D: "Эффект стрельбы",
  T_49_META_TYP_29_I39_D: "Эффект навыка",
  T_49_META_TYP_29_I40_D: "Нимб",
  T_49_META_TYP_29_I41_D: "Пузырьки",
  T_49_META_TYP_29_I42_D: "Дым и пыль",
  T_49_META_TYP_29_I43_D: "Летающие обломки",
  T_49_META_TYP_29_I44_D: "Линии",
  T_49_META_TYP_29_I45_D: "Мерцание",
  T_49_META_TYP_29_I47_D: "Восходящие частицы",
  T_49_META_TYP_29_I48_D: "Дым",
  T_49_META_TYP_29_I49_D: "Амулет",
  T_49_META_TYP_29_I50_D: "Замороженная зона",
  T_49_META_TYP_29_I51_D: "Туман",
  T_49_META_TYP_29_I52_D: "Снежинка",
  T_49_META_TYP_29_I53_D: "Огонь",
  T_49_META_TYP_29_I54_D: "Луч света",
  T_49_META_TYP_29_I55_D: "Рассеивание ядовитого газа",
  T_49_META_TYP_29_I56_D: "Ядовитый газ",
  T_49_META_TYP_29_I57_D: "Пламя взрыва",
  T_49_META_TYP_29_I58_D: "Световой эффект",
  T_49_META_TYP_29_I59_D: "Звезда",
  T_49_META_TYP_29_I6_D: "Ореол ноги",
  T_49_META_TYP_29_I60_D: "Горящий костер",
  T_49_META_TYP_29_I61_D: "Всплеск воды",
  T_49_META_TYP_29_I62_D: "Электрический шок",
  T_49_META_TYP_29_I63_D: "Эффект чернил",
  T_49_META_TYP_29_I64_D: "Эффект черной дыры",
  T_49_META_TYP_29_I65_D: "Визуальные эффекты взрыва черной дыры",
  T_49_META_TYP_29_I66_D: "Визуальные эффекты кристального шара",
  T_49_META_TYP_29_I67_D: "Эффект лазерной пули",
  T_49_META_TYP_29_I68_D: "Эффекты волочения",
  T_49_META_TYP_29_I69_D: "Облака",
  T_49_META_TYP_29_I7_D: "Разметка на земле",
  T_49_META_TYP_29_I8_D: "Дым",
  T_49_META_TYP_29_I9_D: "Взрыв амулета",
  T_49_META_TYP_290_I0_D: "Интервал обновления, чем больше число, тем медленнее обновление, в миллисекундах.",
  T_49_META_TYP_290_I1_D: "Включать ли отладку",
  T_49_META_TYP_291_I0_D: "Узел Условий",
  T_49_META_TYP_291_I1_D: "Узел Действия",
  T_49_META_TYP_293_I0_D: "ID дерева поведения",
  T_49_META_TYP_293_I1_D: "Цель прикрепления",
  T_49_META_TYP_294_I1_D: "Тип раскладки",
  T_49_META_TYP_294_I10_D: "Тип сортировки",
  T_49_META_TYP_294_I2_D: "Начало содержимого",
  T_49_META_TYP_294_I3_D: "Направление выравнивания",
  T_49_META_TYP_294_I4_D: "Ширина и высота сетки подпунктов",
  T_49_META_TYP_294_I5_D: "Интервал между ячейками",
  T_49_META_TYP_294_I6_D: "Ограничение",
  T_49_META_TYP_294_I7_D: "Количество ограничений",
  T_49_META_TYP_294_I8_D: "Вертикальное смещение",
  T_49_META_TYP_294_I9_D: "Горизонтальное смещение",
  T_49_META_TYP_295_I2_D: "Скорость воспроизведения",
  T_49_META_TYP_296_I1_D: "Длина Клипса",
  T_49_META_TYP_297_I0_D: "Связанные объекты",
  T_49_META_TYP_297_I4_D: "ID ресурса",
  T_49_META_TYP_298_I0_D: "По умолчанию",
  T_49_META_TYP_298_I2_D: "Один раз",
  T_49_META_TYP_30_I0_D: "Квадрат",
  T_49_META_TYP_30_I1_D: "Четырехугольник",
  T_49_META_TYP_30_I10_D: "Стрелка",
  T_49_META_TYP_30_I11_D: "Вызов",
  T_49_META_TYP_30_I12_D: "Камень",
  T_49_META_TYP_30_I13_D: "Ножницы",
  T_49_META_TYP_30_I14_D: "Бумага",
  T_49_META_TYP_30_I15_D: "Лайк",
  T_49_META_TYP_30_I16_D: "Правильно",
  T_49_META_TYP_30_I17_D: "Ошибка",
  T_49_META_TYP_30_I18_D: "Плюс",
  T_49_META_TYP_30_I19_D: "Молния",
  T_49_META_TYP_30_I2_D: "Прямоугольный трапециевид",
  T_49_META_TYP_30_I20_D: "Сердце",
  T_49_META_TYP_30_I21_D: "Звезда",
  T_49_META_TYP_30_I22_D: "Луна",
  T_49_META_TYP_30_I23_D: "Солнце",
  T_49_META_TYP_30_I24_D: "Очки",
  T_49_META_TYP_30_I25_D: "Ключ",
  T_49_META_TYP_30_I26_D: "Трофей",
  T_49_META_TYP_30_I27_D: "Флаг",
  T_49_META_TYP_30_I28_D: "Песочные часы",
  T_49_META_TYP_30_I29_D: "Папка",
  T_49_META_TYP_30_I3_D: "Трапеция",
  T_49_META_TYP_30_I30_D: "Открытая папка",
  T_49_META_TYP_30_I31_D: "Дом",
  T_49_META_TYP_30_I32_D: "Отдых",
  T_49_META_TYP_30_I33_D: "Обновить",
  T_49_META_TYP_30_I34_D: "Цикл",
  T_49_META_TYP_30_I35_D: "Лупа",
  T_49_META_TYP_30_I36_D: "Мусорное ведро",
  T_49_META_TYP_30_I37_D: "Возврат",
  T_49_META_TYP_30_I38_D: "Алмаз",
  T_49_META_TYP_30_I39_D: "Спасательный круг",
  T_49_META_TYP_30_I4_D: "Шестиугольник",
  T_49_META_TYP_30_I40_D: "Деньги",
  T_49_META_TYP_30_I41_D: "Замок",
  T_49_META_TYP_30_I42_D: "Настройки",
  T_49_META_TYP_30_I43_D: "Выход",
  T_49_META_TYP_30_I44_D: "Диалог",
  T_49_META_TYP_30_I45_D: "Перекрестие",
  T_49_META_TYP_30_I46_D: "Оружие",
  T_49_META_TYP_30_I47_D: "Меч",
  T_49_META_TYP_30_I48_D: "Взрыв",
  T_49_META_TYP_30_I49_D: "Прицел",
  T_49_META_TYP_30_I5_D: "Круги",
  T_49_META_TYP_30_I50_D: "Крест",
  T_49_META_TYP_30_I51_D: "Оборона",
  T_49_META_TYP_30_I52_D: "Зомби",
  T_49_META_TYP_30_I53_D: "Переработка",
  T_49_META_TYP_30_I54_D: "Подарок",
  T_49_META_TYP_30_I55_D: "Одежда",
  T_49_META_TYP_30_I56_D: "Игра",
  T_49_META_TYP_30_I57_D: "Игрок",
  T_49_META_TYP_30_I58_D: "Магазин",
  T_49_META_TYP_30_I59_D: "Выход",
  T_49_META_TYP_30_I6_D: "Треугольник",
  T_49_META_TYP_30_I60_D: "Предупреждение",
  T_49_META_TYP_30_I61_D: "Текст",
  T_49_META_TYP_30_I62_D: "Объекты с таймером",
  T_49_META_TYP_30_I63_D: "Колокол",
  T_49_META_TYP_30_I64_D: "Питомец",
  T_49_META_TYP_30_I65_D: "Бомба",
  T_49_META_TYP_30_I66_D: "Ремонт",
  T_49_META_TYP_30_I67_D: "Улыбающееся лицо",
  T_49_META_TYP_30_I68_D: "Динамик",
  T_49_META_TYP_30_I7_D: "Восклицательный знак",
  T_49_META_TYP_30_I70_D: "Корона",
  T_49_META_TYP_30_I71_D: "Битва",
  T_49_META_TYP_30_I72_D: "Гильдия",
  T_49_META_TYP_30_I73_D: "Сердцебиение",
  T_49_META_TYP_30_I74_D: "Музыка",
  T_49_META_TYP_30_I75_D: "Транспортное средство",
  T_49_META_TYP_30_I76_D: "Холодное оружие",
  T_49_META_TYP_30_I77_D: "Пистолет",
  T_49_META_TYP_30_I78_D: "Винтовка",
  T_49_META_TYP_30_I79_D: "Снайперская винтовка",
  T_49_META_TYP_30_I8_D: "Вопросительный знак",
  T_49_META_TYP_30_I80_D: "Дробовик",
  T_49_META_TYP_30_I81_D: "ПП",
  T_49_META_TYP_30_I82_D: "Лечащий пистолет",
  T_49_META_TYP_30_I83_D: "Разрушение брони",
  T_49_META_TYP_30_I84_D: "Хэдшот",
  T_49_META_TYP_30_I85_D: "Навык 1",
  T_49_META_TYP_30_I86_D: "Навык 2",
  T_49_META_TYP_30_I87_D: "Навык 3",
  T_49_META_TYP_30_I88_D: "Навык 4",
  T_49_META_TYP_30_I89_D: "Навык 5",
  T_49_META_TYP_30_I9_D: "Знак",
  T_49_META_TYP_30_I90_D: "Навык 6",
  T_49_META_TYP_30_I91_D: "Навык 7",
  T_49_META_TYP_30_I92_D: "Навык 8",
  T_49_META_TYP_30_I93_D: "Навык 9",
  T_49_META_TYP_30_I94_D: "Навык 10",
  T_49_META_TYP_300_I0_D: "ID ресурса",
  T_49_META_TYP_300_I2_D: "Вращение",
  T_49_META_TYP_300_I3_D: "Созданная сущность",
  T_49_META_TYP_301_I1_D: "Саморазрушение",
  T_49_META_TYP_301_I2_D: "Атака в рывке",
  T_49_META_TYP_301_I3_D: "Ударная волна",
  T_49_META_TYP_301_I4_D: "Атака торнадо",
  T_49_META_TYP_301_I5_D: "Прыжковая атака",
  T_49_META_TYP_301_I6_D: "Щит поднят",
  T_49_META_TYP_301_I7_D: "Щит сломан",
  T_49_META_TYP_302_I5_D: "Рюкзак",
  T_49_META_TYP_302_I7_D: "Скейтборд, камуфляж ....",
  T_49_META_TYP_303_I0_D: "Добавить Макс. ХП игрока",
  T_49_META_TYP_303_I1_D: "Постоянно восстанавливать ХП игрока",
  T_49_META_TYP_305_I0_D: "Завершить",
  T_49_META_TYP_305_I1_D: "Работающий",
  T_49_META_TYP_307_I0_D: "Опыт за урон",
  T_49_META_TYP_307_I1_D: "Опыт за пройденное расстояние",
  T_49_META_TYP_307_I2_D: "Опыт за время",
  T_49_META_TYP_307_I3_D: "Опыт за чип",
  T_49_META_TYP_307_I4_D: "Макс. заряд",
  T_49_META_TYP_308_I0_D: "Создатель геля",
  T_49_META_TYP_31_I0_D: "Взрыв гранаты",
  T_49_META_TYP_31_I1_D: "Звук пистолета",
  T_49_META_TYP_31_I10_D: "Звук повреждения при ударе",
  T_49_META_TYP_31_I11_D: "Звук обновления",
  T_49_META_TYP_31_I12_D: "Звуковой эффект удара по слабости",
  T_49_META_TYP_31_I13_D: "Звуковой эффект шага игрока",
  T_49_META_TYP_31_I14_D: "Звук ремонта оборудования",
  T_49_META_TYP_31_I15_D: "Звук ремонта оборудования",
  T_49_META_TYP_31_I16_D: "Звуковой эффект пропажи или потери",
  T_49_META_TYP_31_I17_D: "Звук напоминания",
  T_49_META_TYP_31_I18_D: "Звук падения футбольного мяча",
  T_49_META_TYP_31_I19_D: 'Звуковой эффект "Аплодисменты',
  T_49_META_TYP_31_I2_D: "Звуковой сигнал обратного отсчета",
  T_49_META_TYP_31_I20_D: "Звук оповещения о бомбе",
  T_49_META_TYP_31_I21_D: 'Звуковой эффект "Бомба перед взрывом',
  T_49_META_TYP_31_I22_D: "Звуковой эффект появления охотника",
  T_49_META_TYP_31_I23_D: "Звуковой эффект финального BGM",
  T_49_META_TYP_31_I24_D: "Звуковой эффект обновления ящика для пополнения запасов",
  T_49_META_TYP_31_I25_D: "Звук ускорителя",
  T_49_META_TYP_31_I26_D: "Исчезающий звук",
  T_49_META_TYP_31_I27_D: "Визуальные эффекты",
  T_49_META_TYP_31_I28_D: "Ночные жуки",
  T_49_META_TYP_31_I29_D: "Звуковой эффект тупой перкуссии",
  T_49_META_TYP_31_I3_D: "Нажатие интерфейса",
  T_49_META_TYP_31_I30_D: "Звуковой эффект реакции",
  T_49_META_TYP_31_I31_D: 'Звуковой эффект "Неожиданное открытие',
  T_49_META_TYP_31_I32_D: 'Звуковой эффект "Играющие призраки',
  T_49_META_TYP_31_I33_D: "Звуковой эффект начала сцены",
  T_49_META_TYP_31_I34_D: "Звуковой эффект Зомби",
  T_49_META_TYP_31_I35_D: "Страшный звуковой эффект",
  T_49_META_TYP_31_I36_D: "Звуковой эффект трансформации",
  T_49_META_TYP_31_I37_D: "Быстрый звук сердцебиения",
  T_49_META_TYP_31_I38_D: "Средний звук сердцебиения",
  T_49_META_TYP_31_I39_D: "Звуковой эффект медленного сердцебиения",
  T_49_META_TYP_31_I4_D: "Крик женщины при попадании",
  T_49_META_TYP_31_I40_D: "Звуковой эффект стампида",
  T_49_META_TYP_31_I41_D: "Звук щелчка",
  T_49_META_TYP_31_I42_D: "Звук восстановления навыков",
  T_49_META_TYP_31_I43_D: "Звуковые эффекты присоединения к игре",
  T_49_META_TYP_31_I44_D: "Звук эха механизма",
  T_49_META_TYP_31_I45_D: "Звуковой эффект комара",
  T_49_META_TYP_31_I46_D: "Звуковой эффект Clank 1",
  T_49_META_TYP_31_I47_D: "Звуковой эффект Clank 2",
  T_49_META_TYP_31_I48_D: "Звуковой эффект открытия механизма",
  T_49_META_TYP_31_I49_D: "Заряд 1 звуковой эффект",
  T_49_META_TYP_31_I5_D: "Крик мужчины при попадании",
  T_49_META_TYP_31_I50_D: 'Звуковой эффект "Шаги',
  T_49_META_TYP_31_I51_D: "Успех миссии 1 звуковой эффект",
  T_49_META_TYP_31_I52_D: "Звуковой эффект Danger Tone 1",
  T_49_META_TYP_31_I53_D: 'Звуковой эффект "Опасный сигнал 2',
  T_49_META_TYP_31_I54_D: 'Звуковой эффект "Обратный отсчет" 3',
  T_49_META_TYP_31_I55_D: "Звуковой эффект Show Tips",
  T_49_META_TYP_31_I56_D: "Звуковой эффект ворона",
  T_49_META_TYP_31_I57_D: "Звуковой эффект телепортации в неправильную область с помощью точки телепортации",
  T_49_META_TYP_31_I58_D: "Звуковой эффект телепортации в нужную область с помощью точки телепортации",
  T_49_META_TYP_31_I59_D: "Звуковой эффект телепорта",
  T_49_META_TYP_31_I6_D: "Звуковой эффект подбора золота",
  T_49_META_TYP_31_I60_D: "Звуковой эффект электрического удара",
  T_49_META_TYP_31_I61_D: 'Звуковой эффект "Получение реквизита',
  T_49_META_TYP_31_I62_D: "Звуковые эффекты электронной фэнтези милой фоновой музыки",
  T_49_META_TYP_31_I63_D: "Казуальная игра Фоновая музыка Звуковые эффекты",
  T_49_META_TYP_31_I64_D: "Открыть коробку",
  T_49_META_TYP_31_I65_D: "Повышение ранга",
  T_49_META_TYP_31_I66_D: "Максимальный уровень",
  T_49_META_TYP_31_I67_D: "Кнопка нажать",
  T_49_META_TYP_31_I68_D: "Обратный отсчет",
  T_49_META_TYP_31_I69_D: "Побеждать врага",
  T_49_META_TYP_31_I7_D: "Звуковой эффект запуска гонки мимо финиша",
  T_49_META_TYP_31_I70_D: "Конец",
  T_49_META_TYP_31_I71_D: "Вперед",
  T_49_META_TYP_31_I72_D: "Победа",
  T_49_META_TYP_31_I73_D: "Контрольные точки тренировочной базы",
  T_49_META_TYP_31_I74_D: "Обратный отсчет",
  T_49_META_TYP_31_I75_D: "Начало игры",
  T_49_META_TYP_31_I76_D: "Получить большие золото",
  T_49_META_TYP_31_I77_D: "Получить среднее золото",
  T_49_META_TYP_31_I78_D: "Получить малое золото",
  T_49_META_TYP_31_I79_D: "Присоединиться к битве",
  T_49_META_TYP_31_I8_D: "Звук триггера",
  T_49_META_TYP_31_I80_D: "Поставка гильдии",
  T_49_META_TYP_31_I81_D: "Динамик",
  T_49_META_TYP_31_I82_D: "Отстранение лидера гильдии",
  T_49_META_TYP_31_I83_D: "Сохранить склад",
  T_49_META_TYP_31_I84_D: "Специальный звук оружия",
  T_49_META_TYP_31_I85_D: "Попадание пули",
  T_49_META_TYP_31_I86_D: "Двигать",
  T_49_META_TYP_31_I87_D: "Нажать кнопку отключения",
  T_49_META_TYP_31_I88_D: "Завершение зарядки навыков",
  T_49_META_TYP_31_I89_D: "Лазерный навык",
  T_49_META_TYP_31_I9_D: "Звук деградации",
  T_49_META_TYP_31_I90_D: "Получить расходный материал 2",
  T_49_META_TYP_31_I91_D: "Обратный отсчет 3",
  T_49_META_TYP_31_I92_D: "Конец игры 2",
  T_49_META_TYP_31_I93_D: "Подсказка об устранении",
  T_49_META_TYP_31_I94_D: "Взрыв",
  T_49_META_TYP_31_I95_D: "Навык энергического шара",
  T_49_META_TYP_31_I96_D: "Навык алого бассейна",
  T_49_META_TYP_311_I1_D: "Максимальный урон",
  T_49_META_TYP_311_I3_D: "Скорость снаряда после его выпуска, в м/с.",
  T_49_META_TYP_311_I4_D: "Интервал времени между моментом выпуска снаряда и моментом его действия, в секундах.",
  T_49_META_TYP_313_I0_D: "Радиус зоны",
  T_49_META_TYP_313_I1_D: "Длительность зоны противодействия, в секундах",
  T_49_META_TYP_314_I0_D: "Идентификатор ресурса контроллера анимации",
  T_49_META_TYP_314_I1_D: "Контроллер анимации",
  T_49_META_TYP_315_I0_D: "Владелец рюкзака",
  T_49_META_TYP_315_I1_D: "Пространство рюкзака",
  T_49_META_TYP_315_I2_D: "Исп. вместимость",
  T_49_META_TYP_315_I3_D: "Все запасы",
  T_49_META_TYP_316_I0_D: "Ресурс текстуры",
  T_49_META_TYP_316_I1_D: "Название шейдера",
  T_49_META_TYP_316_I11_D: "Метод переворота",
  T_49_META_TYP_316_I2_D: "Смещение UV",
  T_49_META_TYP_316_I3_D: "Размер UV",
  T_49_META_TYP_316_I4_D: "Тип заполнения",
  T_49_META_TYP_316_I5_D: "Левая и правая границы",
  T_49_META_TYP_316_I6_D: "Верхняя и нижняя границы",
  T_49_META_TYP_317_I0_D: "Отсутствует",
  T_49_META_TYP_317_I1_D: "Зафиксировать положение X",
  T_49_META_TYP_317_I2_D: "Зафиксировать положение Y",
  T_49_META_TYP_317_I3_D: "Зафиксировать положение Z",
  T_49_META_TYP_317_I4_D: "Ограничение вращения вокруг оси X",
  T_49_META_TYP_317_I5_D: "Ограничение вращения вокруг оси Y",
  T_49_META_TYP_317_I6_D: "Ограничение вращения вокруг оси Z",
  T_49_META_TYP_317_I7_D: "Зафиксировать положение",
  T_49_META_TYP_317_I8_D: "Заморозить вращение",
  T_49_META_TYP_317_I9_D: "Заморозить все",
  T_49_META_TYP_318_I0_D: "Дальность",
  T_49_META_TYP_318_I1_D: "Полный урон на расстоянии",
  T_49_META_TYP_318_I10_D: "Коэффициент скорости прицеливания игрока",
  T_49_META_TYP_318_I11_D: "Коэффициент увеличения зума",
  T_49_META_TYP_318_I12_D: "Увеличение угла обзора (FOV)",
  T_49_META_TYP_318_I13_D: "Увеличение прицела",
  T_49_META_TYP_318_I14_D: "Время увеличения прицела (с)",
  T_49_META_TYP_318_I15_D: "Время восстановления прицела (с)",
  T_49_META_TYP_318_I16_D: "Поправочный коэффициент минимальной дальности поражения для прицелов",
  T_49_META_TYP_318_I17_D: "Разрешить помощь при прицеливании",
  T_49_META_TYP_318_I18_D: "Коэффициент притяжения прицела в пределах экрана (0-1)",
  T_49_META_TYP_318_I19_D: "Коэффициент затухания дистанции помощи при прицеливании (0-1)",
  T_49_META_TYP_318_I2_D: "Минимальное расстояние до урона",
  T_49_META_TYP_318_I20_D: "Разрешить приоритет дистанц. помощи при прицел.",
  T_49_META_TYP_318_I21_D: "Минимальная дистанция приоритета помощи при прицеливании",
  T_49_META_TYP_318_I22_D: "Максимальная дистанция приоритета помощи при прицеливании",
  T_49_META_TYP_318_I23_D: "Коэффициент влияния приоритета дистанции помощи при прицеливании (>=1)",
  T_49_META_TYP_318_I24_D: "Чувствительность вращения прицела",
  T_49_META_TYP_318_I25_D: "Скорость сходимости",
  T_49_META_TYP_318_I3_D: "Размер магазина",
  T_49_META_TYP_318_I4_D: "Интервал атаки",
  T_49_META_TYP_318_I5_D: "Скорость перезарядки",
  T_49_META_TYP_318_I6_D: "Автоматическая скорость перезарядки",
  T_49_META_TYP_318_I7_D: "Скорость разброса",
  T_49_META_TYP_318_I8_D: "Коэффициент рассеивания при приседании и лежании, в 0,1 означает увеличение дальности на 10% за раунд столкновения",
  T_49_META_TYP_318_I9_D: "Максимальный разброс",
  T_49_META_TYP_319_I0_D: "Простой",
  T_49_META_TYP_319_I1_D: "Нарезанный",
  T_49_META_TYP_319_I2_D: "Мозаичный",
  T_49_META_TYP_319_I3_D: "Заполненный",
  T_49_META_TYP_319_I4_D: "Подходит",
  T_49_META_TYP_32_I0_D: "Игрок в обычном активном состоянии",
  T_49_META_TYP_32_I1_D: "Игрок сбит с ног",
  T_49_META_TYP_32_I2_D: "Игрок мертв",
  T_49_META_TYP_320_I0_D: "Горизонтальный",
  T_49_META_TYP_320_I1_D: "Вертикальный",
  T_49_META_TYP_320_I2_D: "Радиальный 90°",
  T_49_META_TYP_320_I3_D: "Радиальный 180°",
  T_49_META_TYP_320_I4_D: "Радиальный 360°",
  T_49_META_TYP_321_I0_D: "Максимальное расстояние, на котором будет срабатывать помощь при наведении.",
  T_49_META_TYP_321_I1_D: "Смещение коллиматора при срабатывании таргетинга; если точка смещения не находится в твердом теле, таргетинг будет отключен.",
  T_49_META_TYP_322_I0_D: "Нет",
  T_49_META_TYP_322_I1_D: "Голова",
  T_49_META_TYP_322_I2_D: "Тело",
  T_49_META_TYP_322_I3_D: "Конечность",
  T_49_META_TYP_323_I0_D: "Масштаб",
  T_49_META_TYP_323_I1_D: "ID аккаунта",
  T_49_META_TYP_323_I2_D: "Информация о профиле игрока",
  T_49_META_TYP_323_I3_D: "Стиль",
  T_49_META_TYP_323_I4_D: "Показать ранг",
  T_49_META_TYP_323_I5_D: "Показать значок",
  T_49_META_TYP_323_I6_D: "Показать ник",
  T_49_META_TYP_324_I0_D: "Генерировать силу заданной величины",
  T_49_META_TYP_324_I1_D: "Генерировать ускорение заданной величины",
  T_49_META_TYP_324_I2_D: "Генерировать импульс заданной величины",
  T_49_META_TYP_324_I3_D: "Генерировать заданную скорость",
  T_49_META_TYP_326_I0_D: "ID аккаунта",
  T_49_META_TYP_326_I1_D: "ID аватара",
  T_49_META_TYP_326_I2_D: "ID баннера",
  T_49_META_TYP_326_I3_D: "ID значка",
  T_49_META_TYP_326_I4_D: "Прозвище игрока",
  T_49_META_TYP_326_I5_D: "Ранг КБ",
  T_49_META_TYP_326_I6_D: "Высший ранг КБ",
  T_49_META_TYP_326_I7_D: "Ранг БО",
  T_49_META_TYP_326_I8_D: "Высший ранг БО",
  T_49_META_TYP_327_I0_D: "Идентификатор ресурса",
  T_49_META_TYP_327_I1_D: "Маска части 1",
  T_49_META_TYP_327_I2_D: "Маска части 2",
  T_49_META_TYP_327_I3_D: "Маска части 3",
  T_49_META_TYP_327_I4_D: "Маска части 4",
  T_49_META_TYP_329_I0_D: "Водитель",
  T_49_META_TYP_329_I1_D: "Пассажир A",
  T_49_META_TYP_329_I2_D: "Пассажир B",
  T_49_META_TYP_329_I3_D: "Пассажир C",
  T_49_META_TYP_33_I0_D: "Порядок возрастания игнорирует нулевые значения, нулевые значения идут последними",
  T_49_META_TYP_33_I1_D: "Порядок убывания, от большого к маленькому",
  T_49_META_TYP_33_I2_D: "По возрастанию, от меньшего к большему",
  T_49_META_TYP_330_I4_D: "Длительность эффекта неуязвимости (в сек)",
  T_49_META_TYP_330_I5_D: "Точки управления",
  T_49_META_TYP_330_I8_D: "Значение Дельта",
  T_49_META_TYP_332_I0_D: "Зациклено",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Супермаркет",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Путь к ресурсам, по умолчанию пустой",
  T_49_META_TYP_335_I1_D: "Количество игр, по умолчанию 1",
  T_49_META_TYP_335_I2_D: "Громкость, по умолчанию 50",
  T_49_META_TYP_335_I3_D: "Макс. дистанция",
  T_49_META_TYP_335_I4_D: "Мин. дистанция",
  T_49_META_TYP_335_I5_D: "Будет ли музыка 3D или нет",
  T_49_META_TYP_335_I6_D: "Приоритет",
  T_49_META_TYP_335_I7_D: "Время ожидания перед началом, в секундах",
  T_49_META_TYP_335_I8_D: "Воспроизводится ли",
  T_49_META_TYP_338_I0_D: "Статус движения",
  T_49_META_TYP_338_I1_D: "Спринт",
  T_49_META_TYP_338_I2_D: "Атака",
  T_49_META_TYP_338_I3_D: "Прыжок",
  T_49_META_TYP_338_I4_D: "Преодолеть",
  T_49_META_TYP_338_I5_D: "Вход в транспортное средство (водитель)",
  T_49_META_TYP_338_I6_D: "Вход в транспортное средство (пассажир)",
  T_49_META_TYP_338_I7_D: "Выйти из транспорта",
  T_49_META_TYP_338_I8_D: "Вождение",
  T_49_META_TYP_339_I0_D: "Коэффициент урона по конечностям",
  T_49_META_TYP_339_I1_D: "Коэффициент урона хэдшота",
  T_49_META_TYP_339_I2_D: "Коэффициент максимальной прочности",
  T_49_META_TYP_339_I3_D: "Коэффициент дополнительного здоровья",
  T_49_META_TYP_339_I4_D: "Дополнительный коэффициент снижения урона от взрыва (%)",
  T_49_META_TYP_339_I5_D: "Дополнительная вместимость рюкзака",
  T_49_META_TYP_339_I6_D: "Приоритет замены",
  T_49_META_TYP_34_I0_D: "Кулак по умолчанию",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Гроза-X",
  T_49_META_TYP_34_I102_D: "СВД-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Дробовик",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Ручная пушка",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Щитовая пушка",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Щитовая пушка",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-II Kar98K-III Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Пламенная граната",
  T_49_META_TYP_34_I133_D: "Осветительная граната",
  T_49_META_TYP_34_I134_D: "Дымовая граната",
  T_49_META_TYP_34_I135_D: "Крио-граната",
  T_49_META_TYP_34_I136_D: "Пуленепробиваемый жилет Lv1",
  T_49_META_TYP_34_I137_D: "Пуленепробиваемый жилет Lv2",
  T_49_META_TYP_34_I138_D: "Бронежилет Lv3",
  T_49_META_TYP_34_I139_D: "Шлем Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Шлем Lv2",
  T_49_META_TYP_34_I141_D: "Шлем Lv3",
  T_49_META_TYP_34_I142_D: "Взрывозащищенная броня",
  T_49_META_TYP_34_I143_D: "Рюкзак Lv1",
  T_49_META_TYP_34_I144_D: "Рюкзак Lv2",
  T_49_META_TYP_34_I145_D: "Рюкзак Lv3",
  T_49_META_TYP_34_I146_D: "Дуло Lv1",
  T_49_META_TYP_34_I147_D: "Дуло Lv2",
  T_49_META_TYP_34_I148_D: "Морда Lv3",
  T_49_META_TYP_34_I149_D: "Глушитель",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Штурмовое дуло",
  T_49_META_TYP_34_I151_D: "Широкое дуло",
  T_49_META_TYP_34_I152_D: "Журнал Lv1",
  T_49_META_TYP_34_I153_D: "Журнал Lv2",
  T_49_META_TYP_34_I154_D: "Журнал Lv3",
  T_49_META_TYP_34_I155_D: "Журнал с двойным пучком",
  T_49_META_TYP_34_I156_D: "Журнал с цепью",
  T_49_META_TYP_34_I157_D: "Захват Lv1",
  T_49_META_TYP_34_I158_D: "Захват Lv2",
  T_49_META_TYP_34_I159_D: "Рукоятка Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Складной кронштейн",
  T_49_META_TYP_34_I161_D: "Стрелковая рукоятка",
  T_49_META_TYP_34_I162_D: "Колодки для дробовика",
  T_49_META_TYP_34_I163_D: "Снайперские приклады",
  T_49_META_TYP_34_I164_D: "Тепловизионный прицел",
  T_49_META_TYP_34_I165_D: "Приклад Lv1",
  T_49_META_TYP_34_I166_D: "Сток Lv2",
  T_49_META_TYP_34_I167_D: "Запас Lv3",
  T_49_META_TYP_34_I168_D: "Расширитель щита",
  T_49_META_TYP_34_I169_D: "Полная броня тела",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Лишняя куртка",
  T_49_META_TYP_34_I171_D: "Взрывозащищенная куртка",
  T_49_META_TYP_34_I172_D: "Расширение рюкзака",
  T_49_META_TYP_34_I173_D: "Целебный дыхательный аппарат",
  T_49_META_TYP_34_I174_D: "Горизалин",
  T_49_META_TYP_34_I175_D: "Аптечка",
  T_49_META_TYP_34_I176_D: "Ремонтный комплект для защиты",
  T_49_META_TYP_34_I177_D: "Часовая башня с искусственным интеллектом из высокотехнологичных материалов, которая активно ищет и атакует врагов в определенном радиусе действия",
  T_49_META_TYP_34_I178_D: "Гриб 1 уровня",
  T_49_META_TYP_34_I179_D: "Гриб 2-го уровня",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Уровень 3 Гриб",
  T_49_META_TYP_34_I181_D: "Уровень 4 Гриб",
  T_49_META_TYP_34_I182_D: "Личный Дрон",
  T_49_META_TYP_34_I184_D: "Сенсорные мины",
  T_49_META_TYP_34_I185_D: "Реактивные летающие ботинки",
  T_49_META_TYP_34_I186_D: "Прыгающие ботинки",
  T_49_META_TYP_34_I187_D: "Планер",
  T_49_META_TYP_34_I188_D: "Граната-приманка",
  T_49_META_TYP_34_I189_D: "Скейтборд Maglev",
  T_49_META_TYP_34_I19_D: "Пустынный орел",
  T_49_META_TYP_34_I190_D: "Саперные щипцы",
  T_49_META_TYP_34_I191_D: "Модернизация оружия",
  T_49_META_TYP_34_I192_D: "Боеприпасы для винтовки",
  T_49_META_TYP_34_I193_D: "Боеприпасы для пистолета",
  T_49_META_TYP_34_I194_D: "Патроны для снайперской винтовки",
  T_49_META_TYP_34_I195_D: "Патроны для дробовика",
  T_49_META_TYP_34_I196_D: "Патроны для пистолета-пулемета",
  T_49_META_TYP_34_I197_D: "Стрелы",
  T_49_META_TYP_34_I198_D: "Граната M79",
  T_49_META_TYP_34_I199_D: "Огнеметные пули",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "ТРОГАТЕЛЬНАЯ НОЖНИЦА2",
  T_49_META_TYP_34_I201_D: "Крючок",
  T_49_META_TYP_34_I202_D: "Футбольное оружие",
  T_49_META_TYP_34_I203_D: "Бокс",
  T_49_META_TYP_34_I204_D: "Огнемет",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "ГраффитиКарта",
  T_49_META_TYP_34_I209_D: "ДетективКарта",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ПрофессорКарта",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "СуперзвездаКарта",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "Карта злодея",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Футбольный щит",
  T_49_META_TYP_34_I30_D: "Энергетическая пушка с перегревом",
  T_49_META_TYP_34_I31_D: "Перегретая пушка-I",
  T_49_META_TYP_34_I32_D: "Перегретая пушка-II",
  T_49_META_TYP_34_I33_D: "Перегретая пушка-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Лечебный пистолет-Y",
  T_49_META_TYP_34_I36_D: "Исцеление снайпера",
  T_49_META_TYP_34_I37_D: "Лечебный пистолет",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "ГРОЗА",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "ГРОЗА",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Пан",
  T_49_META_TYP_34_I44_D: "Мачете",
  T_49_META_TYP_34_I45_D: "СКС",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Бизон",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "СВД",
  T_49_META_TYP_34_I53_D: "СВД",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Бейсбольная бита",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Самурайский меч",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Гатлинг",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Пистолет с крюком",
  T_49_META_TYP_34_I71_D: "Нож FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 раунда 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Дятел",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Коса",
  T_49_META_TYP_34_I87_D: "Молот с большой головой",
  T_49_META_TYP_34_I88_D: "Летающий кинжал (можно подобрать)",
  T_49_META_TYP_34_I89_D: "Корд",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "УСП-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "УЗИ",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Легкий",
  T_49_META_TYP_340_I1_D: "Простой",
  T_49_META_TYP_340_I2_D: "Нормальный",
  T_49_META_TYP_340_I3_D: "Умеренный",
  T_49_META_TYP_340_I4_D: "Сложный",
  T_49_META_TYP_340_I5_D: "Инферно",
  T_49_META_TYP_342_I0_D: "Начало События",
  T_49_META_TYP_342_I1_D: "Остановка События",
  T_49_META_TYP_342_I2_D: "Пауза События",
  T_49_META_TYP_342_I3_D: "Сколько времени нужно ждать после создания, чтобы запустить таймер, в миллисекундах",
  T_49_META_TYP_342_I4_D: "Количество Циклов",
  T_49_META_TYP_342_I5_D: "События",
  T_49_META_TYP_342_I6_D: "Обратный отсчет или положительный таймер",
  T_49_META_TYP_342_I7_D: "Статус игрока",
  T_49_META_TYP_342_I8_D: "Время окончания таймера в секундах",
  T_49_META_TYP_345_I10_D: "Ручная пушка",
  T_49_META_TYP_345_I12_D: "Пушка с ледяной стеной",
  T_49_META_TYP_345_I13_D: "Огнемет",
  T_49_META_TYP_345_I4_D: "Дробовик",
  T_49_META_TYP_345_I6_D: "Специальное оружие",
  T_49_META_TYP_345_I8_D: "Хранимое оружие",
  T_49_META_TYP_346_I0_D: "Боеприпасы для винтовки",
  T_49_META_TYP_346_I1_D: "Боеприпасы для пистолета",
  T_49_META_TYP_346_I2_D: "Патроны для снайперской винтовки",
  T_49_META_TYP_346_I3_D: "Патроны для дробовика",
  T_49_META_TYP_346_I4_D: "Патроны для пистолета-пулемета",
  T_49_META_TYP_346_I5_D: "Стрелы",
  T_49_META_TYP_346_I6_D: "Граната M79",
  T_49_META_TYP_346_I7_D: "Крючок",
  T_49_META_TYP_346_I8_D: "Специализированная граната M79",
  T_49_META_TYP_347_I3_D: "Может быть объединен с Relative Motion, если true, должен быть объединен с Absolute Motion, если false, иначе атрибут не будет действовать корректно.",
  T_49_META_TYP_347_I6_D: "Значение Дельта",
  T_49_META_TYP_350_I0_D: "Спорткар",
  T_49_META_TYP_350_I1_D: "Мотоцикл",
  T_49_META_TYP_350_I2_D: "Джип",
  T_49_META_TYP_350_I3_D: "Внедорожник",
  T_49_META_TYP_350_I4_D: "Грузовик-монстр",
  T_49_META_TYP_350_I5_D: "Грузовик-мутант",
  T_49_META_TYP_352_I1_D: "Спрайт при невыборе",
  T_49_META_TYP_352_I2_D: "Тип изображения не отмечен",
  T_49_META_TYP_352_I3_D: "Цвет при невыборе",
  T_49_META_TYP_352_I4_D: "Спрайт при выборе",
  T_49_META_TYP_352_I5_D: "Тип изображения выбран",
  T_49_META_TYP_352_I6_D: "Цвет при выборе",
  T_49_META_TYP_353_I0_D: "Количество восстановления здоровья",
  T_49_META_TYP_353_I1_D: "Скорость восстановления здоровья (мс)",
  T_49_META_TYP_353_I2_D: "Требуемое время (мс)",
  T_49_META_TYP_354_I0_D: "Количество восстановления энергии (EP)",
  T_49_META_TYP_355_I0_D: "Количество восстановления здоровья",
  T_49_META_TYP_355_I1_D: "Количество восстановления энергии (EP)",
  T_49_META_TYP_355_I2_D: "Требуемое время (мс)",
  T_49_META_TYP_356_I0_D: "Предметы Падения",
  T_49_META_TYP_356_I1_D: "Время выпадения ящика мс",
  T_49_META_TYP_356_I2_D: "Состояние Авиапосылки",
  T_49_META_TYP_357_I0_D: "Поверхность",
  T_49_META_TYP_357_I1_D: "Граница",
  T_49_META_TYP_359_I0_D: "Использовать ли контроллер игрока с физическими эффектами",
  T_49_META_TYP_359_I1_D: "При размещении на склоне, превышающем этот угол, тело будет скользить вниз.",
  T_49_META_TYP_359_I10_D: "Гравитационное ускорение только для данного контроллера игрока",
  T_49_META_TYP_359_I11_D: "Масса в кг",
  T_49_META_TYP_359_I12_D: "Если уклон превышает максимальный угол подъема, капсула будет скользить вниз.",
  T_49_META_TYP_359_I16_D: "Если включено, движение контролируется серверными кортежами или скриптами.",
  T_49_META_TYP_359_I17_D: "Если включено, можно настраивать силу, прикладываемую при надавливании персонажа на жесткое тело.",
  T_49_META_TYP_359_I18_D: "Величина силы, прикладываемой, когда персонаж толкает жесткое тело",
  T_49_META_TYP_359_I19_D: "True, когда нижняя часть тела касается тела столкновения, обычно используется для определения того, находится ли игрок на земле или нет.",
  T_49_META_TYP_359_I2_D: "Только препятствия выше этой высоты будут иметь эффект блокировки, в диапазоне [0,Высота].",
  T_49_META_TYP_359_I20_D: "Настраиваемый уровень физики, значение [0,15].",
  T_49_META_TYP_359_I21_D: "Вращение с гравитацией",
  T_49_META_TYP_359_I3_D: "Позволяет изменять глубину корпуса капсулы. Может предотвратить застревание или тряску персонажа, не рекомендуется изменять без особых надобностей. Диапазон значений (0,Радиус]",
  T_49_META_TYP_359_I4_D: "Минимальное расстояние перемещения, любое перемещение меньше этого значения не будет выполнено. Если нет особой необходимости, рекомендуется оставить значение 0.",
  T_49_META_TYP_359_I5_D: "Смещение центра блока столкновений от начала локальных координат.",
  T_49_META_TYP_359_I6_D: "Радиус капсулы, минимальное значение 0,01.",
  T_49_META_TYP_359_I7_D: "Общая высота капсулы, включая верхнее и нижнее полушария, мин. 2*Радиус",
  T_49_META_TYP_359_I8_D: "Текущая линейная скорость, в м/с",
  T_49_META_TYP_360_I0_D: "Угол стрельбы влево",
  T_49_META_TYP_360_I1_D: "Угол стрельбы вправо",
  T_49_META_TYP_360_I2_D: "Минимальный угол подъема",
  T_49_META_TYP_360_I3_D: "Максимальный угол снижения",
  T_49_META_TYP_360_I4_D: "Скорость вылета пули",
  T_49_META_TYP_362_I0_D: "Время заморозки, вызванной попаданием в игрока, в секундах",
  T_49_META_TYP_363_I0_D: "Отключить Хад Запросить покупку",
  T_49_META_TYP_363_I1_D: "Запросить помощь у команды для покупки",
  T_49_META_TYP_363_I2_D: "Приобрести, запросив помощь в лагере",
  T_49_META_TYP_364_I0_D: "Является Центр Позиции",
  T_49_META_TYP_364_I1_D: "Зацикливать или нет",
  T_49_META_TYP_364_I2_D: "Название анимации",
  T_49_META_TYP_364_I3_D: "Автовоспроизведение или нет",
  T_49_META_TYP_364_I4_D: "Использовать Пользовательский Ресурс",
  T_49_META_TYP_366_I0_D: "Указывается UUID ресурса Batch для рендеринга.",
  T_49_META_TYP_367_I1_D: "Показать Метку",
  T_49_META_TYP_367_I2_D: "Стиль иконок для отмеченных целей",
  T_49_META_TYP_367_I3_D: "Цвет наложения иконок, отображаемых на отмеченных целях",
  T_49_META_TYP_367_I4_D: "Стиль иконок, отображаемых на шкале",
  T_49_META_TYP_367_I5_D: "Цвет наложения значка, отображаемого на шкале",
  T_49_META_TYP_367_I6_D: "Всегда Показать Отметку",
  T_49_META_TYP_370_I0_D: "Основной заголовок",
  T_49_META_TYP_370_I1_D: "Субтитры",
  T_49_META_TYP_370_I2_D: "Цвет верхнего фона",
  T_49_META_TYP_370_I3_D: "Цвет нижнего фона",
  T_49_META_TYP_371_I2_D: "Левый Счет",
  T_49_META_TYP_371_I3_D: "Правый Счет",
  T_49_META_TYP_371_I4_D: "Последний счет слева, используемый для воспроизведения анимации переключения счета",
  T_49_META_TYP_371_I5_D: "Последний счет справа, используемый для анимации переключения счета",
  T_49_META_TYP_372_I0_D: "Стоящий",
  T_49_META_TYP_372_I1_D: "Показать приседание",
  T_49_META_TYP_372_I10_D: "Высокое падение",
  T_49_META_TYP_372_I11_D: "Низкое падение, например, прыжок",
  T_49_META_TYP_372_I12_D: "Летающие ботинки",
  T_49_META_TYP_372_I13_D: "Два прыжка с трамплина",
  T_49_META_TYP_372_I14_D: "Сидя на стуле",
  T_49_META_TYP_372_I15_D: "Выброс с помощью катапульты",
  T_49_META_TYP_372_I16_D: "Этап подготовки катапульты",
  T_49_META_TYP_372_I17_D: "Планерный реквизит скользит",
  T_49_META_TYP_372_I18_D: "Падение стойки планера",
  T_49_META_TYP_372_I19_D: "Отскакивание от шин",
  T_49_META_TYP_372_I2_D: "Бег",
  T_49_META_TYP_372_I20_D: "Отскакивание от человеческих шин",
  T_49_META_TYP_372_I21_D: "Действие в зоне развлечений",
  T_49_META_TYP_372_I22_D: "Прокатиться на летающей машине",
  T_49_META_TYP_372_I23_D: "Вход в пушку",
  T_49_META_TYP_372_I24_D: "При выходе из пушки, транспортера и т.д. это состояние, если объект катания летает",
  T_49_META_TYP_372_I25_D: "После прыжка с трамплина",
  T_49_META_TYP_372_I26_D: "После спуска с зиплайна",
  T_49_META_TYP_372_I27_D: "Не используется",
  T_49_META_TYP_372_I3_D: "Лежать и ползти",
  T_49_META_TYP_372_I4_D: "Плавание",
  T_49_META_TYP_372_I5_D: "Падение вертикально",
  T_49_META_TYP_372_I6_D: "Через стену",
  T_49_META_TYP_372_I7_D: "Неиспользованный",
  T_49_META_TYP_372_I8_D: "Сбит с ног, но не мертв",
  T_49_META_TYP_372_I9_D: "Водный скейтбординг",
  T_49_META_TYP_374_I0_D: "Цвета жизни, уровня и обводки",
  T_49_META_TYP_374_I1_D: "Когда значение жизни уменьшается, потерянная часть кратковременно отображается этим цветом.",
  T_49_META_TYP_374_I10_D: "Смещение относительно объекта, за которым нужно следовать",
  T_49_META_TYP_374_I11_D: "Количество жизни между каждой линией, если оно меньше или равно 0, она не будет отображаться.",
  T_49_META_TYP_374_I12_D: "Всего ХП",
  T_49_META_TYP_374_I13_D: "Текущее Здоровье",
  T_49_META_TYP_374_I14_D: "Если включено, изменения крови будут окрашиваться в разные цвета.",
  T_49_META_TYP_374_I15_D: "Если включено, атрибут смещения переносится в мировую систему координат с помощью локальной системы координат.",
  T_49_META_TYP_374_I2_D: "Этот цвет кратковременно отображается для растущей части значения жизни, когда оно увеличивается.",
  T_49_META_TYP_374_I3_D: "Цвет границы значения жизни и нижней части виньетки.",
  T_49_META_TYP_374_I4_D: "Диапазон 0~1, прозрачность всего пользовательского интерфейса.",
  T_49_META_TYP_374_I5_D: "Определяет общее масштабирование пользовательского интерфейса, а также масштабирование шрифта.",
  T_49_META_TYP_374_I6_D: "Указывает имя владельца текущего пятна крови.",
  T_49_META_TYP_374_I8_D: "Длина части пятна крови на экране.",
  T_49_META_TYP_374_I9_D: "Должна следовать за сущностью с компонентом Transform.",
  T_49_META_TYP_375_I1_D: "Боевая сущность",
  T_49_META_TYP_376_I1_D: "Боевая сущность",
  T_49_META_TYP_38_I0_D: "Прозрачность",
  T_49_META_TYP_382_I0_D: "По умолчанию",
  T_49_META_TYP_382_I1_D: "Пропустить состояние нокдауна и просто умереть",
  T_49_META_TYP_382_I2_D: "Без пропуска поверженного",
  T_49_META_TYP_387_I1_D: "Разрешить нажатие вне области",
  T_49_META_TYP_389_I0_D: "Смещение базы по умолчанию",
  T_49_META_TYP_389_I1_D: "Спрайт фона",
  T_49_META_TYP_389_I10_D: "Неактивный альфа",
  T_49_META_TYP_389_I2_D: "Радиус фона",
  T_49_META_TYP_389_I3_D: "Изображение колпачка джойстика",
  T_49_META_TYP_389_I4_D: "Радиус колпачка джойстика",
  T_49_META_TYP_389_I5_D: "Радиус перетаскивания колпачка джойстика",
  T_49_META_TYP_389_I6_D: "Спрайт стрелки",
  T_49_META_TYP_389_I7_D: "Размер стрелки",
  T_49_META_TYP_389_I8_D: "Смещение стрелки",
  T_49_META_TYP_389_I9_D: "Активный альфа",
  T_49_META_TYP_39_I1_D: "Форма спрайта",
  T_49_META_TYP_39_I10_D: "Верхний градиент",
  T_49_META_TYP_39_I11_D: "Нижний градиент",
  T_49_META_TYP_39_I12_D: "Верхний альфа",
  T_49_META_TYP_39_I13_D: "Нижний альфа",
  T_49_META_TYP_39_I3_D: "Переворот",
  T_49_META_TYP_39_I4_D: "Заполненный",
  T_49_META_TYP_39_I5_D: "Центр невидим",
  T_49_META_TYP_39_I6_D: "Направление заполнения",
  T_49_META_TYP_39_I7_D: "Значение заполнения",
  T_49_META_TYP_39_I8_D: "Инвертировать заполнение",
  T_49_META_TYP_39_I9_D: "Градиент",
  T_49_META_TYP_392_I0_D: "Время появления безопасной зоны в игре за ход по умолчанию равно 0, в мс.",
  T_49_META_TYP_392_I1_D: "Время, необходимое для уменьшения круга, в мс",
  T_49_META_TYP_392_I10_D: "Время окончания круга, в мс",
  T_49_META_TYP_392_I12_D: "Радиус конечного круга",
  T_49_META_TYP_392_I13_D: "Время начала сужения",
  T_49_META_TYP_392_I14_D: "Интервал Урона (мс)",
  T_49_META_TYP_392_I3_D: "Количество урона, наносимого игроку в отравленном круге за один ход.",
  T_49_META_TYP_392_I4_D: "Список игроков в безопасной зоне",
  T_49_META_TYP_392_I5_D: "Время исчезновения безопасной зоны, безопасная зона не будет создана, если время исчезновения безопасной зоны меньше эффективного времени.",
  T_49_META_TYP_392_I6_D: "ID Группы",
  T_49_META_TYP_392_I7_D: "Радиус начального круга",
  T_49_META_TYP_392_I8_D: "Состояние конца",
  T_49_META_TYP_392_I9_D: "Статус",
  T_49_META_TYP_394_I0_D: "Значение около 3.1416",
  T_49_META_TYP_394_I1_D: "Значение около 2.7183",
  T_49_META_TYP_396_I0_D: "Заголовок",
  T_49_META_TYP_396_I1_D: "Содержание",
  T_49_META_TYP_396_I2_D: "Опции",
  T_49_META_TYP_396_I3_D: "Показать фон",
  T_49_META_TYP_399_I0_D: "Высота прыжка",
  T_49_META_TYP_399_I1_D: "Количество последовательных прыжков, которые можно выполнить до приземления",
  T_49_META_TYP_399_I2_D: "Сколько еще прыжков можно совершить перед приземлением",
  T_49_META_TYP_399_I3_D: "Перемещение в воздухе",
  T_49_META_TYP_40_I1_D: "Ярлык",
  T_49_META_TYP_40_I10_D: "Межстрочный интервал",
  T_49_META_TYP_40_I11_D: "Метод переполнения",
  T_49_META_TYP_40_I12_D: "Стиль шрифта",
  T_49_META_TYP_40_I13_D: "Применить тень",
  T_49_META_TYP_40_I14_D: "Цвет тени",
  T_49_META_TYP_40_I15_D: "Смещение тени",
  T_49_META_TYP_40_I3_D: "Локализованный ключ, может использоваться на нескольких языках",
  T_49_META_TYP_40_I5_D: "Метод выравнивания",
  T_49_META_TYP_40_I6_D: "Вертикальное выравнивание",
  T_49_META_TYP_40_I7_D: "Жирный",
  T_49_META_TYP_40_I8_D: "Курсив",
  T_49_META_TYP_40_I9_D: "Подчёркнутый",
  T_49_META_TYP_400_I0_D: "Активный",
  T_49_META_TYP_400_I1_D: "Пассивный",
  T_49_META_TYP_400_I2_D: "Без атаки",
  T_49_META_TYP_401_I0_D: "Не могут вести огонь.",
  T_49_META_TYP_401_I1_D: "Может вести непрерывный огонь",
  T_49_META_TYP_401_I2_D: "Стреляет один раз за команду атаки",
  T_49_META_TYP_401_I3_D: "Три раза за команду атаки.",
  T_49_META_TYP_401_I4_D: "Стреляет дважды за команду атаки",
  T_49_META_TYP_401_I5_D: "Парировать",
  T_49_META_TYP_402_I0_D: "Цели для друга",
  T_49_META_TYP_402_I1_D: "Тип функции",
  T_49_META_TYP_402_I2_D: "Стиль",
  T_49_META_TYP_403_I0_D: "Добавить друга",
  T_49_META_TYP_403_I1_D: "Сообщить",
  T_49_META_TYP_404_I0_D: "Светлый",
  T_49_META_TYP_404_I1_D: "Тёмный",
  T_49_META_TYP_405_I0_D: "По иерархии",
  T_49_META_TYP_405_I1_D: "По приоритету от высокого к низкому",
  T_49_META_TYP_405_I2_D: "По приоритету от низкого к высокому",
  T_49_META_TYP_406_I0_D: "Контролирует расстояние движения игрока при обгоне",
  T_49_META_TYP_406_I1_D: "Управляет высотой движения тела игрока во время прыжка.",
  T_49_META_TYP_407_I0_D: "Локальный",
  T_49_META_TYP_407_I1_D: "Клиент",
  T_49_META_TYP_407_I2_D: "Сервер",
  T_49_META_TYP_407_I3_D: "Оба",
  T_49_META_TYP_409_I0_D: "Нет ошибок",
  T_49_META_TYP_409_I1_D: "Таймаут хранения данных, в основном для операций чтения",
  T_49_META_TYP_409_I10_D: "Не удалось сменить команду - недействительная целевая команда",
  T_49_META_TYP_409_I11_D: "Неудачная смена команды - мертвый игрок не имеет права менять команду",
  T_49_META_TYP_409_I12_D: "Неудачная смена команды - не разрешено менять команду в носителе",
  T_49_META_TYP_409_I2_D: "Частота чтения и записи данных в хранилище превышает предел",
  T_49_META_TYP_409_I3_D: "Исключение параметра",
  T_49_META_TYP_409_I4_D: "Не удалось создать комнату: нет действительных PersonaID",
  T_49_META_TYP_409_I5_D: "Неопределенный статус ошибки",
  T_49_META_TYP_409_I6_D: "Коммерческий сервис закрыт, пользователь больше не имеет доступа к сервису разработчика",
  T_49_META_TYP_409_I7_D: "Не удалось сменить команду - режим не поддерживается",
  T_49_META_TYP_409_I8_D: "Смена команды не удалась - в настоящее время вы уже находитесь в целевой команде",
  T_49_META_TYP_409_I9_D: "Не удалось изменить очередь - недействительная цель",
  T_49_META_TYP_41_I0_D: "Форма спрайта",
  T_49_META_TYP_41_I19_D: "Отключить блок столкновений",
  T_49_META_TYP_41_I3_D: "Отключить цвет",
  T_49_META_TYP_41_I4_D: "Цвет при нажатии",
  T_49_META_TYP_41_I5_D: "Тип заполнения",
  T_49_META_TYP_41_I6_D: "Это кнопка FE",
  T_49_META_TYP_41_I7_D: "Спрайт при нажатии",
  T_49_META_TYP_41_I8_D: "Тип спрайта при нажатии",
  T_49_META_TYP_41_I9_D: "Тип переворота",
  T_49_META_TYP_411_I0_D: "Скорость Вперед",
  T_49_META_TYP_411_I1_D: "Скорость Назад",
  T_49_META_TYP_411_I2_D: "Скорость Вверх",
  T_49_META_TYP_411_I3_D: "Скорость Вниз",
  T_49_META_TYP_411_I4_D: "Минимальный Урон Гранаты",
  T_49_META_TYP_411_I5_D: "Максимальный Урон Гранаты",
  T_49_META_TYP_411_I6_D: "Дальность Гранаты",
  T_49_META_TYP_412_I0_D: "Лошадиная сила, развиваемая транспортным средством при использовании кнопки газа",
  T_49_META_TYP_412_I1_D: "Лошадиная сила, развиваемая автомобилем при использовании кнопки заднего хода/тормоза",
  T_49_META_TYP_412_I2_D: "Максимальный угол поворота руля на высокой скорости",
  T_49_META_TYP_412_I3_D: "Порог скорости, применяемый к максимальному углу поворота руля на высоких скоростях",
  T_49_META_TYP_412_I4_D: "После достижения максимальной скорости носитель больше не выдает лошадиных сил, но он может превысить эту максимальную скорость (например, на спуске).",
  T_49_META_TYP_412_I5_D: "Когда перевозчик не маневрирует, он замедляется путем умножения IdleBrakeInput на BrakeTorque",
  T_49_META_TYP_412_I6_D: "Расчет повреждений при столкновениях с применением параметров формулы повреждений",
  T_49_META_TYP_412_I7_D: "Расчет повреждений при таране, повреждения не увеличиваются даже при превышении скорости",
  T_49_META_TYP_412_I8_D: "Расчет повреждений при таране, минимальный урон",
  T_49_META_TYP_412_I9_D: "Расчет повреждений при таране, максимальный урон",
  T_49_META_TYP_413_I0_D: "Трансформируемый костюм игрока (NPC)",
  T_49_META_TYP_414_I1_D: "Широкий диапазон",
  T_49_META_TYP_415_I0_D: "ID Персонажа",
  T_49_META_TYP_415_I1_D: "Псевдоним",
  T_49_META_TYP_415_I2_D: "Аватар",
  T_49_META_TYP_416_I1_D: "Персона, к которой она привязана",
  T_49_META_TYP_416_I2_D: "Смещение",
  T_49_META_TYP_416_I3_D: "Высота",
  T_49_META_TYP_416_I4_D: "Отвечать ли на системные сообщения",
  T_49_META_TYP_416_I5_D: "Прозвище персоны",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Псевдоним пользователя",
  T_49_META_TYP_416_I8_D: "UserAvatar",
  T_49_META_TYP_417_I0_D: "Идентификатор ресурса",
  T_49_META_TYP_418_I0_D: "Истечение срока действия членства",
  T_49_META_TYP_418_I1_D: "Стать членом",
  T_49_META_TYP_418_I2_D: "Продлить членство",
  T_49_META_TYP_42_I0_D: "Текст по умолчанию",
  T_49_META_TYP_42_I1_D: "Активный текст",
  T_49_META_TYP_42_I10_D: "Максимальная длина",
  T_49_META_TYP_42_I14_D: "Цвет при нажатии",
  T_49_META_TYP_42_I16_D: "Локализованный ключ, доступен на нескольких языках",
  T_49_META_TYP_42_I3_D: "Метод выравнивания",
  T_49_META_TYP_42_I4_D: "Вертикальное выравнивание",
  T_49_META_TYP_42_I5_D: "Жирный",
  T_49_META_TYP_42_I6_D: "Курсив",
  T_49_META_TYP_42_I7_D: "Подчёркнутый",
  T_49_META_TYP_42_I8_D: "Межстрочный интервал",
  T_49_META_TYP_42_I9_D: "Перенос слов",
  T_49_META_TYP_424_I0_D: "Линейный туман",
  T_49_META_TYP_424_I1_D: "Экспоненциальный туман",
  T_49_META_TYP_424_I2_D: "Экспоненциальный квадратный туман",
  T_49_META_TYP_426_I0_D: "Интенсивность",
  T_49_META_TYP_426_I1_D: "Диапазон",
  T_49_META_TYP_426_I2_D: "Угол конуса в градусах",
  T_49_META_TYP_426_I3_D: "Цвет света",
  T_49_META_TYP_428_I0_D: "Идентификаторы скинов оружия",
  T_49_META_TYP_428_I2_D: "ID костюма",
  T_49_META_TYP_428_I3_D: "ID головного убора",
  T_49_META_TYP_428_I4_D: "ID лица",
  T_49_META_TYP_428_I5_D: "ID макияжа",
  T_49_META_TYP_428_I6_D: "ID верхней части тела",
  T_49_META_TYP_428_I7_D: "ID нижней части тела",
  T_49_META_TYP_428_I8_D: "ID обуви",
  T_49_META_TYP_431_I1_D: "Траектория движения целевого объекта",
  T_49_META_TYP_431_I3_D: "Скорость движения, единица измерения м/с",
  T_49_META_TYP_431_I4_D: `Направлено ли движение по касательной к траектории или нет 
 по умолчанию False, направление движения объекта остается неизменным 
 по умолчанию True, движущийся объект будет обращен по направлению движения вперед`,
  T_49_META_TYP_431_I5_D: "Процент воспроизведения",
  T_49_META_TYP_432_I0_D: "Угол поворота, влияет на радиальное вращение траектории с обеих сторон от этой точки",
  T_49_META_TYP_432_I1_D: "Относительное положение контрольной точки касательной к путевой точке, которая определяет касательную к пути.",
  T_49_META_TYP_433_I0_D: "Линейная интерполяция между точками пути",
  T_49_META_TYP_433_I1_D: "Кривая интерполяция между точками пути для плавного перемещения",
  T_49_META_TYP_433_I2_D: "Поддержка ручной настройки касательных к точкам кривой",
  T_49_META_TYP_434_I0_D: "Тип пути",
  T_49_META_TYP_434_I1_D: "Общая длина пути",
  T_49_META_TYP_434_I2_D: "Начинается и заканчивается ли путь в одно и то же время.",
  T_49_META_TYP_434_I3_D: "Коллекция путевых точек",
  T_49_META_TYP_437_I3_D: "Игроки слева",
  T_49_META_TYP_437_I4_D: "Игроки справа",
  T_49_META_TYP_437_I5_D: "Массив имен типов точек",
  T_49_META_TYP_437_I6_D: "Массив точек слева (список 1D: игрок; список 2D: данные точек, заполненные в соответствии с пользовательским типом точек)",
  T_49_META_TYP_437_I7_D: "Массив точек справа (список 1D: игроки; список 2D: данные точек, заполненные в соответствии с пользовательскими типами точек)",
  T_49_META_TYP_438_I1_D: "Массив сгруппированных игроков",
  T_49_META_TYP_438_I2_D: "Массив сгруппированных рейтингов",
  T_49_META_TYP_438_I3_D: "Массив сгруппированных очков",
  T_49_META_TYP_438_I4_D: "Массив названий типов очков",
  T_49_META_TYP_438_I5_D: "Массив цветов групп",
  T_49_META_TYP_438_I6_D: "Массив очков игроков (соответствует их порядку, когда они не сгруппированы)",
  T_49_META_TYP_442_I1_D: "Левый Счет",
  T_49_META_TYP_442_I10_D: "Иконка правой смерти",
  T_49_META_TYP_442_I2_D: "Правый Счет",
  T_49_META_TYP_442_I3_D: "Количество выживших слева",
  T_49_META_TYP_442_I4_D: "Выживших справа",
  T_49_META_TYP_442_I5_D: "Смерть слева",
  T_49_META_TYP_442_I6_D: "Правые погибшие",
  T_49_META_TYP_442_I7_D: "Значок выжившего слева",
  T_49_META_TYP_442_I8_D: "Иконка выжившего справа",
  T_49_META_TYP_442_I9_D: "Левая иконка смерти",
  T_49_META_TYP_444_I0_D: "Английский",
  T_49_META_TYP_444_I1_D: "Упрощенный китайский",
  T_49_META_TYP_444_I10_D: "Французский",
  T_49_META_TYP_444_I11_D: "Немецкий",
  T_49_META_TYP_444_I12_D: "Турецкий",
  T_49_META_TYP_444_I13_D: "Хинди",
  T_49_META_TYP_444_I14_D: "Японский",
  T_49_META_TYP_444_I15_D: "Румынский",
  T_49_META_TYP_444_I16_D: "Румынский",
  T_49_META_TYP_444_I17_D: "Бирманский",
  T_49_META_TYP_444_I18_D: "Урду",
  T_49_META_TYP_444_I19_D: "Бенгальский",
  T_49_META_TYP_444_I2_D: "Традиционный китайский",
  T_49_META_TYP_444_I3_D: "Тайский",
  T_49_META_TYP_444_I4_D: "Вьетнамский",
  T_49_META_TYP_444_I5_D: "Индонезийский",
  T_49_META_TYP_444_I6_D: "Китайский (упрощенный)",
  T_49_META_TYP_444_I7_D: "Испанский",
  T_49_META_TYP_444_I8_D: "Русский",
  T_49_META_TYP_444_I9_D: "Корейский",
  T_49_META_TYP_51_I0_D: "Обычный зомби",
  T_49_META_TYP_51_I1_D: "Древоруб-зомби",
  T_49_META_TYP_51_I10_D: "Летучая бомба-пчела",
  T_49_META_TYP_51_I11_D: "Зомби-дракон",
  T_49_META_TYP_51_I2_D: "Метатель-зомби",
  T_49_META_TYP_51_I3_D: "Взрывной зомби",
  T_49_META_TYP_51_I4_D: "Тиран-зомби",
  T_49_META_TYP_51_I5_D: "Метатель-красный зомби",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Танковый зомби",
  T_49_META_TYP_51_I8_D: "Зомби с дрелью",
  T_49_META_TYP_51_I9_D: "Самурай",
  T_49_META_TYP_56_I10_D: "Задержка взрыва",
  T_49_META_TYP_56_I11_D: "Радиус взрыва",
  T_49_META_TYP_56_I12_D: "Урон от взрыва",
  T_49_META_TYP_56_I13_D: "Время горения",
  T_49_META_TYP_56_I14_D: "Урон от горения",
  T_49_META_TYP_56_I15_D: "Интервал урона от горения",
  T_49_META_TYP_56_I17_D: "Пилот транспортного средства",
  T_49_META_TYP_56_I18_D: "Все пассажиры транспортного средства",
  T_49_META_TYP_56_I19_D: "ID обшивки транспортного средства",
  T_49_META_TYP_56_I20_D: "Перенос приоритетов конфигурации игрока",
  T_49_META_TYP_56_I21_D: "Макс. ХП",
  T_49_META_TYP_56_I22_D: "ХП",
  T_49_META_TYP_57_I0_D: "Телепортироваться вручную или автоматически (по умолчанию - вручную)",
  T_49_META_TYP_58_I0_D: "Тип генерируемого баффа",
  T_49_META_TYP_58_I1_D: "Время в секундах от момента получения баффа до момента получения следующего баффа.",
  T_49_META_TYP_59_I0_D: "Тип движения",
  T_49_META_TYP_59_I1_D: "Значение движения по оси X",
  T_49_META_TYP_59_I2_D: "Значение движения по оси Y",
  T_49_META_TYP_59_I3_D: "Значение движения по оси Z",
  T_49_META_TYP_59_I4_D: "Продолжительность движения",
  T_49_META_TYP_59_I5_D: "Продолжительность остановки",
  T_49_META_TYP_59_I6_D: "Отключить возвратное движение",
  T_49_META_TYP_60_I0_D: "Точка награбленного оружия",
  T_49_META_TYP_61_I0_D: "Привязанная валюта",
  T_49_META_TYP_61_I1_D: "Установка диапазона срабатывания",
  T_49_META_TYP_61_I2_D: "Видимость модели",
  T_49_META_TYP_62_I0_D: "Скорость по осям XZ",
  T_49_META_TYP_62_I1_D: "Скорость по оси Y",
  T_49_META_TYP_64_I0_D: "Тип музыкального компонента",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Точка Пути",
  T_49_META_TYP_68_I0_D: "Текущий уровень крови ИИ",
  T_49_META_TYP_68_I1_D: "Текущий максимальный уровень крови ИИ",
  T_49_META_TYP_68_I10_D: "Выбрасывает ли ИИ снаряжение или предметы после смерти.",
  T_49_META_TYP_68_I11_D: "Является ли ИИ в данный момент неуязвимым.",
  T_49_META_TYP_68_I12_D: "Процент урона, наносимого ИИ, когда он получает урон, либо уменьшенный, либо увеличенный.",
  T_49_META_TYP_68_I13_D: "Тип ИИ",
  T_49_META_TYP_68_I14_D: "следует ли автоматически утверждать, что враг",
  T_49_META_TYP_68_I15_D: "0 - автоатака, 1 - атака защитой, 2 - вообще не атакует.",
  T_49_META_TYP_68_I16_D: "ID Пути",
  T_49_META_TYP_68_I17_D: "Цель преследования",
  T_49_META_TYP_68_I18_D: "Цель атаки",
  T_49_META_TYP_68_I19_D: "Координаты точки рождения ИИ",
  T_49_META_TYP_68_I2_D: "Получить сущность команды ИИ.",
  T_49_META_TYP_68_I20_D: "Номер лагеря команды",
  T_49_META_TYP_68_I4_D: "Может изменять силу атаки только обычной атаки, но не атаки навыка.",
  T_49_META_TYP_68_I7_D: "Дальность свободного перемещения ИИ, можно изменить только базовое значение, если есть дополнительный бонус, он будет добавлен поверх этого значения.",
  T_49_META_TYP_68_I8_D: "Дальность обнаружения врагов ИИ, можно изменить только базовое значение, если есть дополнительный бонус, он будет добавлен поверх этого значения.",
  T_49_META_TYP_68_I9_D: "Истинная скорость передвижения, если есть ускорение навыка, то оно будет умножено на него.",
  T_49_META_TYP_70_I0_D: "ID целевой сущности, на которую действует формула, используется внутренними реализациями, не виден игрокам.",
  T_49_META_TYP_70_I1_D: "ID атрибута целевой сущности, на которой работает формула, используется внутренними реализациями, не виден игроку.",
  T_49_META_TYP_70_I2_D: "Минимальное допустимое значение",
  T_49_META_TYP_70_I3_D: "Максимальное допустимое значение",
  T_49_META_TYP_70_I4_D: "Базовый коэффициент",
  T_49_META_TYP_70_I5_D: "Предварительный аккумулятор",
  T_49_META_TYP_70_I6_D: "Множитель",
  T_49_META_TYP_70_I7_D: "Умножить и накапливать",
  T_49_META_TYP_70_I8_D: "Пост-аккумулятор",
  T_49_META_TYP_71_I0_D: "Номер продукта",
  T_49_META_TYP_71_I1_D: "Цена",
  T_49_META_TYP_71_I10_D: "Список товаров",
  T_49_META_TYP_71_I2_D: "Тип валюты",
  T_49_META_TYP_71_I3_D: "Общий лимит",
  T_49_META_TYP_71_I4_D: "Текущий общий лимит",
  T_49_META_TYP_71_I5_D: "Название продукта",
  T_49_META_TYP_71_I6_D: "Описание",
  T_49_META_TYP_71_I7_D: "Список товаров",
  T_49_META_TYP_71_I8_D: "Можно ли купить",
  T_49_META_TYP_71_I9_D: "Путь, по умолчанию пустой",
  T_49_META_TYP_72_I1_D: "Список полок",
  T_49_META_TYP_73_I1_D: "Запрещено ли ручное закрытие",
  T_49_META_TYP_74_I0_D: "Оружие",
  T_49_META_TYP_74_I1_D: "Шлем",
  T_49_META_TYP_74_I2_D: "Бронежилет",
  T_49_META_TYP_74_I3_D: "Граната",
  T_49_META_TYP_75_I0_D: "Односторонний",
  T_49_META_TYP_75_I1_D: "Туда и обратно",
  T_49_META_TYP_76_I0_D: "Только патрулирование. Не атакуют цели по пути следования.",
  T_49_META_TYP_76_I1_D: "Патруль и атака",
  T_49_META_TYP_79_I0_D: "Мощность оружия",
  T_49_META_TYP_79_I1_D: "Дальность атаки",
  T_49_META_TYP_79_I10_D: "Начальная точка разброса",
  T_49_META_TYP_79_I11_D: "ID оружия",
  T_49_META_TYP_79_I12_D: "Минимальное время ожидания между выстрелами в секундах, за один выстрел может быть сделано несколько выстрелов в зависимости от типа огня",
  T_49_META_TYP_79_I13_D: "Игрок, владеющий оружием",
  T_49_META_TYP_79_I14_D: "Расход патронов",
  T_49_META_TYP_79_I15_D: "Тип двойного оружия (0, не двойное оружие 1 и 2 и любое оружие)",
  T_49_META_TYP_79_I16_D: "Коэффициент повреждения брони",
  T_49_META_TYP_79_I17_D: "Эффекты скорости передвижения игрока",
  T_49_META_TYP_79_I18_D: "Процент урона при попадании в туловище",
  T_49_META_TYP_79_I19_D: "Процент урона, наносимого по голове",
  T_49_META_TYP_79_I2_D: "Время ожидания между выстрелами, в секундах.",
  T_49_META_TYP_79_I20_D: "Процент урона при попадании в конечности",
  T_49_META_TYP_79_I21_D: "Дополнительный урон (транспортное средство, бочка с маслом, ледяная стена)",
  T_49_META_TYP_79_I22_D: "Видимый на спине",
  T_49_META_TYP_79_I23_D: "Дополнительный урон при попадании в землю",
  T_49_META_TYP_79_I24_D: "Патроны на выстрел",
  T_49_META_TYP_79_I25_D: "Скорость смены пули (базовая скорость * коэффициент)",
  T_49_META_TYP_79_I26_D: "Текущее количество патронов",
  T_49_META_TYP_79_I27_D: "Идентификатор шкуры оружия",
  T_49_META_TYP_79_I28_D: "Когда конфигурации игрока имеют приоритет, конфигурация скина оружия на игроке переопределяет свойства скина самого оружия",
  T_49_META_TYP_79_I29_D: "При записи скина оружия в свойства оружия, базовое значение оружия зависит от скина оружия",
  T_49_META_TYP_79_I3_D: "Размер магазина патронов",
  T_49_META_TYP_79_I30_D: "Скорость увеличения диффузии (0.1 = 10% расширения коллимации за каждый дополнительный всплеск)",
  T_49_META_TYP_79_I31_D: "Скорость восстановления диффузии",
  T_49_META_TYP_79_I32_D: "Эффект скорости игрока при стрельбе",
  T_49_META_TYP_79_I33_D: "Размер диффузии в случае движения (1,5 = 1,5 * базовый размер коллиматора)",
  T_49_META_TYP_79_I34_D: "Тип Оружия",
  T_49_META_TYP_79_I36_D: "Тип Огня",
  T_49_META_TYP_79_I37_D: "Является одиночным выстрелом",
  T_49_META_TYP_79_I38_D: "Является бесшумным",
  T_49_META_TYP_79_I39_D: "Уровень чувствительности",
  T_49_META_TYP_79_I4_D: "Начальное количество магазинов",
  T_49_META_TYP_79_I5_D: "Пробивная Способность Брони",
  T_49_META_TYP_79_I6_D: "Полный урон на расстоянии",
  T_49_META_TYP_79_I7_D: "Минимальное расстояние до урона",
  T_49_META_TYP_79_I8_D: "Минимальный урон",
  T_49_META_TYP_79_I9_D: "Количество выстрелов, которое можно сделать до начала рассеивания.",
  T_49_META_TYP_80_I1_D: "При значении true отключается ручное выключение.",
  T_49_META_TYP_80_I2_D: "Привязанные сущности магазина",
  T_49_META_TYP_80_I4_D: "ID привязанного кошелька",
  T_49_META_TYP_80_I5_D: "Тип запроса",
  T_49_META_TYP_80_I6_D: "Тип цели для текущего запроса игрока UI",
  T_49_META_TYP_80_I7_D: "ID триггерного игрока",
  T_49_META_TYP_81_I0_D: "Случайный бафф",
  T_49_META_TYP_81_I1_D: "ХП Бафф",
  T_49_META_TYP_81_I2_D: "Патронный бафф",
  T_49_META_TYP_81_I3_D: "Броневой бафф",
  T_49_META_TYP_82_I1_D: "Значок кнопки",
  T_49_META_TYP_82_I3_D: "Позиция относительно точки привязки",
  T_49_META_TYP_83_I1_D: "Деньги",
  T_49_META_TYP_83_I2_D: "Передаваемые параметры",
  T_49_META_TYP_86_I0_D: "Минимум",
  T_49_META_TYP_86_I1_D: "Максимум",
  T_49_META_TYP_86_I2_D: "Базовый коэффициент, умножается на исходное значение перед выполнением всех вычислений.",
  T_49_META_TYP_86_I3_D: "Пре-аккумулятор, накапливается до умножения, участвует в расчетах умножения",
  T_49_META_TYP_86_I4_D: "Последовательные множители, например (уменьшен до 90%, усилен до 110%), имеют эффект Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "Накопитель умножения, например (прибавить 10%, прибавить 5%) эффект Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Пост-аккумулятор, не участвующий в вычислениях умножения, складывается в конце",
  T_49_META_TYP_88_I0_D: "Базовый тип, самая основная внутриигровая валюта, тип общей цены на предметы в текущей версии",
  T_49_META_TYP_89_I0_D: "В текущей версии доступна только базовая валюта",
  T_49_META_TYP_89_I1_D: "Сумма валюты",
  T_49_META_TYP_89_I2_D: "Значок валюты",
  T_49_META_TYP_89_I3_D: "Цвет иконки валюты",
  T_49_META_TYP_90_I0_D: "Содержимое кошелька представляет собой кучу валют",
  T_49_META_TYP_92_I0_D: "Квадратный деревянный ящик",
  T_49_META_TYP_92_I1_D: "Длинный деревянный ящик",
  T_49_META_TYP_92_I10_D: "Турель",
  T_49_META_TYP_92_I100_D: "Лестница",
  T_49_META_TYP_92_I101_D: "Площадка лестницы B",
  T_49_META_TYP_92_I102_D: "Площадка лестницы A",
  T_49_META_TYP_92_I103_D: "Телефонная будка",
  T_49_META_TYP_92_I104_D: "Стена с темой BIS",
  T_49_META_TYP_92_I105_D: "Цветочная клумба с темой BIS",
  T_49_META_TYP_92_I106_D: "Торговый автомат",
  T_49_META_TYP_92_I107_D: "Существа-монстры",
  T_49_META_TYP_92_I108_D: "Генератор единиц",
  T_49_META_TYP_92_I109_D: "Спорткар",
  T_49_META_TYP_92_I11_D: "Охрана",
  T_49_META_TYP_92_I110_D: "Тук-тук",
  T_49_META_TYP_92_I111_D: "Разрушимый деревянный ящик",
  T_49_META_TYP_92_I112_D: "Внедорожник",
  T_49_META_TYP_92_I113_D: "Мотоцикл",
  T_49_META_TYP_92_I114_D: "Грузовик-монстр",
  T_49_META_TYP_92_I115_D: "Генератор монет",
  T_49_META_TYP_92_I116_D: "Площадка лестницы C",
  T_49_META_TYP_92_I117_D: "Знак",
  T_49_META_TYP_92_I118_D: "Забор",
  T_49_META_TYP_92_I119_D: "Машина для изготовления футбольных форм",
  T_49_META_TYP_92_I12_D: "Двухэтажный дом",
  T_49_META_TYP_92_I121_D: "Бетонная колонна",
  T_49_META_TYP_92_I122_D: "Коробка для футбольного лута",
  T_49_META_TYP_92_I123_D: "Бочка с маслом",
  T_49_META_TYP_92_I124_D: "Зона с низким гравитацией",
  T_49_META_TYP_92_I125_D: "Оружие",
  T_49_META_TYP_92_I126_D: "Забор B",
  T_49_META_TYP_92_I127_D: "Малый дом A",
  T_49_META_TYP_92_I128_D: "Поврежденный грузовик",
  T_49_META_TYP_92_I129_D: "Основная сфера",
  T_49_META_TYP_92_I13_D: "Песчаная скульптура",
  T_49_META_TYP_92_I130_D: "Основной конус",
  T_49_META_TYP_92_I131_D: "Основной цилиндр",
  T_49_META_TYP_92_I132_D: "Генератор расходных материалов",
  T_49_META_TYP_92_I133_D: "Пользовательская акватория",
  T_49_META_TYP_92_I134_D: "Стрелка",
  T_49_META_TYP_92_I135_D: "Окрашенный блок",
  T_49_META_TYP_92_I136_D: "Окрашенная бочка",
  T_49_META_TYP_92_I137_D: "Текст",
  T_49_META_TYP_92_I138_D: "Иконка",
  T_49_META_TYP_92_I139_D: "Ледяная кукла",
  T_49_META_TYP_92_I14_D: "Фонтан",
  T_49_META_TYP_92_I140_D: "Капсульный триггер",
  T_49_META_TYP_92_I141_D: "Сферический коллизионный триггер",
  T_49_META_TYP_92_I142_D: "Отражающий блок основного цвета 1",
  T_49_META_TYP_92_I143_D: "Производитель машин на надувных колесах",
  T_49_META_TYP_92_I144_D: "Плитка для парка аттракционов в клеточку",
  T_49_META_TYP_92_I145_D: "Большой экран",
  T_49_META_TYP_92_I146_D: "Подиум",
  T_49_META_TYP_92_I147_D: "Огромный леденец",
  T_49_META_TYP_92_I148_D: "Маленький фургончик с едой B",
  T_49_META_TYP_92_I15_D: "Дерево сакуры",
  T_49_META_TYP_92_I16_D: "Одноэтажный дом",
  T_49_META_TYP_92_I17_D: "Трехэтажный дом",
  T_49_META_TYP_92_I18_D: "Банановое дерево",
  T_49_META_TYP_92_I19_D: "Туалет",
  T_49_META_TYP_92_I2_D: "Длинный деревянный ящик, покрытый кустарником",
  T_49_META_TYP_92_I20_D: "Забор",
  T_49_META_TYP_92_I21_D: "Разрушаемый контейнер",
  T_49_META_TYP_92_I22_D: "Разрушаемое ограждение",
  T_49_META_TYP_92_I23_D: "Шина",
  T_49_META_TYP_92_I24_D: "Автодромное колесо",
  T_49_META_TYP_92_I25_D: "Амфибия",
  T_49_META_TYP_92_I26_D: "Джип",
  T_49_META_TYP_92_I27_D: "Мусорное ведро",
  T_49_META_TYP_92_I28_D: "Медицинская палатка",
  T_49_META_TYP_92_I29_D: "Гараж",
  T_49_META_TYP_92_I3_D: "Стог сена",
  T_49_META_TYP_92_I30_D: "Расписная стена",
  T_49_META_TYP_92_I31_D: "Тории",
  T_49_META_TYP_92_I32_D: "Железная платформа",
  T_49_META_TYP_92_I33_D: "Контейнерный дом",
  T_49_META_TYP_92_I34_D: "Прицеп",
  T_49_META_TYP_92_I35_D: "Стена A",
  T_49_META_TYP_92_I36_D: "Музыкальные ноты - Пианино",
  T_49_META_TYP_92_I37_D: "Музыкальные ноты - Пианино",
  T_49_META_TYP_92_I38_D: "Музыкальные ноты - Барабан",
  T_49_META_TYP_92_I39_D: "Музыкальные ноты - Барабан",
  T_49_META_TYP_92_I4_D: "Разрушенная машина",
  T_49_META_TYP_92_I40_D: "Музыкальные ноты - Синтезатор A",
  T_49_META_TYP_92_I41_D: "Музыкальные ноты - Синтезатор A",
  T_49_META_TYP_92_I42_D: "Музыкальные ноты - Синтезатор B",
  T_49_META_TYP_92_I43_D: "Музыкальные ноты - Синтезатор B",
  T_49_META_TYP_92_I44_D: "Музыкальные ноты - Синтезатор C",
  T_49_META_TYP_92_I45_D: "Музыкальные ноты - Синтезатор C",
  T_49_META_TYP_92_I46_D: "Генератор баффов",
  T_49_META_TYP_92_I47_D: "Механизмы пропеллеров",
  T_49_META_TYP_92_I48_D: "Лут с кастрюли",
  T_49_META_TYP_92_I49_D: "Куб",
  T_49_META_TYP_92_I5_D: "Разрушенный автобус",
  T_49_META_TYP_92_I50_D: "Круг",
  T_49_META_TYP_92_I51_D: "Молоток",
  T_49_META_TYP_92_I52_D: "Движущаяся доска",
  T_49_META_TYP_92_I53_D: "Движущаяся мишень",
  T_49_META_TYP_92_I54_D: "Выдвижная стена",
  T_49_META_TYP_92_I55_D: "Компонент оружия Loot Point",
  T_49_META_TYP_92_I56_D: "Компонент пули с лут-поинтом",
  T_49_META_TYP_92_I57_D: "Компонент расходуемого предмета Loot Point",
  T_49_META_TYP_92_I58_D: "Компоненты метаемых предметов",
  T_49_META_TYP_92_I59_D: "Множитель лут-поинтов",
  T_49_META_TYP_92_I6_D: "Контейнер A",
  T_49_META_TYP_92_I60_D: "Компонент Loot Point Armour",
  T_49_META_TYP_92_I61_D: "Труба I",
  T_49_META_TYP_92_I62_D: "Труба T",
  T_49_META_TYP_92_I63_D: "Перекрестная труба",
  T_49_META_TYP_92_I64_D: "Трубка с углом",
  T_49_META_TYP_92_I65_D: "Кластер гигантских грибов",
  T_49_META_TYP_92_I66_D: "Сушилка для одежды",
  T_49_META_TYP_92_I67_D: "Деревянный мост",
  T_49_META_TYP_92_I68_D: "Экран",
  T_49_META_TYP_92_I69_D: "Бетонная колонна",
  T_49_META_TYP_92_I7_D: "Контейнер B",
  T_49_META_TYP_92_I70_D: "Кактус",
  T_49_META_TYP_92_I71_D: "Мертвая древесина",
  T_49_META_TYP_92_I72_D: "Дворцовый фонарь",
  T_49_META_TYP_92_I73_D: "Уличный светильник",
  T_49_META_TYP_92_I74_D: "Солнечная панель",
  T_49_META_TYP_92_I75_D: "Кондиционер",
  T_49_META_TYP_92_I76_D: "Квадрат",
  T_49_META_TYP_92_I77_D: "Склон",
  T_49_META_TYP_92_I78_D: "Фургон с едой",
  T_49_META_TYP_92_I79_D: "Триггер устранения или неуязвимости",
  T_49_META_TYP_92_I8_D: "Контейнер C",
  T_49_META_TYP_92_I80_D: "Контрольная точка",
  T_49_META_TYP_92_I81_D: "Конечная позиция",
  T_49_META_TYP_92_I82_D: "Кубик",
  T_49_META_TYP_92_I83_D: "Скамейка",
  T_49_META_TYP_92_I84_D: "Автобусная станция",
  T_49_META_TYP_92_I85_D: "Домик для собак",
  T_49_META_TYP_92_I86_D: "Рекламный щит",
  T_49_META_TYP_92_I87_D: "Водяной кувшин",
  T_49_META_TYP_92_I88_D: "Граффити стена",
  T_49_META_TYP_92_I89_D: "Стабильный",
  T_49_META_TYP_92_I9_D: "Кабина",
  T_49_META_TYP_92_I90_D: "Каменный арочный мост",
  T_49_META_TYP_92_I91_D: "Комплект для патио с зонтом",
  T_49_META_TYP_92_I92_D: "Баннер финиша",
  T_49_META_TYP_92_I93_D: "Крепость",
  T_49_META_TYP_92_I94_D: "Точка появления монстра",
  T_49_META_TYP_92_I95_D: "Знак",
  T_49_META_TYP_92_I97_D: "Пользовательский триггер",
  T_49_META_TYP_92_I98_D: "Дверь с двумя створками",
  T_49_META_TYP_92_I99_D: "Баррикада",
  T_49_META_TYP_94_I0_D: "Добавить",
  T_49_META_TYP_94_I1_D: "Умножить",
  T_49_META_TYP_95_I0_D: "Тип валюты",
  T_49_META_TYP_95_I1_D: "Сумма валюты",
  T_49_META_TYP_96_I0_D: "Получить кошелек",
  T_49_META_TYP_96_I1_D: "Позиция отображения (якорь находится в правом верхнем углу)",
  T_49_META_TYP_97_I0_D: "Положение в мировой системе координат",
  T_49_META_TYP_97_I1_D: "Угол поворота в мировой системе координат, компоненты XYZ - тангаж, рысканье и крен соответственно, порядок поворота YXZ.",
  T_49_META_TYP_97_I10_D: "Ориентация оси x местной координаты",
  T_49_META_TYP_97_I11_D: "Ориентация локальной оси координат по оси z",
  T_49_META_TYP_97_I2_D: "Размер масштабирования в мировой системе координат",
  T_49_META_TYP_97_I3_D: "Родительский узел этого узла",
  T_49_META_TYP_97_I4_D: "Вращение в мировой системе координат, выраженное в кватернионах",
  T_49_META_TYP_97_I5_D: "Положение в локальной системе координат",
  T_49_META_TYP_97_I6_D: "Вращение в локальной системе координат, выраженное в кватернионах",
  T_49_META_TYP_97_I7_D: "Угол поворота в локальной системе координат, с компонентами XYZ для тангажа, рысканья и крена, соответственно, и порядком поворота YXZ.",
  T_49_META_TYP_97_I8_D: "Размерность масштабирования в локальной системе координат",
  T_49_META_TYP_97_I9_D: "Ориентация оси y местной системы координат",
  T_49_META_TYP_99_I0_D: "Радиус футбольного поля",
  T_49_META_TYP_99_I1_D: "Коэффициент трения в нормальном состоянии",
  T_49_META_TYP_99_I2_D: "Трение при ударе",
  T_49_META_TYP_99_I3_D: "Минимальный угол стрельбы",
  T_49_META_TYP_99_I4_D: "Минимальный угол подъема",
  T_49_META_TYP_99_I5_D: "Время сброса",
  T_49_META_TYP_99_I6_D: "Максимальный угол стрельбы",
  T_49_META_TYP_99_I7_D: "Сброс позиции",
  T_49_META_TYPE_0_D: "Объект, корень иерархии типов",
  T_49_META_TYPE_1_D: "Контейнер для набора данных в виде списка",
  T_49_META_TYPE_10_D: "Базовый компонент сущности, все компоненты будут объединять этот компонент",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Объект для морфирования",
  T_49_META_TYPE_1010_D: "Информация о таймере",
  T_49_META_TYPE_1011_D: "Баннер открытия",
  T_49_META_TYPE_1012_D: "Баннерные сущности стартуют в раундах с двумя командами, изменение атрибутов сущности влияет на содержимое, отображаемое в соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1013_D: "Баннерная сущность начала общего раунда, изменение атрибутов сущности влияет на отображение содержимого в соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1014_D: "Баннерный баннер командного раунда, изменение атрибутов сущности влияет на отображение на соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1015_D: 'Сущность "Менеджер контрольных точек", изменение атрибутов сущности влияет на отображение в соответствующем пользовательском интерфейсе.',
  T_49_META_TYPE_1016_D: 'Сущность "Отображение конца хода", изменение атрибутов сущности влияет на отображение содержимого на соответствующем пользовательском интерфейсе.',
  T_49_META_TYPE_1017_D: "Если в начале раунда есть две команды, отобразите баннер соперничества двух команд.",
  T_49_META_TYPE_1018_D: "Счет раунда обеих команд.",
  T_49_META_TYPE_1019_D: "Окончательный результат - ничья",
  T_49_META_TYPE_102_D: "Тип источника воскрешения: мертвый, неработающий",
  T_49_META_TYPE_1020_D: 'Сущность "Счет раунда", изменение атрибутов сущности влияет на отображение содержимого соответствующего пользовательского интерфейса.',
  T_49_META_TYPE_1021_D: 'Сущность "Обратный отсчет времени", изменение атрибутов сущности повлияет на содержимое соответствующего пользовательского интерфейса.',
  T_49_META_TYPE_1022_D: 'Сущность "Подзаголовок информации о матче", изменение атрибутов сущности повлияет на отображение содержимого на соответствующем пользовательском интерфейсе.',
  T_49_META_TYPE_1023_D: 'Сущность "Информация о матче двух команд", изменение атрибутов сущности повлияет на отображение содержимого на соответствующем пользовательском интерфейсе.',
  T_49_META_TYPE_1024_D: "Команда совпадает с сущностью UI информации, изменение атрибутов сущности повлияет на отображение содержимого на соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1027_D: "Описывает тип типа и возвращает этот тип при использовании Typeof",
  T_49_META_TYPE_1028_D: "Информационная сущность лагеря, измените атрибут сущности, чтобы повлиять на содержимое дисплея на соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1029_D: 'Информационная сущность "Иконка-подсказка", изменение атрибутов сущности повлияет на содержимое, отображаемое на соответствующем пользовательском интерфейсе.',
  T_49_META_TYPE_103_D: "Перечисление слотов для предметов",
  T_49_META_TYPE_1030_D: "Краткая версия информации о матче двух команд, изменение атрибутов сущности повлияет на содержимое, отображаемое в соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1031_D: "Интерфейсная сущность Timing hint, изменение свойств сущности повлияет на отображение содержимого в соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_1032_D: 'Сущность "Плавающая подсказка", изменение свойств сущности влияет на отображение содержимого в соответствующем пользовательском интерфейсе.',
  T_49_META_TYPE_1033_D: 'Сущность "Переключение раунда", включающая информацию о расчете текущего раунда и начале следующего раунда, изменение свойств сущности повлияет на отображение содержимого соответствующего пользовательского интерфейса.',
  T_49_META_TYPE_1035_D: "Открыть кнопку табло UI сущности, изменение атрибутов сущности повлияет на отображение содержимого на соответствующем UI.",
  T_49_META_TYPE_1036_D: "Режим заражения, отображение пользовательского интерфейса текущего уровня зомби.",
  T_49_META_TYPE_1037_D: "Добавьте сущность UI анимации очков, измените атрибуты сущности, чтобы повлиять на отображение содержимого на соответствующем UI.",
  T_49_META_TYPE_1038_D: "Эффекты пользовательского интерфейса зомби в режиме заражения",
  T_49_META_TYPE_1039_D: "Сущность подсказки обратного отсчета, изменение свойств сущности влияет на отображение содержимого на соответствующем пользовательском интерфейсе.",
  T_49_META_TYPE_104_D: "Стиль Джерси",
  T_49_META_TYPE_1040_D: "Панель выбора карт UI",
  T_49_META_TYPE_1041_D: "Уведомление о личности UI",
  T_49_META_TYPE_1042_D: "Обратный отсчет на 5 секунд UI",
  T_49_META_TYPE_1043_D: "Баннер заголовка UI",
  T_49_META_TYPE_1044_D: "Встроенный переключатель UI",
  T_49_META_TYPE_1045_D: "Кнопка навыка UI",
  T_49_META_TYPE_105_D: "Футбольный гол",
  T_49_META_TYPE_106_D: "Тип средства прицеливания",
  T_49_META_TYPE_107_D: "Объекты, в которые можно целиться и попадать, но не обязательно повреждать их",
  T_49_META_TYPE_108_D: "Целочисленные типы, 64-битные подписанные целые числа",
  T_49_META_TYPE_109_D: "Сущность канала чата - это контейнер, содержащий идентификатор канала и игроков.",
  T_49_META_TYPE_11_D: "Глобальная сущность, уникальная для всей игры",
  T_49_META_TYPE_110_D: "Холостой голосовой канал",
  T_49_META_TYPE_111_D: "Типы поведения",
  T_49_META_TYPE_112_D: "Тип статуса поведения игрока",
  T_49_META_TYPE_113_D: "Музыка на барабанах",
  T_49_META_TYPE_114_D: "Музыка Lead1",
  T_49_META_TYPE_115_D: "Музыка Lead2",
  T_49_META_TYPE_116_D: "Музыка Lead3",
  T_49_META_TYPE_117_D: "Тип музыкального компонента Drum beat",
  T_49_META_TYPE_118_D: "Фракция",
  T_49_META_TYPE_119_D: "Варианты атак",
  T_49_META_TYPE_12_D: "Боевые сущности, могут атаковать, принимать удары, убивать и т. д.",
  T_49_META_TYPE_120_D: "Полоса прогресса UI",
  T_49_META_TYPE_121_D: "Интервал между волнами",
  T_49_META_TYPE_122_D: "Скайбокс",
  T_49_META_TYPE_123_D: "Перечисление типов основы скайбокса",
  T_49_META_TYPE_124_D: "Диапазон вражеских требований",
  T_49_META_TYPE_125_D: "Может изменять базовый внешний вид объектов, например отображение и прозрачность",
  T_49_META_TYPE_126_D: "Полоса здоровья",
  T_49_META_TYPE_127_D: "Как перемещать объекты",
  T_49_META_TYPE_128_D: "Объект, который можно морфировать",
  T_49_META_TYPE_129_D: "Тип лут-патронов",
  T_49_META_TYPE_13_D: "Элемент управления пользовательским интерфейсом",
  T_49_META_TYPE_130_D: "Тип лут-потребляемого",
  T_49_META_TYPE_131_D: "Тип лут-брони",
  T_49_META_TYPE_132_D: "Тип лут-метательного",
  T_49_META_TYPE_133_D: "Тип лут-прицела",
  T_49_META_TYPE_134_D: "Тип лут-оружия",
  T_49_META_TYPE_135_D: "Генерирует дроп боеприпасов выбранного типа",
  T_49_META_TYPE_136_D: "Генерирует дроп выбранного типа реквизита",
  T_49_META_TYPE_137_D: "Генерирует дроп снарядов выбранного типа",
  T_49_META_TYPE_138_D: "Генерирует дроп прицела выбранного типа",
  T_49_META_TYPE_139_D: "Генерирует сброс защиты выбранного типа.",
  T_49_META_TYPE_14_D: "Игровые сущности игрока, по одной на пользователя",
  T_49_META_TYPE_140_D: "Волна",
  T_49_META_TYPE_141_D: "Тип футбольного лута",
  T_49_META_TYPE_142_D: "Коробка для футбольного лута",
  T_49_META_TYPE_143_D: "Тип музыкального компонента Lead1",
  T_49_META_TYPE_144_D: "Тип музыкального компонента Lead2",
  T_49_META_TYPE_145_D: "Тип музыкального компонента Lead3",
  T_49_META_TYPE_146_D: "Тип музыкального компонента Key",
  T_49_META_TYPE_147_D: "Доступно несколько предустановленных типов камер, а также пользовательские типы камер",
  T_49_META_TYPE_148_D: "Компоненты камеры",
  T_49_META_TYPE_149_D: "Ключ локализации",
  T_49_META_TYPE_15_D: "Сущности внутриигровой команды, по одной на команду",
  T_49_META_TYPE_150_D: "Бочка с маслом",
  T_49_META_TYPE_151_D: "Кватернион - специальный четырехмерный вектор, используемый только для представления вращений",
  T_49_META_TYPE_152_D: "Зона с низким гравитацией",
  T_49_META_TYPE_153_D: "Контейнеры сущностей, которые генерируют сущности соответствующего типа в данном месте.",
  T_49_META_TYPE_154_D: "Двойное Оружие",
  T_49_META_TYPE_155_D: "Объект шлема",
  T_49_META_TYPE_156_D: "Броня тела",
  T_49_META_TYPE_157_D: "Тип перехода камеры",
  T_49_META_TYPE_158_D: "Интерфейс текстовых подсказок",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Сущности объектов уровня",
  T_49_META_TYPE_160_D: "Типы текстур",
  T_49_META_TYPE_161_D: "Не заменяемый текстурный VFX",
  T_49_META_TYPE_162_D: "Список типов",
  T_49_META_TYPE_163_D: "Тип или список типов",
  T_49_META_TYPE_164_D: "Компонент - базовый класс всех компонентов сущности или определенных классов компонентов.",
  T_49_META_TYPE_165_D: "Компоненты блока столкновений",
  T_49_META_TYPE_166_D: "Эмоты",
  T_49_META_TYPE_167_D: 'Сущность "Спецэффект" представляет отображаемый спецэффект (удаляемый, многократно используемый).',
  T_49_META_TYPE_17_D: "Список Уровней Объектов",
  T_49_META_TYPE_170_D: "Указывает, может ли быть установлена видимость",
  T_49_META_TYPE_171_D: "Гриб",
  T_49_META_TYPE_172_D: "Боеприпасы",
  T_49_META_TYPE_173_D: "Рюкзак",
  T_49_META_TYPE_174_D: "Компонент гранаты",
  T_49_META_TYPE_175_D: "Граната замедления",
  T_49_META_TYPE_176_D: "Генератор Оружия",
  T_49_META_TYPE_177_D: "Режим движения камеры, когда между камерой и объектом, за которым она следит, есть препятствие",
  T_49_META_TYPE_178_D: "Стиль изображения камеры при рендеринге экрана",
  T_49_META_TYPE_179_D: "Основная сфера",
  T_49_META_TYPE_18_D: "(Утратило силу, пожалуйста, не используйте)",
  T_49_META_TYPE_180_D: "ссылается на свойство компонента",
  T_49_META_TYPE_181_D: "Типы, используемые для описания активов сетки",
  T_49_META_TYPE_182_D: "Тип, используемый для описания актива материала",
  T_49_META_TYPE_183_D: "Тип для описания актива текстуры",
  T_49_META_TYPE_184_D: "Компонент рендеринга Bridged для рендеринга со встроенными ресурсами модели",
  T_49_META_TYPE_185_D: "Пользовательский компонент рендеринга для рендеринга с использованием ресурсов пользовательской модели",
  T_49_META_TYPE_186_D: "Сборка пустых объектов, которую можно использовать вместе со сборками рендера, сборками коллайдеров и т. д.",
  T_49_META_TYPE_187_D: "Контейнер",
  T_49_META_TYPE_188_D: "Основной цилиндр",
  T_49_META_TYPE_189_D: "Список локализованных строк",
  T_49_META_TYPE_19_D: "Шаблоны списков, тип содержимого может быть указан через T",
  T_49_META_TYPE_190_D: "Панель очков для двух команд",
  T_49_META_TYPE_191_D: "Тактическое метательное оружие, ослепляющее врагов в определенном радиусе действия на короткий промежуток времени.",
  T_49_META_TYPE_192_D: "При его использовании может образовываться дым, заслоняющий события, - полезный инструмент, мешающий атакам противника.",
  T_49_META_TYPE_193_D: "Панель результатов для нескольких команд",
  T_49_META_TYPE_194_D: "Сенсорные мины, которые можно разместить на земле, и они взорвутся, когда враги подойдут близко, будьте осторожны и не наступите на них сами.",
  T_49_META_TYPE_195_D: "Интерполированное движение",
  T_49_META_TYPE_197_D: "Воспроизводимые компоненты",
  T_49_META_TYPE_198_D: "Базовый элемент",
  T_49_META_TYPE_199_D: "Помогает в воздушном бою, но нужно постоянно следить за расходом энергии.",
  T_49_META_TYPE_2_D: "Булевы типы, используемые для обозначения истины, лжи, да или нет",
  T_49_META_TYPE_20_D: "Перечисление встроенных интерфейсных типов, которые автоматически генерируются системой типов.",
  T_49_META_TYPE_200_D: "Зона побега из тюрьмы",
  T_49_META_TYPE_201_D: "Зоны, в которых можно плавать после входа",
  T_49_META_TYPE_202_D: "ID Коллайдера",
  T_49_META_TYPE_203_D: "Интерполированное движение",
  T_49_META_TYPE_204_D: "Обувь, оснащенная технологическими бонусами, которые позволяют прыгать в воздух в два этапа",
  T_49_META_TYPE_205_D: "Планер, который может летать в небе, используйте его для приземления с высокого места, чтобы переместиться дальше",
  T_49_META_TYPE_206_D: "Скейтборд",
  T_49_META_TYPE_207_D: "Зиплайн",
  T_49_META_TYPE_208_D: "Список игровых предметов",
  T_49_META_TYPE_209_D: "Игровой объект или список игровых объектов",
  T_49_META_TYPE_21_D: "Встроенные интерфейсные сущности, которые инкапсулируют определенную функциональность.",
  T_49_META_TYPE_210_D: "Баллистическая анимация - это симуляция баллистического движения.",
  T_49_META_TYPE_211_D: "Система координат",
  T_49_META_TYPE_212_D: "Объект следует за другим объектом",
  T_49_META_TYPE_213_D: "Передняя поверхность объекта всегда обращена к другому объекту.",
  T_49_META_TYPE_214_D: "Идентификатор для описания актива спрайта галереи",
  T_49_META_TYPE_215_D: "результаты конкурса",
  T_49_META_TYPE_216_D: "Контейнер данных словаря, элемент данных представляет собой пару Key, Value",
  T_49_META_TYPE_217_D: "Шаблон словарных данных, тип содержимого может быть указан T1, T2",
  T_49_META_TYPE_218_D: "Тип источника света, который излучает свет одинаковой интенсивности во всех направлениях от места расположения источника света.",
  T_49_META_TYPE_219_D: "Мотоциклист",
  T_49_META_TYPE_22_D: "Пользовательские интерфейсы, создаваемые игроком с помощью редактора интерфейсов.",
  T_49_META_TYPE_220_D: "Носитель штурмовой (трехколесной) машины",
  T_49_META_TYPE_221_D: "Амфибия/пулеметный мотовездеход",
  T_49_META_TYPE_222_D: "Четырехколесное транспортное средство",
  T_49_META_TYPE_224_D: "Список типов навыков",
  T_49_META_TYPE_225_D: "ИИ-турель из высокотехнологичных материалов, которая активно ищет и атакует врагов в определенном радиусе действия.",
  T_49_META_TYPE_226_D: "Турели создаются с помощью реквизита турели",
  T_49_META_TYPE_227_D: "Перечисление типов пользовательских элементов управления пользовательским интерфейсом",
  T_49_META_TYPE_23_D: "Перечисление типов объектов уровня, которое автоматически генерируется в зависимости от типа.",
  T_49_META_TYPE_231_D: "Ремонтный комплект",
  T_49_META_TYPE_233_D: "Прогресс-круг",
  T_49_META_TYPE_234_D: "Созданное минное поле",
  T_49_META_TYPE_235_D: "Стена",
  T_49_META_TYPE_236_D: "Созданная ледяная стена",
  T_49_META_TYPE_237_D: "Крюковая Пушка",
  T_49_META_TYPE_238_D: "Пистолет с радужной краской",
  T_49_META_TYPE_239_D: "Ручной распылитель",
  T_49_META_TYPE_24_D: "Текущие типы повреждений, определяемые системой",
  T_49_META_TYPE_240_D: "Сущности являются носителями всех компонентов, и для создания экземпляров компоненты должны быть привязаны к сущности",
  T_49_META_TYPE_241_D: "Пистолет с силовым крюком",
  T_49_META_TYPE_242_D: "Панель очков",
  T_49_META_TYPE_243_D: "Слоты для одежды",
  T_49_META_TYPE_244_D: "Текстовая сущность представляет отображаемый текст",
  T_49_META_TYPE_245_D: "Сущность Icon представляет отображаемую иконку",
  T_49_META_TYPE_246_D: "Цвет спрея",
  T_49_META_TYPE_247_D: "Тип интерфейса игрока UI",
  T_49_META_TYPE_248_D: "Сущность переключателя общего пользовательского интерфейса",
  T_49_META_TYPE_249_D: "Переключение слота оборудования",
  T_49_META_TYPE_25_D: "Фазы игры, такие как начало игры, подготовка к игре, конец игры и т. д.",
  T_49_META_TYPE_250_D: "Сущность Effects представляет отображаемый специальный эффект",
  T_49_META_TYPE_2500_D: "Точка рождения игрока",
  T_49_META_TYPE_2501_D: "Триггеры, используемые для запуска событий входа и выхода игрока (или другого объекта)",
  T_49_META_TYPE_2502_D: "Триггеры смерти или неуязвимости, которые контролируют, является ли игрок мертвым или неуязвимым при входе, основываясь на атрибутах",
  T_49_META_TYPE_2503_D: "Контрольные точки в режиме гонки",
  T_49_META_TYPE_2504_D: "Обычно используются в режиме гонки, чтобы распознать, когда игрок достигает определенной финишной линии. Это специфический триггер, пользовательские триггеры будут открыты позже, эта конечная точка - просто обертка для пользовательского триггера.",
  T_49_META_TYPE_2505_D: "Ограждение вокруг точки рождения, закройте его, чтобы покинуть точку рождения",
  T_49_META_TYPE_2507_D: "Башня",
  T_49_META_TYPE_2508_D: "Спавн монстра",
  T_49_META_TYPE_2509_D: "Экземпляры типа могут быть сгенерированы по требованию",
  T_49_META_TYPE_251_D: "Контейнер эффектов",
  T_49_META_TYPE_2510_D: "Область рождения игрока (прямоугольник)",
  T_49_META_TYPE_252_D: "UI результатов распыла",
  T_49_META_TYPE_253_D: "Кнопка подсказки",
  T_49_META_TYPE_254_D: "Эффект пульса",
  T_49_META_TYPE_255_D: "Локализованная строка временной метки",
  T_49_META_TYPE_256_D: "Тип Rigidbody",
  T_49_META_TYPE_257_D: "Компоненты жесткого тела",
  T_49_META_TYPE_258_D: "Тип форматирования временной метки",
  T_49_META_TYPE_259_D: "Подсказки",
  T_49_META_TYPE_26_D: "Ход игры, часто это небольшая игра с несколькими фазами.",
  T_49_META_TYPE_260_D: "Кнопка прогресс-умения",
  T_49_META_TYPE_261_D: "Уникальный идентификатор",
  T_49_META_TYPE_262_D: "ID оружейного скина",
  T_49_META_TYPE_263_D: "Идентификатор одежды",
  T_49_META_TYPE_264_D: "ID реквизита, если в версии есть только ID оружия.",
  T_49_META_TYPE_265_D: "Сущность UI-панель",
  T_49_META_TYPE_267_D: "Сущность UI scroll view, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_268_D: "Переключатели с тремя состояниями, с возможностью сохранения оригинальной логики, за исключением включения и выключения.",
  T_49_META_TYPE_269_D: "Одежда, в которую одет игрок",
  T_49_META_TYPE_270_D: "Сущность или ID сборного объекта",
  T_49_META_TYPE_271_D: "Сущность UI-панель, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_272_D: "Перечисление полов",
  T_49_META_TYPE_273_D: "Мини-карта",
  T_49_META_TYPE_274_D: "Иконка, отображаемая на мини-карте для отслеживания цели",
  T_49_META_TYPE_275_D: "Узлы отдельных частей в скелете",
  T_49_META_TYPE_276_D: "Узлы, используемые для доступа к скелету со скинами",
  T_49_META_TYPE_277_D: "Обнаружение лучей камеры на стороне клиента",
  T_49_META_TYPE_278_D: "Пиксельные блоки, отображаемые на мини-карте и представляющие размер столкновения объекта в данной позиции.",
  T_49_META_TYPE_279_D: "Цветной барабан",
  T_49_META_TYPE_28_D: "Сбрасывается в начале каждого хода.",
  T_49_META_TYPE_280_D: "Сфера-триггер",
  T_49_META_TYPE_281_D: "Капсульный триггер",
  T_49_META_TYPE_282_D: "Тип, описывающий идентификатор конфигурации актива, используется для указания на то, что родительский пакет поставляется с идентификатором конфигурации актива, который необходимо разобрать в таблице конфигурации перед загрузкой",
  T_49_META_TYPE_283_D: "Тип актива, используется для указания идентификатора актива, может быть загружен напрямую.",
  T_49_META_TYPE_284_D: "Указывает на ресурс гуманоидной модели, который может быть заменен персонажем игрока",
  T_49_META_TYPE_285_D: "Списки или словари, которые можно обходить циклически",
  T_49_META_TYPE_286_D: "Идентификатор для описания актива скрипта",
  T_49_META_TYPE_287_D: "для описания идентификатора статического актива скрипта",
  T_49_META_TYPE_288_D: "Идентификатор актива пользовательского интерфейса",
  T_49_META_TYPE_289_D: "ID для описания тела предварительно настроенного актива",
  T_49_META_TYPE_29_D: "Специальные эффекты",
  T_49_META_TYPE_290_D: "Дерево поведения",
  T_49_META_TYPE_291_D: "Тип узла дерева поведения",
  T_49_META_TYPE_292_D: "Пользовательский узел дерева поведения",
  T_49_META_TYPE_293_D: "Прикрепляемое дерево поведения",
  T_49_META_TYPE_294_D: "Сущность UI layout, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_295_D: "Состояние",
  T_49_META_TYPE_296_D: "Клип анимации",
  T_49_META_TYPE_297_D: "Контроллер анимации",
  T_49_META_TYPE_298_D: "Тип цикла",
  T_49_META_TYPE_3_D: "Целочисленные типы, 32-битные подписанные целые числа",
  T_49_META_TYPE_30_D: "Иконка",
  T_49_META_TYPE_300_D: "Сущность UI3DContainer, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_301_D: "Тип навыков ИИ",
  T_49_META_TYPE_302_D: "Перечисление слотов для снаряжения",
  T_49_META_TYPE_303_D: "Соответствует столбцу Id в BuffData.csv, пожалуйста, уточните у GPP, прежде чем добавлять новые элементы.",
  T_49_META_TYPE_304_D: "Список типов бонуса",
  T_49_META_TYPE_305_D: "Статус узла дерева поведения",
  T_49_META_TYPE_306_D: "Может добавлять баффы, удалять баффы, получать список уже добавленных баффов",
  T_49_META_TYPE_307_D: "Создатель Стен",
  T_49_META_TYPE_308_D: "Специальный Тип ID Предмета",
  T_49_META_TYPE_309_D: "Реквизиты брошенного объекта",
  T_49_META_TYPE_31_D: "Звуковые эффекты",
  T_49_META_TYPE_310_D: "Арбалет",
  T_49_META_TYPE_311_D: "База гранаты",
  T_49_META_TYPE_312_D: "Реквизиты метаемых объектов",
  T_49_META_TYPE_313_D: "Граната для дезледяной стены",
  T_49_META_TYPE_314_D: "Управление контроллерами анимации и ресурсами",
  T_49_META_TYPE_315_D: "Рюкзак игрока",
  T_49_META_TYPE_316_D: "Сущность UITexture, пользовательский интерфейс игрока, редактируемый редактором пользовательского интерфейса",
  T_49_META_TYPE_317_D: "Ограничения движения жесткого тела, каждое из которых может быть использовано в комбинации",
  T_49_META_TYPE_318_D: "Прикрепление",
  T_49_META_TYPE_319_D: "Перечисление типов заливки",
  T_49_META_TYPE_32_D: "Тип состояния игрока",
  T_49_META_TYPE_320_D: "Направление заливки",
  T_49_META_TYPE_321_D: "Сущности, которые могут быть нацелены на цель",
  T_49_META_TYPE_322_D: "Поврежденный тип части тела",
  T_49_META_TYPE_323_D: "Сущность UIProfileInfo, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_324_D: "Несколько различных эффектов сил жесткого тела. Обратите внимание, что это доступно только для типов Dynamic.",
  T_49_META_TYPE_325_D: "для описания идентификатора элемента управления в активе пользовательского интерфейса",
  T_49_META_TYPE_326_D: "Информация о профиле игрока",
  T_49_META_TYPE_327_D: "Конфигурирование одевания в соответствии с каждым компонентом",
  T_49_META_TYPE_328_D: "Идентификатор дерева поведения",
  T_49_META_TYPE_329_D: "Тип сидения",
  T_49_META_TYPE_33_D: "Сортировать по: по возрастанию, игнорировать нулевое значение, по убыванию, по возрастанию",
  T_49_META_TYPE_330_D: "Движение относительно себя",
  T_49_META_TYPE_331_D: "Кривая Безье",
  T_49_META_TYPE_332_D: "Зацикливаемые компоненты",
  T_49_META_TYPE_333_D: "Тип шрифта",
  T_49_META_TYPE_334_D: "ID скина транспорта",
  T_49_META_TYPE_335_D: "Сущность звука представляет играющий звуковой эффект",
  T_49_META_TYPE_336_D: "Список звуковых эффектов",
  T_49_META_TYPE_337_D: "Звуковой эффект или список звуковых эффектов",
  T_49_META_TYPE_338_D: "Сущность синхронизации атрибутов поведения игрока",
  T_49_META_TYPE_339_D: "Оборудование аксессуара",
  T_49_META_TYPE_34_D: "ID предмета",
  T_49_META_TYPE_340_D: "Тип сложности бота",
  T_49_META_TYPE_341_D: "Словарь целых чисел",
  T_49_META_TYPE_342_D: "Объекты таймера",
  T_49_META_TYPE_343_D: "Летающие кинжалы (могут быть подобраны)",
  T_49_META_TYPE_344_D: "Метательный нож",
  T_49_META_TYPE_345_D: "Тип Оружия",
  T_49_META_TYPE_346_D: "Тип Патронов",
  T_49_META_TYPE_347_D: "Самоотносительное по кадрам",
  T_49_META_TYPE_348_D: "Указатель функции на экземпляр функции, используемый для реализации фиктивной функции или механизма делегирования.",
  T_49_META_TYPE_349_D: "Указатель на поток, который может быть использован для выполнения некоторых операций с потоком.",
  T_49_META_TYPE_350_D: "Перечисление транспортных средств",
  T_49_META_TYPE_351_D: "Описывает тип объекта",
  T_49_META_TYPE_352_D: "Сущность UIToggle, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_353_D: "Аптечка",
  T_49_META_TYPE_354_D: "Противогаз",
  T_49_META_TYPE_355_D: "Горизонтальная линия",
  T_49_META_TYPE_356_D: "Пневматические капли, начинают падать с высоты по истечении времени подготовки",
  T_49_META_TYPE_357_D: "Описательные цвета для объектов, например, границ, поверхностей и т. д. (удалено, повторно используется)",
  T_49_META_TYPE_358_D: "Ссылается на событие",
  T_49_META_TYPE_359_D: "Контроллеры игрока с физическими эффектами, которые могут применять силу к силам",
  T_49_META_TYPE_360_D: "Пусковая площадка",
  T_49_META_TYPE_361_D: "Сложенная пушка, при раскладывании может быть использована для запуска людей, будьте осторожны, чтобы не запустить себя за пределы безопасной зоны!",
  T_49_META_TYPE_362_D: "Бой снежками! Ударь!",
  T_49_META_TYPE_363_D: "Запрос на покупку в магазине",
  T_49_META_TYPE_364_D: "Триггер анимации",
  T_49_META_TYPE_365_D: "Анимированный компонент интерфейса триггера",
  T_49_META_TYPE_366_D: "Пакетный комбинированный рендеринг",
  T_49_META_TYPE_367_D: "Верхний компас",
  T_49_META_TYPE_368_D: "Идентификатор ресурса пользовательской роли",
  T_49_META_TYPE_369_D: "Пользовательский идентификатор ресурса анимации",
  T_49_META_TYPE_370_D: "Информация, отображаемая в начале раунда",
  T_49_META_TYPE_371_D: "В конце каждого раунда отображаются результаты",
  T_49_META_TYPE_372_D: "Типы состояний игрока",
  T_49_META_TYPE_373_D: "Идентификатор коллекции, используемый для сбора информации о ресурсе",
  T_49_META_TYPE_374_D: "Полоса здоровья следования",
  T_49_META_TYPE_375_D: "Тип цели монстра",
  T_49_META_TYPE_376_D: "Тип цели атаки защитной башни",
  T_49_META_TYPE_377_D: "Псевдоним, указывающий на тип сущности игрока или транспортного средства",
  T_49_META_TYPE_378_D: "для описания идентификатора аудиоактива",
  T_49_META_TYPE_379_D: "ID для описания актива таблицы конфигурации",
  T_49_META_TYPE_38_D: "Сущность UI Empty Widget, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса.",
  T_49_META_TYPE_380_D: "ID для описания актива эффектов",
  T_49_META_TYPE_381_D: "ID для описания актива контроллера анимации",
  T_49_META_TYPE_382_D: "Как обрабатывается статус нокдауна",
  T_49_META_TYPE_383_D: "Поверхность или украшения на самой карте",
  T_49_META_TYPE_384_D: "Предметы",
  T_49_META_TYPE_385_D: "ID навыка персонажа",
  T_49_META_TYPE_386_D: "Список ID навыков",
  T_49_META_TYPE_387_D: "Сущность UITouchPad, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_388_D: "ID скина рюкзака",
  T_49_META_TYPE_389_D: 'Сущность "Джойстик", пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса',
  T_49_META_TYPE_39_D: "Сущность UI image - пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса.",
  T_49_META_TYPE_390_D: "Иерархический",
  T_49_META_TYPE_391_D: "Пользовательский интерфейс или виджет",
  T_49_META_TYPE_392_D: "Объекты ядовитого кольца, которые можно разместить",
  T_49_META_TYPE_393_D: "Сущности с компонентами PhysicalCCT или Rigidbody.",
  T_49_META_TYPE_394_D: "Математические константы",
  T_49_META_TYPE_395_D: "Существа с компонентами PhysicalCCT или PlayerCCT могут перемещаться с их помощью.",
  T_49_META_TYPE_396_D: "Конфигурация выхода из игры",
  T_49_META_TYPE_397_D: "Компоненты, используемые для описания форм столкновений",
  T_49_META_TYPE_398_D: "Строка или локализированная строка",
  T_49_META_TYPE_399_D: "Контроллер персонажа с физическими эффектами, только для персонажей FF.",
  T_49_META_TYPE_4_D: "Тип с плавающей точкой, 32-битное число с плавающей точкой одинарной точности",
  T_49_META_TYPE_40_D: "Текстовая сущность UI, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса.",
  T_49_META_TYPE_400_D: "Как выполнить поведение атаки",
  T_49_META_TYPE_401_D: "Тип Огня",
  T_49_META_TYPE_402_D: "Виджет социальной кнопки",
  T_49_META_TYPE_403_D: "Типы социальных кнопок",
  T_49_META_TYPE_404_D: "Стили социальных кнопок",
  T_49_META_TYPE_405_D: "Тип сортировки макета",
  T_49_META_TYPE_406_D: "Могут быть вызваны для преодоления препятствий",
  T_49_META_TYPE_407_D: "Тип платформы",
  T_49_META_TYPE_408_D: "Псевдоним базовых данных",
  T_49_META_TYPE_409_D: "Перечисление кодов ошибок",
  T_49_META_TYPE_41_D: "Сущность UI button, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса.",
  T_49_META_TYPE_410_D: "Псевдоним, ссылающийся на сущность игрока или тип сущности трансформера",
  T_49_META_TYPE_411_D: "Носитель вертолета",
  T_49_META_TYPE_412_D: "Компонент Vehicle, который является продолжением компонента Carrier.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Ограничивает диапазон углов поворота камеры",
  T_49_META_TYPE_415_D: "Персона",
  T_49_META_TYPE_416_D: "Интерфейс окна чата персоны",
  T_49_META_TYPE_417_D: "Компонент сущности частицы",
  T_49_META_TYPE_418_D: "Перечисление статусов участников",
  T_49_META_TYPE_419_D: "Типы кожи оружия",
  T_49_META_TYPE_42_D: "Сущность UI input, пользовательский интерфейс, редактируемый игроком через редактор пользовательского интерфейса",
  T_49_META_TYPE_420_D: "Типы кожи транспортных средств",
  T_49_META_TYPE_421_D: "Типы кожи",
  T_49_META_TYPE_422_D: "Типы кожи рюкзака",
  T_49_META_TYPE_423_D: "ID Персонажа",
  T_49_META_TYPE_424_D: "Базовый тип эффекта тумана",
  T_49_META_TYPE_425_D: "Идентификатор актива частиц",
  T_49_META_TYPE_426_D: "Тип источника света, который излучает конус света в отрицательном направлении по оси Y от источника света, по умолчанию направленный на землю.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Информация об одежде, которая будет сохранена при превращении игрока в другого персонажа.",
  T_49_META_TYPE_429_D: "Сущности игрока или NPC",
  T_49_META_TYPE_43_D: "Список типов элементов, которые должны быть сущностями игрока",
  T_49_META_TYPE_430_D: "Генератор случайных чисел",
  T_49_META_TYPE_431_D: "Объекты движения, перемещающиеся по пользовательской траектории",
  T_49_META_TYPE_432_D: "Пользовательские путевые точки кривой траектории",
  T_49_META_TYPE_433_D: "Типы пользовательских путевых точек кривой траектории",
  T_49_META_TYPE_434_D: "Пользовательские пути кривых",
  T_49_META_TYPE_435_D: "Список уникальных идентификаторов игроков",
  T_49_META_TYPE_436_D: "Список кодов ошибок",
  T_49_META_TYPE_437_D: "Две команды сопоставляют детали сущности UI, измените атрибут сущности, чтобы повлиять на содержимое дисплея на соответствующем UI.",
  T_49_META_TYPE_438_D: "Сущность UI с подробной информацией о матче нескольких команд, изменение атрибутов сущности повлияет на отображение содержимого на соответствующем UI.",
  T_49_META_TYPE_439_D: "Комбинировать",
  T_49_META_TYPE_44_D: "Список сущностей, тип элемента которых должен быть сущностью команды",
  T_49_META_TYPE_440_D: "Временная шкала",
  T_49_META_TYPE_441_D: "Идентификатор ресурса временной шкалы",
  T_49_META_TYPE_442_D: 'Новый компонент короткой версии сущности "Информация о матче двух команд", поддерживает полностью настраиваемое количество отображаемых людей',
  T_49_META_TYPE_443_D: "Идентификатор актива диалогового потока",
  T_49_META_TYPE_444_D: "Тип языка",
  T_49_META_TYPE_45_D: "Список Булевых",
  T_49_META_TYPE_46_D: "Список Int",
  T_49_META_TYPE_47_D: "Список десятичных дробей",
  T_49_META_TYPE_48_D: "Список строк",
  T_49_META_TYPE_49_D: "Список Vector3",
  T_49_META_TYPE_5_D: "Тип String, значение - текстовое содержимое",
  T_49_META_TYPE_50_D: "Список типов элементов, которые должны быть сущностями",
  T_49_META_TYPE_51_D: "Типы зомби",
  T_49_META_TYPE_53_D: "Общий уровень объекта",
  T_49_META_TYPE_54_D: "Разрушаемый объект",
  T_49_META_TYPE_55_D: "Общая точка спауна",
  T_49_META_TYPE_56_D: "Транспортное средство",
  T_49_META_TYPE_57_D: "Игроки могут быть телепортированы в определенное место при входе.",
  T_49_META_TYPE_58_D: "Баффы могут генерироваться по требованию",
  T_49_META_TYPE_59_D: "Платформа перемещения",
  T_49_META_TYPE_6_D: "Трехмерные векторы, которые могут представлять пространственные координаты или пространственные направления",
  T_49_META_TYPE_60_D: "Генерирует дроп оружия выбранного типа",
  T_49_META_TYPE_61_D: "При входе в зону срабатывания открывается магазин Bound Shop",
  T_49_META_TYPE_62_D: "Упругие кубики",
  T_49_META_TYPE_63_D: "Игроки наступают на них, и они отскакивают в определенное место.",
  T_49_META_TYPE_64_D: "Наступая на них, игроки издают звук.",
  T_49_META_TYPE_65_D: "Основной масштабируемый",
  T_49_META_TYPE_66_D: "Пользовательский Путь",
  T_49_META_TYPE_67_D: "Точка Пути",
  T_49_META_TYPE_68_D: "ИИ монстров, таких как зомби.",
  T_49_META_TYPE_69_D: "Большие числа - это числа высокой точности с плавающей точкой",
  T_49_META_TYPE_7_D: "Числа - это псевдонимы типов, которые ссылаются на целые, 64-битные целые числа или типы с плавающей точкой.",
  T_49_META_TYPE_70_D: "Формулы атрибутов используются для расчета значений атрибутов сущностей, пока что поддерживаются только некоторые атрибуты игроков и атрибуты оружия.",
  T_49_META_TYPE_71_D: "Используется только для сущностей, продаваемых в магазинах, концепция товаров отличается от концепции предметов, получаемых при покупке товаров.",
  T_49_META_TYPE_72_D: "Содержит несколько предметов",
  T_49_META_TYPE_73_D: "Содержит несколько полок",
  T_49_META_TYPE_74_D: "ID предмета",
  T_49_META_TYPE_75_D: "Вернуться",
  T_49_META_TYPE_76_D: "Стиль патруля",
  T_49_META_TYPE_77_D: "Сущность-генератор, которая может генерировать и обновлять предметы.",
  T_49_META_TYPE_78_D: "Сущность юнита, которая может быть использована генератором юнитов для поглощения и генерации юнитов партиями.",
  T_49_META_TYPE_79_D: "Оружие",
  T_49_META_TYPE_8_D: "Условия - это специальные типы Bool",
  T_49_META_TYPE_80_D: "Интерфейс магазина",
  T_49_META_TYPE_81_D: "Тип баффа",
  T_49_META_TYPE_82_D: "Сердцебиение UI",
  T_49_META_TYPE_83_D: "Кнопка взаимодействия",
  T_49_META_TYPE_84_D: "Ранжируемая сущность, может быть ранжирована",
  T_49_META_TYPE_85_D: "Сущность с возможностью начисления очков, имеет свой собственный счет",
  T_49_META_TYPE_86_D: "Атрибут Формула Фактор Тип",
  T_49_META_TYPE_87_D: "Описывает тип цвета RGBA, каждый канал принимает значение в диапазоне от 0 до 255",
  T_49_META_TYPE_88_D: "Тип валюты, в настоящее время только базовый тип валюты",
  T_49_META_TYPE_89_D: "Валютная сущность, которая описывает тип и количество валюты.",
  T_49_META_TYPE_9_D: "Набор условий",
  T_49_META_TYPE_90_D: "Сущности кошелька являются контейнерами для множества сущностей валюты",
  T_49_META_TYPE_91_D: "Указывает на целое число или целочисленный тип массива.",
  T_49_META_TYPE_92_D: "Динамический тип создаваемого объекта уровня",
  T_49_META_TYPE_93_D: "Сущности с формулируемыми атрибутами",
  T_49_META_TYPE_94_D: "Модификация атрибутов",
  T_49_META_TYPE_95_D: "Генератор монет",
  T_49_META_TYPE_96_D: "Кошелек",
  T_49_META_TYPE_97_D: "Масштабирование вращение позиции, поддерживает структуру родитель-ребенок",
  T_49_META_TYPE_98_D: "Список всех доступных типов",
  T_49_META_TYPE_99_D: "Футбол"
};
export {
  _ as default
};
